var jj = Object.defineProperty;
var zj = (e, n, i) => n in e ? jj(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i;
var Sb = (e, n, i) => zj(e, typeof n != "symbol" ? n + "" : n, i);
import { typographyClasses as IS, colors as Nj, Button as v2, Badge as Pj, SvgIcon as BA, Dialog as hl, dialogClasses as Fj, paperClasses as Bj, DialogTitle as HA, dialogTitleClasses as Hj, Stack as qe, Typography as le, IconButton as xc, DialogContent as T0, dialogContentClasses as Uj, DialogActions as Nc, useTheme as ka, useMediaQuery as hc, Breadcrumbs as Wj, Chip as dl, Box as _1, LinearProgress as pS, styled as q1, Link as _j, Backdrop as Vj, CircularProgress as D3, useForkRef as Kj, Popper as hS, Skeleton as _h, PaginationItem as Jj, Pagination as Eb, TextField as Mf, Popover as UA, debounce as Yj, InputAdornment as Vh, ButtonBase as Kh, Checkbox as IA, Stepper as Qj, stepIconClasses as Jg, stepClasses as Xj, stepConnectorClasses as _p, stepLabelClasses as Vp, stepButtonClasses as Gj, Step as qj, StepButton as Zj, StepLabel as $j, FormHelperText as ez, FormLabel as tz, FormControl as nz, FormControlLabel as Jh, Autocomplete as rz, Accordion as iz, AccordionSummary as az, AccordionDetails as oz, ListItemButton as sz, ListItem as mS, ListItemIcon as lz, MenuItem as Ta, ListItemText as vS, Menu as U7, Avatar as yS, Tab as bS, Tabs as wS, alpha as Tf, Radio as uz, List as cz, Tooltip as gz, TableCell as sf, TableContainer as xS, TableRow as W7, Drawer as fz, SwipeableDrawer as dz, Alert as Yr, DialogContentText as SS, Divider as pA, MenuList as ES, ListSubheader as Cz, Paper as MS, Switch as Az, Table as Iz, TableHead as pz, TableBody as hz, Container as mz } from "@mui/material";
import * as o1 from "react";
import nn, { useMemo as V2, forwardRef as ja, useCallback as m2, createContext as vz, useContext as yz, Children as bz, isValidElement as nA, cloneElement as rA, useLayoutEffect as pf, useState as gt, useEffect as vn, createElement as TS, useRef as Cn, useImperativeHandle as Mb, Fragment as wz, useId as LS, Component as xz, lazy as Sz, Suspense as Ez } from "react";
import { useMatch as Mz, Link as Yh, useLocation as RS, useSearchParams as Tz } from "react-router-dom";
import Lz from "@emotion/styled";
import { CacheProvider as Rz, Global as Oz, ThemeContext as OS, css as Dz, keyframes as WA } from "@emotion/react";
import "@mui/x-data-grid";
import { DatePicker as Tb } from "@mui/x-date-pickers";
import { preventBubbling as iA, readableBytes as kz, defaultErrorParser as DS, DEFAULT_ERROR_MESSAGE as _7, downloadPreviewFile as jz } from "@liscio/utils";
import { useController as Qh, useFormContext as Lf, Controller as zz } from "react-hook-form";
import { AnimatePresence as Nz, motion as Pz } from "framer-motion";
const Oe1 = "data:image/png;base64,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", De1 = "data:image/png;base64,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", Fz = "data:image/png;base64,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", Lb = "data:image/svg+xml,%3csvg%20width='43'%20height='28'%20viewBox='0%200%20828%20539'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_7716_239579)'%3e%3cpath%20d='M539.534%20269.5C539.534%20418.349%20418.749%20539%20269.776%20539H0V269.5C0%20120.669%20120.785%200%20269.758%200C418.731%200%20539.516%20120.669%20539.516%20269.5H539.534Z'%20fill='%2300AFCC'/%3e%3cpath%20d='M288.48%20269.501C288.48%20120.67%20409.247%200.000976562%20558.239%200.000976562H827.997V269.501C827.997%20418.35%20707.212%20539.001%20558.239%20539.001C409.265%20539.001%20288.48%20418.332%20288.48%20269.501Z'%20fill='%23EC2AAC'/%3e%3cpath%20d='M288.48%20269.498C288.48%20365.338%20338.567%20449.479%20413.997%20497.272C489.444%20449.497%20539.513%20365.338%20539.513%20269.498C539.513%20173.658%20489.426%2089.5178%20413.997%2041.7246C338.549%2089.4997%20288.48%20173.658%20288.48%20269.498Z'%20fill='%230061A0'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_7716_239579'%3e%3crect%20width='828'%20height='539'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
function Cl(e) {
  let n = "https://mui.com/production-error/?code=" + e;
  for (let i = 1; i < arguments.length; i += 1)
    n += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified MUI error #" + e + "; visit " + n + " for the full message.";
}
const Bz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cl
}, Symbol.toStringTag, { value: "Module" })), kS = "$$material";
function k1() {
  return k1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n];
      for (var a in i) ({}).hasOwnProperty.call(i, a) && (e[a] = i[a]);
    }
    return e;
  }, k1.apply(null, arguments);
}
function Dt(e, n) {
  if (e == null) return {};
  var i = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (n.includes(a)) continue;
    i[a] = e[a];
  }
  return i;
}
var Hz = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _A(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Zo(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var i = function a() {
      return this instanceof a ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    i.prototype = n.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var s = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(i, a, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), i;
}
var V7 = { exports: {} }, PC = { exports: {} }, qt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rb;
function Uz() {
  if (Rb) return qt;
  Rb = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, g = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, I = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, w = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, M = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, U = e ? Symbol.for("react.responder") : 60118, Q = e ? Symbol.for("react.scope") : 60119;
  function _(B) {
    if (typeof B == "object" && B !== null) {
      var Z = B.$$typeof;
      switch (Z) {
        case n:
          switch (B = B.type, B) {
            case h:
            case m:
            case a:
            case g:
            case s:
            case x:
              return B;
            default:
              switch (B = B && B.$$typeof, B) {
                case I:
                case w:
                case k:
                case O:
                case c:
                  return B;
                default:
                  return Z;
              }
          }
        case i:
          return Z;
      }
    }
  }
  function X(B) {
    return _(B) === m;
  }
  return qt.AsyncMode = h, qt.ConcurrentMode = m, qt.ContextConsumer = I, qt.ContextProvider = c, qt.Element = n, qt.ForwardRef = w, qt.Fragment = a, qt.Lazy = k, qt.Memo = O, qt.Portal = i, qt.Profiler = g, qt.StrictMode = s, qt.Suspense = x, qt.isAsyncMode = function(B) {
    return X(B) || _(B) === h;
  }, qt.isConcurrentMode = X, qt.isContextConsumer = function(B) {
    return _(B) === I;
  }, qt.isContextProvider = function(B) {
    return _(B) === c;
  }, qt.isElement = function(B) {
    return typeof B == "object" && B !== null && B.$$typeof === n;
  }, qt.isForwardRef = function(B) {
    return _(B) === w;
  }, qt.isFragment = function(B) {
    return _(B) === a;
  }, qt.isLazy = function(B) {
    return _(B) === k;
  }, qt.isMemo = function(B) {
    return _(B) === O;
  }, qt.isPortal = function(B) {
    return _(B) === i;
  }, qt.isProfiler = function(B) {
    return _(B) === g;
  }, qt.isStrictMode = function(B) {
    return _(B) === s;
  }, qt.isSuspense = function(B) {
    return _(B) === x;
  }, qt.isValidElementType = function(B) {
    return typeof B == "string" || typeof B == "function" || B === a || B === m || B === g || B === s || B === x || B === M || typeof B == "object" && B !== null && (B.$$typeof === k || B.$$typeof === O || B.$$typeof === c || B.$$typeof === I || B.$$typeof === w || B.$$typeof === N || B.$$typeof === U || B.$$typeof === Q || B.$$typeof === z);
  }, qt.typeOf = _, qt;
}
var Zt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ob;
function Wz() {
  return Ob || (Ob = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, i = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, g = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, I = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, w = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, M = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, z = e ? Symbol.for("react.block") : 60121, N = e ? Symbol.for("react.fundamental") : 60117, U = e ? Symbol.for("react.responder") : 60118, Q = e ? Symbol.for("react.scope") : 60119;
    function _(D1) {
      return typeof D1 == "string" || typeof D1 == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D1 === a || D1 === m || D1 === g || D1 === s || D1 === x || D1 === M || typeof D1 == "object" && D1 !== null && (D1.$$typeof === k || D1.$$typeof === O || D1.$$typeof === c || D1.$$typeof === I || D1.$$typeof === w || D1.$$typeof === N || D1.$$typeof === U || D1.$$typeof === Q || D1.$$typeof === z);
    }
    function X(D1) {
      if (typeof D1 == "object" && D1 !== null) {
        var $1 = D1.$$typeof;
        switch ($1) {
          case n:
            var y1 = D1.type;
            switch (y1) {
              case h:
              case m:
              case a:
              case g:
              case s:
              case x:
                return y1;
              default:
                var ie = y1 && y1.$$typeof;
                switch (ie) {
                  case I:
                  case w:
                  case k:
                  case O:
                  case c:
                    return ie;
                  default:
                    return $1;
                }
            }
          case i:
            return $1;
        }
      }
    }
    var B = h, Z = m, Y = I, V = c, J = n, e1 = w, f1 = a, v1 = k, a1 = O, d1 = i, S1 = g, h1 = s, L1 = x, c1 = !1;
    function b1(D1) {
      return c1 || (c1 = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), t1(D1) || X(D1) === h;
    }
    function t1(D1) {
      return X(D1) === m;
    }
    function C1(D1) {
      return X(D1) === I;
    }
    function w1(D1) {
      return X(D1) === c;
    }
    function E1(D1) {
      return typeof D1 == "object" && D1 !== null && D1.$$typeof === n;
    }
    function V1(D1) {
      return X(D1) === w;
    }
    function K1(D1) {
      return X(D1) === a;
    }
    function B1(D1) {
      return X(D1) === k;
    }
    function te(D1) {
      return X(D1) === O;
    }
    function R1(D1) {
      return X(D1) === i;
    }
    function x1(D1) {
      return X(D1) === g;
    }
    function J1(D1) {
      return X(D1) === s;
    }
    function X1(D1) {
      return X(D1) === x;
    }
    Zt.AsyncMode = B, Zt.ConcurrentMode = Z, Zt.ContextConsumer = Y, Zt.ContextProvider = V, Zt.Element = J, Zt.ForwardRef = e1, Zt.Fragment = f1, Zt.Lazy = v1, Zt.Memo = a1, Zt.Portal = d1, Zt.Profiler = S1, Zt.StrictMode = h1, Zt.Suspense = L1, Zt.isAsyncMode = b1, Zt.isConcurrentMode = t1, Zt.isContextConsumer = C1, Zt.isContextProvider = w1, Zt.isElement = E1, Zt.isForwardRef = V1, Zt.isFragment = K1, Zt.isLazy = B1, Zt.isMemo = te, Zt.isPortal = R1, Zt.isProfiler = x1, Zt.isStrictMode = J1, Zt.isSuspense = X1, Zt.isValidElementType = _, Zt.typeOf = X;
  }()), Zt;
}
var Db;
function jS() {
  return Db || (Db = 1, process.env.NODE_ENV === "production" ? PC.exports = Uz() : PC.exports = Wz()), PC.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Kp, kb;
function _z() {
  if (kb) return Kp;
  kb = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function a(g) {
    if (g == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(g);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var g = new String("abc");
      if (g[5] = "de", Object.getOwnPropertyNames(g)[0] === "5")
        return !1;
      for (var c = {}, I = 0; I < 10; I++)
        c["_" + String.fromCharCode(I)] = I;
      var h = Object.getOwnPropertyNames(c).map(function(w) {
        return c[w];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(w) {
        m[w] = w;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Kp = s() ? Object.assign : function(g, c) {
    for (var I, h = a(g), m, w = 1; w < arguments.length; w++) {
      I = Object(arguments[w]);
      for (var x in I)
        n.call(I, x) && (h[x] = I[x]);
      if (e) {
        m = e(I);
        for (var M = 0; M < m.length; M++)
          i.call(I, m[M]) && (h[m[M]] = I[m[M]]);
      }
    }
    return h;
  }, Kp;
}
var Jp, jb;
function Xh() {
  if (jb) return Jp;
  jb = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Jp = e, Jp;
}
var Yp, zb;
function zS() {
  return zb || (zb = 1, Yp = Function.call.bind(Object.prototype.hasOwnProperty)), Yp;
}
var Qp, Nb;
function Vz() {
  if (Nb) return Qp;
  Nb = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Xh(), i = {}, a = zS();
    e = function(g) {
      var c = "Warning: " + g;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function s(g, c, I, h, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var w in g)
        if (a(g, w)) {
          var x;
          try {
            if (typeof g[w] != "function") {
              var M = Error(
                (h || "React class") + ": " + I + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw M.name = "Invariant Violation", M;
            }
            x = g[w](c, w, h, I, null, n);
          } catch (k) {
            x = k;
          }
          if (x && !(x instanceof Error) && e(
            (h || "React class") + ": type specification of " + I + " `" + w + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), x instanceof Error && !(x.message in i)) {
            i[x.message] = !0;
            var O = m ? m() : "";
            e(
              "Failed " + I + " type: " + x.message + (O ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (i = {});
  }, Qp = s, Qp;
}
var Xp, Pb;
function Kz() {
  if (Pb) return Xp;
  Pb = 1;
  var e = jS(), n = _z(), i = Xh(), a = zS(), s = Vz(), g = function() {
  };
  process.env.NODE_ENV !== "production" && (g = function(I) {
    var h = "Warning: " + I;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return Xp = function(I, h) {
    var m = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
    function x(t1) {
      var C1 = t1 && (m && t1[m] || t1[w]);
      if (typeof C1 == "function")
        return C1;
    }
    var M = "<<anonymous>>", O = {
      array: U("array"),
      bigint: U("bigint"),
      bool: U("boolean"),
      func: U("function"),
      number: U("number"),
      object: U("object"),
      string: U("string"),
      symbol: U("symbol"),
      any: Q(),
      arrayOf: _,
      element: X(),
      elementType: B(),
      instanceOf: Z,
      node: e1(),
      objectOf: V,
      oneOf: Y,
      oneOfType: J,
      shape: v1,
      exact: a1
    };
    function k(t1, C1) {
      return t1 === C1 ? t1 !== 0 || 1 / t1 === 1 / C1 : t1 !== t1 && C1 !== C1;
    }
    function z(t1, C1) {
      this.message = t1, this.data = C1 && typeof C1 == "object" ? C1 : {}, this.stack = "";
    }
    z.prototype = Error.prototype;
    function N(t1) {
      if (process.env.NODE_ENV !== "production")
        var C1 = {}, w1 = 0;
      function E1(K1, B1, te, R1, x1, J1, X1) {
        if (R1 = R1 || M, J1 = J1 || te, X1 !== i) {
          if (h) {
            var D1 = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D1.name = "Invariant Violation", D1;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var $1 = R1 + ":" + te;
            !C1[$1] && // Avoid spamming the console because they are often not actionable except for lib authors
            w1 < 3 && (g(
              "You are manually calling a React.PropTypes validation function for the `" + J1 + "` prop on `" + R1 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C1[$1] = !0, w1++);
          }
        }
        return B1[te] == null ? K1 ? B1[te] === null ? new z("The " + x1 + " `" + J1 + "` is marked as required " + ("in `" + R1 + "`, but its value is `null`.")) : new z("The " + x1 + " `" + J1 + "` is marked as required in " + ("`" + R1 + "`, but its value is `undefined`.")) : null : t1(B1, te, R1, x1, J1);
      }
      var V1 = E1.bind(null, !1);
      return V1.isRequired = E1.bind(null, !0), V1;
    }
    function U(t1) {
      function C1(w1, E1, V1, K1, B1, te) {
        var R1 = w1[E1], x1 = h1(R1);
        if (x1 !== t1) {
          var J1 = L1(R1);
          return new z(
            "Invalid " + K1 + " `" + B1 + "` of type " + ("`" + J1 + "` supplied to `" + V1 + "`, expected ") + ("`" + t1 + "`."),
            { expectedType: t1 }
          );
        }
        return null;
      }
      return N(C1);
    }
    function Q() {
      return N(c);
    }
    function _(t1) {
      function C1(w1, E1, V1, K1, B1) {
        if (typeof t1 != "function")
          return new z("Property `" + B1 + "` of component `" + V1 + "` has invalid PropType notation inside arrayOf.");
        var te = w1[E1];
        if (!Array.isArray(te)) {
          var R1 = h1(te);
          return new z("Invalid " + K1 + " `" + B1 + "` of type " + ("`" + R1 + "` supplied to `" + V1 + "`, expected an array."));
        }
        for (var x1 = 0; x1 < te.length; x1++) {
          var J1 = t1(te, x1, V1, K1, B1 + "[" + x1 + "]", i);
          if (J1 instanceof Error)
            return J1;
        }
        return null;
      }
      return N(C1);
    }
    function X() {
      function t1(C1, w1, E1, V1, K1) {
        var B1 = C1[w1];
        if (!I(B1)) {
          var te = h1(B1);
          return new z("Invalid " + V1 + " `" + K1 + "` of type " + ("`" + te + "` supplied to `" + E1 + "`, expected a single ReactElement."));
        }
        return null;
      }
      return N(t1);
    }
    function B() {
      function t1(C1, w1, E1, V1, K1) {
        var B1 = C1[w1];
        if (!e.isValidElementType(B1)) {
          var te = h1(B1);
          return new z("Invalid " + V1 + " `" + K1 + "` of type " + ("`" + te + "` supplied to `" + E1 + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return N(t1);
    }
    function Z(t1) {
      function C1(w1, E1, V1, K1, B1) {
        if (!(w1[E1] instanceof t1)) {
          var te = t1.name || M, R1 = b1(w1[E1]);
          return new z("Invalid " + K1 + " `" + B1 + "` of type " + ("`" + R1 + "` supplied to `" + V1 + "`, expected ") + ("instance of `" + te + "`."));
        }
        return null;
      }
      return N(C1);
    }
    function Y(t1) {
      if (!Array.isArray(t1))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? g(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : g("Invalid argument supplied to oneOf, expected an array.")), c;
      function C1(w1, E1, V1, K1, B1) {
        for (var te = w1[E1], R1 = 0; R1 < t1.length; R1++)
          if (k(te, t1[R1]))
            return null;
        var x1 = JSON.stringify(t1, function(X1, D1) {
          var $1 = L1(D1);
          return $1 === "symbol" ? String(D1) : D1;
        });
        return new z("Invalid " + K1 + " `" + B1 + "` of value `" + String(te) + "` " + ("supplied to `" + V1 + "`, expected one of " + x1 + "."));
      }
      return N(C1);
    }
    function V(t1) {
      function C1(w1, E1, V1, K1, B1) {
        if (typeof t1 != "function")
          return new z("Property `" + B1 + "` of component `" + V1 + "` has invalid PropType notation inside objectOf.");
        var te = w1[E1], R1 = h1(te);
        if (R1 !== "object")
          return new z("Invalid " + K1 + " `" + B1 + "` of type " + ("`" + R1 + "` supplied to `" + V1 + "`, expected an object."));
        for (var x1 in te)
          if (a(te, x1)) {
            var J1 = t1(te, x1, V1, K1, B1 + "." + x1, i);
            if (J1 instanceof Error)
              return J1;
          }
        return null;
      }
      return N(C1);
    }
    function J(t1) {
      if (!Array.isArray(t1))
        return process.env.NODE_ENV !== "production" && g("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var C1 = 0; C1 < t1.length; C1++) {
        var w1 = t1[C1];
        if (typeof w1 != "function")
          return g(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + c1(w1) + " at index " + C1 + "."
          ), c;
      }
      function E1(V1, K1, B1, te, R1) {
        for (var x1 = [], J1 = 0; J1 < t1.length; J1++) {
          var X1 = t1[J1], D1 = X1(V1, K1, B1, te, R1, i);
          if (D1 == null)
            return null;
          D1.data && a(D1.data, "expectedType") && x1.push(D1.data.expectedType);
        }
        var $1 = x1.length > 0 ? ", expected one of type [" + x1.join(", ") + "]" : "";
        return new z("Invalid " + te + " `" + R1 + "` supplied to " + ("`" + B1 + "`" + $1 + "."));
      }
      return N(E1);
    }
    function e1() {
      function t1(C1, w1, E1, V1, K1) {
        return d1(C1[w1]) ? null : new z("Invalid " + V1 + " `" + K1 + "` supplied to " + ("`" + E1 + "`, expected a ReactNode."));
      }
      return N(t1);
    }
    function f1(t1, C1, w1, E1, V1) {
      return new z(
        (t1 || "React class") + ": " + C1 + " type `" + w1 + "." + E1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V1 + "`."
      );
    }
    function v1(t1) {
      function C1(w1, E1, V1, K1, B1) {
        var te = w1[E1], R1 = h1(te);
        if (R1 !== "object")
          return new z("Invalid " + K1 + " `" + B1 + "` of type `" + R1 + "` " + ("supplied to `" + V1 + "`, expected `object`."));
        for (var x1 in t1) {
          var J1 = t1[x1];
          if (typeof J1 != "function")
            return f1(V1, K1, B1, x1, L1(J1));
          var X1 = J1(te, x1, V1, K1, B1 + "." + x1, i);
          if (X1)
            return X1;
        }
        return null;
      }
      return N(C1);
    }
    function a1(t1) {
      function C1(w1, E1, V1, K1, B1) {
        var te = w1[E1], R1 = h1(te);
        if (R1 !== "object")
          return new z("Invalid " + K1 + " `" + B1 + "` of type `" + R1 + "` " + ("supplied to `" + V1 + "`, expected `object`."));
        var x1 = n({}, w1[E1], t1);
        for (var J1 in x1) {
          var X1 = t1[J1];
          if (a(t1, J1) && typeof X1 != "function")
            return f1(V1, K1, B1, J1, L1(X1));
          if (!X1)
            return new z(
              "Invalid " + K1 + " `" + B1 + "` key `" + J1 + "` supplied to `" + V1 + "`.\nBad object: " + JSON.stringify(w1[E1], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(t1), null, "  ")
            );
          var D1 = X1(te, J1, V1, K1, B1 + "." + J1, i);
          if (D1)
            return D1;
        }
        return null;
      }
      return N(C1);
    }
    function d1(t1) {
      switch (typeof t1) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t1;
        case "object":
          if (Array.isArray(t1))
            return t1.every(d1);
          if (t1 === null || I(t1))
            return !0;
          var C1 = x(t1);
          if (C1) {
            var w1 = C1.call(t1), E1;
            if (C1 !== t1.entries) {
              for (; !(E1 = w1.next()).done; )
                if (!d1(E1.value))
                  return !1;
            } else
              for (; !(E1 = w1.next()).done; ) {
                var V1 = E1.value;
                if (V1 && !d1(V1[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function S1(t1, C1) {
      return t1 === "symbol" ? !0 : C1 ? C1["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C1 instanceof Symbol : !1;
    }
    function h1(t1) {
      var C1 = typeof t1;
      return Array.isArray(t1) ? "array" : t1 instanceof RegExp ? "object" : S1(C1, t1) ? "symbol" : C1;
    }
    function L1(t1) {
      if (typeof t1 > "u" || t1 === null)
        return "" + t1;
      var C1 = h1(t1);
      if (C1 === "object") {
        if (t1 instanceof Date)
          return "date";
        if (t1 instanceof RegExp)
          return "regexp";
      }
      return C1;
    }
    function c1(t1) {
      var C1 = L1(t1);
      switch (C1) {
        case "array":
        case "object":
          return "an " + C1;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C1;
        default:
          return C1;
      }
    }
    function b1(t1) {
      return !t1.constructor || !t1.constructor.name ? M : t1.constructor.name;
    }
    return O.checkPropTypes = s, O.resetWarningCache = s.resetWarningCache, O.PropTypes = O, O;
  }, Xp;
}
var Gp, Fb;
function Jz() {
  if (Fb) return Gp;
  Fb = 1;
  var e = Xh();
  function n() {
  }
  function i() {
  }
  return i.resetWarningCache = n, Gp = function() {
    function a(c, I, h, m, w, x) {
      if (x !== e) {
        var M = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw M.name = "Invariant Violation", M;
      }
    }
    a.isRequired = a;
    function s() {
      return a;
    }
    var g = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: s,
      element: a,
      elementType: a,
      instanceOf: s,
      node: a,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: i,
      resetWarningCache: n
    };
    return g.PropTypes = g, g;
  }, Gp;
}
if (process.env.NODE_ENV !== "production") {
  var Yz = jS(), Qz = !0;
  V7.exports = Kz()(Yz.isElement, Qz);
} else
  V7.exports = Jz()();
var F1 = V7.exports;
const E = /* @__PURE__ */ _A(F1);
var Xz = !1;
function Gz(e) {
  if (e.sheet)
    return e.sheet;
  for (var n = 0; n < document.styleSheets.length; n++)
    if (document.styleSheets[n].ownerNode === e)
      return document.styleSheets[n];
}
function qz(e) {
  var n = document.createElement("style");
  return n.setAttribute("data-emotion", e.key), e.nonce !== void 0 && n.setAttribute("nonce", e.nonce), n.appendChild(document.createTextNode("")), n.setAttribute("data-s", ""), n;
}
var Zz = /* @__PURE__ */ function() {
  function e(i) {
    var a = this;
    this._insertTag = function(s) {
      var g;
      a.tags.length === 0 ? a.insertionPoint ? g = a.insertionPoint.nextSibling : a.prepend ? g = a.container.firstChild : g = a.before : g = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(s, g), a.tags.push(s);
    }, this.isSpeedy = i.speedy === void 0 ? !Xz : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var n = e.prototype;
  return n.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, n.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(qz(this));
    var s = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var g = Gz(s);
      try {
        g.insertRule(a, g.cssRules.length);
      } catch {
      }
    } else
      s.appendChild(document.createTextNode(a));
    this.ctr++;
  }, n.flush = function() {
    this.tags.forEach(function(a) {
      var s;
      return (s = a.parentNode) == null ? void 0 : s.removeChild(a);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Or = "-ms-", hA = "-moz-", _t = "-webkit-", NS = "comm", Gh = "rule", qh = "decl", $z = "@import", PS = "@keyframes", eN = "@layer", tN = Math.abs, VA = String.fromCharCode, nN = Object.assign;
function rN(e, n) {
  return or(e, 0) ^ 45 ? (((n << 2 ^ or(e, 0)) << 2 ^ or(e, 1)) << 2 ^ or(e, 2)) << 2 ^ or(e, 3) : 0;
}
function FS(e) {
  return e.trim();
}
function iN(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function Vt(e, n, i) {
  return e.replace(n, i);
}
function K7(e, n) {
  return e.indexOf(n);
}
function or(e, n) {
  return e.charCodeAt(n) | 0;
}
function hf(e, n, i) {
  return e.slice(n, i);
}
function x0(e) {
  return e.length;
}
function Zh(e) {
  return e.length;
}
function FC(e, n) {
  return n.push(e), e;
}
function aN(e, n) {
  return e.map(n).join("");
}
var KA = 1, Tc = 1, BS = 0, y3 = 0, h2 = 0, Pc = "";
function JA(e, n, i, a, s, g, c) {
  return { value: e, root: n, parent: i, type: a, props: s, children: g, line: KA, column: Tc, length: c, return: "" };
}
function Yg(e, n) {
  return nN(JA("", null, null, "", null, null, 0), e, { length: -e.length }, n);
}
function oN() {
  return h2;
}
function sN() {
  return h2 = y3 > 0 ? or(Pc, --y3) : 0, Tc--, h2 === 10 && (Tc = 1, KA--), h2;
}
function O3() {
  return h2 = y3 < BS ? or(Pc, y3++) : 0, Tc++, h2 === 10 && (Tc = 1, KA++), h2;
}
function j0() {
  return or(Pc, y3);
}
function aA() {
  return y3;
}
function Rf(e, n) {
  return hf(Pc, e, n);
}
function mf(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function HS(e) {
  return KA = Tc = 1, BS = x0(Pc = e), y3 = 0, [];
}
function US(e) {
  return Pc = "", e;
}
function oA(e) {
  return FS(Rf(y3 - 1, J7(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function lN(e) {
  for (; (h2 = j0()) && h2 < 33; )
    O3();
  return mf(e) > 2 || mf(h2) > 3 ? "" : " ";
}
function uN(e, n) {
  for (; --n && O3() && !(h2 < 48 || h2 > 102 || h2 > 57 && h2 < 65 || h2 > 70 && h2 < 97); )
    ;
  return Rf(e, aA() + (n < 6 && j0() == 32 && O3() == 32));
}
function J7(e) {
  for (; O3(); )
    switch (h2) {
      case e:
        return y3;
      case 34:
      case 39:
        e !== 34 && e !== 39 && J7(h2);
        break;
      case 40:
        e === 41 && J7(e);
        break;
      case 92:
        O3();
        break;
    }
  return y3;
}
function cN(e, n) {
  for (; O3() && e + h2 !== 57; )
    if (e + h2 === 84 && j0() === 47)
      break;
  return "/*" + Rf(n, y3 - 1) + "*" + VA(e === 47 ? e : O3());
}
function gN(e) {
  for (; !mf(j0()); )
    O3();
  return Rf(e, y3);
}
function fN(e) {
  return US(sA("", null, null, null, [""], e = HS(e), 0, [0], e));
}
function sA(e, n, i, a, s, g, c, I, h) {
  for (var m = 0, w = 0, x = c, M = 0, O = 0, k = 0, z = 1, N = 1, U = 1, Q = 0, _ = "", X = s, B = g, Z = a, Y = _; N; )
    switch (k = Q, Q = O3()) {
      case 40:
        if (k != 108 && or(Y, x - 1) == 58) {
          K7(Y += Vt(oA(Q), "&", "&\f"), "&\f") != -1 && (U = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        Y += oA(Q);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        Y += lN(k);
        break;
      case 92:
        Y += uN(aA() - 1, 7);
        continue;
      case 47:
        switch (j0()) {
          case 42:
          case 47:
            FC(dN(cN(O3(), aA()), n, i), h);
            break;
          default:
            Y += "/";
        }
        break;
      case 123 * z:
        I[m++] = x0(Y) * U;
      case 125 * z:
      case 59:
      case 0:
        switch (Q) {
          case 0:
          case 125:
            N = 0;
          case 59 + w:
            U == -1 && (Y = Vt(Y, /\f/g, "")), O > 0 && x0(Y) - x && FC(O > 32 ? Hb(Y + ";", a, i, x - 1) : Hb(Vt(Y, " ", "") + ";", a, i, x - 2), h);
            break;
          case 59:
            Y += ";";
          default:
            if (FC(Z = Bb(Y, n, i, m, w, s, I, _, X = [], B = [], x), g), Q === 123)
              if (w === 0)
                sA(Y, n, Z, Z, X, g, x, I, B);
              else
                switch (M === 99 && or(Y, 3) === 110 ? 100 : M) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    sA(e, Z, Z, a && FC(Bb(e, Z, Z, 0, 0, s, I, _, s, X = [], x), B), s, B, x, I, a ? X : B);
                    break;
                  default:
                    sA(Y, Z, Z, Z, [""], B, 0, I, B);
                }
        }
        m = w = O = 0, z = U = 1, _ = Y = "", x = c;
        break;
      case 58:
        x = 1 + x0(Y), O = k;
      default:
        if (z < 1) {
          if (Q == 123)
            --z;
          else if (Q == 125 && z++ == 0 && sN() == 125)
            continue;
        }
        switch (Y += VA(Q), Q * z) {
          case 38:
            U = w > 0 ? 1 : (Y += "\f", -1);
            break;
          case 44:
            I[m++] = (x0(Y) - 1) * U, U = 1;
            break;
          case 64:
            j0() === 45 && (Y += oA(O3())), M = j0(), w = x = x0(_ = Y += gN(aA())), Q++;
            break;
          case 45:
            k === 45 && x0(Y) == 2 && (z = 0);
        }
    }
  return g;
}
function Bb(e, n, i, a, s, g, c, I, h, m, w) {
  for (var x = s - 1, M = s === 0 ? g : [""], O = Zh(M), k = 0, z = 0, N = 0; k < a; ++k)
    for (var U = 0, Q = hf(e, x + 1, x = tN(z = c[k])), _ = e; U < O; ++U)
      (_ = FS(z > 0 ? M[U] + " " + Q : Vt(Q, /&\f/g, M[U]))) && (h[N++] = _);
  return JA(e, n, i, s === 0 ? Gh : I, h, m, w);
}
function dN(e, n, i) {
  return JA(e, n, i, NS, VA(oN()), hf(e, 2, -2), 0);
}
function Hb(e, n, i, a) {
  return JA(e, n, i, qh, hf(e, 0, a), hf(e, a + 1, -1), a);
}
function Sc(e, n) {
  for (var i = "", a = Zh(e), s = 0; s < a; s++)
    i += n(e[s], s, e, n) || "";
  return i;
}
function CN(e, n, i, a) {
  switch (e.type) {
    case eN:
      if (e.children.length) break;
    case $z:
    case qh:
      return e.return = e.return || e.value;
    case NS:
      return "";
    case PS:
      return e.return = e.value + "{" + Sc(e.children, a) + "}";
    case Gh:
      e.value = e.props.join(",");
  }
  return x0(i = Sc(e.children, a)) ? e.return = e.value + "{" + i + "}" : "";
}
function AN(e) {
  var n = Zh(e);
  return function(i, a, s, g) {
    for (var c = "", I = 0; I < n; I++)
      c += e[I](i, a, s, g) || "";
    return c;
  };
}
function IN(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
var pN = function(n, i, a) {
  for (var s = 0, g = 0; s = g, g = j0(), s === 38 && g === 12 && (i[a] = 1), !mf(g); )
    O3();
  return Rf(n, y3);
}, hN = function(n, i) {
  var a = -1, s = 44;
  do
    switch (mf(s)) {
      case 0:
        s === 38 && j0() === 12 && (i[a] = 1), n[a] += pN(y3 - 1, i, a);
        break;
      case 2:
        n[a] += oA(s);
        break;
      case 4:
        if (s === 44) {
          n[++a] = j0() === 58 ? "&\f" : "", i[a] = n[a].length;
          break;
        }
      default:
        n[a] += VA(s);
    }
  while (s = O3());
  return n;
}, mN = function(n, i) {
  return US(hN(HS(n), i));
}, Ub = /* @__PURE__ */ new WeakMap(), vN = function(n) {
  if (!(n.type !== "rule" || !n.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  n.length < 1)) {
    for (var i = n.value, a = n.parent, s = n.column === a.column && n.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a) return;
    if (!(n.props.length === 1 && i.charCodeAt(0) !== 58 && !Ub.get(a)) && !s) {
      Ub.set(n, !0);
      for (var g = [], c = mN(i, g), I = a.props, h = 0, m = 0; h < c.length; h++)
        for (var w = 0; w < I.length; w++, m++)
          n.props[m] = g[h] ? c[h].replace(/&\f/g, I[w]) : I[w] + " " + c[h];
    }
  }
}, yN = function(n) {
  if (n.type === "decl") {
    var i = n.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (n.return = "", n.value = "");
  }
};
function WS(e, n) {
  switch (rN(e, n)) {
    case 5103:
      return _t + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return _t + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return _t + e + hA + e + Or + e + e;
    case 6828:
    case 4268:
      return _t + e + Or + e + e;
    case 6165:
      return _t + e + Or + "flex-" + e + e;
    case 5187:
      return _t + e + Vt(e, /(\w+).+(:[^]+)/, _t + "box-$1$2" + Or + "flex-$1$2") + e;
    case 5443:
      return _t + e + Or + "flex-item-" + Vt(e, /flex-|-self/, "") + e;
    case 4675:
      return _t + e + Or + "flex-line-pack" + Vt(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return _t + e + Or + Vt(e, "shrink", "negative") + e;
    case 5292:
      return _t + e + Or + Vt(e, "basis", "preferred-size") + e;
    case 6060:
      return _t + "box-" + Vt(e, "-grow", "") + _t + e + Or + Vt(e, "grow", "positive") + e;
    case 4554:
      return _t + Vt(e, /([^-])(transform)/g, "$1" + _t + "$2") + e;
    case 6187:
      return Vt(Vt(Vt(e, /(zoom-|grab)/, _t + "$1"), /(image-set)/, _t + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Vt(e, /(image-set\([^]*)/, _t + "$1$`$1");
    case 4968:
      return Vt(Vt(e, /(.+:)(flex-)?(.*)/, _t + "box-pack:$3" + Or + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + _t + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Vt(e, /(.+)-inline(.+)/, _t + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (x0(e) - 1 - n > 6) switch (or(e, n + 1)) {
        case 109:
          if (or(e, n + 4) !== 45) break;
        case 102:
          return Vt(e, /(.+:)(.+)-([^]+)/, "$1" + _t + "$2-$3$1" + hA + (or(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~K7(e, "stretch") ? WS(Vt(e, "stretch", "fill-available"), n) + e : e;
      }
      break;
    case 4949:
      if (or(e, n + 1) !== 115) break;
    case 6444:
      switch (or(e, x0(e) - 3 - (~K7(e, "!important") && 10))) {
        case 107:
          return Vt(e, ":", ":" + _t) + e;
        case 101:
          return Vt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + _t + (or(e, 14) === 45 ? "inline-" : "") + "box$3$1" + _t + "$2$3$1" + Or + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (or(e, n + 11)) {
        case 114:
          return _t + e + Or + Vt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return _t + e + Or + Vt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return _t + e + Or + Vt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return _t + e + Or + e + e;
  }
  return e;
}
var bN = function(n, i, a, s) {
  if (n.length > -1 && !n.return) switch (n.type) {
    case qh:
      n.return = WS(n.value, n.length);
      break;
    case PS:
      return Sc([Yg(n, {
        value: Vt(n.value, "@", "@" + _t)
      })], s);
    case Gh:
      if (n.length) return aN(n.props, function(g) {
        switch (iN(g, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Sc([Yg(n, {
              props: [Vt(g, /:(read-\w+)/, ":" + hA + "$1")]
            })], s);
          case "::placeholder":
            return Sc([Yg(n, {
              props: [Vt(g, /:(plac\w+)/, ":" + _t + "input-$1")]
            }), Yg(n, {
              props: [Vt(g, /:(plac\w+)/, ":" + hA + "$1")]
            }), Yg(n, {
              props: [Vt(g, /:(plac\w+)/, Or + "input-$1")]
            })], s);
        }
        return "";
      });
  }
}, wN = [bN], xN = function(n) {
  var i = n.key;
  if (i === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(z) {
      var N = z.getAttribute("data-emotion");
      N.indexOf(" ") !== -1 && (document.head.appendChild(z), z.setAttribute("data-s", ""));
    });
  }
  var s = n.stylisPlugins || wN, g = {}, c, I = [];
  c = n.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(z) {
      for (var N = z.getAttribute("data-emotion").split(" "), U = 1; U < N.length; U++)
        g[N[U]] = !0;
      I.push(z);
    }
  );
  var h, m = [vN, yN];
  {
    var w, x = [CN, IN(function(z) {
      w.insert(z);
    })], M = AN(m.concat(s, x)), O = function(N) {
      return Sc(fN(N), M);
    };
    h = function(N, U, Q, _) {
      w = Q, O(N ? N + "{" + U.styles + "}" : U.styles), _ && (k.inserted[U.name] = !0);
    };
  }
  var k = {
    key: i,
    sheet: new Zz({
      key: i,
      container: c,
      nonce: n.nonce,
      speedy: n.speedy,
      prepend: n.prepend,
      insertionPoint: n.insertionPoint
    }),
    nonce: n.nonce,
    inserted: g,
    registered: {},
    insert: h
  };
  return k.sheet.hydrate(I), k;
}, Y7 = { exports: {} }, Qg = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wb;
function SN() {
  if (Wb) return Qg;
  Wb = 1;
  var e = nn, n = Symbol.for("react.element"), i = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(I, h, m) {
    var w, x = {}, M = null, O = null;
    m !== void 0 && (M = "" + m), h.key !== void 0 && (M = "" + h.key), h.ref !== void 0 && (O = h.ref);
    for (w in h) a.call(h, w) && !g.hasOwnProperty(w) && (x[w] = h[w]);
    if (I && I.defaultProps) for (w in h = I.defaultProps, h) x[w] === void 0 && (x[w] = h[w]);
    return { $$typeof: n, type: I, key: M, ref: O, props: x, _owner: s.current };
  }
  return Qg.Fragment = i, Qg.jsx = c, Qg.jsxs = c, Qg;
}
var Xg = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _b;
function EN() {
  return _b || (_b = 1, process.env.NODE_ENV !== "production" && function() {
    var e = nn, n = Symbol.for("react.element"), i = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), I = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), k = Symbol.iterator, z = "@@iterator";
    function N(G) {
      if (G === null || typeof G != "object")
        return null;
      var P1 = k && G[k] || G[z];
      return typeof P1 == "function" ? P1 : null;
    }
    var U = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Q(G) {
      {
        for (var P1 = arguments.length, re = new Array(P1 > 1 ? P1 - 1 : 0), be = 1; be < P1; be++)
          re[be - 1] = arguments[be];
        _("error", G, re);
      }
    }
    function _(G, P1, re) {
      {
        var be = U.ReactDebugCurrentFrame, st = be.getStackAddendum();
        st !== "" && (P1 += "%s", re = re.concat([st]));
        var ft = re.map(function(He) {
          return String(He);
        });
        ft.unshift("Warning: " + P1), Function.prototype.apply.call(console[G], console, ft);
      }
    }
    var X = !1, B = !1, Z = !1, Y = !1, V = !1, J;
    J = Symbol.for("react.module.reference");
    function e1(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === a || G === g || V || G === s || G === m || G === w || Y || G === O || X || B || Z || typeof G == "object" && G !== null && (G.$$typeof === M || G.$$typeof === x || G.$$typeof === c || G.$$typeof === I || G.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === J || G.getModuleId !== void 0));
    }
    function f1(G, P1, re) {
      var be = G.displayName;
      if (be)
        return be;
      var st = P1.displayName || P1.name || "";
      return st !== "" ? re + "(" + st + ")" : re;
    }
    function v1(G) {
      return G.displayName || "Context";
    }
    function a1(G) {
      if (G == null)
        return null;
      if (typeof G.tag == "number" && Q("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof G == "function")
        return G.displayName || G.name || null;
      if (typeof G == "string")
        return G;
      switch (G) {
        case a:
          return "Fragment";
        case i:
          return "Portal";
        case g:
          return "Profiler";
        case s:
          return "StrictMode";
        case m:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case I:
            var P1 = G;
            return v1(P1) + ".Consumer";
          case c:
            var re = G;
            return v1(re._context) + ".Provider";
          case h:
            return f1(G, G.render, "ForwardRef");
          case x:
            var be = G.displayName || null;
            return be !== null ? be : a1(G.type) || "Memo";
          case M: {
            var st = G, ft = st._payload, He = st._init;
            try {
              return a1(He(ft));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var d1 = Object.assign, S1 = 0, h1, L1, c1, b1, t1, C1, w1;
    function E1() {
    }
    E1.__reactDisabledLog = !0;
    function V1() {
      {
        if (S1 === 0) {
          h1 = console.log, L1 = console.info, c1 = console.warn, b1 = console.error, t1 = console.group, C1 = console.groupCollapsed, w1 = console.groupEnd;
          var G = {
            configurable: !0,
            enumerable: !0,
            value: E1,
            writable: !0
          };
          Object.defineProperties(console, {
            info: G,
            log: G,
            warn: G,
            error: G,
            group: G,
            groupCollapsed: G,
            groupEnd: G
          });
        }
        S1++;
      }
    }
    function K1() {
      {
        if (S1--, S1 === 0) {
          var G = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: d1({}, G, {
              value: h1
            }),
            info: d1({}, G, {
              value: L1
            }),
            warn: d1({}, G, {
              value: c1
            }),
            error: d1({}, G, {
              value: b1
            }),
            group: d1({}, G, {
              value: t1
            }),
            groupCollapsed: d1({}, G, {
              value: C1
            }),
            groupEnd: d1({}, G, {
              value: w1
            })
          });
        }
        S1 < 0 && Q("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var B1 = U.ReactCurrentDispatcher, te;
    function R1(G, P1, re) {
      {
        if (te === void 0)
          try {
            throw Error();
          } catch (st) {
            var be = st.stack.trim().match(/\n( *(at )?)/);
            te = be && be[1] || "";
          }
        return `
` + te + G;
      }
    }
    var x1 = !1, J1;
    {
      var X1 = typeof WeakMap == "function" ? WeakMap : Map;
      J1 = new X1();
    }
    function D1(G, P1) {
      if (!G || x1)
        return "";
      {
        var re = J1.get(G);
        if (re !== void 0)
          return re;
      }
      var be;
      x1 = !0;
      var st = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ft;
      ft = B1.current, B1.current = null, V1();
      try {
        if (P1) {
          var He = function() {
            throw Error();
          };
          if (Object.defineProperty(He.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(He, []);
            } catch (Gn) {
              be = Gn;
            }
            Reflect.construct(G, [], He);
          } else {
            try {
              He.call();
            } catch (Gn) {
              be = Gn;
            }
            G.call(He.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Gn) {
            be = Gn;
          }
          G();
        }
      } catch (Gn) {
        if (Gn && be && typeof Gn.stack == "string") {
          for (var nt = Gn.stack.split(`
`), Un = be.stack.split(`
`), Wt = nt.length - 1, rn = Un.length - 1; Wt >= 1 && rn >= 0 && nt[Wt] !== Un[rn]; )
            rn--;
          for (; Wt >= 1 && rn >= 0; Wt--, rn--)
            if (nt[Wt] !== Un[rn]) {
              if (Wt !== 1 || rn !== 1)
                do
                  if (Wt--, rn--, rn < 0 || nt[Wt] !== Un[rn]) {
                    var P2 = `
` + nt[Wt].replace(" at new ", " at ");
                    return G.displayName && P2.includes("<anonymous>") && (P2 = P2.replace("<anonymous>", G.displayName)), typeof G == "function" && J1.set(G, P2), P2;
                  }
                while (Wt >= 1 && rn >= 0);
              break;
            }
        }
      } finally {
        x1 = !1, B1.current = ft, K1(), Error.prepareStackTrace = st;
      }
      var B3 = G ? G.displayName || G.name : "", Et = B3 ? R1(B3) : "";
      return typeof G == "function" && J1.set(G, Et), Et;
    }
    function $1(G, P1, re) {
      return D1(G, !1);
    }
    function y1(G) {
      var P1 = G.prototype;
      return !!(P1 && P1.isReactComponent);
    }
    function ie(G, P1, re) {
      if (G == null)
        return "";
      if (typeof G == "function")
        return D1(G, y1(G));
      if (typeof G == "string")
        return R1(G);
      switch (G) {
        case m:
          return R1("Suspense");
        case w:
          return R1("SuspenseList");
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case h:
            return $1(G.render);
          case x:
            return ie(G.type, P1, re);
          case M: {
            var be = G, st = be._payload, ft = be._init;
            try {
              return ie(ft(st), P1, re);
            } catch {
            }
          }
        }
      return "";
    }
    var ae = Object.prototype.hasOwnProperty, H1 = {}, Y1 = U.ReactDebugCurrentFrame;
    function me(G) {
      if (G) {
        var P1 = G._owner, re = ie(G.type, G._source, P1 ? P1.type : null);
        Y1.setExtraStackFrame(re);
      } else
        Y1.setExtraStackFrame(null);
    }
    function ut(G, P1, re, be, st) {
      {
        var ft = Function.call.bind(ae);
        for (var He in G)
          if (ft(G, He)) {
            var nt = void 0;
            try {
              if (typeof G[He] != "function") {
                var Un = Error((be || "React class") + ": " + re + " type `" + He + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof G[He] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Un.name = "Invariant Violation", Un;
              }
              nt = G[He](P1, He, be, re, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Wt) {
              nt = Wt;
            }
            nt && !(nt instanceof Error) && (me(st), Q("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", be || "React class", re, He, typeof nt), me(null)), nt instanceof Error && !(nt.message in H1) && (H1[nt.message] = !0, me(st), Q("Failed %s type: %s", re, nt.message), me(null));
          }
      }
    }
    var Qe = Array.isArray;
    function Ae(G) {
      return Qe(G);
    }
    function Bt(G) {
      {
        var P1 = typeof Symbol == "function" && Symbol.toStringTag, re = P1 && G[Symbol.toStringTag] || G.constructor.name || "Object";
        return re;
      }
    }
    function ke(G) {
      try {
        return bt(G), !1;
      } catch {
        return !0;
      }
    }
    function bt(G) {
      return "" + G;
    }
    function pt(G) {
      if (ke(G))
        return Q("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Bt(G)), bt(G);
    }
    var rt = U.ReactCurrentOwner, Jt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pe, yn, ee;
    ee = {};
    function ge(G) {
      if (ae.call(G, "ref")) {
        var P1 = Object.getOwnPropertyDescriptor(G, "ref").get;
        if (P1 && P1.isReactWarning)
          return !1;
      }
      return G.ref !== void 0;
    }
    function _e(G) {
      if (ae.call(G, "key")) {
        var P1 = Object.getOwnPropertyDescriptor(G, "key").get;
        if (P1 && P1.isReactWarning)
          return !1;
      }
      return G.key !== void 0;
    }
    function wt(G, P1) {
      if (typeof G.ref == "string" && rt.current && P1 && rt.current.stateNode !== P1) {
        var re = a1(rt.current.type);
        ee[re] || (Q('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', a1(rt.current.type), G.ref), ee[re] = !0);
      }
    }
    function Yt(G, P1) {
      {
        var re = function() {
          Pe || (Pe = !0, Q("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P1));
        };
        re.isReactWarning = !0, Object.defineProperty(G, "key", {
          get: re,
          configurable: !0
        });
      }
    }
    function An(G, P1) {
      {
        var re = function() {
          yn || (yn = !0, Q("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P1));
        };
        re.isReactWarning = !0, Object.defineProperty(G, "ref", {
          get: re,
          configurable: !0
        });
      }
    }
    var sn = function(G, P1, re, be, st, ft, He) {
      var nt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: G,
        key: P1,
        ref: re,
        props: He,
        // Record the component responsible for creating this element.
        _owner: ft
      };
      return nt._store = {}, Object.defineProperty(nt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(nt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: be
      }), Object.defineProperty(nt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: st
      }), Object.freeze && (Object.freeze(nt.props), Object.freeze(nt)), nt;
    };
    function Hn(G, P1, re, be, st) {
      {
        var ft, He = {}, nt = null, Un = null;
        re !== void 0 && (pt(re), nt = "" + re), _e(P1) && (pt(P1.key), nt = "" + P1.key), ge(P1) && (Un = P1.ref, wt(P1, st));
        for (ft in P1)
          ae.call(P1, ft) && !Jt.hasOwnProperty(ft) && (He[ft] = P1[ft]);
        if (G && G.defaultProps) {
          var Wt = G.defaultProps;
          for (ft in Wt)
            He[ft] === void 0 && (He[ft] = Wt[ft]);
        }
        if (nt || Un) {
          var rn = typeof G == "function" ? G.displayName || G.name || "Unknown" : G;
          nt && Yt(He, rn), Un && An(He, rn);
        }
        return sn(G, nt, Un, st, be, rt.current, He);
      }
    }
    var Ht = U.ReactCurrentOwner, b2 = U.ReactDebugCurrentFrame;
    function Ut(G) {
      if (G) {
        var P1 = G._owner, re = ie(G.type, G._source, P1 ? P1.type : null);
        b2.setExtraStackFrame(re);
      } else
        b2.setExtraStackFrame(null);
    }
    var Qt;
    Qt = !1;
    function N3(G) {
      return typeof G == "object" && G !== null && G.$$typeof === n;
    }
    function ci() {
      {
        if (Ht.current) {
          var G = a1(Ht.current.type);
          if (G)
            return `

Check the render method of \`` + G + "`.";
        }
        return "";
      }
    }
    function Vi(G) {
      return "";
    }
    var F0 = {};
    function P3(G) {
      {
        var P1 = ci();
        if (!P1) {
          var re = typeof G == "string" ? G : G.displayName || G.name;
          re && (P1 = `

Check the top-level render call using <` + re + ">.");
        }
        return P1;
      }
    }
    function F3(G, P1) {
      {
        if (!G._store || G._store.validated || G.key != null)
          return;
        G._store.validated = !0;
        var re = P3(P1);
        if (F0[re])
          return;
        F0[re] = !0;
        var be = "";
        G && G._owner && G._owner !== Ht.current && (be = " It was passed a child from " + a1(G._owner.type) + "."), Ut(G), Q('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', re, be), Ut(null);
      }
    }
    function Xn(G, P1) {
      {
        if (typeof G != "object")
          return;
        if (Ae(G))
          for (var re = 0; re < G.length; re++) {
            var be = G[re];
            N3(be) && F3(be, P1);
          }
        else if (N3(G))
          G._store && (G._store.validated = !0);
        else if (G) {
          var st = N(G);
          if (typeof st == "function" && st !== G.entries)
            for (var ft = st.call(G), He; !(He = ft.next()).done; )
              N3(He.value) && F3(He.value, P1);
        }
      }
    }
    function gi(G) {
      {
        var P1 = G.type;
        if (P1 == null || typeof P1 == "string")
          return;
        var re;
        if (typeof P1 == "function")
          re = P1.propTypes;
        else if (typeof P1 == "object" && (P1.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P1.$$typeof === x))
          re = P1.propTypes;
        else
          return;
        if (re) {
          var be = a1(P1);
          ut(re, G.props, "prop", be, G);
        } else if (P1.PropTypes !== void 0 && !Qt) {
          Qt = !0;
          var st = a1(P1);
          Q("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", st || "Unknown");
        }
        typeof P1.getDefaultProps == "function" && !P1.getDefaultProps.isReactClassApproved && Q("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ki(G) {
      {
        for (var P1 = Object.keys(G.props), re = 0; re < P1.length; re++) {
          var be = P1[re];
          if (be !== "children" && be !== "key") {
            Ut(G), Q("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", be), Ut(null);
            break;
          }
        }
        G.ref !== null && (Ut(G), Q("Invalid attribute `ref` supplied to `React.Fragment`."), Ut(null));
      }
    }
    var ln = {};
    function Xr(G, P1, re, be, st, ft) {
      {
        var He = e1(G);
        if (!He) {
          var nt = "";
          (G === void 0 || typeof G == "object" && G !== null && Object.keys(G).length === 0) && (nt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Un = Vi();
          Un ? nt += Un : nt += ci();
          var Wt;
          G === null ? Wt = "null" : Ae(G) ? Wt = "array" : G !== void 0 && G.$$typeof === n ? (Wt = "<" + (a1(G.type) || "Unknown") + " />", nt = " Did you accidentally export a JSX literal instead of a component?") : Wt = typeof G, Q("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Wt, nt);
        }
        var rn = Hn(G, P1, re, st, ft);
        if (rn == null)
          return rn;
        if (He) {
          var P2 = P1.children;
          if (P2 !== void 0)
            if (be)
              if (Ae(P2)) {
                for (var B3 = 0; B3 < P2.length; B3++)
                  Xn(P2[B3], G);
                Object.freeze && Object.freeze(P2);
              } else
                Q("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xn(P2, G);
        }
        if (ae.call(P1, "key")) {
          var Et = a1(G), Gn = Object.keys(P1).filter(function(qr) {
            return qr !== "key";
          }), K2 = Gn.length > 0 ? "{key: someKey, " + Gn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ln[Et + K2]) {
            var it = Gn.length > 0 ? "{" + Gn.join(": ..., ") + ": ...}" : "{}";
            Q(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, K2, Et, it, Et), ln[Et + K2] = !0;
          }
        }
        return G === a ? Ki(rn) : gi(rn), rn;
      }
    }
    function z2(G, P1, re) {
      return Xr(G, P1, re, !0);
    }
    function N2(G, P1, re) {
      return Xr(G, P1, re, !1);
    }
    var Gr = N2, fi = z2;
    Xg.Fragment = a, Xg.jsx = Gr, Xg.jsxs = fi;
  }()), Xg;
}
process.env.NODE_ENV === "production" ? Y7.exports = SN() : Y7.exports = EN();
var v = Y7.exports;
let Q7;
typeof document == "object" && (Q7 = xN({
  key: "css",
  prepend: !0
}));
function _S(e) {
  const {
    injectFirst: n,
    children: i
  } = e;
  return n && Q7 ? /* @__PURE__ */ v.jsx(Rz, {
    value: Q7,
    children: i
  }) : i;
}
process.env.NODE_ENV !== "production" && (_S.propTypes = {
  /**
   * Your component tree.
   */
  children: E.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: E.bool
});
function MN(e) {
  return e == null || Object.keys(e).length === 0;
}
function VS(e) {
  const {
    styles: n,
    defaultTheme: i = {}
  } = e, a = typeof n == "function" ? (s) => n(MN(s) ? i : s) : n;
  return /* @__PURE__ */ v.jsx(Oz, {
    styles: a
  });
}
process.env.NODE_ENV !== "production" && (VS.propTypes = {
  defaultTheme: E.object,
  styles: E.oneOfType([E.array, E.string, E.object, E.func])
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function KS(e, n) {
  const i = Lz(e, n);
  return process.env.NODE_ENV !== "production" ? (...a) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return a.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : a.some((g) => g === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), i(...a);
  } : i;
}
const TN = (e, n) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = n(e.__emotion_styles));
}, LN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: VS,
  StyledEngineProvider: _S,
  ThemeContext: OS,
  css: Dz,
  default: KS,
  internal_processStyles: TN,
  keyframes: WA
}, Symbol.toStringTag, { value: "Module" }));
function Vo(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function JS(e) {
  if (!Vo(e))
    return e;
  const n = {};
  return Object.keys(e).forEach((i) => {
    n[i] = JS(e[i]);
  }), n;
}
function z0(e, n, i = {
  clone: !0
}) {
  const a = i.clone ? k1({}, e) : e;
  return Vo(e) && Vo(n) && Object.keys(n).forEach((s) => {
    Vo(n[s]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, s) && Vo(e[s]) ? a[s] = z0(e[s], n[s], i) : i.clone ? a[s] = Vo(n[s]) ? JS(n[s]) : n[s] : a[s] = n[s];
  }), a;
}
const RN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z0,
  isPlainObject: Vo
}, Symbol.toStringTag, { value: "Module" })), ON = ["values", "unit", "step"], DN = (e) => {
  const n = Object.keys(e).map((i) => ({
    key: i,
    val: e[i]
  })) || [];
  return n.sort((i, a) => i.val - a.val), n.reduce((i, a) => k1({}, i, {
    [a.key]: a.val
  }), {});
};
function YS(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: n = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: i = "px",
    step: a = 5
  } = e, s = Dt(e, ON), g = DN(n), c = Object.keys(g);
  function I(M) {
    return `@media (min-width:${typeof n[M] == "number" ? n[M] : M}${i})`;
  }
  function h(M) {
    return `@media (max-width:${(typeof n[M] == "number" ? n[M] : M) - a / 100}${i})`;
  }
  function m(M, O) {
    const k = c.indexOf(O);
    return `@media (min-width:${typeof n[M] == "number" ? n[M] : M}${i}) and (max-width:${(k !== -1 && typeof n[c[k]] == "number" ? n[c[k]] : O) - a / 100}${i})`;
  }
  function w(M) {
    return c.indexOf(M) + 1 < c.length ? m(M, c[c.indexOf(M) + 1]) : I(M);
  }
  function x(M) {
    const O = c.indexOf(M);
    return O === 0 ? I(c[1]) : O === c.length - 1 ? h(c[O]) : m(M, c[c.indexOf(M) + 1]).replace("@media", "@media not all and");
  }
  return k1({
    keys: c,
    values: g,
    up: I,
    down: h,
    between: m,
    only: w,
    not: x,
    unit: i
  }, s);
}
const kN = {
  borderRadius: 4
}, $o = process.env.NODE_ENV !== "production" ? E.oneOfType([E.number, E.string, E.object, E.array]) : {};
function cf(e, n) {
  return n ? z0(e, n, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const $h = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Vb = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${$h[e]}px)`
};
function La(e, n, i) {
  const a = e.theme || {};
  if (Array.isArray(n)) {
    const g = a.breakpoints || Vb;
    return n.reduce((c, I, h) => (c[g.up(g.keys[h])] = i(n[h]), c), {});
  }
  if (typeof n == "object") {
    const g = a.breakpoints || Vb;
    return Object.keys(n).reduce((c, I) => {
      if (Object.keys(g.values || $h).indexOf(I) !== -1) {
        const h = g.up(I);
        c[h] = i(n[I], I);
      } else {
        const h = I;
        c[h] = n[h];
      }
      return c;
    }, {});
  }
  return i(n);
}
function jN(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((a, s) => {
    const g = e.up(s);
    return a[g] = {}, a;
  }, {})) || {};
}
function zN(e, n) {
  return e.reduce((i, a) => {
    const s = i[a];
    return (!s || Object.keys(s).length === 0) && delete i[a], i;
  }, n);
}
function sr(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Cl(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const NN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sr
}, Symbol.toStringTag, { value: "Module" }));
function YA(e, n, i = !0) {
  if (!n || typeof n != "string")
    return null;
  if (e && e.vars && i) {
    const a = `vars.${n}`.split(".").reduce((s, g) => s && s[g] ? s[g] : null, e);
    if (a != null)
      return a;
  }
  return n.split(".").reduce((a, s) => a && a[s] != null ? a[s] : null, e);
}
function mA(e, n, i, a = i) {
  let s;
  return typeof e == "function" ? s = e(i) : Array.isArray(e) ? s = e[i] || a : s = YA(e, i) || a, n && (s = n(s, a, e)), s;
}
function s2(e) {
  const {
    prop: n,
    cssProperty: i = e.prop,
    themeKey: a,
    transform: s
  } = e, g = (c) => {
    if (c[n] == null)
      return null;
    const I = c[n], h = c.theme, m = YA(h, a) || {};
    return La(c, I, (x) => {
      let M = mA(m, s, x);
      return x === M && typeof x == "string" && (M = mA(m, s, `${n}${x === "default" ? "" : sr(x)}`, x)), i === !1 ? M : {
        [i]: M
      };
    });
  };
  return g.propTypes = process.env.NODE_ENV !== "production" ? {
    [n]: $o
  } : {}, g.filterProps = [n], g;
}
function PN(e) {
  const n = {};
  return (i) => (n[i] === void 0 && (n[i] = e(i)), n[i]);
}
const FN = {
  m: "margin",
  p: "padding"
}, BN = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Kb = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, HN = PN((e) => {
  if (e.length > 2)
    if (Kb[e])
      e = Kb[e];
    else
      return [e];
  const [n, i] = e.split(""), a = FN[n], s = BN[i] || "";
  return Array.isArray(s) ? s.map((g) => a + g) : [a + s];
}), QA = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], XA = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], UN = [...QA, ...XA];
function Of(e, n, i, a) {
  var s;
  const g = (s = YA(e, n, !1)) != null ? s : i;
  return typeof g == "number" ? (c) => typeof c == "string" ? c : (process.env.NODE_ENV !== "production" && typeof c != "number" && console.error(`MUI: Expected ${a} argument to be a number or a string, got ${c}.`), g * c) : Array.isArray(g) ? (c) => typeof c == "string" ? c : (process.env.NODE_ENV !== "production" && (Number.isInteger(c) ? c > g.length - 1 && console.error([`MUI: The value provided (${c}) overflows.`, `The supported values are: ${JSON.stringify(g)}.`, `${c} > ${g.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${n}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${n}\` as a number.`].join(`
`))), g[c]) : typeof g == "function" ? g : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${n}\` value (${g}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function QS(e) {
  return Of(e, "spacing", 8, "spacing");
}
function Df(e, n) {
  if (typeof n == "string" || n == null)
    return n;
  const i = Math.abs(n), a = e(i);
  return n >= 0 ? a : typeof a == "number" ? -a : `-${a}`;
}
function WN(e, n) {
  return (i) => e.reduce((a, s) => (a[s] = Df(n, i), a), {});
}
function _N(e, n, i, a) {
  if (n.indexOf(i) === -1)
    return null;
  const s = HN(i), g = WN(s, a), c = e[i];
  return La(e, c, g);
}
function XS(e, n) {
  const i = QS(e.theme);
  return Object.keys(e).map((a) => _N(e, n, a, i)).reduce(cf, {});
}
function Jn(e) {
  return XS(e, QA);
}
Jn.propTypes = process.env.NODE_ENV !== "production" ? QA.reduce((e, n) => (e[n] = $o, e), {}) : {};
Jn.filterProps = QA;
function Yn(e) {
  return XS(e, XA);
}
Yn.propTypes = process.env.NODE_ENV !== "production" ? XA.reduce((e, n) => (e[n] = $o, e), {}) : {};
Yn.filterProps = XA;
process.env.NODE_ENV !== "production" && UN.reduce((e, n) => (e[n] = $o, e), {});
function VN(e = 8) {
  if (e.mui)
    return e;
  const n = QS({
    spacing: e
  }), i = (...a) => (process.env.NODE_ENV !== "production" && (a.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${a.length}`)), (a.length === 0 ? [1] : a).map((g) => {
    const c = n(g);
    return typeof c == "number" ? `${c}px` : c;
  }).join(" "));
  return i.mui = !0, i;
}
function GA(...e) {
  const n = e.reduce((a, s) => (s.filterProps.forEach((g) => {
    a[g] = s;
  }), a), {}), i = (a) => Object.keys(a).reduce((s, g) => n[g] ? cf(s, n[g](a)) : s, {});
  return i.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((a, s) => Object.assign(a, s.propTypes), {}) : {}, i.filterProps = e.reduce((a, s) => a.concat(s.filterProps), []), i;
}
function ai(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ui(e, n) {
  return s2({
    prop: e,
    themeKey: "borders",
    transform: n
  });
}
const KN = ui("border", ai), JN = ui("borderTop", ai), YN = ui("borderRight", ai), QN = ui("borderBottom", ai), XN = ui("borderLeft", ai), GN = ui("borderColor"), qN = ui("borderTopColor"), ZN = ui("borderRightColor"), $N = ui("borderBottomColor"), eP = ui("borderLeftColor"), tP = ui("outline", ai), nP = ui("outlineColor"), qA = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const n = Of(e.theme, "shape.borderRadius", 4, "borderRadius"), i = (a) => ({
      borderRadius: Df(n, a)
    });
    return La(e, e.borderRadius, i);
  }
  return null;
};
qA.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: $o
} : {};
qA.filterProps = ["borderRadius"];
GA(KN, JN, YN, QN, XN, GN, qN, ZN, $N, eP, qA, tP, nP);
const ZA = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const n = Of(e.theme, "spacing", 8, "gap"), i = (a) => ({
      gap: Df(n, a)
    });
    return La(e, e.gap, i);
  }
  return null;
};
ZA.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: $o
} : {};
ZA.filterProps = ["gap"];
const $A = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const n = Of(e.theme, "spacing", 8, "columnGap"), i = (a) => ({
      columnGap: Df(n, a)
    });
    return La(e, e.columnGap, i);
  }
  return null;
};
$A.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: $o
} : {};
$A.filterProps = ["columnGap"];
const e6 = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const n = Of(e.theme, "spacing", 8, "rowGap"), i = (a) => ({
      rowGap: Df(n, a)
    });
    return La(e, e.rowGap, i);
  }
  return null;
};
e6.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: $o
} : {};
e6.filterProps = ["rowGap"];
const rP = s2({
  prop: "gridColumn"
}), iP = s2({
  prop: "gridRow"
}), aP = s2({
  prop: "gridAutoFlow"
}), oP = s2({
  prop: "gridAutoColumns"
}), sP = s2({
  prop: "gridAutoRows"
}), lP = s2({
  prop: "gridTemplateColumns"
}), uP = s2({
  prop: "gridTemplateRows"
}), cP = s2({
  prop: "gridTemplateAreas"
}), gP = s2({
  prop: "gridArea"
});
GA(ZA, $A, e6, rP, iP, aP, oP, sP, lP, uP, cP, gP);
function Ec(e, n) {
  return n === "grey" ? n : e;
}
const fP = s2({
  prop: "color",
  themeKey: "palette",
  transform: Ec
}), dP = s2({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ec
}), CP = s2({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ec
});
GA(fP, dP, CP);
function R3(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const AP = s2({
  prop: "width",
  transform: R3
}), em = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const n = (i) => {
      var a, s;
      const g = ((a = e.theme) == null || (a = a.breakpoints) == null || (a = a.values) == null ? void 0 : a[i]) || $h[i];
      return g ? ((s = e.theme) == null || (s = s.breakpoints) == null ? void 0 : s.unit) !== "px" ? {
        maxWidth: `${g}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: g
      } : {
        maxWidth: R3(i)
      };
    };
    return La(e, e.maxWidth, n);
  }
  return null;
};
em.filterProps = ["maxWidth"];
const IP = s2({
  prop: "minWidth",
  transform: R3
}), pP = s2({
  prop: "height",
  transform: R3
}), hP = s2({
  prop: "maxHeight",
  transform: R3
}), mP = s2({
  prop: "minHeight",
  transform: R3
});
s2({
  prop: "size",
  cssProperty: "width",
  transform: R3
});
s2({
  prop: "size",
  cssProperty: "height",
  transform: R3
});
const vP = s2({
  prop: "boxSizing"
});
GA(AP, em, IP, pP, hP, mP, vP);
const kf = {
  // borders
  border: {
    themeKey: "borders",
    transform: ai
  },
  borderTop: {
    themeKey: "borders",
    transform: ai
  },
  borderRight: {
    themeKey: "borders",
    transform: ai
  },
  borderBottom: {
    themeKey: "borders",
    transform: ai
  },
  borderLeft: {
    themeKey: "borders",
    transform: ai
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ai
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: qA
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ec
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ec
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ec
  },
  // spacing
  p: {
    style: Yn
  },
  pt: {
    style: Yn
  },
  pr: {
    style: Yn
  },
  pb: {
    style: Yn
  },
  pl: {
    style: Yn
  },
  px: {
    style: Yn
  },
  py: {
    style: Yn
  },
  padding: {
    style: Yn
  },
  paddingTop: {
    style: Yn
  },
  paddingRight: {
    style: Yn
  },
  paddingBottom: {
    style: Yn
  },
  paddingLeft: {
    style: Yn
  },
  paddingX: {
    style: Yn
  },
  paddingY: {
    style: Yn
  },
  paddingInline: {
    style: Yn
  },
  paddingInlineStart: {
    style: Yn
  },
  paddingInlineEnd: {
    style: Yn
  },
  paddingBlock: {
    style: Yn
  },
  paddingBlockStart: {
    style: Yn
  },
  paddingBlockEnd: {
    style: Yn
  },
  m: {
    style: Jn
  },
  mt: {
    style: Jn
  },
  mr: {
    style: Jn
  },
  mb: {
    style: Jn
  },
  ml: {
    style: Jn
  },
  mx: {
    style: Jn
  },
  my: {
    style: Jn
  },
  margin: {
    style: Jn
  },
  marginTop: {
    style: Jn
  },
  marginRight: {
    style: Jn
  },
  marginBottom: {
    style: Jn
  },
  marginLeft: {
    style: Jn
  },
  marginX: {
    style: Jn
  },
  marginY: {
    style: Jn
  },
  marginInline: {
    style: Jn
  },
  marginInlineStart: {
    style: Jn
  },
  marginInlineEnd: {
    style: Jn
  },
  marginBlock: {
    style: Jn
  },
  marginBlockStart: {
    style: Jn
  },
  marginBlockEnd: {
    style: Jn
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: ZA
  },
  rowGap: {
    style: e6
  },
  columnGap: {
    style: $A
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: R3
  },
  maxWidth: {
    style: em
  },
  minWidth: {
    transform: R3
  },
  height: {
    transform: R3
  },
  maxHeight: {
    transform: R3
  },
  minHeight: {
    transform: R3
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function yP(...e) {
  const n = e.reduce((a, s) => a.concat(Object.keys(s)), []), i = new Set(n);
  return e.every((a) => i.size === Object.keys(a).length);
}
function bP(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function GS() {
  function e(i, a, s, g) {
    const c = {
      [i]: a,
      theme: s
    }, I = g[i];
    if (!I)
      return {
        [i]: a
      };
    const {
      cssProperty: h = i,
      themeKey: m,
      transform: w,
      style: x
    } = I;
    if (a == null)
      return null;
    if (m === "typography" && a === "inherit")
      return {
        [i]: a
      };
    const M = YA(s, m) || {};
    return x ? x(c) : La(c, a, (k) => {
      let z = mA(M, w, k);
      return k === z && typeof k == "string" && (z = mA(M, w, `${i}${k === "default" ? "" : sr(k)}`, k)), h === !1 ? z : {
        [h]: z
      };
    });
  }
  function n(i) {
    var a;
    const {
      sx: s,
      theme: g = {}
    } = i || {};
    if (!s)
      return null;
    const c = (a = g.unstable_sxConfig) != null ? a : kf;
    function I(h) {
      let m = h;
      if (typeof h == "function")
        m = h(g);
      else if (typeof h != "object")
        return h;
      if (!m)
        return null;
      const w = jN(g.breakpoints), x = Object.keys(w);
      let M = w;
      return Object.keys(m).forEach((O) => {
        const k = bP(m[O], g);
        if (k != null)
          if (typeof k == "object")
            if (c[O])
              M = cf(M, e(O, k, g, c));
            else {
              const z = La({
                theme: g
              }, k, (N) => ({
                [O]: N
              }));
              yP(z, k) ? M[O] = n({
                sx: k,
                theme: g
              }) : M = cf(M, z);
            }
          else
            M = cf(M, e(O, k, g, c));
      }), zN(x, M);
    }
    return Array.isArray(s) ? s.map(I) : I(s);
  }
  return n;
}
const jf = GS();
jf.filterProps = ["sx"];
function qS(e, n) {
  const i = this;
  return i.vars && typeof i.getColorSchemeSelector == "function" ? {
    [i.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: n
  } : i.palette.mode === e ? n : {};
}
const wP = ["breakpoints", "palette", "spacing", "shape"];
function tm(e = {}, ...n) {
  const {
    breakpoints: i = {},
    palette: a = {},
    spacing: s,
    shape: g = {}
  } = e, c = Dt(e, wP), I = YS(i), h = VN(s);
  let m = z0({
    breakpoints: I,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: k1({
      mode: "light"
    }, a),
    spacing: h,
    shape: k1({}, kN, g)
  }, c);
  return m.applyStyles = qS, m = n.reduce((w, x) => z0(w, x), m), m.unstable_sxConfig = k1({}, kf, c == null ? void 0 : c.unstable_sxConfig), m.unstable_sx = function(x) {
    return jf({
      sx: x,
      theme: this
    });
  }, m;
}
const xP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tm,
  private_createBreakpoints: YS,
  unstable_applyStyles: qS
}, Symbol.toStringTag, { value: "Module" }));
function SP(e) {
  return Object.keys(e).length === 0;
}
function ZS(e = null) {
  const n = o1.useContext(OS);
  return !n || SP(n) ? e : n;
}
const EP = tm();
function $S(e = EP) {
  return ZS(e);
}
const MP = ["sx"], TP = (e) => {
  var n, i;
  const a = {
    systemProps: {},
    otherProps: {}
  }, s = (n = e == null || (i = e.theme) == null ? void 0 : i.unstable_sxConfig) != null ? n : kf;
  return Object.keys(e).forEach((g) => {
    s[g] ? a.systemProps[g] = e[g] : a.otherProps[g] = e[g];
  }), a;
};
function nm(e) {
  const {
    sx: n
  } = e, i = Dt(e, MP), {
    systemProps: a,
    otherProps: s
  } = TP(i);
  let g;
  return Array.isArray(n) ? g = [a, ...n] : typeof n == "function" ? g = (...c) => {
    const I = n(...c);
    return Vo(I) ? k1({}, a, I) : a;
  } : g = k1({}, a, n), k1({}, s, {
    sx: g
  });
}
const LP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jf,
  extendSxProp: nm,
  unstable_createStyleFunctionSx: GS,
  unstable_defaultSxConfig: kf
}, Symbol.toStringTag, { value: "Module" })), Jb = (e) => e, RP = () => {
  let e = Jb;
  return {
    configure(n) {
      e = n;
    },
    generate(n) {
      return e(n);
    },
    reset() {
      e = Jb;
    }
  };
}, eE = RP();
function tE(e) {
  var n, i, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (n = 0; n < s; n++) e[n] && (i = tE(e[n])) && (a && (a += " "), a += i);
  } else for (i in e) e[i] && (a && (a += " "), a += i);
  return a;
}
function tn() {
  for (var e, n, i = 0, a = "", s = arguments.length; i < s; i++) (e = arguments[i]) && (n = tE(e)) && (a && (a += " "), a += n);
  return a;
}
const OP = ["className", "component"];
function DP(e = {}) {
  const {
    themeId: n,
    defaultTheme: i,
    defaultClassName: a = "MuiBox-root",
    generateClassName: s
  } = e, g = KS("div", {
    shouldForwardProp: (I) => I !== "theme" && I !== "sx" && I !== "as"
  })(jf);
  return /* @__PURE__ */ o1.forwardRef(function(h, m) {
    const w = $S(i), x = nm(h), {
      className: M,
      component: O = "div"
    } = x, k = Dt(x, OP);
    return /* @__PURE__ */ v.jsx(g, k1({
      as: O,
      ref: m,
      className: tn(M, s ? s(a) : a),
      theme: n && w[n] || w
    }, k));
  });
}
const kP = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function lr(e, n, i = "Mui") {
  const a = kP[n];
  return a ? `${i}-${a}` : `${eE.generate(e)}-${n}`;
}
function y2(e, n, i = "Mui") {
  const a = {};
  return n.forEach((s) => {
    a[s] = lr(e, s, i);
  }), a;
}
const jP = y2("MuiBox", ["root"]), nE = DP({
  defaultClassName: jP.root,
  generateClassName: eE.generate
});
process.env.NODE_ENV !== "production" && (nE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: E.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
var X7 = { exports: {} }, $t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yb;
function zP() {
  if (Yb) return $t;
  Yb = 1;
  var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), c = Symbol.for("react.context"), I = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), k;
  k = Symbol.for("react.module.reference");
  function z(N) {
    if (typeof N == "object" && N !== null) {
      var U = N.$$typeof;
      switch (U) {
        case e:
          switch (N = N.type, N) {
            case i:
            case s:
            case a:
            case m:
            case w:
              return N;
            default:
              switch (N = N && N.$$typeof, N) {
                case I:
                case c:
                case h:
                case M:
                case x:
                case g:
                  return N;
                default:
                  return U;
              }
          }
        case n:
          return U;
      }
    }
  }
  return $t.ContextConsumer = c, $t.ContextProvider = g, $t.Element = e, $t.ForwardRef = h, $t.Fragment = i, $t.Lazy = M, $t.Memo = x, $t.Portal = n, $t.Profiler = s, $t.StrictMode = a, $t.Suspense = m, $t.SuspenseList = w, $t.isAsyncMode = function() {
    return !1;
  }, $t.isConcurrentMode = function() {
    return !1;
  }, $t.isContextConsumer = function(N) {
    return z(N) === c;
  }, $t.isContextProvider = function(N) {
    return z(N) === g;
  }, $t.isElement = function(N) {
    return typeof N == "object" && N !== null && N.$$typeof === e;
  }, $t.isForwardRef = function(N) {
    return z(N) === h;
  }, $t.isFragment = function(N) {
    return z(N) === i;
  }, $t.isLazy = function(N) {
    return z(N) === M;
  }, $t.isMemo = function(N) {
    return z(N) === x;
  }, $t.isPortal = function(N) {
    return z(N) === n;
  }, $t.isProfiler = function(N) {
    return z(N) === s;
  }, $t.isStrictMode = function(N) {
    return z(N) === a;
  }, $t.isSuspense = function(N) {
    return z(N) === m;
  }, $t.isSuspenseList = function(N) {
    return z(N) === w;
  }, $t.isValidElementType = function(N) {
    return typeof N == "string" || typeof N == "function" || N === i || N === s || N === a || N === m || N === w || N === O || typeof N == "object" && N !== null && (N.$$typeof === M || N.$$typeof === x || N.$$typeof === g || N.$$typeof === c || N.$$typeof === h || N.$$typeof === k || N.getModuleId !== void 0);
  }, $t.typeOf = z, $t;
}
var en = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qb;
function NP() {
  return Qb || (Qb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), c = Symbol.for("react.context"), I = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), k = !1, z = !1, N = !1, U = !1, Q = !1, _;
    _ = Symbol.for("react.module.reference");
    function X(y1) {
      return !!(typeof y1 == "string" || typeof y1 == "function" || y1 === i || y1 === s || Q || y1 === a || y1 === m || y1 === w || U || y1 === O || k || z || N || typeof y1 == "object" && y1 !== null && (y1.$$typeof === M || y1.$$typeof === x || y1.$$typeof === g || y1.$$typeof === c || y1.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y1.$$typeof === _ || y1.getModuleId !== void 0));
    }
    function B(y1) {
      if (typeof y1 == "object" && y1 !== null) {
        var ie = y1.$$typeof;
        switch (ie) {
          case e:
            var ae = y1.type;
            switch (ae) {
              case i:
              case s:
              case a:
              case m:
              case w:
                return ae;
              default:
                var H1 = ae && ae.$$typeof;
                switch (H1) {
                  case I:
                  case c:
                  case h:
                  case M:
                  case x:
                  case g:
                    return H1;
                  default:
                    return ie;
                }
            }
          case n:
            return ie;
        }
      }
    }
    var Z = c, Y = g, V = e, J = h, e1 = i, f1 = M, v1 = x, a1 = n, d1 = s, S1 = a, h1 = m, L1 = w, c1 = !1, b1 = !1;
    function t1(y1) {
      return c1 || (c1 = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function C1(y1) {
      return b1 || (b1 = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function w1(y1) {
      return B(y1) === c;
    }
    function E1(y1) {
      return B(y1) === g;
    }
    function V1(y1) {
      return typeof y1 == "object" && y1 !== null && y1.$$typeof === e;
    }
    function K1(y1) {
      return B(y1) === h;
    }
    function B1(y1) {
      return B(y1) === i;
    }
    function te(y1) {
      return B(y1) === M;
    }
    function R1(y1) {
      return B(y1) === x;
    }
    function x1(y1) {
      return B(y1) === n;
    }
    function J1(y1) {
      return B(y1) === s;
    }
    function X1(y1) {
      return B(y1) === a;
    }
    function D1(y1) {
      return B(y1) === m;
    }
    function $1(y1) {
      return B(y1) === w;
    }
    en.ContextConsumer = Z, en.ContextProvider = Y, en.Element = V, en.ForwardRef = J, en.Fragment = e1, en.Lazy = f1, en.Memo = v1, en.Portal = a1, en.Profiler = d1, en.StrictMode = S1, en.Suspense = h1, en.SuspenseList = L1, en.isAsyncMode = t1, en.isConcurrentMode = C1, en.isContextConsumer = w1, en.isContextProvider = E1, en.isElement = V1, en.isForwardRef = K1, en.isFragment = B1, en.isLazy = te, en.isMemo = R1, en.isPortal = x1, en.isProfiler = J1, en.isStrictMode = X1, en.isSuspense = D1, en.isSuspenseList = $1, en.isValidElementType = X, en.typeOf = B;
  }()), en;
}
process.env.NODE_ENV === "production" ? X7.exports = zP() : X7.exports = NP();
var vA = X7.exports;
const PP = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function rE(e) {
  const n = `${e}`.match(PP);
  return n && n[1] || "";
}
function iE(e, n = "") {
  return e.displayName || e.name || rE(e) || n;
}
function Xb(e, n, i) {
  const a = iE(n);
  return e.displayName || (a !== "" ? `${i}(${a})` : i);
}
function FP(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return iE(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case vA.ForwardRef:
          return Xb(e, e.render, "ForwardRef");
        case vA.Memo:
          return Xb(e, e.type, "memo");
        default:
          return;
      }
  }
}
const BP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FP,
  getFunctionName: rE
}, Symbol.toStringTag, { value: "Module" }));
function yA(e, n) {
  const i = k1({}, n);
  return Object.keys(e).forEach((a) => {
    if (a.toString().match(/^(components|slots)$/))
      i[a] = k1({}, e[a], i[a]);
    else if (a.toString().match(/^(componentsProps|slotProps)$/)) {
      const s = e[a] || {}, g = n[a];
      i[a] = {}, !g || !Object.keys(g) ? i[a] = s : !s || !Object.keys(s) ? i[a] = g : (i[a] = k1({}, g), Object.keys(s).forEach((c) => {
        i[a][c] = yA(s[c], g[c]);
      }));
    } else i[a] === void 0 && (i[a] = e[a]);
  }), i;
}
function HP(e) {
  const {
    theme: n,
    name: i,
    props: a
  } = e;
  return !n || !n.components || !n.components[i] || !n.components[i].defaultProps ? a : yA(n.components[i].defaultProps, a);
}
const Lc = typeof window < "u" ? o1.useLayoutEffect : o1.useEffect;
function UP(e, n, i, a, s) {
  const [g, c] = o1.useState(() => s && i ? i(e).matches : a ? a(e).matches : n);
  return Lc(() => {
    let I = !0;
    if (!i)
      return;
    const h = i(e), m = () => {
      I && c(h.matches);
    };
    return m(), h.addListener(m), () => {
      I = !1, h.removeListener(m);
    };
  }, [e, i]), g;
}
const aE = o1.useSyncExternalStore;
function WP(e, n, i, a, s) {
  const g = o1.useCallback(() => n, [n]), c = o1.useMemo(() => {
    if (s && i)
      return () => i(e).matches;
    if (a !== null) {
      const {
        matches: w
      } = a(e);
      return () => w;
    }
    return g;
  }, [g, e, a, s, i]), [I, h] = o1.useMemo(() => {
    if (i === null)
      return [g, () => () => {
      }];
    const w = i(e);
    return [() => w.matches, (x) => (w.addListener(x), () => {
      w.removeListener(x);
    })];
  }, [g, i, e]);
  return aE(h, I, c);
}
function Gb(e, n = {}) {
  const i = ZS(), a = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: s = !1,
    matchMedia: g = a ? window.matchMedia : null,
    ssrMatchMedia: c = null,
    noSsr: I = !1
  } = HP({
    name: "MuiUseMediaQuery",
    props: n,
    theme: i
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let h = typeof e == "function" ? e(i) : e;
  h = h.replace(/^@media( ?)/m, "");
  const w = (aE !== void 0 ? WP : UP)(h, s, g, c, I);
  return process.env.NODE_ENV !== "production" && o1.useDebugValue({
    query: h,
    match: w
  }), w;
}
function oE(e, n = Number.MIN_SAFE_INTEGER, i = Number.MAX_SAFE_INTEGER) {
  return Math.max(n, Math.min(e, i));
}
const _P = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oE
}, Symbol.toStringTag, { value: "Module" }));
function VP(e, n = 0, i = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > i) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${i}].`), oE(e, n, i);
}
function KP(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(n);
  return i && i[0].length === 1 && (i = i.map((a) => a + a)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((a, s) => s < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function sE(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return sE(KP(e));
  const n = e.indexOf("("), i = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Cl(9, e));
  let a = e.substring(n + 1, e.length - 1), s;
  if (i === "color") {
    if (a = a.split(" "), s = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Cl(10, s));
  } else
    a = a.split(",");
  return a = a.map((g) => parseFloat(g)), {
    type: i,
    values: a,
    colorSpace: s
  };
}
function JP(e) {
  const {
    type: n,
    colorSpace: i
  } = e;
  let {
    values: a
  } = e;
  return n.indexOf("rgb") !== -1 ? a = a.map((s, g) => g < 3 ? parseInt(s, 10) : s) : n.indexOf("hsl") !== -1 && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), n.indexOf("color") !== -1 ? a = `${i} ${a.join(" ")}` : a = `${a.join(", ")}`, `${n}(${a})`;
}
function YP(e, n) {
  return e = sE(e), n = VP(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, JP(e);
}
function Fc(e, n) {
  return process.env.NODE_ENV === "production" ? () => null : function(...a) {
    return e(...a) || n(...a);
  };
}
function QP(e) {
  const {
    prototype: n = {}
  } = e;
  return !!n.isReactComponent;
}
function lE(e, n, i, a, s) {
  const g = e[n], c = s || n;
  if (g == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let I;
  const h = g.type;
  return typeof h == "function" && !QP(h) && (I = "Did you accidentally use a plain function component for an element instead?"), I !== void 0 ? new Error(`Invalid ${a} \`${c}\` supplied to \`${i}\`. Expected an element that can hold a ref. ${I} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const zf = Fc(E.element, lE);
zf.isRequired = Fc(E.element.isRequired, lE);
function XP(e) {
  const {
    prototype: n = {}
  } = e;
  return !!n.isReactComponent;
}
function GP(e, n, i, a, s) {
  const g = e[n], c = s || n;
  if (g == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let I;
  return typeof g == "function" && !XP(g) && (I = "Did you accidentally provide a plain function component instead?"), I !== void 0 ? new Error(`Invalid ${a} \`${c}\` supplied to \`${i}\`. Expected an element type that can hold a ref. ${I} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const uE = Fc(E.elementType, GP), qP = "exact-prop: ​";
function cE(e) {
  return process.env.NODE_ENV === "production" ? e : k1({}, e, {
    [qP]: (n) => {
      const i = Object.keys(n).filter((a) => !e.hasOwnProperty(a));
      return i.length > 0 ? new Error(`The following props are not supported: ${i.map((a) => `\`${a}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function vf(e, n, i, a, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const g = e[n], c = s || n;
  return g == null ? null : g && g.nodeType !== 1 ? new Error(`Invalid ${a} \`${c}\` supplied to \`${i}\`. Expected an HTMLElement.`) : null;
}
const gE = E.oneOfType([E.func, E.object]);
function qb(...e) {
  return e.reduce((n, i) => i == null ? n : function(...s) {
    n.apply(this, s), i.apply(this, s);
  }, () => {
  });
}
function ZP(e, n = 166) {
  let i;
  function a(...s) {
    const g = () => {
      e.apply(this, s);
    };
    clearTimeout(i), i = setTimeout(g, n);
  }
  return a.clear = () => {
    clearTimeout(i);
  }, a;
}
function si(e) {
  return e && e.ownerDocument || document;
}
function yf(e) {
  return si(e).defaultView || window;
}
function G7(e, n) {
  typeof e == "function" ? e(n) : e && (e.current = n);
}
function vc(e) {
  const n = o1.useRef(e);
  return Lc(() => {
    n.current = e;
  }), o1.useRef((...i) => (
    // @ts-expect-error hide `this`
    (0, n.current)(...i)
  )).current;
}
function _i(...e) {
  return o1.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    e.forEach((i) => {
      G7(i, n);
    });
  }, e);
}
const Zb = {};
function $P(e, n) {
  const i = o1.useRef(Zb);
  return i.current === Zb && (i.current = e(n)), i;
}
const eF = [];
function tF(e) {
  o1.useEffect(e, eF);
}
class t6 {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new t6();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(n, i) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, i();
    }, n);
  }
}
function fE() {
  const e = $P(t6.create).current;
  return tF(e.disposeEffect), e;
}
let n6 = !0, q7 = !1;
const nF = new t6(), rF = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function iF(e) {
  const {
    type: n,
    tagName: i
  } = e;
  return !!(i === "INPUT" && rF[n] && !e.readOnly || i === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function aF(e) {
  e.metaKey || e.altKey || e.ctrlKey || (n6 = !0);
}
function qp() {
  n6 = !1;
}
function oF() {
  this.visibilityState === "hidden" && q7 && (n6 = !0);
}
function sF(e) {
  e.addEventListener("keydown", aF, !0), e.addEventListener("mousedown", qp, !0), e.addEventListener("pointerdown", qp, !0), e.addEventListener("touchstart", qp, !0), e.addEventListener("visibilitychange", oF, !0);
}
function lF(e) {
  const {
    target: n
  } = e;
  try {
    return n.matches(":focus-visible");
  } catch {
  }
  return n6 || iF(n);
}
function uF() {
  const e = o1.useCallback((s) => {
    s != null && sF(s.ownerDocument);
  }, []), n = o1.useRef(!1);
  function i() {
    return n.current ? (q7 = !0, nF.start(100, () => {
      q7 = !1;
    }), n.current = !1, !0) : !1;
  }
  function a(s) {
    return lF(s) ? (n.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: n,
    onFocus: a,
    onBlur: i,
    ref: e
  };
}
function dE(e) {
  const n = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - n);
}
function cF(e) {
  const n = typeof e;
  switch (n) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return n;
  }
}
function gF(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const fF = Number.isInteger || gF;
function CE(e, n, i, a) {
  const s = e[n];
  if (s == null || !fF(s)) {
    const g = cF(s);
    return new RangeError(`Invalid ${a} \`${n}\` of type \`${g}\` supplied to \`${i}\`, expected \`integer\`.`);
  }
  return null;
}
function AE(e, n, ...i) {
  return e[n] === void 0 ? null : CE(e, n, ...i);
}
function Z7() {
  return null;
}
AE.isRequired = CE;
Z7.isRequired = Z7;
const IE = process.env.NODE_ENV === "production" ? Z7 : AE;
function Qr(e, n, i = void 0) {
  const a = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (s) => {
      a[s] = e[s].reduce((g, c) => {
        if (c) {
          const I = n(c);
          I !== "" && g.push(I), i && i[c] && g.push(i[c]);
        }
        return g;
      }, []).join(" ");
    }
  ), a;
}
function pE(e) {
  return typeof e == "string";
}
function dF(e, n, i) {
  return e === void 0 || pE(e) ? n : k1({}, n, {
    ownerState: k1({}, n.ownerState, i)
  });
}
function hE(e, n = []) {
  if (e === void 0)
    return {};
  const i = {};
  return Object.keys(e).filter((a) => a.match(/^on[A-Z]/) && typeof e[a] == "function" && !n.includes(a)).forEach((a) => {
    i[a] = e[a];
  }), i;
}
function $b(e) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((i) => !(i.match(/^on[A-Z]/) && typeof e[i] == "function")).forEach((i) => {
    n[i] = e[i];
  }), n;
}
function CF(e) {
  const {
    getSlotProps: n,
    additionalProps: i,
    externalSlotProps: a,
    externalForwardedProps: s,
    className: g
  } = e;
  if (!n) {
    const O = tn(i == null ? void 0 : i.className, g, s == null ? void 0 : s.className, a == null ? void 0 : a.className), k = k1({}, i == null ? void 0 : i.style, s == null ? void 0 : s.style, a == null ? void 0 : a.style), z = k1({}, i, s, a);
    return O.length > 0 && (z.className = O), Object.keys(k).length > 0 && (z.style = k), {
      props: z,
      internalRef: void 0
    };
  }
  const c = hE(k1({}, s, a)), I = $b(a), h = $b(s), m = n(c), w = tn(m == null ? void 0 : m.className, i == null ? void 0 : i.className, g, s == null ? void 0 : s.className, a == null ? void 0 : a.className), x = k1({}, m == null ? void 0 : m.style, i == null ? void 0 : i.style, s == null ? void 0 : s.style, a == null ? void 0 : a.style), M = k1({}, m, i, h, I);
  return w.length > 0 && (M.className = w), Object.keys(x).length > 0 && (M.style = x), {
    props: M,
    internalRef: m.ref
  };
}
function AF(e, n, i) {
  return typeof e == "function" ? e(n, i) : e;
}
const IF = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Rc(e) {
  var n;
  const {
    elementType: i,
    externalSlotProps: a,
    ownerState: s,
    skipResolvingSlotProps: g = !1
  } = e, c = Dt(e, IF), I = g ? {} : AF(a, s), {
    props: h,
    internalRef: m
  } = CF(k1({}, c, {
    externalSlotProps: I
  })), w = _i(m, I == null ? void 0 : I.ref, (n = e.additionalProps) == null ? void 0 : n.ref);
  return dF(i, k1({}, h, {
    ref: w
  }), s);
}
const pF = /* @__PURE__ */ o1.createContext();
process.env.NODE_ENV !== "production" && (E.node, E.bool);
const hF = () => {
  const e = o1.useContext(pF);
  return e ?? !1;
}, mF = /* @__PURE__ */ o1.createContext(void 0);
process.env.NODE_ENV !== "production" && (E.node, E.object);
function vF(e) {
  const {
    theme: n,
    name: i,
    props: a
  } = e;
  if (!n || !n.components || !n.components[i])
    return a;
  const s = n.components[i];
  return s.defaultProps ? yA(s.defaultProps, a) : !s.styleOverrides && !s.variants ? yA(s, a) : a;
}
function yF({
  props: e,
  name: n
}) {
  const i = o1.useContext(mF);
  return vF({
    props: e,
    name: n,
    theme: {
      components: i
    }
  });
}
function Ra(e) {
  "@babel/helpers - typeof";
  return Ra = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ra(e);
}
function bF(e, n) {
  if (Ra(e) != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var a = i.call(e, n || "default");
    if (Ra(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function mE(e) {
  var n = bF(e, "string");
  return Ra(n) == "symbol" ? n : n + "";
}
function wF(e, n) {
  return k1({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, n);
}
var l2 = {}, vE = { exports: {} };
(function(e) {
  function n(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(vE);
var yE = vE.exports;
const xF = /* @__PURE__ */ Zo(Bz), SF = /* @__PURE__ */ Zo(_P);
var bE = yE;
Object.defineProperty(l2, "__esModule", {
  value: !0
});
var oi = l2.alpha = TE;
l2.blend = zF;
l2.colorChannel = void 0;
var wE = l2.darken = im;
l2.decomposeColor = li;
l2.emphasize = LE;
var ew = l2.getContrastRatio = RF;
l2.getLuminance = bA;
l2.hexToRgb = SE;
l2.hslToRgb = ME;
var xE = l2.lighten = am;
l2.private_safeAlpha = OF;
l2.private_safeColorChannel = void 0;
l2.private_safeDarken = DF;
l2.private_safeEmphasize = jF;
l2.private_safeLighten = kF;
l2.recomposeColor = Bc;
l2.rgbToHex = LF;
var tw = bE(xF), EF = bE(SF);
function rm(e, n = 0, i = 1) {
  return process.env.NODE_ENV !== "production" && (e < n || e > i) && console.error(`MUI: The value provided ${e} is out of range [${n}, ${i}].`), (0, EF.default)(e, n, i);
}
function SE(e) {
  e = e.slice(1);
  const n = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(n);
  return i && i[0].length === 1 && (i = i.map((a) => a + a)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((a, s) => s < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function MF(e) {
  const n = e.toString(16);
  return n.length === 1 ? `0${n}` : n;
}
function li(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return li(SE(e));
  const n = e.indexOf("("), i = e.substring(0, n);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, tw.default)(9, e));
  let a = e.substring(n + 1, e.length - 1), s;
  if (i === "color") {
    if (a = a.split(" "), s = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(s) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, tw.default)(10, s));
  } else
    a = a.split(",");
  return a = a.map((g) => parseFloat(g)), {
    type: i,
    values: a,
    colorSpace: s
  };
}
const EE = (e) => {
  const n = li(e);
  return n.values.slice(0, 3).map((i, a) => n.type.indexOf("hsl") !== -1 && a !== 0 ? `${i}%` : i).join(" ");
};
l2.colorChannel = EE;
const TF = (e, n) => {
  try {
    return EE(e);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
};
l2.private_safeColorChannel = TF;
function Bc(e) {
  const {
    type: n,
    colorSpace: i
  } = e;
  let {
    values: a
  } = e;
  return n.indexOf("rgb") !== -1 ? a = a.map((s, g) => g < 3 ? parseInt(s, 10) : s) : n.indexOf("hsl") !== -1 && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), n.indexOf("color") !== -1 ? a = `${i} ${a.join(" ")}` : a = `${a.join(", ")}`, `${n}(${a})`;
}
function LF(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: n
  } = li(e);
  return `#${n.map((i, a) => MF(a === 3 ? Math.round(255 * i) : i)).join("")}`;
}
function ME(e) {
  e = li(e);
  const {
    values: n
  } = e, i = n[0], a = n[1] / 100, s = n[2] / 100, g = a * Math.min(s, 1 - s), c = (m, w = (m + i / 30) % 12) => s - g * Math.max(Math.min(w - 3, 9 - w, 1), -1);
  let I = "rgb";
  const h = [Math.round(c(0) * 255), Math.round(c(8) * 255), Math.round(c(4) * 255)];
  return e.type === "hsla" && (I += "a", h.push(n[3])), Bc({
    type: I,
    values: h
  });
}
function bA(e) {
  e = li(e);
  let n = e.type === "hsl" || e.type === "hsla" ? li(ME(e)).values : e.values;
  return n = n.map((i) => (e.type !== "color" && (i /= 255), i <= 0.03928 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4)), Number((0.2126 * n[0] + 0.7152 * n[1] + 0.0722 * n[2]).toFixed(3));
}
function RF(e, n) {
  const i = bA(e), a = bA(n);
  return (Math.max(i, a) + 0.05) / (Math.min(i, a) + 0.05);
}
function TE(e, n) {
  return e = li(e), n = rm(n), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${n}` : e.values[3] = n, Bc(e);
}
function OF(e, n, i) {
  try {
    return TE(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function im(e, n) {
  if (e = li(e), n = rm(n), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - n;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - n;
  return Bc(e);
}
function DF(e, n, i) {
  try {
    return im(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function am(e, n) {
  if (e = li(e), n = rm(n), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * n;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * n;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * n;
  return Bc(e);
}
function kF(e, n, i) {
  try {
    return am(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function LE(e, n = 0.15) {
  return bA(e) > 0.5 ? im(e, n) : am(e, n);
}
function jF(e, n, i) {
  try {
    return LE(e, n);
  } catch {
    return i && process.env.NODE_ENV !== "production" && console.warn(i), e;
  }
}
function zF(e, n, i, a = 1) {
  const s = (h, m) => Math.round((h ** (1 / a) * (1 - i) + m ** (1 / a) * i) ** a), g = li(e), c = li(n), I = [s(g.values[0], c.values[0]), s(g.values[1], c.values[1]), s(g.values[2], c.values[2])];
  return Bc({
    type: "rgb",
    values: I
  });
}
const bf = {
  black: "#000",
  white: "#fff"
}, NF = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, gc = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, fc = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Gg = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, dc = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Cc = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Ac = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, PF = ["mode", "contrastThreshold", "tonalOffset"], nw = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: bf.white,
    default: bf.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Zp = {
  text: {
    primary: bf.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: bf.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function rw(e, n, i, a) {
  const s = a.light || a, g = a.dark || a * 1.5;
  e[n] || (e.hasOwnProperty(i) ? e[n] = e[i] : n === "light" ? e.light = xE(e.main, s) : n === "dark" && (e.dark = wE(e.main, g)));
}
function FF(e = "light") {
  return e === "dark" ? {
    main: dc[200],
    light: dc[50],
    dark: dc[400]
  } : {
    main: dc[700],
    light: dc[400],
    dark: dc[800]
  };
}
function BF(e = "light") {
  return e === "dark" ? {
    main: gc[200],
    light: gc[50],
    dark: gc[400]
  } : {
    main: gc[500],
    light: gc[300],
    dark: gc[700]
  };
}
function HF(e = "light") {
  return e === "dark" ? {
    main: fc[500],
    light: fc[300],
    dark: fc[700]
  } : {
    main: fc[700],
    light: fc[400],
    dark: fc[800]
  };
}
function UF(e = "light") {
  return e === "dark" ? {
    main: Cc[400],
    light: Cc[300],
    dark: Cc[700]
  } : {
    main: Cc[700],
    light: Cc[500],
    dark: Cc[900]
  };
}
function WF(e = "light") {
  return e === "dark" ? {
    main: Ac[400],
    light: Ac[300],
    dark: Ac[700]
  } : {
    main: Ac[800],
    light: Ac[500],
    dark: Ac[900]
  };
}
function _F(e = "light") {
  return e === "dark" ? {
    main: Gg[400],
    light: Gg[300],
    dark: Gg[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Gg[500],
    dark: Gg[900]
  };
}
function VF(e) {
  const {
    mode: n = "light",
    contrastThreshold: i = 3,
    tonalOffset: a = 0.2
  } = e, s = Dt(e, PF), g = e.primary || FF(n), c = e.secondary || BF(n), I = e.error || HF(n), h = e.info || UF(n), m = e.success || WF(n), w = e.warning || _F(n);
  function x(z) {
    const N = ew(z, Zp.text.primary) >= i ? Zp.text.primary : nw.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const U = ew(z, N);
      U < 3 && console.error([`MUI: The contrast ratio of ${U}:1 for ${N} on ${z}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return N;
  }
  const M = ({
    color: z,
    name: N,
    mainShade: U = 500,
    lightShade: Q = 300,
    darkShade: _ = 700
  }) => {
    if (z = k1({}, z), !z.main && z[U] && (z.main = z[U]), !z.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${N ? ` (${N})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${U}\` property.` : Cl(11, N ? ` (${N})` : "", U));
    if (typeof z.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${N ? ` (${N})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(z.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Cl(12, N ? ` (${N})` : "", JSON.stringify(z.main)));
    return rw(z, "light", Q, a), rw(z, "dark", _, a), z.contrastText || (z.contrastText = x(z.main)), z;
  }, O = {
    dark: Zp,
    light: nw
  };
  return process.env.NODE_ENV !== "production" && (O[n] || console.error(`MUI: The palette mode \`${n}\` is not supported.`)), z0(k1({
    // A collection of common colors.
    common: k1({}, bf),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: n,
    // The colors used to represent primary interface elements for a user.
    primary: M({
      color: g,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: M({
      color: c,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: M({
      color: I,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: M({
      color: w,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: M({
      color: h,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: M({
      color: m,
      name: "success"
    }),
    // The grey colors.
    grey: NF,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: i,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: x,
    // Generate a rich color object.
    augmentColor: M,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: a
  }, O[n]), s);
}
const KF = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function JF(e) {
  return Math.round(e * 1e5) / 1e5;
}
const iw = {
  textTransform: "uppercase"
}, aw = '"Roboto", "Helvetica", "Arial", sans-serif';
function YF(e, n) {
  const i = typeof n == "function" ? n(e) : n, {
    fontFamily: a = aw,
    // The default font size of the Material Specification.
    fontSize: s = 14,
    // px
    fontWeightLight: g = 300,
    fontWeightRegular: c = 400,
    fontWeightMedium: I = 500,
    fontWeightBold: h = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: m = 16,
    // Apply the CSS properties to all the variants.
    allVariants: w,
    pxToRem: x
  } = i, M = Dt(i, KF);
  process.env.NODE_ENV !== "production" && (typeof s != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof m != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const O = s / 14, k = x || ((U) => `${U / m * O}rem`), z = (U, Q, _, X, B) => k1({
    fontFamily: a,
    fontWeight: U,
    fontSize: k(Q),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: _
  }, a === aw ? {
    letterSpacing: `${JF(X / Q)}em`
  } : {}, B, w), N = {
    h1: z(g, 96, 1.167, -1.5),
    h2: z(g, 60, 1.2, -0.5),
    h3: z(c, 48, 1.167, 0),
    h4: z(c, 34, 1.235, 0.25),
    h5: z(c, 24, 1.334, 0),
    h6: z(I, 20, 1.6, 0.15),
    subtitle1: z(c, 16, 1.75, 0.15),
    subtitle2: z(I, 14, 1.57, 0.1),
    body1: z(c, 16, 1.5, 0.15),
    body2: z(c, 14, 1.43, 0.15),
    button: z(I, 14, 1.75, 0.4, iw),
    caption: z(c, 12, 1.66, 0.4),
    overline: z(c, 12, 2.66, 1, iw),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return z0(k1({
    htmlFontSize: m,
    pxToRem: k,
    fontFamily: a,
    fontSize: s,
    fontWeightLight: g,
    fontWeightRegular: c,
    fontWeightMedium: I,
    fontWeightBold: h
  }, N), M, {
    clone: !1
    // No need to clone deep
  });
}
const QF = 0.2, XF = 0.14, GF = 0.12;
function On(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${QF})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${XF})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${GF})`].join(",");
}
const qF = ["none", On(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), On(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), On(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), On(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), On(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), On(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), On(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), On(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), On(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), On(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), On(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), On(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), On(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), On(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), On(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), On(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), On(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), On(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), On(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), On(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), On(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), On(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), On(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), On(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], ZF = ["duration", "easing", "delay"], $F = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, eB = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function ow(e) {
  return `${Math.round(e)}ms`;
}
function tB(e) {
  if (!e)
    return 0;
  const n = e / 36;
  return Math.round((4 + 15 * n ** 0.25 + n / 5) * 10);
}
function nB(e) {
  const n = k1({}, $F, e.easing), i = k1({}, eB, e.duration);
  return k1({
    getAutoHeightDuration: tB,
    create: (s = ["all"], g = {}) => {
      const {
        duration: c = i.standard,
        easing: I = n.easeInOut,
        delay: h = 0
      } = g, m = Dt(g, ZF);
      if (process.env.NODE_ENV !== "production") {
        const w = (M) => typeof M == "string", x = (M) => !isNaN(parseFloat(M));
        !w(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !x(c) && !w(c) && console.error(`MUI: Argument "duration" must be a number or a string but found ${c}.`), w(I) || console.error('MUI: Argument "easing" must be a string.'), !x(h) && !w(h) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof g != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(m).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(m).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((w) => `${w} ${typeof c == "string" ? c : ow(c)} ${I} ${typeof h == "string" ? h : ow(h)}`).join(",");
    }
  }, e, {
    easing: n,
    duration: i
  });
}
const rB = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, iB = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function $7(e = {}, ...n) {
  const {
    mixins: i = {},
    palette: a = {},
    transitions: s = {},
    typography: g = {}
  } = e, c = Dt(e, iB);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Cl(18));
  const I = VF(a), h = tm(e);
  let m = z0(h, {
    mixins: wF(h.breakpoints, i),
    palette: I,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: qF.slice(),
    typography: YF(I, g),
    transitions: nB(s),
    zIndex: k1({}, rB)
  });
  if (m = z0(m, c), m = n.reduce((w, x) => z0(w, x), m), process.env.NODE_ENV !== "production") {
    const w = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], x = (M, O) => {
      let k;
      for (k in M) {
        const z = M[k];
        if (w.indexOf(k) !== -1 && Object.keys(z).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const N = lr("", k);
            console.error([`MUI: The \`${O}\` component increases the CSS specificity of the \`${k}\` internal state.`, "You can not override it like this: ", JSON.stringify(M, null, 2), "", `Instead, you need to use the '&.${N}' syntax:`, JSON.stringify({
              root: {
                [`&.${N}`]: z
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          M[k] = {};
        }
      }
    };
    Object.keys(m.components).forEach((M) => {
      const O = m.components[M].styleOverrides;
      O && M.indexOf("Mui") === 0 && x(O, M);
    });
  }
  return m.unstable_sxConfig = k1({}, kf, c == null ? void 0 : c.unstable_sxConfig), m.unstable_sx = function(x) {
    return jf({
      sx: x,
      theme: this
    });
  }, m;
}
const RE = $7();
function r6() {
  const e = $S(RE);
  return process.env.NODE_ENV !== "production" && o1.useDebugValue(e), e[kS] || e;
}
var Nf = {}, $p = { exports: {} }, sw;
function aB() {
  return sw || (sw = 1, function(e) {
    function n() {
      return e.exports = n = Object.assign ? Object.assign.bind() : function(i) {
        for (var a = 1; a < arguments.length; a++) {
          var s = arguments[a];
          for (var g in s) ({}).hasOwnProperty.call(s, g) && (i[g] = s[g]);
        }
        return i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n.apply(null, arguments);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }($p)), $p.exports;
}
var e7 = { exports: {} }, lw;
function oB() {
  return lw || (lw = 1, function(e) {
    function n(i, a) {
      if (i == null) return {};
      var s = {};
      for (var g in i) if ({}.hasOwnProperty.call(i, g)) {
        if (a.includes(g)) continue;
        s[g] = i[g];
      }
      return s;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(e7)), e7.exports;
}
const sB = /* @__PURE__ */ Zo(LN), lB = /* @__PURE__ */ Zo(RN), uB = /* @__PURE__ */ Zo(NN), cB = /* @__PURE__ */ Zo(BP), gB = /* @__PURE__ */ Zo(xP), fB = /* @__PURE__ */ Zo(LP);
var Hc = yE;
Object.defineProperty(Nf, "__esModule", {
  value: !0
});
var dB = Nf.default = MB;
Nf.shouldForwardProp = lA;
Nf.systemDefaultTheme = void 0;
var ri = Hc(aB()), eh = Hc(oB()), uw = bB(sB), CB = lB, AB = Hc(uB), IB = Hc(cB), pB = Hc(gB), hB = Hc(fB);
const mB = ["ownerState"], vB = ["variants"], yB = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function OE(e) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
  return (OE = function(a) {
    return a ? i : n;
  })(e);
}
function bB(e, n) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var i = OE(n);
  if (i && i.has(e)) return i.get(e);
  var a = { __proto__: null }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var g in e) if (g !== "default" && Object.prototype.hasOwnProperty.call(e, g)) {
    var c = s ? Object.getOwnPropertyDescriptor(e, g) : null;
    c && (c.get || c.set) ? Object.defineProperty(a, g, c) : a[g] = e[g];
  }
  return a.default = e, i && i.set(e, a), a;
}
function wB(e) {
  return Object.keys(e).length === 0;
}
function xB(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function lA(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const SB = Nf.systemDefaultTheme = (0, pB.default)(), cw = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function BC({
  defaultTheme: e,
  theme: n,
  themeId: i
}) {
  return wB(n) ? e : n[i] || n;
}
function EB(e) {
  return e ? (n, i) => i[e] : null;
}
function uA(e, n) {
  let {
    ownerState: i
  } = n, a = (0, eh.default)(n, mB);
  const s = typeof e == "function" ? e((0, ri.default)({
    ownerState: i
  }, a)) : e;
  if (Array.isArray(s))
    return s.flatMap((g) => uA(g, (0, ri.default)({
      ownerState: i
    }, a)));
  if (s && typeof s == "object" && Array.isArray(s.variants)) {
    const {
      variants: g = []
    } = s;
    let I = (0, eh.default)(s, vB);
    return g.forEach((h) => {
      let m = !0;
      typeof h.props == "function" ? m = h.props((0, ri.default)({
        ownerState: i
      }, a, i)) : Object.keys(h.props).forEach((w) => {
        (i == null ? void 0 : i[w]) !== h.props[w] && a[w] !== h.props[w] && (m = !1);
      }), m && (Array.isArray(I) || (I = [I]), I.push(typeof h.style == "function" ? h.style((0, ri.default)({
        ownerState: i
      }, a, i)) : h.style));
    }), I;
  }
  return s;
}
function MB(e = {}) {
  const {
    themeId: n,
    defaultTheme: i = SB,
    rootShouldForwardProp: a = lA,
    slotShouldForwardProp: s = lA
  } = e, g = (c) => (0, hB.default)((0, ri.default)({}, c, {
    theme: BC((0, ri.default)({}, c, {
      defaultTheme: i,
      themeId: n
    }))
  }));
  return g.__mui_systemSx = !0, (c, I = {}) => {
    (0, uw.internal_processStyles)(c, (B) => B.filter((Z) => !(Z != null && Z.__mui_systemSx)));
    const {
      name: h,
      slot: m,
      skipVariantsResolver: w,
      skipSx: x,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: M = EB(cw(m))
    } = I, O = (0, eh.default)(I, yB), k = w !== void 0 ? w : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      m && m !== "Root" && m !== "root" || !1
    ), z = x || !1;
    let N;
    process.env.NODE_ENV !== "production" && h && (N = `${h}-${cw(m || "Root")}`);
    let U = lA;
    m === "Root" || m === "root" ? U = a : m ? U = s : xB(c) && (U = void 0);
    const Q = (0, uw.default)(c, (0, ri.default)({
      shouldForwardProp: U,
      label: N
    }, O)), _ = (B) => typeof B == "function" && B.__emotion_real !== B || (0, CB.isPlainObject)(B) ? (Z) => uA(B, (0, ri.default)({}, Z, {
      theme: BC({
        theme: Z.theme,
        defaultTheme: i,
        themeId: n
      })
    })) : B, X = (B, ...Z) => {
      let Y = _(B);
      const V = Z ? Z.map(_) : [];
      h && M && V.push((f1) => {
        const v1 = BC((0, ri.default)({}, f1, {
          defaultTheme: i,
          themeId: n
        }));
        if (!v1.components || !v1.components[h] || !v1.components[h].styleOverrides)
          return null;
        const a1 = v1.components[h].styleOverrides, d1 = {};
        return Object.entries(a1).forEach(([S1, h1]) => {
          d1[S1] = uA(h1, (0, ri.default)({}, f1, {
            theme: v1
          }));
        }), M(f1, d1);
      }), h && !k && V.push((f1) => {
        var v1;
        const a1 = BC((0, ri.default)({}, f1, {
          defaultTheme: i,
          themeId: n
        })), d1 = a1 == null || (v1 = a1.components) == null || (v1 = v1[h]) == null ? void 0 : v1.variants;
        return uA({
          variants: d1
        }, (0, ri.default)({}, f1, {
          theme: a1
        }));
      }), z || V.push(g);
      const J = V.length - Z.length;
      if (Array.isArray(B) && J > 0) {
        const f1 = new Array(J).fill("");
        Y = [...B, ...f1], Y.raw = [...B.raw, ...f1];
      }
      const e1 = Q(Y, ...V);
      if (process.env.NODE_ENV !== "production") {
        let f1;
        h && (f1 = `${h}${(0, AB.default)(m || "")}`), f1 === void 0 && (f1 = `Styled(${(0, IB.default)(c)})`), e1.displayName = f1;
      }
      return c.muiName && (e1.muiName = c.muiName), e1;
    };
    return Q.withConfig && (X.withConfig = Q.withConfig), X;
  };
}
function TB(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const om = (e) => TB(e) && e !== "classes", kn = dB({
  themeId: kS,
  defaultTheme: RE,
  rootShouldForwardProp: om
}), gw = (e) => {
  let n;
  return e < 1 ? n = 5.11916 * e ** 2 : n = 4.5 * Math.log(e + 1) + 2, (n / 100).toFixed(2);
}, LB = (e) => ({
  logo: e.assets.logo,
  logoExpanded: e.assets.logo_expanded,
  logoSplash: e.assets.logo_splash,
  loginHero: e.assets.login_hero,
  loginHeroMobile: e.assets.login_hero_mobile
}), RB = "#1565c0", OB = "#434566", DB = "#0061a0", kB = "#434566", jB = "#ea15a4", zB = "#ffffff", NB = "#ffffff", PB = "#ffffff", FB = (e) => ({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&:before": {
            content: "unset"
          },
          ".MuiAccordionSummary-root": {
            "&:hover": { background: e.palette.common.neutrals[50] }
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: 0,
          borderBottom: `solid 1px ${e.palette.common.neutrals[200]}`
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          alignItems: "start",
          margin: "0",
          rowGap: "8px",
          // Center align only for checkbox and switch controls (small controls)
          "&:has(.MuiCheckbox-root), &:has(.MuiSwitch-root)": {
            alignItems: "center"
          }
        },
        label: {
          fontSize: "1rem",
          color: e.palette.common.neutrals[800],
          fontWeight: e.typography.fontWeightRegular,
          lineHeight: "1.5rem",
          "&.Mui-disabled": {
            color: e.palette.common.neutrals[300],
            fontSize: ".938rem"
          }
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: e.palette.common.error[500],
            fontSize: "0.8rem"
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            lineHeight: "1rem"
          },
          "& .MuiInputLabel-shrink": {
            top: "2px"
          }
        },
        input: {
          "&.MuiAutocomplete-input": {
            paddingLeft: 2.5,
            paddingBottom: 2.5,
            paddingTop: 2.5
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&.MuiOutlinedInput-input": {
            padding: "11.5px 12px",
            color: e.palette.common.neutrals[800],
            borderRadius: e.shape.borderRadius
          }
        },
        root: {
          borderRadius: e.shape.borderRadius,
          fontWeight: 400,
          "&.Mui-error": {
            backgroundColor: e.palette.common.error[100],
            color: e.palette.common.error[100]
          },
          "&.Mui-error fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.error[600]
          },
          "&.Mui-disabled": {
            cursor: "not-allowed",
            backgroundColor: e.palette.common.neutrals[100],
            "& .MuiInputBase-input": {
              cursor: "not-allowed"
            }
          },
          "&.Mui-disabled fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.neutrals[300]
          },
          "&.Mui-disabled:hover fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.neutrals[300]
          },
          "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.common.primary[500],
            borderWidth: "1px"
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: e.palette.common.neutrals[200]
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: e.shape.borderRadius
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme: n }) => n.unstable_sx({
          // https://mui.com/system/getting-started/the-sx-prop/#spacing
          px: 1,
          py: 0.25,
          // https://mui.com/system/borders/#border-radius
          borderRadius: 1
          // 4px as default.
        })
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: ({}) => ({}),
        paper: ({ theme: n }) => ({
          minWidth: "240px",
          backgroundColor: n.palette.common.tertiary[500],
          color: n.palette.common.white,
          "html.native-android &": {
            boxSizing: "border-box",
            paddingTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
            paddingBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))",
            "&.MuiDrawer-paperAnchorBottom": { paddingTop: 0 },
            "&.MuiDrawer-paperAnchorTop": { paddingBottom: 0 }
          }
        })
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          "html.native-android &.MuiDialog-paperFullScreen": {
            boxSizing: "border-box",
            paddingTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
            paddingBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          height: "100%",
          alignItems: "center"
        },
        root: ({ theme: n }) => ({
          minHeight: 48,
          height: 48,
          [n.breakpoints.up("sm")]: {
            minHeight: 72,
            height: 72,
            "& .MuiTabs-flexContainer": {
              gap: "24px"
            }
          }
        }),
        indicator: ({ theme: n }) => ({
          backgroundColor: n.palette.text.primary,
          height: 2
        })
      }
    },
    MuiTab: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(14),
          fontWeight: 500,
          lineHeight: 1.5,
          padding: "0 16px",
          minHeight: 48,
          textTransform: "none",
          "&.Mui-selected": {
            color: n.palette.text.primary
          },
          [n.breakpoints.up("sm")]: {
            fontSize: n.typography.pxToRem(16),
            minHeight: 72
          }
        })
      }
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: () => ({
          svg: {
            width: 20,
            height: 20
          },
          "&.Mui-selected": {
            svg: {
              fill: "#b3e7f0"
            },
            color: "#008ba3"
          }
        }),
        label: () => ({
          paddingTop: "4px",
          fontSize: "14px",
          lineHeight: "17.6px",
          "&.Mui-selected": {
            fontSize: "14px"
          }
        })
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          backgroundColor: n.palette.background.default,
          color: "#353c42",
          fontWeight: 400,
          boxShadow: n.shadows[0],
          borderBottom: "solid 1px #e0e1e2",
          paddingBottom: "2px",
          "& .MuiTypography-h2": {
            fontSize: "17px",
            fontWeight: "400",
            lineHeight: "22px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap"
          }
        }),
        colorSecondary: ({ theme: n }) => ({
          backgroundColor: n.palette.grey[50]
        })
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: !1,
        disableElevation: !0
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          lineHeight: 1.9,
          borderRadius: e.shape.borderRadius,
          textTransform: "none"
        },
        startIcon: ({ theme: n }) => ({
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(14)
          }
        }),
        endIcon: ({ theme: n }) => ({
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(14)
          }
        }),
        iconSizeSmall: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(12),
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(12)
          }
        }),
        iconSizeMedium: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(14),
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(14)
          }
        }),
        iconSizeLarge: ({ theme: n }) => ({
          fontSize: n.typography.pxToRem(16),
          "& > *:first-of-type": {
            fontSize: n.typography.pxToRem(16)
          }
        }),
        sizeSmall: {
          fontSize: 12
        },
        sizeMedium: {
          fontSize: 15
        },
        sizeLarge: {
          fontSize: 18
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    },
    MuiMenu: {
      defaultProps: {
        elevation: 3
      },
      styleOverrides: {
        paper: {
          borderRadius: e.shape.borderRadius
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: "12px 20px 12px 25px",
          borderRadius: e.shape.borderRadius,
          [`& .${IS.body1}`]: {
            fontSize: "14px"
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "40px",
          fontSize: "15px"
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          opacity: 1,
          background: e.palette.common.neutrals[200],
          transform: "scaleY(1.8) scaleX(1.4)"
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          // Static link color; Blue800 keeps normal text at 4.5:1 or more on light backgrounds
          color: RB
        }
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          "& .MuiSvgIcon-root": {
            fontSize: n.typography.pxToRem(16)
          }
        })
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          fontSize: "1.125rem"
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          "& .MuiSvgIcon-root": {
            fontSize: n.typography.pxToRem(16)
          }
        }),
        sizeSmall: {
          "& > *:first-of-type": { fontSize: 12 }
        },
        sizeMedium: {
          "& > *:first-of-type": { fontSize: 16 }
        },
        sizeLarge: {
          "& > *:first-of-type": { fontSize: 18 }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme: n }) => ({
          "& .MuiTableCell-head": {
            textTransform: "uppercase",
            fontWeight: 600,
            letterSpacing: "0.06rem",
            color: n.palette.text.secondary,
            "& .MuiSvgIcon-root": {
              verticalAlign: "middle"
            }
          }
        })
      }
    }
  }
}), yc = {
  50: "#FFF0EE",
  100: "#FFDAD6",
  200: "#FFB4AB",
  300: "#FF897D",
  400: "#FF5449",
  500: "#DE3730",
  600: "#BA1A1A",
  700: "#93000A",
  800: "#690005",
  900: "#410002",
  A100: "",
  A200: "",
  A400: "",
  A700: ""
}, HC = {
  50: "#E6FCE8",
  100: "#B4F5BA",
  200: "#83EE8E",
  300: "#51E760",
  400: "#1FE032",
  500: "#1ABA2A",
  600: "#18AE27",
  700: "#117C1C",
  800: "#0A5D12",
  900: "#031905",
  A100: "",
  A200: "",
  A400: "",
  A700: ""
}, BB = Nj.orange, Ui = {
  50: "#FFFFFF",
  100: "#F2F2F2",
  200: "#DBDBDB",
  300: "#A8A6A6",
  400: "#BABABA",
  500: "#8A939A",
  600: "#7D7D7D",
  700: "#4D4D4F",
  800: "#262626",
  900: "#121212",
  A100: "#dfe3e8",
  A200: "#eef0f1",
  A400: "",
  A700: ""
};
function xe(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Oc(e, n) {
  return Oc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, a) {
    return i.__proto__ = a, i;
  }, Oc(e, n);
}
function sm(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Oc(e, n);
}
function wf(e) {
  return wf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, wf(e);
}
function HB(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function lm() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (lm = function() {
    return !!e;
  })();
}
function UB(e, n, i) {
  if (lm()) return Reflect.construct.apply(null, arguments);
  var a = [null];
  a.push.apply(a, n);
  var s = new (e.bind.apply(e, a))();
  return i && Oc(s, i.prototype), s;
}
function th(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return th = function(a) {
    if (a === null || !HB(a)) return a;
    if (typeof a != "function") throw new TypeError("Super expression must either be null or a function");
    if (n !== void 0) {
      if (n.has(a)) return n.get(a);
      n.set(a, s);
    }
    function s() {
      return UB(a, arguments, wf(this).constructor);
    }
    return s.prototype = Object.create(a.prototype, {
      constructor: {
        value: s,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Oc(s, a);
  }, th(e);
}
var WB = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function _B() {
  for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
    n[i] = arguments[i];
  var a = n[0], s = [], g;
  for (g = 1; g < n.length; g += 1)
    s.push(n[g]);
  return s.forEach(function(c) {
    a = a.replace(/%[a-z]/, c);
  }), a;
}
var L0 = /* @__PURE__ */ function(e) {
  sm(n, e);
  function n(i) {
    var a;
    if (process.env.NODE_ENV === "production")
      a = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + i + " for more information.") || this;
    else {
      for (var s = arguments.length, g = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        g[c - 1] = arguments[c];
      a = e.call(this, _B.apply(void 0, [WB[i]].concat(g))) || this;
    }
    return xe(a);
  }
  return n;
}(/* @__PURE__ */ th(Error));
function t7(e) {
  return Math.round(e * 255);
}
function VB(e, n, i) {
  return t7(e) + "," + t7(n) + "," + t7(i);
}
function xf(e, n, i, a) {
  if (a === void 0 && (a = VB), n === 0)
    return a(i, i, i);
  var s = (e % 360 + 360) % 360 / 60, g = (1 - Math.abs(2 * i - 1)) * n, c = g * (1 - Math.abs(s % 2 - 1)), I = 0, h = 0, m = 0;
  s >= 0 && s < 1 ? (I = g, h = c) : s >= 1 && s < 2 ? (I = c, h = g) : s >= 2 && s < 3 ? (h = g, m = c) : s >= 3 && s < 4 ? (h = c, m = g) : s >= 4 && s < 5 ? (I = c, m = g) : s >= 5 && s < 6 && (I = g, m = c);
  var w = i - g / 2, x = I + w, M = h + w, O = m + w;
  return a(x, M, O);
}
var fw = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function KB(e) {
  if (typeof e != "string") return e;
  var n = e.toLowerCase();
  return fw[n] ? "#" + fw[n] : e;
}
var JB = /^#[a-fA-F0-9]{6}$/, YB = /^#[a-fA-F0-9]{8}$/, QB = /^#[a-fA-F0-9]{3}$/, XB = /^#[a-fA-F0-9]{4}$/, n7 = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, GB = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, qB = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, ZB = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function Dc(e) {
  if (typeof e != "string")
    throw new L0(3);
  var n = KB(e);
  if (n.match(JB))
    return {
      red: parseInt("" + n[1] + n[2], 16),
      green: parseInt("" + n[3] + n[4], 16),
      blue: parseInt("" + n[5] + n[6], 16)
    };
  if (n.match(YB)) {
    var i = parseFloat((parseInt("" + n[7] + n[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + n[1] + n[2], 16),
      green: parseInt("" + n[3] + n[4], 16),
      blue: parseInt("" + n[5] + n[6], 16),
      alpha: i
    };
  }
  if (n.match(QB))
    return {
      red: parseInt("" + n[1] + n[1], 16),
      green: parseInt("" + n[2] + n[2], 16),
      blue: parseInt("" + n[3] + n[3], 16)
    };
  if (n.match(XB)) {
    var a = parseFloat((parseInt("" + n[4] + n[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + n[1] + n[1], 16),
      green: parseInt("" + n[2] + n[2], 16),
      blue: parseInt("" + n[3] + n[3], 16),
      alpha: a
    };
  }
  var s = n7.exec(n);
  if (s)
    return {
      red: parseInt("" + s[1], 10),
      green: parseInt("" + s[2], 10),
      blue: parseInt("" + s[3], 10)
    };
  var g = GB.exec(n.substring(0, 50));
  if (g)
    return {
      red: parseInt("" + g[1], 10),
      green: parseInt("" + g[2], 10),
      blue: parseInt("" + g[3], 10),
      alpha: parseFloat("" + g[4]) > 1 ? parseFloat("" + g[4]) / 100 : parseFloat("" + g[4])
    };
  var c = qB.exec(n);
  if (c) {
    var I = parseInt("" + c[1], 10), h = parseInt("" + c[2], 10) / 100, m = parseInt("" + c[3], 10) / 100, w = "rgb(" + xf(I, h, m) + ")", x = n7.exec(w);
    if (!x)
      throw new L0(4, n, w);
    return {
      red: parseInt("" + x[1], 10),
      green: parseInt("" + x[2], 10),
      blue: parseInt("" + x[3], 10)
    };
  }
  var M = ZB.exec(n.substring(0, 50));
  if (M) {
    var O = parseInt("" + M[1], 10), k = parseInt("" + M[2], 10) / 100, z = parseInt("" + M[3], 10) / 100, N = "rgb(" + xf(O, k, z) + ")", U = n7.exec(N);
    if (!U)
      throw new L0(4, n, N);
    return {
      red: parseInt("" + U[1], 10),
      green: parseInt("" + U[2], 10),
      blue: parseInt("" + U[3], 10),
      alpha: parseFloat("" + M[4]) > 1 ? parseFloat("" + M[4]) / 100 : parseFloat("" + M[4])
    };
  }
  throw new L0(5);
}
function $B(e) {
  var n = e.red / 255, i = e.green / 255, a = e.blue / 255, s = Math.max(n, i, a), g = Math.min(n, i, a), c = (s + g) / 2;
  if (s === g)
    return e.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: c,
      alpha: e.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: c
    };
  var I, h = s - g, m = c > 0.5 ? h / (2 - s - g) : h / (s + g);
  switch (s) {
    case n:
      I = (i - a) / h + (i < a ? 6 : 0);
      break;
    case i:
      I = (a - n) / h + 2;
      break;
    default:
      I = (n - i) / h + 4;
      break;
  }
  return I *= 60, e.alpha !== void 0 ? {
    hue: I,
    saturation: m,
    lightness: c,
    alpha: e.alpha
  } : {
    hue: I,
    saturation: m,
    lightness: c
  };
}
function es(e) {
  return $B(Dc(e));
}
var eH = function(n) {
  return n.length === 7 && n[1] === n[2] && n[3] === n[4] && n[5] === n[6] ? "#" + n[1] + n[3] + n[5] : n;
}, nh = eH;
function al(e) {
  var n = e.toString(16);
  return n.length === 1 ? "0" + n : n;
}
function r7(e) {
  return al(Math.round(e * 255));
}
function tH(e, n, i) {
  return nh("#" + r7(e) + r7(n) + r7(i));
}
function wA(e, n, i) {
  return xf(e, n, i, tH);
}
function nH(e, n, i) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number")
    return wA(e, n, i);
  if (typeof e == "object" && n === void 0 && i === void 0)
    return wA(e.hue, e.saturation, e.lightness);
  throw new L0(1);
}
function rH(e, n, i, a) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number" && typeof a == "number")
    return a >= 1 ? wA(e, n, i) : "rgba(" + xf(e, n, i) + "," + a + ")";
  if (typeof e == "object" && n === void 0 && i === void 0 && a === void 0)
    return e.alpha >= 1 ? wA(e.hue, e.saturation, e.lightness) : "rgba(" + xf(e.hue, e.saturation, e.lightness) + "," + e.alpha + ")";
  throw new L0(2);
}
function rh(e, n, i) {
  if (typeof e == "number" && typeof n == "number" && typeof i == "number")
    return nh("#" + al(e) + al(n) + al(i));
  if (typeof e == "object" && n === void 0 && i === void 0)
    return nh("#" + al(e.red) + al(e.green) + al(e.blue));
  throw new L0(6);
}
function i6(e, n, i, a) {
  if (typeof e == "string" && typeof n == "number") {
    var s = Dc(e);
    return "rgba(" + s.red + "," + s.green + "," + s.blue + "," + n + ")";
  } else {
    if (typeof e == "number" && typeof n == "number" && typeof i == "number" && typeof a == "number")
      return a >= 1 ? rh(e, n, i) : "rgba(" + e + "," + n + "," + i + "," + a + ")";
    if (typeof e == "object" && n === void 0 && i === void 0 && a === void 0)
      return e.alpha >= 1 ? rh(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  }
  throw new L0(7);
}
var iH = function(n) {
  return typeof n.red == "number" && typeof n.green == "number" && typeof n.blue == "number" && (typeof n.alpha != "number" || typeof n.alpha > "u");
}, aH = function(n) {
  return typeof n.red == "number" && typeof n.green == "number" && typeof n.blue == "number" && typeof n.alpha == "number";
}, oH = function(n) {
  return typeof n.hue == "number" && typeof n.saturation == "number" && typeof n.lightness == "number" && (typeof n.alpha != "number" || typeof n.alpha > "u");
}, sH = function(n) {
  return typeof n.hue == "number" && typeof n.saturation == "number" && typeof n.lightness == "number" && typeof n.alpha == "number";
};
function ts(e) {
  if (typeof e != "object") throw new L0(8);
  if (aH(e)) return i6(e);
  if (iH(e)) return rh(e);
  if (sH(e)) return rH(e);
  if (oH(e)) return nH(e);
  throw new L0(8);
}
function DE(e, n, i) {
  return function() {
    var s = i.concat(Array.prototype.slice.call(arguments));
    return s.length >= n ? e.apply(this, s) : DE(e, n, s);
  };
}
function j3(e) {
  return DE(e, e.length, []);
}
function lH(e, n) {
  if (n === "transparent") return n;
  var i = es(n);
  return ts(k1({}, i, {
    hue: i.hue + parseFloat(e)
  }));
}
j3(lH);
function Uc(e, n, i) {
  return Math.max(e, Math.min(n, i));
}
function uH(e, n) {
  if (n === "transparent") return n;
  var i = es(n);
  return ts(k1({}, i, {
    lightness: Uc(0, 1, i.lightness - parseFloat(e))
  }));
}
var cH = j3(uH), b0 = cH;
function gH(e, n) {
  if (n === "transparent") return n;
  var i = es(n);
  return ts(k1({}, i, {
    saturation: Uc(0, 1, i.saturation - parseFloat(e))
  }));
}
j3(gH);
function fH(e, n) {
  if (n === "transparent") return n;
  var i = es(n);
  return ts(k1({}, i, {
    lightness: Uc(0, 1, i.lightness + parseFloat(e))
  }));
}
j3(fH);
function dH(e, n, i) {
  if (n === "transparent") return i;
  if (i === "transparent") return n;
  if (e === 0) return i;
  var a = Dc(n), s = k1({}, a, {
    alpha: typeof a.alpha == "number" ? a.alpha : 1
  }), g = Dc(i), c = k1({}, g, {
    alpha: typeof g.alpha == "number" ? g.alpha : 1
  }), I = s.alpha - c.alpha, h = parseFloat(e) * 2 - 1, m = h * I === -1 ? h : h + I, w = 1 + h * I, x = (m / w + 1) / 2, M = 1 - x, O = {
    red: Math.floor(s.red * x + c.red * M),
    green: Math.floor(s.green * x + c.green * M),
    blue: Math.floor(s.blue * x + c.blue * M),
    alpha: s.alpha * parseFloat(e) + c.alpha * (1 - parseFloat(e))
  };
  return i6(O);
}
var CH = j3(dH), kE = CH;
function AH(e, n) {
  if (n === "transparent") return n;
  var i = Dc(n), a = typeof i.alpha == "number" ? i.alpha : 1, s = k1({}, i, {
    alpha: Uc(0, 1, (a * 100 + parseFloat(e) * 100) / 100)
  });
  return i6(s);
}
j3(AH);
function IH(e, n) {
  if (n === "transparent") return n;
  var i = es(n);
  return ts(k1({}, i, {
    saturation: Uc(0, 1, i.saturation + parseFloat(e))
  }));
}
j3(IH);
function pH(e, n) {
  return n === "transparent" ? n : ts(k1({}, es(n), {
    hue: parseFloat(e)
  }));
}
j3(pH);
function hH(e, n) {
  return n === "transparent" ? n : ts(k1({}, es(n), {
    lightness: parseFloat(e)
  }));
}
j3(hH);
function mH(e, n) {
  return n === "transparent" ? n : ts(k1({}, es(n), {
    saturation: parseFloat(e)
  }));
}
j3(mH);
function vH(e, n) {
  return n === "transparent" ? n : kE(parseFloat(e), "rgb(0, 0, 0)", n);
}
j3(vH);
function yH(e, n) {
  return n === "transparent" ? n : kE(parseFloat(e), "rgb(255, 255, 255)", n);
}
j3(yH);
function bH(e, n) {
  if (n === "transparent") return n;
  var i = Dc(n), a = typeof i.alpha == "number" ? i.alpha : 1, s = k1({}, i, {
    alpha: Uc(0, 1, +(a * 100 - parseFloat(e) * 100).toFixed(2) / 100)
  });
  return i6(s);
}
j3(bH);
const w0 = {
  50: -0.55,
  100: -0.45,
  200: -0.35,
  300: -0.25,
  400: 0.05,
  500: 0,
  600: 0.05,
  700: 0.15,
  800: 0.25,
  900: 0.35
}, UC = (e) => ({
  50: b0(w0[50], e),
  100: b0(w0[100], e),
  200: b0(w0[200], e),
  300: b0(w0[300], e),
  400: b0(w0[400], e),
  500: b0(w0[500], e),
  600: b0(w0[600], e),
  700: b0(w0[700], e),
  800: b0(w0[800], e),
  900: b0(w0[900], e),
  // NOTE: These accent shades are supposedly not being used. It may
  // behoove us to eventually add them in, though for completeness
  A100: "",
  A200: "",
  A400: "",
  A700: ""
}), wH = (e) => {
  const n = UC(e.color_palette.primary), i = UC(e.color_palette.secondary), a = UC(e.color_palette.tertiary), s = UC(e.color_palette.accent);
  return {
    mode: "light",
    primary: {
      main: n[500],
      dark: n[700],
      light: n[300],
      contrastText: e.color_palette.primary_contrast
    },
    secondary: {
      main: i[500],
      dark: i[700],
      light: i[300],
      contrastText: e.color_palette.secondary_contrast
    },
    error: {
      main: yc[500],
      dark: yc[700],
      light: yc[300],
      contrastText: Ui[50]
    },
    // NOTE: For warning we fall back to MUI default settings which is an orange variant rather than yellow which is not a11y
    success: {
      main: HC[500],
      dark: HC[700],
      light: HC[300],
      contrastText: Ui[50]
    },
    text: {
      primary: Ui[800],
      secondary: Ui[500],
      disabled: Ui[400]
    },
    common: {
      /**
       * Configurable Theme colors
       */
      primary: n,
      primaryContrast: e.color_palette.primary_contrast,
      secondary: i,
      secondaryContrast: e.color_palette.secondary_contrast,
      tertiary: a,
      tertiaryContrast: e.color_palette.tertiary_contrast,
      accent: s,
      /**
       * Non-configurable theme colors
       */
      black: Ui[800],
      white: Ui[50],
      error: yc,
      success: HC,
      /**
       * @deprecated We need a more a11y warning color. Use mui orange defaults for now
       */
      warning: BB,
      neutrals: Ui,
      /**
       * @deprecated Theme colors. DO NOT USE THESE!
       */
      cyan: n,
      blueGray: Ui,
      red: {},
      sky: "",
      gray: {},
      figmaBlueGray: {},
      /** Refactor-aligned dark text color */
      darkText: "#212b36"
    },
    background: {
      default: Ui[50],
      paper: Ui[50]
    }
  };
}, xH = (e) => {
  var n, i, a, s, g;
  return {
    primary: ((n = e.common) == null ? void 0 : n.primary[500]) || "",
    tertiary: ((i = e.common) == null ? void 0 : i.tertiary[500]) || "",
    onTertiary: ((a = e.common) == null ? void 0 : a.neutrals[50]) || "",
    onBackground: ((s = e.common) == null ? void 0 : s.neutrals[800]) || "",
    onErrorContainer: yc[600],
    errorContainer: yc[100],
    secondaryContainer: "#E5F5FF",
    onSecondaryContainer: ((g = e.common) == null ? void 0 : g.neutrals[800]) || "",
    // Deprecated
    dark: "#232438",
    medium: "#434566"
  };
}, SH = "data:image/webp;base64,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", EH = "data:image/webp;base64,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", ni = {
  color_palette: {
    primary: OB,
    primary_contrast: zB,
    secondary: DB,
    secondary_contrast: NB,
    tertiary: kB,
    tertiary_contrast: PB,
    accent: jB
  },
  assets: {
    logo: Lb,
    logo_expanded: Lb,
    logo_splash: Fz,
    login_hero: SH,
    login_hero_mobile: EH
  }
}, MH = (e) => {
  var n, i, a, s, g, c, I, h, m, w, x, M;
  return {
    color_palette: {
      primary: ((n = e == null ? void 0 : e.color_palette) == null ? void 0 : n.primary) || ni.color_palette.primary,
      primary_contrast: ((i = e == null ? void 0 : e.color_palette) == null ? void 0 : i.primary_contrast) || ni.color_palette.primary_contrast,
      secondary: ((a = e == null ? void 0 : e.color_palette) == null ? void 0 : a.secondary) || ni.color_palette.secondary,
      secondary_contrast: ((s = e == null ? void 0 : e.color_palette) == null ? void 0 : s.secondary_contrast) || ni.color_palette.secondary_contrast,
      tertiary: ((g = e == null ? void 0 : e.color_palette) == null ? void 0 : g.tertiary) || ni.color_palette.tertiary,
      tertiary_contrast: ((c = e == null ? void 0 : e.color_palette) == null ? void 0 : c.tertiary_contrast) || ni.color_palette.tertiary_contrast,
      accent: ((I = e == null ? void 0 : e.color_palette) == null ? void 0 : I.accent) || ni.color_palette.accent
    },
    assets: {
      logo: ((h = e == null ? void 0 : e.assets) == null ? void 0 : h.logo) || ni.assets.logo,
      logo_expanded: ((m = e == null ? void 0 : e.assets) == null ? void 0 : m.logo_expanded) || ni.assets.logo_expanded,
      logo_splash: ((w = e == null ? void 0 : e.assets) == null ? void 0 : w.logo_splash) || ni.assets.logo_splash,
      login_hero: ((x = e == null ? void 0 : e.assets) == null ? void 0 : x.login_hero) || ni.assets.login_hero,
      login_hero_mobile: ((M = e == null ? void 0 : e.assets) == null ? void 0 : M.login_hero_mobile) || ni.assets.login_hero_mobile
    }
  };
}, jE = (e) => ({
  typography: {
    h1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      color: e.palette.common.neutrals[800],
      fontWeight: 600,
      lineHeight: "110%",
      fontSize: "2rem",
      [e.breakpoints.up("md")]: {
        fontSize: "2.5rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: "2.25rem"
      },
      padding: "14px 24px"
    },
    h2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.75rem",
      fontWeight: 500,
      lineHeight: "130%",
      [e.breakpoints.up("md")]: {
        fontSize: "2rem"
      }
    },
    h3: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.5rem",
      fontWeight: 400,
      lineHeight: "130%",
      [e.breakpoints.up("md")]: {
        fontSize: "1.75rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: "1.625rem"
      }
    },
    h4: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Bold', Sans-serif",
    },
    h5: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.25rem",
      fontWeight: 600,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Bold', Sans-serif",
    },
    h6: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: ".938rem",
      fontWeight: 600,
      lineHeight: "110%"
      // fontFamily: "'Source Sans Pro Semi Bold', Sans-serif",
    },
    subtitle1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.188rem",
      fontWeight: 500,
      lineHeight: "150%"
    },
    subtitle2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Semi Bold', Sans-serif",
    },
    body1: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: ".938rem",
      fontWeight: 400,
      lineHeight: "150%",
      [e.breakpoints.up("md")]: {
        fontSize: ".938rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: ".938rem"
      }
    },
    body2: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: ".875rem",
      fontWeight: 700,
      lineHeight: "150%",
      [e.breakpoints.up("md")]: {
        fontSize: ".875rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: ".875rem"
      }
    },
    label: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "160%",
      [e.breakpoints.up("md")]: {
        fontSize: "1.125rem"
      },
      [e.breakpoints.up("lg")]: {
        fontSize: "1.313rem",
        lineHeight: "120%"
      }
    },
    caption: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "0.8rem",
      fontWeight: 500,
      lineHeight: "150%"
    },
    overline: {
      fontFamily: "'Source Sans Pro', Sans-serif",
      fontSize: "1.125rem",
      fontWeight: 500,
      lineHeight: "150%"
      // fontFamily: "'Source Sans Pro Semi Bold', Sans-serif",
    }
  }
}), TH = (e) => ({
  zIndex: {
    ...e.zIndex,
    slidingViews: 1e3
  }
}), ke1 = (e) => {
  const n = MH(e), i = wH(n), a = LB(n), s = $7({
    spacing: 8,
    shape: { borderRadius: 2 },
    palette: i,
    assets: a,
    /**
     * @deprecated Please use colors directly from palette.common instead
     */
    brandColors: xH(i)
  });
  return [jE, FB, TH].concat(
    (e == null ? void 0 : e.extensions) ?? []
  ).reduce(
    (I, h) => $7(I, h(I)),
    s
  );
}, a6 = ({
  to: e,
  selected: n,
  href: i,
  target: a,
  state: s = {}
}) => {
  const g = Mz((e == null ? void 0 : e.toString()) || ""), c = n ?? (e ? !!g : void 0), I = V2(() => {
    if (e) return Yh;
    if (i) return "a";
  }, [e, i]);
  return {
    to: e,
    selected: c,
    component: I,
    href: i,
    target: a,
    ...e ? { state: s } : {}
  };
};
function j2({
  to: e,
  state: n,
  href: i,
  target: a,
  children: s,
  ...g
}) {
  const c = a6({ to: e, state: n, href: i, target: a });
  return /* @__PURE__ */ v.jsx(v2, { ...c, ...g, children: s });
}
j2.displayName = "Button";
const je1 = ({ fallback: e, ...n }) => {
  var s;
  const a = ((s = RS().state) == null ? void 0 : s.goBackUrl) || e;
  return /* @__PURE__ */ v.jsx(j2, { ...n, to: a });
}, ze1 = ({ children: e }) => /* @__PURE__ */ v.jsx(Pj, { color: "primary", overlap: "circular", variant: "dot", children: e });
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function LH(e, n, i) {
  return (n = OH(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function dw(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, a);
  }
  return i;
}
function Z1(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? dw(Object(i), !0).forEach(function(a) {
      LH(e, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : dw(Object(i)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }
  return e;
}
function RH(e, n) {
  if (typeof e != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var a = i.call(e, n || "default");
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function OH(e) {
  var n = RH(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
const Cw = () => {
};
let um = {}, zE = {}, NE = null, PE = {
  mark: Cw,
  measure: Cw
};
try {
  typeof window < "u" && (um = window), typeof document < "u" && (zE = document), typeof MutationObserver < "u" && (NE = MutationObserver), typeof performance < "u" && (PE = performance);
} catch {
}
const {
  userAgent: Aw = ""
} = um.navigator || {}, Yo = um, Sn = zE, Iw = NE, WC = PE;
Yo.document;
const za = !!Sn.documentElement && !!Sn.head && typeof Sn.addEventListener == "function" && typeof Sn.createElement == "function", FE = ~Aw.indexOf("MSIE") || ~Aw.indexOf("Trident/");
var DH = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, kH = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, BE = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, jH = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, HE = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], kr = "classic", o6 = "duotone", zH = "sharp", NH = "sharp-duotone", UE = [kr, o6, zH, NH], PH = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, FH = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, BH = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), HH = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, UH = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], pw = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, WH = ["kit"], _H = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
}, VH = ["fak", "fakd"], KH = {
  kit: {
    fak: "fa-kit"
  },
  "kit-duotone": {
    fakd: "fa-kit-duotone"
  }
}, hw = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, _C = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, JH = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], YH = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], QH = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, XH = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, GH = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, ih = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, qH = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], ah = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...JH, ...qH], ZH = ["solid", "regular", "light", "thin", "duotone", "brands"], WE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], $H = WE.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), eU = [...Object.keys(GH), ...ZH, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", _C.GROUP, _C.SWAP_OPACITY, _C.PRIMARY, _C.SECONDARY].concat(WE.map((e) => "".concat(e, "x"))).concat($H.map((e) => "w-".concat(e))), tU = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Oa = "___FONT_AWESOME___", oh = 16, _E = "fa", VE = "svg-inline--fa", Al = "data-fa-i2svg", sh = "data-fa-pseudo-element", nU = "data-fa-pseudo-element-pending", cm = "data-prefix", gm = "data-icon", mw = "fontawesome-i2svg", rU = "async", iU = ["HTML", "HEAD", "STYLE", "SCRIPT"], KE = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Pf(e) {
  return new Proxy(e, {
    get(n, i) {
      return i in n ? n[i] : n[kr];
    }
  });
}
const JE = Z1({}, BE);
JE[kr] = Z1(Z1(Z1(Z1({}, {
  "fa-duotone": "duotone"
}), BE[kr]), pw.kit), pw["kit-duotone"]);
const aU = Pf(JE), lh = Z1({}, HH);
lh[kr] = Z1(Z1(Z1(Z1({}, {
  duotone: "fad"
}), lh[kr]), hw.kit), hw["kit-duotone"]);
const vw = Pf(lh), uh = Z1({}, ih);
uh[kr] = Z1(Z1({}, uh[kr]), KH.kit);
const fm = Pf(uh), ch = Z1({}, XH);
ch[kr] = Z1(Z1({}, ch[kr]), _H.kit);
Pf(ch);
const oU = DH, YE = "fa-layers-text", sU = kH, lU = Z1({}, PH);
Pf(lU);
const uU = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], i7 = jH, cU = [...WH, ...eU], gf = Yo.FontAwesomeConfig || {};
function gU(e) {
  var n = Sn.querySelector("script[" + e + "]");
  if (n)
    return n.getAttribute(e);
}
function fU(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Sn && typeof Sn.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((n) => {
  let [i, a] = n;
  const s = fU(gU(i));
  s != null && (gf[a] = s);
});
const QE = {
  styleDefault: "solid",
  familyDefault: kr,
  cssPrefix: _E,
  replacementClass: VE,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
gf.familyPrefix && (gf.cssPrefix = gf.familyPrefix);
const kc = Z1(Z1({}, QE), gf);
kc.autoReplaceSvg || (kc.observeMutations = !1);
const Be = {};
Object.keys(QE).forEach((e) => {
  Object.defineProperty(Be, e, {
    enumerable: !0,
    set: function(n) {
      kc[e] = n, ff.forEach((i) => i(Be));
    },
    get: function() {
      return kc[e];
    }
  });
});
Object.defineProperty(Be, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    kc.cssPrefix = e, ff.forEach((n) => n(Be));
  },
  get: function() {
    return kc.cssPrefix;
  }
});
Yo.FontAwesomeConfig = Be;
const ff = [];
function dU(e) {
  return ff.push(e), () => {
    ff.splice(ff.indexOf(e), 1);
  };
}
const Wo = oh, R0 = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function CU(e) {
  if (!e || !za)
    return;
  const n = Sn.createElement("style");
  n.setAttribute("type", "text/css"), n.innerHTML = e;
  const i = Sn.head.childNodes;
  let a = null;
  for (let s = i.length - 1; s > -1; s--) {
    const g = i[s], c = (g.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(c) > -1 && (a = g);
  }
  return Sn.head.insertBefore(n, a), e;
}
const AU = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Sf() {
  let e = 12, n = "";
  for (; e-- > 0; )
    n += AU[Math.random() * 62 | 0];
  return n;
}
function Wc(e) {
  const n = [];
  for (let i = (e || []).length >>> 0; i--; )
    n[i] = e[i];
  return n;
}
function dm(e) {
  return e.classList ? Wc(e.classList) : (e.getAttribute("class") || "").split(" ").filter((n) => n);
}
function XE(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function IU(e) {
  return Object.keys(e || {}).reduce((n, i) => n + "".concat(i, '="').concat(XE(e[i]), '" '), "").trim();
}
function s6(e) {
  return Object.keys(e || {}).reduce((n, i) => n + "".concat(i, ": ").concat(e[i].trim(), ";"), "");
}
function Cm(e) {
  return e.size !== R0.size || e.x !== R0.x || e.y !== R0.y || e.rotate !== R0.rotate || e.flipX || e.flipY;
}
function pU(e) {
  let {
    transform: n,
    containerWidth: i,
    iconWidth: a
  } = e;
  const s = {
    transform: "translate(".concat(i / 2, " 256)")
  }, g = "translate(".concat(n.x * 32, ", ").concat(n.y * 32, ") "), c = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "), I = "rotate(".concat(n.rotate, " 0 0)"), h = {
    transform: "".concat(g, " ").concat(c, " ").concat(I)
  }, m = {
    transform: "translate(".concat(a / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: h,
    path: m
  };
}
function hU(e) {
  let {
    transform: n,
    width: i = oh,
    height: a = oh,
    startCentered: s = !1
  } = e, g = "";
  return s && FE ? g += "translate(".concat(n.x / Wo - i / 2, "em, ").concat(n.y / Wo - a / 2, "em) ") : s ? g += "translate(calc(-50% + ".concat(n.x / Wo, "em), calc(-50% + ").concat(n.y / Wo, "em)) ") : g += "translate(".concat(n.x / Wo, "em, ").concat(n.y / Wo, "em) "), g += "scale(".concat(n.size / Wo * (n.flipX ? -1 : 1), ", ").concat(n.size / Wo * (n.flipY ? -1 : 1), ") "), g += "rotate(".concat(n.rotate, "deg) "), g;
}
var mU = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function GE() {
  const e = _E, n = VE, i = Be.cssPrefix, a = Be.replacementClass;
  let s = mU;
  if (i !== e || a !== n) {
    const g = new RegExp("\\.".concat(e, "\\-"), "g"), c = new RegExp("\\--".concat(e, "\\-"), "g"), I = new RegExp("\\.".concat(n), "g");
    s = s.replace(g, ".".concat(i, "-")).replace(c, "--".concat(i, "-")).replace(I, ".".concat(a));
  }
  return s;
}
let yw = !1;
function a7() {
  Be.autoAddCss && !yw && (CU(GE()), yw = !0);
}
var vU = {
  mixout() {
    return {
      dom: {
        css: GE,
        insertCss: a7
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        a7();
      },
      beforeI2svg() {
        a7();
      }
    };
  }
};
const Da = Yo || {};
Da[Oa] || (Da[Oa] = {});
Da[Oa].styles || (Da[Oa].styles = {});
Da[Oa].hooks || (Da[Oa].hooks = {});
Da[Oa].shims || (Da[Oa].shims = []);
var O0 = Da[Oa];
const qE = [], ZE = function() {
  Sn.removeEventListener("DOMContentLoaded", ZE), xA = 1, qE.map((e) => e());
};
let xA = !1;
za && (xA = (Sn.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Sn.readyState), xA || Sn.addEventListener("DOMContentLoaded", ZE));
function yU(e) {
  za && (xA ? setTimeout(e, 0) : qE.push(e));
}
function Ff(e) {
  const {
    tag: n,
    attributes: i = {},
    children: a = []
  } = e;
  return typeof e == "string" ? XE(e) : "<".concat(n, " ").concat(IU(i), ">").concat(a.map(Ff).join(""), "</").concat(n, ">");
}
function bw(e, n, i) {
  if (e && e[n] && e[n][i])
    return {
      prefix: n,
      iconName: i,
      icon: e[n][i]
    };
}
var o7 = function(n, i, a, s) {
  var g = Object.keys(n), c = g.length, I = i, h, m, w;
  for (a === void 0 ? (h = 1, w = n[g[0]]) : (h = 0, w = a); h < c; h++)
    m = g[h], w = I(w, n[m], m, n);
  return w;
};
function bU(e) {
  const n = [];
  let i = 0;
  const a = e.length;
  for (; i < a; ) {
    const s = e.charCodeAt(i++);
    if (s >= 55296 && s <= 56319 && i < a) {
      const g = e.charCodeAt(i++);
      (g & 64512) == 56320 ? n.push(((s & 1023) << 10) + (g & 1023) + 65536) : (n.push(s), i--);
    } else
      n.push(s);
  }
  return n;
}
function gh(e) {
  const n = bU(e);
  return n.length === 1 ? n[0].toString(16) : null;
}
function wU(e, n) {
  const i = e.length;
  let a = e.charCodeAt(n), s;
  return a >= 55296 && a <= 56319 && i > n + 1 && (s = e.charCodeAt(n + 1), s >= 56320 && s <= 57343) ? (a - 55296) * 1024 + s - 56320 + 65536 : a;
}
function ww(e) {
  return Object.keys(e).reduce((n, i) => {
    const a = e[i];
    return !!a.icon ? n[a.iconName] = a.icon : n[i] = a, n;
  }, {});
}
function fh(e, n) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: a = !1
  } = i, s = ww(n);
  typeof O0.hooks.addPack == "function" && !a ? O0.hooks.addPack(e, ww(n)) : O0.styles[e] = Z1(Z1({}, O0.styles[e] || {}), s), e === "fas" && fh("fa", n);
}
const {
  styles: Ef,
  shims: xU
} = O0, $E = Object.keys(fm), SU = $E.reduce((e, n) => (e[n] = Object.keys(fm[n]), e), {});
let Am = null, eM = {}, tM = {}, nM = {}, rM = {}, iM = {};
function EU(e) {
  return ~cU.indexOf(e);
}
function MU(e, n) {
  const i = n.split("-"), a = i[0], s = i.slice(1).join("-");
  return a === e && s !== "" && !EU(s) ? s : null;
}
const aM = () => {
  const e = (a) => o7(Ef, (s, g, c) => (s[c] = o7(g, a, {}), s), {});
  eM = e((a, s, g) => (s[3] && (a[s[3]] = g), s[2] && s[2].filter((I) => typeof I == "number").forEach((I) => {
    a[I.toString(16)] = g;
  }), a)), tM = e((a, s, g) => (a[g] = g, s[2] && s[2].filter((I) => typeof I == "string").forEach((I) => {
    a[I] = g;
  }), a)), iM = e((a, s, g) => {
    const c = s[2];
    return a[g] = g, c.forEach((I) => {
      a[I] = g;
    }), a;
  });
  const n = "far" in Ef || Be.autoFetchSvg, i = o7(xU, (a, s) => {
    const g = s[0];
    let c = s[1];
    const I = s[2];
    return c === "far" && !n && (c = "fas"), typeof g == "string" && (a.names[g] = {
      prefix: c,
      iconName: I
    }), typeof g == "number" && (a.unicodes[g.toString(16)] = {
      prefix: c,
      iconName: I
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  nM = i.names, rM = i.unicodes, Am = l6(Be.styleDefault, {
    family: Be.familyDefault
  });
};
dU((e) => {
  Am = l6(e.styleDefault, {
    family: Be.familyDefault
  });
});
aM();
function Im(e, n) {
  return (eM[e] || {})[n];
}
function TU(e, n) {
  return (tM[e] || {})[n];
}
function cl(e, n) {
  return (iM[e] || {})[n];
}
function oM(e) {
  return nM[e] || {
    prefix: null,
    iconName: null
  };
}
function LU(e) {
  const n = rM[e], i = Im("fas", e);
  return n || (i ? {
    prefix: "fas",
    iconName: i
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Qo() {
  return Am;
}
const sM = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function RU(e) {
  let n = kr;
  const i = $E.reduce((a, s) => (a[s] = "".concat(Be.cssPrefix, "-").concat(s), a), {});
  return UE.forEach((a) => {
    (e.includes(i[a]) || e.some((s) => SU[a].includes(s))) && (n = a);
  }), n;
}
function l6(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: i = kr
  } = n, a = aU[i][e];
  if (i === o6 && !e)
    return "fad";
  const s = vw[i][e] || vw[i][a], g = e in O0.styles ? e : null;
  return s || g || null;
}
function OU(e) {
  let n = [], i = null;
  return e.forEach((a) => {
    const s = MU(Be.cssPrefix, a);
    s ? i = s : a && n.push(a);
  }), {
    iconName: i,
    rest: n
  };
}
function xw(e) {
  return e.sort().filter((n, i, a) => a.indexOf(n) === i);
}
function u6(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: i = !1
  } = n;
  let a = null;
  const s = ah.concat(YH), g = xw(e.filter((x) => s.includes(x))), c = xw(e.filter((x) => !ah.includes(x))), I = g.filter((x) => (a = x, !HE.includes(x))), [h = null] = I, m = RU(g), w = Z1(Z1({}, OU(c)), {}, {
    prefix: l6(h, {
      family: m
    })
  });
  return Z1(Z1(Z1({}, w), zU({
    values: e,
    family: m,
    styles: Ef,
    config: Be,
    canonical: w,
    givenPrefix: a
  })), DU(i, a, w));
}
function DU(e, n, i) {
  let {
    prefix: a,
    iconName: s
  } = i;
  if (e || !a || !s)
    return {
      prefix: a,
      iconName: s
    };
  const g = n === "fa" ? oM(s) : {}, c = cl(a, s);
  return s = g.iconName || c || s, a = g.prefix || a, a === "far" && !Ef.far && Ef.fas && !Be.autoFetchSvg && (a = "fas"), {
    prefix: a,
    iconName: s
  };
}
const kU = UE.filter((e) => e !== kr || e !== o6), jU = Object.keys(ih).filter((e) => e !== kr).map((e) => Object.keys(ih[e])).flat();
function zU(e) {
  const {
    values: n,
    family: i,
    canonical: a,
    givenPrefix: s = "",
    styles: g = {},
    config: c = {}
  } = e, I = i === o6, h = n.includes("fa-duotone") || n.includes("fad"), m = c.familyDefault === "duotone", w = a.prefix === "fad" || a.prefix === "fa-duotone";
  if (!I && (h || m || w) && (a.prefix = "fad"), (n.includes("fa-brands") || n.includes("fab")) && (a.prefix = "fab"), !a.prefix && kU.includes(i) && (Object.keys(g).find((M) => jU.includes(M)) || c.autoFetchSvg)) {
    const M = BH.get(i).defaultShortPrefixId;
    a.prefix = M, a.iconName = cl(a.prefix, a.iconName) || a.iconName;
  }
  return (a.prefix === "fa" || s === "fa") && (a.prefix = Qo() || "fas"), a;
}
class NU {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    const s = i.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((g) => {
      this.definitions[g] = Z1(Z1({}, this.definitions[g] || {}), s[g]), fh(g, s[g]);
      const c = fm[kr][g];
      c && fh(c, s[g]), aM();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(n, i) {
    const a = i.prefix && i.iconName && i.icon ? {
      0: i
    } : i;
    return Object.keys(a).map((s) => {
      const {
        prefix: g,
        iconName: c,
        icon: I
      } = a[s], h = I[2];
      n[g] || (n[g] = {}), h.length > 0 && h.forEach((m) => {
        typeof m == "string" && (n[g][m] = I);
      }), n[g][c] = I;
    }), n;
  }
}
let Sw = [], bc = {};
const Mc = {}, PU = Object.keys(Mc);
function FU(e, n) {
  let {
    mixoutsTo: i
  } = n;
  return Sw = e, bc = {}, Object.keys(Mc).forEach((a) => {
    PU.indexOf(a) === -1 && delete Mc[a];
  }), Sw.forEach((a) => {
    const s = a.mixout ? a.mixout() : {};
    if (Object.keys(s).forEach((g) => {
      typeof s[g] == "function" && (i[g] = s[g]), typeof s[g] == "object" && Object.keys(s[g]).forEach((c) => {
        i[g] || (i[g] = {}), i[g][c] = s[g][c];
      });
    }), a.hooks) {
      const g = a.hooks();
      Object.keys(g).forEach((c) => {
        bc[c] || (bc[c] = []), bc[c].push(g[c]);
      });
    }
    a.provides && a.provides(Mc);
  }), i;
}
function dh(e, n) {
  for (var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++)
    a[s - 2] = arguments[s];
  return (bc[e] || []).forEach((c) => {
    n = c.apply(null, [n, ...a]);
  }), n;
}
function Il(e) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    i[a - 1] = arguments[a];
  (bc[e] || []).forEach((g) => {
    g.apply(null, i);
  });
}
function Xo() {
  const e = arguments[0], n = Array.prototype.slice.call(arguments, 1);
  return Mc[e] ? Mc[e].apply(null, n) : void 0;
}
function Ch(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: n
  } = e;
  const i = e.prefix || Qo();
  if (n)
    return n = cl(i, n) || n, bw(lM.definitions, i, n) || bw(O0.styles, i, n);
}
const lM = new NU(), BU = () => {
  Be.autoReplaceSvg = !1, Be.observeMutations = !1, Il("noAuto");
}, HU = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return za ? (Il("beforeI2svg", e), Xo("pseudoElements2svg", e), Xo("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: n
    } = e;
    Be.autoReplaceSvg === !1 && (Be.autoReplaceSvg = !0), Be.observeMutations = !0, yU(() => {
      WU({
        autoReplaceSvgRoot: n
      }), Il("watch", e);
    });
  }
}, UU = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: cl(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const n = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], i = l6(e[0]);
      return {
        prefix: i,
        iconName: cl(i, n) || n
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Be.cssPrefix, "-")) > -1 || e.match(oU))) {
      const n = u6(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: n.prefix || Qo(),
        iconName: cl(n.prefix, n.iconName) || n.iconName
      };
    }
    if (typeof e == "string") {
      const n = Qo();
      return {
        prefix: n,
        iconName: cl(n, e) || e
      };
    }
  }
}, z3 = {
  noAuto: BU,
  config: Be,
  dom: HU,
  parse: UU,
  library: lM,
  findIconDefinition: Ch,
  toHtml: Ff
}, WU = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: n = Sn
  } = e;
  (Object.keys(O0.styles).length > 0 || Be.autoFetchSvg) && za && Be.autoReplaceSvg && z3.dom.i2svg({
    node: n
  });
};
function c6(e, n) {
  return Object.defineProperty(e, "abstract", {
    get: n
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((i) => Ff(i));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!za) return;
      const i = Sn.createElement("div");
      return i.innerHTML = e.html, i.children;
    }
  }), e;
}
function _U(e) {
  let {
    children: n,
    main: i,
    mask: a,
    attributes: s,
    styles: g,
    transform: c
  } = e;
  if (Cm(c) && i.found && !a.found) {
    const {
      width: I,
      height: h
    } = i, m = {
      x: I / h / 2,
      y: 0.5
    };
    s.style = s6(Z1(Z1({}, g), {}, {
      "transform-origin": "".concat(m.x + c.x / 16, "em ").concat(m.y + c.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: n
  }];
}
function VU(e) {
  let {
    prefix: n,
    iconName: i,
    children: a,
    attributes: s,
    symbol: g
  } = e;
  const c = g === !0 ? "".concat(n, "-").concat(Be.cssPrefix, "-").concat(i) : g;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: Z1(Z1({}, s), {}, {
        id: c
      }),
      children: a
    }]
  }];
}
function pm(e) {
  const {
    icons: {
      main: n,
      mask: i
    },
    prefix: a,
    iconName: s,
    transform: g,
    symbol: c,
    title: I,
    maskId: h,
    titleId: m,
    extra: w,
    watchable: x = !1
  } = e, {
    width: M,
    height: O
  } = i.found ? i : n, k = VH.includes(a), z = [Be.replacementClass, s ? "".concat(Be.cssPrefix, "-").concat(s) : ""].filter((B) => w.classes.indexOf(B) === -1).filter((B) => B !== "" || !!B).concat(w.classes).join(" ");
  let N = {
    children: [],
    attributes: Z1(Z1({}, w.attributes), {}, {
      "data-prefix": a,
      "data-icon": s,
      class: z,
      role: w.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(M, " ").concat(O)
    })
  };
  const U = k && !~w.classes.indexOf("fa-fw") ? {
    width: "".concat(M / O * 16 * 0.0625, "em")
  } : {};
  x && (N.attributes[Al] = ""), I && (N.children.push({
    tag: "title",
    attributes: {
      id: N.attributes["aria-labelledby"] || "title-".concat(m || Sf())
    },
    children: [I]
  }), delete N.attributes.title);
  const Q = Z1(Z1({}, N), {}, {
    prefix: a,
    iconName: s,
    main: n,
    mask: i,
    maskId: h,
    transform: g,
    symbol: c,
    styles: Z1(Z1({}, U), w.styles)
  }), {
    children: _,
    attributes: X
  } = i.found && n.found ? Xo("generateAbstractMask", Q) || {
    children: [],
    attributes: {}
  } : Xo("generateAbstractIcon", Q) || {
    children: [],
    attributes: {}
  };
  return Q.children = _, Q.attributes = X, c ? VU(Q) : _U(Q);
}
function Ew(e) {
  const {
    content: n,
    width: i,
    height: a,
    transform: s,
    title: g,
    extra: c,
    watchable: I = !1
  } = e, h = Z1(Z1(Z1({}, c.attributes), g ? {
    title: g
  } : {}), {}, {
    class: c.classes.join(" ")
  });
  I && (h[Al] = "");
  const m = Z1({}, c.styles);
  Cm(s) && (m.transform = hU({
    transform: s,
    startCentered: !0,
    width: i,
    height: a
  }), m["-webkit-transform"] = m.transform);
  const w = s6(m);
  w.length > 0 && (h.style = w);
  const x = [];
  return x.push({
    tag: "span",
    attributes: h,
    children: [n]
  }), g && x.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [g]
  }), x;
}
function KU(e) {
  const {
    content: n,
    title: i,
    extra: a
  } = e, s = Z1(Z1(Z1({}, a.attributes), i ? {
    title: i
  } : {}), {}, {
    class: a.classes.join(" ")
  }), g = s6(a.styles);
  g.length > 0 && (s.style = g);
  const c = [];
  return c.push({
    tag: "span",
    attributes: s,
    children: [n]
  }), i && c.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), c;
}
const {
  styles: s7
} = O0;
function Ah(e) {
  const n = e[0], i = e[1], [a] = e.slice(4);
  let s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(Be.cssPrefix, "-").concat(i7.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Be.cssPrefix, "-").concat(i7.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Be.cssPrefix, "-").concat(i7.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: n,
    height: i,
    icon: s
  };
}
const JU = {
  found: !1,
  width: 512,
  height: 512
};
function YU(e, n) {
  !KE && !Be.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(n, '" is missing.'));
}
function Ih(e, n) {
  let i = n;
  return n === "fa" && Be.styleDefault !== null && (n = Qo()), new Promise((a, s) => {
    if (i === "fa") {
      const g = oM(e) || {};
      e = g.iconName || e, n = g.prefix || n;
    }
    if (e && n && s7[n] && s7[n][e]) {
      const g = s7[n][e];
      return a(Ah(g));
    }
    YU(e, n), a(Z1(Z1({}, JU), {}, {
      icon: Be.showMissingIcons && e ? Xo("missingIconAbstract") || {} : {}
    }));
  });
}
const Mw = () => {
}, ph = Be.measurePerformance && WC && WC.mark && WC.measure ? WC : {
  mark: Mw,
  measure: Mw
}, lf = 'FA "6.7.2"', QU = (e) => (ph.mark("".concat(lf, " ").concat(e, " begins")), () => uM(e)), uM = (e) => {
  ph.mark("".concat(lf, " ").concat(e, " ends")), ph.measure("".concat(lf, " ").concat(e), "".concat(lf, " ").concat(e, " begins"), "".concat(lf, " ").concat(e, " ends"));
};
var hm = {
  begin: QU,
  end: uM
};
const cA = () => {
};
function Tw(e) {
  return typeof (e.getAttribute ? e.getAttribute(Al) : null) == "string";
}
function XU(e) {
  const n = e.getAttribute ? e.getAttribute(cm) : null, i = e.getAttribute ? e.getAttribute(gm) : null;
  return n && i;
}
function GU(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Be.replacementClass);
}
function qU() {
  return Be.autoReplaceSvg === !0 ? gA.replace : gA[Be.autoReplaceSvg] || gA.replace;
}
function ZU(e) {
  return Sn.createElementNS("http://www.w3.org/2000/svg", e);
}
function $U(e) {
  return Sn.createElement(e);
}
function cM(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: i = e.tag === "svg" ? ZU : $U
  } = n;
  if (typeof e == "string")
    return Sn.createTextNode(e);
  const a = i(e.tag);
  return Object.keys(e.attributes || []).forEach(function(g) {
    a.setAttribute(g, e.attributes[g]);
  }), (e.children || []).forEach(function(g) {
    a.appendChild(cM(g, {
      ceFn: i
    }));
  }), a;
}
function eW(e) {
  let n = " ".concat(e.outerHTML, " ");
  return n = "".concat(n, "Font Awesome fontawesome.com "), n;
}
const gA = {
  replace: function(e) {
    const n = e[0];
    if (n.parentNode)
      if (e[1].forEach((i) => {
        n.parentNode.insertBefore(cM(i), n);
      }), n.getAttribute(Al) === null && Be.keepOriginalSource) {
        let i = Sn.createComment(eW(n));
        n.parentNode.replaceChild(i, n);
      } else
        n.remove();
  },
  nest: function(e) {
    const n = e[0], i = e[1];
    if (~dm(n).indexOf(Be.replacementClass))
      return gA.replace(e);
    const a = new RegExp("".concat(Be.cssPrefix, "-.*"));
    if (delete i[0].attributes.id, i[0].attributes.class) {
      const g = i[0].attributes.class.split(" ").reduce((c, I) => (I === Be.replacementClass || I.match(a) ? c.toSvg.push(I) : c.toNode.push(I), c), {
        toNode: [],
        toSvg: []
      });
      i[0].attributes.class = g.toSvg.join(" "), g.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", g.toNode.join(" "));
    }
    const s = i.map((g) => Ff(g)).join(`
`);
    n.setAttribute(Al, ""), n.innerHTML = s;
  }
};
function Lw(e) {
  e();
}
function gM(e, n) {
  const i = typeof n == "function" ? n : cA;
  if (e.length === 0)
    i();
  else {
    let a = Lw;
    Be.mutateApproach === rU && (a = Yo.requestAnimationFrame || Lw), a(() => {
      const s = qU(), g = hm.begin("mutate");
      e.map(s), g(), i();
    });
  }
}
let mm = !1;
function fM() {
  mm = !0;
}
function hh() {
  mm = !1;
}
let SA = null;
function Rw(e) {
  if (!Iw || !Be.observeMutations)
    return;
  const {
    treeCallback: n = cA,
    nodeCallback: i = cA,
    pseudoElementsCallback: a = cA,
    observeMutationsRoot: s = Sn
  } = e;
  SA = new Iw((g) => {
    if (mm) return;
    const c = Qo();
    Wc(g).forEach((I) => {
      if (I.type === "childList" && I.addedNodes.length > 0 && !Tw(I.addedNodes[0]) && (Be.searchPseudoElements && a(I.target), n(I.target)), I.type === "attributes" && I.target.parentNode && Be.searchPseudoElements && a(I.target.parentNode), I.type === "attributes" && Tw(I.target) && ~uU.indexOf(I.attributeName))
        if (I.attributeName === "class" && XU(I.target)) {
          const {
            prefix: h,
            iconName: m
          } = u6(dm(I.target));
          I.target.setAttribute(cm, h || c), m && I.target.setAttribute(gm, m);
        } else GU(I.target) && i(I.target);
    });
  }), za && SA.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function tW() {
  SA && SA.disconnect();
}
function nW(e) {
  const n = e.getAttribute("style");
  let i = [];
  return n && (i = n.split(";").reduce((a, s) => {
    const g = s.split(":"), c = g[0], I = g.slice(1);
    return c && I.length > 0 && (a[c] = I.join(":").trim()), a;
  }, {})), i;
}
function rW(e) {
  const n = e.getAttribute("data-prefix"), i = e.getAttribute("data-icon"), a = e.innerText !== void 0 ? e.innerText.trim() : "";
  let s = u6(dm(e));
  return s.prefix || (s.prefix = Qo()), n && i && (s.prefix = n, s.iconName = i), s.iconName && s.prefix || (s.prefix && a.length > 0 && (s.iconName = TU(s.prefix, e.innerText) || Im(s.prefix, gh(e.innerText))), !s.iconName && Be.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function iW(e) {
  const n = Wc(e.attributes).reduce((s, g) => (s.name !== "class" && s.name !== "style" && (s[g.name] = g.value), s), {}), i = e.getAttribute("title"), a = e.getAttribute("data-fa-title-id");
  return Be.autoA11y && (i ? n["aria-labelledby"] = "".concat(Be.replacementClass, "-title-").concat(a || Sf()) : (n["aria-hidden"] = "true", n.focusable = "false")), n;
}
function aW() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: R0,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Ow(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: i,
    prefix: a,
    rest: s
  } = rW(e), g = iW(e), c = dh("parseNodeAttributes", {}, e);
  let I = n.styleParser ? nW(e) : [];
  return Z1({
    iconName: i,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: R0,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: I,
      attributes: g
    }
  }, c);
}
const {
  styles: oW
} = O0;
function dM(e) {
  const n = Be.autoReplaceSvg === "nest" ? Ow(e, {
    styleParser: !1
  }) : Ow(e);
  return ~n.extra.classes.indexOf(YE) ? Xo("generateLayersText", e, n) : Xo("generateSvgReplacementMutation", e, n);
}
function sW() {
  return [...UH, ...ah];
}
function Dw(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!za) return Promise.resolve();
  const i = Sn.documentElement.classList, a = (w) => i.add("".concat(mw, "-").concat(w)), s = (w) => i.remove("".concat(mw, "-").concat(w)), g = Be.autoFetchSvg ? sW() : HE.concat(Object.keys(oW));
  g.includes("fa") || g.push("fa");
  const c = [".".concat(YE, ":not([").concat(Al, "])")].concat(g.map((w) => ".".concat(w, ":not([").concat(Al, "])"))).join(", ");
  if (c.length === 0)
    return Promise.resolve();
  let I = [];
  try {
    I = Wc(e.querySelectorAll(c));
  } catch {
  }
  if (I.length > 0)
    a("pending"), s("complete");
  else
    return Promise.resolve();
  const h = hm.begin("onTree"), m = I.reduce((w, x) => {
    try {
      const M = dM(x);
      M && w.push(M);
    } catch (M) {
      KE || M.name === "MissingIcon" && console.error(M);
    }
    return w;
  }, []);
  return new Promise((w, x) => {
    Promise.all(m).then((M) => {
      gM(M, () => {
        a("active"), a("complete"), s("pending"), typeof n == "function" && n(), h(), w();
      });
    }).catch((M) => {
      h(), x(M);
    });
  });
}
function lW(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  dM(e).then((i) => {
    i && gM([i], n);
  });
}
function uW(e) {
  return function(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = (n || {}).icon ? n : Ch(n || {});
    let {
      mask: s
    } = i;
    return s && (s = (s || {}).icon ? s : Ch(s || {})), e(a, Z1(Z1({}, i), {}, {
      mask: s
    }));
  };
}
const cW = function(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: i = R0,
    symbol: a = !1,
    mask: s = null,
    maskId: g = null,
    title: c = null,
    titleId: I = null,
    classes: h = [],
    attributes: m = {},
    styles: w = {}
  } = n;
  if (!e) return;
  const {
    prefix: x,
    iconName: M,
    icon: O
  } = e;
  return c6(Z1({
    type: "icon"
  }, e), () => (Il("beforeDOMElementCreation", {
    iconDefinition: e,
    params: n
  }), Be.autoA11y && (c ? m["aria-labelledby"] = "".concat(Be.replacementClass, "-title-").concat(I || Sf()) : (m["aria-hidden"] = "true", m.focusable = "false")), pm({
    icons: {
      main: Ah(O),
      mask: s ? Ah(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: x,
    iconName: M,
    transform: Z1(Z1({}, R0), i),
    symbol: a,
    title: c,
    maskId: g,
    titleId: I,
    extra: {
      attributes: m,
      styles: w,
      classes: h
    }
  })));
};
var gW = {
  mixout() {
    return {
      icon: uW(cW)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = Dw, e.nodeCallback = lW, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(n) {
      const {
        node: i = Sn,
        callback: a = () => {
        }
      } = n;
      return Dw(i, a);
    }, e.generateSvgReplacementMutation = function(n, i) {
      const {
        iconName: a,
        title: s,
        titleId: g,
        prefix: c,
        transform: I,
        symbol: h,
        mask: m,
        maskId: w,
        extra: x
      } = i;
      return new Promise((M, O) => {
        Promise.all([Ih(a, c), m.iconName ? Ih(m.iconName, m.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((k) => {
          let [z, N] = k;
          M([n, pm({
            icons: {
              main: z,
              mask: N
            },
            prefix: c,
            iconName: a,
            transform: I,
            symbol: h,
            maskId: w,
            title: s,
            titleId: g,
            extra: x,
            watchable: !0
          })]);
        }).catch(O);
      });
    }, e.generateAbstractIcon = function(n) {
      let {
        children: i,
        attributes: a,
        main: s,
        transform: g,
        styles: c
      } = n;
      const I = s6(c);
      I.length > 0 && (a.style = I);
      let h;
      return Cm(g) && (h = Xo("generateAbstractTransformGrouping", {
        main: s,
        transform: g,
        containerWidth: s.width,
        iconWidth: s.width
      })), i.push(h || s.icon), {
        children: i,
        attributes: a
      };
    };
  }
}, fW = {
  mixout() {
    return {
      layer(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: i = []
        } = n;
        return c6({
          type: "layer"
        }, () => {
          Il("beforeDOMElementCreation", {
            assembler: e,
            params: n
          });
          let a = [];
          return e((s) => {
            Array.isArray(s) ? s.map((g) => {
              a = a.concat(g.abstract);
            }) : a = a.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Be.cssPrefix, "-layers"), ...i].join(" ")
            },
            children: a
          }];
        });
      }
    };
  }
}, dW = {
  mixout() {
    return {
      counter(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: i = null,
          classes: a = [],
          attributes: s = {},
          styles: g = {}
        } = n;
        return c6({
          type: "counter",
          content: e
        }, () => (Il("beforeDOMElementCreation", {
          content: e,
          params: n
        }), KU({
          content: e.toString(),
          title: i,
          extra: {
            attributes: s,
            styles: g,
            classes: ["".concat(Be.cssPrefix, "-layers-counter"), ...a]
          }
        })));
      }
    };
  }
}, CW = {
  mixout() {
    return {
      text(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: i = R0,
          title: a = null,
          classes: s = [],
          attributes: g = {},
          styles: c = {}
        } = n;
        return c6({
          type: "text",
          content: e
        }, () => (Il("beforeDOMElementCreation", {
          content: e,
          params: n
        }), Ew({
          content: e,
          transform: Z1(Z1({}, R0), i),
          title: a,
          extra: {
            attributes: g,
            styles: c,
            classes: ["".concat(Be.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(n, i) {
      const {
        title: a,
        transform: s,
        extra: g
      } = i;
      let c = null, I = null;
      if (FE) {
        const h = parseInt(getComputedStyle(n).fontSize, 10), m = n.getBoundingClientRect();
        c = m.width / h, I = m.height / h;
      }
      return Be.autoA11y && !a && (g.attributes["aria-hidden"] = "true"), Promise.resolve([n, Ew({
        content: n.innerHTML,
        width: c,
        height: I,
        transform: s,
        title: a,
        extra: g,
        watchable: !0
      })]);
    };
  }
};
const AW = new RegExp('"', "ug"), kw = [1105920, 1112319], jw = Z1(Z1(Z1(Z1({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), FH), tU), QH), mh = Object.keys(jw).reduce((e, n) => (e[n.toLowerCase()] = jw[n], e), {}), IW = Object.keys(mh).reduce((e, n) => {
  const i = mh[n];
  return e[n] = i[900] || [...Object.entries(i)][0][1], e;
}, {});
function pW(e) {
  const n = e.replace(AW, ""), i = wU(n, 0), a = i >= kw[0] && i <= kw[1], s = n.length === 2 ? n[0] === n[1] : !1;
  return {
    value: gh(s ? n[0] : n),
    isSecondary: a || s
  };
}
function hW(e, n) {
  const i = e.replace(/^['"]|['"]$/g, "").toLowerCase(), a = parseInt(n), s = isNaN(a) ? "normal" : a;
  return (mh[i] || {})[s] || IW[i];
}
function zw(e, n) {
  const i = "".concat(nU).concat(n.replace(":", "-"));
  return new Promise((a, s) => {
    if (e.getAttribute(i) !== null)
      return a();
    const c = Wc(e.children).filter((M) => M.getAttribute(sh) === n)[0], I = Yo.getComputedStyle(e, n), h = I.getPropertyValue("font-family"), m = h.match(sU), w = I.getPropertyValue("font-weight"), x = I.getPropertyValue("content");
    if (c && !m)
      return e.removeChild(c), a();
    if (m && x !== "none" && x !== "") {
      const M = I.getPropertyValue("content");
      let O = hW(h, w);
      const {
        value: k,
        isSecondary: z
      } = pW(M), N = m[0].startsWith("FontAwesome");
      let U = Im(O, k), Q = U;
      if (N) {
        const _ = LU(k);
        _.iconName && _.prefix && (U = _.iconName, O = _.prefix);
      }
      if (U && !z && (!c || c.getAttribute(cm) !== O || c.getAttribute(gm) !== Q)) {
        e.setAttribute(i, Q), c && e.removeChild(c);
        const _ = aW(), {
          extra: X
        } = _;
        X.attributes[sh] = n, Ih(U, O).then((B) => {
          const Z = pm(Z1(Z1({}, _), {}, {
            icons: {
              main: B,
              mask: sM()
            },
            prefix: O,
            iconName: Q,
            extra: X,
            watchable: !0
          })), Y = Sn.createElementNS("http://www.w3.org/2000/svg", "svg");
          n === "::before" ? e.insertBefore(Y, e.firstChild) : e.appendChild(Y), Y.outerHTML = Z.map((V) => Ff(V)).join(`
`), e.removeAttribute(i), a();
        }).catch(s);
      } else
        a();
    } else
      a();
  });
}
function mW(e) {
  return Promise.all([zw(e, "::before"), zw(e, "::after")]);
}
function vW(e) {
  return e.parentNode !== document.head && !~iU.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(sh) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function Nw(e) {
  if (za)
    return new Promise((n, i) => {
      const a = Wc(e.querySelectorAll("*")).filter(vW).map(mW), s = hm.begin("searchPseudoElements");
      fM(), Promise.all(a).then(() => {
        s(), hh(), n();
      }).catch(() => {
        s(), hh(), i();
      });
    });
}
var yW = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = Nw, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(n) {
      const {
        node: i = Sn
      } = n;
      Be.searchPseudoElements && Nw(i);
    };
  }
};
let Pw = !1;
var bW = {
  mixout() {
    return {
      dom: {
        unwatch() {
          fM(), Pw = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        Rw(dh("mutationObserverCallbacks", {}));
      },
      noAuto() {
        tW();
      },
      watch(e) {
        const {
          observeMutationsRoot: n
        } = e;
        Pw ? hh() : Rw(dh("mutationObserverCallbacks", {
          observeMutationsRoot: n
        }));
      }
    };
  }
};
const Fw = (e) => {
  let n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((i, a) => {
    const s = a.toLowerCase().split("-"), g = s[0];
    let c = s.slice(1).join("-");
    if (g && c === "h")
      return i.flipX = !0, i;
    if (g && c === "v")
      return i.flipY = !0, i;
    if (c = parseFloat(c), isNaN(c))
      return i;
    switch (g) {
      case "grow":
        i.size = i.size + c;
        break;
      case "shrink":
        i.size = i.size - c;
        break;
      case "left":
        i.x = i.x - c;
        break;
      case "right":
        i.x = i.x + c;
        break;
      case "up":
        i.y = i.y - c;
        break;
      case "down":
        i.y = i.y + c;
        break;
      case "rotate":
        i.rotate = i.rotate + c;
        break;
    }
    return i;
  }, n);
};
var wW = {
  mixout() {
    return {
      parse: {
        transform: (e) => Fw(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, n) {
        const i = n.getAttribute("data-fa-transform");
        return i && (e.transform = Fw(i)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(n) {
      let {
        main: i,
        transform: a,
        containerWidth: s,
        iconWidth: g
      } = n;
      const c = {
        transform: "translate(".concat(s / 2, " 256)")
      }, I = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), h = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), m = "rotate(".concat(a.rotate, " 0 0)"), w = {
        transform: "".concat(I, " ").concat(h, " ").concat(m)
      }, x = {
        transform: "translate(".concat(g / 2 * -1, " -256)")
      }, M = {
        outer: c,
        inner: w,
        path: x
      };
      return {
        tag: "g",
        attributes: Z1({}, M.outer),
        children: [{
          tag: "g",
          attributes: Z1({}, M.inner),
          children: [{
            tag: i.icon.tag,
            children: i.icon.children,
            attributes: Z1(Z1({}, i.icon.attributes), M.path)
          }]
        }]
      };
    };
  }
};
const l7 = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Bw(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || n) && (e.attributes.fill = "black"), e;
}
function xW(e) {
  return e.tag === "g" ? e.children : [e];
}
var SW = {
  hooks() {
    return {
      parseNodeAttributes(e, n) {
        const i = n.getAttribute("data-fa-mask"), a = i ? u6(i.split(" ").map((s) => s.trim())) : sM();
        return a.prefix || (a.prefix = Qo()), e.mask = a, e.maskId = n.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(n) {
      let {
        children: i,
        attributes: a,
        main: s,
        mask: g,
        maskId: c,
        transform: I
      } = n;
      const {
        width: h,
        icon: m
      } = s, {
        width: w,
        icon: x
      } = g, M = pU({
        transform: I,
        containerWidth: w,
        iconWidth: h
      }), O = {
        tag: "rect",
        attributes: Z1(Z1({}, l7), {}, {
          fill: "white"
        })
      }, k = m.children ? {
        children: m.children.map(Bw)
      } : {}, z = {
        tag: "g",
        attributes: Z1({}, M.inner),
        children: [Bw(Z1({
          tag: m.tag,
          attributes: Z1(Z1({}, m.attributes), M.path)
        }, k))]
      }, N = {
        tag: "g",
        attributes: Z1({}, M.outer),
        children: [z]
      }, U = "mask-".concat(c || Sf()), Q = "clip-".concat(c || Sf()), _ = {
        tag: "mask",
        attributes: Z1(Z1({}, l7), {}, {
          id: U,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [O, N]
      }, X = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: Q
          },
          children: xW(x)
        }, _]
      };
      return i.push(X, {
        tag: "rect",
        attributes: Z1({
          fill: "currentColor",
          "clip-path": "url(#".concat(Q, ")"),
          mask: "url(#".concat(U, ")")
        }, l7)
      }), {
        children: i,
        attributes: a
      };
    };
  }
}, EW = {
  provides(e) {
    let n = !1;
    Yo.matchMedia && (n = Yo.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const i = [], a = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      i.push({
        tag: "path",
        attributes: Z1(Z1({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const g = Z1(Z1({}, s), {}, {
        attributeName: "opacity"
      }), c = {
        tag: "circle",
        attributes: Z1(Z1({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || c.children.push({
        tag: "animate",
        attributes: Z1(Z1({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: Z1(Z1({}, g), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), i.push(c), i.push({
        tag: "path",
        attributes: Z1(Z1({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: Z1(Z1({}, g), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || i.push({
        tag: "path",
        attributes: Z1(Z1({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: Z1(Z1({}, g), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: i
      };
    };
  }
}, MW = {
  hooks() {
    return {
      parseNodeAttributes(e, n) {
        const i = n.getAttribute("data-fa-symbol"), a = i === null ? !1 : i === "" ? !0 : i;
        return e.symbol = a, e;
      }
    };
  }
}, TW = [vU, gW, fW, dW, CW, yW, bW, wW, SW, EW, MW];
FU(TW, {
  mixoutsTo: z3
});
z3.noAuto;
z3.config;
z3.library;
z3.dom;
const vh = z3.parse;
z3.findIconDefinition;
z3.toHtml;
const LW = z3.icon;
z3.layer;
z3.text;
z3.counter;
function Hw(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), i.push.apply(i, a);
  }
  return i;
}
function S0(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Hw(Object(i), !0).forEach(function(a) {
      wc(e, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Hw(Object(i)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }
  return e;
}
function EA(e) {
  "@babel/helpers - typeof";
  return EA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, EA(e);
}
function wc(e, n, i) {
  return n in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function RW(e, n) {
  if (e == null) return {};
  var i = {}, a = Object.keys(e), s, g;
  for (g = 0; g < a.length; g++)
    s = a[g], !(n.indexOf(s) >= 0) && (i[s] = e[s]);
  return i;
}
function OW(e, n) {
  if (e == null) return {};
  var i = RW(e, n), a, s;
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(e);
    for (s = 0; s < g.length; s++)
      a = g[s], !(n.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (i[a] = e[a]);
  }
  return i;
}
function yh(e) {
  return DW(e) || kW(e) || jW(e) || zW();
}
function DW(e) {
  if (Array.isArray(e)) return bh(e);
}
function kW(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function jW(e, n) {
  if (e) {
    if (typeof e == "string") return bh(e, n);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set") return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return bh(e, n);
  }
}
function bh(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, a = new Array(n); i < n; i++) a[i] = e[i];
  return a;
}
function zW() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NW(e) {
  var n, i = e.beat, a = e.fade, s = e.beatFade, g = e.bounce, c = e.shake, I = e.flash, h = e.spin, m = e.spinPulse, w = e.spinReverse, x = e.pulse, M = e.fixedWidth, O = e.inverse, k = e.border, z = e.listItem, N = e.flip, U = e.size, Q = e.rotation, _ = e.pull, X = (n = {
    "fa-beat": i,
    "fa-fade": a,
    "fa-beat-fade": s,
    "fa-bounce": g,
    "fa-shake": c,
    "fa-flash": I,
    "fa-spin": h,
    "fa-spin-reverse": w,
    "fa-spin-pulse": m,
    "fa-pulse": x,
    "fa-fw": M,
    "fa-inverse": O,
    "fa-border": k,
    "fa-li": z,
    "fa-flip": N === !0,
    "fa-flip-horizontal": N === "horizontal" || N === "both",
    "fa-flip-vertical": N === "vertical" || N === "both"
  }, wc(n, "fa-".concat(U), typeof U < "u" && U !== null), wc(n, "fa-rotate-".concat(Q), typeof Q < "u" && Q !== null && Q !== 0), wc(n, "fa-pull-".concat(_), typeof _ < "u" && _ !== null), wc(n, "fa-swap-opacity", e.swapOpacity), n);
  return Object.keys(X).map(function(B) {
    return X[B] ? B : null;
  }).filter(function(B) {
    return B;
  });
}
function PW(e) {
  return e = e - 0, e === e;
}
function CM(e) {
  return PW(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(n, i) {
    return i ? i.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var FW = ["style"];
function BW(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function HW(e) {
  return e.split(";").map(function(n) {
    return n.trim();
  }).filter(function(n) {
    return n;
  }).reduce(function(n, i) {
    var a = i.indexOf(":"), s = CM(i.slice(0, a)), g = i.slice(a + 1).trim();
    return s.startsWith("webkit") ? n[BW(s)] = g : n[s] = g, n;
  }, {});
}
function AM(e, n) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof n == "string")
    return n;
  var a = (n.children || []).map(function(h) {
    return AM(e, h);
  }), s = Object.keys(n.attributes || {}).reduce(function(h, m) {
    var w = n.attributes[m];
    switch (m) {
      case "class":
        h.attrs.className = w, delete n.attributes.class;
        break;
      case "style":
        h.attrs.style = HW(w);
        break;
      default:
        m.indexOf("aria-") === 0 || m.indexOf("data-") === 0 ? h.attrs[m.toLowerCase()] = w : h.attrs[CM(m)] = w;
    }
    return h;
  }, {
    attrs: {}
  }), g = i.style, c = g === void 0 ? {} : g, I = OW(i, FW);
  return s.attrs.style = S0(S0({}, s.attrs.style), c), e.apply(void 0, [n.tag, S0(S0({}, s.attrs), I)].concat(yh(a)));
}
var IM = !1;
try {
  IM = process.env.NODE_ENV === "production";
} catch {
}
function UW() {
  if (!IM && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function Uw(e) {
  if (e && EA(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (vh.icon)
    return vh.icon(e);
  if (e === null)
    return null;
  if (e && EA(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function u7(e, n) {
  return Array.isArray(n) && n.length > 0 || !Array.isArray(n) && n ? wc({}, e, n) : {};
}
var Ww = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, vm = /* @__PURE__ */ nn.forwardRef(function(e, n) {
  var i = S0(S0({}, Ww), e), a = i.icon, s = i.mask, g = i.symbol, c = i.className, I = i.title, h = i.titleId, m = i.maskId, w = Uw(a), x = u7("classes", [].concat(yh(NW(i)), yh((c || "").split(" ")))), M = u7("transform", typeof i.transform == "string" ? vh.transform(i.transform) : i.transform), O = u7("mask", Uw(s)), k = LW(w, S0(S0(S0(S0({}, x), M), O), {}, {
    symbol: g,
    title: I,
    titleId: h,
    maskId: m
  }));
  if (!k)
    return UW("Could not find icon", w), null;
  var z = k.abstract, N = {
    ref: n
  };
  return Object.keys(i).forEach(function(U) {
    Ww.hasOwnProperty(U) || (N[U] = i[U]);
  }), WW(z[0], N);
});
vm.displayName = "FontAwesomeIcon";
vm.propTypes = {
  beat: E.bool,
  border: E.bool,
  beatFade: E.bool,
  bounce: E.bool,
  className: E.string,
  fade: E.bool,
  flash: E.bool,
  mask: E.oneOfType([E.object, E.array, E.string]),
  maskId: E.string,
  fixedWidth: E.bool,
  inverse: E.bool,
  flip: E.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: E.oneOfType([E.object, E.array, E.string]),
  listItem: E.bool,
  pull: E.oneOf(["right", "left"]),
  pulse: E.bool,
  rotation: E.oneOf([0, 90, 180, 270]),
  shake: E.bool,
  size: E.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: E.bool,
  spinPulse: E.bool,
  spinReverse: E.bool,
  symbol: E.oneOfType([E.bool, E.string]),
  title: E.string,
  titleId: E.string,
  transform: E.oneOfType([E.string, E.object]),
  swapOpacity: E.bool
};
var WW = AM.bind(null, nn.createElement);
const _W = (e) => /* @__PURE__ */ o1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 634 512", ...e }, /* @__PURE__ */ o1.createElement("path", { d: "M196.2 503.5c-21.6 20.9-67.9-19.2-43.8-43.8s41-40 41-40c-54.3-2.9-100-23.8-137.1-62.9S1 272.1 1 217.8C1 161.6 20 114 59.1 74.9s86.7-59 143.8-59c0 0 48.7 0 84.2 0s35.5 62.9 0 62.9-84.2 0-84.2 0c-39 0-72.4 13.3-99 40c-27.6 26.7-41 60-41 98.1c0 37.1 12.4 68.6 37.1 95.2c23.8 26.7 55.2 41 91.4 43.8c0 0-13.9-14.4-39-39s19.3-65.8 43.8-42.9 115.2 114.3 115.2 114.3-93.6 94.3-115.2 115.2zM353.6 49.8c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8c0 18.6-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8zm0 167c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8c0 18.6-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8zM621.7 388.7c0 18.5-14.4 31.8-31.3 31.8H384.9c-18.3 0-31.3-13.3-31.3-31.8c0-17.2 13.1-31.8 31.3-31.8H590.4c17 0 31.3 14.6 31.3 31.8z" })), VW = (e) => /* @__PURE__ */ o1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ o1.createElement("path", { d: "M39.3 142.3c0-6.5 5.7-13.1 13.1-13.1l314.1 0c6.5 0 13.1 6.5 13.1 13.1l0 18.8-18.8 14.7c13.9-4.9 29.4-7.4 45-7.4c2 0 3.9 .2 5.9 .4c2.2 .2 4.6 .4 7.1 .4l0-27c0-28.6-23.7-52.3-52.3-52.3l-314.1 0C22.9 89.9 0 113.7 0 142.3L0 351.7C0 381.1 22.9 404 52.3 404l242.1 0c-9.8-11.5-18-24.5-22.9-39.3l-219.2 0c-7.4 0-13.1-5.7-13.1-13.1l0-139.9 116.1 94.9c30.3 25.4 74.4 26.2 106.3 1.6c.8-23.7 7.4-46.6 18-66.3L238 276.4c-17.2 13.9-40.9 13.9-58.1 0L39.3 161.1l0-18.8zM300.4 365.4A113.3 113.3 0 1 0 496.6 252 113.3 113.3 0 1 0 300.4 365.4zm98.4-7.1c-6.2 0-10.6-4.4-10.6-10.6l0-28.4-28.4 0c-6.2 0-10.6-4.4-10.6-10.6c0-5.8 4.4-10.6 10.6-10.6l28.4 0 0-28.4c0-5.8 4.4-10.6 10.6-10.6c5.8 0 10.6 4.9 10.6 10.6l0 28.4 28.4 0c5.8 0 10.6 4.9 10.6 10.6c0 6.2-4.9 10.6-10.6 10.6l-28.4 0 0 28.4c0 6.2-4.9 10.6-10.6 10.6z" })), KW = (e) => /* @__PURE__ */ o1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 491 512", ...e }, /* @__PURE__ */ o1.createElement("path", { d: "M224 59.3c-2.6 6.1-3.9 12.7-3.9 19.4c0 8 1.9 15.7 5.4 22.6l-169.4-.1c-7.7 0-14 6.3-14 14V367.7c0 7.7 6.3 14 14 14h84.2c23.2 0 42.1 18.8 42.1 42.1v14l63.6-47.7c7.3-5.4 16.1-8.4 25.2-8.4H392.8c7.7 0 14-6.3 14-14l-.7-123.9c4.5 1.4 9.3 2.2 14.3 2.2c7.7 0 15.2-1.8 22.1-5.6c1.3-.7 3.3-1.8 5.7-3.4l.7 130.7c0 30.9-25.2 56.1-56.1 56.1H271.2l-88.8 66.6-.2 .2-4.5 3.3-15 11.2c-4.3 3.2-10 3.7-14.7 1.3s-7.7-7.2-7.7-12.5v-70H56.1c-31 0-56.1-25.2-56.1-56.1V115.2c0-31 25.2-56.1 56.1-56.1L224 59.3zM133.3 269.6c-11.7 0-21 9.4-21 21s9.4 21 21 21h98.2c11.7 0 21-9.4 21-21s-9.4-21-21-21H133.3zm0-84.2c-11.7 0-21 9.4-21 21s9.4 21 21 21H315.6c11.7 0 21-9.4 21-21s-9.4-21-21-21H133.3zM353.5 1.2c5.1 2.3 8.4 7.4 8.4 12.9V42.5h49.6c43 0 77.9 34.9 77.9 77.9c0 50.2-36.1 72.6-44.4 77.1c-1.1 .6-2.3 .8-3.6 .8c-4.8 0-8.7-3.9-8.7-8.7c0-3.3 1.9-6.4 4.3-8.6c4.2-3.9 9.8-11.7 9.8-25.1c0-23.5-19-42.5-42.5-42.5H361.9v28.3c0 5.6-3.3 10.7-8.4 12.9s-11.1 1.3-15.2-2.4L267.4 88.5c-3-2.7-4.7-6.6-4.7-10.6s1.7-7.8 4.7-10.5L338.2 3.6c4.2-3.8 10.1-4.7 15.2-2.4z" })), JW = (e) => /* @__PURE__ */ o1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 492 512", ...e }, /* @__PURE__ */ o1.createElement("path", { d: "M115.4 56.3l261.1 0c3.8 0 7.7 3.8 7.7 7.7l0 163.2 40.3-34.6 5.8-2.9 0-125.8c0-28.8-25-53.8-53.8-53.8l-261.1 0c-29.8 0-53.8 25-53.8 53.8l0 125.8c.4 .4 1 .8 1.6 1.3c.9 .7 2.1 1.5 3.2 2.6l41.3 33.6 0-163.2c0-3.8 2.9-7.7 7.7-7.7zM46.3 448l0-171.8L182.6 387.5c36.5 30.7 89.3 30.7 126.7 0L445.7 276.2l0 171.8c0 4.8-3.8 7.7-7.7 7.7l-384 0c-4.8 0-7.7-2.9-7.7-7.7zM28.1 209.9c-15.4 0-27.8 13.4-27.8 28.8L.2 448c0 29.8 24 53.8 53.8 53.8l384 0c29.8 0 53.8-24 53.8-53.8l0-209.3c0-15.4-13.4-28.8-28.8-28.8c-6.7 0-13.4 2.9-18.2 6.7L279.6 352c-20.2 16.3-48 16.3-68.2 0L46.3 216.6c-4.8-3.8-11.5-6.7-18.2-6.7zM203.4 103.7c3.7-4.1 3.4-10.4-.8-14.1c0 0 0 0 0 0c-4.1-3.7-10.4-3.4-14.2 .8l-23 25.5-9.2-9.2c-3.9-3.9-10.3-3.9-14.1 0s-3.9 10.3 0 14.2l16.7 16.7c2 1.9 4.6 3 7.3 2.9s5.3-1.2 7.2-3.3l30.1-33.4zm0 66.8c3.7-4.1 3.4-10.4-.8-14.2c0 0 0 0 0 0c-4.1-3.7-10.4-3.4-14.2 .7l-23 25.5-9.2-9.2c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.2l16.7 16.7c2 1.9 4.6 3 7.3 2.9s5.3-1.3 7.2-3.3l30.1-33.4zM246 100.3c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l93.5 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-93.5 0zm0 66.8c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l93.5 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-93.5 0zm-26.7 66.8c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4l120.2 0c7.4 0 13.4-6 13.4-13.4s-6-13.4-13.4-13.4l-120.2 0zm-42.8 3.3a20 20 0 1 0 -34.7 20 20 20 0 1 0 34.7-20z" })), ym = {
  lowPriority: _W,
  newEmail: VW,
  replyToMessage: KW,
  requests: JW
}, YW = ({ icon: e, ...n }) => {
  const i = ym[e];
  return /* @__PURE__ */ v.jsx(i, { ...n });
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const QW = {
  prefix: "fab",
  iconName: "microsoft",
  icon: [448, 512, [], "f3ca", "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"]
}, XW = {
  prefix: "fab",
  iconName: "chrome",
  icon: [512, 512, [], "f268", "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"]
}, GW = {
  prefix: "fab",
  iconName: "apple",
  icon: [384, 512, [], "f179", "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"]
}, qW = {
  prefix: "fab",
  iconName: "linux",
  icon: [448, 512, [], "f17c", "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"]
}, ZW = {
  prefix: "fab",
  iconName: "android",
  icon: [576, 512, [], "f17b", "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const _w = {
  prefix: "fad",
  iconName: "list-tree",
  icon: [512, 512, [], "e1d2", ["M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z", "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48z"]]
}, $W = {
  prefix: "fad",
  iconName: "arrow-rotate-right",
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", ["M32 256c0 57.3 21.9 114.7 65.6 158.4S198.7 480 256 480s114.7-21.9 158.4-65.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160l45.7 0 0-44.8L414.4 97.6C370.6 53.9 313.3 32 256 32S141.3 53.9 97.6 97.6S32 198.7 32 256z", "M496 192c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128z"]]
}, e_ = {
  prefix: "fad",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", ["M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z", ""]]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const t_ = {
  prefix: "far",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"]
}, n_ = {
  prefix: "far",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
}, r_ = {
  prefix: "far",
  iconName: "calendar-days",
  icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"]
}, i_ = {
  prefix: "far",
  iconName: "sort-down",
  icon: [320, 512, ["sort-desc"], "f0dd", "M160 425.4L70.6 336l178.7 0L160 425.4zm-22.6 45.3c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, a_ = {
  prefix: "far",
  iconName: "right-from-bracket",
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M352 146.2L462 256 352 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L499.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"]
}, o_ = {
  prefix: "far",
  iconName: "fingerprint",
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM352 256c0-53-43-96-96-96s-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9zm-96-24c-13.3 0-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9c0-13.3-10.7-24-24-24z"]
}, s_ = {
  prefix: "far",
  iconName: "hexagon-xmark",
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, l_ = {
  prefix: "far",
  iconName: "address-book",
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"]
}, u_ = {
  prefix: "far",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
}, c_ = {
  prefix: "far",
  iconName: "cloud-xmark",
  icon: [640, 512, [], "e35f", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
}, g_ = {
  prefix: "far",
  iconName: "box-archive",
  icon: [512, 512, ["archive"], "f187", "M48 80l0 48 416 0 0-48L48 80zM32 32l448 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32L32 176c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM32 416l0-208 48 0 0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208 48 0 0 208c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64z"]
}, f_ = g_, d_ = {
  prefix: "far",
  iconName: "cloud",
  icon: [640, 512, [9729], "f0c2", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z"]
}, Vw = {
  prefix: "far",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z"]
}, C_ = {
  prefix: "far",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, A_ = {
  prefix: "far",
  iconName: "lock",
  icon: [448, 512, [128274], "f023", "M144 128l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0zM48 256l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240c-8.8 0-16 7.2-16 16z"]
}, I_ = {
  prefix: "far",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"]
}, p_ = I_, h_ = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"]
}, m_ = {
  prefix: "far",
  iconName: "calendar-circle-exclamation",
  icon: [576, 512, [], "e46e", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
}, v_ = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
}, y_ = {
  prefix: "far",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, b_ = {
  prefix: "far",
  iconName: "angle-right",
  icon: [320, 512, [8250], "f105", "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"]
}, w_ = {
  prefix: "far",
  iconName: "arrow-left-to-line",
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"]
}, x_ = {
  prefix: "far",
  iconName: "arrow-up-from-bracket",
  icon: [448, 512, [], "e09a", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z"]
}, S_ = {
  prefix: "far",
  iconName: "folder",
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"]
}, E_ = {
  prefix: "far",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"]
}, M_ = {
  prefix: "far",
  iconName: "file-invoice-dollar",
  icon: [384, 512, [], "f571", "M336 448l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 215.6c11 0 20 9 20 20l0 10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8l0 10.1c0 11-9 20-20 20s-20-9-20-20l0-10.8c-10-1.9-19.3-4.8-27.5-7.3c0 0 0 0 0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2c0 0 0 0 0 0s0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3l0-10.3c0-11 9-20 20-20zM96 96l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, T_ = {
  prefix: "far",
  iconName: "user-group",
  icon: [640, 512, [128101, "user-friends"], "f500", "M1.5 458.7c6-45.5 29.2-85.6 62.8-113.6C95.3 319.4 135 304 178.3 304l45.7 0 45.7 0c43.3 0 83 15.4 113.9 41.1c33.6 28 56.8 68.1 62.8 113.6c1 7.7 1.5 15.6 1.5 23.6c0 16.4-13.3 29.7-29.7 29.7l-19.6 0L49.3 512l-19.6 0C13.3 512 0 498.7 0 482.3c0-8 .5-15.9 1.5-23.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm208 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM178.3 352c-47.8 0-89.5 25.7-112.2 64c-8.6 14.4-14.4 30.7-16.8 48L98 464 350 464l48.8 0c-.4-2.7-.8-5.3-1.4-8c-2.9-14.3-8.2-27.8-15.5-40c-22.7-38.3-64.4-64-112.2-64l-91.4 0zm431 160l-136.9 0c4.9-8.8 7.6-18.9 7.6-29.7c0-65-29.5-123.2-75.9-161.8c4.3-.4 8.7-.5 13.2-.5l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
}, L_ = {
  prefix: "far",
  iconName: "comment-plus",
  icon: [512, 512, [], "f4b2", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, R_ = {
  prefix: "far",
  iconName: "circle-arrow-up",
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM361 207l-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
}, O_ = {
  prefix: "far",
  iconName: "folder-open",
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z"]
}, D_ = {
  prefix: "far",
  iconName: "file-arrow-up",
  icon: [384, 512, ["file-upload"], "f574", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 408l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L168 408c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
}, k_ = {
  prefix: "far",
  iconName: "signature",
  icon: [640, 512, [], "f5b7", "M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 27.5-2.3 55-7 82.1L158 251.1c-36.9 11.4-62 45.5-62 84.1L96 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-101.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96s-96 43-96 96l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm-3.8 169l80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2zM64 368l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.2 0c-.1-2-.2-4-.2-6l0-42zm216.8 48L616 416c13.3 0 24-10.7 24-24s-10.7-24-24-24l-311.9 0c-7 16.3-14.8 32.4-23.3 48z"]
}, j_ = {
  prefix: "far",
  iconName: "square-plus",
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
}, z_ = {
  prefix: "far",
  iconName: "message-lines",
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
}, N_ = {
  prefix: "far",
  iconName: "image",
  icon: [512, 512, [], "f03e", "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
}, P_ = {
  prefix: "far",
  iconName: "microphone",
  icon: [384, 512, [], "f130", "M240 96l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48s48 21.5 48 48zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"]
}, F_ = {
  prefix: "far",
  iconName: "file-zip",
  icon: [512, 512, [], "e5ee", "M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z"]
}, Kw = {
  prefix: "far",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, B_ = {
  prefix: "far",
  iconName: "circle-arrow-down",
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 305l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, H_ = {
  prefix: "far",
  iconName: "box-open",
  icon: [640, 512, [], "f49e", "M17.2 125.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 125.5zM320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1L581.1 42.1c-3-6.1-9.6-9.6-16.3-8.7L320 64zm-1.1 64l2.2 0s0 0 0 0l-2.2 0s0 0 0 0zM528 225.3l0 153.2-184 46L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 240.5-184-46 0-153.2L64 211.6l0 167c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-167-48 13.7z"]
}, U_ = {
  prefix: "far",
  iconName: "pause",
  icon: [320, 512, [9208], "f04c", "M48 112l0 288 48 0 0-288-48 0zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zm224 0l0 288 48 0 0-288-48 0zm-48 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z"]
}, W_ = {
  prefix: "far",
  iconName: "address-card",
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
}, __ = {
  prefix: "far",
  iconName: "money-bills",
  icon: [640, 512, [], "e1f3", "M528 80c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
}, V_ = {
  prefix: "far",
  iconName: "cloud-arrow-up",
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
}, Jw = {
  prefix: "far",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L414.1 176 360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L395.9 89.9C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L97.9 336l54.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-54.1 52.1 52.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9z"]
}, K_ = {
  prefix: "far",
  iconName: "layer-group",
  icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
}, J_ = {
  prefix: "far",
  iconName: "square",
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
}, Y_ = {
  prefix: "far",
  iconName: "sort",
  icon: [320, 512, ["unsorted"], "f0dc", "M70.6 176l178.7 0L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336 70.6 336zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
}, Q_ = {
  prefix: "far",
  iconName: "file-signature",
  icon: [576, 512, [], "f573", "M64 464l256 0c8.8 0 16-7.2 16-16l0-6.7 39.8-9.9c2.8-.7 5.6-1.6 8.2-2.7l0 19.3c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 49.1-48 48 0-91.6-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm96-115l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L96 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 25.6 0 12-48.2c1.4-5.6 4.3-10.8 8.4-14.9L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-1.1 .3-2.1 .4-3.2 .5c-.8 .1-1.5 .2-2.3 .2L256 416c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L160 349zM549.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0z"]
}, X_ = {
  prefix: "far",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
}, G_ = {
  prefix: "far",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"]
}, q_ = {
  prefix: "far",
  iconName: "wifi-slash",
  icon: [640, 512, [], "f6ac", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-267-209.3c47.2 8.4 89.8 30.2 123.8 61.4c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208c-7.2 0-14.3 .3-21.4 .8L169.4 107.5C216.2 89.7 267 80 320 80c107.4 0 205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32c-69.1 0-134.7 14.9-193.9 41.5L38.8 5.1zM76.9 156.6L37.7 125.7c-10.2 7.6-20 15.6-29.5 23.9c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c11.8-10.4 24.1-20.1 37-29.1zM226.3 274.3L184 241c-23.4 12.1-44.9 27.2-64.1 44.8c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c21.5-19.7 46.5-35.7 73.9-46.9zM376 424a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
}, Z_ = {
  prefix: "far",
  iconName: "lock-open",
  icon: [576, 512, [], "f3c1", "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72C560 57.3 502.7 0 432 0S304 57.3 304 128l0 64L64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-64zM64 240l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16z"]
}, $_ = {
  prefix: "far",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
}, eV = {
  prefix: "far",
  iconName: "file-image",
  icon: [384, 512, [128443], "f1c5", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"]
}, tV = {
  prefix: "far",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, nV = {
  prefix: "far",
  iconName: "files",
  icon: [448, 512, [], "e178", "M160 368l224 0c8.8 0 16-7.2 16-16l0-224-48 0c-17.7 0-32-14.3-32-32l0-48L160 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16zm224 48l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64L325.5 0c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24z"]
}, Yw = {
  prefix: "far",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
}, rV = {
  prefix: "far",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"]
}, iV = {
  prefix: "far",
  iconName: "sort-up",
  icon: [320, 512, ["sort-asc"], "f0de", "M160 86.6L70.6 176l178.7 0L160 86.6zM137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
}, aV = {
  prefix: "far",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", "M457 372c11.5 6.6 26.3 2.7 31.8-9.3C503.7 330.2 512 294.1 512 256C512 122.7 410.1 13.2 280 1.1C266.8-.1 256 10.7 256 24s10.8 23.9 24 25.4C383.5 61.2 464 149.2 464 256c0 29.3-6.1 57.3-17 82.6c-5.3 12.2-1.5 26.8 10 33.5z"]
}, oV = {
  prefix: "far",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z"]
}, sV = {
  prefix: "far",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z"]
}, lV = {
  prefix: "far",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
}, uV = {
  prefix: "far",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"]
}, cV = {
  prefix: "far",
  iconName: "comment",
  icon: [512, 512, [128489, 61669], "f075", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"]
}, gV = {
  prefix: "far",
  iconName: "envelope",
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"]
}, fV = {
  prefix: "far",
  iconName: "paperclip",
  icon: [448, 512, [128206], "f0c6", "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.3-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"]
}, dV = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, CV = dV, AV = {
  prefix: "far",
  iconName: "camera",
  icon: [512, 512, [62258, "camera-alt"], "f030", "M199.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L137.4 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C358.4 47.4 337 32 312.9 32L199.1 32zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l90.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
}, IV = {
  prefix: "far",
  iconName: "check-double",
  icon: [448, 512, [], "f560", "M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z"]
}, Qw = {
  prefix: "far",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
}, pV = {
  prefix: "far",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
}, hV = {
  prefix: "far",
  iconName: "sliders",
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
}, Xw = {
  prefix: "far",
  iconName: "wand-sparkles",
  icon: [512, 512, [], "f72b", "M455.9 49.3c.9-.8 2.1-1.3 3.3-1.3c2.7 0 4.9 2.2 4.9 4.9c0 1.2-.4 2.4-1.3 3.3L97.3 459.6c-2.5 2.8-6.1 4.4-9.9 4.4c-3.5 0-6.9-1.4-9.4-3.9L51.9 434c-2.5-2.5-3.9-5.9-3.9-9.4c0-3.8 1.6-7.3 4.4-9.9L455.9 49.3zM459.1 0C446 0 433.4 4.9 423.6 13.7l-263 238.2c-2.9 2.7-6.8 4.1-10.7 4.1L112 256c-8.8 0-16 7.2-16 16l0 31.3c0 4.5-1.9 8.8-5.3 11.9L20.2 379.1C7.3 390.7 0 407.2 0 424.5c0 16.3 6.5 31.9 18 43.4L44.1 494c11.5 11.5 27.1 18 43.4 18c17.3 0 33.8-7.3 45.4-20.2L399.7 197.3c3-3.3 7.3-5.3 11.9-5.3l20.4 0c8.8 0 16-7.2 16-16l0-25.9c0-4 1.5-7.8 4.1-10.7l46.2-51C507.1 78.6 512 66 512 52.9C512 23.7 488.3 0 459.1 0zM432 288c-3.6 0-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8zM208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0z"]
}, mV = {
  prefix: "far",
  iconName: "ellipsis-vertical",
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
}, vV = {
  prefix: "far",
  iconName: "download",
  icon: [512, 512, [], "f019", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 270.1-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L280 24zM128.8 304L64 304c-35.3 0-64 28.7-64 64l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64l-64.8 0-48 48L448 352c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l112.8 0-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
}, yV = {
  prefix: "far",
  iconName: "mobile",
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, bV = {
  prefix: "far",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-48 0 0-152c0-22.1-17.9-40-40-40l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32zm128 32l0-144 96 0 0 144-96 0z"]
}, wV = {
  prefix: "far",
  iconName: "rotate-right",
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3L496 200c0 13.3-10.7 24-24 24l-116.7 0c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176l62.1 0 0-62.1z"]
}, xV = {
  prefix: "far",
  iconName: "upload",
  icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.1-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95L280 360zm32-8l0-48 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80c0-35.3 28.7-64 64-64l136 0 0 48L64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-136 0zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
}, SV = {
  prefix: "far",
  iconName: "file-arrow-down",
  icon: [384, 512, ["file-download"], "f56d", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L216 232z"]
}, EV = {
  prefix: "far",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"]
}, MV = {
  prefix: "far",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
}, TV = {
  prefix: "far",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
}, LV = {
  prefix: "far",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"]
}, RV = {
  prefix: "far",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"]
}, OV = {
  prefix: "far",
  iconName: "inbox",
  icon: [512, 512, [], "f01c", "M48 336l81.2 0 20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1l140.2 0c15.1 0 29-8.6 35.8-22.1L382.8 336l81.2 0 0 80c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-80zm406.5-48l-76.6 0c-15.1 0-29 8.6-35.8 22.1L321.2 352l-130.3 0-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1l-76.6 0 49-195.9C108.2 85 114.6 80 122 80L390 80c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32L122 32C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
}, DV = {
  prefix: "far",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
}, kV = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
}, jV = {
  prefix: "far",
  iconName: "arrow-up",
  icon: [384, 512, [8593], "f062", "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-340.1L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z"]
}, zV = {
  prefix: "far",
  iconName: "list-check",
  icon: [512, 512, ["tasks"], "f0ae", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 72c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, NV = zV, PV = {
  prefix: "far",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"]
}, FV = {
  prefix: "far",
  iconName: "share-from-square",
  icon: [576, 512, [61509, "share-square"], "f14d", "M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
}, Gw = {
  prefix: "far",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z"]
}, BV = {
  prefix: "far",
  iconName: "cloud-check",
  icon: [640, 512, [], "e35c", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
}, HV = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
}, qw = HV, UV = {
  prefix: "far",
  iconName: "angle-up",
  icon: [448, 512, [8963], "f106", "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"]
}, WV = {
  prefix: "far",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
}, _V = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
}, VV = {
  prefix: "far",
  iconName: "thumbtack",
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304 168 304l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 115.5 0-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7L134.8 48c0 1.2 0 2.5-.1 3.7zM168 352L32 352c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48L56 48c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0L86.8 0 297.2 0 328 0c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3l-30.8 0 3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-136 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z"]
}, KV = VV, JV = {
  prefix: "far",
  iconName: "arrow-right-to-line",
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L235.5 232 152 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"]
}, YV = {
  prefix: "far",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"]
}, QV = {
  prefix: "far",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"]
}, XV = {
  prefix: "far",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, GV = {
  prefix: "far",
  iconName: "desktop",
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 48L64 48c-8.8 0-16 7.2-16 16l0 192 480 0 0-192c0-8.8-7.2-16-16-16zm64 208l0 48 0 48c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64l0-48 0-48L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 192zM48 304l0 48c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-48L48 304zM252.3 464l71.3 0-8-48-55.3 0-8 48z"]
}, qV = {
  prefix: "far",
  iconName: "comment-sms",
  icon: [512, 512, ["sms"], "f7cd", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 176 96 192.5 96 212.8zM372.8 176c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 185.1 192 192l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9z"]
}, ZV = qV, $V = {
  prefix: "far",
  iconName: "user-plus",
  icon: [640, 512, [], "f234", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM504 312c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
}, eK = {
  prefix: "far",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
}, tK = {
  prefix: "far",
  iconName: "angle-left",
  icon: [320, 512, [8249], "f104", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"]
}, nK = {
  prefix: "far",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 120 0 136c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 280 0 160c0-35.3 28.7-64 64-64l64 0zM48 304l0 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-112-144 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L48 304zm144-48l128 0 144 0 0-96c0-8.8-7.2-16-16-16l-88 0-208 0-88 0c-8.8 0-16 7.2-16 16l0 96 144 0z"]
}, rK = {
  prefix: "far",
  iconName: "paper-plane",
  icon: [512, 512, [61913], "f1d8", "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"]
}, iK = {
  prefix: "far",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
}, Zw = {
  prefix: "far",
  iconName: "paperclip-vertical",
  icon: [384, 512, [], "e3c2", "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108l0 236c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-236c0-33.1-26.9-60-60-60s-60 26.9-60 60l0 260c0 53 43 96 96 96s96-43 96-96l0-216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-260z"]
}, aK = {
  prefix: "far",
  iconName: "print",
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M112 160l0-96c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64l0 96 48 0zm16 208l256 0 0 96-256 0 0-96zm-16-48c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 96-32 0c0-17.7-14.3-32-32-32l-288 0zm320 80l48 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 368c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-80z"]
}, oK = {
  prefix: "far",
  iconName: "building-columns",
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144L88.2 144 256 51.4 423.8 144l-140.1 0c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224l0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l456 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464z"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const sK = {
  prefix: "fas",
  iconName: "info",
  icon: [192, 512, [], "f129", "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"]
}, lK = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, uK = {
  prefix: "fas",
  iconName: "square-check",
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, cK = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, gK = {
  prefix: "fas",
  iconName: "folder",
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"]
}, fK = {
  prefix: "fas",
  iconName: "caret-up",
  icon: [320, 512, [], "f0d8", "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]
}, $w = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, dK = {
  prefix: "fas",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
}, CK = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"]
}, AK = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, IK = {
  prefix: "fas",
  iconName: "user-shield",
  icon: [640, 512, [], "f505", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3l-91.4 0zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7l0-187.8L591.4 312z"]
}, pK = {
  prefix: "fas",
  iconName: "video-slash",
  icon: [640, 512, [], "f4e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9l0 17.1 0 128 0 5.8-32-25.1L416 128c0-35.3-28.7-64-64-64L113.9 64 38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5l0 256c0 35.3 28.7 64 64 64l256 0c23.4 0 43.9-12.6 55-31.3z"]
}, hK = {
  prefix: "fas",
  iconName: "thumbtack",
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z"]
}, mK = hK, vK = {
  prefix: "fas",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"]
}, yK = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, pM = {
  home: bV,
  inbox: OV,
  tasks: NV,
  task: Kw,
  emails: gV,
  accounts: nK,
  files: nV,
  billing: __,
  entity: YV,
  help: tV,
  sms: ZV,
  edoc: k_,
  bulkActions: K_,
  contacts: l_,
  contact: W_,
  notifications: TV,
  logout: a_,
  taxAutomation: Xw,
  paperclip: fV,
  file: LV,
  fileLines: n_,
  fileImage: eV,
  camera: AV,
  microphone: P_,
  sparkles: y_,
  sparklesSolid: cK,
  wandSparkles: Xw,
  pause: U_,
  filePdf: uV,
  fileZip: F_,
  taxDoc: M_,
  signatureReq: Q_,
  folder: S_,
  folderOpen: O_,
  folderSolid: gK,
  download: vV,
  upload: xV,
  uploadFile: D_,
  downloadFile: SV,
  import: x_,
  show: Yw,
  hide: h_,
  calendar: r_,
  calendarDay: QV,
  calendarExclaim: m_,
  addUser: $V,
  clear: qw,
  close: qw,
  createSms: L_,
  sort: Y_,
  sortUp: iV,
  sortDown: i_,
  chevronLeft: WV,
  chevronRight: _V,
  chevronUp: v_,
  chevronDown: kV,
  caretUp: fK,
  caretDown: AK,
  edit: p_,
  pencil: u_,
  copy: PV,
  archive: f_,
  unarchive: H_,
  ellipsis: MV,
  ellipsisVertical: mV,
  delete: sV,
  deleteSolid: CK,
  info: sK,
  infoCircle: CV,
  success: $w,
  warning: yK,
  error: lK,
  errorOutline: C_,
  retry: wV,
  attachFile: Zw,
  attachment: Zw,
  menu: Vw,
  arrowUp: jV,
  arrowRight: G_,
  arrowDown: RV,
  arrowLeft: lV,
  arrowLeftToLine: w_,
  arrowRightToLine: JV,
  angleUp: UV,
  angleRight: b_,
  angleDown: EV,
  angleLeft: tK,
  circle: $_,
  circleArrowUp: R_,
  circleArrowDown: B_,
  check: eK,
  circleCheck: Kw,
  circleCheckSolid: $w,
  circleX: iK,
  circlePlus: XV,
  videoSlash: pK,
  preview: Yw,
  lock: A_,
  lockOpen: Z_,
  danger: s_,
  image: N_,
  search: DV,
  checkbox: uK,
  checkboxBlank: J_,
  sliders: hV,
  add: Gw,
  plus: Gw,
  plusSquare: j_,
  plusDuotone: e_,
  remove: Qw,
  minus: Qw,
  pushpin: KV,
  pushpinFilled: mK,
  phone: oV,
  comment: cV,
  fingerprint: o_,
  wifiSlash: q_,
  bank: oK,
  recurringCharge: Jw,
  messageLines: z_,
  print: aK,
  pen: dK,
  penOutline: rV,
  reassignTask: IV,
  share: FV,
  externalLink: X_,
  admin: IK,
  send: rK,
  user: E_,
  userGroup: T_,
  arrowsRotate: Jw,
  cloud: d_,
  cloudArrowUp: V_,
  cloudCheck: BV,
  cloudX: c_,
  gripVertical: Vw,
  arrowRotateRightDuotone: $W,
  template: _w,
  toc: _w,
  apple: GW,
  linux: qW,
  microsoft: QW,
  android: ZW,
  chrome: XW,
  desktop: GV,
  mobile: yV,
  message: t_,
  clockRotateLeft: vK,
  spinner: aV,
  gear: pV
}, bK = (e) => e ? `fa-rotate-${e}` : "", wK = (e) => e ? `fa-flip-${e}` : "", xK = (e) => {
  switch (e) {
    case void 0:
      return "";
    case "spin-reverse":
      return "fa-spin fa-spin-reverse";
    case "pulse-reverse":
      return "fa-spin-pulse fa-spin-reverse";
    default:
      return `fa-${e}`;
  }
}, SK = (e) => `${bK(e == null ? void 0 : e.rotation)}${wK(
  e == null ? void 0 : e.flip
)}${xK(e == null ? void 0 : e.animate)}`, Ne1 = {
  ...ym,
  ...pM
}, EK = (e) => !!ym[e], De = ja(
  ({
    icon: e,
    rotation: n,
    flip: i,
    animate: a,
    iconProps: s = {},
    ...g
  }, c) => {
    const I = `${g.className} ${SK({
      rotation: n,
      flip: i,
      animate: a
    })}`;
    return /* @__PURE__ */ v.jsx(
      BA,
      {
        "data-testid": `${e}Icon`,
        ...g,
        fontSize: g.fontSize ?? "inherit",
        className: I,
        ref: c,
        children: EK(e) ? /* @__PURE__ */ v.jsx(YW, { icon: e }) : /* @__PURE__ */ v.jsx(vm, { ...s, icon: pM[e] })
      }
    );
  }
);
De.displayName = "Icon";
const MK = "@media (max-height: 500px)", TK = ({
  title: e,
  children: n,
  iconClose: i = !0,
  escClose: a = !1,
  bgClose: s = !1,
  onClose: g,
  onSubmit: c,
  submitLabel: I = "Submit",
  submitBtnProps: h = {},
  onCancel: m,
  cancelLabel: w = "Cancel",
  cancelBtnProps: x = {},
  actions: M,
  contentProps: O = {},
  actionsProps: k = {},
  type: z,
  options: N,
  layout: U,
  shortViewportFullScreen: Q = !1,
  outerPaperOnly: _ = !1,
  ...X
}) => {
  const B = m2(
    (Y, V) => {
      V === "backdropClick" && s && g(), V === "escapeKeyDown" && a && g();
    },
    [g, a, s]
  ), Z = {
    info: /* @__PURE__ */ v.jsx(De, { icon: "info", color: "info" }),
    warning: /* @__PURE__ */ v.jsx(De, { icon: "warning", color: "warning" }),
    success: /* @__PURE__ */ v.jsx(De, { icon: "success", color: "success" })
  };
  return /* @__PURE__ */ v.jsxs(
    hl,
    {
      maxWidth: "xs",
      sx: {
        [`.${_ ? Fj.paper : Bj.root}`]: {
          padding: 2,
          ...U === "documentPreview" && {
            width: "calc(100% - 64px)",
            height: "calc(100% - 64px)",
            maxWidth: "none",
            maxHeight: "none",
            display: "flex",
            flexDirection: "column",
            ...Q && {
              [MK]: {
                margin: 0,
                padding: 0,
                marginLeft: "var(--safe-area-inset-left, env(safe-area-inset-left, 0px))",
                marginRight: "var(--safe-area-inset-right, env(safe-area-inset-right, 0px))",
                marginTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
                marginBottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))",
                width: "calc(100% - var(--safe-area-inset-left, env(safe-area-inset-left, 0px)) - var(--safe-area-inset-right, env(safe-area-inset-right, 0px)))",
                height: "calc(100% - var(--safe-area-inset-top, env(safe-area-inset-top, 0px)) - var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))"
              }
            }
          }
        }
      },
      ...X,
      onClose: B,
      children: [
        /* @__PURE__ */ v.jsx(
          HA,
          {
            sx: {
              [`&.${Hj.root}.${IS.root}`]: {
                padding: 1
              }
            },
            children: /* @__PURE__ */ v.jsxs(
              qe,
              {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                sx: { minWidth: 0 },
                children: [
                  /* @__PURE__ */ v.jsxs(
                    qe,
                    {
                      direction: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      spacing: 1,
                      sx: {
                        minWidth: 0,
                        flex: 1,
                        overflow: "hidden"
                      },
                      children: [
                        z && Z[z],
                        /* @__PURE__ */ v.jsx(
                          le,
                          {
                            component: "span",
                            variant: "h5",
                            sx: {
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            },
                            children: e
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ v.jsxs(
                    qe,
                    {
                      direction: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 1,
                      sx: { flexShrink: 0 },
                      children: [
                        N,
                        i && /* @__PURE__ */ v.jsx(
                          xc,
                          {
                            "aria-label": "close",
                            onClick: g,
                            sx: { padding: 1, margin: -1 },
                            children: /* @__PURE__ */ v.jsx(De, { icon: "close" })
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsx(
          T0,
          {
            sx: {
              [`&.${Uj.root}`]: {
                padding: 1,
                paddingBottom: 2,
                ...U === "documentPreview" && {
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  flex: "1 1 auto",
                  minHeight: 0,
                  overflow: "hidden"
                }
              }
            },
            ...O,
            children: n
          }
        ),
        (M || m || c) && /* @__PURE__ */ v.jsxs(Nc, { ...k, children: [
          M,
          m && /* @__PURE__ */ v.jsx(
            j2,
            {
              variant: "outlined",
              color: "error",
              ...x,
              onClick: m,
              fullWidth: !0,
              children: w
            }
          ),
          c && /* @__PURE__ */ v.jsx(
            j2,
            {
              variant: "contained",
              color: "primary",
              ...h,
              onClick: c,
              fullWidth: !0,
              children: I
            }
          )
        ] })
      ]
    }
  );
}, hM = vz(void 0), Pe1 = () => yz(hM);
function Fe1({
  children: e,
  onClose: n,
  ...i
}) {
  return /* @__PURE__ */ v.jsx(
    TK,
    {
      ...i,
      onClose: n,
      layout: "documentPreview",
      outerPaperOnly: !0,
      fullScreen: !1,
      maxWidth: !1,
      scroll: "paper",
      escClose: !0,
      bgClose: !0,
      children: /* @__PURE__ */ v.jsx(hM.Provider, { value: n, children: e })
    }
  );
}
process.env.NODE_ENV !== "production" && (E.node, E.object.isRequired);
function jr(e) {
  return yF(e);
}
var wh = { exports: {} }, h3 = {}, VC = { exports: {} }, c7 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ex;
function LK() {
  return ex || (ex = 1, function(e) {
    function n(c1, b1) {
      var t1 = c1.length;
      c1.push(b1);
      e: for (; 0 < t1; ) {
        var C1 = t1 - 1 >>> 1, w1 = c1[C1];
        if (0 < s(w1, b1)) c1[C1] = b1, c1[t1] = w1, t1 = C1;
        else break e;
      }
    }
    function i(c1) {
      return c1.length === 0 ? null : c1[0];
    }
    function a(c1) {
      if (c1.length === 0) return null;
      var b1 = c1[0], t1 = c1.pop();
      if (t1 !== b1) {
        c1[0] = t1;
        e: for (var C1 = 0, w1 = c1.length, E1 = w1 >>> 1; C1 < E1; ) {
          var V1 = 2 * (C1 + 1) - 1, K1 = c1[V1], B1 = V1 + 1, te = c1[B1];
          if (0 > s(K1, t1)) B1 < w1 && 0 > s(te, K1) ? (c1[C1] = te, c1[B1] = t1, C1 = B1) : (c1[C1] = K1, c1[V1] = t1, C1 = V1);
          else if (B1 < w1 && 0 > s(te, t1)) c1[C1] = te, c1[B1] = t1, C1 = B1;
          else break e;
        }
      }
      return b1;
    }
    function s(c1, b1) {
      var t1 = c1.sortIndex - b1.sortIndex;
      return t1 !== 0 ? t1 : c1.id - b1.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var g = performance;
      e.unstable_now = function() {
        return g.now();
      };
    } else {
      var c = Date, I = c.now();
      e.unstable_now = function() {
        return c.now() - I;
      };
    }
    var h = [], m = [], w = 1, x = null, M = 3, O = !1, k = !1, z = !1, N = typeof setTimeout == "function" ? setTimeout : null, U = typeof clearTimeout == "function" ? clearTimeout : null, Q = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function _(c1) {
      for (var b1 = i(m); b1 !== null; ) {
        if (b1.callback === null) a(m);
        else if (b1.startTime <= c1) a(m), b1.sortIndex = b1.expirationTime, n(h, b1);
        else break;
        b1 = i(m);
      }
    }
    function X(c1) {
      if (z = !1, _(c1), !k) if (i(h) !== null) k = !0, h1(B);
      else {
        var b1 = i(m);
        b1 !== null && L1(X, b1.startTime - c1);
      }
    }
    function B(c1, b1) {
      k = !1, z && (z = !1, U(V), V = -1), O = !0;
      var t1 = M;
      try {
        for (_(b1), x = i(h); x !== null && (!(x.expirationTime > b1) || c1 && !f1()); ) {
          var C1 = x.callback;
          if (typeof C1 == "function") {
            x.callback = null, M = x.priorityLevel;
            var w1 = C1(x.expirationTime <= b1);
            b1 = e.unstable_now(), typeof w1 == "function" ? x.callback = w1 : x === i(h) && a(h), _(b1);
          } else a(h);
          x = i(h);
        }
        if (x !== null) var E1 = !0;
        else {
          var V1 = i(m);
          V1 !== null && L1(X, V1.startTime - b1), E1 = !1;
        }
        return E1;
      } finally {
        x = null, M = t1, O = !1;
      }
    }
    var Z = !1, Y = null, V = -1, J = 5, e1 = -1;
    function f1() {
      return !(e.unstable_now() - e1 < J);
    }
    function v1() {
      if (Y !== null) {
        var c1 = e.unstable_now();
        e1 = c1;
        var b1 = !0;
        try {
          b1 = Y(!0, c1);
        } finally {
          b1 ? a1() : (Z = !1, Y = null);
        }
      } else Z = !1;
    }
    var a1;
    if (typeof Q == "function") a1 = function() {
      Q(v1);
    };
    else if (typeof MessageChannel < "u") {
      var d1 = new MessageChannel(), S1 = d1.port2;
      d1.port1.onmessage = v1, a1 = function() {
        S1.postMessage(null);
      };
    } else a1 = function() {
      N(v1, 0);
    };
    function h1(c1) {
      Y = c1, Z || (Z = !0, a1());
    }
    function L1(c1, b1) {
      V = N(function() {
        c1(e.unstable_now());
      }, b1);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(c1) {
      c1.callback = null;
    }, e.unstable_continueExecution = function() {
      k || O || (k = !0, h1(B));
    }, e.unstable_forceFrameRate = function(c1) {
      0 > c1 || 125 < c1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : J = 0 < c1 ? Math.floor(1e3 / c1) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return M;
    }, e.unstable_getFirstCallbackNode = function() {
      return i(h);
    }, e.unstable_next = function(c1) {
      switch (M) {
        case 1:
        case 2:
        case 3:
          var b1 = 3;
          break;
        default:
          b1 = M;
      }
      var t1 = M;
      M = b1;
      try {
        return c1();
      } finally {
        M = t1;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(c1, b1) {
      switch (c1) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          c1 = 3;
      }
      var t1 = M;
      M = c1;
      try {
        return b1();
      } finally {
        M = t1;
      }
    }, e.unstable_scheduleCallback = function(c1, b1, t1) {
      var C1 = e.unstable_now();
      switch (typeof t1 == "object" && t1 !== null ? (t1 = t1.delay, t1 = typeof t1 == "number" && 0 < t1 ? C1 + t1 : C1) : t1 = C1, c1) {
        case 1:
          var w1 = -1;
          break;
        case 2:
          w1 = 250;
          break;
        case 5:
          w1 = 1073741823;
          break;
        case 4:
          w1 = 1e4;
          break;
        default:
          w1 = 5e3;
      }
      return w1 = t1 + w1, c1 = { id: w++, callback: b1, priorityLevel: c1, startTime: t1, expirationTime: w1, sortIndex: -1 }, t1 > C1 ? (c1.sortIndex = t1, n(m, c1), i(h) === null && c1 === i(m) && (z ? (U(V), V = -1) : z = !0, L1(X, t1 - C1))) : (c1.sortIndex = w1, n(h, c1), k || O || (k = !0, h1(B))), c1;
    }, e.unstable_shouldYield = f1, e.unstable_wrapCallback = function(c1) {
      var b1 = M;
      return function() {
        var t1 = M;
        M = b1;
        try {
          return c1.apply(this, arguments);
        } finally {
          M = t1;
        }
      };
    };
  }(c7)), c7;
}
var g7 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tx;
function RK() {
  return tx || (tx = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var n = !1, i = !1, a = 5;
      function s(ee, ge) {
        var _e = ee.length;
        ee.push(ge), I(ee, ge, _e);
      }
      function g(ee) {
        return ee.length === 0 ? null : ee[0];
      }
      function c(ee) {
        if (ee.length === 0)
          return null;
        var ge = ee[0], _e = ee.pop();
        return _e !== ge && (ee[0] = _e, h(ee, _e, 0)), ge;
      }
      function I(ee, ge, _e) {
        for (var wt = _e; wt > 0; ) {
          var Yt = wt - 1 >>> 1, An = ee[Yt];
          if (m(An, ge) > 0)
            ee[Yt] = ge, ee[wt] = An, wt = Yt;
          else
            return;
        }
      }
      function h(ee, ge, _e) {
        for (var wt = _e, Yt = ee.length, An = Yt >>> 1; wt < An; ) {
          var sn = (wt + 1) * 2 - 1, Hn = ee[sn], Ht = sn + 1, b2 = ee[Ht];
          if (m(Hn, ge) < 0)
            Ht < Yt && m(b2, Hn) < 0 ? (ee[wt] = b2, ee[Ht] = ge, wt = Ht) : (ee[wt] = Hn, ee[sn] = ge, wt = sn);
          else if (Ht < Yt && m(b2, ge) < 0)
            ee[wt] = b2, ee[Ht] = ge, wt = Ht;
          else
            return;
        }
      }
      function m(ee, ge) {
        var _e = ee.sortIndex - ge.sortIndex;
        return _e !== 0 ? _e : ee.id - ge.id;
      }
      var w = 1, x = 2, M = 3, O = 4, k = 5;
      function z(ee, ge) {
      }
      var N = typeof performance == "object" && typeof performance.now == "function";
      if (N) {
        var U = performance;
        e.unstable_now = function() {
          return U.now();
        };
      } else {
        var Q = Date, _ = Q.now();
        e.unstable_now = function() {
          return Q.now() - _;
        };
      }
      var X = 1073741823, B = -1, Z = 250, Y = 5e3, V = 1e4, J = X, e1 = [], f1 = [], v1 = 1, a1 = null, d1 = M, S1 = !1, h1 = !1, L1 = !1, c1 = typeof setTimeout == "function" ? setTimeout : null, b1 = typeof clearTimeout == "function" ? clearTimeout : null, t1 = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function C1(ee) {
        for (var ge = g(f1); ge !== null; ) {
          if (ge.callback === null)
            c(f1);
          else if (ge.startTime <= ee)
            c(f1), ge.sortIndex = ge.expirationTime, s(e1, ge);
          else
            return;
          ge = g(f1);
        }
      }
      function w1(ee) {
        if (L1 = !1, C1(ee), !h1)
          if (g(e1) !== null)
            h1 = !0, pt(E1);
          else {
            var ge = g(f1);
            ge !== null && rt(w1, ge.startTime - ee);
          }
      }
      function E1(ee, ge) {
        h1 = !1, L1 && (L1 = !1, Jt()), S1 = !0;
        var _e = d1;
        try {
          var wt;
          if (!i) return V1(ee, ge);
        } finally {
          a1 = null, d1 = _e, S1 = !1;
        }
      }
      function V1(ee, ge) {
        var _e = ge;
        for (C1(_e), a1 = g(e1); a1 !== null && !n && !(a1.expirationTime > _e && (!ee || me())); ) {
          var wt = a1.callback;
          if (typeof wt == "function") {
            a1.callback = null, d1 = a1.priorityLevel;
            var Yt = a1.expirationTime <= _e, An = wt(Yt);
            _e = e.unstable_now(), typeof An == "function" ? a1.callback = An : a1 === g(e1) && c(e1), C1(_e);
          } else
            c(e1);
          a1 = g(e1);
        }
        if (a1 !== null)
          return !0;
        var sn = g(f1);
        return sn !== null && rt(w1, sn.startTime - _e), !1;
      }
      function K1(ee, ge) {
        switch (ee) {
          case w:
          case x:
          case M:
          case O:
          case k:
            break;
          default:
            ee = M;
        }
        var _e = d1;
        d1 = ee;
        try {
          return ge();
        } finally {
          d1 = _e;
        }
      }
      function B1(ee) {
        var ge;
        switch (d1) {
          case w:
          case x:
          case M:
            ge = M;
            break;
          default:
            ge = d1;
            break;
        }
        var _e = d1;
        d1 = ge;
        try {
          return ee();
        } finally {
          d1 = _e;
        }
      }
      function te(ee) {
        var ge = d1;
        return function() {
          var _e = d1;
          d1 = ge;
          try {
            return ee.apply(this, arguments);
          } finally {
            d1 = _e;
          }
        };
      }
      function R1(ee, ge, _e) {
        var wt = e.unstable_now(), Yt;
        if (typeof _e == "object" && _e !== null) {
          var An = _e.delay;
          typeof An == "number" && An > 0 ? Yt = wt + An : Yt = wt;
        } else
          Yt = wt;
        var sn;
        switch (ee) {
          case w:
            sn = B;
            break;
          case x:
            sn = Z;
            break;
          case k:
            sn = J;
            break;
          case O:
            sn = V;
            break;
          case M:
          default:
            sn = Y;
            break;
        }
        var Hn = Yt + sn, Ht = {
          id: v1++,
          callback: ge,
          priorityLevel: ee,
          startTime: Yt,
          expirationTime: Hn,
          sortIndex: -1
        };
        return Yt > wt ? (Ht.sortIndex = Yt, s(f1, Ht), g(e1) === null && Ht === g(f1) && (L1 ? Jt() : L1 = !0, rt(w1, Yt - wt))) : (Ht.sortIndex = Hn, s(e1, Ht), !h1 && !S1 && (h1 = !0, pt(E1))), Ht;
      }
      function x1() {
      }
      function J1() {
        !h1 && !S1 && (h1 = !0, pt(E1));
      }
      function X1() {
        return g(e1);
      }
      function D1(ee) {
        ee.callback = null;
      }
      function $1() {
        return d1;
      }
      var y1 = !1, ie = null, ae = -1, H1 = a, Y1 = -1;
      function me() {
        var ee = e.unstable_now() - Y1;
        return !(ee < H1);
      }
      function ut() {
      }
      function Qe(ee) {
        if (ee < 0 || ee > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        ee > 0 ? H1 = Math.floor(1e3 / ee) : H1 = a;
      }
      var Ae = function() {
        if (ie !== null) {
          var ee = e.unstable_now();
          Y1 = ee;
          var ge = !0, _e = !0;
          try {
            _e = ie(ge, ee);
          } finally {
            _e ? Bt() : (y1 = !1, ie = null);
          }
        } else
          y1 = !1;
      }, Bt;
      if (typeof t1 == "function")
        Bt = function() {
          t1(Ae);
        };
      else if (typeof MessageChannel < "u") {
        var ke = new MessageChannel(), bt = ke.port2;
        ke.port1.onmessage = Ae, Bt = function() {
          bt.postMessage(null);
        };
      } else
        Bt = function() {
          c1(Ae, 0);
        };
      function pt(ee) {
        ie = ee, y1 || (y1 = !0, Bt());
      }
      function rt(ee, ge) {
        ae = c1(function() {
          ee(e.unstable_now());
        }, ge);
      }
      function Jt() {
        b1(ae), ae = -1;
      }
      var Pe = ut, yn = null;
      e.unstable_IdlePriority = k, e.unstable_ImmediatePriority = w, e.unstable_LowPriority = O, e.unstable_NormalPriority = M, e.unstable_Profiling = yn, e.unstable_UserBlockingPriority = x, e.unstable_cancelCallback = D1, e.unstable_continueExecution = J1, e.unstable_forceFrameRate = Qe, e.unstable_getCurrentPriorityLevel = $1, e.unstable_getFirstCallbackNode = X1, e.unstable_next = B1, e.unstable_pauseExecution = x1, e.unstable_requestPaint = Pe, e.unstable_runWithPriority = K1, e.unstable_scheduleCallback = R1, e.unstable_shouldYield = me, e.unstable_wrapCallback = te, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(g7)), g7;
}
var nx;
function mM() {
  return nx || (nx = 1, process.env.NODE_ENV === "production" ? VC.exports = LK() : VC.exports = RK()), VC.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rx;
function OK() {
  if (rx) return h3;
  rx = 1;
  var e = nn, n = mM();
  function i(o) {
    for (var l = "https://reactjs.org/docs/error-decoder.html?invariant=" + o, d = 1; d < arguments.length; d++) l += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + o + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var a = /* @__PURE__ */ new Set(), s = {};
  function g(o, l) {
    c(o, l), c(o + "Capture", l);
  }
  function c(o, l) {
    for (s[o] = l, o = 0; o < l.length; o++) a.add(l[o]);
  }
  var I = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), h = Object.prototype.hasOwnProperty, m = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, w = {}, x = {};
  function M(o) {
    return h.call(x, o) ? !0 : h.call(w, o) ? !1 : m.test(o) ? x[o] = !0 : (w[o] = !0, !1);
  }
  function O(o, l, d, A) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof l) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return A ? !1 : d !== null ? !d.acceptsBooleans : (o = o.toLowerCase().slice(0, 5), o !== "data-" && o !== "aria-");
      default:
        return !1;
    }
  }
  function k(o, l, d, A) {
    if (l === null || typeof l > "u" || O(o, l, d, A)) return !0;
    if (A) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !l;
      case 4:
        return l === !1;
      case 5:
        return isNaN(l);
      case 6:
        return isNaN(l) || 1 > l;
    }
    return !1;
  }
  function z(o, l, d, A, y, S, j) {
    this.acceptsBooleans = l === 2 || l === 3 || l === 4, this.attributeName = A, this.attributeNamespace = y, this.mustUseProperty = d, this.propertyName = o, this.type = l, this.sanitizeURL = S, this.removeEmptyString = j;
  }
  var N = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(o) {
    N[o] = new z(o, 0, !1, o, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(o) {
    var l = o[0];
    N[l] = new z(l, 1, !1, o[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(o) {
    N[o] = new z(o, 2, !1, o.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(o) {
    N[o] = new z(o, 2, !1, o, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(o) {
    N[o] = new z(o, 3, !1, o.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(o) {
    N[o] = new z(o, 3, !0, o, null, !1, !1);
  }), ["capture", "download"].forEach(function(o) {
    N[o] = new z(o, 4, !1, o, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(o) {
    N[o] = new z(o, 6, !1, o, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(o) {
    N[o] = new z(o, 5, !1, o.toLowerCase(), null, !1, !1);
  });
  var U = /[\-:]([a-z])/g;
  function Q(o) {
    return o[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(o) {
    var l = o.replace(
      U,
      Q
    );
    N[l] = new z(l, 1, !1, o, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(o) {
    var l = o.replace(U, Q);
    N[l] = new z(l, 1, !1, o, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(o) {
    var l = o.replace(U, Q);
    N[l] = new z(l, 1, !1, o, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(o) {
    N[o] = new z(o, 1, !1, o.toLowerCase(), null, !1, !1);
  }), N.xlinkHref = new z("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(o) {
    N[o] = new z(o, 1, !1, o.toLowerCase(), null, !0, !0);
  });
  function _(o, l, d, A) {
    var y = N.hasOwnProperty(l) ? N[l] : null;
    (y !== null ? y.type !== 0 : A || !(2 < l.length) || l[0] !== "o" && l[0] !== "O" || l[1] !== "n" && l[1] !== "N") && (k(l, d, y, A) && (d = null), A || y === null ? M(l) && (d === null ? o.removeAttribute(l) : o.setAttribute(l, "" + d)) : y.mustUseProperty ? o[y.propertyName] = d === null ? y.type === 3 ? !1 : "" : d : (l = y.attributeName, A = y.attributeNamespace, d === null ? o.removeAttribute(l) : (y = y.type, d = y === 3 || y === 4 && d === !0 ? "" : "" + d, A ? o.setAttributeNS(A, l, d) : o.setAttribute(l, d))));
  }
  var X = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, B = Symbol.for("react.element"), Z = Symbol.for("react.portal"), Y = Symbol.for("react.fragment"), V = Symbol.for("react.strict_mode"), J = Symbol.for("react.profiler"), e1 = Symbol.for("react.provider"), f1 = Symbol.for("react.context"), v1 = Symbol.for("react.forward_ref"), a1 = Symbol.for("react.suspense"), d1 = Symbol.for("react.suspense_list"), S1 = Symbol.for("react.memo"), h1 = Symbol.for("react.lazy"), L1 = Symbol.for("react.offscreen"), c1 = Symbol.iterator;
  function b1(o) {
    return o === null || typeof o != "object" ? null : (o = c1 && o[c1] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var t1 = Object.assign, C1;
  function w1(o) {
    if (C1 === void 0) try {
      throw Error();
    } catch (d) {
      var l = d.stack.trim().match(/\n( *(at )?)/);
      C1 = l && l[1] || "";
    }
    return `
` + C1 + o;
  }
  var E1 = !1;
  function V1(o, l) {
    if (!o || E1) return "";
    E1 = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (l) if (l = function() {
        throw Error();
      }, Object.defineProperty(l.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(l, []);
        } catch (p1) {
          var A = p1;
        }
        Reflect.construct(o, [], l);
      } else {
        try {
          l.call();
        } catch (p1) {
          A = p1;
        }
        o.call(l.prototype);
      }
      else {
        try {
          throw Error();
        } catch (p1) {
          A = p1;
        }
        o();
      }
    } catch (p1) {
      if (p1 && A && typeof p1.stack == "string") {
        for (var y = p1.stack.split(`
`), S = A.stack.split(`
`), j = y.length - 1, K = S.length - 1; 1 <= j && 0 <= K && y[j] !== S[K]; ) K--;
        for (; 1 <= j && 0 <= K; j--, K--) if (y[j] !== S[K]) {
          if (j !== 1 || K !== 1)
            do
              if (j--, K--, 0 > K || y[j] !== S[K]) {
                var q = `
` + y[j].replace(" at new ", " at ");
                return o.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", o.displayName)), q;
              }
            while (1 <= j && 0 <= K);
          break;
        }
      }
    } finally {
      E1 = !1, Error.prepareStackTrace = d;
    }
    return (o = o ? o.displayName || o.name : "") ? w1(o) : "";
  }
  function K1(o) {
    switch (o.tag) {
      case 5:
        return w1(o.type);
      case 16:
        return w1("Lazy");
      case 13:
        return w1("Suspense");
      case 19:
        return w1("SuspenseList");
      case 0:
      case 2:
      case 15:
        return o = V1(o.type, !1), o;
      case 11:
        return o = V1(o.type.render, !1), o;
      case 1:
        return o = V1(o.type, !0), o;
      default:
        return "";
    }
  }
  function B1(o) {
    if (o == null) return null;
    if (typeof o == "function") return o.displayName || o.name || null;
    if (typeof o == "string") return o;
    switch (o) {
      case Y:
        return "Fragment";
      case Z:
        return "Portal";
      case J:
        return "Profiler";
      case V:
        return "StrictMode";
      case a1:
        return "Suspense";
      case d1:
        return "SuspenseList";
    }
    if (typeof o == "object") switch (o.$$typeof) {
      case f1:
        return (o.displayName || "Context") + ".Consumer";
      case e1:
        return (o._context.displayName || "Context") + ".Provider";
      case v1:
        var l = o.render;
        return o = o.displayName, o || (o = l.displayName || l.name || "", o = o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef"), o;
      case S1:
        return l = o.displayName || null, l !== null ? l : B1(o.type) || "Memo";
      case h1:
        l = o._payload, o = o._init;
        try {
          return B1(o(l));
        } catch {
        }
    }
    return null;
  }
  function te(o) {
    var l = o.type;
    switch (o.tag) {
      case 24:
        return "Cache";
      case 9:
        return (l.displayName || "Context") + ".Consumer";
      case 10:
        return (l._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return o = l.render, o = o.displayName || o.name || "", l.displayName || (o !== "" ? "ForwardRef(" + o + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return l;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return B1(l);
      case 8:
        return l === V ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof l == "function") return l.displayName || l.name || null;
        if (typeof l == "string") return l;
    }
    return null;
  }
  function R1(o) {
    switch (typeof o) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return o;
      case "object":
        return o;
      default:
        return "";
    }
  }
  function x1(o) {
    var l = o.type;
    return (o = o.nodeName) && o.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
  }
  function J1(o) {
    var l = x1(o) ? "checked" : "value", d = Object.getOwnPropertyDescriptor(o.constructor.prototype, l), A = "" + o[l];
    if (!o.hasOwnProperty(l) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var y = d.get, S = d.set;
      return Object.defineProperty(o, l, { configurable: !0, get: function() {
        return y.call(this);
      }, set: function(j) {
        A = "" + j, S.call(this, j);
      } }), Object.defineProperty(o, l, { enumerable: d.enumerable }), { getValue: function() {
        return A;
      }, setValue: function(j) {
        A = "" + j;
      }, stopTracking: function() {
        o._valueTracker = null, delete o[l];
      } };
    }
  }
  function X1(o) {
    o._valueTracker || (o._valueTracker = J1(o));
  }
  function D1(o) {
    if (!o) return !1;
    var l = o._valueTracker;
    if (!l) return !0;
    var d = l.getValue(), A = "";
    return o && (A = x1(o) ? o.checked ? "true" : "false" : o.value), o = A, o !== d ? (l.setValue(o), !0) : !1;
  }
  function $1(o) {
    if (o = o || (typeof document < "u" ? document : void 0), typeof o > "u") return null;
    try {
      return o.activeElement || o.body;
    } catch {
      return o.body;
    }
  }
  function y1(o, l) {
    var d = l.checked;
    return t1({}, l, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: d ?? o._wrapperState.initialChecked });
  }
  function ie(o, l) {
    var d = l.defaultValue == null ? "" : l.defaultValue, A = l.checked != null ? l.checked : l.defaultChecked;
    d = R1(l.value != null ? l.value : d), o._wrapperState = { initialChecked: A, initialValue: d, controlled: l.type === "checkbox" || l.type === "radio" ? l.checked != null : l.value != null };
  }
  function ae(o, l) {
    l = l.checked, l != null && _(o, "checked", l, !1);
  }
  function H1(o, l) {
    ae(o, l);
    var d = R1(l.value), A = l.type;
    if (d != null) A === "number" ? (d === 0 && o.value === "" || o.value != d) && (o.value = "" + d) : o.value !== "" + d && (o.value = "" + d);
    else if (A === "submit" || A === "reset") {
      o.removeAttribute("value");
      return;
    }
    l.hasOwnProperty("value") ? me(o, l.type, d) : l.hasOwnProperty("defaultValue") && me(o, l.type, R1(l.defaultValue)), l.checked == null && l.defaultChecked != null && (o.defaultChecked = !!l.defaultChecked);
  }
  function Y1(o, l, d) {
    if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
      var A = l.type;
      if (!(A !== "submit" && A !== "reset" || l.value !== void 0 && l.value !== null)) return;
      l = "" + o._wrapperState.initialValue, d || l === o.value || (o.value = l), o.defaultValue = l;
    }
    d = o.name, d !== "" && (o.name = ""), o.defaultChecked = !!o._wrapperState.initialChecked, d !== "" && (o.name = d);
  }
  function me(o, l, d) {
    (l !== "number" || $1(o.ownerDocument) !== o) && (d == null ? o.defaultValue = "" + o._wrapperState.initialValue : o.defaultValue !== "" + d && (o.defaultValue = "" + d));
  }
  var ut = Array.isArray;
  function Qe(o, l, d, A) {
    if (o = o.options, l) {
      l = {};
      for (var y = 0; y < d.length; y++) l["$" + d[y]] = !0;
      for (d = 0; d < o.length; d++) y = l.hasOwnProperty("$" + o[d].value), o[d].selected !== y && (o[d].selected = y), y && A && (o[d].defaultSelected = !0);
    } else {
      for (d = "" + R1(d), l = null, y = 0; y < o.length; y++) {
        if (o[y].value === d) {
          o[y].selected = !0, A && (o[y].defaultSelected = !0);
          return;
        }
        l !== null || o[y].disabled || (l = o[y]);
      }
      l !== null && (l.selected = !0);
    }
  }
  function Ae(o, l) {
    if (l.dangerouslySetInnerHTML != null) throw Error(i(91));
    return t1({}, l, { value: void 0, defaultValue: void 0, children: "" + o._wrapperState.initialValue });
  }
  function Bt(o, l) {
    var d = l.value;
    if (d == null) {
      if (d = l.children, l = l.defaultValue, d != null) {
        if (l != null) throw Error(i(92));
        if (ut(d)) {
          if (1 < d.length) throw Error(i(93));
          d = d[0];
        }
        l = d;
      }
      l == null && (l = ""), d = l;
    }
    o._wrapperState = { initialValue: R1(d) };
  }
  function ke(o, l) {
    var d = R1(l.value), A = R1(l.defaultValue);
    d != null && (d = "" + d, d !== o.value && (o.value = d), l.defaultValue == null && o.defaultValue !== d && (o.defaultValue = d)), A != null && (o.defaultValue = "" + A);
  }
  function bt(o) {
    var l = o.textContent;
    l === o._wrapperState.initialValue && l !== "" && l !== null && (o.value = l);
  }
  function pt(o) {
    switch (o) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function rt(o, l) {
    return o == null || o === "http://www.w3.org/1999/xhtml" ? pt(l) : o === "http://www.w3.org/2000/svg" && l === "foreignObject" ? "http://www.w3.org/1999/xhtml" : o;
  }
  var Jt, Pe = function(o) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, d, A, y) {
      MSApp.execUnsafeLocalFunction(function() {
        return o(l, d, A, y);
      });
    } : o;
  }(function(o, l) {
    if (o.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in o) o.innerHTML = l;
    else {
      for (Jt = Jt || document.createElement("div"), Jt.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>", l = Jt.firstChild; o.firstChild; ) o.removeChild(o.firstChild);
      for (; l.firstChild; ) o.appendChild(l.firstChild);
    }
  });
  function yn(o, l) {
    if (l) {
      var d = o.firstChild;
      if (d && d === o.lastChild && d.nodeType === 3) {
        d.nodeValue = l;
        return;
      }
    }
    o.textContent = l;
  }
  var ee = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, ge = ["Webkit", "ms", "Moz", "O"];
  Object.keys(ee).forEach(function(o) {
    ge.forEach(function(l) {
      l = l + o.charAt(0).toUpperCase() + o.substring(1), ee[l] = ee[o];
    });
  });
  function _e(o, l, d) {
    return l == null || typeof l == "boolean" || l === "" ? "" : d || typeof l != "number" || l === 0 || ee.hasOwnProperty(o) && ee[o] ? ("" + l).trim() : l + "px";
  }
  function wt(o, l) {
    o = o.style;
    for (var d in l) if (l.hasOwnProperty(d)) {
      var A = d.indexOf("--") === 0, y = _e(d, l[d], A);
      d === "float" && (d = "cssFloat"), A ? o.setProperty(d, y) : o[d] = y;
    }
  }
  var Yt = t1({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function An(o, l) {
    if (l) {
      if (Yt[o] && (l.children != null || l.dangerouslySetInnerHTML != null)) throw Error(i(137, o));
      if (l.dangerouslySetInnerHTML != null) {
        if (l.children != null) throw Error(i(60));
        if (typeof l.dangerouslySetInnerHTML != "object" || !("__html" in l.dangerouslySetInnerHTML)) throw Error(i(61));
      }
      if (l.style != null && typeof l.style != "object") throw Error(i(62));
    }
  }
  function sn(o, l) {
    if (o.indexOf("-") === -1) return typeof l.is == "string";
    switch (o) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Hn = null;
  function Ht(o) {
    return o = o.target || o.srcElement || window, o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === 3 ? o.parentNode : o;
  }
  var b2 = null, Ut = null, Qt = null;
  function N3(o) {
    if (o = Is(o)) {
      if (typeof b2 != "function") throw Error(i(280));
      var l = o.stateNode;
      l && (l = Ue(l), b2(o.stateNode, o.type, l));
    }
  }
  function ci(o) {
    Ut ? Qt ? Qt.push(o) : Qt = [o] : Ut = o;
  }
  function Vi() {
    if (Ut) {
      var o = Ut, l = Qt;
      if (Qt = Ut = null, N3(o), l) for (o = 0; o < l.length; o++) N3(l[o]);
    }
  }
  function F0(o, l) {
    return o(l);
  }
  function P3() {
  }
  var F3 = !1;
  function Xn(o, l, d) {
    if (F3) return o(l, d);
    F3 = !0;
    try {
      return F0(o, l, d);
    } finally {
      F3 = !1, (Ut !== null || Qt !== null) && (P3(), Vi());
    }
  }
  function gi(o, l) {
    var d = o.stateNode;
    if (d === null) return null;
    var A = Ue(d);
    if (A === null) return null;
    d = A[l];
    e: switch (l) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (A = !A.disabled) || (o = o.type, A = !(o === "button" || o === "input" || o === "select" || o === "textarea")), o = !A;
        break e;
      default:
        o = !1;
    }
    if (o) return null;
    if (d && typeof d != "function") throw Error(i(231, l, typeof d));
    return d;
  }
  var Ki = !1;
  if (I) try {
    var ln = {};
    Object.defineProperty(ln, "passive", { get: function() {
      Ki = !0;
    } }), window.addEventListener("test", ln, ln), window.removeEventListener("test", ln, ln);
  } catch {
    Ki = !1;
  }
  function Xr(o, l, d, A, y, S, j, K, q) {
    var p1 = Array.prototype.slice.call(arguments, 3);
    try {
      l.apply(d, p1);
    } catch (W1) {
      this.onError(W1);
    }
  }
  var z2 = !1, N2 = null, Gr = !1, fi = null, G = { onError: function(o) {
    z2 = !0, N2 = o;
  } };
  function P1(o, l, d, A, y, S, j, K, q) {
    z2 = !1, N2 = null, Xr.apply(G, arguments);
  }
  function re(o, l, d, A, y, S, j, K, q) {
    if (P1.apply(this, arguments), z2) {
      if (z2) {
        var p1 = N2;
        z2 = !1, N2 = null;
      } else throw Error(i(198));
      Gr || (Gr = !0, fi = p1);
    }
  }
  function be(o) {
    var l = o, d = o;
    if (o.alternate) for (; l.return; ) l = l.return;
    else {
      o = l;
      do
        l = o, l.flags & 4098 && (d = l.return), o = l.return;
      while (o);
    }
    return l.tag === 3 ? d : null;
  }
  function st(o) {
    if (o.tag === 13) {
      var l = o.memoizedState;
      if (l === null && (o = o.alternate, o !== null && (l = o.memoizedState)), l !== null) return l.dehydrated;
    }
    return null;
  }
  function ft(o) {
    if (be(o) !== o) throw Error(i(188));
  }
  function He(o) {
    var l = o.alternate;
    if (!l) {
      if (l = be(o), l === null) throw Error(i(188));
      return l !== o ? null : o;
    }
    for (var d = o, A = l; ; ) {
      var y = d.return;
      if (y === null) break;
      var S = y.alternate;
      if (S === null) {
        if (A = y.return, A !== null) {
          d = A;
          continue;
        }
        break;
      }
      if (y.child === S.child) {
        for (S = y.child; S; ) {
          if (S === d) return ft(y), o;
          if (S === A) return ft(y), l;
          S = S.sibling;
        }
        throw Error(i(188));
      }
      if (d.return !== A.return) d = y, A = S;
      else {
        for (var j = !1, K = y.child; K; ) {
          if (K === d) {
            j = !0, d = y, A = S;
            break;
          }
          if (K === A) {
            j = !0, A = y, d = S;
            break;
          }
          K = K.sibling;
        }
        if (!j) {
          for (K = S.child; K; ) {
            if (K === d) {
              j = !0, d = S, A = y;
              break;
            }
            if (K === A) {
              j = !0, A = S, d = y;
              break;
            }
            K = K.sibling;
          }
          if (!j) throw Error(i(189));
        }
      }
      if (d.alternate !== A) throw Error(i(190));
    }
    if (d.tag !== 3) throw Error(i(188));
    return d.stateNode.current === d ? o : l;
  }
  function nt(o) {
    return o = He(o), o !== null ? Un(o) : null;
  }
  function Un(o) {
    if (o.tag === 5 || o.tag === 6) return o;
    for (o = o.child; o !== null; ) {
      var l = Un(o);
      if (l !== null) return l;
      o = o.sibling;
    }
    return null;
  }
  var Wt = n.unstable_scheduleCallback, rn = n.unstable_cancelCallback, P2 = n.unstable_shouldYield, B3 = n.unstable_requestPaint, Et = n.unstable_now, Gn = n.unstable_getCurrentPriorityLevel, K2 = n.unstable_ImmediatePriority, it = n.unstable_UserBlockingPriority, qr = n.unstable_NormalPriority, ml = n.unstable_LowPriority, ns = n.unstable_IdlePriority, B0 = null, J2 = null;
  function vl(o) {
    if (J2 && typeof J2.onCommitFiberRoot == "function") try {
      J2.onCommitFiberRoot(B0, o, void 0, (o.current.flags & 128) === 128);
    } catch {
    }
  }
  var ur = Math.clz32 ? Math.clz32 : bl, yl = Math.log, Ji = Math.LN2;
  function bl(o) {
    return o >>>= 0, o === 0 ? 32 : 31 - (yl(o) / Ji | 0) | 0;
  }
  var Yi = 64, di = 4194304;
  function Ci(o) {
    switch (o & -o) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return o & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return o;
    }
  }
  function Y2(o, l) {
    var d = o.pendingLanes;
    if (d === 0) return 0;
    var A = 0, y = o.suspendedLanes, S = o.pingedLanes, j = d & 268435455;
    if (j !== 0) {
      var K = j & ~y;
      K !== 0 ? A = Ci(K) : (S &= j, S !== 0 && (A = Ci(S)));
    } else j = d & ~y, j !== 0 ? A = Ci(j) : S !== 0 && (A = Ci(S));
    if (A === 0) return 0;
    if (l !== 0 && l !== A && !(l & y) && (y = A & -A, S = l & -l, y >= S || y === 16 && (S & 4194240) !== 0)) return l;
    if (A & 4 && (A |= d & 16), l = o.entangledLanes, l !== 0) for (o = o.entanglements, l &= A; 0 < l; ) d = 31 - ur(l), y = 1 << d, A |= o[d], l &= ~y;
    return A;
  }
  function Na(o, l) {
    switch (o) {
      case 1:
      case 2:
      case 4:
        return l + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Qi(o, l) {
    for (var d = o.suspendedLanes, A = o.pingedLanes, y = o.expirationTimes, S = o.pendingLanes; 0 < S; ) {
      var j = 31 - ur(S), K = 1 << j, q = y[j];
      q === -1 ? (!(K & d) || K & A) && (y[j] = Na(K, l)) : q <= l && (o.expiredLanes |= K), S &= ~K;
    }
  }
  function rs(o) {
    return o = o.pendingLanes & -1073741825, o !== 0 ? o : o & 1073741824 ? 1073741824 : 0;
  }
  function Pa() {
    var o = Yi;
    return Yi <<= 1, !(Yi & 4194240) && (Yi = 64), o;
  }
  function Fa(o) {
    for (var l = [], d = 0; 31 > d; d++) l.push(o);
    return l;
  }
  function H3(o, l, d) {
    o.pendingLanes |= l, l !== 536870912 && (o.suspendedLanes = 0, o.pingedLanes = 0), o = o.eventTimes, l = 31 - ur(l), o[l] = d;
  }
  function Ba(o, l) {
    var d = o.pendingLanes & ~l;
    o.pendingLanes = l, o.suspendedLanes = 0, o.pingedLanes = 0, o.expiredLanes &= l, o.mutableReadLanes &= l, o.entangledLanes &= l, l = o.entanglements;
    var A = o.eventTimes;
    for (o = o.expirationTimes; 0 < d; ) {
      var y = 31 - ur(d), S = 1 << y;
      l[y] = 0, A[y] = -1, o[y] = -1, d &= ~S;
    }
  }
  function H0(o, l) {
    var d = o.entangledLanes |= l;
    for (o = o.entanglements; d; ) {
      var A = 31 - ur(d), y = 1 << A;
      y & l | o[A] & l && (o[A] |= l), d &= ~y;
    }
  }
  var Ve = 0;
  function U0(o) {
    return o &= -o, 1 < o ? 4 < o ? o & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var is, cr, Mt, gr, Q2, Fe = !1, Xi = [], En = null, fr = null, dr = null, W0 = /* @__PURE__ */ new Map(), jn = /* @__PURE__ */ new Map(), Nt = [], _c = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function zr(o, l) {
    switch (o) {
      case "focusin":
      case "focusout":
        En = null;
        break;
      case "dragenter":
      case "dragleave":
        fr = null;
        break;
      case "mouseover":
      case "mouseout":
        dr = null;
        break;
      case "pointerover":
      case "pointerout":
        W0.delete(l.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        jn.delete(l.pointerId);
    }
  }
  function u2(o, l, d, A, y, S) {
    return o === null || o.nativeEvent !== S ? (o = { blockedOn: l, domEventName: d, eventSystemFlags: A, nativeEvent: S, targetContainers: [y] }, l !== null && (l = Is(l), l !== null && cr(l)), o) : (o.eventSystemFlags |= A, l = o.targetContainers, y !== null && l.indexOf(y) === -1 && l.push(y), o);
  }
  function U3(o, l, d, A, y) {
    switch (l) {
      case "focusin":
        return En = u2(En, o, l, d, A, y), !0;
      case "dragenter":
        return fr = u2(fr, o, l, d, A, y), !0;
      case "mouseover":
        return dr = u2(dr, o, l, d, A, y), !0;
      case "pointerover":
        var S = y.pointerId;
        return W0.set(S, u2(W0.get(S) || null, o, l, d, A, y)), !0;
      case "gotpointercapture":
        return S = y.pointerId, jn.set(S, u2(jn.get(S) || null, o, l, d, A, y)), !0;
    }
    return !1;
  }
  function _0(o) {
    var l = e3(o.target);
    if (l !== null) {
      var d = be(l);
      if (d !== null) {
        if (l = d.tag, l === 13) {
          if (l = st(d), l !== null) {
            o.blockedOn = l, Q2(o.priority, function() {
              Mt(d);
            });
            return;
          }
        } else if (l === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          o.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    o.blockedOn = null;
  }
  function Ai(o) {
    if (o.blockedOn !== null) return !1;
    for (var l = o.targetContainers; 0 < l.length; ) {
      var d = Le(o.domEventName, o.eventSystemFlags, l[0], o.nativeEvent);
      if (d === null) {
        d = o.nativeEvent;
        var A = new d.constructor(d.type, d);
        Hn = A, d.target.dispatchEvent(A), Hn = null;
      } else return l = Is(d), l !== null && cr(l), o.blockedOn = d, !1;
      l.shift();
    }
    return !0;
  }
  function L(o, l, d) {
    Ai(o) && d.delete(l);
  }
  function R() {
    Fe = !1, En !== null && Ai(En) && (En = null), fr !== null && Ai(fr) && (fr = null), dr !== null && Ai(dr) && (dr = null), W0.forEach(L), jn.forEach(L);
  }
  function H(o, l) {
    o.blockedOn === l && (o.blockedOn = null, Fe || (Fe = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, R)));
  }
  function W(o) {
    function l(y) {
      return H(y, o);
    }
    if (0 < Xi.length) {
      H(Xi[0], o);
      for (var d = 1; d < Xi.length; d++) {
        var A = Xi[d];
        A.blockedOn === o && (A.blockedOn = null);
      }
    }
    for (En !== null && H(En, o), fr !== null && H(fr, o), dr !== null && H(dr, o), W0.forEach(l), jn.forEach(l), d = 0; d < Nt.length; d++) A = Nt[d], A.blockedOn === o && (A.blockedOn = null);
    for (; 0 < Nt.length && (d = Nt[0], d.blockedOn === null); ) _0(d), d.blockedOn === null && Nt.shift();
  }
  var $ = X.ReactCurrentBatchConfig, I1 = !0;
  function U1(o, l, d, A) {
    var y = Ve, S = $.transition;
    $.transition = null;
    try {
      Ve = 1, ce(o, l, d, A);
    } finally {
      Ve = y, $.transition = S;
    }
  }
  function O1(o, l, d, A) {
    var y = Ve, S = $.transition;
    $.transition = null;
    try {
      Ve = 4, ce(o, l, d, A);
    } finally {
      Ve = y, $.transition = S;
    }
  }
  function ce(o, l, d, A) {
    if (I1) {
      var y = Le(o, l, d, A);
      if (y === null) kl(o, l, A, fe, d), zr(o, A);
      else if (U3(y, o, l, d, A)) A.stopPropagation();
      else if (zr(o, A), l & 4 && -1 < _c.indexOf(o)) {
        for (; y !== null; ) {
          var S = Is(y);
          if (S !== null && is(S), S = Le(o, l, d, A), S === null && kl(o, l, A, fe, d), S === y) break;
          y = S;
        }
        y !== null && A.stopPropagation();
      } else kl(o, l, A, null, d);
    }
  }
  var fe = null;
  function Le(o, l, d, A) {
    if (fe = null, o = Ht(A), o = e3(o), o !== null) if (l = be(o), l === null) o = null;
    else if (d = l.tag, d === 13) {
      if (o = st(l), o !== null) return o;
      o = null;
    } else if (d === 3) {
      if (l.stateNode.current.memoizedState.isDehydrated) return l.tag === 3 ? l.stateNode.containerInfo : null;
      o = null;
    } else l !== o && (o = null);
    return fe = o, null;
  }
  function lt(o) {
    switch (o) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Gn()) {
          case K2:
            return 1;
          case it:
            return 4;
          case qr:
          case ml:
            return 16;
          case ns:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Ct = null, qn = null, an = null;
  function In() {
    if (an) return an;
    var o, l = qn, d = l.length, A, y = "value" in Ct ? Ct.value : Ct.textContent, S = y.length;
    for (o = 0; o < d && l[o] === y[o]; o++) ;
    var j = d - o;
    for (A = 1; A <= j && l[d - A] === y[S - A]; A++) ;
    return an = y.slice(o, 1 < A ? 1 - A : void 0);
  }
  function c2(o) {
    var l = o.keyCode;
    return "charCode" in o ? (o = o.charCode, o === 0 && l === 13 && (o = 13)) : o = l, o === 10 && (o = 13), 32 <= o || o === 13 ? o : 0;
  }
  function b3() {
    return !0;
  }
  function F2() {
    return !1;
  }
  function Zn(o) {
    function l(d, A, y, S, j) {
      this._reactName = d, this._targetInst = y, this.type = A, this.nativeEvent = S, this.target = j, this.currentTarget = null;
      for (var K in o) o.hasOwnProperty(K) && (d = o[K], this[K] = d ? d(S) : S[K]);
      return this.isDefaultPrevented = (S.defaultPrevented != null ? S.defaultPrevented : S.returnValue === !1) ? b3 : F2, this.isPropagationStopped = F2, this;
    }
    return t1(l.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var d = this.nativeEvent;
      d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = b3);
    }, stopPropagation: function() {
      var d = this.nativeEvent;
      d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = b3);
    }, persist: function() {
    }, isPersistent: b3 }), l;
  }
  var Zr = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(o) {
    return o.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, V0 = Zn(Zr), Ha = t1({}, Zr, { view: 0, detail: 0 }), Vf = Zn(Ha), wl, Vc, as, g2 = t1({}, Ha, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Qc, button: 0, buttons: 0, relatedTarget: function(o) {
    return o.relatedTarget === void 0 ? o.fromElement === o.srcElement ? o.toElement : o.fromElement : o.relatedTarget;
  }, movementX: function(o) {
    return "movementX" in o ? o.movementX : (o !== as && (as && o.type === "mousemove" ? (wl = o.screenX - as.screenX, Vc = o.screenY - as.screenY) : Vc = wl = 0, as = o), wl);
  }, movementY: function(o) {
    return "movementY" in o ? o.movementY : Vc;
  } }), xl = Zn(g2), Kf = t1({}, g2, { dataTransfer: 0 }), Jf = Zn(Kf), h6 = t1({}, Ha, { relatedTarget: 0 }), Gi = Zn(h6), Kc = t1({}, Zr, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Yf = Zn(Kc), m6 = t1({}, Zr, { clipboardData: function(o) {
    return "clipboardData" in o ? o.clipboardData : window.clipboardData;
  } }), v6 = Zn(m6), y6 = t1({}, Zr, { data: 0 }), Jc = Zn(y6), Yc = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Xf = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Gf(o) {
    var l = this.nativeEvent;
    return l.getModifierState ? l.getModifierState(o) : (o = Xf[o]) ? !!l[o] : !1;
  }
  function Qc() {
    return Gf;
  }
  var Ii = t1({}, Ha, { key: function(o) {
    if (o.key) {
      var l = Yc[o.key] || o.key;
      if (l !== "Unidentified") return l;
    }
    return o.type === "keypress" ? (o = c2(o), o === 13 ? "Enter" : String.fromCharCode(o)) : o.type === "keydown" || o.type === "keyup" ? Qf[o.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Qc, charCode: function(o) {
    return o.type === "keypress" ? c2(o) : 0;
  }, keyCode: function(o) {
    return o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  }, which: function(o) {
    return o.type === "keypress" ? c2(o) : o.type === "keydown" || o.type === "keyup" ? o.keyCode : 0;
  } }), b6 = Zn(Ii), Xc = t1({}, g2, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Sl = Zn(Xc), Gc = t1({}, Ha, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Qc }), w6 = Zn(Gc), El = t1({}, Zr, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), qf = Zn(El), Cr = t1({}, g2, {
    deltaX: function(o) {
      return "deltaX" in o ? o.deltaX : "wheelDeltaX" in o ? -o.wheelDeltaX : 0;
    },
    deltaY: function(o) {
      return "deltaY" in o ? o.deltaY : "wheelDeltaY" in o ? -o.wheelDeltaY : "wheelDelta" in o ? -o.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), pi = Zn(Cr), Wn = [9, 13, 27, 32], w3 = I && "CompositionEvent" in window, K0 = null;
  I && "documentMode" in document && (K0 = document.documentMode);
  var Ml = I && "TextEvent" in window && !K0, Zf = I && (!w3 || K0 && 8 < K0 && 11 >= K0), Ua = " ", $f = !1;
  function ed(o, l) {
    switch (o) {
      case "keyup":
        return Wn.indexOf(l.keyCode) !== -1;
      case "keydown":
        return l.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Tl(o) {
    return o = o.detail, typeof o == "object" && "data" in o ? o.data : null;
  }
  var Wa = !1;
  function x6(o, l) {
    switch (o) {
      case "compositionend":
        return Tl(l);
      case "keypress":
        return l.which !== 32 ? null : ($f = !0, Ua);
      case "textInput":
        return o = l.data, o === Ua && $f ? null : o;
      default:
        return null;
    }
  }
  function S6(o, l) {
    if (Wa) return o === "compositionend" || !w3 && ed(o, l) ? (o = In(), an = qn = Ct = null, Wa = !1, o) : null;
    switch (o) {
      case "paste":
        return null;
      case "keypress":
        if (!(l.ctrlKey || l.altKey || l.metaKey) || l.ctrlKey && l.altKey) {
          if (l.char && 1 < l.char.length) return l.char;
          if (l.which) return String.fromCharCode(l.which);
        }
        return null;
      case "compositionend":
        return Zf && l.locale !== "ko" ? null : l.data;
      default:
        return null;
    }
  }
  var td = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function nd(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l === "input" ? !!td[o.type] : l === "textarea";
  }
  function rd(o, l, d, A) {
    ci(A), l = ds(l, "onChange"), 0 < l.length && (d = new V0("onChange", "change", null, d, A), o.push({ event: d, listeners: l }));
  }
  var os = null, _a = null;
  function Va(o) {
    Dl(o, 0);
  }
  function Ka(o) {
    var l = Ya(o);
    if (D1(l)) return o;
  }
  function id(o, l) {
    if (o === "change") return l;
  }
  var qc = !1;
  if (I) {
    var Zc;
    if (I) {
      var $c = "oninput" in document;
      if (!$c) {
        var ad = document.createElement("div");
        ad.setAttribute("oninput", "return;"), $c = typeof ad.oninput == "function";
      }
      Zc = $c;
    } else Zc = !1;
    qc = Zc && (!document.documentMode || 9 < document.documentMode);
  }
  function od() {
    os && (os.detachEvent("onpropertychange", sd), _a = os = null);
  }
  function sd(o) {
    if (o.propertyName === "value" && Ka(_a)) {
      var l = [];
      rd(l, _a, o, Ht(o)), Xn(Va, l);
    }
  }
  function E6(o, l, d) {
    o === "focusin" ? (od(), os = l, _a = d, os.attachEvent("onpropertychange", sd)) : o === "focusout" && od();
  }
  function M6(o) {
    if (o === "selectionchange" || o === "keyup" || o === "keydown") return Ka(_a);
  }
  function T6(o, l) {
    if (o === "click") return Ka(l);
  }
  function ld(o, l) {
    if (o === "input" || o === "change") return Ka(l);
  }
  function L6(o, l) {
    return o === l && (o !== 0 || 1 / o === 1 / l) || o !== o && l !== l;
  }
  var $r = typeof Object.is == "function" ? Object.is : L6;
  function ss(o, l) {
    if ($r(o, l)) return !0;
    if (typeof o != "object" || o === null || typeof l != "object" || l === null) return !1;
    var d = Object.keys(o), A = Object.keys(l);
    if (d.length !== A.length) return !1;
    for (A = 0; A < d.length; A++) {
      var y = d[A];
      if (!h.call(l, y) || !$r(o[y], l[y])) return !1;
    }
    return !0;
  }
  function ud(o) {
    for (; o && o.firstChild; ) o = o.firstChild;
    return o;
  }
  function cd(o, l) {
    var d = ud(o);
    o = 0;
    for (var A; d; ) {
      if (d.nodeType === 3) {
        if (A = o + d.textContent.length, o <= l && A >= l) return { node: d, offset: l - o };
        o = A;
      }
      e: {
        for (; d; ) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = ud(d);
    }
  }
  function gd(o, l) {
    return o && l ? o === l ? !0 : o && o.nodeType === 3 ? !1 : l && l.nodeType === 3 ? gd(o, l.parentNode) : "contains" in o ? o.contains(l) : o.compareDocumentPosition ? !!(o.compareDocumentPosition(l) & 16) : !1 : !1;
  }
  function Ll() {
    for (var o = window, l = $1(); l instanceof o.HTMLIFrameElement; ) {
      try {
        var d = typeof l.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) o = l.contentWindow;
      else break;
      l = $1(o.document);
    }
    return l;
  }
  function hi(o) {
    var l = o && o.nodeName && o.nodeName.toLowerCase();
    return l && (l === "input" && (o.type === "text" || o.type === "search" || o.type === "tel" || o.type === "url" || o.type === "password") || l === "textarea" || o.contentEditable === "true");
  }
  function Rl(o) {
    var l = Ll(), d = o.focusedElem, A = o.selectionRange;
    if (l !== d && d && d.ownerDocument && gd(d.ownerDocument.documentElement, d)) {
      if (A !== null && hi(d)) {
        if (l = A.start, o = A.end, o === void 0 && (o = l), "selectionStart" in d) d.selectionStart = l, d.selectionEnd = Math.min(o, d.value.length);
        else if (o = (l = d.ownerDocument || document) && l.defaultView || window, o.getSelection) {
          o = o.getSelection();
          var y = d.textContent.length, S = Math.min(A.start, y);
          A = A.end === void 0 ? S : Math.min(A.end, y), !o.extend && S > A && (y = A, A = S, S = y), y = cd(d, S);
          var j = cd(
            d,
            A
          );
          y && j && (o.rangeCount !== 1 || o.anchorNode !== y.node || o.anchorOffset !== y.offset || o.focusNode !== j.node || o.focusOffset !== j.offset) && (l = l.createRange(), l.setStart(y.node, y.offset), o.removeAllRanges(), S > A ? (o.addRange(l), o.extend(j.node, j.offset)) : (l.setEnd(j.node, j.offset), o.addRange(l)));
        }
      }
      for (l = [], o = d; o = o.parentNode; ) o.nodeType === 1 && l.push({ element: o, left: o.scrollLeft, top: o.scrollTop });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < l.length; d++) o = l[d], o.element.scrollLeft = o.left, o.element.scrollTop = o.top;
    }
  }
  var fd = I && "documentMode" in document && 11 >= document.documentMode, x3 = null, e4 = null, ls = null, t4 = !1;
  function dd(o, l, d) {
    var A = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    t4 || x3 == null || x3 !== $1(A) || (A = x3, "selectionStart" in A && hi(A) ? A = { start: A.selectionStart, end: A.selectionEnd } : (A = (A.ownerDocument && A.ownerDocument.defaultView || window).getSelection(), A = { anchorNode: A.anchorNode, anchorOffset: A.anchorOffset, focusNode: A.focusNode, focusOffset: A.focusOffset }), ls && ss(ls, A) || (ls = A, A = ds(e4, "onSelect"), 0 < A.length && (l = new V0("onSelect", "select", null, l, d), o.push({ event: l, listeners: A }), l.target = x3)));
  }
  function Ol(o, l) {
    var d = {};
    return d[o.toLowerCase()] = l.toLowerCase(), d["Webkit" + o] = "webkit" + l, d["Moz" + o] = "moz" + l, d;
  }
  var J0 = { animationend: Ol("Animation", "AnimationEnd"), animationiteration: Ol("Animation", "AnimationIteration"), animationstart: Ol("Animation", "AnimationStart"), transitionend: Ol("Transition", "TransitionEnd") }, n4 = {}, r4 = {};
  I && (r4 = document.createElement("div").style, "AnimationEvent" in window || (delete J0.animationend.animation, delete J0.animationiteration.animation, delete J0.animationstart.animation), "TransitionEvent" in window || delete J0.transitionend.transition);
  function f2(o) {
    if (n4[o]) return n4[o];
    if (!J0[o]) return o;
    var l = J0[o], d;
    for (d in l) if (l.hasOwnProperty(d) && d in r4) return n4[o] = l[d];
    return o;
  }
  var i4 = f2("animationend"), Cd = f2("animationiteration"), Ad = f2("animationstart"), Id = f2("transitionend"), pd = /* @__PURE__ */ new Map(), hd = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function mi(o, l) {
    pd.set(o, l), g(l, [o]);
  }
  for (var us = 0; us < hd.length; us++) {
    var Y0 = hd[us], R6 = Y0.toLowerCase(), cs = Y0[0].toUpperCase() + Y0.slice(1);
    mi(R6, "on" + cs);
  }
  mi(i4, "onAnimationEnd"), mi(Cd, "onAnimationIteration"), mi(Ad, "onAnimationStart"), mi("dblclick", "onDoubleClick"), mi("focusin", "onFocus"), mi("focusout", "onBlur"), mi(Id, "onTransitionEnd"), c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), g("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), g("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), g("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), g("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), g("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var gs = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), O6 = new Set("cancel close invalid load scroll toggle".split(" ").concat(gs));
  function md(o, l, d) {
    var A = o.type || "unknown-event";
    o.currentTarget = d, re(A, l, void 0, o), o.currentTarget = null;
  }
  function Dl(o, l) {
    l = (l & 4) !== 0;
    for (var d = 0; d < o.length; d++) {
      var A = o[d], y = A.event;
      A = A.listeners;
      e: {
        var S = void 0;
        if (l) for (var j = A.length - 1; 0 <= j; j--) {
          var K = A[j], q = K.instance, p1 = K.currentTarget;
          if (K = K.listener, q !== S && y.isPropagationStopped()) break e;
          md(y, K, p1), S = q;
        }
        else for (j = 0; j < A.length; j++) {
          if (K = A[j], q = K.instance, p1 = K.currentTarget, K = K.listener, q !== S && y.isPropagationStopped()) break e;
          md(y, K, p1), S = q;
        }
      }
    }
    if (Gr) throw o = fi, Gr = !1, fi = null, o;
  }
  function on(o, l) {
    var d = l[g4];
    d === void 0 && (d = l[g4] = /* @__PURE__ */ new Set());
    var A = o + "__bubble";
    d.has(A) || (vd(l, o, 2, !1), d.add(A));
  }
  function qi(o, l, d) {
    var A = 0;
    l && (A |= 4), vd(d, o, A, l);
  }
  var vi = "_reactListening" + Math.random().toString(36).slice(2);
  function Ja(o) {
    if (!o[vi]) {
      o[vi] = !0, a.forEach(function(d) {
        d !== "selectionchange" && (O6.has(d) || qi(d, !1, o), qi(d, !0, o));
      });
      var l = o.nodeType === 9 ? o : o.ownerDocument;
      l === null || l[vi] || (l[vi] = !0, qi("selectionchange", !1, l));
    }
  }
  function vd(o, l, d, A) {
    switch (lt(l)) {
      case 1:
        var y = U1;
        break;
      case 4:
        y = O1;
        break;
      default:
        y = ce;
    }
    d = y.bind(null, l, d, o), y = void 0, !Ki || l !== "touchstart" && l !== "touchmove" && l !== "wheel" || (y = !0), A ? y !== void 0 ? o.addEventListener(l, d, { capture: !0, passive: y }) : o.addEventListener(l, d, !0) : y !== void 0 ? o.addEventListener(l, d, { passive: y }) : o.addEventListener(l, d, !1);
  }
  function kl(o, l, d, A, y) {
    var S = A;
    if (!(l & 1) && !(l & 2) && A !== null) e: for (; ; ) {
      if (A === null) return;
      var j = A.tag;
      if (j === 3 || j === 4) {
        var K = A.stateNode.containerInfo;
        if (K === y || K.nodeType === 8 && K.parentNode === y) break;
        if (j === 4) for (j = A.return; j !== null; ) {
          var q = j.tag;
          if ((q === 3 || q === 4) && (q = j.stateNode.containerInfo, q === y || q.nodeType === 8 && q.parentNode === y)) return;
          j = j.return;
        }
        for (; K !== null; ) {
          if (j = e3(K), j === null) return;
          if (q = j.tag, q === 5 || q === 6) {
            A = S = j;
            continue e;
          }
          K = K.parentNode;
        }
      }
      A = A.return;
    }
    Xn(function() {
      var p1 = S, W1 = Ht(d), Q1 = [];
      e: {
        var N1 = pd.get(o);
        if (N1 !== void 0) {
          var pe = V0, Se = o;
          switch (o) {
            case "keypress":
              if (c2(d) === 0) break e;
            case "keydown":
            case "keyup":
              pe = b6;
              break;
            case "focusin":
              Se = "focus", pe = Gi;
              break;
            case "focusout":
              Se = "blur", pe = Gi;
              break;
            case "beforeblur":
            case "afterblur":
              pe = Gi;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              pe = xl;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              pe = Jf;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              pe = w6;
              break;
            case i4:
            case Cd:
            case Ad:
              pe = Yf;
              break;
            case Id:
              pe = qf;
              break;
            case "scroll":
              pe = Vf;
              break;
            case "wheel":
              pe = pi;
              break;
            case "copy":
            case "cut":
            case "paste":
              pe = v6;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              pe = Sl;
          }
          var Te = (l & 4) !== 0, Pn = !Te && o === "scroll", s1 = Te ? N1 !== null ? N1 + "Capture" : null : N1;
          Te = [];
          for (var r1 = p1, g1; r1 !== null; ) {
            g1 = r1;
            var ne = g1.stateNode;
            if (g1.tag === 5 && ne !== null && (g1 = ne, s1 !== null && (ne = gi(r1, s1), ne != null && Te.push(fs(r1, ne, g1)))), Pn) break;
            r1 = r1.return;
          }
          0 < Te.length && (N1 = new pe(N1, Se, null, d, W1), Q1.push({ event: N1, listeners: Te }));
        }
      }
      if (!(l & 7)) {
        e: {
          if (N1 = o === "mouseover" || o === "pointerover", pe = o === "mouseout" || o === "pointerout", N1 && d !== Hn && (Se = d.relatedTarget || d.fromElement) && (e3(Se) || Se[yi])) break e;
          if ((pe || N1) && (N1 = W1.window === W1 ? W1 : (N1 = W1.ownerDocument) ? N1.defaultView || N1.parentWindow : window, pe ? (Se = d.relatedTarget || d.toElement, pe = p1, Se = Se ? e3(Se) : null, Se !== null && (Pn = be(Se), Se !== Pn || Se.tag !== 5 && Se.tag !== 6) && (Se = null)) : (pe = null, Se = p1), pe !== Se)) {
            if (Te = xl, ne = "onMouseLeave", s1 = "onMouseEnter", r1 = "mouse", (o === "pointerout" || o === "pointerover") && (Te = Sl, ne = "onPointerLeave", s1 = "onPointerEnter", r1 = "pointer"), Pn = pe == null ? N1 : Ya(pe), g1 = Se == null ? N1 : Ya(Se), N1 = new Te(ne, r1 + "leave", pe, d, W1), N1.target = Pn, N1.relatedTarget = g1, ne = null, e3(W1) === p1 && (Te = new Te(s1, r1 + "enter", Se, d, W1), Te.target = g1, Te.relatedTarget = Pn, ne = Te), Pn = ne, pe && Se) t: {
              for (Te = pe, s1 = Se, r1 = 0, g1 = Te; g1; g1 = Q0(g1)) r1++;
              for (g1 = 0, ne = s1; ne; ne = Q0(ne)) g1++;
              for (; 0 < r1 - g1; ) Te = Q0(Te), r1--;
              for (; 0 < g1 - r1; ) s1 = Q0(s1), g1--;
              for (; r1--; ) {
                if (Te === s1 || s1 !== null && Te === s1.alternate) break t;
                Te = Q0(Te), s1 = Q0(s1);
              }
              Te = null;
            }
            else Te = null;
            pe !== null && a4(Q1, N1, pe, Te, !1), Se !== null && Pn !== null && a4(Q1, Pn, Se, Te, !0);
          }
        }
        e: {
          if (N1 = p1 ? Ya(p1) : window, pe = N1.nodeName && N1.nodeName.toLowerCase(), pe === "select" || pe === "input" && N1.type === "file") var Oe = id;
          else if (nd(N1)) if (qc) Oe = ld;
          else {
            Oe = M6;
            var Ke = E6;
          }
          else (pe = N1.nodeName) && pe.toLowerCase() === "input" && (N1.type === "checkbox" || N1.type === "radio") && (Oe = T6);
          if (Oe && (Oe = Oe(o, p1))) {
            rd(Q1, Oe, d, W1);
            break e;
          }
          Ke && Ke(o, N1, p1), o === "focusout" && (Ke = N1._wrapperState) && Ke.controlled && N1.type === "number" && me(N1, "number", N1.value);
        }
        switch (Ke = p1 ? Ya(p1) : window, o) {
          case "focusin":
            (nd(Ke) || Ke.contentEditable === "true") && (x3 = Ke, e4 = p1, ls = null);
            break;
          case "focusout":
            ls = e4 = x3 = null;
            break;
          case "mousedown":
            t4 = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            t4 = !1, dd(Q1, d, W1);
            break;
          case "selectionchange":
            if (fd) break;
          case "keydown":
          case "keyup":
            dd(Q1, d, W1);
        }
        var Ee;
        if (w3) e: {
          switch (o) {
            case "compositionstart":
              var Je = "onCompositionStart";
              break e;
            case "compositionend":
              Je = "onCompositionEnd";
              break e;
            case "compositionupdate":
              Je = "onCompositionUpdate";
              break e;
          }
          Je = void 0;
        }
        else Wa ? ed(o, d) && (Je = "onCompositionEnd") : o === "keydown" && d.keyCode === 229 && (Je = "onCompositionStart");
        Je && (Zf && d.locale !== "ko" && (Wa || Je !== "onCompositionStart" ? Je === "onCompositionEnd" && Wa && (Ee = In()) : (Ct = W1, qn = "value" in Ct ? Ct.value : Ct.textContent, Wa = !0)), Ke = ds(p1, Je), 0 < Ke.length && (Je = new Jc(Je, o, null, d, W1), Q1.push({ event: Je, listeners: Ke }), Ee ? Je.data = Ee : (Ee = Tl(d), Ee !== null && (Je.data = Ee)))), (Ee = Ml ? x6(o, d) : S6(o, d)) && (p1 = ds(p1, "onBeforeInput"), 0 < p1.length && (W1 = new Jc("onBeforeInput", "beforeinput", null, d, W1), Q1.push({ event: W1, listeners: p1 }), W1.data = Ee));
      }
      Dl(Q1, l);
    });
  }
  function fs(o, l, d) {
    return { instance: o, listener: l, currentTarget: d };
  }
  function ds(o, l) {
    for (var d = l + "Capture", A = []; o !== null; ) {
      var y = o, S = y.stateNode;
      y.tag === 5 && S !== null && (y = S, S = gi(o, d), S != null && A.unshift(fs(o, S, y)), S = gi(o, l), S != null && A.push(fs(o, S, y))), o = o.return;
    }
    return A;
  }
  function Q0(o) {
    if (o === null) return null;
    do
      o = o.return;
    while (o && o.tag !== 5);
    return o || null;
  }
  function a4(o, l, d, A, y) {
    for (var S = l._reactName, j = []; d !== null && d !== A; ) {
      var K = d, q = K.alternate, p1 = K.stateNode;
      if (q !== null && q === A) break;
      K.tag === 5 && p1 !== null && (K = p1, y ? (q = gi(d, S), q != null && j.unshift(fs(d, q, K))) : y || (q = gi(d, S), q != null && j.push(fs(d, q, K)))), d = d.return;
    }
    j.length !== 0 && o.push({ event: l, listeners: j });
  }
  var o4 = /\r\n?/g, D6 = /\u0000|\uFFFD/g;
  function s4(o) {
    return (typeof o == "string" ? o : "" + o).replace(o4, `
`).replace(D6, "");
  }
  function jl(o, l, d) {
    if (l = s4(l), s4(o) !== l && d) throw Error(i(425));
  }
  function zl() {
  }
  var l4 = null, X0 = null;
  function Cs(o, l) {
    return o === "textarea" || o === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
  }
  var G0 = typeof setTimeout == "function" ? setTimeout : void 0, yd = typeof clearTimeout == "function" ? clearTimeout : void 0, u4 = typeof Promise == "function" ? Promise : void 0, c4 = typeof queueMicrotask == "function" ? queueMicrotask : typeof u4 < "u" ? function(o) {
    return u4.resolve(null).then(o).catch(k6);
  } : G0;
  function k6(o) {
    setTimeout(function() {
      throw o;
    });
  }
  function Zi(o, l) {
    var d = l, A = 0;
    do {
      var y = d.nextSibling;
      if (o.removeChild(d), y && y.nodeType === 8) if (d = y.data, d === "/$") {
        if (A === 0) {
          o.removeChild(y), W(l);
          return;
        }
        A--;
      } else d !== "$" && d !== "$?" && d !== "$!" || A++;
      d = y;
    } while (d);
    W(l);
  }
  function S3(o) {
    for (; o != null; o = o.nextSibling) {
      var l = o.nodeType;
      if (l === 1 || l === 3) break;
      if (l === 8) {
        if (l = o.data, l === "$" || l === "$!" || l === "$?") break;
        if (l === "/$") return null;
      }
    }
    return o;
  }
  function As(o) {
    o = o.previousSibling;
    for (var l = 0; o; ) {
      if (o.nodeType === 8) {
        var d = o.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (l === 0) return o;
          l--;
        } else d === "/$" && l++;
      }
      o = o.previousSibling;
    }
    return null;
  }
  var $i = Math.random().toString(36).slice(2), W3 = "__reactFiber$" + $i, q0 = "__reactProps$" + $i, yi = "__reactContainer$" + $i, g4 = "__reactEvents$" + $i, j6 = "__reactListeners$" + $i, f4 = "__reactHandles$" + $i;
  function e3(o) {
    var l = o[W3];
    if (l) return l;
    for (var d = o.parentNode; d; ) {
      if (l = d[yi] || d[W3]) {
        if (d = l.alternate, l.child !== null || d !== null && d.child !== null) for (o = As(o); o !== null; ) {
          if (d = o[W3]) return d;
          o = As(o);
        }
        return l;
      }
      o = d, d = o.parentNode;
    }
    return null;
  }
  function Is(o) {
    return o = o[W3] || o[yi], !o || o.tag !== 5 && o.tag !== 6 && o.tag !== 13 && o.tag !== 3 ? null : o;
  }
  function Ya(o) {
    if (o.tag === 5 || o.tag === 6) return o.stateNode;
    throw Error(i(33));
  }
  function Ue(o) {
    return o[q0] || null;
  }
  var e0 = [], cn = -1;
  function tt(o) {
    return { current: o };
  }
  function Ot(o) {
    0 > cn || (o.current = e0[cn], e0[cn] = null, cn--);
  }
  function Pt(o, l) {
    cn++, e0[cn] = o.current, o.current = l;
  }
  var _3 = {}, Xe = tt(_3), Mn = tt(!1), Ar = _3;
  function t3(o, l) {
    var d = o.type.contextTypes;
    if (!d) return _3;
    var A = o.stateNode;
    if (A && A.__reactInternalMemoizedUnmaskedChildContext === l) return A.__reactInternalMemoizedMaskedChildContext;
    var y = {}, S;
    for (S in d) y[S] = l[S];
    return A && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = l, o.__reactInternalMemoizedMaskedChildContext = y), y;
  }
  function pn(o) {
    return o = o.childContextTypes, o != null;
  }
  function n3() {
    Ot(Mn), Ot(Xe);
  }
  function t0(o, l, d) {
    if (Xe.current !== _3) throw Error(i(168));
    Pt(Xe, l), Pt(Mn, d);
  }
  function ps(o, l, d) {
    var A = o.stateNode;
    if (l = l.childContextTypes, typeof A.getChildContext != "function") return d;
    A = A.getChildContext();
    for (var y in A) if (!(y in l)) throw Error(i(108, te(o) || "Unknown", y));
    return t1({}, d, A);
  }
  function Nl(o) {
    return o = (o = o.stateNode) && o.__reactInternalMemoizedMergedChildContext || _3, Ar = Xe.current, Pt(Xe, o), Pt(Mn, Mn.current), !0;
  }
  function bd(o, l, d) {
    var A = o.stateNode;
    if (!A) throw Error(i(169));
    d ? (o = ps(o, l, Ar), A.__reactInternalMemoizedMergedChildContext = o, Ot(Mn), Ot(Xe), Pt(Xe, o)) : Ot(Mn), Pt(Mn, d);
  }
  var Nr = null, d2 = !1, hs = !1;
  function d4(o) {
    Nr === null ? Nr = [o] : Nr.push(o);
  }
  function C4(o) {
    d2 = !0, d4(o);
  }
  function Ir() {
    if (!hs && Nr !== null) {
      hs = !0;
      var o = 0, l = Ve;
      try {
        var d = Nr;
        for (Ve = 1; o < d.length; o++) {
          var A = d[o];
          do
            A = A(!0);
          while (A !== null);
        }
        Nr = null, d2 = !1;
      } catch (y) {
        throw Nr !== null && (Nr = Nr.slice(o + 1)), Wt(K2, Ir), y;
      } finally {
        Ve = l, hs = !1;
      }
    }
    return null;
  }
  var n0 = [], pr = 0, Z0 = null, Qa = 0, hr = [], B2 = 0, r3 = null, w2 = 1, bi = "";
  function Pr(o, l) {
    n0[pr++] = Qa, n0[pr++] = Z0, Z0 = o, Qa = l;
  }
  function A4(o, l, d) {
    hr[B2++] = w2, hr[B2++] = bi, hr[B2++] = r3, r3 = o;
    var A = w2;
    o = bi;
    var y = 32 - ur(A) - 1;
    A &= ~(1 << y), d += 1;
    var S = 32 - ur(l) + y;
    if (30 < S) {
      var j = y - y % 5;
      S = (A & (1 << j) - 1).toString(32), A >>= j, y -= j, w2 = 1 << 32 - ur(l) + y | d << y | A, bi = S + o;
    } else w2 = 1 << S | d << y | A, bi = o;
  }
  function Pl(o) {
    o.return !== null && (Pr(o, 1), A4(o, 1, 0));
  }
  function I4(o) {
    for (; o === Z0; ) Z0 = n0[--pr], n0[pr] = null, Qa = n0[--pr], n0[pr] = null;
    for (; o === r3; ) r3 = hr[--B2], hr[B2] = null, bi = hr[--B2], hr[B2] = null, w2 = hr[--B2], hr[B2] = null;
  }
  var Fr = null, mr = null, gn = !1, i3 = null;
  function p4(o, l) {
    var d = f3(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = l, d.return = o, l = o.deletions, l === null ? (o.deletions = [d], o.flags |= 16) : l.push(d);
  }
  function wd(o, l) {
    switch (o.tag) {
      case 5:
        var d = o.type;
        return l = l.nodeType !== 1 || d.toLowerCase() !== l.nodeName.toLowerCase() ? null : l, l !== null ? (o.stateNode = l, Fr = o, mr = S3(l.firstChild), !0) : !1;
      case 6:
        return l = o.pendingProps === "" || l.nodeType !== 3 ? null : l, l !== null ? (o.stateNode = l, Fr = o, mr = null, !0) : !1;
      case 13:
        return l = l.nodeType !== 8 ? null : l, l !== null ? (d = r3 !== null ? { id: w2, overflow: bi } : null, o.memoizedState = { dehydrated: l, treeContext: d, retryLane: 1073741824 }, d = f3(18, null, null, 0), d.stateNode = l, d.return = o, o.child = d, Fr = o, mr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function Fl(o) {
    return (o.mode & 1) !== 0 && (o.flags & 128) === 0;
  }
  function Bl(o) {
    if (gn) {
      var l = mr;
      if (l) {
        var d = l;
        if (!wd(o, l)) {
          if (Fl(o)) throw Error(i(418));
          l = S3(d.nextSibling);
          var A = Fr;
          l && wd(o, l) ? p4(A, d) : (o.flags = o.flags & -4097 | 2, gn = !1, Fr = o);
        }
      } else {
        if (Fl(o)) throw Error(i(418));
        o.flags = o.flags & -4097 | 2, gn = !1, Fr = o;
      }
    }
  }
  function xd(o) {
    for (o = o.return; o !== null && o.tag !== 5 && o.tag !== 3 && o.tag !== 13; ) o = o.return;
    Fr = o;
  }
  function Hl(o) {
    if (o !== Fr) return !1;
    if (!gn) return xd(o), gn = !0, !1;
    var l;
    if ((l = o.tag !== 3) && !(l = o.tag !== 5) && (l = o.type, l = l !== "head" && l !== "body" && !Cs(o.type, o.memoizedProps)), l && (l = mr)) {
      if (Fl(o)) throw Sd(), Error(i(418));
      for (; l; ) p4(o, l), l = S3(l.nextSibling);
    }
    if (xd(o), o.tag === 13) {
      if (o = o.memoizedState, o = o !== null ? o.dehydrated : null, !o) throw Error(i(317));
      e: {
        for (o = o.nextSibling, l = 0; o; ) {
          if (o.nodeType === 8) {
            var d = o.data;
            if (d === "/$") {
              if (l === 0) {
                mr = S3(o.nextSibling);
                break e;
              }
              l--;
            } else d !== "$" && d !== "$!" && d !== "$?" || l++;
          }
          o = o.nextSibling;
        }
        mr = null;
      }
    } else mr = Fr ? S3(o.stateNode.nextSibling) : null;
    return !0;
  }
  function Sd() {
    for (var o = mr; o; ) o = S3(o.nextSibling);
  }
  function bn() {
    mr = Fr = null, gn = !1;
  }
  function h4(o) {
    i3 === null ? i3 = [o] : i3.push(o);
  }
  var Ul = X.ReactCurrentBatchConfig;
  function $0(o, l, d) {
    if (o = d.ref, o !== null && typeof o != "function" && typeof o != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(i(309));
          var A = d.stateNode;
        }
        if (!A) throw Error(i(147, o));
        var y = A, S = "" + o;
        return l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === S ? l.ref : (l = function(j) {
          var K = y.refs;
          j === null ? delete K[S] : K[S] = j;
        }, l._stringRef = S, l);
      }
      if (typeof o != "string") throw Error(i(284));
      if (!d._owner) throw Error(i(290, o));
    }
    return o;
  }
  function V3(o, l) {
    throw o = Object.prototype.toString.call(l), Error(i(31, o === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : o));
  }
  function Ed(o) {
    var l = o._init;
    return l(o._payload);
  }
  function Wl(o) {
    function l(s1, r1) {
      if (o) {
        var g1 = s1.deletions;
        g1 === null ? (s1.deletions = [r1], s1.flags |= 16) : g1.push(r1);
      }
    }
    function d(s1, r1) {
      if (!o) return null;
      for (; r1 !== null; ) l(s1, r1), r1 = r1.sibling;
      return null;
    }
    function A(s1, r1) {
      for (s1 = /* @__PURE__ */ new Map(); r1 !== null; ) r1.key !== null ? s1.set(r1.key, r1) : s1.set(r1.index, r1), r1 = r1.sibling;
      return s1;
    }
    function y(s1, r1) {
      return s1 = c0(s1, r1), s1.index = 0, s1.sibling = null, s1;
    }
    function S(s1, r1, g1) {
      return s1.index = g1, o ? (g1 = s1.alternate, g1 !== null ? (g1 = g1.index, g1 < r1 ? (s1.flags |= 2, r1) : g1) : (s1.flags |= 2, r1)) : (s1.flags |= 1048576, r1);
    }
    function j(s1) {
      return o && s1.alternate === null && (s1.flags |= 2), s1;
    }
    function K(s1, r1, g1, ne) {
      return r1 === null || r1.tag !== 6 ? (r1 = Lu(g1, s1.mode, ne), r1.return = s1, r1) : (r1 = y(r1, g1), r1.return = s1, r1);
    }
    function q(s1, r1, g1, ne) {
      var Oe = g1.type;
      return Oe === Y ? W1(s1, r1, g1.props.children, ne, g1.key) : r1 !== null && (r1.elementType === Oe || typeof Oe == "object" && Oe !== null && Oe.$$typeof === h1 && Ed(Oe) === r1.type) ? (ne = y(r1, g1.props), ne.ref = $0(s1, r1, g1), ne.return = s1, ne) : (ne = Mu(g1.type, g1.key, g1.props, null, s1.mode, ne), ne.ref = $0(s1, r1, g1), ne.return = s1, ne);
    }
    function p1(s1, r1, g1, ne) {
      return r1 === null || r1.tag !== 4 || r1.stateNode.containerInfo !== g1.containerInfo || r1.stateNode.implementation !== g1.implementation ? (r1 = Ns(g1, s1.mode, ne), r1.return = s1, r1) : (r1 = y(r1, g1.children || []), r1.return = s1, r1);
    }
    function W1(s1, r1, g1, ne, Oe) {
      return r1 === null || r1.tag !== 7 ? (r1 = Ca(g1, s1.mode, ne, Oe), r1.return = s1, r1) : (r1 = y(r1, g1), r1.return = s1, r1);
    }
    function Q1(s1, r1, g1) {
      if (typeof r1 == "string" && r1 !== "" || typeof r1 == "number") return r1 = Lu("" + r1, s1.mode, g1), r1.return = s1, r1;
      if (typeof r1 == "object" && r1 !== null) {
        switch (r1.$$typeof) {
          case B:
            return g1 = Mu(r1.type, r1.key, r1.props, null, s1.mode, g1), g1.ref = $0(s1, null, r1), g1.return = s1, g1;
          case Z:
            return r1 = Ns(r1, s1.mode, g1), r1.return = s1, r1;
          case h1:
            var ne = r1._init;
            return Q1(s1, ne(r1._payload), g1);
        }
        if (ut(r1) || b1(r1)) return r1 = Ca(r1, s1.mode, g1, null), r1.return = s1, r1;
        V3(s1, r1);
      }
      return null;
    }
    function N1(s1, r1, g1, ne) {
      var Oe = r1 !== null ? r1.key : null;
      if (typeof g1 == "string" && g1 !== "" || typeof g1 == "number") return Oe !== null ? null : K(s1, r1, "" + g1, ne);
      if (typeof g1 == "object" && g1 !== null) {
        switch (g1.$$typeof) {
          case B:
            return g1.key === Oe ? q(s1, r1, g1, ne) : null;
          case Z:
            return g1.key === Oe ? p1(s1, r1, g1, ne) : null;
          case h1:
            return Oe = g1._init, N1(
              s1,
              r1,
              Oe(g1._payload),
              ne
            );
        }
        if (ut(g1) || b1(g1)) return Oe !== null ? null : W1(s1, r1, g1, ne, null);
        V3(s1, g1);
      }
      return null;
    }
    function pe(s1, r1, g1, ne, Oe) {
      if (typeof ne == "string" && ne !== "" || typeof ne == "number") return s1 = s1.get(g1) || null, K(r1, s1, "" + ne, Oe);
      if (typeof ne == "object" && ne !== null) {
        switch (ne.$$typeof) {
          case B:
            return s1 = s1.get(ne.key === null ? g1 : ne.key) || null, q(r1, s1, ne, Oe);
          case Z:
            return s1 = s1.get(ne.key === null ? g1 : ne.key) || null, p1(r1, s1, ne, Oe);
          case h1:
            var Ke = ne._init;
            return pe(s1, r1, g1, Ke(ne._payload), Oe);
        }
        if (ut(ne) || b1(ne)) return s1 = s1.get(g1) || null, W1(r1, s1, ne, Oe, null);
        V3(r1, ne);
      }
      return null;
    }
    function Se(s1, r1, g1, ne) {
      for (var Oe = null, Ke = null, Ee = r1, Je = r1 = 0, r2 = null; Ee !== null && Je < g1.length; Je++) {
        Ee.index > Je ? (r2 = Ee, Ee = null) : r2 = Ee.sibling;
        var Tt = N1(s1, Ee, g1[Je], ne);
        if (Tt === null) {
          Ee === null && (Ee = r2);
          break;
        }
        o && Ee && Tt.alternate === null && l(s1, Ee), r1 = S(Tt, r1, Je), Ke === null ? Oe = Tt : Ke.sibling = Tt, Ke = Tt, Ee = r2;
      }
      if (Je === g1.length) return d(s1, Ee), gn && Pr(s1, Je), Oe;
      if (Ee === null) {
        for (; Je < g1.length; Je++) Ee = Q1(s1, g1[Je], ne), Ee !== null && (r1 = S(Ee, r1, Je), Ke === null ? Oe = Ee : Ke.sibling = Ee, Ke = Ee);
        return gn && Pr(s1, Je), Oe;
      }
      for (Ee = A(s1, Ee); Je < g1.length; Je++) r2 = pe(Ee, s1, Je, g1[Je], ne), r2 !== null && (o && r2.alternate !== null && Ee.delete(r2.key === null ? Je : r2.key), r1 = S(r2, r1, Je), Ke === null ? Oe = r2 : Ke.sibling = r2, Ke = r2);
      return o && Ee.forEach(function(Li) {
        return l(s1, Li);
      }), gn && Pr(s1, Je), Oe;
    }
    function Te(s1, r1, g1, ne) {
      var Oe = b1(g1);
      if (typeof Oe != "function") throw Error(i(150));
      if (g1 = Oe.call(g1), g1 == null) throw Error(i(151));
      for (var Ke = Oe = null, Ee = r1, Je = r1 = 0, r2 = null, Tt = g1.next(); Ee !== null && !Tt.done; Je++, Tt = g1.next()) {
        Ee.index > Je ? (r2 = Ee, Ee = null) : r2 = Ee.sibling;
        var Li = N1(s1, Ee, Tt.value, ne);
        if (Li === null) {
          Ee === null && (Ee = r2);
          break;
        }
        o && Ee && Li.alternate === null && l(s1, Ee), r1 = S(Li, r1, Je), Ke === null ? Oe = Li : Ke.sibling = Li, Ke = Li, Ee = r2;
      }
      if (Tt.done) return d(
        s1,
        Ee
      ), gn && Pr(s1, Je), Oe;
      if (Ee === null) {
        for (; !Tt.done; Je++, Tt = g1.next()) Tt = Q1(s1, Tt.value, ne), Tt !== null && (r1 = S(Tt, r1, Je), Ke === null ? Oe = Tt : Ke.sibling = Tt, Ke = Tt);
        return gn && Pr(s1, Je), Oe;
      }
      for (Ee = A(s1, Ee); !Tt.done; Je++, Tt = g1.next()) Tt = pe(Ee, s1, Je, Tt.value, ne), Tt !== null && (o && Tt.alternate !== null && Ee.delete(Tt.key === null ? Je : Tt.key), r1 = S(Tt, r1, Je), Ke === null ? Oe = Tt : Ke.sibling = Tt, Ke = Tt);
      return o && Ee.forEach(function(Z6) {
        return l(s1, Z6);
      }), gn && Pr(s1, Je), Oe;
    }
    function Pn(s1, r1, g1, ne) {
      if (typeof g1 == "object" && g1 !== null && g1.type === Y && g1.key === null && (g1 = g1.props.children), typeof g1 == "object" && g1 !== null) {
        switch (g1.$$typeof) {
          case B:
            e: {
              for (var Oe = g1.key, Ke = r1; Ke !== null; ) {
                if (Ke.key === Oe) {
                  if (Oe = g1.type, Oe === Y) {
                    if (Ke.tag === 7) {
                      d(s1, Ke.sibling), r1 = y(Ke, g1.props.children), r1.return = s1, s1 = r1;
                      break e;
                    }
                  } else if (Ke.elementType === Oe || typeof Oe == "object" && Oe !== null && Oe.$$typeof === h1 && Ed(Oe) === Ke.type) {
                    d(s1, Ke.sibling), r1 = y(Ke, g1.props), r1.ref = $0(s1, Ke, g1), r1.return = s1, s1 = r1;
                    break e;
                  }
                  d(s1, Ke);
                  break;
                } else l(s1, Ke);
                Ke = Ke.sibling;
              }
              g1.type === Y ? (r1 = Ca(g1.props.children, s1.mode, ne, g1.key), r1.return = s1, s1 = r1) : (ne = Mu(g1.type, g1.key, g1.props, null, s1.mode, ne), ne.ref = $0(s1, r1, g1), ne.return = s1, s1 = ne);
            }
            return j(s1);
          case Z:
            e: {
              for (Ke = g1.key; r1 !== null; ) {
                if (r1.key === Ke) if (r1.tag === 4 && r1.stateNode.containerInfo === g1.containerInfo && r1.stateNode.implementation === g1.implementation) {
                  d(s1, r1.sibling), r1 = y(r1, g1.children || []), r1.return = s1, s1 = r1;
                  break e;
                } else {
                  d(s1, r1);
                  break;
                }
                else l(s1, r1);
                r1 = r1.sibling;
              }
              r1 = Ns(g1, s1.mode, ne), r1.return = s1, s1 = r1;
            }
            return j(s1);
          case h1:
            return Ke = g1._init, Pn(s1, r1, Ke(g1._payload), ne);
        }
        if (ut(g1)) return Se(s1, r1, g1, ne);
        if (b1(g1)) return Te(s1, r1, g1, ne);
        V3(s1, g1);
      }
      return typeof g1 == "string" && g1 !== "" || typeof g1 == "number" ? (g1 = "" + g1, r1 !== null && r1.tag === 6 ? (d(s1, r1.sibling), r1 = y(r1, g1), r1.return = s1, s1 = r1) : (d(s1, r1), r1 = Lu(g1, s1.mode, ne), r1.return = s1, s1 = r1), j(s1)) : d(s1, r1);
    }
    return Pn;
  }
  var Xa = Wl(!0), Md = Wl(!1), wi = tt(null), $n = null, oe = null, a3 = null;
  function Br() {
    a3 = oe = $n = null;
  }
  function m4(o) {
    var l = wi.current;
    Ot(wi), o._currentValue = l;
  }
  function v4(o, l, d) {
    for (; o !== null; ) {
      var A = o.alternate;
      if ((o.childLanes & l) !== l ? (o.childLanes |= l, A !== null && (A.childLanes |= l)) : A !== null && (A.childLanes & l) !== l && (A.childLanes |= l), o === d) break;
      o = o.return;
    }
  }
  function Ga(o, l) {
    $n = o, a3 = oe = null, o = o.dependencies, o !== null && o.firstContext !== null && (o.lanes & l && (br = !0), o.firstContext = null);
  }
  function o3(o) {
    var l = o._currentValue;
    if (a3 !== o) if (o = { context: o, memoizedValue: l, next: null }, oe === null) {
      if ($n === null) throw Error(i(308));
      oe = o, $n.dependencies = { lanes: 0, firstContext: o };
    } else oe = oe.next = o;
    return l;
  }
  var ea = null;
  function _n(o) {
    ea === null ? ea = [o] : ea.push(o);
  }
  function Td(o, l, d, A) {
    var y = l.interleaved;
    return y === null ? (d.next = d, _n(l)) : (d.next = y.next, y.next = d), l.interleaved = d, xi(o, A);
  }
  function xi(o, l) {
    o.lanes |= l;
    var d = o.alternate;
    for (d !== null && (d.lanes |= l), d = o, o = o.return; o !== null; ) o.childLanes |= l, d = o.alternate, d !== null && (d.childLanes |= l), d = o, o = o.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var r0 = !1;
  function _l(o) {
    o.updateQueue = { baseState: o.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function qa(o, l) {
    o = o.updateQueue, l.updateQueue === o && (l.updateQueue = { baseState: o.baseState, firstBaseUpdate: o.firstBaseUpdate, lastBaseUpdate: o.lastBaseUpdate, shared: o.shared, effects: o.effects });
  }
  function vr(o, l) {
    return { eventTime: o, lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function i0(o, l, d) {
    var A = o.updateQueue;
    if (A === null) return null;
    if (A = A.shared, At & 2) {
      var y = A.pending;
      return y === null ? l.next = l : (l.next = y.next, y.next = l), A.pending = l, xi(o, d);
    }
    return y = A.interleaved, y === null ? (l.next = l, _n(A)) : (l.next = y.next, y.next = l), A.interleaved = l, xi(o, d);
  }
  function Vl(o, l, d) {
    if (l = l.updateQueue, l !== null && (l = l.shared, (d & 4194240) !== 0)) {
      var A = l.lanes;
      A &= o.pendingLanes, d |= A, l.lanes = d, H0(o, d);
    }
  }
  function Ld(o, l) {
    var d = o.updateQueue, A = o.alternate;
    if (A !== null && (A = A.updateQueue, d === A)) {
      var y = null, S = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var j = { eventTime: d.eventTime, lane: d.lane, tag: d.tag, payload: d.payload, callback: d.callback, next: null };
          S === null ? y = S = j : S = S.next = j, d = d.next;
        } while (d !== null);
        S === null ? y = S = l : S = S.next = l;
      } else y = S = l;
      d = { baseState: A.baseState, firstBaseUpdate: y, lastBaseUpdate: S, shared: A.shared, effects: A.effects }, o.updateQueue = d;
      return;
    }
    o = d.lastBaseUpdate, o === null ? d.firstBaseUpdate = l : o.next = l, d.lastBaseUpdate = l;
  }
  function Kl(o, l, d, A) {
    var y = o.updateQueue;
    r0 = !1;
    var S = y.firstBaseUpdate, j = y.lastBaseUpdate, K = y.shared.pending;
    if (K !== null) {
      y.shared.pending = null;
      var q = K, p1 = q.next;
      q.next = null, j === null ? S = p1 : j.next = p1, j = q;
      var W1 = o.alternate;
      W1 !== null && (W1 = W1.updateQueue, K = W1.lastBaseUpdate, K !== j && (K === null ? W1.firstBaseUpdate = p1 : K.next = p1, W1.lastBaseUpdate = q));
    }
    if (S !== null) {
      var Q1 = y.baseState;
      j = 0, W1 = p1 = q = null, K = S;
      do {
        var N1 = K.lane, pe = K.eventTime;
        if ((A & N1) === N1) {
          W1 !== null && (W1 = W1.next = {
            eventTime: pe,
            lane: 0,
            tag: K.tag,
            payload: K.payload,
            callback: K.callback,
            next: null
          });
          e: {
            var Se = o, Te = K;
            switch (N1 = l, pe = d, Te.tag) {
              case 1:
                if (Se = Te.payload, typeof Se == "function") {
                  Q1 = Se.call(pe, Q1, N1);
                  break e;
                }
                Q1 = Se;
                break e;
              case 3:
                Se.flags = Se.flags & -65537 | 128;
              case 0:
                if (Se = Te.payload, N1 = typeof Se == "function" ? Se.call(pe, Q1, N1) : Se, N1 == null) break e;
                Q1 = t1({}, Q1, N1);
                break e;
              case 2:
                r0 = !0;
            }
          }
          K.callback !== null && K.lane !== 0 && (o.flags |= 64, N1 = y.effects, N1 === null ? y.effects = [K] : N1.push(K));
        } else pe = { eventTime: pe, lane: N1, tag: K.tag, payload: K.payload, callback: K.callback, next: null }, W1 === null ? (p1 = W1 = pe, q = Q1) : W1 = W1.next = pe, j |= N1;
        if (K = K.next, K === null) {
          if (K = y.shared.pending, K === null) break;
          N1 = K, K = N1.next, N1.next = null, y.lastBaseUpdate = N1, y.shared.pending = null;
        }
      } while (!0);
      if (W1 === null && (q = Q1), y.baseState = q, y.firstBaseUpdate = p1, y.lastBaseUpdate = W1, l = y.shared.interleaved, l !== null) {
        y = l;
        do
          j |= y.lane, y = y.next;
        while (y !== l);
      } else S === null && (y.shared.lanes = 0);
      ca |= j, o.lanes = j, o.memoizedState = Q1;
    }
  }
  function Rd(o, l, d) {
    if (o = l.effects, l.effects = null, o !== null) for (l = 0; l < o.length; l++) {
      var A = o[l], y = A.callback;
      if (y !== null) {
        if (A.callback = null, A = d, typeof y != "function") throw Error(i(191, y));
        y.call(A);
      }
    }
  }
  var ms = {}, E3 = tt(ms), Za = tt(ms), vs = tt(ms);
  function ta(o) {
    if (o === ms) throw Error(i(174));
    return o;
  }
  function y4(o, l) {
    switch (Pt(vs, l), Pt(Za, o), Pt(E3, ms), o = l.nodeType, o) {
      case 9:
      case 11:
        l = (l = l.documentElement) ? l.namespaceURI : rt(null, "");
        break;
      default:
        o = o === 8 ? l.parentNode : l, l = o.namespaceURI || null, o = o.tagName, l = rt(l, o);
    }
    Ot(E3), Pt(E3, l);
  }
  function $a() {
    Ot(E3), Ot(Za), Ot(vs);
  }
  function Od(o) {
    ta(vs.current);
    var l = ta(E3.current), d = rt(l, o.type);
    l !== d && (Pt(Za, o), Pt(E3, d));
  }
  function b4(o) {
    Za.current === o && (Ot(E3), Ot(Za));
  }
  var hn = tt(0);
  function Jl(o) {
    for (var l = o; l !== null; ) {
      if (l.tag === 13) {
        var d = l.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return l;
      } else if (l.tag === 19 && l.memoizedProps.revealOrder !== void 0) {
        if (l.flags & 128) return l;
      } else if (l.child !== null) {
        l.child.return = l, l = l.child;
        continue;
      }
      if (l === o) break;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === o) return null;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
    return null;
  }
  var Yl = [];
  function w4() {
    for (var o = 0; o < Yl.length; o++) Yl[o]._workInProgressVersionPrimary = null;
    Yl.length = 0;
  }
  var Ql = X.ReactCurrentDispatcher, ys = X.ReactCurrentBatchConfig, Re = 0, je = null, Ge = null, ct = null, Hr = !1, eo = !1, bs = 0, z6 = 0;
  function H2() {
    throw Error(i(321));
  }
  function ws(o, l) {
    if (l === null) return !1;
    for (var d = 0; d < l.length && d < o.length; d++) if (!$r(o[d], l[d])) return !1;
    return !0;
  }
  function z1(o, l, d, A, y, S) {
    if (Re = S, je = l, l.memoizedState = null, l.updateQueue = null, l.lanes = 0, Ql.current = o === null || o.memoizedState === null ? N6 : un, o = d(A, y), eo) {
      S = 0;
      do {
        if (eo = !1, bs = 0, 25 <= S) throw Error(i(301));
        S += 1, ct = Ge = null, l.updateQueue = null, Ql.current = uu, o = d(A, y);
      } while (eo);
    }
    if (Ql.current = U2, l = Ge !== null && Ge.next !== null, Re = 0, ct = Ge = je = null, Hr = !1, l) throw Error(i(300));
    return o;
  }
  function Vn() {
    var o = bs !== 0;
    return bs = 0, o;
  }
  function Ne() {
    var o = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return ct === null ? je.memoizedState = ct = o : ct = ct.next = o, ct;
  }
  function x2() {
    if (Ge === null) {
      var o = je.alternate;
      o = o !== null ? o.memoizedState : null;
    } else o = Ge.next;
    var l = ct === null ? je.memoizedState : ct.next;
    if (l !== null) ct = l, Ge = o;
    else {
      if (o === null) throw Error(i(310));
      Ge = o, o = { memoizedState: Ge.memoizedState, baseState: Ge.baseState, baseQueue: Ge.baseQueue, queue: Ge.queue, next: null }, ct === null ? je.memoizedState = ct = o : ct = ct.next = o;
    }
    return ct;
  }
  function Ur(o, l) {
    return typeof l == "function" ? l(o) : l;
  }
  function Si(o) {
    var l = x2(), d = l.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = o;
    var A = Ge, y = A.baseQueue, S = d.pending;
    if (S !== null) {
      if (y !== null) {
        var j = y.next;
        y.next = S.next, S.next = j;
      }
      A.baseQueue = y = S, d.pending = null;
    }
    if (y !== null) {
      S = y.next, A = A.baseState;
      var K = j = null, q = null, p1 = S;
      do {
        var W1 = p1.lane;
        if ((Re & W1) === W1) q !== null && (q = q.next = { lane: 0, action: p1.action, hasEagerState: p1.hasEagerState, eagerState: p1.eagerState, next: null }), A = p1.hasEagerState ? p1.eagerState : o(A, p1.action);
        else {
          var Q1 = {
            lane: W1,
            action: p1.action,
            hasEagerState: p1.hasEagerState,
            eagerState: p1.eagerState,
            next: null
          };
          q === null ? (K = q = Q1, j = A) : q = q.next = Q1, je.lanes |= W1, ca |= W1;
        }
        p1 = p1.next;
      } while (p1 !== null && p1 !== S);
      q === null ? j = A : q.next = K, $r(A, l.memoizedState) || (br = !0), l.memoizedState = A, l.baseState = j, l.baseQueue = q, d.lastRenderedState = A;
    }
    if (o = d.interleaved, o !== null) {
      y = o;
      do
        S = y.lane, je.lanes |= S, ca |= S, y = y.next;
      while (y !== o);
    } else y === null && (d.lanes = 0);
    return [l.memoizedState, d.dispatch];
  }
  function s3(o) {
    var l = x2(), d = l.queue;
    if (d === null) throw Error(i(311));
    d.lastRenderedReducer = o;
    var A = d.dispatch, y = d.pending, S = l.memoizedState;
    if (y !== null) {
      d.pending = null;
      var j = y = y.next;
      do
        S = o(S, j.action), j = j.next;
      while (j !== y);
      $r(S, l.memoizedState) || (br = !0), l.memoizedState = S, l.baseQueue === null && (l.baseState = S), d.lastRenderedState = S;
    }
    return [S, A];
  }
  function to() {
  }
  function na(o, l) {
    var d = je, A = x2(), y = l(), S = !$r(A.memoizedState, y);
    if (S && (A.memoizedState = y, br = !0), A = A.queue, xs(Gl.bind(null, d, A, o), [o]), A.getSnapshot !== l || S || ct !== null && ct.memoizedState.tag & 1) {
      if (d.flags |= 2048, ra(9, Xl.bind(null, d, A, y, l), void 0, null), Ln === null) throw Error(i(349));
      Re & 30 || no(d, l, y);
    }
    return y;
  }
  function no(o, l, d) {
    o.flags |= 16384, o = { getSnapshot: l, value: d }, l = je.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, je.updateQueue = l, l.stores = [o]) : (d = l.stores, d === null ? l.stores = [o] : d.push(o));
  }
  function Xl(o, l, d, A) {
    l.value = d, l.getSnapshot = A, ql(l) && Zl(o);
  }
  function Gl(o, l, d) {
    return d(function() {
      ql(l) && Zl(o);
    });
  }
  function ql(o) {
    var l = o.getSnapshot;
    o = o.value;
    try {
      var d = l();
      return !$r(o, d);
    } catch {
      return !0;
    }
  }
  function Zl(o) {
    var l = xi(o, 1);
    l !== null && wn(l, o, 1, -1);
  }
  function $l(o) {
    var l = Ne();
    return typeof o == "function" && (o = o()), l.memoizedState = l.baseState = o, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Ur, lastRenderedState: o }, l.queue = o, o = o.dispatch = Ss.bind(null, je, o), [l.memoizedState, o];
  }
  function ra(o, l, d, A) {
    return o = { tag: o, create: l, destroy: d, deps: A, next: null }, l = je.updateQueue, l === null ? (l = { lastEffect: null, stores: null }, je.updateQueue = l, l.lastEffect = o.next = o) : (d = l.lastEffect, d === null ? l.lastEffect = o.next = o : (A = d.next, d.next = o, o.next = A, l.lastEffect = o)), o;
  }
  function eu() {
    return x2().memoizedState;
  }
  function ro(o, l, d, A) {
    var y = Ne();
    je.flags |= o, y.memoizedState = ra(1 | l, d, void 0, A === void 0 ? null : A);
  }
  function io(o, l, d, A) {
    var y = x2();
    A = A === void 0 ? null : A;
    var S = void 0;
    if (Ge !== null) {
      var j = Ge.memoizedState;
      if (S = j.destroy, A !== null && ws(A, j.deps)) {
        y.memoizedState = ra(l, d, S, A);
        return;
      }
    }
    je.flags |= o, y.memoizedState = ra(1 | l, d, S, A);
  }
  function tu(o, l) {
    return ro(8390656, 8, o, l);
  }
  function xs(o, l) {
    return io(2048, 8, o, l);
  }
  function nu(o, l) {
    return io(4, 2, o, l);
  }
  function ru(o, l) {
    return io(4, 4, o, l);
  }
  function iu(o, l) {
    if (typeof l == "function") return o = o(), l(o), function() {
      l(null);
    };
    if (l != null) return o = o(), l.current = o, function() {
      l.current = null;
    };
  }
  function au(o, l, d) {
    return d = d != null ? d.concat([o]) : null, io(4, 4, iu.bind(null, l, o), d);
  }
  function ao() {
  }
  function ia(o, l) {
    var d = x2();
    l = l === void 0 ? null : l;
    var A = d.memoizedState;
    return A !== null && l !== null && ws(l, A[1]) ? A[0] : (d.memoizedState = [o, l], o);
  }
  function ou(o, l) {
    var d = x2();
    l = l === void 0 ? null : l;
    var A = d.memoizedState;
    return A !== null && l !== null && ws(l, A[1]) ? A[0] : (o = o(), d.memoizedState = [o, l], o);
  }
  function su(o, l, d) {
    return Re & 21 ? ($r(d, l) || (d = Pa(), je.lanes |= d, ca |= d, o.baseState = !0), l) : (o.baseState && (o.baseState = !1, br = !0), o.memoizedState = d);
  }
  function x4(o, l) {
    var d = Ve;
    Ve = d !== 0 && 4 > d ? d : 4, o(!0);
    var A = ys.transition;
    ys.transition = {};
    try {
      o(!1), l();
    } finally {
      Ve = d, ys.transition = A;
    }
  }
  function lu() {
    return x2().memoizedState;
  }
  function Dd(o, l, d) {
    var A = Ti(o);
    if (d = { lane: A, action: d, hasEagerState: !1, eagerState: null, next: null }, S4(o)) oo(l, d);
    else if (d = Td(o, l, d, A), d !== null) {
      var y = I2();
      wn(d, o, A, y), a0(d, l, A);
    }
  }
  function Ss(o, l, d) {
    var A = Ti(o), y = { lane: A, action: d, hasEagerState: !1, eagerState: null, next: null };
    if (S4(o)) oo(l, y);
    else {
      var S = o.alternate;
      if (o.lanes === 0 && (S === null || S.lanes === 0) && (S = l.lastRenderedReducer, S !== null)) try {
        var j = l.lastRenderedState, K = S(j, d);
        if (y.hasEagerState = !0, y.eagerState = K, $r(K, j)) {
          var q = l.interleaved;
          q === null ? (y.next = y, _n(l)) : (y.next = q.next, q.next = y), l.interleaved = y;
          return;
        }
      } catch {
      } finally {
      }
      d = Td(o, l, y, A), d !== null && (y = I2(), wn(d, o, A, y), a0(d, l, A));
    }
  }
  function S4(o) {
    var l = o.alternate;
    return o === je || l !== null && l === je;
  }
  function oo(o, l) {
    eo = Hr = !0;
    var d = o.pending;
    d === null ? l.next = l : (l.next = d.next, d.next = l), o.pending = l;
  }
  function a0(o, l, d) {
    if (d & 4194240) {
      var A = l.lanes;
      A &= o.pendingLanes, d |= A, l.lanes = d, H0(o, d);
    }
  }
  var U2 = { readContext: o3, useCallback: H2, useContext: H2, useEffect: H2, useImperativeHandle: H2, useInsertionEffect: H2, useLayoutEffect: H2, useMemo: H2, useReducer: H2, useRef: H2, useState: H2, useDebugValue: H2, useDeferredValue: H2, useTransition: H2, useMutableSource: H2, useSyncExternalStore: H2, useId: H2, unstable_isNewReconciler: !1 }, N6 = { readContext: o3, useCallback: function(o, l) {
    return Ne().memoizedState = [o, l === void 0 ? null : l], o;
  }, useContext: o3, useEffect: tu, useImperativeHandle: function(o, l, d) {
    return d = d != null ? d.concat([o]) : null, ro(
      4194308,
      4,
      iu.bind(null, l, o),
      d
    );
  }, useLayoutEffect: function(o, l) {
    return ro(4194308, 4, o, l);
  }, useInsertionEffect: function(o, l) {
    return ro(4, 2, o, l);
  }, useMemo: function(o, l) {
    var d = Ne();
    return l = l === void 0 ? null : l, o = o(), d.memoizedState = [o, l], o;
  }, useReducer: function(o, l, d) {
    var A = Ne();
    return l = d !== void 0 ? d(l) : l, A.memoizedState = A.baseState = l, o = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: o, lastRenderedState: l }, A.queue = o, o = o.dispatch = Dd.bind(null, je, o), [A.memoizedState, o];
  }, useRef: function(o) {
    var l = Ne();
    return o = { current: o }, l.memoizedState = o;
  }, useState: $l, useDebugValue: ao, useDeferredValue: function(o) {
    return Ne().memoizedState = o;
  }, useTransition: function() {
    var o = $l(!1), l = o[0];
    return o = x4.bind(null, o[1]), Ne().memoizedState = o, [l, o];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(o, l, d) {
    var A = je, y = Ne();
    if (gn) {
      if (d === void 0) throw Error(i(407));
      d = d();
    } else {
      if (d = l(), Ln === null) throw Error(i(349));
      Re & 30 || no(A, l, d);
    }
    y.memoizedState = d;
    var S = { value: d, getSnapshot: l };
    return y.queue = S, tu(Gl.bind(
      null,
      A,
      S,
      o
    ), [o]), A.flags |= 2048, ra(9, Xl.bind(null, A, S, d, l), void 0, null), d;
  }, useId: function() {
    var o = Ne(), l = Ln.identifierPrefix;
    if (gn) {
      var d = bi, A = w2;
      d = (A & ~(1 << 32 - ur(A) - 1)).toString(32) + d, l = ":" + l + "R" + d, d = bs++, 0 < d && (l += "H" + d.toString(32)), l += ":";
    } else d = z6++, l = ":" + l + "r" + d.toString(32) + ":";
    return o.memoizedState = l;
  }, unstable_isNewReconciler: !1 }, un = {
    readContext: o3,
    useCallback: ia,
    useContext: o3,
    useEffect: xs,
    useImperativeHandle: au,
    useInsertionEffect: nu,
    useLayoutEffect: ru,
    useMemo: ou,
    useReducer: Si,
    useRef: eu,
    useState: function() {
      return Si(Ur);
    },
    useDebugValue: ao,
    useDeferredValue: function(o) {
      var l = x2();
      return su(l, Ge.memoizedState, o);
    },
    useTransition: function() {
      var o = Si(Ur)[0], l = x2().memoizedState;
      return [o, l];
    },
    useMutableSource: to,
    useSyncExternalStore: na,
    useId: lu,
    unstable_isNewReconciler: !1
  }, uu = { readContext: o3, useCallback: ia, useContext: o3, useEffect: xs, useImperativeHandle: au, useInsertionEffect: nu, useLayoutEffect: ru, useMemo: ou, useReducer: s3, useRef: eu, useState: function() {
    return s3(Ur);
  }, useDebugValue: ao, useDeferredValue: function(o) {
    var l = x2();
    return Ge === null ? l.memoizedState = o : su(l, Ge.memoizedState, o);
  }, useTransition: function() {
    var o = s3(Ur)[0], l = x2().memoizedState;
    return [o, l];
  }, useMutableSource: to, useSyncExternalStore: na, useId: lu, unstable_isNewReconciler: !1 };
  function yr(o, l) {
    if (o && o.defaultProps) {
      l = t1({}, l), o = o.defaultProps;
      for (var d in o) l[d] === void 0 && (l[d] = o[d]);
      return l;
    }
    return l;
  }
  function aa(o, l, d, A) {
    l = o.memoizedState, d = d(A, l), d = d == null ? l : t1({}, l, d), o.memoizedState = d, o.lanes === 0 && (o.updateQueue.baseState = d);
  }
  var oa = { isMounted: function(o) {
    return (o = o._reactInternals) ? be(o) === o : !1;
  }, enqueueSetState: function(o, l, d) {
    o = o._reactInternals;
    var A = I2(), y = Ti(o), S = vr(A, y);
    S.payload = l, d != null && (S.callback = d), l = i0(o, S, y), l !== null && (wn(l, o, y, A), Vl(l, o, y));
  }, enqueueReplaceState: function(o, l, d) {
    o = o._reactInternals;
    var A = I2(), y = Ti(o), S = vr(A, y);
    S.tag = 1, S.payload = l, d != null && (S.callback = d), l = i0(o, S, y), l !== null && (wn(l, o, y, A), Vl(l, o, y));
  }, enqueueForceUpdate: function(o, l) {
    o = o._reactInternals;
    var d = I2(), A = Ti(o), y = vr(d, A);
    y.tag = 2, l != null && (y.callback = l), l = i0(o, y, A), l !== null && (wn(l, o, A, d), Vl(l, o, A));
  } };
  function kd(o, l, d, A, y, S, j) {
    return o = o.stateNode, typeof o.shouldComponentUpdate == "function" ? o.shouldComponentUpdate(A, S, j) : l.prototype && l.prototype.isPureReactComponent ? !ss(d, A) || !ss(y, S) : !0;
  }
  function jd(o, l, d) {
    var A = !1, y = _3, S = l.contextType;
    return typeof S == "object" && S !== null ? S = o3(S) : (y = pn(l) ? Ar : Xe.current, A = l.contextTypes, S = (A = A != null) ? t3(o, y) : _3), l = new l(d, S), o.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, l.updater = oa, o.stateNode = l, l._reactInternals = o, A && (o = o.stateNode, o.__reactInternalMemoizedUnmaskedChildContext = y, o.__reactInternalMemoizedMaskedChildContext = S), l;
  }
  function zd(o, l, d, A) {
    o = l.state, typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(d, A), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(d, A), l.state !== o && oa.enqueueReplaceState(l, l.state, null);
  }
  function E4(o, l, d, A) {
    var y = o.stateNode;
    y.props = d, y.state = o.memoizedState, y.refs = {}, _l(o);
    var S = l.contextType;
    typeof S == "object" && S !== null ? y.context = o3(S) : (S = pn(l) ? Ar : Xe.current, y.context = t3(o, S)), y.state = o.memoizedState, S = l.getDerivedStateFromProps, typeof S == "function" && (aa(o, l, S, d), y.state = o.memoizedState), typeof l.getDerivedStateFromProps == "function" || typeof y.getSnapshotBeforeUpdate == "function" || typeof y.UNSAFE_componentWillMount != "function" && typeof y.componentWillMount != "function" || (l = y.state, typeof y.componentWillMount == "function" && y.componentWillMount(), typeof y.UNSAFE_componentWillMount == "function" && y.UNSAFE_componentWillMount(), l !== y.state && oa.enqueueReplaceState(y, y.state, null), Kl(o, d, y, A), y.state = o.memoizedState), typeof y.componentDidMount == "function" && (o.flags |= 4194308);
  }
  function o0(o, l) {
    try {
      var d = "", A = l;
      do
        d += K1(A), A = A.return;
      while (A);
      var y = d;
    } catch (S) {
      y = `
Error generating stack: ` + S.message + `
` + S.stack;
    }
    return { value: o, source: l, stack: y, digest: null };
  }
  function M4(o, l, d) {
    return { value: o, source: null, stack: d ?? null, digest: l ?? null };
  }
  function Es(o, l) {
    try {
      console.error(l.value);
    } catch (d) {
      setTimeout(function() {
        throw d;
      });
    }
  }
  var Nd = typeof WeakMap == "function" ? WeakMap : Map;
  function Pd(o, l, d) {
    d = vr(-1, d), d.tag = 3, d.payload = { element: null };
    var A = l.value;
    return d.callback = function() {
      yu || (yu = !0, N4 = A), Es(o, l);
    }, d;
  }
  function Fd(o, l, d) {
    d = vr(-1, d), d.tag = 3;
    var A = o.type.getDerivedStateFromError;
    if (typeof A == "function") {
      var y = l.value;
      d.payload = function() {
        return A(y);
      }, d.callback = function() {
        Es(o, l);
      };
    }
    var S = o.stateNode;
    return S !== null && typeof S.componentDidCatch == "function" && (d.callback = function() {
      Es(o, l), typeof A != "function" && (c3 === null ? c3 = /* @__PURE__ */ new Set([this]) : c3.add(this));
      var j = l.stack;
      this.componentDidCatch(l.value, { componentStack: j !== null ? j : "" });
    }), d;
  }
  function Ms(o, l, d) {
    var A = o.pingCache;
    if (A === null) {
      A = o.pingCache = new Nd();
      var y = /* @__PURE__ */ new Set();
      A.set(l, y);
    } else y = A.get(l), y === void 0 && (y = /* @__PURE__ */ new Set(), A.set(l, y));
    y.has(d) || (y.add(d), o = J6.bind(null, o, l, d), l.then(o, o));
  }
  function Bd(o) {
    do {
      var l;
      if ((l = o.tag === 13) && (l = o.memoizedState, l = l !== null ? l.dehydrated !== null : !0), l) return o;
      o = o.return;
    } while (o !== null);
    return null;
  }
  function T4(o, l, d, A, y) {
    return o.mode & 1 ? (o.flags |= 65536, o.lanes = y, o) : (o === l ? o.flags |= 65536 : (o.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (l = vr(-1, 1), l.tag = 2, i0(d, l, 1))), d.lanes |= 1), o);
  }
  var Hd = X.ReactCurrentOwner, br = !1;
  function zn(o, l, d, A) {
    l.child = o === null ? Md(l, null, d, A) : Xa(l, o.child, d, A);
  }
  function so(o, l, d, A, y) {
    d = d.render;
    var S = l.ref;
    return Ga(l, y), A = z1(o, l, d, A, S, y), d = Vn(), o !== null && !br ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~y, Nn(o, l, y)) : (gn && d && Pl(l), l.flags |= 1, zn(o, l, A, y), l.child);
  }
  function s0(o, l, d, A, y) {
    if (o === null) {
      var S = d.type;
      return typeof S == "function" && !U4(S) && S.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (l.tag = 15, l.type = S, cu(o, l, S, A, y)) : (o = Mu(d.type, null, A, l, l.mode, y), o.ref = l.ref, o.return = l, l.child = o);
    }
    if (S = o.child, !(o.lanes & y)) {
      var j = S.memoizedProps;
      if (d = d.compare, d = d !== null ? d : ss, d(j, A) && o.ref === l.ref) return Nn(o, l, y);
    }
    return l.flags |= 1, o = c0(S, A), o.ref = l.ref, o.return = l, l.child = o;
  }
  function cu(o, l, d, A, y) {
    if (o !== null) {
      var S = o.memoizedProps;
      if (ss(S, A) && o.ref === l.ref) if (br = !1, l.pendingProps = A = S, (o.lanes & y) !== 0) o.flags & 131072 && (br = !0);
      else return l.lanes = o.lanes, Nn(o, l, y);
    }
    return et(o, l, d, A, y);
  }
  function wr(o, l, d) {
    var A = l.pendingProps, y = A.children, S = o !== null ? o.memoizedState : null;
    if (A.mode === "hidden") if (!(l.mode & 1)) l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Pt(ho, xr), xr |= d;
    else {
      if (!(d & 1073741824)) return o = S !== null ? S.baseLanes | d : d, l.lanes = l.childLanes = 1073741824, l.memoizedState = { baseLanes: o, cachePool: null, transitions: null }, l.updateQueue = null, Pt(ho, xr), xr |= o, null;
      l.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, A = S !== null ? S.baseLanes : d, Pt(ho, xr), xr |= A;
    }
    else S !== null ? (A = S.baseLanes | d, l.memoizedState = null) : A = d, Pt(ho, xr), xr |= A;
    return zn(o, l, y, d), l.child;
  }
  function sa(o, l) {
    var d = l.ref;
    (o === null && d !== null || o !== null && o.ref !== d) && (l.flags |= 512, l.flags |= 2097152);
  }
  function et(o, l, d, A, y) {
    var S = pn(d) ? Ar : Xe.current;
    return S = t3(l, S), Ga(l, y), d = z1(o, l, d, A, S, y), A = Vn(), o !== null && !br ? (l.updateQueue = o.updateQueue, l.flags &= -2053, o.lanes &= ~y, Nn(o, l, y)) : (gn && A && Pl(l), l.flags |= 1, zn(o, l, d, y), l.child);
  }
  function Ts(o, l, d, A, y) {
    if (pn(d)) {
      var S = !0;
      Nl(l);
    } else S = !1;
    if (Ga(l, y), l.stateNode === null) Rs(o, l), jd(l, d, A), E4(l, d, A, y), A = !0;
    else if (o === null) {
      var j = l.stateNode, K = l.memoizedProps;
      j.props = K;
      var q = j.context, p1 = d.contextType;
      typeof p1 == "object" && p1 !== null ? p1 = o3(p1) : (p1 = pn(d) ? Ar : Xe.current, p1 = t3(l, p1));
      var W1 = d.getDerivedStateFromProps, Q1 = typeof W1 == "function" || typeof j.getSnapshotBeforeUpdate == "function";
      Q1 || typeof j.UNSAFE_componentWillReceiveProps != "function" && typeof j.componentWillReceiveProps != "function" || (K !== A || q !== p1) && zd(l, j, A, p1), r0 = !1;
      var N1 = l.memoizedState;
      j.state = N1, Kl(l, A, j, y), q = l.memoizedState, K !== A || N1 !== q || Mn.current || r0 ? (typeof W1 == "function" && (aa(l, d, W1, A), q = l.memoizedState), (K = r0 || kd(l, d, K, A, N1, q, p1)) ? (Q1 || typeof j.UNSAFE_componentWillMount != "function" && typeof j.componentWillMount != "function" || (typeof j.componentWillMount == "function" && j.componentWillMount(), typeof j.UNSAFE_componentWillMount == "function" && j.UNSAFE_componentWillMount()), typeof j.componentDidMount == "function" && (l.flags |= 4194308)) : (typeof j.componentDidMount == "function" && (l.flags |= 4194308), l.memoizedProps = A, l.memoizedState = q), j.props = A, j.state = q, j.context = p1, A = K) : (typeof j.componentDidMount == "function" && (l.flags |= 4194308), A = !1);
    } else {
      j = l.stateNode, qa(o, l), K = l.memoizedProps, p1 = l.type === l.elementType ? K : yr(l.type, K), j.props = p1, Q1 = l.pendingProps, N1 = j.context, q = d.contextType, typeof q == "object" && q !== null ? q = o3(q) : (q = pn(d) ? Ar : Xe.current, q = t3(l, q));
      var pe = d.getDerivedStateFromProps;
      (W1 = typeof pe == "function" || typeof j.getSnapshotBeforeUpdate == "function") || typeof j.UNSAFE_componentWillReceiveProps != "function" && typeof j.componentWillReceiveProps != "function" || (K !== Q1 || N1 !== q) && zd(l, j, A, q), r0 = !1, N1 = l.memoizedState, j.state = N1, Kl(l, A, j, y);
      var Se = l.memoizedState;
      K !== Q1 || N1 !== Se || Mn.current || r0 ? (typeof pe == "function" && (aa(l, d, pe, A), Se = l.memoizedState), (p1 = r0 || kd(l, d, p1, A, N1, Se, q) || !1) ? (W1 || typeof j.UNSAFE_componentWillUpdate != "function" && typeof j.componentWillUpdate != "function" || (typeof j.componentWillUpdate == "function" && j.componentWillUpdate(A, Se, q), typeof j.UNSAFE_componentWillUpdate == "function" && j.UNSAFE_componentWillUpdate(A, Se, q)), typeof j.componentDidUpdate == "function" && (l.flags |= 4), typeof j.getSnapshotBeforeUpdate == "function" && (l.flags |= 1024)) : (typeof j.componentDidUpdate != "function" || K === o.memoizedProps && N1 === o.memoizedState || (l.flags |= 4), typeof j.getSnapshotBeforeUpdate != "function" || K === o.memoizedProps && N1 === o.memoizedState || (l.flags |= 1024), l.memoizedProps = A, l.memoizedState = Se), j.props = A, j.state = Se, j.context = q, A = p1) : (typeof j.componentDidUpdate != "function" || K === o.memoizedProps && N1 === o.memoizedState || (l.flags |= 4), typeof j.getSnapshotBeforeUpdate != "function" || K === o.memoizedProps && N1 === o.memoizedState || (l.flags |= 1024), A = !1);
    }
    return gu(o, l, d, A, S, y);
  }
  function gu(o, l, d, A, y, S) {
    sa(o, l);
    var j = (l.flags & 128) !== 0;
    if (!A && !j) return y && bd(l, d, !1), Nn(o, l, S);
    A = l.stateNode, Hd.current = l;
    var K = j && typeof d.getDerivedStateFromError != "function" ? null : A.render();
    return l.flags |= 1, o !== null && j ? (l.child = Xa(l, o.child, null, S), l.child = Xa(l, null, K, S)) : zn(o, l, K, S), l.memoizedState = A.state, y && bd(l, d, !0), l.child;
  }
  function P6(o) {
    var l = o.stateNode;
    l.pendingContext ? t0(o, l.pendingContext, l.pendingContext !== l.context) : l.context && t0(o, l.context, !1), y4(o, l.containerInfo);
  }
  function Ud(o, l, d, A, y) {
    return bn(), h4(y), l.flags |= 256, zn(o, l, d, A), l.child;
  }
  var Ls = { dehydrated: null, treeContext: null, retryLane: 0 };
  function la(o) {
    return { baseLanes: o, cachePool: null, transitions: null };
  }
  function Wd(o, l, d) {
    var A = l.pendingProps, y = hn.current, S = !1, j = (l.flags & 128) !== 0, K;
    if ((K = j) || (K = o !== null && o.memoizedState === null ? !1 : (y & 2) !== 0), K ? (S = !0, l.flags &= -129) : (o === null || o.memoizedState !== null) && (y |= 1), Pt(hn, y & 1), o === null)
      return Bl(l), o = l.memoizedState, o !== null && (o = o.dehydrated, o !== null) ? (l.mode & 1 ? o.data === "$!" ? l.lanes = 8 : l.lanes = 1073741824 : l.lanes = 1, null) : (j = A.children, o = A.fallback, S ? (A = l.mode, S = l.child, j = { mode: "hidden", children: j }, !(A & 1) && S !== null ? (S.childLanes = 0, S.pendingProps = j) : S = Tu(j, A, 0, null), o = Ca(o, A, d, null), S.return = l, o.return = l, S.sibling = o, l.child = S, l.child.memoizedState = la(d), l.memoizedState = Ls, o) : fu(l, j));
    if (y = o.memoizedState, y !== null && (K = y.dehydrated, K !== null)) return L4(o, l, j, A, K, y, d);
    if (S) {
      S = A.fallback, j = l.mode, y = o.child, K = y.sibling;
      var q = { mode: "hidden", children: A.children };
      return !(j & 1) && l.child !== y ? (A = l.child, A.childLanes = 0, A.pendingProps = q, l.deletions = null) : (A = c0(y, q), A.subtreeFlags = y.subtreeFlags & 14680064), K !== null ? S = c0(K, S) : (S = Ca(S, j, d, null), S.flags |= 2), S.return = l, A.return = l, A.sibling = S, l.child = A, A = S, S = l.child, j = o.child.memoizedState, j = j === null ? la(d) : { baseLanes: j.baseLanes | d, cachePool: null, transitions: j.transitions }, S.memoizedState = j, S.childLanes = o.childLanes & ~d, l.memoizedState = Ls, A;
    }
    return S = o.child, o = S.sibling, A = c0(S, { mode: "visible", children: A.children }), !(l.mode & 1) && (A.lanes = d), A.return = l, A.sibling = null, o !== null && (d = l.deletions, d === null ? (l.deletions = [o], l.flags |= 16) : d.push(o)), l.child = A, l.memoizedState = null, A;
  }
  function fu(o, l) {
    return l = Tu({ mode: "visible", children: l }, o.mode, 0, null), l.return = o, o.child = l;
  }
  function du(o, l, d, A) {
    return A !== null && h4(A), Xa(l, o.child, null, d), o = fu(l, l.pendingProps.children), o.flags |= 2, l.memoizedState = null, o;
  }
  function L4(o, l, d, A, y, S, j) {
    if (d)
      return l.flags & 256 ? (l.flags &= -257, A = M4(Error(i(422))), du(o, l, j, A)) : l.memoizedState !== null ? (l.child = o.child, l.flags |= 128, null) : (S = A.fallback, y = l.mode, A = Tu({ mode: "visible", children: A.children }, y, 0, null), S = Ca(S, y, j, null), S.flags |= 2, A.return = l, S.return = l, A.sibling = S, l.child = A, l.mode & 1 && Xa(l, o.child, null, j), l.child.memoizedState = la(j), l.memoizedState = Ls, S);
    if (!(l.mode & 1)) return du(o, l, j, null);
    if (y.data === "$!") {
      if (A = y.nextSibling && y.nextSibling.dataset, A) var K = A.dgst;
      return A = K, S = Error(i(419)), A = M4(S, A, void 0), du(o, l, j, A);
    }
    if (K = (j & o.childLanes) !== 0, br || K) {
      if (A = Ln, A !== null) {
        switch (j & -j) {
          case 4:
            y = 2;
            break;
          case 16:
            y = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            y = 32;
            break;
          case 536870912:
            y = 268435456;
            break;
          default:
            y = 0;
        }
        y = y & (A.suspendedLanes | j) ? 0 : y, y !== 0 && y !== S.retryLane && (S.retryLane = y, xi(o, y), wn(A, o, y, -1));
      }
      return zs(), A = M4(Error(i(421))), du(o, l, j, A);
    }
    return y.data === "$?" ? (l.flags |= 128, l.child = o.child, l = H4.bind(null, o), y._reactRetry = l, null) : (o = S.treeContext, mr = S3(y.nextSibling), Fr = l, gn = !0, i3 = null, o !== null && (hr[B2++] = w2, hr[B2++] = bi, hr[B2++] = r3, w2 = o.id, bi = o.overflow, r3 = l), l = fu(l, A.children), l.flags |= 4096, l);
  }
  function _d(o, l, d) {
    o.lanes |= l;
    var A = o.alternate;
    A !== null && (A.lanes |= l), v4(o.return, l, d);
  }
  function Cu(o, l, d, A, y) {
    var S = o.memoizedState;
    S === null ? o.memoizedState = { isBackwards: l, rendering: null, renderingStartTime: 0, last: A, tail: d, tailMode: y } : (S.isBackwards = l, S.rendering = null, S.renderingStartTime = 0, S.last = A, S.tail = d, S.tailMode = y);
  }
  function R4(o, l, d) {
    var A = l.pendingProps, y = A.revealOrder, S = A.tail;
    if (zn(o, l, A.children, d), A = hn.current, A & 2) A = A & 1 | 2, l.flags |= 128;
    else {
      if (o !== null && o.flags & 128) e: for (o = l.child; o !== null; ) {
        if (o.tag === 13) o.memoizedState !== null && _d(o, d, l);
        else if (o.tag === 19) _d(o, d, l);
        else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === l) break e;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === l) break e;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      A &= 1;
    }
    if (Pt(hn, A), !(l.mode & 1)) l.memoizedState = null;
    else switch (y) {
      case "forwards":
        for (d = l.child, y = null; d !== null; ) o = d.alternate, o !== null && Jl(o) === null && (y = d), d = d.sibling;
        d = y, d === null ? (y = l.child, l.child = null) : (y = d.sibling, d.sibling = null), Cu(l, !1, y, d, S);
        break;
      case "backwards":
        for (d = null, y = l.child, l.child = null; y !== null; ) {
          if (o = y.alternate, o !== null && Jl(o) === null) {
            l.child = y;
            break;
          }
          o = y.sibling, y.sibling = d, d = y, y = o;
        }
        Cu(l, !0, d, null, S);
        break;
      case "together":
        Cu(l, !1, null, null, void 0);
        break;
      default:
        l.memoizedState = null;
    }
    return l.child;
  }
  function Rs(o, l) {
    !(l.mode & 1) && o !== null && (o.alternate = null, l.alternate = null, l.flags |= 2);
  }
  function Nn(o, l, d) {
    if (o !== null && (l.dependencies = o.dependencies), ca |= l.lanes, !(d & l.childLanes)) return null;
    if (o !== null && l.child !== o.child) throw Error(i(153));
    if (l.child !== null) {
      for (o = l.child, d = c0(o, o.pendingProps), l.child = d, d.return = l; o.sibling !== null; ) o = o.sibling, d = d.sibling = c0(o, o.pendingProps), d.return = l;
      d.sibling = null;
    }
    return l.child;
  }
  function Ei(o, l, d) {
    switch (l.tag) {
      case 3:
        P6(l), bn();
        break;
      case 5:
        Od(l);
        break;
      case 1:
        pn(l.type) && Nl(l);
        break;
      case 4:
        y4(l, l.stateNode.containerInfo);
        break;
      case 10:
        var A = l.type._context, y = l.memoizedProps.value;
        Pt(wi, A._currentValue), A._currentValue = y;
        break;
      case 13:
        if (A = l.memoizedState, A !== null)
          return A.dehydrated !== null ? (Pt(hn, hn.current & 1), l.flags |= 128, null) : d & l.child.childLanes ? Wd(o, l, d) : (Pt(hn, hn.current & 1), o = Nn(o, l, d), o !== null ? o.sibling : null);
        Pt(hn, hn.current & 1);
        break;
      case 19:
        if (A = (d & l.childLanes) !== 0, o.flags & 128) {
          if (A) return R4(o, l, d);
          l.flags |= 128;
        }
        if (y = l.memoizedState, y !== null && (y.rendering = null, y.tail = null, y.lastEffect = null), Pt(hn, hn.current), A) break;
        return null;
      case 22:
      case 23:
        return l.lanes = 0, wr(o, l, d);
    }
    return Nn(o, l, d);
  }
  var K3, lo, uo, l3;
  K3 = function(o, l) {
    for (var d = l.child; d !== null; ) {
      if (d.tag === 5 || d.tag === 6) o.appendChild(d.stateNode);
      else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === l) break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === l) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, lo = function() {
  }, uo = function(o, l, d, A) {
    var y = o.memoizedProps;
    if (y !== A) {
      o = l.stateNode, ta(E3.current);
      var S = null;
      switch (d) {
        case "input":
          y = y1(o, y), A = y1(o, A), S = [];
          break;
        case "select":
          y = t1({}, y, { value: void 0 }), A = t1({}, A, { value: void 0 }), S = [];
          break;
        case "textarea":
          y = Ae(o, y), A = Ae(o, A), S = [];
          break;
        default:
          typeof y.onClick != "function" && typeof A.onClick == "function" && (o.onclick = zl);
      }
      An(d, A);
      var j;
      d = null;
      for (p1 in y) if (!A.hasOwnProperty(p1) && y.hasOwnProperty(p1) && y[p1] != null) if (p1 === "style") {
        var K = y[p1];
        for (j in K) K.hasOwnProperty(j) && (d || (d = {}), d[j] = "");
      } else p1 !== "dangerouslySetInnerHTML" && p1 !== "children" && p1 !== "suppressContentEditableWarning" && p1 !== "suppressHydrationWarning" && p1 !== "autoFocus" && (s.hasOwnProperty(p1) ? S || (S = []) : (S = S || []).push(p1, null));
      for (p1 in A) {
        var q = A[p1];
        if (K = y != null ? y[p1] : void 0, A.hasOwnProperty(p1) && q !== K && (q != null || K != null)) if (p1 === "style") if (K) {
          for (j in K) !K.hasOwnProperty(j) || q && q.hasOwnProperty(j) || (d || (d = {}), d[j] = "");
          for (j in q) q.hasOwnProperty(j) && K[j] !== q[j] && (d || (d = {}), d[j] = q[j]);
        } else d || (S || (S = []), S.push(
          p1,
          d
        )), d = q;
        else p1 === "dangerouslySetInnerHTML" ? (q = q ? q.__html : void 0, K = K ? K.__html : void 0, q != null && K !== q && (S = S || []).push(p1, q)) : p1 === "children" ? typeof q != "string" && typeof q != "number" || (S = S || []).push(p1, "" + q) : p1 !== "suppressContentEditableWarning" && p1 !== "suppressHydrationWarning" && (s.hasOwnProperty(p1) ? (q != null && p1 === "onScroll" && on("scroll", o), S || K === q || (S = [])) : (S = S || []).push(p1, q));
      }
      d && (S = S || []).push("style", d);
      var p1 = S;
      (l.updateQueue = p1) && (l.flags |= 4);
    }
  }, l3 = function(o, l, d, A) {
    d !== A && (l.flags |= 4);
  };
  function Tn(o, l) {
    if (!gn) switch (o.tailMode) {
      case "hidden":
        l = o.tail;
        for (var d = null; l !== null; ) l.alternate !== null && (d = l), l = l.sibling;
        d === null ? o.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = o.tail;
        for (var A = null; d !== null; ) d.alternate !== null && (A = d), d = d.sibling;
        A === null ? l || o.tail === null ? o.tail = null : o.tail.sibling = null : A.sibling = null;
    }
  }
  function W2(o) {
    var l = o.alternate !== null && o.alternate.child === o.child, d = 0, A = 0;
    if (l) for (var y = o.child; y !== null; ) d |= y.lanes | y.childLanes, A |= y.subtreeFlags & 14680064, A |= y.flags & 14680064, y.return = o, y = y.sibling;
    else for (y = o.child; y !== null; ) d |= y.lanes | y.childLanes, A |= y.subtreeFlags, A |= y.flags, y.return = o, y = y.sibling;
    return o.subtreeFlags |= A, o.childLanes = d, l;
  }
  function F6(o, l, d) {
    var A = l.pendingProps;
    switch (I4(l), l.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return W2(l), null;
      case 1:
        return pn(l.type) && n3(), W2(l), null;
      case 3:
        return A = l.stateNode, $a(), Ot(Mn), Ot(Xe), w4(), A.pendingContext && (A.context = A.pendingContext, A.pendingContext = null), (o === null || o.child === null) && (Hl(l) ? l.flags |= 4 : o === null || o.memoizedState.isDehydrated && !(l.flags & 256) || (l.flags |= 1024, i3 !== null && (P4(i3), i3 = null))), lo(o, l), W2(l), null;
      case 5:
        b4(l);
        var y = ta(vs.current);
        if (d = l.type, o !== null && l.stateNode != null) uo(o, l, d, A, y), o.ref !== l.ref && (l.flags |= 512, l.flags |= 2097152);
        else {
          if (!A) {
            if (l.stateNode === null) throw Error(i(166));
            return W2(l), null;
          }
          if (o = ta(E3.current), Hl(l)) {
            A = l.stateNode, d = l.type;
            var S = l.memoizedProps;
            switch (A[W3] = l, A[q0] = S, o = (l.mode & 1) !== 0, d) {
              case "dialog":
                on("cancel", A), on("close", A);
                break;
              case "iframe":
              case "object":
              case "embed":
                on("load", A);
                break;
              case "video":
              case "audio":
                for (y = 0; y < gs.length; y++) on(gs[y], A);
                break;
              case "source":
                on("error", A);
                break;
              case "img":
              case "image":
              case "link":
                on(
                  "error",
                  A
                ), on("load", A);
                break;
              case "details":
                on("toggle", A);
                break;
              case "input":
                ie(A, S), on("invalid", A);
                break;
              case "select":
                A._wrapperState = { wasMultiple: !!S.multiple }, on("invalid", A);
                break;
              case "textarea":
                Bt(A, S), on("invalid", A);
            }
            An(d, S), y = null;
            for (var j in S) if (S.hasOwnProperty(j)) {
              var K = S[j];
              j === "children" ? typeof K == "string" ? A.textContent !== K && (S.suppressHydrationWarning !== !0 && jl(A.textContent, K, o), y = ["children", K]) : typeof K == "number" && A.textContent !== "" + K && (S.suppressHydrationWarning !== !0 && jl(
                A.textContent,
                K,
                o
              ), y = ["children", "" + K]) : s.hasOwnProperty(j) && K != null && j === "onScroll" && on("scroll", A);
            }
            switch (d) {
              case "input":
                X1(A), Y1(A, S, !0);
                break;
              case "textarea":
                X1(A), bt(A);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof S.onClick == "function" && (A.onclick = zl);
            }
            A = y, l.updateQueue = A, A !== null && (l.flags |= 4);
          } else {
            j = y.nodeType === 9 ? y : y.ownerDocument, o === "http://www.w3.org/1999/xhtml" && (o = pt(d)), o === "http://www.w3.org/1999/xhtml" ? d === "script" ? (o = j.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild)) : typeof A.is == "string" ? o = j.createElement(d, { is: A.is }) : (o = j.createElement(d), d === "select" && (j = o, A.multiple ? j.multiple = !0 : A.size && (j.size = A.size))) : o = j.createElementNS(o, d), o[W3] = l, o[q0] = A, K3(o, l, !1, !1), l.stateNode = o;
            e: {
              switch (j = sn(d, A), d) {
                case "dialog":
                  on("cancel", o), on("close", o), y = A;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  on("load", o), y = A;
                  break;
                case "video":
                case "audio":
                  for (y = 0; y < gs.length; y++) on(gs[y], o);
                  y = A;
                  break;
                case "source":
                  on("error", o), y = A;
                  break;
                case "img":
                case "image":
                case "link":
                  on(
                    "error",
                    o
                  ), on("load", o), y = A;
                  break;
                case "details":
                  on("toggle", o), y = A;
                  break;
                case "input":
                  ie(o, A), y = y1(o, A), on("invalid", o);
                  break;
                case "option":
                  y = A;
                  break;
                case "select":
                  o._wrapperState = { wasMultiple: !!A.multiple }, y = t1({}, A, { value: void 0 }), on("invalid", o);
                  break;
                case "textarea":
                  Bt(o, A), y = Ae(o, A), on("invalid", o);
                  break;
                default:
                  y = A;
              }
              An(d, y), K = y;
              for (S in K) if (K.hasOwnProperty(S)) {
                var q = K[S];
                S === "style" ? wt(o, q) : S === "dangerouslySetInnerHTML" ? (q = q ? q.__html : void 0, q != null && Pe(o, q)) : S === "children" ? typeof q == "string" ? (d !== "textarea" || q !== "") && yn(o, q) : typeof q == "number" && yn(o, "" + q) : S !== "suppressContentEditableWarning" && S !== "suppressHydrationWarning" && S !== "autoFocus" && (s.hasOwnProperty(S) ? q != null && S === "onScroll" && on("scroll", o) : q != null && _(o, S, q, j));
              }
              switch (d) {
                case "input":
                  X1(o), Y1(o, A, !1);
                  break;
                case "textarea":
                  X1(o), bt(o);
                  break;
                case "option":
                  A.value != null && o.setAttribute("value", "" + R1(A.value));
                  break;
                case "select":
                  o.multiple = !!A.multiple, S = A.value, S != null ? Qe(o, !!A.multiple, S, !1) : A.defaultValue != null && Qe(
                    o,
                    !!A.multiple,
                    A.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof y.onClick == "function" && (o.onclick = zl);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  A = !!A.autoFocus;
                  break e;
                case "img":
                  A = !0;
                  break e;
                default:
                  A = !1;
              }
            }
            A && (l.flags |= 4);
          }
          l.ref !== null && (l.flags |= 512, l.flags |= 2097152);
        }
        return W2(l), null;
      case 6:
        if (o && l.stateNode != null) l3(o, l, o.memoizedProps, A);
        else {
          if (typeof A != "string" && l.stateNode === null) throw Error(i(166));
          if (d = ta(vs.current), ta(E3.current), Hl(l)) {
            if (A = l.stateNode, d = l.memoizedProps, A[W3] = l, (S = A.nodeValue !== d) && (o = Fr, o !== null)) switch (o.tag) {
              case 3:
                jl(A.nodeValue, d, (o.mode & 1) !== 0);
                break;
              case 5:
                o.memoizedProps.suppressHydrationWarning !== !0 && jl(A.nodeValue, d, (o.mode & 1) !== 0);
            }
            S && (l.flags |= 4);
          } else A = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(A), A[W3] = l, l.stateNode = A;
        }
        return W2(l), null;
      case 13:
        if (Ot(hn), A = l.memoizedState, o === null || o.memoizedState !== null && o.memoizedState.dehydrated !== null) {
          if (gn && mr !== null && l.mode & 1 && !(l.flags & 128)) Sd(), bn(), l.flags |= 98560, S = !1;
          else if (S = Hl(l), A !== null && A.dehydrated !== null) {
            if (o === null) {
              if (!S) throw Error(i(318));
              if (S = l.memoizedState, S = S !== null ? S.dehydrated : null, !S) throw Error(i(317));
              S[W3] = l;
            } else bn(), !(l.flags & 128) && (l.memoizedState = null), l.flags |= 4;
            W2(l), S = !1;
          } else i3 !== null && (P4(i3), i3 = null), S = !0;
          if (!S) return l.flags & 65536 ? l : null;
        }
        return l.flags & 128 ? (l.lanes = d, l) : (A = A !== null, A !== (o !== null && o.memoizedState !== null) && A && (l.child.flags |= 8192, l.mode & 1 && (o === null || hn.current & 1 ? t2 === 0 && (t2 = 3) : zs())), l.updateQueue !== null && (l.flags |= 4), W2(l), null);
      case 4:
        return $a(), lo(o, l), o === null && Ja(l.stateNode.containerInfo), W2(l), null;
      case 10:
        return m4(l.type._context), W2(l), null;
      case 17:
        return pn(l.type) && n3(), W2(l), null;
      case 19:
        if (Ot(hn), S = l.memoizedState, S === null) return W2(l), null;
        if (A = (l.flags & 128) !== 0, j = S.rendering, j === null) if (A) Tn(S, !1);
        else {
          if (t2 !== 0 || o !== null && o.flags & 128) for (o = l.child; o !== null; ) {
            if (j = Jl(o), j !== null) {
              for (l.flags |= 128, Tn(S, !1), A = j.updateQueue, A !== null && (l.updateQueue = A, l.flags |= 4), l.subtreeFlags = 0, A = d, d = l.child; d !== null; ) S = d, o = A, S.flags &= 14680066, j = S.alternate, j === null ? (S.childLanes = 0, S.lanes = o, S.child = null, S.subtreeFlags = 0, S.memoizedProps = null, S.memoizedState = null, S.updateQueue = null, S.dependencies = null, S.stateNode = null) : (S.childLanes = j.childLanes, S.lanes = j.lanes, S.child = j.child, S.subtreeFlags = 0, S.deletions = null, S.memoizedProps = j.memoizedProps, S.memoizedState = j.memoizedState, S.updateQueue = j.updateQueue, S.type = j.type, o = j.dependencies, S.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }), d = d.sibling;
              return Pt(hn, hn.current & 1 | 2), l.child;
            }
            o = o.sibling;
          }
          S.tail !== null && Et() > vo && (l.flags |= 128, A = !0, Tn(S, !1), l.lanes = 4194304);
        }
        else {
          if (!A) if (o = Jl(j), o !== null) {
            if (l.flags |= 128, A = !0, d = o.updateQueue, d !== null && (l.updateQueue = d, l.flags |= 4), Tn(S, !0), S.tail === null && S.tailMode === "hidden" && !j.alternate && !gn) return W2(l), null;
          } else 2 * Et() - S.renderingStartTime > vo && d !== 1073741824 && (l.flags |= 128, A = !0, Tn(S, !1), l.lanes = 4194304);
          S.isBackwards ? (j.sibling = l.child, l.child = j) : (d = S.last, d !== null ? d.sibling = j : l.child = j, S.last = j);
        }
        return S.tail !== null ? (l = S.tail, S.rendering = l, S.tail = l.sibling, S.renderingStartTime = Et(), l.sibling = null, d = hn.current, Pt(hn, A ? d & 1 | 2 : d & 1), l) : (W2(l), null);
      case 22:
      case 23:
        return Su(), A = l.memoizedState !== null, o !== null && o.memoizedState !== null !== A && (l.flags |= 8192), A && l.mode & 1 ? xr & 1073741824 && (W2(l), l.subtreeFlags & 6 && (l.flags |= 8192)) : W2(l), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, l.tag));
  }
  function B6(o, l) {
    switch (I4(l), l.tag) {
      case 1:
        return pn(l.type) && n3(), o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 3:
        return $a(), Ot(Mn), Ot(Xe), w4(), o = l.flags, o & 65536 && !(o & 128) ? (l.flags = o & -65537 | 128, l) : null;
      case 5:
        return b4(l), null;
      case 13:
        if (Ot(hn), o = l.memoizedState, o !== null && o.dehydrated !== null) {
          if (l.alternate === null) throw Error(i(340));
          bn();
        }
        return o = l.flags, o & 65536 ? (l.flags = o & -65537 | 128, l) : null;
      case 19:
        return Ot(hn), null;
      case 4:
        return $a(), null;
      case 10:
        return m4(l.type._context), null;
      case 22:
      case 23:
        return Su(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var co = !1, S2 = !1, Au = typeof WeakSet == "function" ? WeakSet : Set, we = null;
  function go(o, l) {
    var d = o.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (A) {
      Rn(o, l, A);
    }
    else d.current = null;
  }
  function O4(o, l, d) {
    try {
      d();
    } catch (A) {
      Rn(o, l, A);
    }
  }
  var Iu = !1;
  function H6(o, l) {
    if (l4 = I1, o = Ll(), hi(o)) {
      if ("selectionStart" in o) var d = { start: o.selectionStart, end: o.selectionEnd };
      else e: {
        d = (d = o.ownerDocument) && d.defaultView || window;
        var A = d.getSelection && d.getSelection();
        if (A && A.rangeCount !== 0) {
          d = A.anchorNode;
          var y = A.anchorOffset, S = A.focusNode;
          A = A.focusOffset;
          try {
            d.nodeType, S.nodeType;
          } catch {
            d = null;
            break e;
          }
          var j = 0, K = -1, q = -1, p1 = 0, W1 = 0, Q1 = o, N1 = null;
          t: for (; ; ) {
            for (var pe; Q1 !== d || y !== 0 && Q1.nodeType !== 3 || (K = j + y), Q1 !== S || A !== 0 && Q1.nodeType !== 3 || (q = j + A), Q1.nodeType === 3 && (j += Q1.nodeValue.length), (pe = Q1.firstChild) !== null; )
              N1 = Q1, Q1 = pe;
            for (; ; ) {
              if (Q1 === o) break t;
              if (N1 === d && ++p1 === y && (K = j), N1 === S && ++W1 === A && (q = j), (pe = Q1.nextSibling) !== null) break;
              Q1 = N1, N1 = Q1.parentNode;
            }
            Q1 = pe;
          }
          d = K === -1 || q === -1 ? null : { start: K, end: q };
        } else d = null;
      }
      d = d || { start: 0, end: 0 };
    } else d = null;
    for (X0 = { focusedElem: o, selectionRange: d }, I1 = !1, we = l; we !== null; ) if (l = we, o = l.child, (l.subtreeFlags & 1028) !== 0 && o !== null) o.return = l, we = o;
    else for (; we !== null; ) {
      l = we;
      try {
        var Se = l.alternate;
        if (l.flags & 1024) switch (l.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (Se !== null) {
              var Te = Se.memoizedProps, Pn = Se.memoizedState, s1 = l.stateNode, r1 = s1.getSnapshotBeforeUpdate(l.elementType === l.type ? Te : yr(l.type, Te), Pn);
              s1.__reactInternalSnapshotBeforeUpdate = r1;
            }
            break;
          case 3:
            var g1 = l.stateNode.containerInfo;
            g1.nodeType === 1 ? g1.textContent = "" : g1.nodeType === 9 && g1.documentElement && g1.removeChild(g1.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(i(163));
        }
      } catch (ne) {
        Rn(l, l.return, ne);
      }
      if (o = l.sibling, o !== null) {
        o.return = l.return, we = o;
        break;
      }
      we = l.return;
    }
    return Se = Iu, Iu = !1, Se;
  }
  function fo(o, l, d) {
    var A = l.updateQueue;
    if (A = A !== null ? A.lastEffect : null, A !== null) {
      var y = A = A.next;
      do {
        if ((y.tag & o) === o) {
          var S = y.destroy;
          y.destroy = void 0, S !== void 0 && O4(l, d, S);
        }
        y = y.next;
      } while (y !== A);
    }
  }
  function pu(o, l) {
    if (l = l.updateQueue, l = l !== null ? l.lastEffect : null, l !== null) {
      var d = l = l.next;
      do {
        if ((d.tag & o) === o) {
          var A = d.create;
          d.destroy = A();
        }
        d = d.next;
      } while (d !== l);
    }
  }
  function hu(o) {
    var l = o.ref;
    if (l !== null) {
      var d = o.stateNode;
      switch (o.tag) {
        case 5:
          o = d;
          break;
        default:
          o = d;
      }
      typeof l == "function" ? l(o) : l.current = o;
    }
  }
  function Vd(o) {
    var l = o.alternate;
    l !== null && (o.alternate = null, Vd(l)), o.child = null, o.deletions = null, o.sibling = null, o.tag === 5 && (l = o.stateNode, l !== null && (delete l[W3], delete l[q0], delete l[g4], delete l[j6], delete l[f4])), o.stateNode = null, o.return = null, o.dependencies = null, o.memoizedProps = null, o.memoizedState = null, o.pendingProps = null, o.stateNode = null, o.updateQueue = null;
  }
  function D4(o) {
    return o.tag === 5 || o.tag === 3 || o.tag === 4;
  }
  function Kd(o) {
    e: for (; ; ) {
      for (; o.sibling === null; ) {
        if (o.return === null || D4(o.return)) return null;
        o = o.return;
      }
      for (o.sibling.return = o.return, o = o.sibling; o.tag !== 5 && o.tag !== 6 && o.tag !== 18; ) {
        if (o.flags & 2 || o.child === null || o.tag === 4) continue e;
        o.child.return = o, o = o.child;
      }
      if (!(o.flags & 2)) return o.stateNode;
    }
  }
  function Os(o, l, d) {
    var A = o.tag;
    if (A === 5 || A === 6) o = o.stateNode, l ? d.nodeType === 8 ? d.parentNode.insertBefore(o, l) : d.insertBefore(o, l) : (d.nodeType === 8 ? (l = d.parentNode, l.insertBefore(o, d)) : (l = d, l.appendChild(o)), d = d._reactRootContainer, d != null || l.onclick !== null || (l.onclick = zl));
    else if (A !== 4 && (o = o.child, o !== null)) for (Os(o, l, d), o = o.sibling; o !== null; ) Os(o, l, d), o = o.sibling;
  }
  function Co(o, l, d) {
    var A = o.tag;
    if (A === 5 || A === 6) o = o.stateNode, l ? d.insertBefore(o, l) : d.appendChild(o);
    else if (A !== 4 && (o = o.child, o !== null)) for (Co(o, l, d), o = o.sibling; o !== null; ) Co(o, l, d), o = o.sibling;
  }
  var mn = null, C2 = !1;
  function X2(o, l, d) {
    for (d = d.child; d !== null; ) Ao(o, l, d), d = d.sibling;
  }
  function Ao(o, l, d) {
    if (J2 && typeof J2.onCommitFiberUnmount == "function") try {
      J2.onCommitFiberUnmount(B0, d);
    } catch {
    }
    switch (d.tag) {
      case 5:
        S2 || go(d, l);
      case 6:
        var A = mn, y = C2;
        mn = null, X2(o, l, d), mn = A, C2 = y, mn !== null && (C2 ? (o = mn, d = d.stateNode, o.nodeType === 8 ? o.parentNode.removeChild(d) : o.removeChild(d)) : mn.removeChild(d.stateNode));
        break;
      case 18:
        mn !== null && (C2 ? (o = mn, d = d.stateNode, o.nodeType === 8 ? Zi(o.parentNode, d) : o.nodeType === 1 && Zi(o, d), W(o)) : Zi(mn, d.stateNode));
        break;
      case 4:
        A = mn, y = C2, mn = d.stateNode.containerInfo, C2 = !0, X2(o, l, d), mn = A, C2 = y;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!S2 && (A = d.updateQueue, A !== null && (A = A.lastEffect, A !== null))) {
          y = A = A.next;
          do {
            var S = y, j = S.destroy;
            S = S.tag, j !== void 0 && (S & 2 || S & 4) && O4(d, l, j), y = y.next;
          } while (y !== A);
        }
        X2(o, l, d);
        break;
      case 1:
        if (!S2 && (go(d, l), A = d.stateNode, typeof A.componentWillUnmount == "function")) try {
          A.props = d.memoizedProps, A.state = d.memoizedState, A.componentWillUnmount();
        } catch (K) {
          Rn(d, l, K);
        }
        X2(o, l, d);
        break;
      case 21:
        X2(o, l, d);
        break;
      case 22:
        d.mode & 1 ? (S2 = (A = S2) || d.memoizedState !== null, X2(o, l, d), S2 = A) : X2(o, l, d);
        break;
      default:
        X2(o, l, d);
    }
  }
  function Io(o) {
    var l = o.updateQueue;
    if (l !== null) {
      o.updateQueue = null;
      var d = o.stateNode;
      d === null && (d = o.stateNode = new Au()), l.forEach(function(A) {
        var y = Y6.bind(null, o, A);
        d.has(A) || (d.add(A), A.then(y, y));
      });
    }
  }
  function A2(o, l) {
    var d = l.deletions;
    if (d !== null) for (var A = 0; A < d.length; A++) {
      var y = d[A];
      try {
        var S = o, j = l, K = j;
        e: for (; K !== null; ) {
          switch (K.tag) {
            case 5:
              mn = K.stateNode, C2 = !1;
              break e;
            case 3:
              mn = K.stateNode.containerInfo, C2 = !0;
              break e;
            case 4:
              mn = K.stateNode.containerInfo, C2 = !0;
              break e;
          }
          K = K.return;
        }
        if (mn === null) throw Error(i(160));
        Ao(S, j, y), mn = null, C2 = !1;
        var q = y.alternate;
        q !== null && (q.return = null), y.return = null;
      } catch (p1) {
        Rn(y, l, p1);
      }
    }
    if (l.subtreeFlags & 12854) for (l = l.child; l !== null; ) Jd(l, o), l = l.sibling;
  }
  function Jd(o, l) {
    var d = o.alternate, A = o.flags;
    switch (o.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (A2(l, o), J3(o), A & 4) {
          try {
            fo(3, o, o.return), pu(3, o);
          } catch (Te) {
            Rn(o, o.return, Te);
          }
          try {
            fo(5, o, o.return);
          } catch (Te) {
            Rn(o, o.return, Te);
          }
        }
        break;
      case 1:
        A2(l, o), J3(o), A & 512 && d !== null && go(d, d.return);
        break;
      case 5:
        if (A2(l, o), J3(o), A & 512 && d !== null && go(d, d.return), o.flags & 32) {
          var y = o.stateNode;
          try {
            yn(y, "");
          } catch (Te) {
            Rn(o, o.return, Te);
          }
        }
        if (A & 4 && (y = o.stateNode, y != null)) {
          var S = o.memoizedProps, j = d !== null ? d.memoizedProps : S, K = o.type, q = o.updateQueue;
          if (o.updateQueue = null, q !== null) try {
            K === "input" && S.type === "radio" && S.name != null && ae(y, S), sn(K, j);
            var p1 = sn(K, S);
            for (j = 0; j < q.length; j += 2) {
              var W1 = q[j], Q1 = q[j + 1];
              W1 === "style" ? wt(y, Q1) : W1 === "dangerouslySetInnerHTML" ? Pe(y, Q1) : W1 === "children" ? yn(y, Q1) : _(y, W1, Q1, p1);
            }
            switch (K) {
              case "input":
                H1(y, S);
                break;
              case "textarea":
                ke(y, S);
                break;
              case "select":
                var N1 = y._wrapperState.wasMultiple;
                y._wrapperState.wasMultiple = !!S.multiple;
                var pe = S.value;
                pe != null ? Qe(y, !!S.multiple, pe, !1) : N1 !== !!S.multiple && (S.defaultValue != null ? Qe(
                  y,
                  !!S.multiple,
                  S.defaultValue,
                  !0
                ) : Qe(y, !!S.multiple, S.multiple ? [] : "", !1));
            }
            y[q0] = S;
          } catch (Te) {
            Rn(o, o.return, Te);
          }
        }
        break;
      case 6:
        if (A2(l, o), J3(o), A & 4) {
          if (o.stateNode === null) throw Error(i(162));
          y = o.stateNode, S = o.memoizedProps;
          try {
            y.nodeValue = S;
          } catch (Te) {
            Rn(o, o.return, Te);
          }
        }
        break;
      case 3:
        if (A2(l, o), J3(o), A & 4 && d !== null && d.memoizedState.isDehydrated) try {
          W(l.containerInfo);
        } catch (Te) {
          Rn(o, o.return, Te);
        }
        break;
      case 4:
        A2(l, o), J3(o);
        break;
      case 13:
        A2(l, o), J3(o), y = o.child, y.flags & 8192 && (S = y.memoizedState !== null, y.stateNode.isHidden = S, !S || y.alternate !== null && y.alternate.memoizedState !== null || (vu = Et())), A & 4 && Io(o);
        break;
      case 22:
        if (W1 = d !== null && d.memoizedState !== null, o.mode & 1 ? (S2 = (p1 = S2) || W1, A2(l, o), S2 = p1) : A2(l, o), J3(o), A & 8192) {
          if (p1 = o.memoizedState !== null, (o.stateNode.isHidden = p1) && !W1 && o.mode & 1) for (we = o, W1 = o.child; W1 !== null; ) {
            for (Q1 = we = W1; we !== null; ) {
              switch (N1 = we, pe = N1.child, N1.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  fo(4, N1, N1.return);
                  break;
                case 1:
                  go(N1, N1.return);
                  var Se = N1.stateNode;
                  if (typeof Se.componentWillUnmount == "function") {
                    A = N1, d = N1.return;
                    try {
                      l = A, Se.props = l.memoizedProps, Se.state = l.memoizedState, Se.componentWillUnmount();
                    } catch (Te) {
                      Rn(A, d, Te);
                    }
                  }
                  break;
                case 5:
                  go(N1, N1.return);
                  break;
                case 22:
                  if (N1.memoizedState !== null) {
                    Yd(Q1);
                    continue;
                  }
              }
              pe !== null ? (pe.return = N1, we = pe) : Yd(Q1);
            }
            W1 = W1.sibling;
          }
          e: for (W1 = null, Q1 = o; ; ) {
            if (Q1.tag === 5) {
              if (W1 === null) {
                W1 = Q1;
                try {
                  y = Q1.stateNode, p1 ? (S = y.style, typeof S.setProperty == "function" ? S.setProperty("display", "none", "important") : S.display = "none") : (K = Q1.stateNode, q = Q1.memoizedProps.style, j = q != null && q.hasOwnProperty("display") ? q.display : null, K.style.display = _e("display", j));
                } catch (Te) {
                  Rn(o, o.return, Te);
                }
              }
            } else if (Q1.tag === 6) {
              if (W1 === null) try {
                Q1.stateNode.nodeValue = p1 ? "" : Q1.memoizedProps;
              } catch (Te) {
                Rn(o, o.return, Te);
              }
            } else if ((Q1.tag !== 22 && Q1.tag !== 23 || Q1.memoizedState === null || Q1 === o) && Q1.child !== null) {
              Q1.child.return = Q1, Q1 = Q1.child;
              continue;
            }
            if (Q1 === o) break e;
            for (; Q1.sibling === null; ) {
              if (Q1.return === null || Q1.return === o) break e;
              W1 === Q1 && (W1 = null), Q1 = Q1.return;
            }
            W1 === Q1 && (W1 = null), Q1.sibling.return = Q1.return, Q1 = Q1.sibling;
          }
        }
        break;
      case 19:
        A2(l, o), J3(o), A & 4 && Io(o);
        break;
      case 21:
        break;
      default:
        A2(
          l,
          o
        ), J3(o);
    }
  }
  function J3(o) {
    var l = o.flags;
    if (l & 2) {
      try {
        e: {
          for (var d = o.return; d !== null; ) {
            if (D4(d)) {
              var A = d;
              break e;
            }
            d = d.return;
          }
          throw Error(i(160));
        }
        switch (A.tag) {
          case 5:
            var y = A.stateNode;
            A.flags & 32 && (yn(y, ""), A.flags &= -33);
            var S = Kd(o);
            Co(o, S, y);
            break;
          case 3:
          case 4:
            var j = A.stateNode.containerInfo, K = Kd(o);
            Os(o, K, j);
            break;
          default:
            throw Error(i(161));
        }
      } catch (q) {
        Rn(o, o.return, q);
      }
      o.flags &= -3;
    }
    l & 4096 && (o.flags &= -4097);
  }
  function U6(o, l, d) {
    we = o, k4(o);
  }
  function k4(o, l, d) {
    for (var A = (o.mode & 1) !== 0; we !== null; ) {
      var y = we, S = y.child;
      if (y.tag === 22 && A) {
        var j = y.memoizedState !== null || co;
        if (!j) {
          var K = y.alternate, q = K !== null && K.memoizedState !== null || S2;
          K = co;
          var p1 = S2;
          if (co = j, (S2 = q) && !p1) for (we = y; we !== null; ) j = we, q = j.child, j.tag === 22 && j.memoizedState !== null ? j4(y) : q !== null ? (q.return = j, we = q) : j4(y);
          for (; S !== null; ) we = S, k4(S), S = S.sibling;
          we = y, co = K, S2 = p1;
        }
        po(o);
      } else y.subtreeFlags & 8772 && S !== null ? (S.return = y, we = S) : po(o);
    }
  }
  function po(o) {
    for (; we !== null; ) {
      var l = we;
      if (l.flags & 8772) {
        var d = l.alternate;
        try {
          if (l.flags & 8772) switch (l.tag) {
            case 0:
            case 11:
            case 15:
              S2 || pu(5, l);
              break;
            case 1:
              var A = l.stateNode;
              if (l.flags & 4 && !S2) if (d === null) A.componentDidMount();
              else {
                var y = l.elementType === l.type ? d.memoizedProps : yr(l.type, d.memoizedProps);
                A.componentDidUpdate(y, d.memoizedState, A.__reactInternalSnapshotBeforeUpdate);
              }
              var S = l.updateQueue;
              S !== null && Rd(l, S, A);
              break;
            case 3:
              var j = l.updateQueue;
              if (j !== null) {
                if (d = null, l.child !== null) switch (l.child.tag) {
                  case 5:
                    d = l.child.stateNode;
                    break;
                  case 1:
                    d = l.child.stateNode;
                }
                Rd(l, j, d);
              }
              break;
            case 5:
              var K = l.stateNode;
              if (d === null && l.flags & 4) {
                d = K;
                var q = l.memoizedProps;
                switch (l.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    q.autoFocus && d.focus();
                    break;
                  case "img":
                    q.src && (d.src = q.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (l.memoizedState === null) {
                var p1 = l.alternate;
                if (p1 !== null) {
                  var W1 = p1.memoizedState;
                  if (W1 !== null) {
                    var Q1 = W1.dehydrated;
                    Q1 !== null && W(Q1);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(i(163));
          }
          S2 || l.flags & 512 && hu(l);
        } catch (N1) {
          Rn(l, l.return, N1);
        }
      }
      if (l === o) {
        we = null;
        break;
      }
      if (d = l.sibling, d !== null) {
        d.return = l.return, we = d;
        break;
      }
      we = l.return;
    }
  }
  function Yd(o) {
    for (; we !== null; ) {
      var l = we;
      if (l === o) {
        we = null;
        break;
      }
      var d = l.sibling;
      if (d !== null) {
        d.return = l.return, we = d;
        break;
      }
      we = l.return;
    }
  }
  function j4(o) {
    for (; we !== null; ) {
      var l = we;
      try {
        switch (l.tag) {
          case 0:
          case 11:
          case 15:
            var d = l.return;
            try {
              pu(4, l);
            } catch (q) {
              Rn(l, d, q);
            }
            break;
          case 1:
            var A = l.stateNode;
            if (typeof A.componentDidMount == "function") {
              var y = l.return;
              try {
                A.componentDidMount();
              } catch (q) {
                Rn(l, y, q);
              }
            }
            var S = l.return;
            try {
              hu(l);
            } catch (q) {
              Rn(l, S, q);
            }
            break;
          case 5:
            var j = l.return;
            try {
              hu(l);
            } catch (q) {
              Rn(l, j, q);
            }
        }
      } catch (q) {
        Rn(l, l.return, q);
      }
      if (l === o) {
        we = null;
        break;
      }
      var K = l.sibling;
      if (K !== null) {
        K.return = l.return, we = K;
        break;
      }
      we = l.return;
    }
  }
  var W6 = Math.ceil, ua = X.ReactCurrentDispatcher, mu = X.ReactCurrentOwner, u3 = X.ReactCurrentBatchConfig, At = 0, Ln = null, fn = null, e2 = 0, xr = 0, ho = tt(0), t2 = 0, Ds = null, ca = 0, mo = 0, z4 = 0, l0 = null, _2 = null, vu = 0, vo = 1 / 0, Mi = null, yu = !1, N4 = null, c3 = null, yo = !1, g3 = null, bu = 0, ks = 0, wu = null, js = -1, ga = 0;
  function I2() {
    return At & 6 ? Et() : js !== -1 ? js : js = Et();
  }
  function Ti(o) {
    return o.mode & 1 ? At & 2 && e2 !== 0 ? e2 & -e2 : Ul.transition !== null ? (ga === 0 && (ga = Pa()), ga) : (o = Ve, o !== 0 || (o = window.event, o = o === void 0 ? 16 : lt(o.type)), o) : 1;
  }
  function wn(o, l, d, A) {
    if (50 < ks) throw ks = 0, wu = null, Error(i(185));
    H3(o, d, A), (!(At & 2) || o !== Ln) && (o === Ln && (!(At & 2) && (mo |= d), t2 === 4 && Y3(o, e2)), n2(o, A), d === 1 && At === 0 && !(l.mode & 1) && (vo = Et() + 500, d2 && Ir()));
  }
  function n2(o, l) {
    var d = o.callbackNode;
    Qi(o, l);
    var A = Y2(o, o === Ln ? e2 : 0);
    if (A === 0) d !== null && rn(d), o.callbackNode = null, o.callbackPriority = 0;
    else if (l = A & -A, o.callbackPriority !== l) {
      if (d != null && rn(d), l === 1) o.tag === 0 ? C4(bo.bind(null, o)) : d4(bo.bind(null, o)), c4(function() {
        !(At & 6) && Ir();
      }), d = null;
      else {
        switch (U0(A)) {
          case 1:
            d = K2;
            break;
          case 4:
            d = it;
            break;
          case 16:
            d = qr;
            break;
          case 536870912:
            d = ns;
            break;
          default:
            d = qr;
        }
        d = t9(d, xu.bind(null, o));
      }
      o.callbackPriority = l, o.callbackNode = d;
    }
  }
  function xu(o, l) {
    if (js = -1, ga = 0, At & 6) throw Error(i(327));
    var d = o.callbackNode;
    if (wo() && o.callbackNode !== d) return null;
    var A = Y2(o, o === Ln ? e2 : 0);
    if (A === 0) return null;
    if (A & 30 || A & o.expiredLanes || l) l = Eu(o, A);
    else {
      l = A;
      var y = At;
      At |= 2;
      var S = Xd();
      (Ln !== o || e2 !== l) && (Mi = null, vo = Et() + 500, da(o, l));
      do
        try {
          V6();
          break;
        } catch (K) {
          Qd(o, K);
        }
      while (!0);
      Br(), ua.current = S, At = y, fn !== null ? l = 0 : (Ln = null, e2 = 0, l = t2);
    }
    if (l !== 0) {
      if (l === 2 && (y = rs(o), y !== 0 && (A = y, l = fa(o, y))), l === 1) throw d = Ds, da(o, 0), Y3(o, A), n2(o, Et()), d;
      if (l === 6) Y3(o, A);
      else {
        if (y = o.current.alternate, !(A & 30) && !F4(y) && (l = Eu(o, A), l === 2 && (S = rs(o), S !== 0 && (A = S, l = fa(o, S))), l === 1)) throw d = Ds, da(o, 0), Y3(o, A), n2(o, Et()), d;
        switch (o.finishedWork = y, o.finishedLanes = A, l) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            u0(o, _2, Mi);
            break;
          case 3:
            if (Y3(o, A), (A & 130023424) === A && (l = vu + 500 - Et(), 10 < l)) {
              if (Y2(o, 0) !== 0) break;
              if (y = o.suspendedLanes, (y & A) !== A) {
                I2(), o.pingedLanes |= o.suspendedLanes & y;
                break;
              }
              o.timeoutHandle = G0(u0.bind(null, o, _2, Mi), l);
              break;
            }
            u0(o, _2, Mi);
            break;
          case 4:
            if (Y3(o, A), (A & 4194240) === A) break;
            for (l = o.eventTimes, y = -1; 0 < A; ) {
              var j = 31 - ur(A);
              S = 1 << j, j = l[j], j > y && (y = j), A &= ~S;
            }
            if (A = y, A = Et() - A, A = (120 > A ? 120 : 480 > A ? 480 : 1080 > A ? 1080 : 1920 > A ? 1920 : 3e3 > A ? 3e3 : 4320 > A ? 4320 : 1960 * W6(A / 1960)) - A, 10 < A) {
              o.timeoutHandle = G0(u0.bind(null, o, _2, Mi), A);
              break;
            }
            u0(o, _2, Mi);
            break;
          case 5:
            u0(o, _2, Mi);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return n2(o, Et()), o.callbackNode === d ? xu.bind(null, o) : null;
  }
  function fa(o, l) {
    var d = l0;
    return o.current.memoizedState.isDehydrated && (da(o, l).flags |= 256), o = Eu(o, l), o !== 2 && (l = _2, _2 = d, l !== null && P4(l)), o;
  }
  function P4(o) {
    _2 === null ? _2 = o : _2.push.apply(_2, o);
  }
  function F4(o) {
    for (var l = o; ; ) {
      if (l.flags & 16384) {
        var d = l.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var A = 0; A < d.length; A++) {
          var y = d[A], S = y.getSnapshot;
          y = y.value;
          try {
            if (!$r(S(), y)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = l.child, l.subtreeFlags & 16384 && d !== null) d.return = l, l = d;
      else {
        if (l === o) break;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === o) return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    }
    return !0;
  }
  function Y3(o, l) {
    for (l &= ~z4, l &= ~mo, o.suspendedLanes |= l, o.pingedLanes &= ~l, o = o.expirationTimes; 0 < l; ) {
      var d = 31 - ur(l), A = 1 << d;
      o[d] = -1, l &= ~A;
    }
  }
  function bo(o) {
    if (At & 6) throw Error(i(327));
    wo();
    var l = Y2(o, 0);
    if (!(l & 1)) return n2(o, Et()), null;
    var d = Eu(o, l);
    if (o.tag !== 0 && d === 2) {
      var A = rs(o);
      A !== 0 && (l = A, d = fa(o, A));
    }
    if (d === 1) throw d = Ds, da(o, 0), Y3(o, l), n2(o, Et()), d;
    if (d === 6) throw Error(i(345));
    return o.finishedWork = o.current.alternate, o.finishedLanes = l, u0(o, _2, Mi), n2(o, Et()), null;
  }
  function B4(o, l) {
    var d = At;
    At |= 1;
    try {
      return o(l);
    } finally {
      At = d, At === 0 && (vo = Et() + 500, d2 && Ir());
    }
  }
  function Q3(o) {
    g3 !== null && g3.tag === 0 && !(At & 6) && wo();
    var l = At;
    At |= 1;
    var d = u3.transition, A = Ve;
    try {
      if (u3.transition = null, Ve = 1, o) return o();
    } finally {
      Ve = A, u3.transition = d, At = l, !(At & 6) && Ir();
    }
  }
  function Su() {
    xr = ho.current, Ot(ho);
  }
  function da(o, l) {
    o.finishedWork = null, o.finishedLanes = 0;
    var d = o.timeoutHandle;
    if (d !== -1 && (o.timeoutHandle = -1, yd(d)), fn !== null) for (d = fn.return; d !== null; ) {
      var A = d;
      switch (I4(A), A.tag) {
        case 1:
          A = A.type.childContextTypes, A != null && n3();
          break;
        case 3:
          $a(), Ot(Mn), Ot(Xe), w4();
          break;
        case 5:
          b4(A);
          break;
        case 4:
          $a();
          break;
        case 13:
          Ot(hn);
          break;
        case 19:
          Ot(hn);
          break;
        case 10:
          m4(A.type._context);
          break;
        case 22:
        case 23:
          Su();
      }
      d = d.return;
    }
    if (Ln = o, fn = o = c0(o.current, null), e2 = xr = l, t2 = 0, Ds = null, z4 = mo = ca = 0, _2 = l0 = null, ea !== null) {
      for (l = 0; l < ea.length; l++) if (d = ea[l], A = d.interleaved, A !== null) {
        d.interleaved = null;
        var y = A.next, S = d.pending;
        if (S !== null) {
          var j = S.next;
          S.next = y, A.next = j;
        }
        d.pending = A;
      }
      ea = null;
    }
    return o;
  }
  function Qd(o, l) {
    do {
      var d = fn;
      try {
        if (Br(), Ql.current = U2, Hr) {
          for (var A = je.memoizedState; A !== null; ) {
            var y = A.queue;
            y !== null && (y.pending = null), A = A.next;
          }
          Hr = !1;
        }
        if (Re = 0, ct = Ge = je = null, eo = !1, bs = 0, mu.current = null, d === null || d.return === null) {
          t2 = 1, Ds = l, fn = null;
          break;
        }
        e: {
          var S = o, j = d.return, K = d, q = l;
          if (l = e2, K.flags |= 32768, q !== null && typeof q == "object" && typeof q.then == "function") {
            var p1 = q, W1 = K, Q1 = W1.tag;
            if (!(W1.mode & 1) && (Q1 === 0 || Q1 === 11 || Q1 === 15)) {
              var N1 = W1.alternate;
              N1 ? (W1.updateQueue = N1.updateQueue, W1.memoizedState = N1.memoizedState, W1.lanes = N1.lanes) : (W1.updateQueue = null, W1.memoizedState = null);
            }
            var pe = Bd(j);
            if (pe !== null) {
              pe.flags &= -257, T4(pe, j, K, S, l), pe.mode & 1 && Ms(S, p1, l), l = pe, q = p1;
              var Se = l.updateQueue;
              if (Se === null) {
                var Te = /* @__PURE__ */ new Set();
                Te.add(q), l.updateQueue = Te;
              } else Se.add(q);
              break e;
            } else {
              if (!(l & 1)) {
                Ms(S, p1, l), zs();
                break e;
              }
              q = Error(i(426));
            }
          } else if (gn && K.mode & 1) {
            var Pn = Bd(j);
            if (Pn !== null) {
              !(Pn.flags & 65536) && (Pn.flags |= 256), T4(Pn, j, K, S, l), h4(o0(q, K));
              break e;
            }
          }
          S = q = o0(q, K), t2 !== 4 && (t2 = 2), l0 === null ? l0 = [S] : l0.push(S), S = j;
          do {
            switch (S.tag) {
              case 3:
                S.flags |= 65536, l &= -l, S.lanes |= l;
                var s1 = Pd(S, q, l);
                Ld(S, s1);
                break e;
              case 1:
                K = q;
                var r1 = S.type, g1 = S.stateNode;
                if (!(S.flags & 128) && (typeof r1.getDerivedStateFromError == "function" || g1 !== null && typeof g1.componentDidCatch == "function" && (c3 === null || !c3.has(g1)))) {
                  S.flags |= 65536, l &= -l, S.lanes |= l;
                  var ne = Fd(S, K, l);
                  Ld(S, ne);
                  break e;
                }
            }
            S = S.return;
          } while (S !== null);
        }
        qd(d);
      } catch (Oe) {
        l = Oe, fn === d && d !== null && (fn = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function Xd() {
    var o = ua.current;
    return ua.current = U2, o === null ? U2 : o;
  }
  function zs() {
    (t2 === 0 || t2 === 3 || t2 === 2) && (t2 = 4), Ln === null || !(ca & 268435455) && !(mo & 268435455) || Y3(Ln, e2);
  }
  function Eu(o, l) {
    var d = At;
    At |= 2;
    var A = Xd();
    (Ln !== o || e2 !== l) && (Mi = null, da(o, l));
    do
      try {
        _6();
        break;
      } catch (y) {
        Qd(o, y);
      }
    while (!0);
    if (Br(), At = d, ua.current = A, fn !== null) throw Error(i(261));
    return Ln = null, e2 = 0, t2;
  }
  function _6() {
    for (; fn !== null; ) Gd(fn);
  }
  function V6() {
    for (; fn !== null && !P2(); ) Gd(fn);
  }
  function Gd(o) {
    var l = e9(o.alternate, o, xr);
    o.memoizedProps = o.pendingProps, l === null ? qd(o) : fn = l, mu.current = null;
  }
  function qd(o) {
    var l = o;
    do {
      var d = l.alternate;
      if (o = l.return, l.flags & 32768) {
        if (d = B6(d, l), d !== null) {
          d.flags &= 32767, fn = d;
          return;
        }
        if (o !== null) o.flags |= 32768, o.subtreeFlags = 0, o.deletions = null;
        else {
          t2 = 6, fn = null;
          return;
        }
      } else if (d = F6(d, l, xr), d !== null) {
        fn = d;
        return;
      }
      if (l = l.sibling, l !== null) {
        fn = l;
        return;
      }
      fn = l = o;
    } while (l !== null);
    t2 === 0 && (t2 = 5);
  }
  function u0(o, l, d) {
    var A = Ve, y = u3.transition;
    try {
      u3.transition = null, Ve = 1, K6(o, l, d, A);
    } finally {
      u3.transition = y, Ve = A;
    }
    return null;
  }
  function K6(o, l, d, A) {
    do
      wo();
    while (g3 !== null);
    if (At & 6) throw Error(i(327));
    d = o.finishedWork;
    var y = o.finishedLanes;
    if (d === null) return null;
    if (o.finishedWork = null, o.finishedLanes = 0, d === o.current) throw Error(i(177));
    o.callbackNode = null, o.callbackPriority = 0;
    var S = d.lanes | d.childLanes;
    if (Ba(o, S), o === Ln && (fn = Ln = null, e2 = 0), !(d.subtreeFlags & 2064) && !(d.flags & 2064) || yo || (yo = !0, t9(qr, function() {
      return wo(), null;
    })), S = (d.flags & 15990) !== 0, d.subtreeFlags & 15990 || S) {
      S = u3.transition, u3.transition = null;
      var j = Ve;
      Ve = 1;
      var K = At;
      At |= 4, mu.current = null, H6(o, d), Jd(d, o), Rl(X0), I1 = !!l4, X0 = l4 = null, o.current = d, U6(d), B3(), At = K, Ve = j, u3.transition = S;
    } else o.current = d;
    if (yo && (yo = !1, g3 = o, bu = y), S = o.pendingLanes, S === 0 && (c3 = null), vl(d.stateNode), n2(o, Et()), l !== null) for (A = o.onRecoverableError, d = 0; d < l.length; d++) y = l[d], A(y.value, { componentStack: y.stack, digest: y.digest });
    if (yu) throw yu = !1, o = N4, N4 = null, o;
    return bu & 1 && o.tag !== 0 && wo(), S = o.pendingLanes, S & 1 ? o === wu ? ks++ : (ks = 0, wu = o) : ks = 0, Ir(), null;
  }
  function wo() {
    if (g3 !== null) {
      var o = U0(bu), l = u3.transition, d = Ve;
      try {
        if (u3.transition = null, Ve = 16 > o ? 16 : o, g3 === null) var A = !1;
        else {
          if (o = g3, g3 = null, bu = 0, At & 6) throw Error(i(331));
          var y = At;
          for (At |= 4, we = o.current; we !== null; ) {
            var S = we, j = S.child;
            if (we.flags & 16) {
              var K = S.deletions;
              if (K !== null) {
                for (var q = 0; q < K.length; q++) {
                  var p1 = K[q];
                  for (we = p1; we !== null; ) {
                    var W1 = we;
                    switch (W1.tag) {
                      case 0:
                      case 11:
                      case 15:
                        fo(8, W1, S);
                    }
                    var Q1 = W1.child;
                    if (Q1 !== null) Q1.return = W1, we = Q1;
                    else for (; we !== null; ) {
                      W1 = we;
                      var N1 = W1.sibling, pe = W1.return;
                      if (Vd(W1), W1 === p1) {
                        we = null;
                        break;
                      }
                      if (N1 !== null) {
                        N1.return = pe, we = N1;
                        break;
                      }
                      we = pe;
                    }
                  }
                }
                var Se = S.alternate;
                if (Se !== null) {
                  var Te = Se.child;
                  if (Te !== null) {
                    Se.child = null;
                    do {
                      var Pn = Te.sibling;
                      Te.sibling = null, Te = Pn;
                    } while (Te !== null);
                  }
                }
                we = S;
              }
            }
            if (S.subtreeFlags & 2064 && j !== null) j.return = S, we = j;
            else e: for (; we !== null; ) {
              if (S = we, S.flags & 2048) switch (S.tag) {
                case 0:
                case 11:
                case 15:
                  fo(9, S, S.return);
              }
              var s1 = S.sibling;
              if (s1 !== null) {
                s1.return = S.return, we = s1;
                break e;
              }
              we = S.return;
            }
          }
          var r1 = o.current;
          for (we = r1; we !== null; ) {
            j = we;
            var g1 = j.child;
            if (j.subtreeFlags & 2064 && g1 !== null) g1.return = j, we = g1;
            else e: for (j = r1; we !== null; ) {
              if (K = we, K.flags & 2048) try {
                switch (K.tag) {
                  case 0:
                  case 11:
                  case 15:
                    pu(9, K);
                }
              } catch (Oe) {
                Rn(K, K.return, Oe);
              }
              if (K === j) {
                we = null;
                break e;
              }
              var ne = K.sibling;
              if (ne !== null) {
                ne.return = K.return, we = ne;
                break e;
              }
              we = K.return;
            }
          }
          if (At = y, Ir(), J2 && typeof J2.onPostCommitFiberRoot == "function") try {
            J2.onPostCommitFiberRoot(B0, o);
          } catch {
          }
          A = !0;
        }
        return A;
      } finally {
        Ve = d, u3.transition = l;
      }
    }
    return !1;
  }
  function Zd(o, l, d) {
    l = o0(d, l), l = Pd(o, l, 1), o = i0(o, l, 1), l = I2(), o !== null && (H3(o, 1, l), n2(o, l));
  }
  function Rn(o, l, d) {
    if (o.tag === 3) Zd(o, o, d);
    else for (; l !== null; ) {
      if (l.tag === 3) {
        Zd(l, o, d);
        break;
      } else if (l.tag === 1) {
        var A = l.stateNode;
        if (typeof l.type.getDerivedStateFromError == "function" || typeof A.componentDidCatch == "function" && (c3 === null || !c3.has(A))) {
          o = o0(d, o), o = Fd(l, o, 1), l = i0(l, o, 1), o = I2(), l !== null && (H3(l, 1, o), n2(l, o));
          break;
        }
      }
      l = l.return;
    }
  }
  function J6(o, l, d) {
    var A = o.pingCache;
    A !== null && A.delete(l), l = I2(), o.pingedLanes |= o.suspendedLanes & d, Ln === o && (e2 & d) === d && (t2 === 4 || t2 === 3 && (e2 & 130023424) === e2 && 500 > Et() - vu ? da(o, 0) : z4 |= d), n2(o, l);
  }
  function $d(o, l) {
    l === 0 && (o.mode & 1 ? (l = di, di <<= 1, !(di & 130023424) && (di = 4194304)) : l = 1);
    var d = I2();
    o = xi(o, l), o !== null && (H3(o, l, d), n2(o, d));
  }
  function H4(o) {
    var l = o.memoizedState, d = 0;
    l !== null && (d = l.retryLane), $d(o, d);
  }
  function Y6(o, l) {
    var d = 0;
    switch (o.tag) {
      case 13:
        var A = o.stateNode, y = o.memoizedState;
        y !== null && (d = y.retryLane);
        break;
      case 19:
        A = o.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    A !== null && A.delete(l), $d(o, d);
  }
  var e9;
  e9 = function(o, l, d) {
    if (o !== null) if (o.memoizedProps !== l.pendingProps || Mn.current) br = !0;
    else {
      if (!(o.lanes & d) && !(l.flags & 128)) return br = !1, Ei(o, l, d);
      br = !!(o.flags & 131072);
    }
    else br = !1, gn && l.flags & 1048576 && A4(l, Qa, l.index);
    switch (l.lanes = 0, l.tag) {
      case 2:
        var A = l.type;
        Rs(o, l), o = l.pendingProps;
        var y = t3(l, Xe.current);
        Ga(l, d), y = z1(null, l, A, o, y, d);
        var S = Vn();
        return l.flags |= 1, typeof y == "object" && y !== null && typeof y.render == "function" && y.$$typeof === void 0 ? (l.tag = 1, l.memoizedState = null, l.updateQueue = null, pn(A) ? (S = !0, Nl(l)) : S = !1, l.memoizedState = y.state !== null && y.state !== void 0 ? y.state : null, _l(l), y.updater = oa, l.stateNode = y, y._reactInternals = l, E4(l, A, o, d), l = gu(null, l, A, !0, S, d)) : (l.tag = 0, gn && S && Pl(l), zn(null, l, y, d), l = l.child), l;
      case 16:
        A = l.elementType;
        e: {
          switch (Rs(o, l), o = l.pendingProps, y = A._init, A = y(A._payload), l.type = A, y = l.tag = Q6(A), o = yr(A, o), y) {
            case 0:
              l = et(null, l, A, o, d);
              break e;
            case 1:
              l = Ts(null, l, A, o, d);
              break e;
            case 11:
              l = so(null, l, A, o, d);
              break e;
            case 14:
              l = s0(null, l, A, yr(A.type, o), d);
              break e;
          }
          throw Error(i(
            306,
            A,
            ""
          ));
        }
        return l;
      case 0:
        return A = l.type, y = l.pendingProps, y = l.elementType === A ? y : yr(A, y), et(o, l, A, y, d);
      case 1:
        return A = l.type, y = l.pendingProps, y = l.elementType === A ? y : yr(A, y), Ts(o, l, A, y, d);
      case 3:
        e: {
          if (P6(l), o === null) throw Error(i(387));
          A = l.pendingProps, S = l.memoizedState, y = S.element, qa(o, l), Kl(l, A, null, d);
          var j = l.memoizedState;
          if (A = j.element, S.isDehydrated) if (S = { element: A, isDehydrated: !1, cache: j.cache, pendingSuspenseBoundaries: j.pendingSuspenseBoundaries, transitions: j.transitions }, l.updateQueue.baseState = S, l.memoizedState = S, l.flags & 256) {
            y = o0(Error(i(423)), l), l = Ud(o, l, A, d, y);
            break e;
          } else if (A !== y) {
            y = o0(Error(i(424)), l), l = Ud(o, l, A, d, y);
            break e;
          } else for (mr = S3(l.stateNode.containerInfo.firstChild), Fr = l, gn = !0, i3 = null, d = Md(l, null, A, d), l.child = d; d; ) d.flags = d.flags & -3 | 4096, d = d.sibling;
          else {
            if (bn(), A === y) {
              l = Nn(o, l, d);
              break e;
            }
            zn(o, l, A, d);
          }
          l = l.child;
        }
        return l;
      case 5:
        return Od(l), o === null && Bl(l), A = l.type, y = l.pendingProps, S = o !== null ? o.memoizedProps : null, j = y.children, Cs(A, y) ? j = null : S !== null && Cs(A, S) && (l.flags |= 32), sa(o, l), zn(o, l, j, d), l.child;
      case 6:
        return o === null && Bl(l), null;
      case 13:
        return Wd(o, l, d);
      case 4:
        return y4(l, l.stateNode.containerInfo), A = l.pendingProps, o === null ? l.child = Xa(l, null, A, d) : zn(o, l, A, d), l.child;
      case 11:
        return A = l.type, y = l.pendingProps, y = l.elementType === A ? y : yr(A, y), so(o, l, A, y, d);
      case 7:
        return zn(o, l, l.pendingProps, d), l.child;
      case 8:
        return zn(o, l, l.pendingProps.children, d), l.child;
      case 12:
        return zn(o, l, l.pendingProps.children, d), l.child;
      case 10:
        e: {
          if (A = l.type._context, y = l.pendingProps, S = l.memoizedProps, j = y.value, Pt(wi, A._currentValue), A._currentValue = j, S !== null) if ($r(S.value, j)) {
            if (S.children === y.children && !Mn.current) {
              l = Nn(o, l, d);
              break e;
            }
          } else for (S = l.child, S !== null && (S.return = l); S !== null; ) {
            var K = S.dependencies;
            if (K !== null) {
              j = S.child;
              for (var q = K.firstContext; q !== null; ) {
                if (q.context === A) {
                  if (S.tag === 1) {
                    q = vr(-1, d & -d), q.tag = 2;
                    var p1 = S.updateQueue;
                    if (p1 !== null) {
                      p1 = p1.shared;
                      var W1 = p1.pending;
                      W1 === null ? q.next = q : (q.next = W1.next, W1.next = q), p1.pending = q;
                    }
                  }
                  S.lanes |= d, q = S.alternate, q !== null && (q.lanes |= d), v4(
                    S.return,
                    d,
                    l
                  ), K.lanes |= d;
                  break;
                }
                q = q.next;
              }
            } else if (S.tag === 10) j = S.type === l.type ? null : S.child;
            else if (S.tag === 18) {
              if (j = S.return, j === null) throw Error(i(341));
              j.lanes |= d, K = j.alternate, K !== null && (K.lanes |= d), v4(j, d, l), j = S.sibling;
            } else j = S.child;
            if (j !== null) j.return = S;
            else for (j = S; j !== null; ) {
              if (j === l) {
                j = null;
                break;
              }
              if (S = j.sibling, S !== null) {
                S.return = j.return, j = S;
                break;
              }
              j = j.return;
            }
            S = j;
          }
          zn(o, l, y.children, d), l = l.child;
        }
        return l;
      case 9:
        return y = l.type, A = l.pendingProps.children, Ga(l, d), y = o3(y), A = A(y), l.flags |= 1, zn(o, l, A, d), l.child;
      case 14:
        return A = l.type, y = yr(A, l.pendingProps), y = yr(A.type, y), s0(o, l, A, y, d);
      case 15:
        return cu(o, l, l.type, l.pendingProps, d);
      case 17:
        return A = l.type, y = l.pendingProps, y = l.elementType === A ? y : yr(A, y), Rs(o, l), l.tag = 1, pn(A) ? (o = !0, Nl(l)) : o = !1, Ga(l, d), jd(l, A, y), E4(l, A, y, d), gu(null, l, A, !0, o, d);
      case 19:
        return R4(o, l, d);
      case 22:
        return wr(o, l, d);
    }
    throw Error(i(156, l.tag));
  };
  function t9(o, l) {
    return Wt(o, l);
  }
  function n9(o, l, d, A) {
    this.tag = o, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = l, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = A, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function f3(o, l, d, A) {
    return new n9(o, l, d, A);
  }
  function U4(o) {
    return o = o.prototype, !(!o || !o.isReactComponent);
  }
  function Q6(o) {
    if (typeof o == "function") return U4(o) ? 1 : 0;
    if (o != null) {
      if (o = o.$$typeof, o === v1) return 11;
      if (o === S1) return 14;
    }
    return 2;
  }
  function c0(o, l) {
    var d = o.alternate;
    return d === null ? (d = f3(o.tag, l, o.key, o.mode), d.elementType = o.elementType, d.type = o.type, d.stateNode = o.stateNode, d.alternate = o, o.alternate = d) : (d.pendingProps = l, d.type = o.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = o.flags & 14680064, d.childLanes = o.childLanes, d.lanes = o.lanes, d.child = o.child, d.memoizedProps = o.memoizedProps, d.memoizedState = o.memoizedState, d.updateQueue = o.updateQueue, l = o.dependencies, d.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }, d.sibling = o.sibling, d.index = o.index, d.ref = o.ref, d;
  }
  function Mu(o, l, d, A, y, S) {
    var j = 2;
    if (A = o, typeof o == "function") U4(o) && (j = 1);
    else if (typeof o == "string") j = 5;
    else e: switch (o) {
      case Y:
        return Ca(d.children, y, S, l);
      case V:
        j = 8, y |= 8;
        break;
      case J:
        return o = f3(12, d, l, y | 2), o.elementType = J, o.lanes = S, o;
      case a1:
        return o = f3(13, d, l, y), o.elementType = a1, o.lanes = S, o;
      case d1:
        return o = f3(19, d, l, y), o.elementType = d1, o.lanes = S, o;
      case L1:
        return Tu(d, y, S, l);
      default:
        if (typeof o == "object" && o !== null) switch (o.$$typeof) {
          case e1:
            j = 10;
            break e;
          case f1:
            j = 9;
            break e;
          case v1:
            j = 11;
            break e;
          case S1:
            j = 14;
            break e;
          case h1:
            j = 16, A = null;
            break e;
        }
        throw Error(i(130, o == null ? o : typeof o, ""));
    }
    return l = f3(j, d, l, y), l.elementType = o, l.type = A, l.lanes = S, l;
  }
  function Ca(o, l, d, A) {
    return o = f3(7, o, A, l), o.lanes = d, o;
  }
  function Tu(o, l, d, A) {
    return o = f3(22, o, A, l), o.elementType = L1, o.lanes = d, o.stateNode = { isHidden: !1 }, o;
  }
  function Lu(o, l, d) {
    return o = f3(6, o, null, l), o.lanes = d, o;
  }
  function Ns(o, l, d) {
    return l = f3(4, o.children !== null ? o.children : [], o.key, l), l.lanes = d, l.stateNode = { containerInfo: o.containerInfo, pendingChildren: null, implementation: o.implementation }, l;
  }
  function Ps(o, l, d, A, y) {
    this.tag = l, this.containerInfo = o, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Fa(0), this.expirationTimes = Fa(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fa(0), this.identifierPrefix = A, this.onRecoverableError = y, this.mutableSourceEagerHydrationData = null;
  }
  function W4(o, l, d, A, y, S, j, K, q) {
    return o = new Ps(o, l, d, K, q), l === 1 ? (l = 1, S === !0 && (l |= 8)) : l = 0, S = f3(3, null, null, l), o.current = S, S.stateNode = o, S.memoizedState = { element: A, isDehydrated: d, cache: null, transitions: null, pendingSuspenseBoundaries: null }, _l(S), o;
  }
  function r9(o, l, d) {
    var A = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: Z, key: A == null ? null : "" + A, children: o, containerInfo: l, implementation: d };
  }
  function _4(o) {
    if (!o) return _3;
    o = o._reactInternals;
    e: {
      if (be(o) !== o || o.tag !== 1) throw Error(i(170));
      var l = o;
      do {
        switch (l.tag) {
          case 3:
            l = l.stateNode.context;
            break e;
          case 1:
            if (pn(l.type)) {
              l = l.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        l = l.return;
      } while (l !== null);
      throw Error(i(171));
    }
    if (o.tag === 1) {
      var d = o.type;
      if (pn(d)) return ps(o, d, l);
    }
    return l;
  }
  function V4(o, l, d, A, y, S, j, K, q) {
    return o = W4(d, A, !0, o, y, S, j, K, q), o.context = _4(null), d = o.current, A = I2(), y = Ti(d), S = vr(A, y), S.callback = l ?? null, i0(d, S, y), o.current.lanes = y, H3(o, y, A), n2(o, A), o;
  }
  function Ru(o, l, d, A) {
    var y = l.current, S = I2(), j = Ti(y);
    return d = _4(d), l.context === null ? l.context = d : l.pendingContext = d, l = vr(S, j), l.payload = { element: o }, A = A === void 0 ? null : A, A !== null && (l.callback = A), o = i0(y, l, j), o !== null && (wn(o, y, j, S), Vl(o, y, j)), j;
  }
  function Fs(o) {
    if (o = o.current, !o.child) return null;
    switch (o.child.tag) {
      case 5:
        return o.child.stateNode;
      default:
        return o.child.stateNode;
    }
  }
  function i9(o, l) {
    if (o = o.memoizedState, o !== null && o.dehydrated !== null) {
      var d = o.retryLane;
      o.retryLane = d !== 0 && d < l ? d : l;
    }
  }
  function K4(o, l) {
    i9(o, l), (o = o.alternate) && i9(o, l);
  }
  function X6() {
    return null;
  }
  var J4 = typeof reportError == "function" ? reportError : function(o) {
    console.error(o);
  };
  function Ou(o) {
    this._internalRoot = o;
  }
  Bs.prototype.render = Ou.prototype.render = function(o) {
    var l = this._internalRoot;
    if (l === null) throw Error(i(409));
    Ru(o, l, null, null);
  }, Bs.prototype.unmount = Ou.prototype.unmount = function() {
    var o = this._internalRoot;
    if (o !== null) {
      this._internalRoot = null;
      var l = o.containerInfo;
      Q3(function() {
        Ru(null, o, null, null);
      }), l[yi] = null;
    }
  };
  function Bs(o) {
    this._internalRoot = o;
  }
  Bs.prototype.unstable_scheduleHydration = function(o) {
    if (o) {
      var l = gr();
      o = { blockedOn: null, target: o, priority: l };
      for (var d = 0; d < Nt.length && l !== 0 && l < Nt[d].priority; d++) ;
      Nt.splice(d, 0, o), d === 0 && _0(o);
    }
  };
  function g0(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11);
  }
  function Du(o) {
    return !(!o || o.nodeType !== 1 && o.nodeType !== 9 && o.nodeType !== 11 && (o.nodeType !== 8 || o.nodeValue !== " react-mount-point-unstable "));
  }
  function a9() {
  }
  function G6(o, l, d, A, y) {
    if (y) {
      if (typeof A == "function") {
        var S = A;
        A = function() {
          var p1 = Fs(j);
          S.call(p1);
        };
      }
      var j = V4(l, A, o, 0, null, !1, !1, "", a9);
      return o._reactRootContainer = j, o[yi] = j.current, Ja(o.nodeType === 8 ? o.parentNode : o), Q3(), j;
    }
    for (; y = o.lastChild; ) o.removeChild(y);
    if (typeof A == "function") {
      var K = A;
      A = function() {
        var p1 = Fs(q);
        K.call(p1);
      };
    }
    var q = W4(o, 0, !1, null, null, !1, !1, "", a9);
    return o._reactRootContainer = q, o[yi] = q.current, Ja(o.nodeType === 8 ? o.parentNode : o), Q3(function() {
      Ru(l, q, d, A);
    }), q;
  }
  function ku(o, l, d, A, y) {
    var S = d._reactRootContainer;
    if (S) {
      var j = S;
      if (typeof y == "function") {
        var K = y;
        y = function() {
          var q = Fs(j);
          K.call(q);
        };
      }
      Ru(l, j, o, y);
    } else j = G6(d, l, o, y, A);
    return Fs(j);
  }
  is = function(o) {
    switch (o.tag) {
      case 3:
        var l = o.stateNode;
        if (l.current.memoizedState.isDehydrated) {
          var d = Ci(l.pendingLanes);
          d !== 0 && (H0(l, d | 1), n2(l, Et()), !(At & 6) && (vo = Et() + 500, Ir()));
        }
        break;
      case 13:
        Q3(function() {
          var A = xi(o, 1);
          if (A !== null) {
            var y = I2();
            wn(A, o, 1, y);
          }
        }), K4(o, 1);
    }
  }, cr = function(o) {
    if (o.tag === 13) {
      var l = xi(o, 134217728);
      if (l !== null) {
        var d = I2();
        wn(l, o, 134217728, d);
      }
      K4(o, 134217728);
    }
  }, Mt = function(o) {
    if (o.tag === 13) {
      var l = Ti(o), d = xi(o, l);
      if (d !== null) {
        var A = I2();
        wn(d, o, l, A);
      }
      K4(o, l);
    }
  }, gr = function() {
    return Ve;
  }, Q2 = function(o, l) {
    var d = Ve;
    try {
      return Ve = o, l();
    } finally {
      Ve = d;
    }
  }, b2 = function(o, l, d) {
    switch (l) {
      case "input":
        if (H1(o, d), l = d.name, d.type === "radio" && l != null) {
          for (d = o; d.parentNode; ) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), l = 0; l < d.length; l++) {
            var A = d[l];
            if (A !== o && A.form === o.form) {
              var y = Ue(A);
              if (!y) throw Error(i(90));
              D1(A), H1(A, y);
            }
          }
        }
        break;
      case "textarea":
        ke(o, d);
        break;
      case "select":
        l = d.value, l != null && Qe(o, !!d.multiple, l, !1);
    }
  }, F0 = B4, P3 = Q3;
  var q6 = { usingClientEntryPoint: !1, Events: [Is, Ya, Ue, ci, Vi, B4] }, Hs = { findFiberByHostInstance: e3, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, o9 = { bundleType: Hs.bundleType, version: Hs.version, rendererPackageName: Hs.rendererPackageName, rendererConfig: Hs.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: X.ReactCurrentDispatcher, findHostInstanceByFiber: function(o) {
    return o = nt(o), o === null ? null : o.stateNode;
  }, findFiberByHostInstance: Hs.findFiberByHostInstance || X6, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ju = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ju.isDisabled && ju.supportsFiber) try {
      B0 = ju.inject(o9), J2 = ju;
    } catch {
    }
  }
  return h3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = q6, h3.createPortal = function(o, l) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!g0(l)) throw Error(i(200));
    return r9(o, l, null, d);
  }, h3.createRoot = function(o, l) {
    if (!g0(o)) throw Error(i(299));
    var d = !1, A = "", y = J4;
    return l != null && (l.unstable_strictMode === !0 && (d = !0), l.identifierPrefix !== void 0 && (A = l.identifierPrefix), l.onRecoverableError !== void 0 && (y = l.onRecoverableError)), l = W4(o, 1, !1, null, null, d, !1, A, y), o[yi] = l.current, Ja(o.nodeType === 8 ? o.parentNode : o), new Ou(l);
  }, h3.findDOMNode = function(o) {
    if (o == null) return null;
    if (o.nodeType === 1) return o;
    var l = o._reactInternals;
    if (l === void 0)
      throw typeof o.render == "function" ? Error(i(188)) : (o = Object.keys(o).join(","), Error(i(268, o)));
    return o = nt(l), o = o === null ? null : o.stateNode, o;
  }, h3.flushSync = function(o) {
    return Q3(o);
  }, h3.hydrate = function(o, l, d) {
    if (!Du(l)) throw Error(i(200));
    return ku(null, o, l, !0, d);
  }, h3.hydrateRoot = function(o, l, d) {
    if (!g0(o)) throw Error(i(405));
    var A = d != null && d.hydratedSources || null, y = !1, S = "", j = J4;
    if (d != null && (d.unstable_strictMode === !0 && (y = !0), d.identifierPrefix !== void 0 && (S = d.identifierPrefix), d.onRecoverableError !== void 0 && (j = d.onRecoverableError)), l = V4(l, null, o, 1, d ?? null, y, !1, S, j), o[yi] = l.current, Ja(o), A) for (o = 0; o < A.length; o++) d = A[o], y = d._getVersion, y = y(d._source), l.mutableSourceEagerHydrationData == null ? l.mutableSourceEagerHydrationData = [d, y] : l.mutableSourceEagerHydrationData.push(
      d,
      y
    );
    return new Bs(l);
  }, h3.render = function(o, l, d) {
    if (!Du(l)) throw Error(i(200));
    return ku(null, o, l, !1, d);
  }, h3.unmountComponentAtNode = function(o) {
    if (!Du(o)) throw Error(i(40));
    return o._reactRootContainer ? (Q3(function() {
      ku(null, null, o, !1, function() {
        o._reactRootContainer = null, o[yi] = null;
      });
    }), !0) : !1;
  }, h3.unstable_batchedUpdates = B4, h3.unstable_renderSubtreeIntoContainer = function(o, l, d, A) {
    if (!Du(d)) throw Error(i(200));
    if (o == null || o._reactInternals === void 0) throw Error(i(38));
    return ku(o, l, d, !1, A);
  }, h3.version = "18.3.1-next-f1338f8080-20240426", h3;
}
var m3 = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ix;
function DK() {
  return ix || (ix = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = nn, n = mM(), i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, a = !1;
    function s(t) {
      a = t;
    }
    function g(t) {
      if (!a) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), f = 1; f < r; f++)
          u[f - 1] = arguments[f];
        I("warn", t, u);
      }
    }
    function c(t) {
      if (!a) {
        for (var r = arguments.length, u = new Array(r > 1 ? r - 1 : 0), f = 1; f < r; f++)
          u[f - 1] = arguments[f];
        I("error", t, u);
      }
    }
    function I(t, r, u) {
      {
        var f = i.ReactDebugCurrentFrame, C = f.getStackAddendum();
        C !== "" && (r += "%s", u = u.concat([C]));
        var p = u.map(function(b) {
          return String(b);
        });
        p.unshift("Warning: " + r), Function.prototype.apply.call(console[t], console, p);
      }
    }
    var h = 0, m = 1, w = 2, x = 3, M = 4, O = 5, k = 6, z = 7, N = 8, U = 9, Q = 10, _ = 11, X = 12, B = 13, Z = 14, Y = 15, V = 16, J = 17, e1 = 18, f1 = 19, v1 = 21, a1 = 22, d1 = 23, S1 = 24, h1 = 25, L1 = !0, c1 = !1, b1 = !1, t1 = !1, C1 = !1, w1 = !0, E1 = !1, V1 = !0, K1 = !0, B1 = !0, te = !0, R1 = /* @__PURE__ */ new Set(), x1 = {}, J1 = {};
    function X1(t, r) {
      D1(t, r), D1(t + "Capture", r);
    }
    function D1(t, r) {
      x1[t] && c("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", t), x1[t] = r;
      {
        var u = t.toLowerCase();
        J1[u] = t, t === "onDoubleClick" && (J1.ondblclick = t);
      }
      for (var f = 0; f < r.length; f++)
        R1.add(r[f]);
    }
    var $1 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", y1 = Object.prototype.hasOwnProperty;
    function ie(t) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, u = r && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function ae(t) {
      try {
        return H1(t), !1;
      } catch {
        return !0;
      }
    }
    function H1(t) {
      return "" + t;
    }
    function Y1(t, r) {
      if (ae(t))
        return c("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", r, ie(t)), H1(t);
    }
    function me(t) {
      if (ae(t))
        return c("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ie(t)), H1(t);
    }
    function ut(t, r) {
      if (ae(t))
        return c("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", r, ie(t)), H1(t);
    }
    function Qe(t, r) {
      if (ae(t))
        return c("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", r, ie(t)), H1(t);
    }
    function Ae(t) {
      if (ae(t))
        return c("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", ie(t)), H1(t);
    }
    function Bt(t) {
      if (ae(t))
        return c("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", ie(t)), H1(t);
    }
    var ke = 0, bt = 1, pt = 2, rt = 3, Jt = 4, Pe = 5, yn = 6, ee = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ge = ee + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", _e = new RegExp("^[" + ee + "][" + ge + "]*$"), wt = {}, Yt = {};
    function An(t) {
      return y1.call(Yt, t) ? !0 : y1.call(wt, t) ? !1 : _e.test(t) ? (Yt[t] = !0, !0) : (wt[t] = !0, c("Invalid attribute name: `%s`", t), !1);
    }
    function sn(t, r, u) {
      return r !== null ? r.type === ke : u ? !1 : t.length > 2 && (t[0] === "o" || t[0] === "O") && (t[1] === "n" || t[1] === "N");
    }
    function Hn(t, r, u, f) {
      if (u !== null && u.type === ke)
        return !1;
      switch (typeof r) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (f)
            return !1;
          if (u !== null)
            return !u.acceptsBooleans;
          var C = t.toLowerCase().slice(0, 5);
          return C !== "data-" && C !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Ht(t, r, u, f) {
      if (r === null || typeof r > "u" || Hn(t, r, u, f))
        return !0;
      if (f)
        return !1;
      if (u !== null)
        switch (u.type) {
          case rt:
            return !r;
          case Jt:
            return r === !1;
          case Pe:
            return isNaN(r);
          case yn:
            return isNaN(r) || r < 1;
        }
      return !1;
    }
    function b2(t) {
      return Qt.hasOwnProperty(t) ? Qt[t] : null;
    }
    function Ut(t, r, u, f, C, p, b) {
      this.acceptsBooleans = r === pt || r === rt || r === Jt, this.attributeName = f, this.attributeNamespace = C, this.mustUseProperty = u, this.propertyName = t, this.type = r, this.sanitizeURL = p, this.removeEmptyString = b;
    }
    var Qt = {}, N3 = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    N3.forEach(function(t) {
      Qt[t] = new Ut(
        t,
        ke,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(t) {
      var r = t[0], u = t[1];
      Qt[r] = new Ut(
        r,
        bt,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        pt,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        pt,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        rt,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        rt,
        !0,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        Jt,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        yn,
        !1,
        // mustUseProperty
        t,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        Pe,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var ci = /[\-\:]([a-z])/g, Vi = function(t) {
      return t[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(ci, Vi);
      Qt[r] = new Ut(
        r,
        bt,
        !1,
        // mustUseProperty
        t,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(ci, Vi);
      Qt[r] = new Ut(
        r,
        bt,
        !1,
        // mustUseProperty
        t,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(t) {
      var r = t.replace(ci, Vi);
      Qt[r] = new Ut(
        r,
        bt,
        !1,
        // mustUseProperty
        t,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        bt,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var F0 = "xlinkHref";
    Qt[F0] = new Ut(
      "xlinkHref",
      bt,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(t) {
      Qt[t] = new Ut(
        t,
        bt,
        !1,
        // mustUseProperty
        t.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var P3 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, F3 = !1;
    function Xn(t) {
      !F3 && P3.test(t) && (F3 = !0, c("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(t)));
    }
    function gi(t, r, u, f) {
      if (f.mustUseProperty) {
        var C = f.propertyName;
        return t[C];
      } else {
        Y1(u, r), f.sanitizeURL && Xn("" + u);
        var p = f.attributeName, b = null;
        if (f.type === Jt) {
          if (t.hasAttribute(p)) {
            var T = t.getAttribute(p);
            return T === "" ? !0 : Ht(r, u, f, !1) ? T : T === "" + u ? u : T;
          }
        } else if (t.hasAttribute(p)) {
          if (Ht(r, u, f, !1))
            return t.getAttribute(p);
          if (f.type === rt)
            return u;
          b = t.getAttribute(p);
        }
        return Ht(r, u, f, !1) ? b === null ? u : b : b === "" + u ? u : b;
      }
    }
    function Ki(t, r, u, f) {
      {
        if (!An(r))
          return;
        if (!t.hasAttribute(r))
          return u === void 0 ? void 0 : null;
        var C = t.getAttribute(r);
        return Y1(u, r), C === "" + u ? u : C;
      }
    }
    function ln(t, r, u, f) {
      var C = b2(r);
      if (!sn(r, C, f)) {
        if (Ht(r, u, C, f) && (u = null), f || C === null) {
          if (An(r)) {
            var p = r;
            u === null ? t.removeAttribute(p) : (Y1(u, r), t.setAttribute(p, "" + u));
          }
          return;
        }
        var b = C.mustUseProperty;
        if (b) {
          var T = C.propertyName;
          if (u === null) {
            var D = C.type;
            t[T] = D === rt ? !1 : "";
          } else
            t[T] = u;
          return;
        }
        var P = C.attributeName, F = C.attributeNamespace;
        if (u === null)
          t.removeAttribute(P);
        else {
          var i1 = C.type, n1;
          i1 === rt || i1 === Jt && u === !0 ? n1 = "" : (Y1(u, P), n1 = "" + u, C.sanitizeURL && Xn(n1.toString())), F ? t.setAttributeNS(F, P, n1) : t.setAttribute(P, n1);
        }
      }
    }
    var Xr = Symbol.for("react.element"), z2 = Symbol.for("react.portal"), N2 = Symbol.for("react.fragment"), Gr = Symbol.for("react.strict_mode"), fi = Symbol.for("react.profiler"), G = Symbol.for("react.provider"), P1 = Symbol.for("react.context"), re = Symbol.for("react.forward_ref"), be = Symbol.for("react.suspense"), st = Symbol.for("react.suspense_list"), ft = Symbol.for("react.memo"), He = Symbol.for("react.lazy"), nt = Symbol.for("react.scope"), Un = Symbol.for("react.debug_trace_mode"), Wt = Symbol.for("react.offscreen"), rn = Symbol.for("react.legacy_hidden"), P2 = Symbol.for("react.cache"), B3 = Symbol.for("react.tracing_marker"), Et = Symbol.iterator, Gn = "@@iterator";
    function K2(t) {
      if (t === null || typeof t != "object")
        return null;
      var r = Et && t[Et] || t[Gn];
      return typeof r == "function" ? r : null;
    }
    var it = Object.assign, qr = 0, ml, ns, B0, J2, vl, ur, yl;
    function Ji() {
    }
    Ji.__reactDisabledLog = !0;
    function bl() {
      {
        if (qr === 0) {
          ml = console.log, ns = console.info, B0 = console.warn, J2 = console.error, vl = console.group, ur = console.groupCollapsed, yl = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ji,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        qr++;
      }
    }
    function Yi() {
      {
        if (qr--, qr === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: it({}, t, {
              value: ml
            }),
            info: it({}, t, {
              value: ns
            }),
            warn: it({}, t, {
              value: B0
            }),
            error: it({}, t, {
              value: J2
            }),
            group: it({}, t, {
              value: vl
            }),
            groupCollapsed: it({}, t, {
              value: ur
            }),
            groupEnd: it({}, t, {
              value: yl
            })
          });
        }
        qr < 0 && c("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var di = i.ReactCurrentDispatcher, Ci;
    function Y2(t, r, u) {
      {
        if (Ci === void 0)
          try {
            throw Error();
          } catch (C) {
            var f = C.stack.trim().match(/\n( *(at )?)/);
            Ci = f && f[1] || "";
          }
        return `
` + Ci + t;
      }
    }
    var Na = !1, Qi;
    {
      var rs = typeof WeakMap == "function" ? WeakMap : Map;
      Qi = new rs();
    }
    function Pa(t, r) {
      if (!t || Na)
        return "";
      {
        var u = Qi.get(t);
        if (u !== void 0)
          return u;
      }
      var f;
      Na = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var p;
      p = di.current, di.current = null, bl();
      try {
        if (r) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (m1) {
              f = m1;
            }
            Reflect.construct(t, [], b);
          } else {
            try {
              b.call();
            } catch (m1) {
              f = m1;
            }
            t.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (m1) {
            f = m1;
          }
          t();
        }
      } catch (m1) {
        if (m1 && f && typeof m1.stack == "string") {
          for (var T = m1.stack.split(`
`), D = f.stack.split(`
`), P = T.length - 1, F = D.length - 1; P >= 1 && F >= 0 && T[P] !== D[F]; )
            F--;
          for (; P >= 1 && F >= 0; P--, F--)
            if (T[P] !== D[F]) {
              if (P !== 1 || F !== 1)
                do
                  if (P--, F--, F < 0 || T[P] !== D[F]) {
                    var i1 = `
` + T[P].replace(" at new ", " at ");
                    return t.displayName && i1.includes("<anonymous>") && (i1 = i1.replace("<anonymous>", t.displayName)), typeof t == "function" && Qi.set(t, i1), i1;
                  }
                while (P >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        Na = !1, di.current = p, Yi(), Error.prepareStackTrace = C;
      }
      var n1 = t ? t.displayName || t.name : "", A1 = n1 ? Y2(n1) : "";
      return typeof t == "function" && Qi.set(t, A1), A1;
    }
    function Fa(t, r, u) {
      return Pa(t, !0);
    }
    function H3(t, r, u) {
      return Pa(t, !1);
    }
    function Ba(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function H0(t, r, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Pa(t, Ba(t));
      if (typeof t == "string")
        return Y2(t);
      switch (t) {
        case be:
          return Y2("Suspense");
        case st:
          return Y2("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case re:
            return H3(t.render);
          case ft:
            return H0(t.type, r, u);
          case He: {
            var f = t, C = f._payload, p = f._init;
            try {
              return H0(p(C), r, u);
            } catch {
            }
          }
        }
      return "";
    }
    function Ve(t) {
      switch (t._debugOwner && t._debugOwner.type, t._debugSource, t.tag) {
        case O:
          return Y2(t.type);
        case V:
          return Y2("Lazy");
        case B:
          return Y2("Suspense");
        case f1:
          return Y2("SuspenseList");
        case h:
        case w:
        case Y:
          return H3(t.type);
        case _:
          return H3(t.type.render);
        case m:
          return Fa(t.type);
        default:
          return "";
      }
    }
    function U0(t) {
      try {
        var r = "", u = t;
        do
          r += Ve(u), u = u.return;
        while (u);
        return r;
      } catch (f) {
        return `
Error generating stack: ` + f.message + `
` + f.stack;
      }
    }
    function is(t, r, u) {
      var f = t.displayName;
      if (f)
        return f;
      var C = r.displayName || r.name || "";
      return C !== "" ? u + "(" + C + ")" : u;
    }
    function cr(t) {
      return t.displayName || "Context";
    }
    function Mt(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && c("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case N2:
          return "Fragment";
        case z2:
          return "Portal";
        case fi:
          return "Profiler";
        case Gr:
          return "StrictMode";
        case be:
          return "Suspense";
        case st:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case P1:
            var r = t;
            return cr(r) + ".Consumer";
          case G:
            var u = t;
            return cr(u._context) + ".Provider";
          case re:
            return is(t, t.render, "ForwardRef");
          case ft:
            var f = t.displayName || null;
            return f !== null ? f : Mt(t.type) || "Memo";
          case He: {
            var C = t, p = C._payload, b = C._init;
            try {
              return Mt(b(p));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function gr(t, r, u) {
      var f = r.displayName || r.name || "";
      return t.displayName || (f !== "" ? u + "(" + f + ")" : u);
    }
    function Q2(t) {
      return t.displayName || "Context";
    }
    function Fe(t) {
      var r = t.tag, u = t.type;
      switch (r) {
        case S1:
          return "Cache";
        case U:
          var f = u;
          return Q2(f) + ".Consumer";
        case Q:
          var C = u;
          return Q2(C._context) + ".Provider";
        case e1:
          return "DehydratedFragment";
        case _:
          return gr(u, u.render, "ForwardRef");
        case z:
          return "Fragment";
        case O:
          return u;
        case M:
          return "Portal";
        case x:
          return "Root";
        case k:
          return "Text";
        case V:
          return Mt(u);
        case N:
          return u === Gr ? "StrictMode" : "Mode";
        case a1:
          return "Offscreen";
        case X:
          return "Profiler";
        case v1:
          return "Scope";
        case B:
          return "Suspense";
        case f1:
          return "SuspenseList";
        case h1:
          return "TracingMarker";
        case m:
        case h:
        case J:
        case w:
        case Z:
        case Y:
          if (typeof u == "function")
            return u.displayName || u.name || null;
          if (typeof u == "string")
            return u;
          break;
      }
      return null;
    }
    var Xi = i.ReactDebugCurrentFrame, En = null, fr = !1;
    function dr() {
      {
        if (En === null)
          return null;
        var t = En._debugOwner;
        if (t !== null && typeof t < "u")
          return Fe(t);
      }
      return null;
    }
    function W0() {
      return En === null ? "" : U0(En);
    }
    function jn() {
      Xi.getCurrentStack = null, En = null, fr = !1;
    }
    function Nt(t) {
      Xi.getCurrentStack = t === null ? null : W0, En = t, fr = !1;
    }
    function _c() {
      return En;
    }
    function zr(t) {
      fr = t;
    }
    function u2(t) {
      return "" + t;
    }
    function U3(t) {
      switch (typeof t) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return t;
        case "object":
          return Bt(t), t;
        default:
          return "";
      }
    }
    var _0 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ai(t, r) {
      _0[r.type] || r.onChange || r.onInput || r.readOnly || r.disabled || r.value == null || c("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), r.onChange || r.readOnly || r.disabled || r.checked == null || c("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function L(t) {
      var r = t.type, u = t.nodeName;
      return u && u.toLowerCase() === "input" && (r === "checkbox" || r === "radio");
    }
    function R(t) {
      return t._valueTracker;
    }
    function H(t) {
      t._valueTracker = null;
    }
    function W(t) {
      var r = "";
      return t && (L(t) ? r = t.checked ? "true" : "false" : r = t.value), r;
    }
    function $(t) {
      var r = L(t) ? "checked" : "value", u = Object.getOwnPropertyDescriptor(t.constructor.prototype, r);
      Bt(t[r]);
      var f = "" + t[r];
      if (!(t.hasOwnProperty(r) || typeof u > "u" || typeof u.get != "function" || typeof u.set != "function")) {
        var C = u.get, p = u.set;
        Object.defineProperty(t, r, {
          configurable: !0,
          get: function() {
            return C.call(this);
          },
          set: function(T) {
            Bt(T), f = "" + T, p.call(this, T);
          }
        }), Object.defineProperty(t, r, {
          enumerable: u.enumerable
        });
        var b = {
          getValue: function() {
            return f;
          },
          setValue: function(T) {
            Bt(T), f = "" + T;
          },
          stopTracking: function() {
            H(t), delete t[r];
          }
        };
        return b;
      }
    }
    function I1(t) {
      R(t) || (t._valueTracker = $(t));
    }
    function U1(t) {
      if (!t)
        return !1;
      var r = R(t);
      if (!r)
        return !0;
      var u = r.getValue(), f = W(t);
      return f !== u ? (r.setValue(f), !0) : !1;
    }
    function O1(t) {
      if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u")
        return null;
      try {
        return t.activeElement || t.body;
      } catch {
        return t.body;
      }
    }
    var ce = !1, fe = !1, Le = !1, lt = !1;
    function Ct(t) {
      var r = t.type === "checkbox" || t.type === "radio";
      return r ? t.checked != null : t.value != null;
    }
    function qn(t, r) {
      var u = t, f = r.checked, C = it({}, r, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: f ?? u._wrapperState.initialChecked
      });
      return C;
    }
    function an(t, r) {
      Ai("input", r), r.checked !== void 0 && r.defaultChecked !== void 0 && !fe && (c("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", dr() || "A component", r.type), fe = !0), r.value !== void 0 && r.defaultValue !== void 0 && !ce && (c("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", dr() || "A component", r.type), ce = !0);
      var u = t, f = r.defaultValue == null ? "" : r.defaultValue;
      u._wrapperState = {
        initialChecked: r.checked != null ? r.checked : r.defaultChecked,
        initialValue: U3(r.value != null ? r.value : f),
        controlled: Ct(r)
      };
    }
    function In(t, r) {
      var u = t, f = r.checked;
      f != null && ln(u, "checked", f, !1);
    }
    function c2(t, r) {
      var u = t;
      {
        var f = Ct(r);
        !u._wrapperState.controlled && f && !lt && (c("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), lt = !0), u._wrapperState.controlled && !f && !Le && (c("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Le = !0);
      }
      In(t, r);
      var C = U3(r.value), p = r.type;
      if (C != null)
        p === "number" ? (C === 0 && u.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        u.value != C) && (u.value = u2(C)) : u.value !== u2(C) && (u.value = u2(C));
      else if (p === "submit" || p === "reset") {
        u.removeAttribute("value");
        return;
      }
      r.hasOwnProperty("value") ? Zr(u, r.type, C) : r.hasOwnProperty("defaultValue") && Zr(u, r.type, U3(r.defaultValue)), r.checked == null && r.defaultChecked != null && (u.defaultChecked = !!r.defaultChecked);
    }
    function b3(t, r, u) {
      var f = t;
      if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
        var C = r.type, p = C === "submit" || C === "reset";
        if (p && (r.value === void 0 || r.value === null))
          return;
        var b = u2(f._wrapperState.initialValue);
        u || b !== f.value && (f.value = b), f.defaultValue = b;
      }
      var T = f.name;
      T !== "" && (f.name = ""), f.defaultChecked = !f.defaultChecked, f.defaultChecked = !!f._wrapperState.initialChecked, T !== "" && (f.name = T);
    }
    function F2(t, r) {
      var u = t;
      c2(u, r), Zn(u, r);
    }
    function Zn(t, r) {
      var u = r.name;
      if (r.type === "radio" && u != null) {
        for (var f = t; f.parentNode; )
          f = f.parentNode;
        Y1(u, "name");
        for (var C = f.querySelectorAll("input[name=" + JSON.stringify("" + u) + '][type="radio"]'), p = 0; p < C.length; p++) {
          var b = C[p];
          if (!(b === t || b.form !== t.form)) {
            var T = w9(b);
            if (!T)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            U1(b), c2(b, T);
          }
        }
      }
    }
    function Zr(t, r, u) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (r !== "number" || O1(t.ownerDocument) !== t) && (u == null ? t.defaultValue = u2(t._wrapperState.initialValue) : t.defaultValue !== u2(u) && (t.defaultValue = u2(u)));
    }
    var V0 = !1, Ha = !1, Vf = !1;
    function wl(t, r) {
      r.value == null && (typeof r.children == "object" && r.children !== null ? e.Children.forEach(r.children, function(u) {
        u != null && (typeof u == "string" || typeof u == "number" || Ha || (Ha = !0, c("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : r.dangerouslySetInnerHTML != null && (Vf || (Vf = !0, c("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), r.selected != null && !V0 && (c("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), V0 = !0);
    }
    function Vc(t, r) {
      r.value != null && t.setAttribute("value", u2(U3(r.value)));
    }
    var as = Array.isArray;
    function g2(t) {
      return as(t);
    }
    var xl;
    xl = !1;
    function Kf() {
      var t = dr();
      return t ? `

Check the render method of \`` + t + "`." : "";
    }
    var Jf = ["value", "defaultValue"];
    function h6(t) {
      {
        Ai("select", t);
        for (var r = 0; r < Jf.length; r++) {
          var u = Jf[r];
          if (t[u] != null) {
            var f = g2(t[u]);
            t.multiple && !f ? c("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", u, Kf()) : !t.multiple && f && c("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", u, Kf());
          }
        }
      }
    }
    function Gi(t, r, u, f) {
      var C = t.options;
      if (r) {
        for (var p = u, b = {}, T = 0; T < p.length; T++)
          b["$" + p[T]] = !0;
        for (var D = 0; D < C.length; D++) {
          var P = b.hasOwnProperty("$" + C[D].value);
          C[D].selected !== P && (C[D].selected = P), P && f && (C[D].defaultSelected = !0);
        }
      } else {
        for (var F = u2(U3(u)), i1 = null, n1 = 0; n1 < C.length; n1++) {
          if (C[n1].value === F) {
            C[n1].selected = !0, f && (C[n1].defaultSelected = !0);
            return;
          }
          i1 === null && !C[n1].disabled && (i1 = C[n1]);
        }
        i1 !== null && (i1.selected = !0);
      }
    }
    function Kc(t, r) {
      return it({}, r, {
        value: void 0
      });
    }
    function Yf(t, r) {
      var u = t;
      h6(r), u._wrapperState = {
        wasMultiple: !!r.multiple
      }, r.value !== void 0 && r.defaultValue !== void 0 && !xl && (c("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), xl = !0);
    }
    function m6(t, r) {
      var u = t;
      u.multiple = !!r.multiple;
      var f = r.value;
      f != null ? Gi(u, !!r.multiple, f, !1) : r.defaultValue != null && Gi(u, !!r.multiple, r.defaultValue, !0);
    }
    function v6(t, r) {
      var u = t, f = u._wrapperState.wasMultiple;
      u._wrapperState.wasMultiple = !!r.multiple;
      var C = r.value;
      C != null ? Gi(u, !!r.multiple, C, !1) : f !== !!r.multiple && (r.defaultValue != null ? Gi(u, !!r.multiple, r.defaultValue, !0) : Gi(u, !!r.multiple, r.multiple ? [] : "", !1));
    }
    function y6(t, r) {
      var u = t, f = r.value;
      f != null && Gi(u, !!r.multiple, f, !1);
    }
    var Jc = !1;
    function Yc(t, r) {
      var u = t;
      if (r.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var f = it({}, r, {
        value: void 0,
        defaultValue: void 0,
        children: u2(u._wrapperState.initialValue)
      });
      return f;
    }
    function Qf(t, r) {
      var u = t;
      Ai("textarea", r), r.value !== void 0 && r.defaultValue !== void 0 && !Jc && (c("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", dr() || "A component"), Jc = !0);
      var f = r.value;
      if (f == null) {
        var C = r.children, p = r.defaultValue;
        if (C != null) {
          c("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (p != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (g2(C)) {
              if (C.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              C = C[0];
            }
            p = C;
          }
        }
        p == null && (p = ""), f = p;
      }
      u._wrapperState = {
        initialValue: U3(f)
      };
    }
    function Xf(t, r) {
      var u = t, f = U3(r.value), C = U3(r.defaultValue);
      if (f != null) {
        var p = u2(f);
        p !== u.value && (u.value = p), r.defaultValue == null && u.defaultValue !== p && (u.defaultValue = p);
      }
      C != null && (u.defaultValue = u2(C));
    }
    function Gf(t, r) {
      var u = t, f = u.textContent;
      f === u._wrapperState.initialValue && f !== "" && f !== null && (u.value = f);
    }
    function Qc(t, r) {
      Xf(t, r);
    }
    var Ii = "http://www.w3.org/1999/xhtml", b6 = "http://www.w3.org/1998/Math/MathML", Xc = "http://www.w3.org/2000/svg";
    function Sl(t) {
      switch (t) {
        case "svg":
          return Xc;
        case "math":
          return b6;
        default:
          return Ii;
      }
    }
    function Gc(t, r) {
      return t == null || t === Ii ? Sl(r) : t === Xc && r === "foreignObject" ? Ii : t;
    }
    var w6 = function(t) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(r, u, f, C) {
        MSApp.execUnsafeLocalFunction(function() {
          return t(r, u, f, C);
        });
      } : t;
    }, El, qf = w6(function(t, r) {
      if (t.namespaceURI === Xc && !("innerHTML" in t)) {
        El = El || document.createElement("div"), El.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>";
        for (var u = El.firstChild; t.firstChild; )
          t.removeChild(t.firstChild);
        for (; u.firstChild; )
          t.appendChild(u.firstChild);
        return;
      }
      t.innerHTML = r;
    }), Cr = 1, pi = 3, Wn = 8, w3 = 9, K0 = 11, Ml = function(t, r) {
      if (r) {
        var u = t.firstChild;
        if (u && u === t.lastChild && u.nodeType === pi) {
          u.nodeValue = r;
          return;
        }
      }
      t.textContent = r;
    }, Zf = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Ua = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function $f(t, r) {
      return t + r.charAt(0).toUpperCase() + r.substring(1);
    }
    var ed = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Ua).forEach(function(t) {
      ed.forEach(function(r) {
        Ua[$f(r, t)] = Ua[t];
      });
    });
    function Tl(t, r, u) {
      var f = r == null || typeof r == "boolean" || r === "";
      return f ? "" : !u && typeof r == "number" && r !== 0 && !(Ua.hasOwnProperty(t) && Ua[t]) ? r + "px" : (Qe(r, t), ("" + r).trim());
    }
    var Wa = /([A-Z])/g, x6 = /^ms-/;
    function S6(t) {
      return t.replace(Wa, "-$1").toLowerCase().replace(x6, "-ms-");
    }
    var td = function() {
    };
    {
      var nd = /^(?:webkit|moz|o)[A-Z]/, rd = /^-ms-/, os = /-(.)/g, _a = /;\s*$/, Va = {}, Ka = {}, id = !1, qc = !1, Zc = function(t) {
        return t.replace(os, function(r, u) {
          return u.toUpperCase();
        });
      }, $c = function(t) {
        Va.hasOwnProperty(t) && Va[t] || (Va[t] = !0, c(
          "Unsupported style property %s. Did you mean %s?",
          t,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Zc(t.replace(rd, "ms-"))
        ));
      }, ad = function(t) {
        Va.hasOwnProperty(t) && Va[t] || (Va[t] = !0, c("Unsupported vendor-prefixed style property %s. Did you mean %s?", t, t.charAt(0).toUpperCase() + t.slice(1)));
      }, od = function(t, r) {
        Ka.hasOwnProperty(r) && Ka[r] || (Ka[r] = !0, c(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, t, r.replace(_a, "")));
      }, sd = function(t, r) {
        id || (id = !0, c("`NaN` is an invalid value for the `%s` css style property.", t));
      }, E6 = function(t, r) {
        qc || (qc = !0, c("`Infinity` is an invalid value for the `%s` css style property.", t));
      };
      td = function(t, r) {
        t.indexOf("-") > -1 ? $c(t) : nd.test(t) ? ad(t) : _a.test(r) && od(t, r), typeof r == "number" && (isNaN(r) ? sd(t, r) : isFinite(r) || E6(t, r));
      };
    }
    var M6 = td;
    function T6(t) {
      {
        var r = "", u = "";
        for (var f in t)
          if (t.hasOwnProperty(f)) {
            var C = t[f];
            if (C != null) {
              var p = f.indexOf("--") === 0;
              r += u + (p ? f : S6(f)) + ":", r += Tl(f, C, p), u = ";";
            }
          }
        return r || null;
      }
    }
    function ld(t, r) {
      var u = t.style;
      for (var f in r)
        if (r.hasOwnProperty(f)) {
          var C = f.indexOf("--") === 0;
          C || M6(f, r[f]);
          var p = Tl(f, r[f], C);
          f === "float" && (f = "cssFloat"), C ? u.setProperty(f, p) : u[f] = p;
        }
    }
    function L6(t) {
      return t == null || typeof t == "boolean" || t === "";
    }
    function $r(t) {
      var r = {};
      for (var u in t)
        for (var f = Zf[u] || [u], C = 0; C < f.length; C++)
          r[f[C]] = u;
      return r;
    }
    function ss(t, r) {
      {
        if (!r)
          return;
        var u = $r(t), f = $r(r), C = {};
        for (var p in u) {
          var b = u[p], T = f[p];
          if (T && b !== T) {
            var D = b + "," + T;
            if (C[D])
              continue;
            C[D] = !0, c("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", L6(t[b]) ? "Removing" : "Updating", b, T);
          }
        }
      }
    }
    var ud = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, cd = it({
      menuitem: !0
    }, ud), gd = "__html";
    function Ll(t, r) {
      if (r) {
        if (cd[t] && (r.children != null || r.dangerouslySetInnerHTML != null))
          throw new Error(t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (r.dangerouslySetInnerHTML != null) {
          if (r.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof r.dangerouslySetInnerHTML != "object" || !(gd in r.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!r.suppressContentEditableWarning && r.contentEditable && r.children != null && c("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), r.style != null && typeof r.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function hi(t, r) {
      if (t.indexOf("-") === -1)
        return typeof r.is == "string";
      switch (t) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Rl = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, fd = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, x3 = {}, e4 = new RegExp("^(aria)-[" + ge + "]*$"), ls = new RegExp("^(aria)[A-Z][" + ge + "]*$");
    function t4(t, r) {
      {
        if (y1.call(x3, r) && x3[r])
          return !0;
        if (ls.test(r)) {
          var u = "aria-" + r.slice(4).toLowerCase(), f = fd.hasOwnProperty(u) ? u : null;
          if (f == null)
            return c("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", r), x3[r] = !0, !0;
          if (r !== f)
            return c("Invalid ARIA attribute `%s`. Did you mean `%s`?", r, f), x3[r] = !0, !0;
        }
        if (e4.test(r)) {
          var C = r.toLowerCase(), p = fd.hasOwnProperty(C) ? C : null;
          if (p == null)
            return x3[r] = !0, !1;
          if (r !== p)
            return c("Unknown ARIA attribute `%s`. Did you mean `%s`?", r, p), x3[r] = !0, !0;
        }
      }
      return !0;
    }
    function dd(t, r) {
      {
        var u = [];
        for (var f in r) {
          var C = t4(t, f);
          C || u.push(f);
        }
        var p = u.map(function(b) {
          return "`" + b + "`";
        }).join(", ");
        u.length === 1 ? c("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", p, t) : u.length > 1 && c("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", p, t);
      }
    }
    function Ol(t, r) {
      hi(t, r) || dd(t, r);
    }
    var J0 = !1;
    function n4(t, r) {
      {
        if (t !== "input" && t !== "textarea" && t !== "select")
          return;
        r != null && r.value === null && !J0 && (J0 = !0, t === "select" && r.multiple ? c("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", t) : c("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", t));
      }
    }
    var r4 = function() {
    };
    {
      var f2 = {}, i4 = /^on./, Cd = /^on[^A-Z]/, Ad = new RegExp("^(aria)-[" + ge + "]*$"), Id = new RegExp("^(aria)[A-Z][" + ge + "]*$");
      r4 = function(t, r, u, f) {
        if (y1.call(f2, r) && f2[r])
          return !0;
        var C = r.toLowerCase();
        if (C === "onfocusin" || C === "onfocusout")
          return c("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), f2[r] = !0, !0;
        if (f != null) {
          var p = f.registrationNameDependencies, b = f.possibleRegistrationNames;
          if (p.hasOwnProperty(r))
            return !0;
          var T = b.hasOwnProperty(C) ? b[C] : null;
          if (T != null)
            return c("Invalid event handler property `%s`. Did you mean `%s`?", r, T), f2[r] = !0, !0;
          if (i4.test(r))
            return c("Unknown event handler property `%s`. It will be ignored.", r), f2[r] = !0, !0;
        } else if (i4.test(r))
          return Cd.test(r) && c("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", r), f2[r] = !0, !0;
        if (Ad.test(r) || Id.test(r))
          return !0;
        if (C === "innerhtml")
          return c("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), f2[r] = !0, !0;
        if (C === "aria")
          return c("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), f2[r] = !0, !0;
        if (C === "is" && u !== null && u !== void 0 && typeof u != "string")
          return c("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof u), f2[r] = !0, !0;
        if (typeof u == "number" && isNaN(u))
          return c("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", r), f2[r] = !0, !0;
        var D = b2(r), P = D !== null && D.type === ke;
        if (Rl.hasOwnProperty(C)) {
          var F = Rl[C];
          if (F !== r)
            return c("Invalid DOM property `%s`. Did you mean `%s`?", r, F), f2[r] = !0, !0;
        } else if (!P && r !== C)
          return c("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", r, C), f2[r] = !0, !0;
        return typeof u == "boolean" && Hn(r, u, D, !1) ? (u ? c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', u, r, r, u, r) : c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', u, r, r, u, r, r, r), f2[r] = !0, !0) : P ? !0 : Hn(r, u, D, !1) ? (f2[r] = !0, !1) : ((u === "false" || u === "true") && D !== null && D.type === rt && (c("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", u, r, u === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', r, u), f2[r] = !0), !0);
      };
    }
    var pd = function(t, r, u) {
      {
        var f = [];
        for (var C in r) {
          var p = r4(t, C, r[C], u);
          p || f.push(C);
        }
        var b = f.map(function(T) {
          return "`" + T + "`";
        }).join(", ");
        f.length === 1 ? c("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", b, t) : f.length > 1 && c("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", b, t);
      }
    };
    function hd(t, r, u) {
      hi(t, r) || pd(t, r, u);
    }
    var mi = 1, us = 2, Y0 = 4, R6 = mi | us | Y0, cs = null;
    function gs(t) {
      cs !== null && c("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), cs = t;
    }
    function O6() {
      cs === null && c("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), cs = null;
    }
    function md(t) {
      return t === cs;
    }
    function Dl(t) {
      var r = t.target || t.srcElement || window;
      return r.correspondingUseElement && (r = r.correspondingUseElement), r.nodeType === pi ? r.parentNode : r;
    }
    var on = null, qi = null, vi = null;
    function Ja(t) {
      var r = Eo(t);
      if (r) {
        if (typeof on != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var u = r.stateNode;
        if (u) {
          var f = w9(u);
          on(r.stateNode, r.type, f);
        }
      }
    }
    function vd(t) {
      on = t;
    }
    function kl(t) {
      qi ? vi ? vi.push(t) : vi = [t] : qi = t;
    }
    function fs() {
      return qi !== null || vi !== null;
    }
    function ds() {
      if (qi) {
        var t = qi, r = vi;
        if (qi = null, vi = null, Ja(t), r)
          for (var u = 0; u < r.length; u++)
            Ja(r[u]);
      }
    }
    var Q0 = function(t, r) {
      return t(r);
    }, a4 = function() {
    }, o4 = !1;
    function D6() {
      var t = fs();
      t && (a4(), ds());
    }
    function s4(t, r, u) {
      if (o4)
        return t(r, u);
      o4 = !0;
      try {
        return Q0(t, r, u);
      } finally {
        o4 = !1, D6();
      }
    }
    function jl(t, r, u) {
      Q0 = t, a4 = u;
    }
    function zl(t) {
      return t === "button" || t === "input" || t === "select" || t === "textarea";
    }
    function l4(t, r, u) {
      switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(u.disabled && zl(r));
        default:
          return !1;
      }
    }
    function X0(t, r) {
      var u = t.stateNode;
      if (u === null)
        return null;
      var f = w9(u);
      if (f === null)
        return null;
      var C = f[r];
      if (l4(r, t.type, f))
        return null;
      if (C && typeof C != "function")
        throw new Error("Expected `" + r + "` listener to be a function, instead got a value of `" + typeof C + "` type.");
      return C;
    }
    var Cs = !1;
    if ($1)
      try {
        var G0 = {};
        Object.defineProperty(G0, "passive", {
          get: function() {
            Cs = !0;
          }
        }), window.addEventListener("test", G0, G0), window.removeEventListener("test", G0, G0);
      } catch {
        Cs = !1;
      }
    function yd(t, r, u, f, C, p, b, T, D) {
      var P = Array.prototype.slice.call(arguments, 3);
      try {
        r.apply(u, P);
      } catch (F) {
        this.onError(F);
      }
    }
    var u4 = yd;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var c4 = document.createElement("react");
      u4 = function(r, u, f, C, p, b, T, D, P) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var F = document.createEvent("Event"), i1 = !1, n1 = !0, A1 = window.event, m1 = Object.getOwnPropertyDescriptor(window, "event");
        function M1() {
          c4.removeEventListener(T1, We, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = A1);
        }
        var Ce = Array.prototype.slice.call(arguments, 3);
        function We() {
          i1 = !0, M1(), u.apply(f, Ce), n1 = !1;
        }
        var ze, mt = !1, It = !1;
        function l1(u1) {
          if (ze = u1.error, mt = !0, ze === null && u1.colno === 0 && u1.lineno === 0 && (It = !0), u1.defaultPrevented && ze != null && typeof ze == "object")
            try {
              ze._suppressLogging = !0;
            } catch {
            }
        }
        var T1 = "react-" + (r || "invokeguardedcallback");
        if (window.addEventListener("error", l1), c4.addEventListener(T1, We, !1), F.initEvent(T1, !1, !1), c4.dispatchEvent(F), m1 && Object.defineProperty(window, "event", m1), i1 && n1 && (mt ? It && (ze = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : ze = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(ze)), window.removeEventListener("error", l1), !i1)
          return M1(), yd.apply(this, arguments);
      };
    }
    var k6 = u4, Zi = !1, S3 = null, As = !1, $i = null, W3 = {
      onError: function(t) {
        Zi = !0, S3 = t;
      }
    };
    function q0(t, r, u, f, C, p, b, T, D) {
      Zi = !1, S3 = null, k6.apply(W3, arguments);
    }
    function yi(t, r, u, f, C, p, b, T, D) {
      if (q0.apply(this, arguments), Zi) {
        var P = f4();
        As || (As = !0, $i = P);
      }
    }
    function g4() {
      if (As) {
        var t = $i;
        throw As = !1, $i = null, t;
      }
    }
    function j6() {
      return Zi;
    }
    function f4() {
      if (Zi) {
        var t = S3;
        return Zi = !1, S3 = null, t;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function e3(t) {
      return t._reactInternals;
    }
    function Is(t) {
      return t._reactInternals !== void 0;
    }
    function Ya(t, r) {
      t._reactInternals = r;
    }
    var Ue = (
      /*                      */
      0
    ), e0 = (
      /*                */
      1
    ), cn = (
      /*                    */
      2
    ), tt = (
      /*                       */
      4
    ), Ot = (
      /*                */
      16
    ), Pt = (
      /*                 */
      32
    ), _3 = (
      /*                     */
      64
    ), Xe = (
      /*                   */
      128
    ), Mn = (
      /*            */
      256
    ), Ar = (
      /*                          */
      512
    ), t3 = (
      /*                     */
      1024
    ), pn = (
      /*                      */
      2048
    ), n3 = (
      /*                    */
      4096
    ), t0 = (
      /*                   */
      8192
    ), ps = (
      /*             */
      16384
    ), Nl = pn | tt | _3 | Ar | t3 | ps, bd = (
      /*               */
      32767
    ), Nr = (
      /*                   */
      32768
    ), d2 = (
      /*                */
      65536
    ), hs = (
      /* */
      131072
    ), d4 = (
      /*                       */
      1048576
    ), C4 = (
      /*                    */
      2097152
    ), Ir = (
      /*                 */
      4194304
    ), n0 = (
      /*                */
      8388608
    ), pr = (
      /*               */
      16777216
    ), Z0 = (
      /*              */
      33554432
    ), Qa = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      tt | t3 | 0
    ), hr = cn | tt | Ot | Pt | Ar | n3 | t0, B2 = tt | _3 | Ar | t0, r3 = pn | Ot, w2 = Ir | n0 | C4, bi = i.ReactCurrentOwner;
    function Pr(t) {
      var r = t, u = t;
      if (t.alternate)
        for (; r.return; )
          r = r.return;
      else {
        var f = r;
        do
          r = f, (r.flags & (cn | n3)) !== Ue && (u = r.return), f = r.return;
        while (f);
      }
      return r.tag === x ? u : null;
    }
    function A4(t) {
      if (t.tag === B) {
        var r = t.memoizedState;
        if (r === null) {
          var u = t.alternate;
          u !== null && (r = u.memoizedState);
        }
        if (r !== null)
          return r.dehydrated;
      }
      return null;
    }
    function Pl(t) {
      return t.tag === x ? t.stateNode.containerInfo : null;
    }
    function I4(t) {
      return Pr(t) === t;
    }
    function Fr(t) {
      {
        var r = bi.current;
        if (r !== null && r.tag === m) {
          var u = r, f = u.stateNode;
          f._warnedAboutRefsInRender || c("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Fe(u) || "A component"), f._warnedAboutRefsInRender = !0;
        }
      }
      var C = e3(t);
      return C ? Pr(C) === C : !1;
    }
    function mr(t) {
      if (Pr(t) !== t)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function gn(t) {
      var r = t.alternate;
      if (!r) {
        var u = Pr(t);
        if (u === null)
          throw new Error("Unable to find node on an unmounted component.");
        return u !== t ? null : t;
      }
      for (var f = t, C = r; ; ) {
        var p = f.return;
        if (p === null)
          break;
        var b = p.alternate;
        if (b === null) {
          var T = p.return;
          if (T !== null) {
            f = C = T;
            continue;
          }
          break;
        }
        if (p.child === b.child) {
          for (var D = p.child; D; ) {
            if (D === f)
              return mr(p), t;
            if (D === C)
              return mr(p), r;
            D = D.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (f.return !== C.return)
          f = p, C = b;
        else {
          for (var P = !1, F = p.child; F; ) {
            if (F === f) {
              P = !0, f = p, C = b;
              break;
            }
            if (F === C) {
              P = !0, C = p, f = b;
              break;
            }
            F = F.sibling;
          }
          if (!P) {
            for (F = b.child; F; ) {
              if (F === f) {
                P = !0, f = b, C = p;
                break;
              }
              if (F === C) {
                P = !0, C = b, f = p;
                break;
              }
              F = F.sibling;
            }
            if (!P)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (f.alternate !== C)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (f.tag !== x)
        throw new Error("Unable to find node on an unmounted component.");
      return f.stateNode.current === f ? t : r;
    }
    function i3(t) {
      var r = gn(t);
      return r !== null ? p4(r) : null;
    }
    function p4(t) {
      if (t.tag === O || t.tag === k)
        return t;
      for (var r = t.child; r !== null; ) {
        var u = p4(r);
        if (u !== null)
          return u;
        r = r.sibling;
      }
      return null;
    }
    function wd(t) {
      var r = gn(t);
      return r !== null ? Fl(r) : null;
    }
    function Fl(t) {
      if (t.tag === O || t.tag === k)
        return t;
      for (var r = t.child; r !== null; ) {
        if (r.tag !== M) {
          var u = Fl(r);
          if (u !== null)
            return u;
        }
        r = r.sibling;
      }
      return null;
    }
    var Bl = n.unstable_scheduleCallback, xd = n.unstable_cancelCallback, Hl = n.unstable_shouldYield, Sd = n.unstable_requestPaint, bn = n.unstable_now, h4 = n.unstable_getCurrentPriorityLevel, Ul = n.unstable_ImmediatePriority, $0 = n.unstable_UserBlockingPriority, V3 = n.unstable_NormalPriority, Ed = n.unstable_LowPriority, Wl = n.unstable_IdlePriority, Xa = n.unstable_yieldValue, Md = n.unstable_setDisableYieldValue, wi = null, $n = null, oe = null, a3 = !1, Br = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function m4(t) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var r = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (r.isDisabled)
        return !0;
      if (!r.supportsFiber)
        return c("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        K1 && (t = it({}, t, {
          getLaneLabelMap: xi,
          injectProfilingHooks: Td
        })), wi = r.inject(t), $n = r;
      } catch (u) {
        c("React instrumentation encountered an error: %s.", u);
      }
      return !!r.checkDCE;
    }
    function v4(t, r) {
      if ($n && typeof $n.onScheduleFiberRoot == "function")
        try {
          $n.onScheduleFiberRoot(wi, t, r);
        } catch (u) {
          a3 || (a3 = !0, c("React instrumentation encountered an error: %s", u));
        }
    }
    function Ga(t, r) {
      if ($n && typeof $n.onCommitFiberRoot == "function")
        try {
          var u = (t.current.flags & Xe) === Xe;
          if (B1) {
            var f;
            switch (r) {
              case Nn:
                f = Ul;
                break;
              case Ei:
                f = $0;
                break;
              case K3:
                f = V3;
                break;
              case lo:
                f = Wl;
                break;
              default:
                f = V3;
                break;
            }
            $n.onCommitFiberRoot(wi, t, f, u);
          }
        } catch (C) {
          a3 || (a3 = !0, c("React instrumentation encountered an error: %s", C));
        }
    }
    function o3(t) {
      if ($n && typeof $n.onPostCommitFiberRoot == "function")
        try {
          $n.onPostCommitFiberRoot(wi, t);
        } catch (r) {
          a3 || (a3 = !0, c("React instrumentation encountered an error: %s", r));
        }
    }
    function ea(t) {
      if ($n && typeof $n.onCommitFiberUnmount == "function")
        try {
          $n.onCommitFiberUnmount(wi, t);
        } catch (r) {
          a3 || (a3 = !0, c("React instrumentation encountered an error: %s", r));
        }
    }
    function _n(t) {
      if (typeof Xa == "function" && (Md(t), s(t)), $n && typeof $n.setStrictMode == "function")
        try {
          $n.setStrictMode(wi, t);
        } catch (r) {
          a3 || (a3 = !0, c("React instrumentation encountered an error: %s", r));
        }
    }
    function Td(t) {
      oe = t;
    }
    function xi() {
      {
        for (var t = /* @__PURE__ */ new Map(), r = 1, u = 0; u < ws; u++) {
          var f = N6(r);
          t.set(r, f), r *= 2;
        }
        return t;
      }
    }
    function r0(t) {
      oe !== null && typeof oe.markCommitStarted == "function" && oe.markCommitStarted(t);
    }
    function _l() {
      oe !== null && typeof oe.markCommitStopped == "function" && oe.markCommitStopped();
    }
    function qa(t) {
      oe !== null && typeof oe.markComponentRenderStarted == "function" && oe.markComponentRenderStarted(t);
    }
    function vr() {
      oe !== null && typeof oe.markComponentRenderStopped == "function" && oe.markComponentRenderStopped();
    }
    function i0(t) {
      oe !== null && typeof oe.markComponentPassiveEffectMountStarted == "function" && oe.markComponentPassiveEffectMountStarted(t);
    }
    function Vl() {
      oe !== null && typeof oe.markComponentPassiveEffectMountStopped == "function" && oe.markComponentPassiveEffectMountStopped();
    }
    function Ld(t) {
      oe !== null && typeof oe.markComponentPassiveEffectUnmountStarted == "function" && oe.markComponentPassiveEffectUnmountStarted(t);
    }
    function Kl() {
      oe !== null && typeof oe.markComponentPassiveEffectUnmountStopped == "function" && oe.markComponentPassiveEffectUnmountStopped();
    }
    function Rd(t) {
      oe !== null && typeof oe.markComponentLayoutEffectMountStarted == "function" && oe.markComponentLayoutEffectMountStarted(t);
    }
    function ms() {
      oe !== null && typeof oe.markComponentLayoutEffectMountStopped == "function" && oe.markComponentLayoutEffectMountStopped();
    }
    function E3(t) {
      oe !== null && typeof oe.markComponentLayoutEffectUnmountStarted == "function" && oe.markComponentLayoutEffectUnmountStarted(t);
    }
    function Za() {
      oe !== null && typeof oe.markComponentLayoutEffectUnmountStopped == "function" && oe.markComponentLayoutEffectUnmountStopped();
    }
    function vs(t, r, u) {
      oe !== null && typeof oe.markComponentErrored == "function" && oe.markComponentErrored(t, r, u);
    }
    function ta(t, r, u) {
      oe !== null && typeof oe.markComponentSuspended == "function" && oe.markComponentSuspended(t, r, u);
    }
    function y4(t) {
      oe !== null && typeof oe.markLayoutEffectsStarted == "function" && oe.markLayoutEffectsStarted(t);
    }
    function $a() {
      oe !== null && typeof oe.markLayoutEffectsStopped == "function" && oe.markLayoutEffectsStopped();
    }
    function Od(t) {
      oe !== null && typeof oe.markPassiveEffectsStarted == "function" && oe.markPassiveEffectsStarted(t);
    }
    function b4() {
      oe !== null && typeof oe.markPassiveEffectsStopped == "function" && oe.markPassiveEffectsStopped();
    }
    function hn(t) {
      oe !== null && typeof oe.markRenderStarted == "function" && oe.markRenderStarted(t);
    }
    function Jl() {
      oe !== null && typeof oe.markRenderYielded == "function" && oe.markRenderYielded();
    }
    function Yl() {
      oe !== null && typeof oe.markRenderStopped == "function" && oe.markRenderStopped();
    }
    function w4(t) {
      oe !== null && typeof oe.markRenderScheduled == "function" && oe.markRenderScheduled(t);
    }
    function Ql(t, r) {
      oe !== null && typeof oe.markForceUpdateScheduled == "function" && oe.markForceUpdateScheduled(t, r);
    }
    function ys(t, r) {
      oe !== null && typeof oe.markStateUpdateScheduled == "function" && oe.markStateUpdateScheduled(t, r);
    }
    var Re = (
      /*                         */
      0
    ), je = (
      /*                 */
      1
    ), Ge = (
      /*                    */
      2
    ), ct = (
      /*               */
      8
    ), Hr = (
      /*              */
      16
    ), eo = Math.clz32 ? Math.clz32 : H2, bs = Math.log, z6 = Math.LN2;
    function H2(t) {
      var r = t >>> 0;
      return r === 0 ? 32 : 31 - (bs(r) / z6 | 0) | 0;
    }
    var ws = 31, z1 = (
      /*                        */
      0
    ), Vn = (
      /*                          */
      0
    ), Ne = (
      /*                        */
      1
    ), x2 = (
      /*    */
      2
    ), Ur = (
      /*             */
      4
    ), Si = (
      /*            */
      8
    ), s3 = (
      /*                     */
      16
    ), to = (
      /*                */
      32
    ), na = (
      /*                       */
      4194240
    ), no = (
      /*                        */
      64
    ), Xl = (
      /*                        */
      128
    ), Gl = (
      /*                        */
      256
    ), ql = (
      /*                        */
      512
    ), Zl = (
      /*                        */
      1024
    ), $l = (
      /*                        */
      2048
    ), ra = (
      /*                        */
      4096
    ), eu = (
      /*                        */
      8192
    ), ro = (
      /*                        */
      16384
    ), io = (
      /*                       */
      32768
    ), tu = (
      /*                       */
      65536
    ), xs = (
      /*                       */
      131072
    ), nu = (
      /*                       */
      262144
    ), ru = (
      /*                       */
      524288
    ), iu = (
      /*                       */
      1048576
    ), au = (
      /*                       */
      2097152
    ), ao = (
      /*                            */
      130023424
    ), ia = (
      /*                             */
      4194304
    ), ou = (
      /*                             */
      8388608
    ), su = (
      /*                             */
      16777216
    ), x4 = (
      /*                             */
      33554432
    ), lu = (
      /*                             */
      67108864
    ), Dd = ia, Ss = (
      /*          */
      134217728
    ), S4 = (
      /*                          */
      268435455
    ), oo = (
      /*               */
      268435456
    ), a0 = (
      /*                        */
      536870912
    ), U2 = (
      /*                   */
      1073741824
    );
    function N6(t) {
      {
        if (t & Ne)
          return "Sync";
        if (t & x2)
          return "InputContinuousHydration";
        if (t & Ur)
          return "InputContinuous";
        if (t & Si)
          return "DefaultHydration";
        if (t & s3)
          return "Default";
        if (t & to)
          return "TransitionHydration";
        if (t & na)
          return "Transition";
        if (t & ao)
          return "Retry";
        if (t & Ss)
          return "SelectiveHydration";
        if (t & oo)
          return "IdleHydration";
        if (t & a0)
          return "Idle";
        if (t & U2)
          return "Offscreen";
      }
    }
    var un = -1, uu = no, yr = ia;
    function aa(t) {
      switch (zn(t)) {
        case Ne:
          return Ne;
        case x2:
          return x2;
        case Ur:
          return Ur;
        case Si:
          return Si;
        case s3:
          return s3;
        case to:
          return to;
        case no:
        case Xl:
        case Gl:
        case ql:
        case Zl:
        case $l:
        case ra:
        case eu:
        case ro:
        case io:
        case tu:
        case xs:
        case nu:
        case ru:
        case iu:
        case au:
          return t & na;
        case ia:
        case ou:
        case su:
        case x4:
        case lu:
          return t & ao;
        case Ss:
          return Ss;
        case oo:
          return oo;
        case a0:
          return a0;
        case U2:
          return U2;
        default:
          return c("Should have found matching lanes. This is a bug in React."), t;
      }
    }
    function oa(t, r) {
      var u = t.pendingLanes;
      if (u === z1)
        return z1;
      var f = z1, C = t.suspendedLanes, p = t.pingedLanes, b = u & S4;
      if (b !== z1) {
        var T = b & ~C;
        if (T !== z1)
          f = aa(T);
        else {
          var D = b & p;
          D !== z1 && (f = aa(D));
        }
      } else {
        var P = u & ~C;
        P !== z1 ? f = aa(P) : p !== z1 && (f = aa(p));
      }
      if (f === z1)
        return z1;
      if (r !== z1 && r !== f && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (r & C) === z1) {
        var F = zn(f), i1 = zn(r);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          F >= i1 || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          F === s3 && (i1 & na) !== z1
        )
          return r;
      }
      (f & Ur) !== z1 && (f |= u & s3);
      var n1 = t.entangledLanes;
      if (n1 !== z1)
        for (var A1 = t.entanglements, m1 = f & n1; m1 > 0; ) {
          var M1 = s0(m1), Ce = 1 << M1;
          f |= A1[M1], m1 &= ~Ce;
        }
      return f;
    }
    function kd(t, r) {
      for (var u = t.eventTimes, f = un; r > 0; ) {
        var C = s0(r), p = 1 << C, b = u[C];
        b > f && (f = b), r &= ~p;
      }
      return f;
    }
    function jd(t, r) {
      switch (t) {
        case Ne:
        case x2:
        case Ur:
          return r + 250;
        case Si:
        case s3:
        case to:
        case no:
        case Xl:
        case Gl:
        case ql:
        case Zl:
        case $l:
        case ra:
        case eu:
        case ro:
        case io:
        case tu:
        case xs:
        case nu:
        case ru:
        case iu:
        case au:
          return r + 5e3;
        case ia:
        case ou:
        case su:
        case x4:
        case lu:
          return un;
        case Ss:
        case oo:
        case a0:
        case U2:
          return un;
        default:
          return c("Should have found matching lanes. This is a bug in React."), un;
      }
    }
    function zd(t, r) {
      for (var u = t.pendingLanes, f = t.suspendedLanes, C = t.pingedLanes, p = t.expirationTimes, b = u; b > 0; ) {
        var T = s0(b), D = 1 << T, P = p[T];
        P === un ? ((D & f) === z1 || (D & C) !== z1) && (p[T] = jd(D, r)) : P <= r && (t.expiredLanes |= D), b &= ~D;
      }
    }
    function E4(t) {
      return aa(t.pendingLanes);
    }
    function o0(t) {
      var r = t.pendingLanes & ~U2;
      return r !== z1 ? r : r & U2 ? U2 : z1;
    }
    function M4(t) {
      return (t & Ne) !== z1;
    }
    function Es(t) {
      return (t & S4) !== z1;
    }
    function Nd(t) {
      return (t & ao) === t;
    }
    function Pd(t) {
      var r = Ne | Ur | s3;
      return (t & r) === z1;
    }
    function Fd(t) {
      return (t & na) === t;
    }
    function Ms(t, r) {
      var u = x2 | Ur | Si | s3;
      return (r & u) !== z1;
    }
    function Bd(t, r) {
      return (r & t.expiredLanes) !== z1;
    }
    function T4(t) {
      return (t & na) !== z1;
    }
    function Hd() {
      var t = uu;
      return uu <<= 1, (uu & na) === z1 && (uu = no), t;
    }
    function br() {
      var t = yr;
      return yr <<= 1, (yr & ao) === z1 && (yr = ia), t;
    }
    function zn(t) {
      return t & -t;
    }
    function so(t) {
      return zn(t);
    }
    function s0(t) {
      return 31 - eo(t);
    }
    function cu(t) {
      return s0(t);
    }
    function wr(t, r) {
      return (t & r) !== z1;
    }
    function sa(t, r) {
      return (t & r) === r;
    }
    function et(t, r) {
      return t | r;
    }
    function Ts(t, r) {
      return t & ~r;
    }
    function gu(t, r) {
      return t & r;
    }
    function P6(t) {
      return t;
    }
    function Ud(t, r) {
      return t !== Vn && t < r ? t : r;
    }
    function Ls(t) {
      for (var r = [], u = 0; u < ws; u++)
        r.push(t);
      return r;
    }
    function la(t, r, u) {
      t.pendingLanes |= r, r !== a0 && (t.suspendedLanes = z1, t.pingedLanes = z1);
      var f = t.eventTimes, C = cu(r);
      f[C] = u;
    }
    function Wd(t, r) {
      t.suspendedLanes |= r, t.pingedLanes &= ~r;
      for (var u = t.expirationTimes, f = r; f > 0; ) {
        var C = s0(f), p = 1 << C;
        u[C] = un, f &= ~p;
      }
    }
    function fu(t, r, u) {
      t.pingedLanes |= t.suspendedLanes & r;
    }
    function du(t, r) {
      var u = t.pendingLanes & ~r;
      t.pendingLanes = r, t.suspendedLanes = z1, t.pingedLanes = z1, t.expiredLanes &= r, t.mutableReadLanes &= r, t.entangledLanes &= r;
      for (var f = t.entanglements, C = t.eventTimes, p = t.expirationTimes, b = u; b > 0; ) {
        var T = s0(b), D = 1 << T;
        f[T] = z1, C[T] = un, p[T] = un, b &= ~D;
      }
    }
    function L4(t, r) {
      for (var u = t.entangledLanes |= r, f = t.entanglements, C = u; C; ) {
        var p = s0(C), b = 1 << p;
        // Is this one of the newly entangled lanes?
        b & r | // Is this lane transitively entangled with the newly entangled lanes?
        f[p] & r && (f[p] |= r), C &= ~b;
      }
    }
    function _d(t, r) {
      var u = zn(r), f;
      switch (u) {
        case Ur:
          f = x2;
          break;
        case s3:
          f = Si;
          break;
        case no:
        case Xl:
        case Gl:
        case ql:
        case Zl:
        case $l:
        case ra:
        case eu:
        case ro:
        case io:
        case tu:
        case xs:
        case nu:
        case ru:
        case iu:
        case au:
        case ia:
        case ou:
        case su:
        case x4:
        case lu:
          f = to;
          break;
        case a0:
          f = oo;
          break;
        default:
          f = Vn;
          break;
      }
      return (f & (t.suspendedLanes | r)) !== Vn ? Vn : f;
    }
    function Cu(t, r, u) {
      if (Br)
        for (var f = t.pendingUpdatersLaneMap; u > 0; ) {
          var C = cu(u), p = 1 << C, b = f[C];
          b.add(r), u &= ~p;
        }
    }
    function R4(t, r) {
      if (Br)
        for (var u = t.pendingUpdatersLaneMap, f = t.memoizedUpdaters; r > 0; ) {
          var C = cu(r), p = 1 << C, b = u[C];
          b.size > 0 && (b.forEach(function(T) {
            var D = T.alternate;
            (D === null || !f.has(D)) && f.add(T);
          }), b.clear()), r &= ~p;
        }
    }
    function Rs(t, r) {
      return null;
    }
    var Nn = Ne, Ei = Ur, K3 = s3, lo = a0, uo = Vn;
    function l3() {
      return uo;
    }
    function Tn(t) {
      uo = t;
    }
    function W2(t, r) {
      var u = uo;
      try {
        return uo = t, r();
      } finally {
        uo = u;
      }
    }
    function F6(t, r) {
      return t !== 0 && t < r ? t : r;
    }
    function B6(t, r) {
      return t > r ? t : r;
    }
    function co(t, r) {
      return t !== 0 && t < r;
    }
    function S2(t) {
      var r = zn(t);
      return co(Nn, r) ? co(Ei, r) ? Es(r) ? K3 : lo : Ei : Nn;
    }
    function Au(t) {
      var r = t.current.memoizedState;
      return r.isDehydrated;
    }
    var we;
    function go(t) {
      we = t;
    }
    function O4(t) {
      we(t);
    }
    var Iu;
    function H6(t) {
      Iu = t;
    }
    var fo;
    function pu(t) {
      fo = t;
    }
    var hu;
    function Vd(t) {
      hu = t;
    }
    var D4;
    function Kd(t) {
      D4 = t;
    }
    var Os = !1, Co = [], mn = null, C2 = null, X2 = null, Ao = /* @__PURE__ */ new Map(), Io = /* @__PURE__ */ new Map(), A2 = [], Jd = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function J3(t) {
      return Jd.indexOf(t) > -1;
    }
    function U6(t, r, u, f, C) {
      return {
        blockedOn: t,
        domEventName: r,
        eventSystemFlags: u,
        nativeEvent: C,
        targetContainers: [f]
      };
    }
    function k4(t, r) {
      switch (t) {
        case "focusin":
        case "focusout":
          mn = null;
          break;
        case "dragenter":
        case "dragleave":
          C2 = null;
          break;
        case "mouseover":
        case "mouseout":
          X2 = null;
          break;
        case "pointerover":
        case "pointerout": {
          var u = r.pointerId;
          Ao.delete(u);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var f = r.pointerId;
          Io.delete(f);
          break;
        }
      }
    }
    function po(t, r, u, f, C, p) {
      if (t === null || t.nativeEvent !== p) {
        var b = U6(r, u, f, C, p);
        if (r !== null) {
          var T = Eo(r);
          T !== null && Iu(T);
        }
        return b;
      }
      t.eventSystemFlags |= f;
      var D = t.targetContainers;
      return C !== null && D.indexOf(C) === -1 && D.push(C), t;
    }
    function Yd(t, r, u, f, C) {
      switch (r) {
        case "focusin": {
          var p = C;
          return mn = po(mn, t, r, u, f, p), !0;
        }
        case "dragenter": {
          var b = C;
          return C2 = po(C2, t, r, u, f, b), !0;
        }
        case "mouseover": {
          var T = C;
          return X2 = po(X2, t, r, u, f, T), !0;
        }
        case "pointerover": {
          var D = C, P = D.pointerId;
          return Ao.set(P, po(Ao.get(P) || null, t, r, u, f, D)), !0;
        }
        case "gotpointercapture": {
          var F = C, i1 = F.pointerId;
          return Io.set(i1, po(Io.get(i1) || null, t, r, u, f, F)), !0;
        }
      }
      return !1;
    }
    function j4(t) {
      var r = _s(t.target);
      if (r !== null) {
        var u = Pr(r);
        if (u !== null) {
          var f = u.tag;
          if (f === B) {
            var C = A4(u);
            if (C !== null) {
              t.blockedOn = C, D4(t.priority, function() {
                fo(u);
              });
              return;
            }
          } else if (f === x) {
            var p = u.stateNode;
            if (Au(p)) {
              t.blockedOn = Pl(u);
              return;
            }
          }
        }
      }
      t.blockedOn = null;
    }
    function W6(t) {
      for (var r = hu(), u = {
        blockedOn: null,
        target: t,
        priority: r
      }, f = 0; f < A2.length && co(r, A2[f].priority); f++)
        ;
      A2.splice(f, 0, u), f === 0 && j4(u);
    }
    function ua(t) {
      if (t.blockedOn !== null)
        return !1;
      for (var r = t.targetContainers; r.length > 0; ) {
        var u = r[0], f = _2(t.domEventName, t.eventSystemFlags, u, t.nativeEvent);
        if (f === null) {
          var C = t.nativeEvent, p = new C.constructor(C.type, C);
          gs(p), C.target.dispatchEvent(p), O6();
        } else {
          var b = Eo(f);
          return b !== null && Iu(b), t.blockedOn = f, !1;
        }
        r.shift();
      }
      return !0;
    }
    function mu(t, r, u) {
      ua(t) && u.delete(r);
    }
    function u3() {
      Os = !1, mn !== null && ua(mn) && (mn = null), C2 !== null && ua(C2) && (C2 = null), X2 !== null && ua(X2) && (X2 = null), Ao.forEach(mu), Io.forEach(mu);
    }
    function At(t, r) {
      t.blockedOn === r && (t.blockedOn = null, Os || (Os = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, u3)));
    }
    function Ln(t) {
      if (Co.length > 0) {
        At(Co[0], t);
        for (var r = 1; r < Co.length; r++) {
          var u = Co[r];
          u.blockedOn === t && (u.blockedOn = null);
        }
      }
      mn !== null && At(mn, t), C2 !== null && At(C2, t), X2 !== null && At(X2, t);
      var f = function(T) {
        return At(T, t);
      };
      Ao.forEach(f), Io.forEach(f);
      for (var C = 0; C < A2.length; C++) {
        var p = A2[C];
        p.blockedOn === t && (p.blockedOn = null);
      }
      for (; A2.length > 0; ) {
        var b = A2[0];
        if (b.blockedOn !== null)
          break;
        j4(b), b.blockedOn === null && A2.shift();
      }
    }
    var fn = i.ReactCurrentBatchConfig, e2 = !0;
    function xr(t) {
      e2 = !!t;
    }
    function ho() {
      return e2;
    }
    function t2(t, r, u) {
      var f = vu(r), C;
      switch (f) {
        case Nn:
          C = Ds;
          break;
        case Ei:
          C = ca;
          break;
        case K3:
        default:
          C = mo;
          break;
      }
      return C.bind(null, r, u, t);
    }
    function Ds(t, r, u, f) {
      var C = l3(), p = fn.transition;
      fn.transition = null;
      try {
        Tn(Nn), mo(t, r, u, f);
      } finally {
        Tn(C), fn.transition = p;
      }
    }
    function ca(t, r, u, f) {
      var C = l3(), p = fn.transition;
      fn.transition = null;
      try {
        Tn(Ei), mo(t, r, u, f);
      } finally {
        Tn(C), fn.transition = p;
      }
    }
    function mo(t, r, u, f) {
      e2 && z4(t, r, u, f);
    }
    function z4(t, r, u, f) {
      var C = _2(t, r, u, f);
      if (C === null) {
        aI(t, r, f, l0, u), k4(t, f);
        return;
      }
      if (Yd(C, t, r, u, f)) {
        f.stopPropagation();
        return;
      }
      if (k4(t, f), r & Y0 && J3(t)) {
        for (; C !== null; ) {
          var p = Eo(C);
          p !== null && O4(p);
          var b = _2(t, r, u, f);
          if (b === null && aI(t, r, f, l0, u), b === C)
            break;
          C = b;
        }
        C !== null && f.stopPropagation();
        return;
      }
      aI(t, r, f, null, u);
    }
    var l0 = null;
    function _2(t, r, u, f) {
      l0 = null;
      var C = Dl(f), p = _s(C);
      if (p !== null) {
        var b = Pr(p);
        if (b === null)
          p = null;
        else {
          var T = b.tag;
          if (T === B) {
            var D = A4(b);
            if (D !== null)
              return D;
            p = null;
          } else if (T === x) {
            var P = b.stateNode;
            if (Au(P))
              return Pl(b);
            p = null;
          } else b !== p && (p = null);
        }
      }
      return l0 = p, null;
    }
    function vu(t) {
      switch (t) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Nn;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Ei;
        case "message": {
          var r = h4();
          switch (r) {
            case Ul:
              return Nn;
            case $0:
              return Ei;
            case V3:
            case Ed:
              return K3;
            case Wl:
              return lo;
            default:
              return K3;
          }
        }
        default:
          return K3;
      }
    }
    function vo(t, r, u) {
      return t.addEventListener(r, u, !1), u;
    }
    function Mi(t, r, u) {
      return t.addEventListener(r, u, !0), u;
    }
    function yu(t, r, u, f) {
      return t.addEventListener(r, u, {
        capture: !0,
        passive: f
      }), u;
    }
    function N4(t, r, u, f) {
      return t.addEventListener(r, u, {
        passive: f
      }), u;
    }
    var c3 = null, yo = null, g3 = null;
    function bu(t) {
      return c3 = t, yo = js(), !0;
    }
    function ks() {
      c3 = null, yo = null, g3 = null;
    }
    function wu() {
      if (g3)
        return g3;
      var t, r = yo, u = r.length, f, C = js(), p = C.length;
      for (t = 0; t < u && r[t] === C[t]; t++)
        ;
      var b = u - t;
      for (f = 1; f <= b && r[u - f] === C[p - f]; f++)
        ;
      var T = f > 1 ? 1 - f : void 0;
      return g3 = C.slice(t, T), g3;
    }
    function js() {
      return "value" in c3 ? c3.value : c3.textContent;
    }
    function ga(t) {
      var r, u = t.keyCode;
      return "charCode" in t ? (r = t.charCode, r === 0 && u === 13 && (r = 13)) : r = u, r === 10 && (r = 13), r >= 32 || r === 13 ? r : 0;
    }
    function I2() {
      return !0;
    }
    function Ti() {
      return !1;
    }
    function wn(t) {
      function r(u, f, C, p, b) {
        this._reactName = u, this._targetInst = C, this.type = f, this.nativeEvent = p, this.target = b, this.currentTarget = null;
        for (var T in t)
          if (t.hasOwnProperty(T)) {
            var D = t[T];
            D ? this[T] = D(p) : this[T] = p[T];
          }
        var P = p.defaultPrevented != null ? p.defaultPrevented : p.returnValue === !1;
        return P ? this.isDefaultPrevented = I2 : this.isDefaultPrevented = Ti, this.isPropagationStopped = Ti, this;
      }
      return it(r.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var u = this.nativeEvent;
          u && (u.preventDefault ? u.preventDefault() : typeof u.returnValue != "unknown" && (u.returnValue = !1), this.isDefaultPrevented = I2);
        },
        stopPropagation: function() {
          var u = this.nativeEvent;
          u && (u.stopPropagation ? u.stopPropagation() : typeof u.cancelBubble != "unknown" && (u.cancelBubble = !0), this.isPropagationStopped = I2);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: I2
      }), r;
    }
    var n2 = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(t) {
        return t.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, xu = wn(n2), fa = it({}, n2, {
      view: 0,
      detail: 0
    }), P4 = wn(fa), F4, Y3, bo;
    function B4(t) {
      t !== bo && (bo && t.type === "mousemove" ? (F4 = t.screenX - bo.screenX, Y3 = t.screenY - bo.screenY) : (F4 = 0, Y3 = 0), bo = t);
    }
    var Q3 = it({}, fa, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: H4,
      button: 0,
      buttons: 0,
      relatedTarget: function(t) {
        return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
      },
      movementX: function(t) {
        return "movementX" in t ? t.movementX : (B4(t), F4);
      },
      movementY: function(t) {
        return "movementY" in t ? t.movementY : Y3;
      }
    }), Su = wn(Q3), da = it({}, Q3, {
      dataTransfer: 0
    }), Qd = wn(da), Xd = it({}, fa, {
      relatedTarget: 0
    }), zs = wn(Xd), Eu = it({}, n2, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), _6 = wn(Eu), V6 = it({}, n2, {
      clipboardData: function(t) {
        return "clipboardData" in t ? t.clipboardData : window.clipboardData;
      }
    }), Gd = wn(V6), qd = it({}, n2, {
      data: 0
    }), u0 = wn(qd), K6 = u0, wo = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Zd = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Rn(t) {
      if (t.key) {
        var r = wo[t.key] || t.key;
        if (r !== "Unidentified")
          return r;
      }
      if (t.type === "keypress") {
        var u = ga(t);
        return u === 13 ? "Enter" : String.fromCharCode(u);
      }
      return t.type === "keydown" || t.type === "keyup" ? Zd[t.keyCode] || "Unidentified" : "";
    }
    var J6 = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function $d(t) {
      var r = this, u = r.nativeEvent;
      if (u.getModifierState)
        return u.getModifierState(t);
      var f = J6[t];
      return f ? !!u[f] : !1;
    }
    function H4(t) {
      return $d;
    }
    var Y6 = it({}, fa, {
      key: Rn,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: H4,
      // Legacy Interface
      charCode: function(t) {
        return t.type === "keypress" ? ga(t) : 0;
      },
      keyCode: function(t) {
        return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      },
      which: function(t) {
        return t.type === "keypress" ? ga(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
      }
    }), e9 = wn(Y6), t9 = it({}, Q3, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), n9 = wn(t9), f3 = it({}, fa, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: H4
    }), U4 = wn(f3), Q6 = it({}, n2, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), c0 = wn(Q6), Mu = it({}, Q3, {
      deltaX: function(t) {
        return "deltaX" in t ? t.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in t ? -t.wheelDeltaX : 0
        );
      },
      deltaY: function(t) {
        return "deltaY" in t ? t.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in t ? -t.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in t ? -t.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Ca = wn(Mu), Tu = [9, 13, 27, 32], Lu = 229, Ns = $1 && "CompositionEvent" in window, Ps = null;
    $1 && "documentMode" in document && (Ps = document.documentMode);
    var W4 = $1 && "TextEvent" in window && !Ps, r9 = $1 && (!Ns || Ps && Ps > 8 && Ps <= 11), _4 = 32, V4 = String.fromCharCode(_4);
    function Ru() {
      X1("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), X1("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), X1("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), X1("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Fs = !1;
    function i9(t) {
      return (t.ctrlKey || t.altKey || t.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(t.ctrlKey && t.altKey);
    }
    function K4(t) {
      switch (t) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function X6(t, r) {
      return t === "keydown" && r.keyCode === Lu;
    }
    function J4(t, r) {
      switch (t) {
        case "keyup":
          return Tu.indexOf(r.keyCode) !== -1;
        case "keydown":
          return r.keyCode !== Lu;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ou(t) {
      var r = t.detail;
      return typeof r == "object" && "data" in r ? r.data : null;
    }
    function Bs(t) {
      return t.locale === "ko";
    }
    var g0 = !1;
    function Du(t, r, u, f, C) {
      var p, b;
      if (Ns ? p = K4(r) : g0 ? J4(r, f) && (p = "onCompositionEnd") : X6(r, f) && (p = "onCompositionStart"), !p)
        return null;
      r9 && !Bs(f) && (!g0 && p === "onCompositionStart" ? g0 = bu(C) : p === "onCompositionEnd" && g0 && (b = wu()));
      var T = c9(u, p);
      if (T.length > 0) {
        var D = new u0(p, r, null, f, C);
        if (t.push({
          event: D,
          listeners: T
        }), b)
          D.data = b;
        else {
          var P = Ou(f);
          P !== null && (D.data = P);
        }
      }
    }
    function a9(t, r) {
      switch (t) {
        case "compositionend":
          return Ou(r);
        case "keypress":
          var u = r.which;
          return u !== _4 ? null : (Fs = !0, V4);
        case "textInput":
          var f = r.data;
          return f === V4 && Fs ? null : f;
        default:
          return null;
      }
    }
    function G6(t, r) {
      if (g0) {
        if (t === "compositionend" || !Ns && J4(t, r)) {
          var u = wu();
          return ks(), g0 = !1, u;
        }
        return null;
      }
      switch (t) {
        case "paste":
          return null;
        case "keypress":
          if (!i9(r)) {
            if (r.char && r.char.length > 1)
              return r.char;
            if (r.which)
              return String.fromCharCode(r.which);
          }
          return null;
        case "compositionend":
          return r9 && !Bs(r) ? null : r.data;
        default:
          return null;
      }
    }
    function ku(t, r, u, f, C) {
      var p;
      if (W4 ? p = a9(r, f) : p = G6(r, f), !p)
        return null;
      var b = c9(u, "onBeforeInput");
      if (b.length > 0) {
        var T = new K6("onBeforeInput", "beforeinput", null, f, C);
        t.push({
          event: T,
          listeners: b
        }), T.data = p;
      }
    }
    function q6(t, r, u, f, C, p, b) {
      Du(t, r, u, f, C), ku(t, r, u, f, C);
    }
    var Hs = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function o9(t) {
      var r = t && t.nodeName && t.nodeName.toLowerCase();
      return r === "input" ? !!Hs[t.type] : r === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function ju(t) {
      if (!$1)
        return !1;
      var r = "on" + t, u = r in document;
      if (!u) {
        var f = document.createElement("div");
        f.setAttribute(r, "return;"), u = typeof f[r] == "function";
      }
      return u;
    }
    function o() {
      X1("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function l(t, r, u, f) {
      kl(f);
      var C = c9(r, "onChange");
      if (C.length > 0) {
        var p = new xu("onChange", "change", null, u, f);
        t.push({
          event: p,
          listeners: C
        });
      }
    }
    var d = null, A = null;
    function y(t) {
      var r = t.nodeName && t.nodeName.toLowerCase();
      return r === "select" || r === "input" && t.type === "file";
    }
    function S(t) {
      var r = [];
      l(r, A, t, Dl(t)), s4(j, r);
    }
    function j(t) {
      n8(t, 0);
    }
    function K(t) {
      var r = Hu(t);
      if (U1(r))
        return t;
    }
    function q(t, r) {
      if (t === "change")
        return r;
    }
    var p1 = !1;
    $1 && (p1 = ju("input") && (!document.documentMode || document.documentMode > 9));
    function W1(t, r) {
      d = t, A = r, d.attachEvent("onpropertychange", N1);
    }
    function Q1() {
      d && (d.detachEvent("onpropertychange", N1), d = null, A = null);
    }
    function N1(t) {
      t.propertyName === "value" && K(A) && S(t);
    }
    function pe(t, r, u) {
      t === "focusin" ? (Q1(), W1(r, u)) : t === "focusout" && Q1();
    }
    function Se(t, r) {
      if (t === "selectionchange" || t === "keyup" || t === "keydown")
        return K(A);
    }
    function Te(t) {
      var r = t.nodeName;
      return r && r.toLowerCase() === "input" && (t.type === "checkbox" || t.type === "radio");
    }
    function Pn(t, r) {
      if (t === "click")
        return K(r);
    }
    function s1(t, r) {
      if (t === "input" || t === "change")
        return K(r);
    }
    function r1(t) {
      var r = t._wrapperState;
      !r || !r.controlled || t.type !== "number" || Zr(t, "number", t.value);
    }
    function g1(t, r, u, f, C, p, b) {
      var T = u ? Hu(u) : window, D, P;
      if (y(T) ? D = q : o9(T) ? p1 ? D = s1 : (D = Se, P = pe) : Te(T) && (D = Pn), D) {
        var F = D(r, u);
        if (F) {
          l(t, F, f, C);
          return;
        }
      }
      P && P(r, T, u), r === "focusout" && r1(T);
    }
    function ne() {
      D1("onMouseEnter", ["mouseout", "mouseover"]), D1("onMouseLeave", ["mouseout", "mouseover"]), D1("onPointerEnter", ["pointerout", "pointerover"]), D1("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Oe(t, r, u, f, C, p, b) {
      var T = r === "mouseover" || r === "pointerover", D = r === "mouseout" || r === "pointerout";
      if (T && !md(f)) {
        var P = f.relatedTarget || f.fromElement;
        if (P && (_s(P) || og(P)))
          return;
      }
      if (!(!D && !T)) {
        var F;
        if (C.window === C)
          F = C;
        else {
          var i1 = C.ownerDocument;
          i1 ? F = i1.defaultView || i1.parentWindow : F = window;
        }
        var n1, A1;
        if (D) {
          var m1 = f.relatedTarget || f.toElement;
          if (n1 = u, A1 = m1 ? _s(m1) : null, A1 !== null) {
            var M1 = Pr(A1);
            (A1 !== M1 || A1.tag !== O && A1.tag !== k) && (A1 = null);
          }
        } else
          n1 = null, A1 = u;
        if (n1 !== A1) {
          var Ce = Su, We = "onMouseLeave", ze = "onMouseEnter", mt = "mouse";
          (r === "pointerout" || r === "pointerover") && (Ce = n9, We = "onPointerLeave", ze = "onPointerEnter", mt = "pointer");
          var It = n1 == null ? F : Hu(n1), l1 = A1 == null ? F : Hu(A1), T1 = new Ce(We, mt + "leave", n1, f, C);
          T1.target = It, T1.relatedTarget = l1;
          var u1 = null, G1 = _s(C);
          if (G1 === u) {
            var ve = new Ce(ze, mt + "enter", A1, f, C);
            ve.target = l1, ve.relatedTarget = It, u1 = ve;
          }
          fL(t, T1, u1, n1, A1);
        }
      }
    }
    function Ke(t, r) {
      return t === r && (t !== 0 || 1 / t === 1 / r) || t !== t && r !== r;
    }
    var Ee = typeof Object.is == "function" ? Object.is : Ke;
    function Je(t, r) {
      if (Ee(t, r))
        return !0;
      if (typeof t != "object" || t === null || typeof r != "object" || r === null)
        return !1;
      var u = Object.keys(t), f = Object.keys(r);
      if (u.length !== f.length)
        return !1;
      for (var C = 0; C < u.length; C++) {
        var p = u[C];
        if (!y1.call(r, p) || !Ee(t[p], r[p]))
          return !1;
      }
      return !0;
    }
    function r2(t) {
      for (; t && t.firstChild; )
        t = t.firstChild;
      return t;
    }
    function Tt(t) {
      for (; t; ) {
        if (t.nextSibling)
          return t.nextSibling;
        t = t.parentNode;
      }
    }
    function Li(t, r) {
      for (var u = r2(t), f = 0, C = 0; u; ) {
        if (u.nodeType === pi) {
          if (C = f + u.textContent.length, f <= r && C >= r)
            return {
              node: u,
              offset: r - f
            };
          f = C;
        }
        u = r2(Tt(u));
      }
    }
    function Z6(t) {
      var r = t.ownerDocument, u = r && r.defaultView || window, f = u.getSelection && u.getSelection();
      if (!f || f.rangeCount === 0)
        return null;
      var C = f.anchorNode, p = f.anchorOffset, b = f.focusNode, T = f.focusOffset;
      try {
        C.nodeType, b.nodeType;
      } catch {
        return null;
      }
      return JT(t, C, p, b, T);
    }
    function JT(t, r, u, f, C) {
      var p = 0, b = -1, T = -1, D = 0, P = 0, F = t, i1 = null;
      e: for (; ; ) {
        for (var n1 = null; F === r && (u === 0 || F.nodeType === pi) && (b = p + u), F === f && (C === 0 || F.nodeType === pi) && (T = p + C), F.nodeType === pi && (p += F.nodeValue.length), (n1 = F.firstChild) !== null; )
          i1 = F, F = n1;
        for (; ; ) {
          if (F === t)
            break e;
          if (i1 === r && ++D === u && (b = p), i1 === f && ++P === C && (T = p), (n1 = F.nextSibling) !== null)
            break;
          F = i1, i1 = F.parentNode;
        }
        F = n1;
      }
      return b === -1 || T === -1 ? null : {
        start: b,
        end: T
      };
    }
    function YT(t, r) {
      var u = t.ownerDocument || document, f = u && u.defaultView || window;
      if (f.getSelection) {
        var C = f.getSelection(), p = t.textContent.length, b = Math.min(r.start, p), T = r.end === void 0 ? b : Math.min(r.end, p);
        if (!C.extend && b > T) {
          var D = T;
          T = b, b = D;
        }
        var P = Li(t, b), F = Li(t, T);
        if (P && F) {
          if (C.rangeCount === 1 && C.anchorNode === P.node && C.anchorOffset === P.offset && C.focusNode === F.node && C.focusOffset === F.offset)
            return;
          var i1 = u.createRange();
          i1.setStart(P.node, P.offset), C.removeAllRanges(), b > T ? (C.addRange(i1), C.extend(F.node, F.offset)) : (i1.setEnd(F.node, F.offset), C.addRange(i1));
        }
      }
    }
    function Vm(t) {
      return t && t.nodeType === pi;
    }
    function Km(t, r) {
      return !t || !r ? !1 : t === r ? !0 : Vm(t) ? !1 : Vm(r) ? Km(t, r.parentNode) : "contains" in t ? t.contains(r) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(r) & 16) : !1;
    }
    function QT(t) {
      return t && t.ownerDocument && Km(t.ownerDocument.documentElement, t);
    }
    function XT(t) {
      try {
        return typeof t.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function Jm() {
      for (var t = window, r = O1(); r instanceof t.HTMLIFrameElement; ) {
        if (XT(r))
          t = r.contentWindow;
        else
          return r;
        r = O1(t.document);
      }
      return r;
    }
    function $6(t) {
      var r = t && t.nodeName && t.nodeName.toLowerCase();
      return r && (r === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || r === "textarea" || t.contentEditable === "true");
    }
    function GT() {
      var t = Jm();
      return {
        focusedElem: t,
        selectionRange: $6(t) ? ZT(t) : null
      };
    }
    function qT(t) {
      var r = Jm(), u = t.focusedElem, f = t.selectionRange;
      if (r !== u && QT(u)) {
        f !== null && $6(u) && $T(u, f);
        for (var C = [], p = u; p = p.parentNode; )
          p.nodeType === Cr && C.push({
            element: p,
            left: p.scrollLeft,
            top: p.scrollTop
          });
        typeof u.focus == "function" && u.focus();
        for (var b = 0; b < C.length; b++) {
          var T = C[b];
          T.element.scrollLeft = T.left, T.element.scrollTop = T.top;
        }
      }
    }
    function ZT(t) {
      var r;
      return "selectionStart" in t ? r = {
        start: t.selectionStart,
        end: t.selectionEnd
      } : r = Z6(t), r || {
        start: 0,
        end: 0
      };
    }
    function $T(t, r) {
      var u = r.start, f = r.end;
      f === void 0 && (f = u), "selectionStart" in t ? (t.selectionStart = u, t.selectionEnd = Math.min(f, t.value.length)) : YT(t, r);
    }
    var eL = $1 && "documentMode" in document && document.documentMode <= 11;
    function tL() {
      X1("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var zu = null, eI = null, Y4 = null, tI = !1;
    function nL(t) {
      if ("selectionStart" in t && $6(t))
        return {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      var r = t.ownerDocument && t.ownerDocument.defaultView || window, u = r.getSelection();
      return {
        anchorNode: u.anchorNode,
        anchorOffset: u.anchorOffset,
        focusNode: u.focusNode,
        focusOffset: u.focusOffset
      };
    }
    function rL(t) {
      return t.window === t ? t.document : t.nodeType === w3 ? t : t.ownerDocument;
    }
    function Ym(t, r, u) {
      var f = rL(u);
      if (!(tI || zu == null || zu !== O1(f))) {
        var C = nL(zu);
        if (!Y4 || !Je(Y4, C)) {
          Y4 = C;
          var p = c9(eI, "onSelect");
          if (p.length > 0) {
            var b = new xu("onSelect", "select", null, r, u);
            t.push({
              event: b,
              listeners: p
            }), b.target = zu;
          }
        }
      }
    }
    function iL(t, r, u, f, C, p, b) {
      var T = u ? Hu(u) : window;
      switch (r) {
        case "focusin":
          (o9(T) || T.contentEditable === "true") && (zu = T, eI = u, Y4 = null);
          break;
        case "focusout":
          zu = null, eI = null, Y4 = null;
          break;
        case "mousedown":
          tI = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          tI = !1, Ym(t, f, C);
          break;
        case "selectionchange":
          if (eL)
            break;
        case "keydown":
        case "keyup":
          Ym(t, f, C);
      }
    }
    function s9(t, r) {
      var u = {};
      return u[t.toLowerCase()] = r.toLowerCase(), u["Webkit" + t] = "webkit" + r, u["Moz" + t] = "moz" + r, u;
    }
    var Nu = {
      animationend: s9("Animation", "AnimationEnd"),
      animationiteration: s9("Animation", "AnimationIteration"),
      animationstart: s9("Animation", "AnimationStart"),
      transitionend: s9("Transition", "TransitionEnd")
    }, nI = {}, Qm = {};
    $1 && (Qm = document.createElement("div").style, "AnimationEvent" in window || (delete Nu.animationend.animation, delete Nu.animationiteration.animation, delete Nu.animationstart.animation), "TransitionEvent" in window || delete Nu.transitionend.transition);
    function l9(t) {
      if (nI[t])
        return nI[t];
      if (!Nu[t])
        return t;
      var r = Nu[t];
      for (var u in r)
        if (r.hasOwnProperty(u) && u in Qm)
          return nI[t] = r[u];
      return t;
    }
    var Xm = l9("animationend"), Gm = l9("animationiteration"), qm = l9("animationstart"), Zm = l9("transitionend"), $m = /* @__PURE__ */ new Map(), e8 = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function xo(t, r) {
      $m.set(t, r), X1(r, [t]);
    }
    function aL() {
      for (var t = 0; t < e8.length; t++) {
        var r = e8[t], u = r.toLowerCase(), f = r[0].toUpperCase() + r.slice(1);
        xo(u, "on" + f);
      }
      xo(Xm, "onAnimationEnd"), xo(Gm, "onAnimationIteration"), xo(qm, "onAnimationStart"), xo("dblclick", "onDoubleClick"), xo("focusin", "onFocus"), xo("focusout", "onBlur"), xo(Zm, "onTransitionEnd");
    }
    function oL(t, r, u, f, C, p, b) {
      var T = $m.get(r);
      if (T !== void 0) {
        var D = xu, P = r;
        switch (r) {
          case "keypress":
            if (ga(f) === 0)
              return;
          case "keydown":
          case "keyup":
            D = e9;
            break;
          case "focusin":
            P = "focus", D = zs;
            break;
          case "focusout":
            P = "blur", D = zs;
            break;
          case "beforeblur":
          case "afterblur":
            D = zs;
            break;
          case "click":
            if (f.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            D = Su;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            D = Qd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            D = U4;
            break;
          case Xm:
          case Gm:
          case qm:
            D = _6;
            break;
          case Zm:
            D = c0;
            break;
          case "scroll":
            D = P4;
            break;
          case "wheel":
            D = Ca;
            break;
          case "copy":
          case "cut":
          case "paste":
            D = Gd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            D = n9;
            break;
        }
        var F = (p & Y0) !== 0;
        {
          var i1 = !F && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          r === "scroll", n1 = cL(u, T, f.type, F, i1);
          if (n1.length > 0) {
            var A1 = new D(T, P, null, f, C);
            t.push({
              event: A1,
              listeners: n1
            });
          }
        }
      }
    }
    aL(), ne(), o(), tL(), Ru();
    function sL(t, r, u, f, C, p, b) {
      oL(t, r, u, f, C, p);
      var T = (p & R6) === 0;
      T && (Oe(t, r, u, f, C), g1(t, r, u, f, C), iL(t, r, u, f, C), q6(t, r, u, f, C));
    }
    var Q4 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], rI = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Q4));
    function t8(t, r, u) {
      var f = t.type || "unknown-event";
      t.currentTarget = u, yi(f, r, void 0, t), t.currentTarget = null;
    }
    function lL(t, r, u) {
      var f;
      if (u)
        for (var C = r.length - 1; C >= 0; C--) {
          var p = r[C], b = p.instance, T = p.currentTarget, D = p.listener;
          if (b !== f && t.isPropagationStopped())
            return;
          t8(t, D, T), f = b;
        }
      else
        for (var P = 0; P < r.length; P++) {
          var F = r[P], i1 = F.instance, n1 = F.currentTarget, A1 = F.listener;
          if (i1 !== f && t.isPropagationStopped())
            return;
          t8(t, A1, n1), f = i1;
        }
    }
    function n8(t, r) {
      for (var u = (r & Y0) !== 0, f = 0; f < t.length; f++) {
        var C = t[f], p = C.event, b = C.listeners;
        lL(p, b, u);
      }
      g4();
    }
    function uL(t, r, u, f, C) {
      var p = Dl(u), b = [];
      sL(b, t, f, u, p, r), n8(b, r);
    }
    function xn(t, r) {
      rI.has(t) || c('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', t);
      var u = !1, f = BR(r), C = dL(t);
      f.has(C) || (r8(r, t, us, u), f.add(C));
    }
    function iI(t, r, u) {
      rI.has(t) && !r && c('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', t);
      var f = 0;
      r && (f |= Y0), r8(u, t, f, r);
    }
    var u9 = "_reactListening" + Math.random().toString(36).slice(2);
    function X4(t) {
      if (!t[u9]) {
        t[u9] = !0, R1.forEach(function(u) {
          u !== "selectionchange" && (rI.has(u) || iI(u, !1, t), iI(u, !0, t));
        });
        var r = t.nodeType === w3 ? t : t.ownerDocument;
        r !== null && (r[u9] || (r[u9] = !0, iI("selectionchange", !1, r)));
      }
    }
    function r8(t, r, u, f, C) {
      var p = t2(t, r, u), b = void 0;
      Cs && (r === "touchstart" || r === "touchmove" || r === "wheel") && (b = !0), t = t, f ? b !== void 0 ? yu(t, r, p, b) : Mi(t, r, p) : b !== void 0 ? N4(t, r, p, b) : vo(t, r, p);
    }
    function i8(t, r) {
      return t === r || t.nodeType === Wn && t.parentNode === r;
    }
    function aI(t, r, u, f, C) {
      var p = f;
      if (!(r & mi) && !(r & us)) {
        var b = C;
        if (f !== null) {
          var T = f;
          e: for (; ; ) {
            if (T === null)
              return;
            var D = T.tag;
            if (D === x || D === M) {
              var P = T.stateNode.containerInfo;
              if (i8(P, b))
                break;
              if (D === M)
                for (var F = T.return; F !== null; ) {
                  var i1 = F.tag;
                  if (i1 === x || i1 === M) {
                    var n1 = F.stateNode.containerInfo;
                    if (i8(n1, b))
                      return;
                  }
                  F = F.return;
                }
              for (; P !== null; ) {
                var A1 = _s(P);
                if (A1 === null)
                  return;
                var m1 = A1.tag;
                if (m1 === O || m1 === k) {
                  T = p = A1;
                  continue e;
                }
                P = P.parentNode;
              }
            }
            T = T.return;
          }
        }
      }
      s4(function() {
        return uL(t, r, u, p);
      });
    }
    function G4(t, r, u) {
      return {
        instance: t,
        listener: r,
        currentTarget: u
      };
    }
    function cL(t, r, u, f, C, p) {
      for (var b = r !== null ? r + "Capture" : null, T = f ? b : r, D = [], P = t, F = null; P !== null; ) {
        var i1 = P, n1 = i1.stateNode, A1 = i1.tag;
        if (A1 === O && n1 !== null && (F = n1, T !== null)) {
          var m1 = X0(P, T);
          m1 != null && D.push(G4(P, m1, F));
        }
        if (C)
          break;
        P = P.return;
      }
      return D;
    }
    function c9(t, r) {
      for (var u = r + "Capture", f = [], C = t; C !== null; ) {
        var p = C, b = p.stateNode, T = p.tag;
        if (T === O && b !== null) {
          var D = b, P = X0(C, u);
          P != null && f.unshift(G4(C, P, D));
          var F = X0(C, r);
          F != null && f.push(G4(C, F, D));
        }
        C = C.return;
      }
      return f;
    }
    function Pu(t) {
      if (t === null)
        return null;
      do
        t = t.return;
      while (t && t.tag !== O);
      return t || null;
    }
    function gL(t, r) {
      for (var u = t, f = r, C = 0, p = u; p; p = Pu(p))
        C++;
      for (var b = 0, T = f; T; T = Pu(T))
        b++;
      for (; C - b > 0; )
        u = Pu(u), C--;
      for (; b - C > 0; )
        f = Pu(f), b--;
      for (var D = C; D--; ) {
        if (u === f || f !== null && u === f.alternate)
          return u;
        u = Pu(u), f = Pu(f);
      }
      return null;
    }
    function a8(t, r, u, f, C) {
      for (var p = r._reactName, b = [], T = u; T !== null && T !== f; ) {
        var D = T, P = D.alternate, F = D.stateNode, i1 = D.tag;
        if (P !== null && P === f)
          break;
        if (i1 === O && F !== null) {
          var n1 = F;
          if (C) {
            var A1 = X0(T, p);
            A1 != null && b.unshift(G4(T, A1, n1));
          } else if (!C) {
            var m1 = X0(T, p);
            m1 != null && b.push(G4(T, m1, n1));
          }
        }
        T = T.return;
      }
      b.length !== 0 && t.push({
        event: r,
        listeners: b
      });
    }
    function fL(t, r, u, f, C) {
      var p = f && C ? gL(f, C) : null;
      f !== null && a8(t, r, f, p, !1), C !== null && u !== null && a8(t, u, C, p, !0);
    }
    function dL(t, r) {
      return t + "__bubble";
    }
    var d3 = !1, q4 = "dangerouslySetInnerHTML", g9 = "suppressContentEditableWarning", So = "suppressHydrationWarning", o8 = "autoFocus", Us = "children", Ws = "style", f9 = "__html", oI, d9, Z4, s8, C9, l8, u8;
    oI = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, d9 = function(t, r) {
      Ol(t, r), n4(t, r), hd(t, r, {
        registrationNameDependencies: x1,
        possibleRegistrationNames: J1
      });
    }, l8 = $1 && !document.documentMode, Z4 = function(t, r, u) {
      if (!d3) {
        var f = A9(u), C = A9(r);
        C !== f && (d3 = !0, c("Prop `%s` did not match. Server: %s Client: %s", t, JSON.stringify(C), JSON.stringify(f)));
      }
    }, s8 = function(t) {
      if (!d3) {
        d3 = !0;
        var r = [];
        t.forEach(function(u) {
          r.push(u);
        }), c("Extra attributes from the server: %s", r);
      }
    }, C9 = function(t, r) {
      r === !1 ? c("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", t, t, t) : c("Expected `%s` listener to be a function, instead got a value of `%s` type.", t, typeof r);
    }, u8 = function(t, r) {
      var u = t.namespaceURI === Ii ? t.ownerDocument.createElement(t.tagName) : t.ownerDocument.createElementNS(t.namespaceURI, t.tagName);
      return u.innerHTML = r, u.innerHTML;
    };
    var CL = /\r\n?/g, AL = /\u0000|\uFFFD/g;
    function A9(t) {
      Ae(t);
      var r = typeof t == "string" ? t : "" + t;
      return r.replace(CL, `
`).replace(AL, "");
    }
    function I9(t, r, u, f) {
      var C = A9(r), p = A9(t);
      if (p !== C && (f && (d3 || (d3 = !0, c('Text content did not match. Server: "%s" Client: "%s"', p, C))), u && L1))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function c8(t) {
      return t.nodeType === w3 ? t : t.ownerDocument;
    }
    function IL() {
    }
    function p9(t) {
      t.onclick = IL;
    }
    function pL(t, r, u, f, C) {
      for (var p in f)
        if (f.hasOwnProperty(p)) {
          var b = f[p];
          if (p === Ws)
            b && Object.freeze(b), ld(r, b);
          else if (p === q4) {
            var T = b ? b[f9] : void 0;
            T != null && qf(r, T);
          } else if (p === Us)
            if (typeof b == "string") {
              var D = t !== "textarea" || b !== "";
              D && Ml(r, b);
            } else typeof b == "number" && Ml(r, "" + b);
          else p === g9 || p === So || p === o8 || (x1.hasOwnProperty(p) ? b != null && (typeof b != "function" && C9(p, b), p === "onScroll" && xn("scroll", r)) : b != null && ln(r, p, b, C));
        }
    }
    function hL(t, r, u, f) {
      for (var C = 0; C < r.length; C += 2) {
        var p = r[C], b = r[C + 1];
        p === Ws ? ld(t, b) : p === q4 ? qf(t, b) : p === Us ? Ml(t, b) : ln(t, p, b, f);
      }
    }
    function mL(t, r, u, f) {
      var C, p = c8(u), b, T = f;
      if (T === Ii && (T = Sl(t)), T === Ii) {
        if (C = hi(t, r), !C && t !== t.toLowerCase() && c("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", t), t === "script") {
          var D = p.createElement("div");
          D.innerHTML = "<script><\/script>";
          var P = D.firstChild;
          b = D.removeChild(P);
        } else if (typeof r.is == "string")
          b = p.createElement(t, {
            is: r.is
          });
        else if (b = p.createElement(t), t === "select") {
          var F = b;
          r.multiple ? F.multiple = !0 : r.size && (F.size = r.size);
        }
      } else
        b = p.createElementNS(T, t);
      return T === Ii && !C && Object.prototype.toString.call(b) === "[object HTMLUnknownElement]" && !y1.call(oI, t) && (oI[t] = !0, c("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", t)), b;
    }
    function vL(t, r) {
      return c8(r).createTextNode(t);
    }
    function yL(t, r, u, f) {
      var C = hi(r, u);
      d9(r, u);
      var p;
      switch (r) {
        case "dialog":
          xn("cancel", t), xn("close", t), p = u;
          break;
        case "iframe":
        case "object":
        case "embed":
          xn("load", t), p = u;
          break;
        case "video":
        case "audio":
          for (var b = 0; b < Q4.length; b++)
            xn(Q4[b], t);
          p = u;
          break;
        case "source":
          xn("error", t), p = u;
          break;
        case "img":
        case "image":
        case "link":
          xn("error", t), xn("load", t), p = u;
          break;
        case "details":
          xn("toggle", t), p = u;
          break;
        case "input":
          an(t, u), p = qn(t, u), xn("invalid", t);
          break;
        case "option":
          wl(t, u), p = u;
          break;
        case "select":
          Yf(t, u), p = Kc(t, u), xn("invalid", t);
          break;
        case "textarea":
          Qf(t, u), p = Yc(t, u), xn("invalid", t);
          break;
        default:
          p = u;
      }
      switch (Ll(r, p), pL(r, t, f, p, C), r) {
        case "input":
          I1(t), b3(t, u, !1);
          break;
        case "textarea":
          I1(t), Gf(t);
          break;
        case "option":
          Vc(t, u);
          break;
        case "select":
          m6(t, u);
          break;
        default:
          typeof p.onClick == "function" && p9(t);
          break;
      }
    }
    function bL(t, r, u, f, C) {
      d9(r, f);
      var p = null, b, T;
      switch (r) {
        case "input":
          b = qn(t, u), T = qn(t, f), p = [];
          break;
        case "select":
          b = Kc(t, u), T = Kc(t, f), p = [];
          break;
        case "textarea":
          b = Yc(t, u), T = Yc(t, f), p = [];
          break;
        default:
          b = u, T = f, typeof b.onClick != "function" && typeof T.onClick == "function" && p9(t);
          break;
      }
      Ll(r, T);
      var D, P, F = null;
      for (D in b)
        if (!(T.hasOwnProperty(D) || !b.hasOwnProperty(D) || b[D] == null))
          if (D === Ws) {
            var i1 = b[D];
            for (P in i1)
              i1.hasOwnProperty(P) && (F || (F = {}), F[P] = "");
          } else D === q4 || D === Us || D === g9 || D === So || D === o8 || (x1.hasOwnProperty(D) ? p || (p = []) : (p = p || []).push(D, null));
      for (D in T) {
        var n1 = T[D], A1 = b != null ? b[D] : void 0;
        if (!(!T.hasOwnProperty(D) || n1 === A1 || n1 == null && A1 == null))
          if (D === Ws)
            if (n1 && Object.freeze(n1), A1) {
              for (P in A1)
                A1.hasOwnProperty(P) && (!n1 || !n1.hasOwnProperty(P)) && (F || (F = {}), F[P] = "");
              for (P in n1)
                n1.hasOwnProperty(P) && A1[P] !== n1[P] && (F || (F = {}), F[P] = n1[P]);
            } else
              F || (p || (p = []), p.push(D, F)), F = n1;
          else if (D === q4) {
            var m1 = n1 ? n1[f9] : void 0, M1 = A1 ? A1[f9] : void 0;
            m1 != null && M1 !== m1 && (p = p || []).push(D, m1);
          } else D === Us ? (typeof n1 == "string" || typeof n1 == "number") && (p = p || []).push(D, "" + n1) : D === g9 || D === So || (x1.hasOwnProperty(D) ? (n1 != null && (typeof n1 != "function" && C9(D, n1), D === "onScroll" && xn("scroll", t)), !p && A1 !== n1 && (p = [])) : (p = p || []).push(D, n1));
      }
      return F && (ss(F, T[Ws]), (p = p || []).push(Ws, F)), p;
    }
    function wL(t, r, u, f, C) {
      u === "input" && C.type === "radio" && C.name != null && In(t, C);
      var p = hi(u, f), b = hi(u, C);
      switch (hL(t, r, p, b), u) {
        case "input":
          c2(t, C);
          break;
        case "textarea":
          Xf(t, C);
          break;
        case "select":
          v6(t, C);
          break;
      }
    }
    function xL(t) {
      {
        var r = t.toLowerCase();
        return Rl.hasOwnProperty(r) && Rl[r] || null;
      }
    }
    function SL(t, r, u, f, C, p, b) {
      var T, D;
      switch (T = hi(r, u), d9(r, u), r) {
        case "dialog":
          xn("cancel", t), xn("close", t);
          break;
        case "iframe":
        case "object":
        case "embed":
          xn("load", t);
          break;
        case "video":
        case "audio":
          for (var P = 0; P < Q4.length; P++)
            xn(Q4[P], t);
          break;
        case "source":
          xn("error", t);
          break;
        case "img":
        case "image":
        case "link":
          xn("error", t), xn("load", t);
          break;
        case "details":
          xn("toggle", t);
          break;
        case "input":
          an(t, u), xn("invalid", t);
          break;
        case "option":
          wl(t, u);
          break;
        case "select":
          Yf(t, u), xn("invalid", t);
          break;
        case "textarea":
          Qf(t, u), xn("invalid", t);
          break;
      }
      Ll(r, u);
      {
        D = /* @__PURE__ */ new Set();
        for (var F = t.attributes, i1 = 0; i1 < F.length; i1++) {
          var n1 = F[i1].name.toLowerCase();
          switch (n1) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              D.add(F[i1].name);
          }
        }
      }
      var A1 = null;
      for (var m1 in u)
        if (u.hasOwnProperty(m1)) {
          var M1 = u[m1];
          if (m1 === Us)
            typeof M1 == "string" ? t.textContent !== M1 && (u[So] !== !0 && I9(t.textContent, M1, p, b), A1 = [Us, M1]) : typeof M1 == "number" && t.textContent !== "" + M1 && (u[So] !== !0 && I9(t.textContent, M1, p, b), A1 = [Us, "" + M1]);
          else if (x1.hasOwnProperty(m1))
            M1 != null && (typeof M1 != "function" && C9(m1, M1), m1 === "onScroll" && xn("scroll", t));
          else if (b && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof T == "boolean") {
            var Ce = void 0, We = T && E1 ? null : b2(m1);
            if (u[So] !== !0) {
              if (!(m1 === g9 || m1 === So || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              m1 === "value" || m1 === "checked" || m1 === "selected")) {
                if (m1 === q4) {
                  var ze = t.innerHTML, mt = M1 ? M1[f9] : void 0;
                  if (mt != null) {
                    var It = u8(t, mt);
                    It !== ze && Z4(m1, ze, It);
                  }
                } else if (m1 === Ws) {
                  if (D.delete(m1), l8) {
                    var l1 = T6(M1);
                    Ce = t.getAttribute("style"), l1 !== Ce && Z4(m1, Ce, l1);
                  }
                } else if (T && !E1)
                  D.delete(m1.toLowerCase()), Ce = Ki(t, m1, M1), M1 !== Ce && Z4(m1, Ce, M1);
                else if (!sn(m1, We, T) && !Ht(m1, M1, We, T)) {
                  var T1 = !1;
                  if (We !== null)
                    D.delete(We.attributeName), Ce = gi(t, m1, M1, We);
                  else {
                    var u1 = f;
                    if (u1 === Ii && (u1 = Sl(r)), u1 === Ii)
                      D.delete(m1.toLowerCase());
                    else {
                      var G1 = xL(m1);
                      G1 !== null && G1 !== m1 && (T1 = !0, D.delete(G1)), D.delete(m1);
                    }
                    Ce = Ki(t, m1, M1);
                  }
                  var ve = E1;
                  !ve && M1 !== Ce && !T1 && Z4(m1, Ce, M1);
                }
              }
            }
          }
        }
      switch (b && // $FlowFixMe - Should be inferred as not undefined.
      D.size > 0 && u[So] !== !0 && s8(D), r) {
        case "input":
          I1(t), b3(t, u, !0);
          break;
        case "textarea":
          I1(t), Gf(t);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof u.onClick == "function" && p9(t);
          break;
      }
      return A1;
    }
    function EL(t, r, u) {
      var f = t.nodeValue !== r;
      return f;
    }
    function sI(t, r) {
      {
        if (d3)
          return;
        d3 = !0, c("Did not expect server HTML to contain a <%s> in <%s>.", r.nodeName.toLowerCase(), t.nodeName.toLowerCase());
      }
    }
    function lI(t, r) {
      {
        if (d3)
          return;
        d3 = !0, c('Did not expect server HTML to contain the text node "%s" in <%s>.', r.nodeValue, t.nodeName.toLowerCase());
      }
    }
    function uI(t, r, u) {
      {
        if (d3)
          return;
        d3 = !0, c("Expected server HTML to contain a matching <%s> in <%s>.", r, t.nodeName.toLowerCase());
      }
    }
    function cI(t, r) {
      {
        if (r === "" || d3)
          return;
        d3 = !0, c('Expected server HTML to contain a matching text node for "%s" in <%s>.', r, t.nodeName.toLowerCase());
      }
    }
    function ML(t, r, u) {
      switch (r) {
        case "input":
          F2(t, u);
          return;
        case "textarea":
          Qc(t, u);
          return;
        case "select":
          y6(t, u);
          return;
      }
    }
    var $4 = function() {
    }, eg = function() {
    };
    {
      var TL = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], g8 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], LL = g8.concat(["button"]), RL = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], f8 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      eg = function(t, r) {
        var u = it({}, t || f8), f = {
          tag: r
        };
        return g8.indexOf(r) !== -1 && (u.aTagInScope = null, u.buttonTagInScope = null, u.nobrTagInScope = null), LL.indexOf(r) !== -1 && (u.pTagInButtonScope = null), TL.indexOf(r) !== -1 && r !== "address" && r !== "div" && r !== "p" && (u.listItemTagAutoclosing = null, u.dlItemTagAutoclosing = null), u.current = f, r === "form" && (u.formTag = f), r === "a" && (u.aTagInScope = f), r === "button" && (u.buttonTagInScope = f), r === "nobr" && (u.nobrTagInScope = f), r === "p" && (u.pTagInButtonScope = f), r === "li" && (u.listItemTagAutoclosing = f), (r === "dd" || r === "dt") && (u.dlItemTagAutoclosing = f), u;
      };
      var OL = function(t, r) {
        switch (r) {
          case "select":
            return t === "option" || t === "optgroup" || t === "#text";
          case "optgroup":
            return t === "option" || t === "#text";
          case "option":
            return t === "#text";
          case "tr":
            return t === "th" || t === "td" || t === "style" || t === "script" || t === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return t === "tr" || t === "style" || t === "script" || t === "template";
          case "colgroup":
            return t === "col" || t === "template";
          case "table":
            return t === "caption" || t === "colgroup" || t === "tbody" || t === "tfoot" || t === "thead" || t === "style" || t === "script" || t === "template";
          case "head":
            return t === "base" || t === "basefont" || t === "bgsound" || t === "link" || t === "meta" || t === "title" || t === "noscript" || t === "noframes" || t === "style" || t === "script" || t === "template";
          case "html":
            return t === "head" || t === "body" || t === "frameset";
          case "frameset":
            return t === "frame";
          case "#document":
            return t === "html";
        }
        switch (t) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r !== "h1" && r !== "h2" && r !== "h3" && r !== "h4" && r !== "h5" && r !== "h6";
          case "rp":
          case "rt":
            return RL.indexOf(r) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return r == null;
        }
        return !0;
      }, DL = function(t, r) {
        switch (t) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return r.pTagInButtonScope;
          case "form":
            return r.formTag || r.pTagInButtonScope;
          case "li":
            return r.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return r.dlItemTagAutoclosing;
          case "button":
            return r.buttonTagInScope;
          case "a":
            return r.aTagInScope;
          case "nobr":
            return r.nobrTagInScope;
        }
        return null;
      }, d8 = {};
      $4 = function(t, r, u) {
        u = u || f8;
        var f = u.current, C = f && f.tag;
        r != null && (t != null && c("validateDOMNesting: when childText is passed, childTag should be null"), t = "#text");
        var p = OL(t, C) ? null : f, b = p ? null : DL(t, u), T = p || b;
        if (T) {
          var D = T.tag, P = !!p + "|" + t + "|" + D;
          if (!d8[P]) {
            d8[P] = !0;
            var F = t, i1 = "";
            if (t === "#text" ? /\S/.test(r) ? F = "Text nodes" : (F = "Whitespace text nodes", i1 = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : F = "<" + t + ">", p) {
              var n1 = "";
              D === "table" && t === "tr" && (n1 += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), c("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", F, D, i1, n1);
            } else
              c("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", F, D);
          }
        }
      };
    }
    var h9 = "suppressHydrationWarning", m9 = "$", v9 = "/$", tg = "$?", ng = "$!", kL = "style", gI = null, fI = null;
    function jL(t) {
      var r, u, f = t.nodeType;
      switch (f) {
        case w3:
        case K0: {
          r = f === w3 ? "#document" : "#fragment";
          var C = t.documentElement;
          u = C ? C.namespaceURI : Gc(null, "");
          break;
        }
        default: {
          var p = f === Wn ? t.parentNode : t, b = p.namespaceURI || null;
          r = p.tagName, u = Gc(b, r);
          break;
        }
      }
      {
        var T = r.toLowerCase(), D = eg(null, T);
        return {
          namespace: u,
          ancestorInfo: D
        };
      }
    }
    function zL(t, r, u) {
      {
        var f = t, C = Gc(f.namespace, r), p = eg(f.ancestorInfo, r);
        return {
          namespace: C,
          ancestorInfo: p
        };
      }
    }
    function pe1(t) {
      return t;
    }
    function NL(t) {
      gI = ho(), fI = GT();
      var r = null;
      return xr(!1), r;
    }
    function PL(t) {
      qT(fI), xr(gI), gI = null, fI = null;
    }
    function FL(t, r, u, f, C) {
      var p;
      {
        var b = f;
        if ($4(t, null, b.ancestorInfo), typeof r.children == "string" || typeof r.children == "number") {
          var T = "" + r.children, D = eg(b.ancestorInfo, t);
          $4(null, T, D);
        }
        p = b.namespace;
      }
      var P = mL(t, r, u, p);
      return ag(C, P), vI(P, r), P;
    }
    function BL(t, r) {
      t.appendChild(r);
    }
    function HL(t, r, u, f, C) {
      switch (yL(t, r, u, f), r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!u.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function UL(t, r, u, f, C, p) {
      {
        var b = p;
        if (typeof f.children != typeof u.children && (typeof f.children == "string" || typeof f.children == "number")) {
          var T = "" + f.children, D = eg(b.ancestorInfo, r);
          $4(null, T, D);
        }
      }
      return bL(t, r, u, f);
    }
    function dI(t, r) {
      return t === "textarea" || t === "noscript" || typeof r.children == "string" || typeof r.children == "number" || typeof r.dangerouslySetInnerHTML == "object" && r.dangerouslySetInnerHTML !== null && r.dangerouslySetInnerHTML.__html != null;
    }
    function WL(t, r, u, f) {
      {
        var C = u;
        $4(null, t, C.ancestorInfo);
      }
      var p = vL(t, r);
      return ag(f, p), p;
    }
    function _L() {
      var t = window.event;
      return t === void 0 ? K3 : vu(t.type);
    }
    var CI = typeof setTimeout == "function" ? setTimeout : void 0, VL = typeof clearTimeout == "function" ? clearTimeout : void 0, AI = -1, C8 = typeof Promise == "function" ? Promise : void 0, KL = typeof queueMicrotask == "function" ? queueMicrotask : typeof C8 < "u" ? function(t) {
      return C8.resolve(null).then(t).catch(JL);
    } : CI;
    function JL(t) {
      setTimeout(function() {
        throw t;
      });
    }
    function YL(t, r, u, f) {
      switch (r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          u.autoFocus && t.focus();
          return;
        case "img": {
          u.src && (t.src = u.src);
          return;
        }
      }
    }
    function QL(t, r, u, f, C, p) {
      wL(t, r, u, f, C), vI(t, C);
    }
    function A8(t) {
      Ml(t, "");
    }
    function XL(t, r, u) {
      t.nodeValue = u;
    }
    function GL(t, r) {
      t.appendChild(r);
    }
    function qL(t, r) {
      var u;
      t.nodeType === Wn ? (u = t.parentNode, u.insertBefore(r, t)) : (u = t, u.appendChild(r));
      var f = t._reactRootContainer;
      f == null && u.onclick === null && p9(u);
    }
    function ZL(t, r, u) {
      t.insertBefore(r, u);
    }
    function $L(t, r, u) {
      t.nodeType === Wn ? t.parentNode.insertBefore(r, u) : t.insertBefore(r, u);
    }
    function eR(t, r) {
      t.removeChild(r);
    }
    function tR(t, r) {
      t.nodeType === Wn ? t.parentNode.removeChild(r) : t.removeChild(r);
    }
    function II(t, r) {
      var u = r, f = 0;
      do {
        var C = u.nextSibling;
        if (t.removeChild(u), C && C.nodeType === Wn) {
          var p = C.data;
          if (p === v9)
            if (f === 0) {
              t.removeChild(C), Ln(r);
              return;
            } else
              f--;
          else (p === m9 || p === tg || p === ng) && f++;
        }
        u = C;
      } while (u);
      Ln(r);
    }
    function nR(t, r) {
      t.nodeType === Wn ? II(t.parentNode, r) : t.nodeType === Cr && II(t, r), Ln(t);
    }
    function rR(t) {
      t = t;
      var r = t.style;
      typeof r.setProperty == "function" ? r.setProperty("display", "none", "important") : r.display = "none";
    }
    function iR(t) {
      t.nodeValue = "";
    }
    function aR(t, r) {
      t = t;
      var u = r[kL], f = u != null && u.hasOwnProperty("display") ? u.display : null;
      t.style.display = Tl("display", f);
    }
    function oR(t, r) {
      t.nodeValue = r;
    }
    function sR(t) {
      t.nodeType === Cr ? t.textContent = "" : t.nodeType === w3 && t.documentElement && t.removeChild(t.documentElement);
    }
    function lR(t, r, u) {
      return t.nodeType !== Cr || r.toLowerCase() !== t.nodeName.toLowerCase() ? null : t;
    }
    function uR(t, r) {
      return r === "" || t.nodeType !== pi ? null : t;
    }
    function cR(t) {
      return t.nodeType !== Wn ? null : t;
    }
    function I8(t) {
      return t.data === tg;
    }
    function pI(t) {
      return t.data === ng;
    }
    function gR(t) {
      var r = t.nextSibling && t.nextSibling.dataset, u, f, C;
      return r && (u = r.dgst, f = r.msg, C = r.stck), {
        message: f,
        digest: u,
        stack: C
      };
    }
    function fR(t, r) {
      t._reactRetry = r;
    }
    function y9(t) {
      for (; t != null; t = t.nextSibling) {
        var r = t.nodeType;
        if (r === Cr || r === pi)
          break;
        if (r === Wn) {
          var u = t.data;
          if (u === m9 || u === ng || u === tg)
            break;
          if (u === v9)
            return null;
        }
      }
      return t;
    }
    function rg(t) {
      return y9(t.nextSibling);
    }
    function dR(t) {
      return y9(t.firstChild);
    }
    function CR(t) {
      return y9(t.firstChild);
    }
    function AR(t) {
      return y9(t.nextSibling);
    }
    function IR(t, r, u, f, C, p, b) {
      ag(p, t), vI(t, u);
      var T;
      {
        var D = C;
        T = D.namespace;
      }
      var P = (p.mode & je) !== Re;
      return SL(t, r, u, T, f, P, b);
    }
    function pR(t, r, u, f) {
      return ag(u, t), u.mode & je, EL(t, r);
    }
    function hR(t, r) {
      ag(r, t);
    }
    function mR(t) {
      for (var r = t.nextSibling, u = 0; r; ) {
        if (r.nodeType === Wn) {
          var f = r.data;
          if (f === v9) {
            if (u === 0)
              return rg(r);
            u--;
          } else (f === m9 || f === ng || f === tg) && u++;
        }
        r = r.nextSibling;
      }
      return null;
    }
    function p8(t) {
      for (var r = t.previousSibling, u = 0; r; ) {
        if (r.nodeType === Wn) {
          var f = r.data;
          if (f === m9 || f === ng || f === tg) {
            if (u === 0)
              return r;
            u--;
          } else f === v9 && u++;
        }
        r = r.previousSibling;
      }
      return null;
    }
    function vR(t) {
      Ln(t);
    }
    function yR(t) {
      Ln(t);
    }
    function bR(t) {
      return t !== "head" && t !== "body";
    }
    function wR(t, r, u, f) {
      var C = !0;
      I9(r.nodeValue, u, f, C);
    }
    function xR(t, r, u, f, C, p) {
      if (r[h9] !== !0) {
        var b = !0;
        I9(f.nodeValue, C, p, b);
      }
    }
    function SR(t, r) {
      r.nodeType === Cr ? sI(t, r) : r.nodeType === Wn || lI(t, r);
    }
    function ER(t, r) {
      {
        var u = t.parentNode;
        u !== null && (r.nodeType === Cr ? sI(u, r) : r.nodeType === Wn || lI(u, r));
      }
    }
    function MR(t, r, u, f, C) {
      (C || r[h9] !== !0) && (f.nodeType === Cr ? sI(u, f) : f.nodeType === Wn || lI(u, f));
    }
    function TR(t, r, u) {
      uI(t, r);
    }
    function LR(t, r) {
      cI(t, r);
    }
    function RR(t, r, u) {
      {
        var f = t.parentNode;
        f !== null && uI(f, r);
      }
    }
    function OR(t, r) {
      {
        var u = t.parentNode;
        u !== null && cI(u, r);
      }
    }
    function DR(t, r, u, f, C, p) {
      (p || r[h9] !== !0) && uI(u, f);
    }
    function kR(t, r, u, f, C) {
      (C || r[h9] !== !0) && cI(u, f);
    }
    function jR(t) {
      c("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", t.nodeName.toLowerCase());
    }
    function zR(t) {
      X4(t);
    }
    var Fu = Math.random().toString(36).slice(2), Bu = "__reactFiber$" + Fu, hI = "__reactProps$" + Fu, ig = "__reactContainer$" + Fu, mI = "__reactEvents$" + Fu, NR = "__reactListeners$" + Fu, PR = "__reactHandles$" + Fu;
    function FR(t) {
      delete t[Bu], delete t[hI], delete t[mI], delete t[NR], delete t[PR];
    }
    function ag(t, r) {
      r[Bu] = t;
    }
    function b9(t, r) {
      r[ig] = t;
    }
    function h8(t) {
      t[ig] = null;
    }
    function og(t) {
      return !!t[ig];
    }
    function _s(t) {
      var r = t[Bu];
      if (r)
        return r;
      for (var u = t.parentNode; u; ) {
        if (r = u[ig] || u[Bu], r) {
          var f = r.alternate;
          if (r.child !== null || f !== null && f.child !== null)
            for (var C = p8(t); C !== null; ) {
              var p = C[Bu];
              if (p)
                return p;
              C = p8(C);
            }
          return r;
        }
        t = u, u = t.parentNode;
      }
      return null;
    }
    function Eo(t) {
      var r = t[Bu] || t[ig];
      return r && (r.tag === O || r.tag === k || r.tag === B || r.tag === x) ? r : null;
    }
    function Hu(t) {
      if (t.tag === O || t.tag === k)
        return t.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function w9(t) {
      return t[hI] || null;
    }
    function vI(t, r) {
      t[hI] = r;
    }
    function BR(t) {
      var r = t[mI];
      return r === void 0 && (r = t[mI] = /* @__PURE__ */ new Set()), r;
    }
    var m8 = {}, v8 = i.ReactDebugCurrentFrame;
    function x9(t) {
      if (t) {
        var r = t._owner, u = H0(t.type, t._source, r ? r.type : null);
        v8.setExtraStackFrame(u);
      } else
        v8.setExtraStackFrame(null);
    }
    function Ri(t, r, u, f, C) {
      {
        var p = Function.call.bind(y1);
        for (var b in t)
          if (p(t, b)) {
            var T = void 0;
            try {
              if (typeof t[b] != "function") {
                var D = Error((f || "React class") + ": " + u + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw D.name = "Invariant Violation", D;
              }
              T = t[b](r, b, f, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (P) {
              T = P;
            }
            T && !(T instanceof Error) && (x9(C), c("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", u, b, typeof T), x9(null)), T instanceof Error && !(T.message in m8) && (m8[T.message] = !0, x9(C), c("Failed %s type: %s", u, T.message), x9(null));
          }
      }
    }
    var yI = [], S9;
    S9 = [];
    var Aa = -1;
    function Mo(t) {
      return {
        current: t
      };
    }
    function Sr(t, r) {
      if (Aa < 0) {
        c("Unexpected pop.");
        return;
      }
      r !== S9[Aa] && c("Unexpected Fiber popped."), t.current = yI[Aa], yI[Aa] = null, S9[Aa] = null, Aa--;
    }
    function Er(t, r, u) {
      Aa++, yI[Aa] = t.current, S9[Aa] = u, t.current = r;
    }
    var bI;
    bI = {};
    var M3 = {};
    Object.freeze(M3);
    var Ia = Mo(M3), f0 = Mo(!1), wI = M3;
    function Uu(t, r, u) {
      return u && d0(r) ? wI : Ia.current;
    }
    function y8(t, r, u) {
      {
        var f = t.stateNode;
        f.__reactInternalMemoizedUnmaskedChildContext = r, f.__reactInternalMemoizedMaskedChildContext = u;
      }
    }
    function Wu(t, r) {
      {
        var u = t.type, f = u.contextTypes;
        if (!f)
          return M3;
        var C = t.stateNode;
        if (C && C.__reactInternalMemoizedUnmaskedChildContext === r)
          return C.__reactInternalMemoizedMaskedChildContext;
        var p = {};
        for (var b in f)
          p[b] = r[b];
        {
          var T = Fe(t) || "Unknown";
          Ri(f, p, "context", T);
        }
        return C && y8(t, r, p), p;
      }
    }
    function E9() {
      return f0.current;
    }
    function d0(t) {
      {
        var r = t.childContextTypes;
        return r != null;
      }
    }
    function M9(t) {
      Sr(f0, t), Sr(Ia, t);
    }
    function xI(t) {
      Sr(f0, t), Sr(Ia, t);
    }
    function b8(t, r, u) {
      {
        if (Ia.current !== M3)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Er(Ia, r, t), Er(f0, u, t);
      }
    }
    function w8(t, r, u) {
      {
        var f = t.stateNode, C = r.childContextTypes;
        if (typeof f.getChildContext != "function") {
          {
            var p = Fe(t) || "Unknown";
            bI[p] || (bI[p] = !0, c("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", p, p));
          }
          return u;
        }
        var b = f.getChildContext();
        for (var T in b)
          if (!(T in C))
            throw new Error((Fe(t) || "Unknown") + '.getChildContext(): key "' + T + '" is not defined in childContextTypes.');
        {
          var D = Fe(t) || "Unknown";
          Ri(C, b, "child context", D);
        }
        return it({}, u, b);
      }
    }
    function T9(t) {
      {
        var r = t.stateNode, u = r && r.__reactInternalMemoizedMergedChildContext || M3;
        return wI = Ia.current, Er(Ia, u, t), Er(f0, f0.current, t), !0;
      }
    }
    function x8(t, r, u) {
      {
        var f = t.stateNode;
        if (!f)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (u) {
          var C = w8(t, r, wI);
          f.__reactInternalMemoizedMergedChildContext = C, Sr(f0, t), Sr(Ia, t), Er(Ia, C, t), Er(f0, u, t);
        } else
          Sr(f0, t), Er(f0, u, t);
      }
    }
    function HR(t) {
      {
        if (!I4(t) || t.tag !== m)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var r = t;
        do {
          switch (r.tag) {
            case x:
              return r.stateNode.context;
            case m: {
              var u = r.type;
              if (d0(u))
                return r.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          r = r.return;
        } while (r !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var To = 0, L9 = 1, pa = null, SI = !1, EI = !1;
    function S8(t) {
      pa === null ? pa = [t] : pa.push(t);
    }
    function UR(t) {
      SI = !0, S8(t);
    }
    function E8() {
      SI && Lo();
    }
    function Lo() {
      if (!EI && pa !== null) {
        EI = !0;
        var t = 0, r = l3();
        try {
          var u = !0, f = pa;
          for (Tn(Nn); t < f.length; t++) {
            var C = f[t];
            do
              C = C(u);
            while (C !== null);
          }
          pa = null, SI = !1;
        } catch (p) {
          throw pa !== null && (pa = pa.slice(t + 1)), Bl(Ul, Lo), p;
        } finally {
          Tn(r), EI = !1;
        }
      }
      return null;
    }
    var _u = [], Vu = 0, R9 = null, O9 = 0, X3 = [], G3 = 0, Vs = null, ha = 1, ma = "";
    function WR(t) {
      return Js(), (t.flags & d4) !== Ue;
    }
    function _R(t) {
      return Js(), O9;
    }
    function VR() {
      var t = ma, r = ha, u = r & ~KR(r);
      return u.toString(32) + t;
    }
    function Ks(t, r) {
      Js(), _u[Vu++] = O9, _u[Vu++] = R9, R9 = t, O9 = r;
    }
    function M8(t, r, u) {
      Js(), X3[G3++] = ha, X3[G3++] = ma, X3[G3++] = Vs, Vs = t;
      var f = ha, C = ma, p = D9(f) - 1, b = f & ~(1 << p), T = u + 1, D = D9(r) + p;
      if (D > 30) {
        var P = p - p % 5, F = (1 << P) - 1, i1 = (b & F).toString(32), n1 = b >> P, A1 = p - P, m1 = D9(r) + A1, M1 = T << A1, Ce = M1 | n1, We = i1 + C;
        ha = 1 << m1 | Ce, ma = We;
      } else {
        var ze = T << p, mt = ze | b, It = C;
        ha = 1 << D | mt, ma = It;
      }
    }
    function MI(t) {
      Js();
      var r = t.return;
      if (r !== null) {
        var u = 1, f = 0;
        Ks(t, u), M8(t, u, f);
      }
    }
    function D9(t) {
      return 32 - eo(t);
    }
    function KR(t) {
      return 1 << D9(t) - 1;
    }
    function TI(t) {
      for (; t === R9; )
        R9 = _u[--Vu], _u[Vu] = null, O9 = _u[--Vu], _u[Vu] = null;
      for (; t === Vs; )
        Vs = X3[--G3], X3[G3] = null, ma = X3[--G3], X3[G3] = null, ha = X3[--G3], X3[G3] = null;
    }
    function JR() {
      return Js(), Vs !== null ? {
        id: ha,
        overflow: ma
      } : null;
    }
    function YR(t, r) {
      Js(), X3[G3++] = ha, X3[G3++] = ma, X3[G3++] = Vs, ha = r.id, ma = r.overflow, Vs = t;
    }
    function Js() {
      q2() || c("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var G2 = null, q3 = null, Oi = !1, Ys = !1, Ro = null;
    function QR() {
      Oi && c("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function T8() {
      Ys = !0;
    }
    function XR() {
      return Ys;
    }
    function GR(t) {
      var r = t.stateNode.containerInfo;
      return q3 = CR(r), G2 = t, Oi = !0, Ro = null, Ys = !1, !0;
    }
    function qR(t, r, u) {
      return q3 = AR(r), G2 = t, Oi = !0, Ro = null, Ys = !1, u !== null && YR(t, u), !0;
    }
    function L8(t, r) {
      switch (t.tag) {
        case x: {
          SR(t.stateNode.containerInfo, r);
          break;
        }
        case O: {
          var u = (t.mode & je) !== Re;
          MR(
            t.type,
            t.memoizedProps,
            t.stateNode,
            r,
            // TODO: Delete this argument when we remove the legacy root API.
            u
          );
          break;
        }
        case B: {
          var f = t.memoizedState;
          f.dehydrated !== null && ER(f.dehydrated, r);
          break;
        }
      }
    }
    function R8(t, r) {
      L8(t, r);
      var u = tj();
      u.stateNode = r, u.return = t;
      var f = t.deletions;
      f === null ? (t.deletions = [u], t.flags |= Ot) : f.push(u);
    }
    function LI(t, r) {
      {
        if (Ys)
          return;
        switch (t.tag) {
          case x: {
            var u = t.stateNode.containerInfo;
            switch (r.tag) {
              case O:
                var f = r.type;
                r.pendingProps, TR(u, f);
                break;
              case k:
                var C = r.pendingProps;
                LR(u, C);
                break;
            }
            break;
          }
          case O: {
            var p = t.type, b = t.memoizedProps, T = t.stateNode;
            switch (r.tag) {
              case O: {
                var D = r.type, P = r.pendingProps, F = (t.mode & je) !== Re;
                DR(
                  p,
                  b,
                  T,
                  D,
                  P,
                  // TODO: Delete this argument when we remove the legacy root API.
                  F
                );
                break;
              }
              case k: {
                var i1 = r.pendingProps, n1 = (t.mode & je) !== Re;
                kR(
                  p,
                  b,
                  T,
                  i1,
                  // TODO: Delete this argument when we remove the legacy root API.
                  n1
                );
                break;
              }
            }
            break;
          }
          case B: {
            var A1 = t.memoizedState, m1 = A1.dehydrated;
            if (m1 !== null) switch (r.tag) {
              case O:
                var M1 = r.type;
                r.pendingProps, RR(m1, M1);
                break;
              case k:
                var Ce = r.pendingProps;
                OR(m1, Ce);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function O8(t, r) {
      r.flags = r.flags & ~n3 | cn, LI(t, r);
    }
    function D8(t, r) {
      switch (t.tag) {
        case O: {
          var u = t.type;
          t.pendingProps;
          var f = lR(r, u);
          return f !== null ? (t.stateNode = f, G2 = t, q3 = dR(f), !0) : !1;
        }
        case k: {
          var C = t.pendingProps, p = uR(r, C);
          return p !== null ? (t.stateNode = p, G2 = t, q3 = null, !0) : !1;
        }
        case B: {
          var b = cR(r);
          if (b !== null) {
            var T = {
              dehydrated: b,
              treeContext: JR(),
              retryLane: U2
            };
            t.memoizedState = T;
            var D = nj(b);
            return D.return = t, t.child = D, G2 = t, q3 = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function RI(t) {
      return (t.mode & je) !== Re && (t.flags & Xe) === Ue;
    }
    function OI(t) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function DI(t) {
      if (Oi) {
        var r = q3;
        if (!r) {
          RI(t) && (LI(G2, t), OI()), O8(G2, t), Oi = !1, G2 = t;
          return;
        }
        var u = r;
        if (!D8(t, r)) {
          RI(t) && (LI(G2, t), OI()), r = rg(u);
          var f = G2;
          if (!r || !D8(t, r)) {
            O8(G2, t), Oi = !1, G2 = t;
            return;
          }
          R8(f, u);
        }
      }
    }
    function ZR(t, r, u) {
      var f = t.stateNode, C = !Ys, p = IR(f, t.type, t.memoizedProps, r, u, t, C);
      return t.updateQueue = p, p !== null;
    }
    function $R(t) {
      var r = t.stateNode, u = t.memoizedProps, f = pR(r, u, t);
      if (f) {
        var C = G2;
        if (C !== null)
          switch (C.tag) {
            case x: {
              var p = C.stateNode.containerInfo, b = (C.mode & je) !== Re;
              wR(
                p,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                b
              );
              break;
            }
            case O: {
              var T = C.type, D = C.memoizedProps, P = C.stateNode, F = (C.mode & je) !== Re;
              xR(
                T,
                D,
                P,
                r,
                u,
                // TODO: Delete this argument when we remove the legacy root API.
                F
              );
              break;
            }
          }
      }
      return f;
    }
    function eO(t) {
      var r = t.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      hR(u, t);
    }
    function tO(t) {
      var r = t.memoizedState, u = r !== null ? r.dehydrated : null;
      if (!u)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return mR(u);
    }
    function k8(t) {
      for (var r = t.return; r !== null && r.tag !== O && r.tag !== x && r.tag !== B; )
        r = r.return;
      G2 = r;
    }
    function k9(t) {
      if (t !== G2)
        return !1;
      if (!Oi)
        return k8(t), Oi = !0, !1;
      if (t.tag !== x && (t.tag !== O || bR(t.type) && !dI(t.type, t.memoizedProps))) {
        var r = q3;
        if (r)
          if (RI(t))
            j8(t), OI();
          else
            for (; r; )
              R8(t, r), r = rg(r);
      }
      return k8(t), t.tag === B ? q3 = tO(t) : q3 = G2 ? rg(t.stateNode) : null, !0;
    }
    function nO() {
      return Oi && q3 !== null;
    }
    function j8(t) {
      for (var r = q3; r; )
        L8(t, r), r = rg(r);
    }
    function Ku() {
      G2 = null, q3 = null, Oi = !1, Ys = !1;
    }
    function z8() {
      Ro !== null && (Ty(Ro), Ro = null);
    }
    function q2() {
      return Oi;
    }
    function kI(t) {
      Ro === null ? Ro = [t] : Ro.push(t);
    }
    var rO = i.ReactCurrentBatchConfig, iO = null;
    function aO() {
      return rO.transition;
    }
    var Di = {
      recordUnsafeLifecycleWarnings: function(t, r) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(t, r) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var oO = function(t) {
        for (var r = null, u = t; u !== null; )
          u.mode & ct && (r = u), u = u.return;
        return r;
      }, Qs = function(t) {
        var r = [];
        return t.forEach(function(u) {
          r.push(u);
        }), r.sort().join(", ");
      }, sg = [], lg = [], ug = [], cg = [], gg = [], fg = [], Xs = /* @__PURE__ */ new Set();
      Di.recordUnsafeLifecycleWarnings = function(t, r) {
        Xs.has(t.type) || (typeof r.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        r.componentWillMount.__suppressDeprecationWarning !== !0 && sg.push(t), t.mode & ct && typeof r.UNSAFE_componentWillMount == "function" && lg.push(t), typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && ug.push(t), t.mode & ct && typeof r.UNSAFE_componentWillReceiveProps == "function" && cg.push(t), typeof r.componentWillUpdate == "function" && r.componentWillUpdate.__suppressDeprecationWarning !== !0 && gg.push(t), t.mode & ct && typeof r.UNSAFE_componentWillUpdate == "function" && fg.push(t));
      }, Di.flushPendingUnsafeLifecycleWarnings = function() {
        var t = /* @__PURE__ */ new Set();
        sg.length > 0 && (sg.forEach(function(n1) {
          t.add(Fe(n1) || "Component"), Xs.add(n1.type);
        }), sg = []);
        var r = /* @__PURE__ */ new Set();
        lg.length > 0 && (lg.forEach(function(n1) {
          r.add(Fe(n1) || "Component"), Xs.add(n1.type);
        }), lg = []);
        var u = /* @__PURE__ */ new Set();
        ug.length > 0 && (ug.forEach(function(n1) {
          u.add(Fe(n1) || "Component"), Xs.add(n1.type);
        }), ug = []);
        var f = /* @__PURE__ */ new Set();
        cg.length > 0 && (cg.forEach(function(n1) {
          f.add(Fe(n1) || "Component"), Xs.add(n1.type);
        }), cg = []);
        var C = /* @__PURE__ */ new Set();
        gg.length > 0 && (gg.forEach(function(n1) {
          C.add(Fe(n1) || "Component"), Xs.add(n1.type);
        }), gg = []);
        var p = /* @__PURE__ */ new Set();
        if (fg.length > 0 && (fg.forEach(function(n1) {
          p.add(Fe(n1) || "Component"), Xs.add(n1.type);
        }), fg = []), r.size > 0) {
          var b = Qs(r);
          c(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, b);
        }
        if (f.size > 0) {
          var T = Qs(f);
          c(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, T);
        }
        if (p.size > 0) {
          var D = Qs(p);
          c(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, D);
        }
        if (t.size > 0) {
          var P = Qs(t);
          g(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, P);
        }
        if (u.size > 0) {
          var F = Qs(u);
          g(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, F);
        }
        if (C.size > 0) {
          var i1 = Qs(C);
          g(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, i1);
        }
      };
      var j9 = /* @__PURE__ */ new Map(), N8 = /* @__PURE__ */ new Set();
      Di.recordLegacyContextWarning = function(t, r) {
        var u = oO(t);
        if (u === null) {
          c("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!N8.has(t.type)) {
          var f = j9.get(u);
          (t.type.contextTypes != null || t.type.childContextTypes != null || r !== null && typeof r.getChildContext == "function") && (f === void 0 && (f = [], j9.set(u, f)), f.push(t));
        }
      }, Di.flushLegacyContextWarning = function() {
        j9.forEach(function(t, r) {
          if (t.length !== 0) {
            var u = t[0], f = /* @__PURE__ */ new Set();
            t.forEach(function(p) {
              f.add(Fe(p) || "Component"), N8.add(p.type);
            });
            var C = Qs(f);
            try {
              Nt(u), c(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, C);
            } finally {
              jn();
            }
          }
        });
      }, Di.discardPendingWarnings = function() {
        sg = [], lg = [], ug = [], cg = [], gg = [], fg = [], j9 = /* @__PURE__ */ new Map();
      };
    }
    var jI, zI, NI, PI, FI, P8 = function(t, r) {
    };
    jI = !1, zI = !1, NI = {}, PI = {}, FI = {}, P8 = function(t, r) {
      if (!(t === null || typeof t != "object") && !(!t._store || t._store.validated || t.key != null)) {
        if (typeof t._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        t._store.validated = !0;
        var u = Fe(r) || "Component";
        PI[u] || (PI[u] = !0, c('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function sO(t) {
      return t.prototype && t.prototype.isReactComponent;
    }
    function dg(t, r, u) {
      var f = u.ref;
      if (f !== null && typeof f != "function" && typeof f != "object") {
        if ((t.mode & ct || V1) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(u._owner && u._self && u._owner.stateNode !== u._self) && // Will already throw with "Function components cannot have string refs"
        !(u._owner && u._owner.tag !== m) && // Will already warn with "Function components cannot be given refs"
        !(typeof u.type == "function" && !sO(u.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        u._owner) {
          var C = Fe(t) || "Component";
          NI[C] || (c('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', C, f), NI[C] = !0);
        }
        if (u._owner) {
          var p = u._owner, b;
          if (p) {
            var T = p;
            if (T.tag !== m)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            b = T.stateNode;
          }
          if (!b)
            throw new Error("Missing owner for string ref " + f + ". This error is likely caused by a bug in React. Please file an issue.");
          var D = b;
          ut(f, "ref");
          var P = "" + f;
          if (r !== null && r.ref !== null && typeof r.ref == "function" && r.ref._stringRef === P)
            return r.ref;
          var F = function(i1) {
            var n1 = D.refs;
            i1 === null ? delete n1[P] : n1[P] = i1;
          };
          return F._stringRef = P, F;
        } else {
          if (typeof f != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!u._owner)
            throw new Error("Element ref was specified as a string (" + f + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return f;
    }
    function z9(t, r) {
      var u = Object.prototype.toString.call(r);
      throw new Error("Objects are not valid as a React child (found: " + (u === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : u) + "). If you meant to render a collection of children, use an array instead.");
    }
    function N9(t) {
      {
        var r = Fe(t) || "Component";
        if (FI[r])
          return;
        FI[r] = !0, c("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function F8(t) {
      var r = t._payload, u = t._init;
      return u(r);
    }
    function B8(t) {
      function r(l1, T1) {
        if (t) {
          var u1 = l1.deletions;
          u1 === null ? (l1.deletions = [T1], l1.flags |= Ot) : u1.push(T1);
        }
      }
      function u(l1, T1) {
        if (!t)
          return null;
        for (var u1 = T1; u1 !== null; )
          r(l1, u1), u1 = u1.sibling;
        return null;
      }
      function f(l1, T1) {
        for (var u1 = /* @__PURE__ */ new Map(), G1 = T1; G1 !== null; )
          G1.key !== null ? u1.set(G1.key, G1) : u1.set(G1.index, G1), G1 = G1.sibling;
        return u1;
      }
      function C(l1, T1) {
        var u1 = il(l1, T1);
        return u1.index = 0, u1.sibling = null, u1;
      }
      function p(l1, T1, u1) {
        if (l1.index = u1, !t)
          return l1.flags |= d4, T1;
        var G1 = l1.alternate;
        if (G1 !== null) {
          var ve = G1.index;
          return ve < T1 ? (l1.flags |= cn, T1) : ve;
        } else
          return l1.flags |= cn, T1;
      }
      function b(l1) {
        return t && l1.alternate === null && (l1.flags |= cn), l1;
      }
      function T(l1, T1, u1, G1) {
        if (T1 === null || T1.tag !== k) {
          var ve = kp(u1, l1.mode, G1);
          return ve.return = l1, ve;
        } else {
          var Ie = C(T1, u1);
          return Ie.return = l1, Ie;
        }
      }
      function D(l1, T1, u1, G1) {
        var ve = u1.type;
        if (ve === N2)
          return F(l1, T1, u1.props.children, G1, u1.key);
        if (T1 !== null && (T1.elementType === ve || // Keep this check inline so it only runs on the false path:
        Vy(T1, u1) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof ve == "object" && ve !== null && ve.$$typeof === He && F8(ve) === T1.type)) {
          var Ie = C(T1, u1.props);
          return Ie.ref = dg(l1, T1, u1), Ie.return = l1, Ie._debugSource = u1._source, Ie._debugOwner = u1._owner, Ie;
        }
        var Ye = Dp(u1, l1.mode, G1);
        return Ye.ref = dg(l1, T1, u1), Ye.return = l1, Ye;
      }
      function P(l1, T1, u1, G1) {
        if (T1 === null || T1.tag !== M || T1.stateNode.containerInfo !== u1.containerInfo || T1.stateNode.implementation !== u1.implementation) {
          var ve = jp(u1, l1.mode, G1);
          return ve.return = l1, ve;
        } else {
          var Ie = C(T1, u1.children || []);
          return Ie.return = l1, Ie;
        }
      }
      function F(l1, T1, u1, G1, ve) {
        if (T1 === null || T1.tag !== z) {
          var Ie = Uo(u1, l1.mode, G1, ve);
          return Ie.return = l1, Ie;
        } else {
          var Ye = C(T1, u1);
          return Ye.return = l1, Ye;
        }
      }
      function i1(l1, T1, u1) {
        if (typeof T1 == "string" && T1 !== "" || typeof T1 == "number") {
          var G1 = kp("" + T1, l1.mode, u1);
          return G1.return = l1, G1;
        }
        if (typeof T1 == "object" && T1 !== null) {
          switch (T1.$$typeof) {
            case Xr: {
              var ve = Dp(T1, l1.mode, u1);
              return ve.ref = dg(l1, null, T1), ve.return = l1, ve;
            }
            case z2: {
              var Ie = jp(T1, l1.mode, u1);
              return Ie.return = l1, Ie;
            }
            case He: {
              var Ye = T1._payload, $e = T1._init;
              return i1(l1, $e(Ye), u1);
            }
          }
          if (g2(T1) || K2(T1)) {
            var Gt = Uo(T1, l1.mode, u1, null);
            return Gt.return = l1, Gt;
          }
          z9(l1, T1);
        }
        return typeof T1 == "function" && N9(l1), null;
      }
      function n1(l1, T1, u1, G1) {
        var ve = T1 !== null ? T1.key : null;
        if (typeof u1 == "string" && u1 !== "" || typeof u1 == "number")
          return ve !== null ? null : T(l1, T1, "" + u1, G1);
        if (typeof u1 == "object" && u1 !== null) {
          switch (u1.$$typeof) {
            case Xr:
              return u1.key === ve ? D(l1, T1, u1, G1) : null;
            case z2:
              return u1.key === ve ? P(l1, T1, u1, G1) : null;
            case He: {
              var Ie = u1._payload, Ye = u1._init;
              return n1(l1, T1, Ye(Ie), G1);
            }
          }
          if (g2(u1) || K2(u1))
            return ve !== null ? null : F(l1, T1, u1, G1, null);
          z9(l1, u1);
        }
        return typeof u1 == "function" && N9(l1), null;
      }
      function A1(l1, T1, u1, G1, ve) {
        if (typeof G1 == "string" && G1 !== "" || typeof G1 == "number") {
          var Ie = l1.get(u1) || null;
          return T(T1, Ie, "" + G1, ve);
        }
        if (typeof G1 == "object" && G1 !== null) {
          switch (G1.$$typeof) {
            case Xr: {
              var Ye = l1.get(G1.key === null ? u1 : G1.key) || null;
              return D(T1, Ye, G1, ve);
            }
            case z2: {
              var $e = l1.get(G1.key === null ? u1 : G1.key) || null;
              return P(T1, $e, G1, ve);
            }
            case He:
              var Gt = G1._payload, Lt = G1._init;
              return A1(l1, T1, u1, Lt(Gt), ve);
          }
          if (g2(G1) || K2(G1)) {
            var i2 = l1.get(u1) || null;
            return F(T1, i2, G1, ve, null);
          }
          z9(T1, G1);
        }
        return typeof G1 == "function" && N9(T1), null;
      }
      function m1(l1, T1, u1) {
        {
          if (typeof l1 != "object" || l1 === null)
            return T1;
          switch (l1.$$typeof) {
            case Xr:
            case z2:
              P8(l1, u1);
              var G1 = l1.key;
              if (typeof G1 != "string")
                break;
              if (T1 === null) {
                T1 = /* @__PURE__ */ new Set(), T1.add(G1);
                break;
              }
              if (!T1.has(G1)) {
                T1.add(G1);
                break;
              }
              c("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", G1);
              break;
            case He:
              var ve = l1._payload, Ie = l1._init;
              m1(Ie(ve), T1, u1);
              break;
          }
        }
        return T1;
      }
      function M1(l1, T1, u1, G1) {
        for (var ve = null, Ie = 0; Ie < u1.length; Ie++) {
          var Ye = u1[Ie];
          ve = m1(Ye, ve, l1);
        }
        for (var $e = null, Gt = null, Lt = T1, i2 = 0, Rt = 0, Kn = null; Lt !== null && Rt < u1.length; Rt++) {
          Lt.index > Rt ? (Kn = Lt, Lt = null) : Kn = Lt.sibling;
          var Tr = n1(l1, Lt, u1[Rt], G1);
          if (Tr === null) {
            Lt === null && (Lt = Kn);
            break;
          }
          t && Lt && Tr.alternate === null && r(l1, Lt), i2 = p(Tr, i2, Rt), Gt === null ? $e = Tr : Gt.sibling = Tr, Gt = Tr, Lt = Kn;
        }
        if (Rt === u1.length) {
          if (u(l1, Lt), q2()) {
            var ir = Rt;
            Ks(l1, ir);
          }
          return $e;
        }
        if (Lt === null) {
          for (; Rt < u1.length; Rt++) {
            var L3 = i1(l1, u1[Rt], G1);
            L3 !== null && (i2 = p(L3, i2, Rt), Gt === null ? $e = L3 : Gt.sibling = L3, Gt = L3);
          }
          if (q2()) {
            var Kr = Rt;
            Ks(l1, Kr);
          }
          return $e;
        }
        for (var Jr = f(l1, Lt); Rt < u1.length; Rt++) {
          var Lr = A1(Jr, l1, Rt, u1[Rt], G1);
          Lr !== null && (t && Lr.alternate !== null && Jr.delete(Lr.key === null ? Rt : Lr.key), i2 = p(Lr, i2, Rt), Gt === null ? $e = Lr : Gt.sibling = Lr, Gt = Lr);
        }
        if (t && Jr.forEach(function(cc) {
          return r(l1, cc);
        }), q2()) {
          var Ea = Rt;
          Ks(l1, Ea);
        }
        return $e;
      }
      function Ce(l1, T1, u1, G1) {
        var ve = K2(u1);
        if (typeof ve != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          u1[Symbol.toStringTag] === "Generator" && (zI || c("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), zI = !0), u1.entries === ve && (jI || c("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), jI = !0);
          var Ie = ve.call(u1);
          if (Ie)
            for (var Ye = null, $e = Ie.next(); !$e.done; $e = Ie.next()) {
              var Gt = $e.value;
              Ye = m1(Gt, Ye, l1);
            }
        }
        var Lt = ve.call(u1);
        if (Lt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var i2 = null, Rt = null, Kn = T1, Tr = 0, ir = 0, L3 = null, Kr = Lt.next(); Kn !== null && !Kr.done; ir++, Kr = Lt.next()) {
          Kn.index > ir ? (L3 = Kn, Kn = null) : L3 = Kn.sibling;
          var Jr = n1(l1, Kn, Kr.value, G1);
          if (Jr === null) {
            Kn === null && (Kn = L3);
            break;
          }
          t && Kn && Jr.alternate === null && r(l1, Kn), Tr = p(Jr, Tr, ir), Rt === null ? i2 = Jr : Rt.sibling = Jr, Rt = Jr, Kn = L3;
        }
        if (Kr.done) {
          if (u(l1, Kn), q2()) {
            var Lr = ir;
            Ks(l1, Lr);
          }
          return i2;
        }
        if (Kn === null) {
          for (; !Kr.done; ir++, Kr = Lt.next()) {
            var Ea = i1(l1, Kr.value, G1);
            Ea !== null && (Tr = p(Ea, Tr, ir), Rt === null ? i2 = Ea : Rt.sibling = Ea, Rt = Ea);
          }
          if (q2()) {
            var cc = ir;
            Ks(l1, cc);
          }
          return i2;
        }
        for (var Kg = f(l1, Kn); !Kr.done; ir++, Kr = Lt.next()) {
          var y0 = A1(Kg, l1, ir, Kr.value, G1);
          y0 !== null && (t && y0.alternate !== null && Kg.delete(y0.key === null ? ir : y0.key), Tr = p(y0, Tr, ir), Rt === null ? i2 = y0 : Rt.sibling = y0, Rt = y0);
        }
        if (t && Kg.forEach(function(kj) {
          return r(l1, kj);
        }), q2()) {
          var Dj = ir;
          Ks(l1, Dj);
        }
        return i2;
      }
      function We(l1, T1, u1, G1) {
        if (T1 !== null && T1.tag === k) {
          u(l1, T1.sibling);
          var ve = C(T1, u1);
          return ve.return = l1, ve;
        }
        u(l1, T1);
        var Ie = kp(u1, l1.mode, G1);
        return Ie.return = l1, Ie;
      }
      function ze(l1, T1, u1, G1) {
        for (var ve = u1.key, Ie = T1; Ie !== null; ) {
          if (Ie.key === ve) {
            var Ye = u1.type;
            if (Ye === N2) {
              if (Ie.tag === z) {
                u(l1, Ie.sibling);
                var $e = C(Ie, u1.props.children);
                return $e.return = l1, $e._debugSource = u1._source, $e._debugOwner = u1._owner, $e;
              }
            } else if (Ie.elementType === Ye || // Keep this check inline so it only runs on the false path:
            Vy(Ie, u1) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Ye == "object" && Ye !== null && Ye.$$typeof === He && F8(Ye) === Ie.type) {
              u(l1, Ie.sibling);
              var Gt = C(Ie, u1.props);
              return Gt.ref = dg(l1, Ie, u1), Gt.return = l1, Gt._debugSource = u1._source, Gt._debugOwner = u1._owner, Gt;
            }
            u(l1, Ie);
            break;
          } else
            r(l1, Ie);
          Ie = Ie.sibling;
        }
        if (u1.type === N2) {
          var Lt = Uo(u1.props.children, l1.mode, G1, u1.key);
          return Lt.return = l1, Lt;
        } else {
          var i2 = Dp(u1, l1.mode, G1);
          return i2.ref = dg(l1, T1, u1), i2.return = l1, i2;
        }
      }
      function mt(l1, T1, u1, G1) {
        for (var ve = u1.key, Ie = T1; Ie !== null; ) {
          if (Ie.key === ve)
            if (Ie.tag === M && Ie.stateNode.containerInfo === u1.containerInfo && Ie.stateNode.implementation === u1.implementation) {
              u(l1, Ie.sibling);
              var Ye = C(Ie, u1.children || []);
              return Ye.return = l1, Ye;
            } else {
              u(l1, Ie);
              break;
            }
          else
            r(l1, Ie);
          Ie = Ie.sibling;
        }
        var $e = jp(u1, l1.mode, G1);
        return $e.return = l1, $e;
      }
      function It(l1, T1, u1, G1) {
        var ve = typeof u1 == "object" && u1 !== null && u1.type === N2 && u1.key === null;
        if (ve && (u1 = u1.props.children), typeof u1 == "object" && u1 !== null) {
          switch (u1.$$typeof) {
            case Xr:
              return b(ze(l1, T1, u1, G1));
            case z2:
              return b(mt(l1, T1, u1, G1));
            case He:
              var Ie = u1._payload, Ye = u1._init;
              return It(l1, T1, Ye(Ie), G1);
          }
          if (g2(u1))
            return M1(l1, T1, u1, G1);
          if (K2(u1))
            return Ce(l1, T1, u1, G1);
          z9(l1, u1);
        }
        return typeof u1 == "string" && u1 !== "" || typeof u1 == "number" ? b(We(l1, T1, "" + u1, G1)) : (typeof u1 == "function" && N9(l1), u(l1, T1));
      }
      return It;
    }
    var Ju = B8(!0), H8 = B8(!1);
    function lO(t, r) {
      if (t !== null && r.child !== t.child)
        throw new Error("Resuming work not yet implemented.");
      if (r.child !== null) {
        var u = r.child, f = il(u, u.pendingProps);
        for (r.child = f, f.return = r; u.sibling !== null; )
          u = u.sibling, f = f.sibling = il(u, u.pendingProps), f.return = r;
        f.sibling = null;
      }
    }
    function uO(t, r) {
      for (var u = t.child; u !== null; )
        Gk(u, r), u = u.sibling;
    }
    var BI = Mo(null), HI;
    HI = {};
    var P9 = null, Yu = null, UI = null, F9 = !1;
    function B9() {
      P9 = null, Yu = null, UI = null, F9 = !1;
    }
    function U8() {
      F9 = !0;
    }
    function W8() {
      F9 = !1;
    }
    function _8(t, r, u) {
      Er(BI, r._currentValue, t), r._currentValue = u, r._currentRenderer !== void 0 && r._currentRenderer !== null && r._currentRenderer !== HI && c("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), r._currentRenderer = HI;
    }
    function WI(t, r) {
      var u = BI.current;
      Sr(BI, r), t._currentValue = u;
    }
    function _I(t, r, u) {
      for (var f = t; f !== null; ) {
        var C = f.alternate;
        if (sa(f.childLanes, r) ? C !== null && !sa(C.childLanes, r) && (C.childLanes = et(C.childLanes, r)) : (f.childLanes = et(f.childLanes, r), C !== null && (C.childLanes = et(C.childLanes, r))), f === u)
          break;
        f = f.return;
      }
      f !== u && c("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function cO(t, r, u) {
      gO(t, r, u);
    }
    function gO(t, r, u) {
      var f = t.child;
      for (f !== null && (f.return = t); f !== null; ) {
        var C = void 0, p = f.dependencies;
        if (p !== null) {
          C = f.child;
          for (var b = p.firstContext; b !== null; ) {
            if (b.context === r) {
              if (f.tag === m) {
                var T = so(u), D = va(un, T);
                D.tag = U9;
                var P = f.updateQueue;
                if (P !== null) {
                  var F = P.shared, i1 = F.pending;
                  i1 === null ? D.next = D : (D.next = i1.next, i1.next = D), F.pending = D;
                }
              }
              f.lanes = et(f.lanes, u);
              var n1 = f.alternate;
              n1 !== null && (n1.lanes = et(n1.lanes, u)), _I(f.return, u, t), p.lanes = et(p.lanes, u);
              break;
            }
            b = b.next;
          }
        } else if (f.tag === Q)
          C = f.type === t.type ? null : f.child;
        else if (f.tag === e1) {
          var A1 = f.return;
          if (A1 === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          A1.lanes = et(A1.lanes, u);
          var m1 = A1.alternate;
          m1 !== null && (m1.lanes = et(m1.lanes, u)), _I(A1, u, t), C = f.sibling;
        } else
          C = f.child;
        if (C !== null)
          C.return = f;
        else
          for (C = f; C !== null; ) {
            if (C === t) {
              C = null;
              break;
            }
            var M1 = C.sibling;
            if (M1 !== null) {
              M1.return = C.return, C = M1;
              break;
            }
            C = C.return;
          }
        f = C;
      }
    }
    function Qu(t, r) {
      P9 = t, Yu = null, UI = null;
      var u = t.dependencies;
      if (u !== null) {
        var f = u.firstContext;
        f !== null && (wr(u.lanes, r) && Tg(), u.firstContext = null);
      }
    }
    function p2(t) {
      F9 && c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var r = t._currentValue;
      if (UI !== t) {
        var u = {
          context: t,
          memoizedValue: r,
          next: null
        };
        if (Yu === null) {
          if (P9 === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Yu = u, P9.dependencies = {
            lanes: z1,
            firstContext: u
          };
        } else
          Yu = Yu.next = u;
      }
      return r;
    }
    var Gs = null;
    function VI(t) {
      Gs === null ? Gs = [t] : Gs.push(t);
    }
    function fO() {
      if (Gs !== null) {
        for (var t = 0; t < Gs.length; t++) {
          var r = Gs[t], u = r.interleaved;
          if (u !== null) {
            r.interleaved = null;
            var f = u.next, C = r.pending;
            if (C !== null) {
              var p = C.next;
              C.next = f, u.next = p;
            }
            r.pending = u;
          }
        }
        Gs = null;
      }
    }
    function V8(t, r, u, f) {
      var C = r.interleaved;
      return C === null ? (u.next = u, VI(r)) : (u.next = C.next, C.next = u), r.interleaved = u, H9(t, f);
    }
    function dO(t, r, u, f) {
      var C = r.interleaved;
      C === null ? (u.next = u, VI(r)) : (u.next = C.next, C.next = u), r.interleaved = u;
    }
    function CO(t, r, u, f) {
      var C = r.interleaved;
      return C === null ? (u.next = u, VI(r)) : (u.next = C.next, C.next = u), r.interleaved = u, H9(t, f);
    }
    function C3(t, r) {
      return H9(t, r);
    }
    var AO = H9;
    function H9(t, r) {
      t.lanes = et(t.lanes, r);
      var u = t.alternate;
      u !== null && (u.lanes = et(u.lanes, r)), u === null && (t.flags & (cn | n3)) !== Ue && Hy(t);
      for (var f = t, C = t.return; C !== null; )
        C.childLanes = et(C.childLanes, r), u = C.alternate, u !== null ? u.childLanes = et(u.childLanes, r) : (C.flags & (cn | n3)) !== Ue && Hy(t), f = C, C = C.return;
      if (f.tag === x) {
        var p = f.stateNode;
        return p;
      } else
        return null;
    }
    var K8 = 0, J8 = 1, U9 = 2, KI = 3, W9 = !1, JI, _9;
    JI = !1, _9 = null;
    function YI(t) {
      var r = {
        baseState: t.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: z1
        },
        effects: null
      };
      t.updateQueue = r;
    }
    function Y8(t, r) {
      var u = r.updateQueue, f = t.updateQueue;
      if (u === f) {
        var C = {
          baseState: f.baseState,
          firstBaseUpdate: f.firstBaseUpdate,
          lastBaseUpdate: f.lastBaseUpdate,
          shared: f.shared,
          effects: f.effects
        };
        r.updateQueue = C;
      }
    }
    function va(t, r) {
      var u = {
        eventTime: t,
        lane: r,
        tag: K8,
        payload: null,
        callback: null,
        next: null
      };
      return u;
    }
    function Oo(t, r, u) {
      var f = t.updateQueue;
      if (f === null)
        return null;
      var C = f.shared;
      if (_9 === C && !JI && (c("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), JI = !0), dk()) {
        var p = C.pending;
        return p === null ? r.next = r : (r.next = p.next, p.next = r), C.pending = r, AO(t, u);
      } else
        return CO(t, C, r, u);
    }
    function V9(t, r, u) {
      var f = r.updateQueue;
      if (f !== null) {
        var C = f.shared;
        if (T4(u)) {
          var p = C.lanes;
          p = gu(p, t.pendingLanes);
          var b = et(p, u);
          C.lanes = b, L4(t, b);
        }
      }
    }
    function QI(t, r) {
      var u = t.updateQueue, f = t.alternate;
      if (f !== null) {
        var C = f.updateQueue;
        if (u === C) {
          var p = null, b = null, T = u.firstBaseUpdate;
          if (T !== null) {
            var D = T;
            do {
              var P = {
                eventTime: D.eventTime,
                lane: D.lane,
                tag: D.tag,
                payload: D.payload,
                callback: D.callback,
                next: null
              };
              b === null ? p = b = P : (b.next = P, b = P), D = D.next;
            } while (D !== null);
            b === null ? p = b = r : (b.next = r, b = r);
          } else
            p = b = r;
          u = {
            baseState: C.baseState,
            firstBaseUpdate: p,
            lastBaseUpdate: b,
            shared: C.shared,
            effects: C.effects
          }, t.updateQueue = u;
          return;
        }
      }
      var F = u.lastBaseUpdate;
      F === null ? u.firstBaseUpdate = r : F.next = r, u.lastBaseUpdate = r;
    }
    function IO(t, r, u, f, C, p) {
      switch (u.tag) {
        case J8: {
          var b = u.payload;
          if (typeof b == "function") {
            U8();
            var T = b.call(p, f, C);
            {
              if (t.mode & ct) {
                _n(!0);
                try {
                  b.call(p, f, C);
                } finally {
                  _n(!1);
                }
              }
              W8();
            }
            return T;
          }
          return b;
        }
        case KI:
          t.flags = t.flags & ~d2 | Xe;
        case K8: {
          var D = u.payload, P;
          if (typeof D == "function") {
            U8(), P = D.call(p, f, C);
            {
              if (t.mode & ct) {
                _n(!0);
                try {
                  D.call(p, f, C);
                } finally {
                  _n(!1);
                }
              }
              W8();
            }
          } else
            P = D;
          return P == null ? f : it({}, f, P);
        }
        case U9:
          return W9 = !0, f;
      }
      return f;
    }
    function K9(t, r, u, f) {
      var C = t.updateQueue;
      W9 = !1, _9 = C.shared;
      var p = C.firstBaseUpdate, b = C.lastBaseUpdate, T = C.shared.pending;
      if (T !== null) {
        C.shared.pending = null;
        var D = T, P = D.next;
        D.next = null, b === null ? p = P : b.next = P, b = D;
        var F = t.alternate;
        if (F !== null) {
          var i1 = F.updateQueue, n1 = i1.lastBaseUpdate;
          n1 !== b && (n1 === null ? i1.firstBaseUpdate = P : n1.next = P, i1.lastBaseUpdate = D);
        }
      }
      if (p !== null) {
        var A1 = C.baseState, m1 = z1, M1 = null, Ce = null, We = null, ze = p;
        do {
          var mt = ze.lane, It = ze.eventTime;
          if (sa(f, mt)) {
            if (We !== null) {
              var T1 = {
                eventTime: It,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Vn,
                tag: ze.tag,
                payload: ze.payload,
                callback: ze.callback,
                next: null
              };
              We = We.next = T1;
            }
            A1 = IO(t, C, ze, A1, r, u);
            var u1 = ze.callback;
            if (u1 !== null && // If the update was already committed, we should not queue its
            // callback again.
            ze.lane !== Vn) {
              t.flags |= _3;
              var G1 = C.effects;
              G1 === null ? C.effects = [ze] : G1.push(ze);
            }
          } else {
            var l1 = {
              eventTime: It,
              lane: mt,
              tag: ze.tag,
              payload: ze.payload,
              callback: ze.callback,
              next: null
            };
            We === null ? (Ce = We = l1, M1 = A1) : We = We.next = l1, m1 = et(m1, mt);
          }
          if (ze = ze.next, ze === null) {
            if (T = C.shared.pending, T === null)
              break;
            var ve = T, Ie = ve.next;
            ve.next = null, ze = Ie, C.lastBaseUpdate = ve, C.shared.pending = null;
          }
        } while (!0);
        We === null && (M1 = A1), C.baseState = M1, C.firstBaseUpdate = Ce, C.lastBaseUpdate = We;
        var Ye = C.shared.interleaved;
        if (Ye !== null) {
          var $e = Ye;
          do
            m1 = et(m1, $e.lane), $e = $e.next;
          while ($e !== Ye);
        } else p === null && (C.shared.lanes = z1);
        Hg(m1), t.lanes = m1, t.memoizedState = A1;
      }
      _9 = null;
    }
    function pO(t, r) {
      if (typeof t != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + t));
      t.call(r);
    }
    function Q8() {
      W9 = !1;
    }
    function J9() {
      return W9;
    }
    function X8(t, r, u) {
      var f = r.effects;
      if (r.effects = null, f !== null)
        for (var C = 0; C < f.length; C++) {
          var p = f[C], b = p.callback;
          b !== null && (p.callback = null, pO(b, u));
        }
    }
    var Cg = {}, Do = Mo(Cg), Ag = Mo(Cg), Y9 = Mo(Cg);
    function Q9(t) {
      if (t === Cg)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return t;
    }
    function G8() {
      var t = Q9(Y9.current);
      return t;
    }
    function XI(t, r) {
      Er(Y9, r, t), Er(Ag, t, t), Er(Do, Cg, t);
      var u = jL(r);
      Sr(Do, t), Er(Do, u, t);
    }
    function Xu(t) {
      Sr(Do, t), Sr(Ag, t), Sr(Y9, t);
    }
    function GI() {
      var t = Q9(Do.current);
      return t;
    }
    function q8(t) {
      Q9(Y9.current);
      var r = Q9(Do.current), u = zL(r, t.type);
      r !== u && (Er(Ag, t, t), Er(Do, u, t));
    }
    function qI(t) {
      Ag.current === t && (Sr(Do, t), Sr(Ag, t));
    }
    var hO = 0, Z8 = 1, $8 = 1, Ig = 2, ki = Mo(hO);
    function ZI(t, r) {
      return (t & r) !== 0;
    }
    function Gu(t) {
      return t & Z8;
    }
    function $I(t, r) {
      return t & Z8 | r;
    }
    function mO(t, r) {
      return t | r;
    }
    function ko(t, r) {
      Er(ki, r, t);
    }
    function qu(t) {
      Sr(ki, t);
    }
    function vO(t, r) {
      var u = t.memoizedState;
      return u !== null ? u.dehydrated !== null : (t.memoizedProps, !0);
    }
    function X9(t) {
      for (var r = t; r !== null; ) {
        if (r.tag === B) {
          var u = r.memoizedState;
          if (u !== null) {
            var f = u.dehydrated;
            if (f === null || I8(f) || pI(f))
              return r;
          }
        } else if (r.tag === f1 && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        r.memoizedProps.revealOrder !== void 0) {
          var C = (r.flags & Xe) !== Ue;
          if (C)
            return r;
        } else if (r.child !== null) {
          r.child.return = r, r = r.child;
          continue;
        }
        if (r === t)
          return null;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === t)
            return null;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return null;
    }
    var A3 = (
      /*   */
      0
    ), E2 = (
      /* */
      1
    ), C0 = (
      /*  */
      2
    ), M2 = (
      /*    */
      4
    ), Z2 = (
      /*   */
      8
    ), e5 = [];
    function t5() {
      for (var t = 0; t < e5.length; t++) {
        var r = e5[t];
        r._workInProgressVersionPrimary = null;
      }
      e5.length = 0;
    }
    function yO(t, r) {
      var u = r._getVersion, f = u(r._source);
      t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [r, f] : t.mutableSourceEagerHydrationData.push(r, f);
    }
    var he = i.ReactCurrentDispatcher, pg = i.ReactCurrentBatchConfig, n5, Zu;
    n5 = /* @__PURE__ */ new Set();
    var qs = z1, Xt = null, T2 = null, L2 = null, G9 = !1, hg = !1, mg = 0, bO = 0, wO = 25, j1 = null, Z3 = null, jo = -1, r5 = !1;
    function Ft() {
      {
        var t = j1;
        Z3 === null ? Z3 = [t] : Z3.push(t);
      }
    }
    function se() {
      {
        var t = j1;
        Z3 !== null && (jo++, Z3[jo] !== t && xO(t));
      }
    }
    function $u(t) {
      t != null && !g2(t) && c("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", j1, typeof t);
    }
    function xO(t) {
      {
        var r = Fe(Xt);
        if (!n5.has(r) && (n5.add(r), Z3 !== null)) {
          for (var u = "", f = 30, C = 0; C <= jo; C++) {
            for (var p = Z3[C], b = C === jo ? t : p, T = C + 1 + ". " + p; T.length < f; )
              T += " ";
            T += b + `
`, u += T;
          }
          c(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, r, u);
        }
      }
    }
    function Mr() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function i5(t, r) {
      if (r5)
        return !1;
      if (r === null)
        return c("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", j1), !1;
      t.length !== r.length && c(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, j1, "[" + r.join(", ") + "]", "[" + t.join(", ") + "]");
      for (var u = 0; u < r.length && u < t.length; u++)
        if (!Ee(t[u], r[u]))
          return !1;
      return !0;
    }
    function ec(t, r, u, f, C, p) {
      qs = p, Xt = r, Z3 = t !== null ? t._debugHookTypes : null, jo = -1, r5 = t !== null && t.type !== r.type, r.memoizedState = null, r.updateQueue = null, r.lanes = z1, t !== null && t.memoizedState !== null ? he.current = yv : Z3 !== null ? he.current = vv : he.current = mv;
      var b = u(f, C);
      if (hg) {
        var T = 0;
        do {
          if (hg = !1, mg = 0, T >= wO)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          T += 1, r5 = !1, T2 = null, L2 = null, r.updateQueue = null, jo = -1, he.current = bv, b = u(f, C);
        } while (hg);
      }
      he.current = uC, r._debugHookTypes = Z3;
      var D = T2 !== null && T2.next !== null;
      if (qs = z1, Xt = null, T2 = null, L2 = null, j1 = null, Z3 = null, jo = -1, t !== null && (t.flags & w2) !== (r.flags & w2) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (t.mode & je) !== Re && c("Internal React error: Expected static flag was missing. Please notify the React team."), G9 = !1, D)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return b;
    }
    function tc() {
      var t = mg !== 0;
      return mg = 0, t;
    }
    function ev(t, r, u) {
      r.updateQueue = t.updateQueue, (r.mode & Hr) !== Re ? r.flags &= ~(Z0 | pr | pn | tt) : r.flags &= ~(pn | tt), t.lanes = Ts(t.lanes, u);
    }
    function tv() {
      if (he.current = uC, G9) {
        for (var t = Xt.memoizedState; t !== null; ) {
          var r = t.queue;
          r !== null && (r.pending = null), t = t.next;
        }
        G9 = !1;
      }
      qs = z1, Xt = null, T2 = null, L2 = null, Z3 = null, jo = -1, j1 = null, Cv = !1, hg = !1, mg = 0;
    }
    function A0() {
      var t = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return L2 === null ? Xt.memoizedState = L2 = t : L2 = L2.next = t, L2;
    }
    function $3() {
      var t;
      if (T2 === null) {
        var r = Xt.alternate;
        r !== null ? t = r.memoizedState : t = null;
      } else
        t = T2.next;
      var u;
      if (L2 === null ? u = Xt.memoizedState : u = L2.next, u !== null)
        L2 = u, u = L2.next, T2 = t;
      else {
        if (t === null)
          throw new Error("Rendered more hooks than during the previous render.");
        T2 = t;
        var f = {
          memoizedState: T2.memoizedState,
          baseState: T2.baseState,
          baseQueue: T2.baseQueue,
          queue: T2.queue,
          next: null
        };
        L2 === null ? Xt.memoizedState = L2 = f : L2 = L2.next = f;
      }
      return L2;
    }
    function nv() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function a5(t, r) {
      return typeof r == "function" ? r(t) : r;
    }
    function o5(t, r, u) {
      var f = A0(), C;
      u !== void 0 ? C = u(r) : C = r, f.memoizedState = f.baseState = C;
      var p = {
        pending: null,
        interleaved: null,
        lanes: z1,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: C
      };
      f.queue = p;
      var b = p.dispatch = TO.bind(null, Xt, p);
      return [f.memoizedState, b];
    }
    function s5(t, r, u) {
      var f = $3(), C = f.queue;
      if (C === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      C.lastRenderedReducer = t;
      var p = T2, b = p.baseQueue, T = C.pending;
      if (T !== null) {
        if (b !== null) {
          var D = b.next, P = T.next;
          b.next = P, T.next = D;
        }
        p.baseQueue !== b && c("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), p.baseQueue = b = T, C.pending = null;
      }
      if (b !== null) {
        var F = b.next, i1 = p.baseState, n1 = null, A1 = null, m1 = null, M1 = F;
        do {
          var Ce = M1.lane;
          if (sa(qs, Ce)) {
            if (m1 !== null) {
              var ze = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Vn,
                action: M1.action,
                hasEagerState: M1.hasEagerState,
                eagerState: M1.eagerState,
                next: null
              };
              m1 = m1.next = ze;
            }
            if (M1.hasEagerState)
              i1 = M1.eagerState;
            else {
              var mt = M1.action;
              i1 = t(i1, mt);
            }
          } else {
            var We = {
              lane: Ce,
              action: M1.action,
              hasEagerState: M1.hasEagerState,
              eagerState: M1.eagerState,
              next: null
            };
            m1 === null ? (A1 = m1 = We, n1 = i1) : m1 = m1.next = We, Xt.lanes = et(Xt.lanes, Ce), Hg(Ce);
          }
          M1 = M1.next;
        } while (M1 !== null && M1 !== F);
        m1 === null ? n1 = i1 : m1.next = A1, Ee(i1, f.memoizedState) || Tg(), f.memoizedState = i1, f.baseState = n1, f.baseQueue = m1, C.lastRenderedState = i1;
      }
      var It = C.interleaved;
      if (It !== null) {
        var l1 = It;
        do {
          var T1 = l1.lane;
          Xt.lanes = et(Xt.lanes, T1), Hg(T1), l1 = l1.next;
        } while (l1 !== It);
      } else b === null && (C.lanes = z1);
      var u1 = C.dispatch;
      return [f.memoizedState, u1];
    }
    function l5(t, r, u) {
      var f = $3(), C = f.queue;
      if (C === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      C.lastRenderedReducer = t;
      var p = C.dispatch, b = C.pending, T = f.memoizedState;
      if (b !== null) {
        C.pending = null;
        var D = b.next, P = D;
        do {
          var F = P.action;
          T = t(T, F), P = P.next;
        } while (P !== D);
        Ee(T, f.memoizedState) || Tg(), f.memoizedState = T, f.baseQueue === null && (f.baseState = T), C.lastRenderedState = T;
      }
      return [T, p];
    }
    function he1(t, r, u) {
    }
    function me1(t, r, u) {
    }
    function u5(t, r, u) {
      var f = Xt, C = A0(), p, b = q2();
      if (b) {
        if (u === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        p = u(), Zu || p !== u() && (c("The result of getServerSnapshot should be cached to avoid an infinite loop"), Zu = !0);
      } else {
        if (p = r(), !Zu) {
          var T = r();
          Ee(p, T) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), Zu = !0);
        }
        var D = TC();
        if (D === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Ms(D, qs) || rv(f, r, p);
      }
      C.memoizedState = p;
      var P = {
        value: p,
        getSnapshot: r
      };
      return C.queue = P, tC(av.bind(null, f, P, t), [t]), f.flags |= pn, vg(E2 | Z2, iv.bind(null, f, P, p, r), void 0, null), p;
    }
    function q9(t, r, u) {
      var f = Xt, C = $3(), p = r();
      if (!Zu) {
        var b = r();
        Ee(p, b) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), Zu = !0);
      }
      var T = C.memoizedState, D = !Ee(T, p);
      D && (C.memoizedState = p, Tg());
      var P = C.queue;
      if (bg(av.bind(null, f, P, t), [t]), P.getSnapshot !== r || D || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      L2 !== null && L2.memoizedState.tag & E2) {
        f.flags |= pn, vg(E2 | Z2, iv.bind(null, f, P, p, r), void 0, null);
        var F = TC();
        if (F === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Ms(F, qs) || rv(f, r, p);
      }
      return p;
    }
    function rv(t, r, u) {
      t.flags |= ps;
      var f = {
        getSnapshot: r,
        value: u
      }, C = Xt.updateQueue;
      if (C === null)
        C = nv(), Xt.updateQueue = C, C.stores = [f];
      else {
        var p = C.stores;
        p === null ? C.stores = [f] : p.push(f);
      }
    }
    function iv(t, r, u, f) {
      r.value = u, r.getSnapshot = f, ov(r) && sv(t);
    }
    function av(t, r, u) {
      var f = function() {
        ov(r) && sv(t);
      };
      return u(f);
    }
    function ov(t) {
      var r = t.getSnapshot, u = t.value;
      try {
        var f = r();
        return !Ee(u, f);
      } catch {
        return !0;
      }
    }
    function sv(t) {
      var r = C3(t, Ne);
      r !== null && k2(r, t, Ne, un);
    }
    function Z9(t) {
      var r = A0();
      typeof t == "function" && (t = t()), r.memoizedState = r.baseState = t;
      var u = {
        pending: null,
        interleaved: null,
        lanes: z1,
        dispatch: null,
        lastRenderedReducer: a5,
        lastRenderedState: t
      };
      r.queue = u;
      var f = u.dispatch = LO.bind(null, Xt, u);
      return [r.memoizedState, f];
    }
    function c5(t) {
      return s5(a5);
    }
    function g5(t) {
      return l5(a5);
    }
    function vg(t, r, u, f) {
      var C = {
        tag: t,
        create: r,
        destroy: u,
        deps: f,
        // Circular
        next: null
      }, p = Xt.updateQueue;
      if (p === null)
        p = nv(), Xt.updateQueue = p, p.lastEffect = C.next = C;
      else {
        var b = p.lastEffect;
        if (b === null)
          p.lastEffect = C.next = C;
        else {
          var T = b.next;
          b.next = C, C.next = T, p.lastEffect = C;
        }
      }
      return C;
    }
    function f5(t) {
      var r = A0();
      {
        var u = {
          current: t
        };
        return r.memoizedState = u, u;
      }
    }
    function $9(t) {
      var r = $3();
      return r.memoizedState;
    }
    function yg(t, r, u, f) {
      var C = A0(), p = f === void 0 ? null : f;
      Xt.flags |= t, C.memoizedState = vg(E2 | r, u, void 0, p);
    }
    function eC(t, r, u, f) {
      var C = $3(), p = f === void 0 ? null : f, b = void 0;
      if (T2 !== null) {
        var T = T2.memoizedState;
        if (b = T.destroy, p !== null) {
          var D = T.deps;
          if (i5(p, D)) {
            C.memoizedState = vg(r, u, b, p);
            return;
          }
        }
      }
      Xt.flags |= t, C.memoizedState = vg(E2 | r, u, b, p);
    }
    function tC(t, r) {
      return (Xt.mode & Hr) !== Re ? yg(Z0 | pn | n0, Z2, t, r) : yg(pn | n0, Z2, t, r);
    }
    function bg(t, r) {
      return eC(pn, Z2, t, r);
    }
    function d5(t, r) {
      return yg(tt, C0, t, r);
    }
    function nC(t, r) {
      return eC(tt, C0, t, r);
    }
    function C5(t, r) {
      var u = tt;
      return u |= Ir, (Xt.mode & Hr) !== Re && (u |= pr), yg(u, M2, t, r);
    }
    function rC(t, r) {
      return eC(tt, M2, t, r);
    }
    function lv(t, r) {
      if (typeof r == "function") {
        var u = r, f = t();
        return u(f), function() {
          u(null);
        };
      } else if (r != null) {
        var C = r;
        C.hasOwnProperty("current") || c("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(C).join(", ") + "}");
        var p = t();
        return C.current = p, function() {
          C.current = null;
        };
      }
    }
    function A5(t, r, u) {
      typeof r != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var f = u != null ? u.concat([t]) : null, C = tt;
      return C |= Ir, (Xt.mode & Hr) !== Re && (C |= pr), yg(C, M2, lv.bind(null, r, t), f);
    }
    function iC(t, r, u) {
      typeof r != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", r !== null ? typeof r : "null");
      var f = u != null ? u.concat([t]) : null;
      return eC(tt, M2, lv.bind(null, r, t), f);
    }
    function SO(t, r) {
    }
    var aC = SO;
    function I5(t, r) {
      var u = A0(), f = r === void 0 ? null : r;
      return u.memoizedState = [t, f], t;
    }
    function oC(t, r) {
      var u = $3(), f = r === void 0 ? null : r, C = u.memoizedState;
      if (C !== null && f !== null) {
        var p = C[1];
        if (i5(f, p))
          return C[0];
      }
      return u.memoizedState = [t, f], t;
    }
    function p5(t, r) {
      var u = A0(), f = r === void 0 ? null : r, C = t();
      return u.memoizedState = [C, f], C;
    }
    function sC(t, r) {
      var u = $3(), f = r === void 0 ? null : r, C = u.memoizedState;
      if (C !== null && f !== null) {
        var p = C[1];
        if (i5(f, p))
          return C[0];
      }
      var b = t();
      return u.memoizedState = [b, f], b;
    }
    function h5(t) {
      var r = A0();
      return r.memoizedState = t, t;
    }
    function uv(t) {
      var r = $3(), u = T2, f = u.memoizedState;
      return gv(r, f, t);
    }
    function cv(t) {
      var r = $3();
      if (T2 === null)
        return r.memoizedState = t, t;
      var u = T2.memoizedState;
      return gv(r, u, t);
    }
    function gv(t, r, u) {
      var f = !Pd(qs);
      if (f) {
        if (!Ee(u, r)) {
          var C = Hd();
          Xt.lanes = et(Xt.lanes, C), Hg(C), t.baseState = !0;
        }
        return r;
      } else
        return t.baseState && (t.baseState = !1, Tg()), t.memoizedState = u, u;
    }
    function EO(t, r, u) {
      var f = l3();
      Tn(F6(f, Ei)), t(!0);
      var C = pg.transition;
      pg.transition = {};
      var p = pg.transition;
      pg.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        t(!1), r();
      } finally {
        if (Tn(f), pg.transition = C, C === null && p._updatedFibers) {
          var b = p._updatedFibers.size;
          b > 10 && g("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), p._updatedFibers.clear();
        }
      }
    }
    function m5() {
      var t = Z9(!1), r = t[0], u = t[1], f = EO.bind(null, u), C = A0();
      return C.memoizedState = f, [r, f];
    }
    function fv() {
      var t = c5(), r = t[0], u = $3(), f = u.memoizedState;
      return [r, f];
    }
    function dv() {
      var t = g5(), r = t[0], u = $3(), f = u.memoizedState;
      return [r, f];
    }
    var Cv = !1;
    function MO() {
      return Cv;
    }
    function v5() {
      var t = A0(), r = TC(), u = r.identifierPrefix, f;
      if (q2()) {
        var C = VR();
        f = ":" + u + "R" + C;
        var p = mg++;
        p > 0 && (f += "H" + p.toString(32)), f += ":";
      } else {
        var b = bO++;
        f = ":" + u + "r" + b.toString(32) + ":";
      }
      return t.memoizedState = f, f;
    }
    function lC() {
      var t = $3(), r = t.memoizedState;
      return r;
    }
    function TO(t, r, u) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var f = Bo(t), C = {
        lane: f,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Av(t))
        Iv(r, C);
      else {
        var p = V8(t, r, C, f);
        if (p !== null) {
          var b = Vr();
          k2(p, t, f, b), pv(p, r, f);
        }
      }
      hv(t, f);
    }
    function LO(t, r, u) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var f = Bo(t), C = {
        lane: f,
        action: u,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Av(t))
        Iv(r, C);
      else {
        var p = t.alternate;
        if (t.lanes === z1 && (p === null || p.lanes === z1)) {
          var b = r.lastRenderedReducer;
          if (b !== null) {
            var T;
            T = he.current, he.current = ji;
            try {
              var D = r.lastRenderedState, P = b(D, u);
              if (C.hasEagerState = !0, C.eagerState = P, Ee(P, D)) {
                dO(t, r, C, f);
                return;
              }
            } catch {
            } finally {
              he.current = T;
            }
          }
        }
        var F = V8(t, r, C, f);
        if (F !== null) {
          var i1 = Vr();
          k2(F, t, f, i1), pv(F, r, f);
        }
      }
      hv(t, f);
    }
    function Av(t) {
      var r = t.alternate;
      return t === Xt || r !== null && r === Xt;
    }
    function Iv(t, r) {
      hg = G9 = !0;
      var u = t.pending;
      u === null ? r.next = r : (r.next = u.next, u.next = r), t.pending = r;
    }
    function pv(t, r, u) {
      if (T4(u)) {
        var f = r.lanes;
        f = gu(f, t.pendingLanes);
        var C = et(f, u);
        r.lanes = C, L4(t, C);
      }
    }
    function hv(t, r, u) {
      ys(t, r);
    }
    var uC = {
      readContext: p2,
      useCallback: Mr,
      useContext: Mr,
      useEffect: Mr,
      useImperativeHandle: Mr,
      useInsertionEffect: Mr,
      useLayoutEffect: Mr,
      useMemo: Mr,
      useReducer: Mr,
      useRef: Mr,
      useState: Mr,
      useDebugValue: Mr,
      useDeferredValue: Mr,
      useTransition: Mr,
      useMutableSource: Mr,
      useSyncExternalStore: Mr,
      useId: Mr,
      unstable_isNewReconciler: c1
    }, mv = null, vv = null, yv = null, bv = null, I0 = null, ji = null, cC = null;
    {
      var y5 = function() {
        c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Ze = function() {
        c("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      mv = {
        readContext: function(t) {
          return p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", Ft(), $u(r), I5(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", Ft(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", Ft(), $u(r), tC(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", Ft(), $u(u), A5(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", Ft(), $u(r), d5(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", Ft(), $u(r), C5(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", Ft(), $u(r);
          var u = he.current;
          he.current = I0;
          try {
            return p5(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", Ft();
          var f = he.current;
          he.current = I0;
          try {
            return o5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", Ft(), f5(t);
        },
        useState: function(t) {
          j1 = "useState", Ft();
          var r = he.current;
          he.current = I0;
          try {
            return Z9(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", Ft(), void 0;
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", Ft(), h5(t);
        },
        useTransition: function() {
          return j1 = "useTransition", Ft(), m5();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", Ft(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", Ft(), u5(t, r, u);
        },
        useId: function() {
          return j1 = "useId", Ft(), v5();
        },
        unstable_isNewReconciler: c1
      }, vv = {
        readContext: function(t) {
          return p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", se(), I5(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", se(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", se(), tC(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", se(), A5(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", se(), d5(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", se(), C5(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", se();
          var u = he.current;
          he.current = I0;
          try {
            return p5(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", se();
          var f = he.current;
          he.current = I0;
          try {
            return o5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", se(), f5(t);
        },
        useState: function(t) {
          j1 = "useState", se();
          var r = he.current;
          he.current = I0;
          try {
            return Z9(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", se(), void 0;
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", se(), h5(t);
        },
        useTransition: function() {
          return j1 = "useTransition", se(), m5();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", se(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", se(), u5(t, r, u);
        },
        useId: function() {
          return j1 = "useId", se(), v5();
        },
        unstable_isNewReconciler: c1
      }, yv = {
        readContext: function(t) {
          return p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", se(), oC(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", se(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", se(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", se(), iC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", se(), nC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", se(), rC(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", se();
          var u = he.current;
          he.current = ji;
          try {
            return sC(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", se();
          var f = he.current;
          he.current = ji;
          try {
            return s5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", se(), $9();
        },
        useState: function(t) {
          j1 = "useState", se();
          var r = he.current;
          he.current = ji;
          try {
            return c5(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", se(), aC();
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", se(), uv(t);
        },
        useTransition: function() {
          return j1 = "useTransition", se(), fv();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", se(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", se(), q9(t, r);
        },
        useId: function() {
          return j1 = "useId", se(), lC();
        },
        unstable_isNewReconciler: c1
      }, bv = {
        readContext: function(t) {
          return p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", se(), oC(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", se(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", se(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", se(), iC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", se(), nC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", se(), rC(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", se();
          var u = he.current;
          he.current = cC;
          try {
            return sC(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", se();
          var f = he.current;
          he.current = cC;
          try {
            return l5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", se(), $9();
        },
        useState: function(t) {
          j1 = "useState", se();
          var r = he.current;
          he.current = cC;
          try {
            return g5(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", se(), aC();
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", se(), cv(t);
        },
        useTransition: function() {
          return j1 = "useTransition", se(), dv();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", se(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", se(), q9(t, r);
        },
        useId: function() {
          return j1 = "useId", se(), lC();
        },
        unstable_isNewReconciler: c1
      }, I0 = {
        readContext: function(t) {
          return y5(), p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", Ze(), Ft(), I5(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", Ze(), Ft(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", Ze(), Ft(), tC(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", Ze(), Ft(), A5(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", Ze(), Ft(), d5(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", Ze(), Ft(), C5(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", Ze(), Ft();
          var u = he.current;
          he.current = I0;
          try {
            return p5(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", Ze(), Ft();
          var f = he.current;
          he.current = I0;
          try {
            return o5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", Ze(), Ft(), f5(t);
        },
        useState: function(t) {
          j1 = "useState", Ze(), Ft();
          var r = he.current;
          he.current = I0;
          try {
            return Z9(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", Ze(), Ft(), void 0;
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", Ze(), Ft(), h5(t);
        },
        useTransition: function() {
          return j1 = "useTransition", Ze(), Ft(), m5();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", Ze(), Ft(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", Ze(), Ft(), u5(t, r, u);
        },
        useId: function() {
          return j1 = "useId", Ze(), Ft(), v5();
        },
        unstable_isNewReconciler: c1
      }, ji = {
        readContext: function(t) {
          return y5(), p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", Ze(), se(), oC(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", Ze(), se(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", Ze(), se(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", Ze(), se(), iC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", Ze(), se(), nC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", Ze(), se(), rC(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", Ze(), se();
          var u = he.current;
          he.current = ji;
          try {
            return sC(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", Ze(), se();
          var f = he.current;
          he.current = ji;
          try {
            return s5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", Ze(), se(), $9();
        },
        useState: function(t) {
          j1 = "useState", Ze(), se();
          var r = he.current;
          he.current = ji;
          try {
            return c5(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", Ze(), se(), aC();
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", Ze(), se(), uv(t);
        },
        useTransition: function() {
          return j1 = "useTransition", Ze(), se(), fv();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", Ze(), se(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", Ze(), se(), q9(t, r);
        },
        useId: function() {
          return j1 = "useId", Ze(), se(), lC();
        },
        unstable_isNewReconciler: c1
      }, cC = {
        readContext: function(t) {
          return y5(), p2(t);
        },
        useCallback: function(t, r) {
          return j1 = "useCallback", Ze(), se(), oC(t, r);
        },
        useContext: function(t) {
          return j1 = "useContext", Ze(), se(), p2(t);
        },
        useEffect: function(t, r) {
          return j1 = "useEffect", Ze(), se(), bg(t, r);
        },
        useImperativeHandle: function(t, r, u) {
          return j1 = "useImperativeHandle", Ze(), se(), iC(t, r, u);
        },
        useInsertionEffect: function(t, r) {
          return j1 = "useInsertionEffect", Ze(), se(), nC(t, r);
        },
        useLayoutEffect: function(t, r) {
          return j1 = "useLayoutEffect", Ze(), se(), rC(t, r);
        },
        useMemo: function(t, r) {
          j1 = "useMemo", Ze(), se();
          var u = he.current;
          he.current = ji;
          try {
            return sC(t, r);
          } finally {
            he.current = u;
          }
        },
        useReducer: function(t, r, u) {
          j1 = "useReducer", Ze(), se();
          var f = he.current;
          he.current = ji;
          try {
            return l5(t, r, u);
          } finally {
            he.current = f;
          }
        },
        useRef: function(t) {
          return j1 = "useRef", Ze(), se(), $9();
        },
        useState: function(t) {
          j1 = "useState", Ze(), se();
          var r = he.current;
          he.current = ji;
          try {
            return g5(t);
          } finally {
            he.current = r;
          }
        },
        useDebugValue: function(t, r) {
          return j1 = "useDebugValue", Ze(), se(), aC();
        },
        useDeferredValue: function(t) {
          return j1 = "useDeferredValue", Ze(), se(), cv(t);
        },
        useTransition: function() {
          return j1 = "useTransition", Ze(), se(), dv();
        },
        useMutableSource: function(t, r, u) {
          return j1 = "useMutableSource", Ze(), se(), void 0;
        },
        useSyncExternalStore: function(t, r, u) {
          return j1 = "useSyncExternalStore", Ze(), se(), q9(t, r);
        },
        useId: function() {
          return j1 = "useId", Ze(), se(), lC();
        },
        unstable_isNewReconciler: c1
      };
    }
    var zo = n.unstable_now, wv = 0, gC = -1, wg = -1, fC = -1, b5 = !1, dC = !1;
    function xv() {
      return b5;
    }
    function RO() {
      dC = !0;
    }
    function OO() {
      b5 = !1, dC = !1;
    }
    function DO() {
      b5 = dC, dC = !1;
    }
    function Sv() {
      return wv;
    }
    function Ev() {
      wv = zo();
    }
    function w5(t) {
      wg = zo(), t.actualStartTime < 0 && (t.actualStartTime = zo());
    }
    function Mv(t) {
      wg = -1;
    }
    function CC(t, r) {
      if (wg >= 0) {
        var u = zo() - wg;
        t.actualDuration += u, r && (t.selfBaseDuration = u), wg = -1;
      }
    }
    function p0(t) {
      if (gC >= 0) {
        var r = zo() - gC;
        gC = -1;
        for (var u = t.return; u !== null; ) {
          switch (u.tag) {
            case x:
              var f = u.stateNode;
              f.effectDuration += r;
              return;
            case X:
              var C = u.stateNode;
              C.effectDuration += r;
              return;
          }
          u = u.return;
        }
      }
    }
    function x5(t) {
      if (fC >= 0) {
        var r = zo() - fC;
        fC = -1;
        for (var u = t.return; u !== null; ) {
          switch (u.tag) {
            case x:
              var f = u.stateNode;
              f !== null && (f.passiveEffectDuration += r);
              return;
            case X:
              var C = u.stateNode;
              C !== null && (C.passiveEffectDuration += r);
              return;
          }
          u = u.return;
        }
      }
    }
    function h0() {
      gC = zo();
    }
    function S5() {
      fC = zo();
    }
    function E5(t) {
      for (var r = t.child; r; )
        t.actualDuration += r.actualDuration, r = r.sibling;
    }
    function zi(t, r) {
      if (t && t.defaultProps) {
        var u = it({}, r), f = t.defaultProps;
        for (var C in f)
          u[C] === void 0 && (u[C] = f[C]);
        return u;
      }
      return r;
    }
    var M5 = {}, T5, L5, R5, O5, D5, Tv, AC, k5, j5, z5, xg;
    {
      T5 = /* @__PURE__ */ new Set(), L5 = /* @__PURE__ */ new Set(), R5 = /* @__PURE__ */ new Set(), O5 = /* @__PURE__ */ new Set(), k5 = /* @__PURE__ */ new Set(), D5 = /* @__PURE__ */ new Set(), j5 = /* @__PURE__ */ new Set(), z5 = /* @__PURE__ */ new Set(), xg = /* @__PURE__ */ new Set();
      var Lv = /* @__PURE__ */ new Set();
      AC = function(t, r) {
        if (!(t === null || typeof t == "function")) {
          var u = r + "_" + t;
          Lv.has(u) || (Lv.add(u), c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, t));
        }
      }, Tv = function(t, r) {
        if (r === void 0) {
          var u = Mt(t) || "Component";
          D5.has(u) || (D5.add(u), c("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", u));
        }
      }, Object.defineProperty(M5, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(M5);
    }
    function N5(t, r, u, f) {
      var C = t.memoizedState, p = u(f, C);
      {
        if (t.mode & ct) {
          _n(!0);
          try {
            p = u(f, C);
          } finally {
            _n(!1);
          }
        }
        Tv(r, p);
      }
      var b = p == null ? C : it({}, C, p);
      if (t.memoizedState = b, t.lanes === z1) {
        var T = t.updateQueue;
        T.baseState = b;
      }
    }
    var P5 = {
      isMounted: Fr,
      enqueueSetState: function(t, r, u) {
        var f = e3(t), C = Vr(), p = Bo(f), b = va(C, p);
        b.payload = r, u != null && (AC(u, "setState"), b.callback = u);
        var T = Oo(f, b, p);
        T !== null && (k2(T, f, p, C), V9(T, f, p)), ys(f, p);
      },
      enqueueReplaceState: function(t, r, u) {
        var f = e3(t), C = Vr(), p = Bo(f), b = va(C, p);
        b.tag = J8, b.payload = r, u != null && (AC(u, "replaceState"), b.callback = u);
        var T = Oo(f, b, p);
        T !== null && (k2(T, f, p, C), V9(T, f, p)), ys(f, p);
      },
      enqueueForceUpdate: function(t, r) {
        var u = e3(t), f = Vr(), C = Bo(u), p = va(f, C);
        p.tag = U9, r != null && (AC(r, "forceUpdate"), p.callback = r);
        var b = Oo(u, p, C);
        b !== null && (k2(b, u, C, f), V9(b, u, C)), Ql(u, C);
      }
    };
    function Rv(t, r, u, f, C, p, b) {
      var T = t.stateNode;
      if (typeof T.shouldComponentUpdate == "function") {
        var D = T.shouldComponentUpdate(f, p, b);
        {
          if (t.mode & ct) {
            _n(!0);
            try {
              D = T.shouldComponentUpdate(f, p, b);
            } finally {
              _n(!1);
            }
          }
          D === void 0 && c("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Mt(r) || "Component");
        }
        return D;
      }
      return r.prototype && r.prototype.isPureReactComponent ? !Je(u, f) || !Je(C, p) : !0;
    }
    function kO(t, r, u) {
      var f = t.stateNode;
      {
        var C = Mt(r) || "Component", p = f.render;
        p || (r.prototype && typeof r.prototype.render == "function" ? c("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", C) : c("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", C)), f.getInitialState && !f.getInitialState.isReactClassApproved && !f.state && c("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", C), f.getDefaultProps && !f.getDefaultProps.isReactClassApproved && c("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", C), f.propTypes && c("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", C), f.contextType && c("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", C), r.childContextTypes && !xg.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (t.mode & ct) === Re && (xg.add(r), c(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, C)), r.contextTypes && !xg.has(r) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (t.mode & ct) === Re && (xg.add(r), c(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, C)), f.contextTypes && c("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", C), r.contextType && r.contextTypes && !j5.has(r) && (j5.add(r), c("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", C)), typeof f.componentShouldUpdate == "function" && c("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", C), r.prototype && r.prototype.isPureReactComponent && typeof f.shouldComponentUpdate < "u" && c("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Mt(r) || "A pure component"), typeof f.componentDidUnmount == "function" && c("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", C), typeof f.componentDidReceiveProps == "function" && c("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", C), typeof f.componentWillRecieveProps == "function" && c("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", C), typeof f.UNSAFE_componentWillRecieveProps == "function" && c("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", C);
        var b = f.props !== u;
        f.props !== void 0 && b && c("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", C, C), f.defaultProps && c("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", C, C), typeof f.getSnapshotBeforeUpdate == "function" && typeof f.componentDidUpdate != "function" && !R5.has(r) && (R5.add(r), c("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Mt(r))), typeof f.getDerivedStateFromProps == "function" && c("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof f.getDerivedStateFromError == "function" && c("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", C), typeof r.getSnapshotBeforeUpdate == "function" && c("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", C);
        var T = f.state;
        T && (typeof T != "object" || g2(T)) && c("%s.state: must be set to an object or null", C), typeof f.getChildContext == "function" && typeof r.childContextTypes != "object" && c("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", C);
      }
    }
    function Ov(t, r) {
      r.updater = P5, t.stateNode = r, Ya(r, t), r._reactInternalInstance = M5;
    }
    function Dv(t, r, u) {
      var f = !1, C = M3, p = M3, b = r.contextType;
      if ("contextType" in r) {
        var T = (
          // Allow null for conditional declaration
          b === null || b !== void 0 && b.$$typeof === P1 && b._context === void 0
        );
        if (!T && !z5.has(r)) {
          z5.add(r);
          var D = "";
          b === void 0 ? D = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof b != "object" ? D = " However, it is set to a " + typeof b + "." : b.$$typeof === G ? D = " Did you accidentally pass the Context.Provider instead?" : b._context !== void 0 ? D = " Did you accidentally pass the Context.Consumer instead?" : D = " However, it is set to an object with keys {" + Object.keys(b).join(", ") + "}.", c("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Mt(r) || "Component", D);
        }
      }
      if (typeof b == "object" && b !== null)
        p = p2(b);
      else {
        C = Uu(t, r, !0);
        var P = r.contextTypes;
        f = P != null, p = f ? Wu(t, C) : M3;
      }
      var F = new r(u, p);
      if (t.mode & ct) {
        _n(!0);
        try {
          F = new r(u, p);
        } finally {
          _n(!1);
        }
      }
      var i1 = t.memoizedState = F.state !== null && F.state !== void 0 ? F.state : null;
      Ov(t, F);
      {
        if (typeof r.getDerivedStateFromProps == "function" && i1 === null) {
          var n1 = Mt(r) || "Component";
          L5.has(n1) || (L5.add(n1), c("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", n1, F.state === null ? "null" : "undefined", n1));
        }
        if (typeof r.getDerivedStateFromProps == "function" || typeof F.getSnapshotBeforeUpdate == "function") {
          var A1 = null, m1 = null, M1 = null;
          if (typeof F.componentWillMount == "function" && F.componentWillMount.__suppressDeprecationWarning !== !0 ? A1 = "componentWillMount" : typeof F.UNSAFE_componentWillMount == "function" && (A1 = "UNSAFE_componentWillMount"), typeof F.componentWillReceiveProps == "function" && F.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? m1 = "componentWillReceiveProps" : typeof F.UNSAFE_componentWillReceiveProps == "function" && (m1 = "UNSAFE_componentWillReceiveProps"), typeof F.componentWillUpdate == "function" && F.componentWillUpdate.__suppressDeprecationWarning !== !0 ? M1 = "componentWillUpdate" : typeof F.UNSAFE_componentWillUpdate == "function" && (M1 = "UNSAFE_componentWillUpdate"), A1 !== null || m1 !== null || M1 !== null) {
            var Ce = Mt(r) || "Component", We = typeof r.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            O5.has(Ce) || (O5.add(Ce), c(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ce, We, A1 !== null ? `
  ` + A1 : "", m1 !== null ? `
  ` + m1 : "", M1 !== null ? `
  ` + M1 : ""));
          }
        }
      }
      return f && y8(t, C, p), F;
    }
    function jO(t, r) {
      var u = r.state;
      typeof r.componentWillMount == "function" && r.componentWillMount(), typeof r.UNSAFE_componentWillMount == "function" && r.UNSAFE_componentWillMount(), u !== r.state && (c("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Fe(t) || "Component"), P5.enqueueReplaceState(r, r.state, null));
    }
    function kv(t, r, u, f) {
      var C = r.state;
      if (typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(u, f), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(u, f), r.state !== C) {
        {
          var p = Fe(t) || "Component";
          T5.has(p) || (T5.add(p), c("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", p));
        }
        P5.enqueueReplaceState(r, r.state, null);
      }
    }
    function F5(t, r, u, f) {
      kO(t, r, u);
      var C = t.stateNode;
      C.props = u, C.state = t.memoizedState, C.refs = {}, YI(t);
      var p = r.contextType;
      if (typeof p == "object" && p !== null)
        C.context = p2(p);
      else {
        var b = Uu(t, r, !0);
        C.context = Wu(t, b);
      }
      {
        if (C.state === u) {
          var T = Mt(r) || "Component";
          k5.has(T) || (k5.add(T), c("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", T));
        }
        t.mode & ct && Di.recordLegacyContextWarning(t, C), Di.recordUnsafeLifecycleWarnings(t, C);
      }
      C.state = t.memoizedState;
      var D = r.getDerivedStateFromProps;
      if (typeof D == "function" && (N5(t, r, D, u), C.state = t.memoizedState), typeof r.getDerivedStateFromProps != "function" && typeof C.getSnapshotBeforeUpdate != "function" && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function") && (jO(t, C), K9(t, u, C, f), C.state = t.memoizedState), typeof C.componentDidMount == "function") {
        var P = tt;
        P |= Ir, (t.mode & Hr) !== Re && (P |= pr), t.flags |= P;
      }
    }
    function zO(t, r, u, f) {
      var C = t.stateNode, p = t.memoizedProps;
      C.props = p;
      var b = C.context, T = r.contextType, D = M3;
      if (typeof T == "object" && T !== null)
        D = p2(T);
      else {
        var P = Uu(t, r, !0);
        D = Wu(t, P);
      }
      var F = r.getDerivedStateFromProps, i1 = typeof F == "function" || typeof C.getSnapshotBeforeUpdate == "function";
      !i1 && (typeof C.UNSAFE_componentWillReceiveProps == "function" || typeof C.componentWillReceiveProps == "function") && (p !== u || b !== D) && kv(t, C, u, D), Q8();
      var n1 = t.memoizedState, A1 = C.state = n1;
      if (K9(t, u, C, f), A1 = t.memoizedState, p === u && n1 === A1 && !E9() && !J9()) {
        if (typeof C.componentDidMount == "function") {
          var m1 = tt;
          m1 |= Ir, (t.mode & Hr) !== Re && (m1 |= pr), t.flags |= m1;
        }
        return !1;
      }
      typeof F == "function" && (N5(t, r, F, u), A1 = t.memoizedState);
      var M1 = J9() || Rv(t, r, p, u, n1, A1, D);
      if (M1) {
        if (!i1 && (typeof C.UNSAFE_componentWillMount == "function" || typeof C.componentWillMount == "function") && (typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount()), typeof C.componentDidMount == "function") {
          var Ce = tt;
          Ce |= Ir, (t.mode & Hr) !== Re && (Ce |= pr), t.flags |= Ce;
        }
      } else {
        if (typeof C.componentDidMount == "function") {
          var We = tt;
          We |= Ir, (t.mode & Hr) !== Re && (We |= pr), t.flags |= We;
        }
        t.memoizedProps = u, t.memoizedState = A1;
      }
      return C.props = u, C.state = A1, C.context = D, M1;
    }
    function NO(t, r, u, f, C) {
      var p = r.stateNode;
      Y8(t, r);
      var b = r.memoizedProps, T = r.type === r.elementType ? b : zi(r.type, b);
      p.props = T;
      var D = r.pendingProps, P = p.context, F = u.contextType, i1 = M3;
      if (typeof F == "object" && F !== null)
        i1 = p2(F);
      else {
        var n1 = Uu(r, u, !0);
        i1 = Wu(r, n1);
      }
      var A1 = u.getDerivedStateFromProps, m1 = typeof A1 == "function" || typeof p.getSnapshotBeforeUpdate == "function";
      !m1 && (typeof p.UNSAFE_componentWillReceiveProps == "function" || typeof p.componentWillReceiveProps == "function") && (b !== D || P !== i1) && kv(r, p, f, i1), Q8();
      var M1 = r.memoizedState, Ce = p.state = M1;
      if (K9(r, f, p, C), Ce = r.memoizedState, b === D && M1 === Ce && !E9() && !J9() && !b1)
        return typeof p.componentDidUpdate == "function" && (b !== t.memoizedProps || M1 !== t.memoizedState) && (r.flags |= tt), typeof p.getSnapshotBeforeUpdate == "function" && (b !== t.memoizedProps || M1 !== t.memoizedState) && (r.flags |= t3), !1;
      typeof A1 == "function" && (N5(r, u, A1, f), Ce = r.memoizedState);
      var We = J9() || Rv(r, u, T, f, M1, Ce, i1) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      b1;
      return We ? (!m1 && (typeof p.UNSAFE_componentWillUpdate == "function" || typeof p.componentWillUpdate == "function") && (typeof p.componentWillUpdate == "function" && p.componentWillUpdate(f, Ce, i1), typeof p.UNSAFE_componentWillUpdate == "function" && p.UNSAFE_componentWillUpdate(f, Ce, i1)), typeof p.componentDidUpdate == "function" && (r.flags |= tt), typeof p.getSnapshotBeforeUpdate == "function" && (r.flags |= t3)) : (typeof p.componentDidUpdate == "function" && (b !== t.memoizedProps || M1 !== t.memoizedState) && (r.flags |= tt), typeof p.getSnapshotBeforeUpdate == "function" && (b !== t.memoizedProps || M1 !== t.memoizedState) && (r.flags |= t3), r.memoizedProps = f, r.memoizedState = Ce), p.props = f, p.state = Ce, p.context = i1, We;
    }
    function Zs(t, r) {
      return {
        value: t,
        source: r,
        stack: U0(r),
        digest: null
      };
    }
    function B5(t, r, u) {
      return {
        value: t,
        source: null,
        stack: u ?? null,
        digest: r ?? null
      };
    }
    function PO(t, r) {
      return !0;
    }
    function H5(t, r) {
      try {
        var u = PO(t, r);
        if (u === !1)
          return;
        var f = r.value, C = r.source, p = r.stack, b = p !== null ? p : "";
        if (f != null && f._suppressLogging) {
          if (t.tag === m)
            return;
          console.error(f);
        }
        var T = C ? Fe(C) : null, D = T ? "The above error occurred in the <" + T + "> component:" : "The above error occurred in one of your React components:", P;
        if (t.tag === x)
          P = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var F = Fe(t) || "Anonymous";
          P = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + F + ".");
        }
        var i1 = D + `
` + b + `

` + ("" + P);
        console.error(i1);
      } catch (n1) {
        setTimeout(function() {
          throw n1;
        });
      }
    }
    var FO = typeof WeakMap == "function" ? WeakMap : Map;
    function jv(t, r, u) {
      var f = va(un, u);
      f.tag = KI, f.payload = {
        element: null
      };
      var C = r.value;
      return f.callback = function() {
        Rk(C), H5(t, r);
      }, f;
    }
    function U5(t, r, u) {
      var f = va(un, u);
      f.tag = KI;
      var C = t.type.getDerivedStateFromError;
      if (typeof C == "function") {
        var p = r.value;
        f.payload = function() {
          return C(p);
        }, f.callback = function() {
          Ky(t), H5(t, r);
        };
      }
      var b = t.stateNode;
      return b !== null && typeof b.componentDidCatch == "function" && (f.callback = function() {
        Ky(t), H5(t, r), typeof C != "function" && Tk(this);
        var D = r.value, P = r.stack;
        this.componentDidCatch(D, {
          componentStack: P !== null ? P : ""
        }), typeof C != "function" && (wr(t.lanes, Ne) || c("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Fe(t) || "Unknown"));
      }), f;
    }
    function zv(t, r, u) {
      var f = t.pingCache, C;
      if (f === null ? (f = t.pingCache = new FO(), C = /* @__PURE__ */ new Set(), f.set(r, C)) : (C = f.get(r), C === void 0 && (C = /* @__PURE__ */ new Set(), f.set(r, C))), !C.has(u)) {
        C.add(u);
        var p = Ok.bind(null, t, r, u);
        Br && Ug(t, u), r.then(p, p);
      }
    }
    function BO(t, r, u, f) {
      var C = t.updateQueue;
      if (C === null) {
        var p = /* @__PURE__ */ new Set();
        p.add(u), t.updateQueue = p;
      } else
        C.add(u);
    }
    function HO(t, r) {
      var u = t.tag;
      if ((t.mode & je) === Re && (u === h || u === _ || u === Y)) {
        var f = t.alternate;
        f ? (t.updateQueue = f.updateQueue, t.memoizedState = f.memoizedState, t.lanes = f.lanes) : (t.updateQueue = null, t.memoizedState = null);
      }
    }
    function Nv(t) {
      var r = t;
      do {
        if (r.tag === B && vO(r))
          return r;
        r = r.return;
      } while (r !== null);
      return null;
    }
    function Pv(t, r, u, f, C) {
      if ((t.mode & je) === Re) {
        if (t === r)
          t.flags |= d2;
        else {
          if (t.flags |= Xe, u.flags |= hs, u.flags &= ~(Nl | Nr), u.tag === m) {
            var p = u.alternate;
            if (p === null)
              u.tag = J;
            else {
              var b = va(un, Ne);
              b.tag = U9, Oo(u, b, Ne);
            }
          }
          u.lanes = et(u.lanes, Ne);
        }
        return t;
      }
      return t.flags |= d2, t.lanes = C, t;
    }
    function UO(t, r, u, f, C) {
      if (u.flags |= Nr, Br && Ug(t, C), f !== null && typeof f == "object" && typeof f.then == "function") {
        var p = f;
        HO(u), q2() && u.mode & je && T8();
        var b = Nv(r);
        if (b !== null) {
          b.flags &= ~Mn, Pv(b, r, u, t, C), b.mode & je && zv(t, p, C), BO(b, t, p);
          return;
        } else {
          if (!M4(C)) {
            zv(t, p, C), vp();
            return;
          }
          var T = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          f = T;
        }
      } else if (q2() && u.mode & je) {
        T8();
        var D = Nv(r);
        if (D !== null) {
          (D.flags & d2) === Ue && (D.flags |= Mn), Pv(D, r, u, t, C), kI(Zs(f, u));
          return;
        }
      }
      f = Zs(f, u), vk(f);
      var P = r;
      do {
        switch (P.tag) {
          case x: {
            var F = f;
            P.flags |= d2;
            var i1 = so(C);
            P.lanes = et(P.lanes, i1);
            var n1 = jv(P, F, i1);
            QI(P, n1);
            return;
          }
          case m:
            var A1 = f, m1 = P.type, M1 = P.stateNode;
            if ((P.flags & Xe) === Ue && (typeof m1.getDerivedStateFromError == "function" || M1 !== null && typeof M1.componentDidCatch == "function" && !Ny(M1))) {
              P.flags |= d2;
              var Ce = so(C);
              P.lanes = et(P.lanes, Ce);
              var We = U5(P, A1, Ce);
              QI(P, We);
              return;
            }
            break;
        }
        P = P.return;
      } while (P !== null);
    }
    function WO() {
      return null;
    }
    var Sg = i.ReactCurrentOwner, Ni = !1, W5, Eg, _5, V5, K5, $s, J5, IC, Mg;
    W5 = {}, Eg = {}, _5 = {}, V5 = {}, K5 = {}, $s = !1, J5 = {}, IC = {}, Mg = {};
    function Wr(t, r, u, f) {
      t === null ? r.child = H8(r, null, u, f) : r.child = Ju(r, t.child, u, f);
    }
    function _O(t, r, u, f) {
      r.child = Ju(r, t.child, null, f), r.child = Ju(r, null, u, f);
    }
    function Fv(t, r, u, f, C) {
      if (r.type !== r.elementType) {
        var p = u.propTypes;
        p && Ri(
          p,
          f,
          // Resolved props
          "prop",
          Mt(u)
        );
      }
      var b = u.render, T = r.ref, D, P;
      Qu(r, C), qa(r);
      {
        if (Sg.current = r, zr(!0), D = ec(t, r, b, f, T, C), P = tc(), r.mode & ct) {
          _n(!0);
          try {
            D = ec(t, r, b, f, T, C), P = tc();
          } finally {
            _n(!1);
          }
        }
        zr(!1);
      }
      return vr(), t !== null && !Ni ? (ev(t, r, C), ya(t, r, C)) : (q2() && P && MI(r), r.flags |= e0, Wr(t, r, D, C), r.child);
    }
    function Bv(t, r, u, f, C) {
      if (t === null) {
        var p = u.type;
        if (Qk(p) && u.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        u.defaultProps === void 0) {
          var b = p;
          return b = uc(p), r.tag = Y, r.type = b, X5(r, p), Hv(t, r, b, f, C);
        }
        {
          var T = p.propTypes;
          if (T && Ri(
            T,
            f,
            // Resolved props
            "prop",
            Mt(p)
          ), u.defaultProps !== void 0) {
            var D = Mt(p) || "Unknown";
            Mg[D] || (c("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", D), Mg[D] = !0);
          }
        }
        var P = Op(u.type, null, f, r, r.mode, C);
        return P.ref = r.ref, P.return = r, r.child = P, P;
      }
      {
        var F = u.type, i1 = F.propTypes;
        i1 && Ri(
          i1,
          f,
          // Resolved props
          "prop",
          Mt(F)
        );
      }
      var n1 = t.child, A1 = tp(t, C);
      if (!A1) {
        var m1 = n1.memoizedProps, M1 = u.compare;
        if (M1 = M1 !== null ? M1 : Je, M1(m1, f) && t.ref === r.ref)
          return ya(t, r, C);
      }
      r.flags |= e0;
      var Ce = il(n1, f);
      return Ce.ref = r.ref, Ce.return = r, r.child = Ce, Ce;
    }
    function Hv(t, r, u, f, C) {
      if (r.type !== r.elementType) {
        var p = r.elementType;
        if (p.$$typeof === He) {
          var b = p, T = b._payload, D = b._init;
          try {
            p = D(T);
          } catch {
            p = null;
          }
          var P = p && p.propTypes;
          P && Ri(
            P,
            f,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Mt(p)
          );
        }
      }
      if (t !== null) {
        var F = t.memoizedProps;
        if (Je(F, f) && t.ref === r.ref && // Prevent bailout if the implementation changed due to hot reload.
        r.type === t.type)
          if (Ni = !1, r.pendingProps = f = F, tp(t, C))
            (t.flags & hs) !== Ue && (Ni = !0);
          else return r.lanes = t.lanes, ya(t, r, C);
      }
      return Y5(t, r, u, f, C);
    }
    function Uv(t, r, u) {
      var f = r.pendingProps, C = f.children, p = t !== null ? t.memoizedState : null;
      if (f.mode === "hidden" || t1)
        if ((r.mode & je) === Re) {
          var b = {
            baseLanes: z1,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = b, LC(r, u);
        } else if (wr(u, U2)) {
          var i1 = {
            baseLanes: z1,
            cachePool: null,
            transitions: null
          };
          r.memoizedState = i1;
          var n1 = p !== null ? p.baseLanes : u;
          LC(r, n1);
        } else {
          var T = null, D;
          if (p !== null) {
            var P = p.baseLanes;
            D = et(P, u);
          } else
            D = u;
          r.lanes = r.childLanes = U2;
          var F = {
            baseLanes: D,
            cachePool: T,
            transitions: null
          };
          return r.memoizedState = F, r.updateQueue = null, LC(r, D), null;
        }
      else {
        var A1;
        p !== null ? (A1 = et(p.baseLanes, u), r.memoizedState = null) : A1 = u, LC(r, A1);
      }
      return Wr(t, r, C, u), r.child;
    }
    function VO(t, r, u) {
      var f = r.pendingProps;
      return Wr(t, r, f, u), r.child;
    }
    function KO(t, r, u) {
      var f = r.pendingProps.children;
      return Wr(t, r, f, u), r.child;
    }
    function JO(t, r, u) {
      {
        r.flags |= tt;
        {
          var f = r.stateNode;
          f.effectDuration = 0, f.passiveEffectDuration = 0;
        }
      }
      var C = r.pendingProps, p = C.children;
      return Wr(t, r, p, u), r.child;
    }
    function Wv(t, r) {
      var u = r.ref;
      (t === null && u !== null || t !== null && t.ref !== u) && (r.flags |= Ar, r.flags |= C4);
    }
    function Y5(t, r, u, f, C) {
      if (r.type !== r.elementType) {
        var p = u.propTypes;
        p && Ri(
          p,
          f,
          // Resolved props
          "prop",
          Mt(u)
        );
      }
      var b;
      {
        var T = Uu(r, u, !0);
        b = Wu(r, T);
      }
      var D, P;
      Qu(r, C), qa(r);
      {
        if (Sg.current = r, zr(!0), D = ec(t, r, u, f, b, C), P = tc(), r.mode & ct) {
          _n(!0);
          try {
            D = ec(t, r, u, f, b, C), P = tc();
          } finally {
            _n(!1);
          }
        }
        zr(!1);
      }
      return vr(), t !== null && !Ni ? (ev(t, r, C), ya(t, r, C)) : (q2() && P && MI(r), r.flags |= e0, Wr(t, r, D, C), r.child);
    }
    function _v(t, r, u, f, C) {
      {
        switch (uj(r)) {
          case !1: {
            var p = r.stateNode, b = r.type, T = new b(r.memoizedProps, p.context), D = T.state;
            p.updater.enqueueSetState(p, D, null);
            break;
          }
          case !0: {
            r.flags |= Xe, r.flags |= d2;
            var P = new Error("Simulated error coming from DevTools"), F = so(C);
            r.lanes = et(r.lanes, F);
            var i1 = U5(r, Zs(P, r), F);
            QI(r, i1);
            break;
          }
        }
        if (r.type !== r.elementType) {
          var n1 = u.propTypes;
          n1 && Ri(
            n1,
            f,
            // Resolved props
            "prop",
            Mt(u)
          );
        }
      }
      var A1;
      d0(u) ? (A1 = !0, T9(r)) : A1 = !1, Qu(r, C);
      var m1 = r.stateNode, M1;
      m1 === null ? (hC(t, r), Dv(r, u, f), F5(r, u, f, C), M1 = !0) : t === null ? M1 = zO(r, u, f, C) : M1 = NO(t, r, u, f, C);
      var Ce = Q5(t, r, u, M1, A1, C);
      {
        var We = r.stateNode;
        M1 && We.props !== f && ($s || c("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Fe(r) || "a component"), $s = !0);
      }
      return Ce;
    }
    function Q5(t, r, u, f, C, p) {
      Wv(t, r);
      var b = (r.flags & Xe) !== Ue;
      if (!f && !b)
        return C && x8(r, u, !1), ya(t, r, p);
      var T = r.stateNode;
      Sg.current = r;
      var D;
      if (b && typeof u.getDerivedStateFromError != "function")
        D = null, Mv();
      else {
        qa(r);
        {
          if (zr(!0), D = T.render(), r.mode & ct) {
            _n(!0);
            try {
              T.render();
            } finally {
              _n(!1);
            }
          }
          zr(!1);
        }
        vr();
      }
      return r.flags |= e0, t !== null && b ? _O(t, r, D, p) : Wr(t, r, D, p), r.memoizedState = T.state, C && x8(r, u, !0), r.child;
    }
    function Vv(t) {
      var r = t.stateNode;
      r.pendingContext ? b8(t, r.pendingContext, r.pendingContext !== r.context) : r.context && b8(t, r.context, !1), XI(t, r.containerInfo);
    }
    function YO(t, r, u) {
      if (Vv(r), t === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var f = r.pendingProps, C = r.memoizedState, p = C.element;
      Y8(t, r), K9(r, f, null, u);
      var b = r.memoizedState;
      r.stateNode;
      var T = b.element;
      if (C.isDehydrated) {
        var D = {
          element: T,
          isDehydrated: !1,
          cache: b.cache,
          pendingSuspenseBoundaries: b.pendingSuspenseBoundaries,
          transitions: b.transitions
        }, P = r.updateQueue;
        if (P.baseState = D, r.memoizedState = D, r.flags & Mn) {
          var F = Zs(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), r);
          return Kv(t, r, T, u, F);
        } else if (T !== p) {
          var i1 = Zs(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), r);
          return Kv(t, r, T, u, i1);
        } else {
          GR(r);
          var n1 = H8(r, null, T, u);
          r.child = n1;
          for (var A1 = n1; A1; )
            A1.flags = A1.flags & ~cn | n3, A1 = A1.sibling;
        }
      } else {
        if (Ku(), T === p)
          return ya(t, r, u);
        Wr(t, r, T, u);
      }
      return r.child;
    }
    function Kv(t, r, u, f, C) {
      return Ku(), kI(C), r.flags |= Mn, Wr(t, r, u, f), r.child;
    }
    function QO(t, r, u) {
      q8(r), t === null && DI(r);
      var f = r.type, C = r.pendingProps, p = t !== null ? t.memoizedProps : null, b = C.children, T = dI(f, C);
      return T ? b = null : p !== null && dI(f, p) && (r.flags |= Pt), Wv(t, r), Wr(t, r, b, u), r.child;
    }
    function XO(t, r) {
      return t === null && DI(r), null;
    }
    function GO(t, r, u, f) {
      hC(t, r);
      var C = r.pendingProps, p = u, b = p._payload, T = p._init, D = T(b);
      r.type = D;
      var P = r.tag = Xk(D), F = zi(D, C), i1;
      switch (P) {
        case h:
          return X5(r, D), r.type = D = uc(D), i1 = Y5(null, r, D, F, f), i1;
        case m:
          return r.type = D = Sp(D), i1 = _v(null, r, D, F, f), i1;
        case _:
          return r.type = D = Ep(D), i1 = Fv(null, r, D, F, f), i1;
        case Z: {
          if (r.type !== r.elementType) {
            var n1 = D.propTypes;
            n1 && Ri(
              n1,
              F,
              // Resolved for outer only
              "prop",
              Mt(D)
            );
          }
          return i1 = Bv(
            null,
            r,
            D,
            zi(D.type, F),
            // The inner type can have defaults too
            f
          ), i1;
        }
      }
      var A1 = "";
      throw D !== null && typeof D == "object" && D.$$typeof === He && (A1 = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + D + ". " + ("Lazy element type must resolve to a class or function." + A1));
    }
    function qO(t, r, u, f, C) {
      hC(t, r), r.tag = m;
      var p;
      return d0(u) ? (p = !0, T9(r)) : p = !1, Qu(r, C), Dv(r, u, f), F5(r, u, f, C), Q5(null, r, u, !0, p, C);
    }
    function ZO(t, r, u, f) {
      hC(t, r);
      var C = r.pendingProps, p;
      {
        var b = Uu(r, u, !1);
        p = Wu(r, b);
      }
      Qu(r, f);
      var T, D;
      qa(r);
      {
        if (u.prototype && typeof u.prototype.render == "function") {
          var P = Mt(u) || "Unknown";
          W5[P] || (c("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", P, P), W5[P] = !0);
        }
        r.mode & ct && Di.recordLegacyContextWarning(r, null), zr(!0), Sg.current = r, T = ec(null, r, u, C, p, f), D = tc(), zr(!1);
      }
      if (vr(), r.flags |= e0, typeof T == "object" && T !== null && typeof T.render == "function" && T.$$typeof === void 0) {
        var F = Mt(u) || "Unknown";
        Eg[F] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", F, F, F), Eg[F] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof T == "object" && T !== null && typeof T.render == "function" && T.$$typeof === void 0
      ) {
        {
          var i1 = Mt(u) || "Unknown";
          Eg[i1] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", i1, i1, i1), Eg[i1] = !0);
        }
        r.tag = m, r.memoizedState = null, r.updateQueue = null;
        var n1 = !1;
        return d0(u) ? (n1 = !0, T9(r)) : n1 = !1, r.memoizedState = T.state !== null && T.state !== void 0 ? T.state : null, YI(r), Ov(r, T), F5(r, u, C, f), Q5(null, r, u, !0, n1, f);
      } else {
        if (r.tag = h, r.mode & ct) {
          _n(!0);
          try {
            T = ec(null, r, u, C, p, f), D = tc();
          } finally {
            _n(!1);
          }
        }
        return q2() && D && MI(r), Wr(null, r, T, f), X5(r, u), r.child;
      }
    }
    function X5(t, r) {
      {
        if (r && r.childContextTypes && c("%s(...): childContextTypes cannot be defined on a function component.", r.displayName || r.name || "Component"), t.ref !== null) {
          var u = "", f = dr();
          f && (u += `

Check the render method of \`` + f + "`.");
          var C = f || "", p = t._debugSource;
          p && (C = p.fileName + ":" + p.lineNumber), K5[C] || (K5[C] = !0, c("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", u));
        }
        if (r.defaultProps !== void 0) {
          var b = Mt(r) || "Unknown";
          Mg[b] || (c("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", b), Mg[b] = !0);
        }
        if (typeof r.getDerivedStateFromProps == "function") {
          var T = Mt(r) || "Unknown";
          V5[T] || (c("%s: Function components do not support getDerivedStateFromProps.", T), V5[T] = !0);
        }
        if (typeof r.contextType == "object" && r.contextType !== null) {
          var D = Mt(r) || "Unknown";
          _5[D] || (c("%s: Function components do not support contextType.", D), _5[D] = !0);
        }
      }
    }
    var G5 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Vn
    };
    function q5(t) {
      return {
        baseLanes: t,
        cachePool: WO(),
        transitions: null
      };
    }
    function $O(t, r) {
      var u = null;
      return {
        baseLanes: et(t.baseLanes, r),
        cachePool: u,
        transitions: t.transitions
      };
    }
    function eD(t, r, u, f) {
      if (r !== null) {
        var C = r.memoizedState;
        if (C === null)
          return !1;
      }
      return ZI(t, Ig);
    }
    function tD(t, r) {
      return Ts(t.childLanes, r);
    }
    function Jv(t, r, u) {
      var f = r.pendingProps;
      cj(r) && (r.flags |= Xe);
      var C = ki.current, p = !1, b = (r.flags & Xe) !== Ue;
      if (b || eD(C, t) ? (p = !0, r.flags &= ~Xe) : (t === null || t.memoizedState !== null) && (C = mO(C, $8)), C = Gu(C), ko(r, C), t === null) {
        DI(r);
        var T = r.memoizedState;
        if (T !== null) {
          var D = T.dehydrated;
          if (D !== null)
            return oD(r, D);
        }
        var P = f.children, F = f.fallback;
        if (p) {
          var i1 = nD(r, P, F, u), n1 = r.child;
          return n1.memoizedState = q5(u), r.memoizedState = G5, i1;
        } else
          return Z5(r, P);
      } else {
        var A1 = t.memoizedState;
        if (A1 !== null) {
          var m1 = A1.dehydrated;
          if (m1 !== null)
            return sD(t, r, b, f, m1, A1, u);
        }
        if (p) {
          var M1 = f.fallback, Ce = f.children, We = iD(t, r, Ce, M1, u), ze = r.child, mt = t.child.memoizedState;
          return ze.memoizedState = mt === null ? q5(u) : $O(mt, u), ze.childLanes = tD(t, u), r.memoizedState = G5, We;
        } else {
          var It = f.children, l1 = rD(t, r, It, u);
          return r.memoizedState = null, l1;
        }
      }
    }
    function Z5(t, r, u) {
      var f = t.mode, C = {
        mode: "visible",
        children: r
      }, p = $5(C, f);
      return p.return = t, t.child = p, p;
    }
    function nD(t, r, u, f) {
      var C = t.mode, p = t.child, b = {
        mode: "hidden",
        children: r
      }, T, D;
      return (C & je) === Re && p !== null ? (T = p, T.childLanes = z1, T.pendingProps = b, t.mode & Ge && (T.actualDuration = 0, T.actualStartTime = -1, T.selfBaseDuration = 0, T.treeBaseDuration = 0), D = Uo(u, C, f, null)) : (T = $5(b, C), D = Uo(u, C, f, null)), T.return = t, D.return = t, T.sibling = D, t.child = T, D;
    }
    function $5(t, r, u) {
      return Yy(t, r, z1, null);
    }
    function Yv(t, r) {
      return il(t, r);
    }
    function rD(t, r, u, f) {
      var C = t.child, p = C.sibling, b = Yv(C, {
        mode: "visible",
        children: u
      });
      if ((r.mode & je) === Re && (b.lanes = f), b.return = r, b.sibling = null, p !== null) {
        var T = r.deletions;
        T === null ? (r.deletions = [p], r.flags |= Ot) : T.push(p);
      }
      return r.child = b, b;
    }
    function iD(t, r, u, f, C) {
      var p = r.mode, b = t.child, T = b.sibling, D = {
        mode: "hidden",
        children: u
      }, P;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (p & je) === Re && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        r.child !== b
      ) {
        var F = r.child;
        P = F, P.childLanes = z1, P.pendingProps = D, r.mode & Ge && (P.actualDuration = 0, P.actualStartTime = -1, P.selfBaseDuration = b.selfBaseDuration, P.treeBaseDuration = b.treeBaseDuration), r.deletions = null;
      } else
        P = Yv(b, D), P.subtreeFlags = b.subtreeFlags & w2;
      var i1;
      return T !== null ? i1 = il(T, f) : (i1 = Uo(f, p, C, null), i1.flags |= cn), i1.return = r, P.return = r, P.sibling = i1, r.child = P, i1;
    }
    function pC(t, r, u, f) {
      f !== null && kI(f), Ju(r, t.child, null, u);
      var C = r.pendingProps, p = C.children, b = Z5(r, p);
      return b.flags |= cn, r.memoizedState = null, b;
    }
    function aD(t, r, u, f, C) {
      var p = r.mode, b = {
        mode: "visible",
        children: u
      }, T = $5(b, p), D = Uo(f, p, C, null);
      return D.flags |= cn, T.return = r, D.return = r, T.sibling = D, r.child = T, (r.mode & je) !== Re && Ju(r, t.child, null, C), D;
    }
    function oD(t, r, u) {
      return (t.mode & je) === Re ? (c("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), t.lanes = Ne) : pI(r) ? t.lanes = Si : t.lanes = U2, null;
    }
    function sD(t, r, u, f, C, p, b) {
      if (u)
        if (r.flags & Mn) {
          r.flags &= ~Mn;
          var l1 = B5(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return pC(t, r, b, l1);
        } else {
          if (r.memoizedState !== null)
            return r.child = t.child, r.flags |= Xe, null;
          var T1 = f.children, u1 = f.fallback, G1 = aD(t, r, T1, u1, b), ve = r.child;
          return ve.memoizedState = q5(b), r.memoizedState = G5, G1;
        }
      else {
        if (QR(), (r.mode & je) === Re)
          return pC(
            t,
            r,
            b,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (pI(C)) {
          var T, D, P;
          {
            var F = gR(C);
            T = F.digest, D = F.message, P = F.stack;
          }
          var i1;
          D ? i1 = new Error(D) : i1 = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var n1 = B5(i1, T, P);
          return pC(t, r, b, n1);
        }
        var A1 = wr(b, t.childLanes);
        if (Ni || A1) {
          var m1 = TC();
          if (m1 !== null) {
            var M1 = _d(m1, b);
            if (M1 !== Vn && M1 !== p.retryLane) {
              p.retryLane = M1;
              var Ce = un;
              C3(t, M1), k2(m1, t, M1, Ce);
            }
          }
          vp();
          var We = B5(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return pC(t, r, b, We);
        } else if (I8(C)) {
          r.flags |= Xe, r.child = t.child;
          var ze = Dk.bind(null, t);
          return fR(C, ze), null;
        } else {
          qR(r, C, p.treeContext);
          var mt = f.children, It = Z5(r, mt);
          return It.flags |= n3, It;
        }
      }
    }
    function Qv(t, r, u) {
      t.lanes = et(t.lanes, r);
      var f = t.alternate;
      f !== null && (f.lanes = et(f.lanes, r)), _I(t.return, r, u);
    }
    function lD(t, r, u) {
      for (var f = r; f !== null; ) {
        if (f.tag === B) {
          var C = f.memoizedState;
          C !== null && Qv(f, u, t);
        } else if (f.tag === f1)
          Qv(f, u, t);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === t)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === t)
            return;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
    }
    function uD(t) {
      for (var r = t, u = null; r !== null; ) {
        var f = r.alternate;
        f !== null && X9(f) === null && (u = r), r = r.sibling;
      }
      return u;
    }
    function cD(t) {
      if (t !== void 0 && t !== "forwards" && t !== "backwards" && t !== "together" && !J5[t])
        if (J5[t] = !0, typeof t == "string")
          switch (t.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', t, t.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', t, t.toLowerCase());
              break;
            }
            default:
              c('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', t);
              break;
          }
        else
          c('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', t);
    }
    function gD(t, r) {
      t !== void 0 && !IC[t] && (t !== "collapsed" && t !== "hidden" ? (IC[t] = !0, c('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', t)) : r !== "forwards" && r !== "backwards" && (IC[t] = !0, c('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', t)));
    }
    function Xv(t, r) {
      {
        var u = g2(t), f = !u && typeof K2(t) == "function";
        if (u || f) {
          var C = u ? "array" : "iterable";
          return c("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", C, r, C), !1;
        }
      }
      return !0;
    }
    function fD(t, r) {
      if ((r === "forwards" || r === "backwards") && t !== void 0 && t !== null && t !== !1)
        if (g2(t)) {
          for (var u = 0; u < t.length; u++)
            if (!Xv(t[u], u))
              return;
        } else {
          var f = K2(t);
          if (typeof f == "function") {
            var C = f.call(t);
            if (C)
              for (var p = C.next(), b = 0; !p.done; p = C.next()) {
                if (!Xv(p.value, b))
                  return;
                b++;
              }
          } else
            c('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', r);
        }
    }
    function ep(t, r, u, f, C) {
      var p = t.memoizedState;
      p === null ? t.memoizedState = {
        isBackwards: r,
        rendering: null,
        renderingStartTime: 0,
        last: f,
        tail: u,
        tailMode: C
      } : (p.isBackwards = r, p.rendering = null, p.renderingStartTime = 0, p.last = f, p.tail = u, p.tailMode = C);
    }
    function Gv(t, r, u) {
      var f = r.pendingProps, C = f.revealOrder, p = f.tail, b = f.children;
      cD(C), gD(p, C), fD(b, C), Wr(t, r, b, u);
      var T = ki.current, D = ZI(T, Ig);
      if (D)
        T = $I(T, Ig), r.flags |= Xe;
      else {
        var P = t !== null && (t.flags & Xe) !== Ue;
        P && lD(r, r.child, u), T = Gu(T);
      }
      if (ko(r, T), (r.mode & je) === Re)
        r.memoizedState = null;
      else
        switch (C) {
          case "forwards": {
            var F = uD(r.child), i1;
            F === null ? (i1 = r.child, r.child = null) : (i1 = F.sibling, F.sibling = null), ep(
              r,
              !1,
              // isBackwards
              i1,
              F,
              p
            );
            break;
          }
          case "backwards": {
            var n1 = null, A1 = r.child;
            for (r.child = null; A1 !== null; ) {
              var m1 = A1.alternate;
              if (m1 !== null && X9(m1) === null) {
                r.child = A1;
                break;
              }
              var M1 = A1.sibling;
              A1.sibling = n1, n1 = A1, A1 = M1;
            }
            ep(
              r,
              !0,
              // isBackwards
              n1,
              null,
              // last
              p
            );
            break;
          }
          case "together": {
            ep(
              r,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            r.memoizedState = null;
        }
      return r.child;
    }
    function dD(t, r, u) {
      XI(r, r.stateNode.containerInfo);
      var f = r.pendingProps;
      return t === null ? r.child = Ju(r, null, f, u) : Wr(t, r, f, u), r.child;
    }
    var qv = !1;
    function CD(t, r, u) {
      var f = r.type, C = f._context, p = r.pendingProps, b = r.memoizedProps, T = p.value;
      {
        "value" in p || qv || (qv = !0, c("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var D = r.type.propTypes;
        D && Ri(D, p, "prop", "Context.Provider");
      }
      if (_8(r, C, T), b !== null) {
        var P = b.value;
        if (Ee(P, T)) {
          if (b.children === p.children && !E9())
            return ya(t, r, u);
        } else
          cO(r, C, u);
      }
      var F = p.children;
      return Wr(t, r, F, u), r.child;
    }
    var Zv = !1;
    function AD(t, r, u) {
      var f = r.type;
      f._context === void 0 ? f !== f.Consumer && (Zv || (Zv = !0, c("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : f = f._context;
      var C = r.pendingProps, p = C.children;
      typeof p != "function" && c("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Qu(r, u);
      var b = p2(f);
      qa(r);
      var T;
      return Sg.current = r, zr(!0), T = p(b), zr(!1), vr(), r.flags |= e0, Wr(t, r, T, u), r.child;
    }
    function Tg() {
      Ni = !0;
    }
    function hC(t, r) {
      (r.mode & je) === Re && t !== null && (t.alternate = null, r.alternate = null, r.flags |= cn);
    }
    function ya(t, r, u) {
      return t !== null && (r.dependencies = t.dependencies), Mv(), Hg(r.lanes), wr(u, r.childLanes) ? (lO(t, r), r.child) : null;
    }
    function ID(t, r, u) {
      {
        var f = r.return;
        if (f === null)
          throw new Error("Cannot swap the root fiber.");
        if (t.alternate = null, r.alternate = null, u.index = r.index, u.sibling = r.sibling, u.return = r.return, u.ref = r.ref, r === f.child)
          f.child = u;
        else {
          var C = f.child;
          if (C === null)
            throw new Error("Expected parent to have a child.");
          for (; C.sibling !== r; )
            if (C = C.sibling, C === null)
              throw new Error("Expected to find the previous sibling.");
          C.sibling = u;
        }
        var p = f.deletions;
        return p === null ? (f.deletions = [t], f.flags |= Ot) : p.push(t), u.flags |= cn, u;
      }
    }
    function tp(t, r) {
      var u = t.lanes;
      return !!wr(u, r);
    }
    function pD(t, r, u) {
      switch (r.tag) {
        case x:
          Vv(r), r.stateNode, Ku();
          break;
        case O:
          q8(r);
          break;
        case m: {
          var f = r.type;
          d0(f) && T9(r);
          break;
        }
        case M:
          XI(r, r.stateNode.containerInfo);
          break;
        case Q: {
          var C = r.memoizedProps.value, p = r.type._context;
          _8(r, p, C);
          break;
        }
        case X:
          {
            var b = wr(u, r.childLanes);
            b && (r.flags |= tt);
            {
              var T = r.stateNode;
              T.effectDuration = 0, T.passiveEffectDuration = 0;
            }
          }
          break;
        case B: {
          var D = r.memoizedState;
          if (D !== null) {
            if (D.dehydrated !== null)
              return ko(r, Gu(ki.current)), r.flags |= Xe, null;
            var P = r.child, F = P.childLanes;
            if (wr(u, F))
              return Jv(t, r, u);
            ko(r, Gu(ki.current));
            var i1 = ya(t, r, u);
            return i1 !== null ? i1.sibling : null;
          } else
            ko(r, Gu(ki.current));
          break;
        }
        case f1: {
          var n1 = (t.flags & Xe) !== Ue, A1 = wr(u, r.childLanes);
          if (n1) {
            if (A1)
              return Gv(t, r, u);
            r.flags |= Xe;
          }
          var m1 = r.memoizedState;
          if (m1 !== null && (m1.rendering = null, m1.tail = null, m1.lastEffect = null), ko(r, ki.current), A1)
            break;
          return null;
        }
        case a1:
        case d1:
          return r.lanes = z1, Uv(t, r, u);
      }
      return ya(t, r, u);
    }
    function $v(t, r, u) {
      if (r._debugNeedsRemount && t !== null)
        return ID(t, r, Op(r.type, r.key, r.pendingProps, r._debugOwner || null, r.mode, r.lanes));
      if (t !== null) {
        var f = t.memoizedProps, C = r.pendingProps;
        if (f !== C || E9() || // Force a re-render if the implementation changed due to hot reload:
        r.type !== t.type)
          Ni = !0;
        else {
          var p = tp(t, u);
          if (!p && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (r.flags & Xe) === Ue)
            return Ni = !1, pD(t, r, u);
          (t.flags & hs) !== Ue ? Ni = !0 : Ni = !1;
        }
      } else if (Ni = !1, q2() && WR(r)) {
        var b = r.index, T = _R();
        M8(r, T, b);
      }
      switch (r.lanes = z1, r.tag) {
        case w:
          return ZO(t, r, r.type, u);
        case V: {
          var D = r.elementType;
          return GO(t, r, D, u);
        }
        case h: {
          var P = r.type, F = r.pendingProps, i1 = r.elementType === P ? F : zi(P, F);
          return Y5(t, r, P, i1, u);
        }
        case m: {
          var n1 = r.type, A1 = r.pendingProps, m1 = r.elementType === n1 ? A1 : zi(n1, A1);
          return _v(t, r, n1, m1, u);
        }
        case x:
          return YO(t, r, u);
        case O:
          return QO(t, r, u);
        case k:
          return XO(t, r);
        case B:
          return Jv(t, r, u);
        case M:
          return dD(t, r, u);
        case _: {
          var M1 = r.type, Ce = r.pendingProps, We = r.elementType === M1 ? Ce : zi(M1, Ce);
          return Fv(t, r, M1, We, u);
        }
        case z:
          return VO(t, r, u);
        case N:
          return KO(t, r, u);
        case X:
          return JO(t, r, u);
        case Q:
          return CD(t, r, u);
        case U:
          return AD(t, r, u);
        case Z: {
          var ze = r.type, mt = r.pendingProps, It = zi(ze, mt);
          if (r.type !== r.elementType) {
            var l1 = ze.propTypes;
            l1 && Ri(
              l1,
              It,
              // Resolved for outer only
              "prop",
              Mt(ze)
            );
          }
          return It = zi(ze.type, It), Bv(t, r, ze, It, u);
        }
        case Y:
          return Hv(t, r, r.type, r.pendingProps, u);
        case J: {
          var T1 = r.type, u1 = r.pendingProps, G1 = r.elementType === T1 ? u1 : zi(T1, u1);
          return qO(t, r, T1, G1, u);
        }
        case f1:
          return Gv(t, r, u);
        case v1:
          break;
        case a1:
          return Uv(t, r, u);
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function nc(t) {
      t.flags |= tt;
    }
    function ey(t) {
      t.flags |= Ar, t.flags |= C4;
    }
    var ty, np, ny, ry;
    ty = function(t, r, u, f) {
      for (var C = r.child; C !== null; ) {
        if (C.tag === O || C.tag === k)
          BL(t, C.stateNode);
        else if (C.tag !== M) {
          if (C.child !== null) {
            C.child.return = C, C = C.child;
            continue;
          }
        }
        if (C === r)
          return;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === r)
            return;
          C = C.return;
        }
        C.sibling.return = C.return, C = C.sibling;
      }
    }, np = function(t, r) {
    }, ny = function(t, r, u, f, C) {
      var p = t.memoizedProps;
      if (p !== f) {
        var b = r.stateNode, T = GI(), D = UL(b, u, p, f, C, T);
        r.updateQueue = D, D && nc(r);
      }
    }, ry = function(t, r, u, f) {
      u !== f && nc(r);
    };
    function Lg(t, r) {
      if (!q2())
        switch (t.tailMode) {
          case "hidden": {
            for (var u = t.tail, f = null; u !== null; )
              u.alternate !== null && (f = u), u = u.sibling;
            f === null ? t.tail = null : f.sibling = null;
            break;
          }
          case "collapsed": {
            for (var C = t.tail, p = null; C !== null; )
              C.alternate !== null && (p = C), C = C.sibling;
            p === null ? !r && t.tail !== null ? t.tail.sibling = null : t.tail = null : p.sibling = null;
            break;
          }
        }
    }
    function $2(t) {
      var r = t.alternate !== null && t.alternate.child === t.child, u = z1, f = Ue;
      if (r) {
        if ((t.mode & Ge) !== Re) {
          for (var D = t.selfBaseDuration, P = t.child; P !== null; )
            u = et(u, et(P.lanes, P.childLanes)), f |= P.subtreeFlags & w2, f |= P.flags & w2, D += P.treeBaseDuration, P = P.sibling;
          t.treeBaseDuration = D;
        } else
          for (var F = t.child; F !== null; )
            u = et(u, et(F.lanes, F.childLanes)), f |= F.subtreeFlags & w2, f |= F.flags & w2, F.return = t, F = F.sibling;
        t.subtreeFlags |= f;
      } else {
        if ((t.mode & Ge) !== Re) {
          for (var C = t.actualDuration, p = t.selfBaseDuration, b = t.child; b !== null; )
            u = et(u, et(b.lanes, b.childLanes)), f |= b.subtreeFlags, f |= b.flags, C += b.actualDuration, p += b.treeBaseDuration, b = b.sibling;
          t.actualDuration = C, t.treeBaseDuration = p;
        } else
          for (var T = t.child; T !== null; )
            u = et(u, et(T.lanes, T.childLanes)), f |= T.subtreeFlags, f |= T.flags, T.return = t, T = T.sibling;
        t.subtreeFlags |= f;
      }
      return t.childLanes = u, r;
    }
    function hD(t, r, u) {
      if (nO() && (r.mode & je) !== Re && (r.flags & Xe) === Ue)
        return j8(r), Ku(), r.flags |= Mn | Nr | d2, !1;
      var f = k9(r);
      if (u !== null && u.dehydrated !== null)
        if (t === null) {
          if (!f)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (eO(r), $2(r), (r.mode & Ge) !== Re) {
            var C = u !== null;
            if (C) {
              var p = r.child;
              p !== null && (r.treeBaseDuration -= p.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Ku(), (r.flags & Xe) === Ue && (r.memoizedState = null), r.flags |= tt, $2(r), (r.mode & Ge) !== Re) {
            var b = u !== null;
            if (b) {
              var T = r.child;
              T !== null && (r.treeBaseDuration -= T.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return z8(), !0;
    }
    function iy(t, r, u) {
      var f = r.pendingProps;
      switch (TI(r), r.tag) {
        case w:
        case V:
        case Y:
        case h:
        case _:
        case z:
        case N:
        case X:
        case U:
        case Z:
          return $2(r), null;
        case m: {
          var C = r.type;
          return d0(C) && M9(r), $2(r), null;
        }
        case x: {
          var p = r.stateNode;
          if (Xu(r), xI(r), t5(), p.pendingContext && (p.context = p.pendingContext, p.pendingContext = null), t === null || t.child === null) {
            var b = k9(r);
            if (b)
              nc(r);
            else if (t !== null) {
              var T = t.memoizedState;
              // Check if this is a client root
              (!T.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (r.flags & Mn) !== Ue) && (r.flags |= t3, z8());
            }
          }
          return np(t, r), $2(r), null;
        }
        case O: {
          qI(r);
          var D = G8(), P = r.type;
          if (t !== null && r.stateNode != null)
            ny(t, r, P, f, D), t.ref !== r.ref && ey(r);
          else {
            if (!f) {
              if (r.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return $2(r), null;
            }
            var F = GI(), i1 = k9(r);
            if (i1)
              ZR(r, D, F) && nc(r);
            else {
              var n1 = FL(P, f, D, F, r);
              ty(n1, r, !1, !1), r.stateNode = n1, HL(n1, P, f, D) && nc(r);
            }
            r.ref !== null && ey(r);
          }
          return $2(r), null;
        }
        case k: {
          var A1 = f;
          if (t && r.stateNode != null) {
            var m1 = t.memoizedProps;
            ry(t, r, m1, A1);
          } else {
            if (typeof A1 != "string" && r.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var M1 = G8(), Ce = GI(), We = k9(r);
            We ? $R(r) && nc(r) : r.stateNode = WL(A1, M1, Ce, r);
          }
          return $2(r), null;
        }
        case B: {
          qu(r);
          var ze = r.memoizedState;
          if (t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
            var mt = hD(t, r, ze);
            if (!mt)
              return r.flags & d2 ? r : null;
          }
          if ((r.flags & Xe) !== Ue)
            return r.lanes = u, (r.mode & Ge) !== Re && E5(r), r;
          var It = ze !== null, l1 = t !== null && t.memoizedState !== null;
          if (It !== l1 && It) {
            var T1 = r.child;
            if (T1.flags |= t0, (r.mode & je) !== Re) {
              var u1 = t === null && (r.memoizedProps.unstable_avoidThisFallback !== !0 || !C1);
              u1 || ZI(ki.current, $8) ? mk() : vp();
            }
          }
          var G1 = r.updateQueue;
          if (G1 !== null && (r.flags |= tt), $2(r), (r.mode & Ge) !== Re && It) {
            var ve = r.child;
            ve !== null && (r.treeBaseDuration -= ve.treeBaseDuration);
          }
          return null;
        }
        case M:
          return Xu(r), np(t, r), t === null && zR(r.stateNode.containerInfo), $2(r), null;
        case Q:
          var Ie = r.type._context;
          return WI(Ie, r), $2(r), null;
        case J: {
          var Ye = r.type;
          return d0(Ye) && M9(r), $2(r), null;
        }
        case f1: {
          qu(r);
          var $e = r.memoizedState;
          if ($e === null)
            return $2(r), null;
          var Gt = (r.flags & Xe) !== Ue, Lt = $e.rendering;
          if (Lt === null)
            if (Gt)
              Lg($e, !1);
            else {
              var i2 = yk() && (t === null || (t.flags & Xe) === Ue);
              if (!i2)
                for (var Rt = r.child; Rt !== null; ) {
                  var Kn = X9(Rt);
                  if (Kn !== null) {
                    Gt = !0, r.flags |= Xe, Lg($e, !1);
                    var Tr = Kn.updateQueue;
                    return Tr !== null && (r.updateQueue = Tr, r.flags |= tt), r.subtreeFlags = Ue, uO(r, u), ko(r, $I(ki.current, Ig)), r.child;
                  }
                  Rt = Rt.sibling;
                }
              $e.tail !== null && bn() > Sy() && (r.flags |= Xe, Gt = !0, Lg($e, !1), r.lanes = Dd);
            }
          else {
            if (!Gt) {
              var ir = X9(Lt);
              if (ir !== null) {
                r.flags |= Xe, Gt = !0;
                var L3 = ir.updateQueue;
                if (L3 !== null && (r.updateQueue = L3, r.flags |= tt), Lg($e, !0), $e.tail === null && $e.tailMode === "hidden" && !Lt.alternate && !q2())
                  return $2(r), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              bn() * 2 - $e.renderingStartTime > Sy() && u !== U2 && (r.flags |= Xe, Gt = !0, Lg($e, !1), r.lanes = Dd);
            }
            if ($e.isBackwards)
              Lt.sibling = r.child, r.child = Lt;
            else {
              var Kr = $e.last;
              Kr !== null ? Kr.sibling = Lt : r.child = Lt, $e.last = Lt;
            }
          }
          if ($e.tail !== null) {
            var Jr = $e.tail;
            $e.rendering = Jr, $e.tail = Jr.sibling, $e.renderingStartTime = bn(), Jr.sibling = null;
            var Lr = ki.current;
            return Gt ? Lr = $I(Lr, Ig) : Lr = Gu(Lr), ko(r, Lr), Jr;
          }
          return $2(r), null;
        }
        case v1:
          break;
        case a1:
        case d1: {
          mp(r);
          var Ea = r.memoizedState, cc = Ea !== null;
          if (t !== null) {
            var Kg = t.memoizedState, y0 = Kg !== null;
            y0 !== cc && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !t1 && (r.flags |= t0);
          }
          return !cc || (r.mode & je) === Re ? $2(r) : wr(v0, U2) && ($2(r), r.subtreeFlags & (cn | tt) && (r.flags |= t0)), null;
        }
        case S1:
          return null;
        case h1:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + r.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function mD(t, r, u) {
      switch (TI(r), r.tag) {
        case m: {
          var f = r.type;
          d0(f) && M9(r);
          var C = r.flags;
          return C & d2 ? (r.flags = C & ~d2 | Xe, (r.mode & Ge) !== Re && E5(r), r) : null;
        }
        case x: {
          r.stateNode, Xu(r), xI(r), t5();
          var p = r.flags;
          return (p & d2) !== Ue && (p & Xe) === Ue ? (r.flags = p & ~d2 | Xe, r) : null;
        }
        case O:
          return qI(r), null;
        case B: {
          qu(r);
          var b = r.memoizedState;
          if (b !== null && b.dehydrated !== null) {
            if (r.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Ku();
          }
          var T = r.flags;
          return T & d2 ? (r.flags = T & ~d2 | Xe, (r.mode & Ge) !== Re && E5(r), r) : null;
        }
        case f1:
          return qu(r), null;
        case M:
          return Xu(r), null;
        case Q:
          var D = r.type._context;
          return WI(D, r), null;
        case a1:
        case d1:
          return mp(r), null;
        case S1:
          return null;
        default:
          return null;
      }
    }
    function ay(t, r, u) {
      switch (TI(r), r.tag) {
        case m: {
          var f = r.type.childContextTypes;
          f != null && M9(r);
          break;
        }
        case x: {
          r.stateNode, Xu(r), xI(r), t5();
          break;
        }
        case O: {
          qI(r);
          break;
        }
        case M:
          Xu(r);
          break;
        case B:
          qu(r);
          break;
        case f1:
          qu(r);
          break;
        case Q:
          var C = r.type._context;
          WI(C, r);
          break;
        case a1:
        case d1:
          mp(r);
          break;
      }
    }
    var oy = null;
    oy = /* @__PURE__ */ new Set();
    var mC = !1, er = !1, vD = typeof WeakSet == "function" ? WeakSet : Set, Me = null, rc = null, ic = null;
    function yD(t) {
      q0(null, function() {
        throw t;
      }), f4();
    }
    var bD = function(t, r) {
      if (r.props = t.memoizedProps, r.state = t.memoizedState, t.mode & Ge)
        try {
          h0(), r.componentWillUnmount();
        } finally {
          p0(t);
        }
      else
        r.componentWillUnmount();
    };
    function sy(t, r) {
      try {
        No(M2, t);
      } catch (u) {
        dn(t, r, u);
      }
    }
    function rp(t, r, u) {
      try {
        bD(t, u);
      } catch (f) {
        dn(t, r, f);
      }
    }
    function wD(t, r, u) {
      try {
        u.componentDidMount();
      } catch (f) {
        dn(t, r, f);
      }
    }
    function ly(t, r) {
      try {
        cy(t);
      } catch (u) {
        dn(t, r, u);
      }
    }
    function ac(t, r) {
      var u = t.ref;
      if (u !== null)
        if (typeof u == "function") {
          var f;
          try {
            if (B1 && te && t.mode & Ge)
              try {
                h0(), f = u(null);
              } finally {
                p0(t);
              }
            else
              f = u(null);
          } catch (C) {
            dn(t, r, C);
          }
          typeof f == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Fe(t));
        } else
          u.current = null;
    }
    function vC(t, r, u) {
      try {
        u();
      } catch (f) {
        dn(t, r, f);
      }
    }
    var uy = !1;
    function xD(t, r) {
      NL(t.containerInfo), Me = r, SD();
      var u = uy;
      return uy = !1, u;
    }
    function SD() {
      for (; Me !== null; ) {
        var t = Me, r = t.child;
        (t.subtreeFlags & Qa) !== Ue && r !== null ? (r.return = t, Me = r) : ED();
      }
    }
    function ED() {
      for (; Me !== null; ) {
        var t = Me;
        Nt(t);
        try {
          MD(t);
        } catch (u) {
          dn(t, t.return, u);
        }
        jn();
        var r = t.sibling;
        if (r !== null) {
          r.return = t.return, Me = r;
          return;
        }
        Me = t.return;
      }
    }
    function MD(t) {
      var r = t.alternate, u = t.flags;
      if ((u & t3) !== Ue) {
        switch (Nt(t), t.tag) {
          case h:
          case _:
          case Y:
            break;
          case m: {
            if (r !== null) {
              var f = r.memoizedProps, C = r.memoizedState, p = t.stateNode;
              t.type === t.elementType && !$s && (p.props !== t.memoizedProps && c("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Fe(t) || "instance"), p.state !== t.memoizedState && c("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Fe(t) || "instance"));
              var b = p.getSnapshotBeforeUpdate(t.elementType === t.type ? f : zi(t.type, f), C);
              {
                var T = oy;
                b === void 0 && !T.has(t.type) && (T.add(t.type), c("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Fe(t)));
              }
              p.__reactInternalSnapshotBeforeUpdate = b;
            }
            break;
          }
          case x: {
            {
              var D = t.stateNode;
              sR(D.containerInfo);
            }
            break;
          }
          case O:
          case k:
          case M:
          case J:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        jn();
      }
    }
    function Pi(t, r, u) {
      var f = r.updateQueue, C = f !== null ? f.lastEffect : null;
      if (C !== null) {
        var p = C.next, b = p;
        do {
          if ((b.tag & t) === t) {
            var T = b.destroy;
            b.destroy = void 0, T !== void 0 && ((t & Z2) !== A3 ? Ld(r) : (t & M2) !== A3 && E3(r), (t & C0) !== A3 && Wg(!0), vC(r, u, T), (t & C0) !== A3 && Wg(!1), (t & Z2) !== A3 ? Kl() : (t & M2) !== A3 && Za());
          }
          b = b.next;
        } while (b !== p);
      }
    }
    function No(t, r) {
      var u = r.updateQueue, f = u !== null ? u.lastEffect : null;
      if (f !== null) {
        var C = f.next, p = C;
        do {
          if ((p.tag & t) === t) {
            (t & Z2) !== A3 ? i0(r) : (t & M2) !== A3 && Rd(r);
            var b = p.create;
            (t & C0) !== A3 && Wg(!0), p.destroy = b(), (t & C0) !== A3 && Wg(!1), (t & Z2) !== A3 ? Vl() : (t & M2) !== A3 && ms();
            {
              var T = p.destroy;
              if (T !== void 0 && typeof T != "function") {
                var D = void 0;
                (p.tag & M2) !== Ue ? D = "useLayoutEffect" : (p.tag & C0) !== Ue ? D = "useInsertionEffect" : D = "useEffect";
                var P = void 0;
                T === null ? P = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof T.then == "function" ? P = `

It looks like you wrote ` + D + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + D + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : P = " You returned: " + T, c("%s must not return anything besides a function, which is used for clean-up.%s", D, P);
              }
            }
          }
          p = p.next;
        } while (p !== C);
      }
    }
    function TD(t, r) {
      if ((r.flags & tt) !== Ue)
        switch (r.tag) {
          case X: {
            var u = r.stateNode.passiveEffectDuration, f = r.memoizedProps, C = f.id, p = f.onPostCommit, b = Sv(), T = r.alternate === null ? "mount" : "update";
            xv() && (T = "nested-update"), typeof p == "function" && p(C, T, u, b);
            var D = r.return;
            e: for (; D !== null; ) {
              switch (D.tag) {
                case x:
                  var P = D.stateNode;
                  P.passiveEffectDuration += u;
                  break e;
                case X:
                  var F = D.stateNode;
                  F.passiveEffectDuration += u;
                  break e;
              }
              D = D.return;
            }
            break;
          }
        }
    }
    function LD(t, r, u, f) {
      if ((u.flags & B2) !== Ue)
        switch (u.tag) {
          case h:
          case _:
          case Y: {
            if (!er)
              if (u.mode & Ge)
                try {
                  h0(), No(M2 | E2, u);
                } finally {
                  p0(u);
                }
              else
                No(M2 | E2, u);
            break;
          }
          case m: {
            var C = u.stateNode;
            if (u.flags & tt && !er)
              if (r === null)
                if (u.type === u.elementType && !$s && (C.props !== u.memoizedProps && c("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Fe(u) || "instance"), C.state !== u.memoizedState && c("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Fe(u) || "instance")), u.mode & Ge)
                  try {
                    h0(), C.componentDidMount();
                  } finally {
                    p0(u);
                  }
                else
                  C.componentDidMount();
              else {
                var p = u.elementType === u.type ? r.memoizedProps : zi(u.type, r.memoizedProps), b = r.memoizedState;
                if (u.type === u.elementType && !$s && (C.props !== u.memoizedProps && c("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Fe(u) || "instance"), C.state !== u.memoizedState && c("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Fe(u) || "instance")), u.mode & Ge)
                  try {
                    h0(), C.componentDidUpdate(p, b, C.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    p0(u);
                  }
                else
                  C.componentDidUpdate(p, b, C.__reactInternalSnapshotBeforeUpdate);
              }
            var T = u.updateQueue;
            T !== null && (u.type === u.elementType && !$s && (C.props !== u.memoizedProps && c("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Fe(u) || "instance"), C.state !== u.memoizedState && c("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Fe(u) || "instance")), X8(u, T, C));
            break;
          }
          case x: {
            var D = u.updateQueue;
            if (D !== null) {
              var P = null;
              if (u.child !== null)
                switch (u.child.tag) {
                  case O:
                    P = u.child.stateNode;
                    break;
                  case m:
                    P = u.child.stateNode;
                    break;
                }
              X8(u, D, P);
            }
            break;
          }
          case O: {
            var F = u.stateNode;
            if (r === null && u.flags & tt) {
              var i1 = u.type, n1 = u.memoizedProps;
              YL(F, i1, n1);
            }
            break;
          }
          case k:
            break;
          case M:
            break;
          case X: {
            {
              var A1 = u.memoizedProps, m1 = A1.onCommit, M1 = A1.onRender, Ce = u.stateNode.effectDuration, We = Sv(), ze = r === null ? "mount" : "update";
              xv() && (ze = "nested-update"), typeof M1 == "function" && M1(u.memoizedProps.id, ze, u.actualDuration, u.treeBaseDuration, u.actualStartTime, We);
              {
                typeof m1 == "function" && m1(u.memoizedProps.id, ze, Ce, We), Ek(u);
                var mt = u.return;
                e: for (; mt !== null; ) {
                  switch (mt.tag) {
                    case x:
                      var It = mt.stateNode;
                      It.effectDuration += Ce;
                      break e;
                    case X:
                      var l1 = mt.stateNode;
                      l1.effectDuration += Ce;
                      break e;
                  }
                  mt = mt.return;
                }
              }
            }
            break;
          }
          case B: {
            PD(t, u);
            break;
          }
          case f1:
          case J:
          case v1:
          case a1:
          case d1:
          case h1:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      er || u.flags & Ar && cy(u);
    }
    function RD(t) {
      switch (t.tag) {
        case h:
        case _:
        case Y: {
          if (t.mode & Ge)
            try {
              h0(), sy(t, t.return);
            } finally {
              p0(t);
            }
          else
            sy(t, t.return);
          break;
        }
        case m: {
          var r = t.stateNode;
          typeof r.componentDidMount == "function" && wD(t, t.return, r), ly(t, t.return);
          break;
        }
        case O: {
          ly(t, t.return);
          break;
        }
      }
    }
    function OD(t, r) {
      for (var u = null, f = t; ; ) {
        if (f.tag === O) {
          if (u === null) {
            u = f;
            try {
              var C = f.stateNode;
              r ? rR(C) : aR(f.stateNode, f.memoizedProps);
            } catch (b) {
              dn(t, t.return, b);
            }
          }
        } else if (f.tag === k) {
          if (u === null)
            try {
              var p = f.stateNode;
              r ? iR(p) : oR(p, f.memoizedProps);
            } catch (b) {
              dn(t, t.return, b);
            }
        } else if (!((f.tag === a1 || f.tag === d1) && f.memoizedState !== null && f !== t)) {
          if (f.child !== null) {
            f.child.return = f, f = f.child;
            continue;
          }
        }
        if (f === t)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === t)
            return;
          u === f && (u = null), f = f.return;
        }
        u === f && (u = null), f.sibling.return = f.return, f = f.sibling;
      }
    }
    function cy(t) {
      var r = t.ref;
      if (r !== null) {
        var u = t.stateNode, f;
        switch (t.tag) {
          case O:
            f = u;
            break;
          default:
            f = u;
        }
        if (typeof r == "function") {
          var C;
          if (t.mode & Ge)
            try {
              h0(), C = r(f);
            } finally {
              p0(t);
            }
          else
            C = r(f);
          typeof C == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Fe(t));
        } else
          r.hasOwnProperty("current") || c("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Fe(t)), r.current = f;
      }
    }
    function DD(t) {
      var r = t.alternate;
      r !== null && (r.return = null), t.return = null;
    }
    function gy(t) {
      var r = t.alternate;
      r !== null && (t.alternate = null, gy(r));
      {
        if (t.child = null, t.deletions = null, t.sibling = null, t.tag === O) {
          var u = t.stateNode;
          u !== null && FR(u);
        }
        t.stateNode = null, t._debugOwner = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
      }
    }
    function kD(t) {
      for (var r = t.return; r !== null; ) {
        if (fy(r))
          return r;
        r = r.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function fy(t) {
      return t.tag === O || t.tag === x || t.tag === M;
    }
    function dy(t) {
      var r = t;
      e: for (; ; ) {
        for (; r.sibling === null; ) {
          if (r.return === null || fy(r.return))
            return null;
          r = r.return;
        }
        for (r.sibling.return = r.return, r = r.sibling; r.tag !== O && r.tag !== k && r.tag !== e1; ) {
          if (r.flags & cn || r.child === null || r.tag === M)
            continue e;
          r.child.return = r, r = r.child;
        }
        if (!(r.flags & cn))
          return r.stateNode;
      }
    }
    function jD(t) {
      var r = kD(t);
      switch (r.tag) {
        case O: {
          var u = r.stateNode;
          r.flags & Pt && (A8(u), r.flags &= ~Pt);
          var f = dy(t);
          ap(t, f, u);
          break;
        }
        case x:
        case M: {
          var C = r.stateNode.containerInfo, p = dy(t);
          ip(t, p, C);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function ip(t, r, u) {
      var f = t.tag, C = f === O || f === k;
      if (C) {
        var p = t.stateNode;
        r ? $L(u, p, r) : qL(u, p);
      } else if (f !== M) {
        var b = t.child;
        if (b !== null) {
          ip(b, r, u);
          for (var T = b.sibling; T !== null; )
            ip(T, r, u), T = T.sibling;
        }
      }
    }
    function ap(t, r, u) {
      var f = t.tag, C = f === O || f === k;
      if (C) {
        var p = t.stateNode;
        r ? ZL(u, p, r) : GL(u, p);
      } else if (f !== M) {
        var b = t.child;
        if (b !== null) {
          ap(b, r, u);
          for (var T = b.sibling; T !== null; )
            ap(T, r, u), T = T.sibling;
        }
      }
    }
    var tr = null, Fi = !1;
    function zD(t, r, u) {
      {
        var f = r;
        e: for (; f !== null; ) {
          switch (f.tag) {
            case O: {
              tr = f.stateNode, Fi = !1;
              break e;
            }
            case x: {
              tr = f.stateNode.containerInfo, Fi = !0;
              break e;
            }
            case M: {
              tr = f.stateNode.containerInfo, Fi = !0;
              break e;
            }
          }
          f = f.return;
        }
        if (tr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        Cy(t, r, u), tr = null, Fi = !1;
      }
      DD(u);
    }
    function Po(t, r, u) {
      for (var f = u.child; f !== null; )
        Cy(t, r, f), f = f.sibling;
    }
    function Cy(t, r, u) {
      switch (ea(u), u.tag) {
        case O:
          er || ac(u, r);
        case k: {
          {
            var f = tr, C = Fi;
            tr = null, Po(t, r, u), tr = f, Fi = C, tr !== null && (Fi ? tR(tr, u.stateNode) : eR(tr, u.stateNode));
          }
          return;
        }
        case e1: {
          tr !== null && (Fi ? nR(tr, u.stateNode) : II(tr, u.stateNode));
          return;
        }
        case M: {
          {
            var p = tr, b = Fi;
            tr = u.stateNode.containerInfo, Fi = !0, Po(t, r, u), tr = p, Fi = b;
          }
          return;
        }
        case h:
        case _:
        case Z:
        case Y: {
          if (!er) {
            var T = u.updateQueue;
            if (T !== null) {
              var D = T.lastEffect;
              if (D !== null) {
                var P = D.next, F = P;
                do {
                  var i1 = F, n1 = i1.destroy, A1 = i1.tag;
                  n1 !== void 0 && ((A1 & C0) !== A3 ? vC(u, r, n1) : (A1 & M2) !== A3 && (E3(u), u.mode & Ge ? (h0(), vC(u, r, n1), p0(u)) : vC(u, r, n1), Za())), F = F.next;
                } while (F !== P);
              }
            }
          }
          Po(t, r, u);
          return;
        }
        case m: {
          if (!er) {
            ac(u, r);
            var m1 = u.stateNode;
            typeof m1.componentWillUnmount == "function" && rp(u, r, m1);
          }
          Po(t, r, u);
          return;
        }
        case v1: {
          Po(t, r, u);
          return;
        }
        case a1: {
          if (
            // TODO: Remove this dead flag
            u.mode & je
          ) {
            var M1 = er;
            er = M1 || u.memoizedState !== null, Po(t, r, u), er = M1;
          } else
            Po(t, r, u);
          break;
        }
        default: {
          Po(t, r, u);
          return;
        }
      }
    }
    function ND(t) {
      t.memoizedState;
    }
    function PD(t, r) {
      var u = r.memoizedState;
      if (u === null) {
        var f = r.alternate;
        if (f !== null) {
          var C = f.memoizedState;
          if (C !== null) {
            var p = C.dehydrated;
            p !== null && yR(p);
          }
        }
      }
    }
    function Ay(t) {
      var r = t.updateQueue;
      if (r !== null) {
        t.updateQueue = null;
        var u = t.stateNode;
        u === null && (u = t.stateNode = new vD()), r.forEach(function(f) {
          var C = kk.bind(null, t, f);
          if (!u.has(f)) {
            if (u.add(f), Br)
              if (rc !== null && ic !== null)
                Ug(ic, rc);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            f.then(C, C);
          }
        });
      }
    }
    function FD(t, r, u) {
      rc = u, ic = t, Nt(r), Iy(r, t), Nt(r), rc = null, ic = null;
    }
    function Bi(t, r, u) {
      var f = r.deletions;
      if (f !== null)
        for (var C = 0; C < f.length; C++) {
          var p = f[C];
          try {
            zD(t, r, p);
          } catch (D) {
            dn(p, r, D);
          }
        }
      var b = _c();
      if (r.subtreeFlags & hr)
        for (var T = r.child; T !== null; )
          Nt(T), Iy(T, t), T = T.sibling;
      Nt(b);
    }
    function Iy(t, r, u) {
      var f = t.alternate, C = t.flags;
      switch (t.tag) {
        case h:
        case _:
        case Z:
        case Y: {
          if (Bi(r, t), m0(t), C & tt) {
            try {
              Pi(C0 | E2, t, t.return), No(C0 | E2, t);
            } catch (Ye) {
              dn(t, t.return, Ye);
            }
            if (t.mode & Ge) {
              try {
                h0(), Pi(M2 | E2, t, t.return);
              } catch (Ye) {
                dn(t, t.return, Ye);
              }
              p0(t);
            } else
              try {
                Pi(M2 | E2, t, t.return);
              } catch (Ye) {
                dn(t, t.return, Ye);
              }
          }
          return;
        }
        case m: {
          Bi(r, t), m0(t), C & Ar && f !== null && ac(f, f.return);
          return;
        }
        case O: {
          Bi(r, t), m0(t), C & Ar && f !== null && ac(f, f.return);
          {
            if (t.flags & Pt) {
              var p = t.stateNode;
              try {
                A8(p);
              } catch (Ye) {
                dn(t, t.return, Ye);
              }
            }
            if (C & tt) {
              var b = t.stateNode;
              if (b != null) {
                var T = t.memoizedProps, D = f !== null ? f.memoizedProps : T, P = t.type, F = t.updateQueue;
                if (t.updateQueue = null, F !== null)
                  try {
                    QL(b, F, P, D, T, t);
                  } catch (Ye) {
                    dn(t, t.return, Ye);
                  }
              }
            }
          }
          return;
        }
        case k: {
          if (Bi(r, t), m0(t), C & tt) {
            if (t.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var i1 = t.stateNode, n1 = t.memoizedProps, A1 = f !== null ? f.memoizedProps : n1;
            try {
              XL(i1, A1, n1);
            } catch (Ye) {
              dn(t, t.return, Ye);
            }
          }
          return;
        }
        case x: {
          if (Bi(r, t), m0(t), C & tt && f !== null) {
            var m1 = f.memoizedState;
            if (m1.isDehydrated)
              try {
                vR(r.containerInfo);
              } catch (Ye) {
                dn(t, t.return, Ye);
              }
          }
          return;
        }
        case M: {
          Bi(r, t), m0(t);
          return;
        }
        case B: {
          Bi(r, t), m0(t);
          var M1 = t.child;
          if (M1.flags & t0) {
            var Ce = M1.stateNode, We = M1.memoizedState, ze = We !== null;
            if (Ce.isHidden = ze, ze) {
              var mt = M1.alternate !== null && M1.alternate.memoizedState !== null;
              mt || hk();
            }
          }
          if (C & tt) {
            try {
              ND(t);
            } catch (Ye) {
              dn(t, t.return, Ye);
            }
            Ay(t);
          }
          return;
        }
        case a1: {
          var It = f !== null && f.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            t.mode & je
          ) {
            var l1 = er;
            er = l1 || It, Bi(r, t), er = l1;
          } else
            Bi(r, t);
          if (m0(t), C & t0) {
            var T1 = t.stateNode, u1 = t.memoizedState, G1 = u1 !== null, ve = t;
            if (T1.isHidden = G1, G1 && !It && (ve.mode & je) !== Re) {
              Me = ve;
              for (var Ie = ve.child; Ie !== null; )
                Me = Ie, HD(Ie), Ie = Ie.sibling;
            }
            OD(ve, G1);
          }
          return;
        }
        case f1: {
          Bi(r, t), m0(t), C & tt && Ay(t);
          return;
        }
        case v1:
          return;
        default: {
          Bi(r, t), m0(t);
          return;
        }
      }
    }
    function m0(t) {
      var r = t.flags;
      if (r & cn) {
        try {
          jD(t);
        } catch (u) {
          dn(t, t.return, u);
        }
        t.flags &= ~cn;
      }
      r & n3 && (t.flags &= ~n3);
    }
    function BD(t, r, u) {
      rc = u, ic = r, Me = t, py(t, r, u), rc = null, ic = null;
    }
    function py(t, r, u) {
      for (var f = (t.mode & je) !== Re; Me !== null; ) {
        var C = Me, p = C.child;
        if (C.tag === a1 && f) {
          var b = C.memoizedState !== null, T = b || mC;
          if (T) {
            op(t, r, u);
            continue;
          } else {
            var D = C.alternate, P = D !== null && D.memoizedState !== null, F = P || er, i1 = mC, n1 = er;
            mC = T, er = F, er && !n1 && (Me = C, UD(C));
            for (var A1 = p; A1 !== null; )
              Me = A1, py(
                A1,
                // New root; bubble back up to here and stop.
                r,
                u
              ), A1 = A1.sibling;
            Me = C, mC = i1, er = n1, op(t, r, u);
            continue;
          }
        }
        (C.subtreeFlags & B2) !== Ue && p !== null ? (p.return = C, Me = p) : op(t, r, u);
      }
    }
    function op(t, r, u) {
      for (; Me !== null; ) {
        var f = Me;
        if ((f.flags & B2) !== Ue) {
          var C = f.alternate;
          Nt(f);
          try {
            LD(r, C, f, u);
          } catch (b) {
            dn(f, f.return, b);
          }
          jn();
        }
        if (f === t) {
          Me = null;
          return;
        }
        var p = f.sibling;
        if (p !== null) {
          p.return = f.return, Me = p;
          return;
        }
        Me = f.return;
      }
    }
    function HD(t) {
      for (; Me !== null; ) {
        var r = Me, u = r.child;
        switch (r.tag) {
          case h:
          case _:
          case Z:
          case Y: {
            if (r.mode & Ge)
              try {
                h0(), Pi(M2, r, r.return);
              } finally {
                p0(r);
              }
            else
              Pi(M2, r, r.return);
            break;
          }
          case m: {
            ac(r, r.return);
            var f = r.stateNode;
            typeof f.componentWillUnmount == "function" && rp(r, r.return, f);
            break;
          }
          case O: {
            ac(r, r.return);
            break;
          }
          case a1: {
            var C = r.memoizedState !== null;
            if (C) {
              hy(t);
              continue;
            }
            break;
          }
        }
        u !== null ? (u.return = r, Me = u) : hy(t);
      }
    }
    function hy(t) {
      for (; Me !== null; ) {
        var r = Me;
        if (r === t) {
          Me = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, Me = u;
          return;
        }
        Me = r.return;
      }
    }
    function UD(t) {
      for (; Me !== null; ) {
        var r = Me, u = r.child;
        if (r.tag === a1) {
          var f = r.memoizedState !== null;
          if (f) {
            my(t);
            continue;
          }
        }
        u !== null ? (u.return = r, Me = u) : my(t);
      }
    }
    function my(t) {
      for (; Me !== null; ) {
        var r = Me;
        Nt(r);
        try {
          RD(r);
        } catch (f) {
          dn(r, r.return, f);
        }
        if (jn(), r === t) {
          Me = null;
          return;
        }
        var u = r.sibling;
        if (u !== null) {
          u.return = r.return, Me = u;
          return;
        }
        Me = r.return;
      }
    }
    function WD(t, r, u, f) {
      Me = r, _D(r, t, u, f);
    }
    function _D(t, r, u, f) {
      for (; Me !== null; ) {
        var C = Me, p = C.child;
        (C.subtreeFlags & r3) !== Ue && p !== null ? (p.return = C, Me = p) : VD(t, r, u, f);
      }
    }
    function VD(t, r, u, f) {
      for (; Me !== null; ) {
        var C = Me;
        if ((C.flags & pn) !== Ue) {
          Nt(C);
          try {
            KD(r, C, u, f);
          } catch (b) {
            dn(C, C.return, b);
          }
          jn();
        }
        if (C === t) {
          Me = null;
          return;
        }
        var p = C.sibling;
        if (p !== null) {
          p.return = C.return, Me = p;
          return;
        }
        Me = C.return;
      }
    }
    function KD(t, r, u, f) {
      switch (r.tag) {
        case h:
        case _:
        case Y: {
          if (r.mode & Ge) {
            S5();
            try {
              No(Z2 | E2, r);
            } finally {
              x5(r);
            }
          } else
            No(Z2 | E2, r);
          break;
        }
      }
    }
    function JD(t) {
      Me = t, YD();
    }
    function YD() {
      for (; Me !== null; ) {
        var t = Me, r = t.child;
        if ((Me.flags & Ot) !== Ue) {
          var u = t.deletions;
          if (u !== null) {
            for (var f = 0; f < u.length; f++) {
              var C = u[f];
              Me = C, GD(C, t);
            }
            {
              var p = t.alternate;
              if (p !== null) {
                var b = p.child;
                if (b !== null) {
                  p.child = null;
                  do {
                    var T = b.sibling;
                    b.sibling = null, b = T;
                  } while (b !== null);
                }
              }
            }
            Me = t;
          }
        }
        (t.subtreeFlags & r3) !== Ue && r !== null ? (r.return = t, Me = r) : QD();
      }
    }
    function QD() {
      for (; Me !== null; ) {
        var t = Me;
        (t.flags & pn) !== Ue && (Nt(t), XD(t), jn());
        var r = t.sibling;
        if (r !== null) {
          r.return = t.return, Me = r;
          return;
        }
        Me = t.return;
      }
    }
    function XD(t) {
      switch (t.tag) {
        case h:
        case _:
        case Y: {
          t.mode & Ge ? (S5(), Pi(Z2 | E2, t, t.return), x5(t)) : Pi(Z2 | E2, t, t.return);
          break;
        }
      }
    }
    function GD(t, r) {
      for (; Me !== null; ) {
        var u = Me;
        Nt(u), ZD(u, r), jn();
        var f = u.child;
        f !== null ? (f.return = u, Me = f) : qD(t);
      }
    }
    function qD(t) {
      for (; Me !== null; ) {
        var r = Me, u = r.sibling, f = r.return;
        if (gy(r), r === t) {
          Me = null;
          return;
        }
        if (u !== null) {
          u.return = f, Me = u;
          return;
        }
        Me = f;
      }
    }
    function ZD(t, r) {
      switch (t.tag) {
        case h:
        case _:
        case Y: {
          t.mode & Ge ? (S5(), Pi(Z2, t, r), x5(t)) : Pi(Z2, t, r);
          break;
        }
      }
    }
    function $D(t) {
      switch (t.tag) {
        case h:
        case _:
        case Y: {
          try {
            No(M2 | E2, t);
          } catch (u) {
            dn(t, t.return, u);
          }
          break;
        }
        case m: {
          var r = t.stateNode;
          try {
            r.componentDidMount();
          } catch (u) {
            dn(t, t.return, u);
          }
          break;
        }
      }
    }
    function ek(t) {
      switch (t.tag) {
        case h:
        case _:
        case Y: {
          try {
            No(Z2 | E2, t);
          } catch (r) {
            dn(t, t.return, r);
          }
          break;
        }
      }
    }
    function tk(t) {
      switch (t.tag) {
        case h:
        case _:
        case Y: {
          try {
            Pi(M2 | E2, t, t.return);
          } catch (u) {
            dn(t, t.return, u);
          }
          break;
        }
        case m: {
          var r = t.stateNode;
          typeof r.componentWillUnmount == "function" && rp(t, t.return, r);
          break;
        }
      }
    }
    function nk(t) {
      switch (t.tag) {
        case h:
        case _:
        case Y:
          try {
            Pi(Z2 | E2, t, t.return);
          } catch (r) {
            dn(t, t.return, r);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var Rg = Symbol.for;
      Rg("selector.component"), Rg("selector.has_pseudo_class"), Rg("selector.role"), Rg("selector.test_id"), Rg("selector.text");
    }
    var rk = [];
    function ik() {
      rk.forEach(function(t) {
        return t();
      });
    }
    var ak = i.ReactCurrentActQueue;
    function ok(t) {
      {
        var r = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), u = typeof jest < "u";
        return u && r !== !1;
      }
    }
    function vy() {
      {
        var t = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !t && ak.current !== null && c("The current testing environment is not configured to support act(...)"), t;
      }
    }
    var sk = Math.ceil, sp = i.ReactCurrentDispatcher, lp = i.ReactCurrentOwner, nr = i.ReactCurrentBatchConfig, Hi = i.ReactCurrentActQueue, R2 = (
      /*             */
      0
    ), yy = (
      /*               */
      1
    ), rr = (
      /*                */
      2
    ), ei = (
      /*                */
      4
    ), ba = 0, Og = 1, el = 2, yC = 3, Dg = 4, by = 5, up = 6, ht = R2, _r = null, Fn = null, O2 = z1, v0 = z1, cp = Mo(z1), D2 = ba, kg = null, bC = z1, jg = z1, wC = z1, zg = null, I3 = null, gp = 0, wy = 500, xy = 1 / 0, lk = 500, wa = null;
    function Ng() {
      xy = bn() + lk;
    }
    function Sy() {
      return xy;
    }
    var xC = !1, fp = null, oc = null, tl = !1, Fo = null, Pg = z1, dp = [], Cp = null, uk = 50, Fg = 0, Ap = null, Ip = !1, SC = !1, ck = 50, sc = 0, EC = null, Bg = un, MC = z1, Ey = !1;
    function TC() {
      return _r;
    }
    function Vr() {
      return (ht & (rr | ei)) !== R2 ? bn() : (Bg !== un || (Bg = bn()), Bg);
    }
    function Bo(t) {
      var r = t.mode;
      if ((r & je) === Re)
        return Ne;
      if ((ht & rr) !== R2 && O2 !== z1)
        return so(O2);
      var u = aO() !== iO;
      if (u) {
        if (nr.transition !== null) {
          var f = nr.transition;
          f._updatedFibers || (f._updatedFibers = /* @__PURE__ */ new Set()), f._updatedFibers.add(t);
        }
        return MC === Vn && (MC = Hd()), MC;
      }
      var C = l3();
      if (C !== Vn)
        return C;
      var p = _L();
      return p;
    }
    function gk(t) {
      var r = t.mode;
      return (r & je) === Re ? Ne : br();
    }
    function k2(t, r, u, f) {
      zk(), Ey && c("useInsertionEffect must not schedule updates."), Ip && (SC = !0), la(t, u, f), (ht & rr) !== z1 && t === _r ? Fk(r) : (Br && Cu(t, r, u), Bk(r), t === _r && ((ht & rr) === R2 && (jg = et(jg, u)), D2 === Dg && Ho(t, O2)), p3(t, f), u === Ne && ht === R2 && (r.mode & je) === Re && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Hi.isBatchingLegacy && (Ng(), E8()));
    }
    function fk(t, r, u) {
      var f = t.current;
      f.lanes = r, la(t, r, u), p3(t, u);
    }
    function dk(t) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (ht & rr) !== R2
      );
    }
    function p3(t, r) {
      var u = t.callbackNode;
      zd(t, r);
      var f = oa(t, t === _r ? O2 : z1);
      if (f === z1) {
        u !== null && Wy(u), t.callbackNode = null, t.callbackPriority = Vn;
        return;
      }
      var C = zn(f), p = t.callbackPriority;
      if (p === C && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Hi.current !== null && u !== wp)) {
        u == null && p !== Ne && c("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      u != null && Wy(u);
      var b;
      if (C === Ne)
        t.tag === To ? (Hi.isBatchingLegacy !== null && (Hi.didScheduleLegacyUpdate = !0), UR(Ly.bind(null, t))) : S8(Ly.bind(null, t)), Hi.current !== null ? Hi.current.push(Lo) : KL(function() {
          (ht & (rr | ei)) === R2 && Lo();
        }), b = null;
      else {
        var T;
        switch (S2(f)) {
          case Nn:
            T = Ul;
            break;
          case Ei:
            T = $0;
            break;
          case K3:
            T = V3;
            break;
          case lo:
            T = Wl;
            break;
          default:
            T = V3;
            break;
        }
        b = xp(T, My.bind(null, t));
      }
      t.callbackPriority = C, t.callbackNode = b;
    }
    function My(t, r) {
      if (OO(), Bg = un, MC = z1, (ht & (rr | ei)) !== R2)
        throw new Error("Should not already be working.");
      var u = t.callbackNode, f = Sa();
      if (f && t.callbackNode !== u)
        return null;
      var C = oa(t, t === _r ? O2 : z1);
      if (C === z1)
        return null;
      var p = !Ms(t, C) && !Bd(t, C) && !r, b = p ? wk(t, C) : RC(t, C);
      if (b !== ba) {
        if (b === el) {
          var T = o0(t);
          T !== z1 && (C = T, b = pp(t, T));
        }
        if (b === Og) {
          var D = kg;
          throw nl(t, z1), Ho(t, C), p3(t, bn()), D;
        }
        if (b === up)
          Ho(t, C);
        else {
          var P = !Ms(t, C), F = t.current.alternate;
          if (P && !Ak(F)) {
            if (b = RC(t, C), b === el) {
              var i1 = o0(t);
              i1 !== z1 && (C = i1, b = pp(t, i1));
            }
            if (b === Og) {
              var n1 = kg;
              throw nl(t, z1), Ho(t, C), p3(t, bn()), n1;
            }
          }
          t.finishedWork = F, t.finishedLanes = C, Ck(t, b, C);
        }
      }
      return p3(t, bn()), t.callbackNode === u ? My.bind(null, t) : null;
    }
    function pp(t, r) {
      var u = zg;
      if (Au(t)) {
        var f = nl(t, r);
        f.flags |= Mn, jR(t.containerInfo);
      }
      var C = RC(t, r);
      if (C !== el) {
        var p = I3;
        I3 = u, p !== null && Ty(p);
      }
      return C;
    }
    function Ty(t) {
      I3 === null ? I3 = t : I3.push.apply(I3, t);
    }
    function Ck(t, r, u) {
      switch (r) {
        case ba:
        case Og:
          throw new Error("Root did not complete. This is a bug in React.");
        case el: {
          rl(t, I3, wa);
          break;
        }
        case yC: {
          if (Ho(t, u), Nd(u) && // do not delay if we're inside an act() scope
          !_y()) {
            var f = gp + wy - bn();
            if (f > 10) {
              var C = oa(t, z1);
              if (C !== z1)
                break;
              var p = t.suspendedLanes;
              if (!sa(p, u)) {
                Vr(), fu(t, p);
                break;
              }
              t.timeoutHandle = CI(rl.bind(null, t, I3, wa), f);
              break;
            }
          }
          rl(t, I3, wa);
          break;
        }
        case Dg: {
          if (Ho(t, u), Fd(u))
            break;
          if (!_y()) {
            var b = kd(t, u), T = b, D = bn() - T, P = jk(D) - D;
            if (P > 10) {
              t.timeoutHandle = CI(rl.bind(null, t, I3, wa), P);
              break;
            }
          }
          rl(t, I3, wa);
          break;
        }
        case by: {
          rl(t, I3, wa);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function Ak(t) {
      for (var r = t; ; ) {
        if (r.flags & ps) {
          var u = r.updateQueue;
          if (u !== null) {
            var f = u.stores;
            if (f !== null)
              for (var C = 0; C < f.length; C++) {
                var p = f[C], b = p.getSnapshot, T = p.value;
                try {
                  if (!Ee(b(), T))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var D = r.child;
        if (r.subtreeFlags & ps && D !== null) {
          D.return = r, r = D;
          continue;
        }
        if (r === t)
          return !0;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === t)
            return !0;
          r = r.return;
        }
        r.sibling.return = r.return, r = r.sibling;
      }
      return !0;
    }
    function Ho(t, r) {
      r = Ts(r, wC), r = Ts(r, jg), Wd(t, r);
    }
    function Ly(t) {
      if (DO(), (ht & (rr | ei)) !== R2)
        throw new Error("Should not already be working.");
      Sa();
      var r = oa(t, z1);
      if (!wr(r, Ne))
        return p3(t, bn()), null;
      var u = RC(t, r);
      if (t.tag !== To && u === el) {
        var f = o0(t);
        f !== z1 && (r = f, u = pp(t, f));
      }
      if (u === Og) {
        var C = kg;
        throw nl(t, z1), Ho(t, r), p3(t, bn()), C;
      }
      if (u === up)
        throw new Error("Root did not complete. This is a bug in React.");
      var p = t.current.alternate;
      return t.finishedWork = p, t.finishedLanes = r, rl(t, I3, wa), p3(t, bn()), null;
    }
    function Ik(t, r) {
      r !== z1 && (L4(t, et(r, Ne)), p3(t, bn()), (ht & (rr | ei)) === R2 && (Ng(), Lo()));
    }
    function hp(t, r) {
      var u = ht;
      ht |= yy;
      try {
        return t(r);
      } finally {
        ht = u, ht === R2 && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Hi.isBatchingLegacy && (Ng(), E8());
      }
    }
    function pk(t, r, u, f, C) {
      var p = l3(), b = nr.transition;
      try {
        return nr.transition = null, Tn(Nn), t(r, u, f, C);
      } finally {
        Tn(p), nr.transition = b, ht === R2 && Ng();
      }
    }
    function xa(t) {
      Fo !== null && Fo.tag === To && (ht & (rr | ei)) === R2 && Sa();
      var r = ht;
      ht |= yy;
      var u = nr.transition, f = l3();
      try {
        return nr.transition = null, Tn(Nn), t ? t() : void 0;
      } finally {
        Tn(f), nr.transition = u, ht = r, (ht & (rr | ei)) === R2 && Lo();
      }
    }
    function Ry() {
      return (ht & (rr | ei)) !== R2;
    }
    function LC(t, r) {
      Er(cp, v0, t), v0 = et(v0, r);
    }
    function mp(t) {
      v0 = cp.current, Sr(cp, t);
    }
    function nl(t, r) {
      t.finishedWork = null, t.finishedLanes = z1;
      var u = t.timeoutHandle;
      if (u !== AI && (t.timeoutHandle = AI, VL(u)), Fn !== null)
        for (var f = Fn.return; f !== null; ) {
          var C = f.alternate;
          ay(C, f), f = f.return;
        }
      _r = t;
      var p = il(t.current, null);
      return Fn = p, O2 = v0 = r, D2 = ba, kg = null, bC = z1, jg = z1, wC = z1, zg = null, I3 = null, fO(), Di.discardPendingWarnings(), p;
    }
    function Oy(t, r) {
      do {
        var u = Fn;
        try {
          if (B9(), tv(), jn(), lp.current = null, u === null || u.return === null) {
            D2 = Og, kg = r, Fn = null;
            return;
          }
          if (B1 && u.mode & Ge && CC(u, !0), K1)
            if (vr(), r !== null && typeof r == "object" && typeof r.then == "function") {
              var f = r;
              ta(u, f, O2);
            } else
              vs(u, r, O2);
          UO(t, u.return, u, r, O2), zy(u);
        } catch (C) {
          r = C, Fn === u && u !== null ? (u = u.return, Fn = u) : u = Fn;
          continue;
        }
        return;
      } while (!0);
    }
    function Dy() {
      var t = sp.current;
      return sp.current = uC, t === null ? uC : t;
    }
    function ky(t) {
      sp.current = t;
    }
    function hk() {
      gp = bn();
    }
    function Hg(t) {
      bC = et(t, bC);
    }
    function mk() {
      D2 === ba && (D2 = yC);
    }
    function vp() {
      (D2 === ba || D2 === yC || D2 === el) && (D2 = Dg), _r !== null && (Es(bC) || Es(jg)) && Ho(_r, O2);
    }
    function vk(t) {
      D2 !== Dg && (D2 = el), zg === null ? zg = [t] : zg.push(t);
    }
    function yk() {
      return D2 === ba;
    }
    function RC(t, r) {
      var u = ht;
      ht |= rr;
      var f = Dy();
      if (_r !== t || O2 !== r) {
        if (Br) {
          var C = t.memoizedUpdaters;
          C.size > 0 && (Ug(t, O2), C.clear()), R4(t, r);
        }
        wa = Rs(), nl(t, r);
      }
      hn(r);
      do
        try {
          bk();
          break;
        } catch (p) {
          Oy(t, p);
        }
      while (!0);
      if (B9(), ht = u, ky(f), Fn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Yl(), _r = null, O2 = z1, D2;
    }
    function bk() {
      for (; Fn !== null; )
        jy(Fn);
    }
    function wk(t, r) {
      var u = ht;
      ht |= rr;
      var f = Dy();
      if (_r !== t || O2 !== r) {
        if (Br) {
          var C = t.memoizedUpdaters;
          C.size > 0 && (Ug(t, O2), C.clear()), R4(t, r);
        }
        wa = Rs(), Ng(), nl(t, r);
      }
      hn(r);
      do
        try {
          xk();
          break;
        } catch (p) {
          Oy(t, p);
        }
      while (!0);
      return B9(), ky(f), ht = u, Fn !== null ? (Jl(), ba) : (Yl(), _r = null, O2 = z1, D2);
    }
    function xk() {
      for (; Fn !== null && !Hl(); )
        jy(Fn);
    }
    function jy(t) {
      var r = t.alternate;
      Nt(t);
      var u;
      (t.mode & Ge) !== Re ? (w5(t), u = yp(r, t, v0), CC(t, !0)) : u = yp(r, t, v0), jn(), t.memoizedProps = t.pendingProps, u === null ? zy(t) : Fn = u, lp.current = null;
    }
    function zy(t) {
      var r = t;
      do {
        var u = r.alternate, f = r.return;
        if ((r.flags & Nr) === Ue) {
          Nt(r);
          var C = void 0;
          if ((r.mode & Ge) === Re ? C = iy(u, r, v0) : (w5(r), C = iy(u, r, v0), CC(r, !1)), jn(), C !== null) {
            Fn = C;
            return;
          }
        } else {
          var p = mD(u, r);
          if (p !== null) {
            p.flags &= bd, Fn = p;
            return;
          }
          if ((r.mode & Ge) !== Re) {
            CC(r, !1);
            for (var b = r.actualDuration, T = r.child; T !== null; )
              b += T.actualDuration, T = T.sibling;
            r.actualDuration = b;
          }
          if (f !== null)
            f.flags |= Nr, f.subtreeFlags = Ue, f.deletions = null;
          else {
            D2 = up, Fn = null;
            return;
          }
        }
        var D = r.sibling;
        if (D !== null) {
          Fn = D;
          return;
        }
        r = f, Fn = r;
      } while (r !== null);
      D2 === ba && (D2 = by);
    }
    function rl(t, r, u) {
      var f = l3(), C = nr.transition;
      try {
        nr.transition = null, Tn(Nn), Sk(t, r, u, f);
      } finally {
        nr.transition = C, Tn(f);
      }
      return null;
    }
    function Sk(t, r, u, f) {
      do
        Sa();
      while (Fo !== null);
      if (Nk(), (ht & (rr | ei)) !== R2)
        throw new Error("Should not already be working.");
      var C = t.finishedWork, p = t.finishedLanes;
      if (r0(p), C === null)
        return _l(), null;
      if (p === z1 && c("root.finishedLanes should not be empty during a commit. This is a bug in React."), t.finishedWork = null, t.finishedLanes = z1, C === t.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      t.callbackNode = null, t.callbackPriority = Vn;
      var b = et(C.lanes, C.childLanes);
      du(t, b), t === _r && (_r = null, Fn = null, O2 = z1), ((C.subtreeFlags & r3) !== Ue || (C.flags & r3) !== Ue) && (tl || (tl = !0, Cp = u, xp(V3, function() {
        return Sa(), null;
      })));
      var T = (C.subtreeFlags & (Qa | hr | B2 | r3)) !== Ue, D = (C.flags & (Qa | hr | B2 | r3)) !== Ue;
      if (T || D) {
        var P = nr.transition;
        nr.transition = null;
        var F = l3();
        Tn(Nn);
        var i1 = ht;
        ht |= ei, lp.current = null, xD(t, C), Ev(), FD(t, C, p), PL(t.containerInfo), t.current = C, y4(p), BD(C, t, p), $a(), Sd(), ht = i1, Tn(F), nr.transition = P;
      } else
        t.current = C, Ev();
      var n1 = tl;
      if (tl ? (tl = !1, Fo = t, Pg = p) : (sc = 0, EC = null), b = t.pendingLanes, b === z1 && (oc = null), n1 || By(t.current, !1), Ga(C.stateNode, f), Br && t.memoizedUpdaters.clear(), ik(), p3(t, bn()), r !== null)
        for (var A1 = t.onRecoverableError, m1 = 0; m1 < r.length; m1++) {
          var M1 = r[m1], Ce = M1.stack, We = M1.digest;
          A1(M1.value, {
            componentStack: Ce,
            digest: We
          });
        }
      if (xC) {
        xC = !1;
        var ze = fp;
        throw fp = null, ze;
      }
      return wr(Pg, Ne) && t.tag !== To && Sa(), b = t.pendingLanes, wr(b, Ne) ? (RO(), t === Ap ? Fg++ : (Fg = 0, Ap = t)) : Fg = 0, Lo(), _l(), null;
    }
    function Sa() {
      if (Fo !== null) {
        var t = S2(Pg), r = B6(K3, t), u = nr.transition, f = l3();
        try {
          return nr.transition = null, Tn(r), Mk();
        } finally {
          Tn(f), nr.transition = u;
        }
      }
      return !1;
    }
    function Ek(t) {
      dp.push(t), tl || (tl = !0, xp(V3, function() {
        return Sa(), null;
      }));
    }
    function Mk() {
      if (Fo === null)
        return !1;
      var t = Cp;
      Cp = null;
      var r = Fo, u = Pg;
      if (Fo = null, Pg = z1, (ht & (rr | ei)) !== R2)
        throw new Error("Cannot flush passive effects while already rendering.");
      Ip = !0, SC = !1, Od(u);
      var f = ht;
      ht |= ei, JD(r.current), WD(r, r.current, u, t);
      {
        var C = dp;
        dp = [];
        for (var p = 0; p < C.length; p++) {
          var b = C[p];
          TD(r, b);
        }
      }
      b4(), By(r.current, !0), ht = f, Lo(), SC ? r === EC ? sc++ : (sc = 0, EC = r) : sc = 0, Ip = !1, SC = !1, o3(r);
      {
        var T = r.current.stateNode;
        T.effectDuration = 0, T.passiveEffectDuration = 0;
      }
      return !0;
    }
    function Ny(t) {
      return oc !== null && oc.has(t);
    }
    function Tk(t) {
      oc === null ? oc = /* @__PURE__ */ new Set([t]) : oc.add(t);
    }
    function Lk(t) {
      xC || (xC = !0, fp = t);
    }
    var Rk = Lk;
    function Py(t, r, u) {
      var f = Zs(u, r), C = jv(t, f, Ne), p = Oo(t, C, Ne), b = Vr();
      p !== null && (la(p, Ne, b), p3(p, b));
    }
    function dn(t, r, u) {
      if (yD(u), Wg(!1), t.tag === x) {
        Py(t, t, u);
        return;
      }
      var f = null;
      for (f = r; f !== null; ) {
        if (f.tag === x) {
          Py(f, t, u);
          return;
        } else if (f.tag === m) {
          var C = f.type, p = f.stateNode;
          if (typeof C.getDerivedStateFromError == "function" || typeof p.componentDidCatch == "function" && !Ny(p)) {
            var b = Zs(u, t), T = U5(f, b, Ne), D = Oo(f, T, Ne), P = Vr();
            D !== null && (la(D, Ne, P), p3(D, P));
            return;
          }
        }
        f = f.return;
      }
      c(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, u);
    }
    function Ok(t, r, u) {
      var f = t.pingCache;
      f !== null && f.delete(r);
      var C = Vr();
      fu(t, u), Hk(t), _r === t && sa(O2, u) && (D2 === Dg || D2 === yC && Nd(O2) && bn() - gp < wy ? nl(t, z1) : wC = et(wC, u)), p3(t, C);
    }
    function Fy(t, r) {
      r === Vn && (r = gk(t));
      var u = Vr(), f = C3(t, r);
      f !== null && (la(f, r, u), p3(f, u));
    }
    function Dk(t) {
      var r = t.memoizedState, u = Vn;
      r !== null && (u = r.retryLane), Fy(t, u);
    }
    function kk(t, r) {
      var u = Vn, f;
      switch (t.tag) {
        case B:
          f = t.stateNode;
          var C = t.memoizedState;
          C !== null && (u = C.retryLane);
          break;
        case f1:
          f = t.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      f !== null && f.delete(r), Fy(t, u);
    }
    function jk(t) {
      return t < 120 ? 120 : t < 480 ? 480 : t < 1080 ? 1080 : t < 1920 ? 1920 : t < 3e3 ? 3e3 : t < 4320 ? 4320 : sk(t / 1960) * 1960;
    }
    function zk() {
      if (Fg > uk)
        throw Fg = 0, Ap = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      sc > ck && (sc = 0, EC = null, c("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function Nk() {
      Di.flushLegacyContextWarning(), Di.flushPendingUnsafeLifecycleWarnings();
    }
    function By(t, r) {
      Nt(t), OC(t, pr, tk), r && OC(t, Z0, nk), OC(t, pr, $D), r && OC(t, Z0, ek), jn();
    }
    function OC(t, r, u) {
      for (var f = t, C = null; f !== null; ) {
        var p = f.subtreeFlags & r;
        f !== C && f.child !== null && p !== Ue ? f = f.child : ((f.flags & r) !== Ue && u(f), f.sibling !== null ? f = f.sibling : f = C = f.return);
      }
    }
    var DC = null;
    function Hy(t) {
      {
        if ((ht & rr) !== R2 || !(t.mode & je))
          return;
        var r = t.tag;
        if (r !== w && r !== x && r !== m && r !== h && r !== _ && r !== Z && r !== Y)
          return;
        var u = Fe(t) || "ReactComponent";
        if (DC !== null) {
          if (DC.has(u))
            return;
          DC.add(u);
        } else
          DC = /* @__PURE__ */ new Set([u]);
        var f = En;
        try {
          Nt(t), c("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          f ? Nt(t) : jn();
        }
      }
    }
    var yp;
    {
      var Pk = null;
      yp = function(t, r, u) {
        var f = Qy(Pk, r);
        try {
          return $v(t, r, u);
        } catch (p) {
          if (XR() || p !== null && typeof p == "object" && typeof p.then == "function")
            throw p;
          if (B9(), tv(), ay(t, r), Qy(r, f), r.mode & Ge && w5(r), q0(null, $v, null, t, r, u), j6()) {
            var C = f4();
            typeof C == "object" && C !== null && C._suppressLogging && typeof p == "object" && p !== null && !p._suppressLogging && (p._suppressLogging = !0);
          }
          throw p;
        }
      };
    }
    var Uy = !1, bp;
    bp = /* @__PURE__ */ new Set();
    function Fk(t) {
      if (fr && !MO())
        switch (t.tag) {
          case h:
          case _:
          case Y: {
            var r = Fn && Fe(Fn) || "Unknown", u = r;
            if (!bp.has(u)) {
              bp.add(u);
              var f = Fe(t) || "Unknown";
              c("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", f, r, r);
            }
            break;
          }
          case m: {
            Uy || (c("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), Uy = !0);
            break;
          }
        }
    }
    function Ug(t, r) {
      if (Br) {
        var u = t.memoizedUpdaters;
        u.forEach(function(f) {
          Cu(t, f, r);
        });
      }
    }
    var wp = {};
    function xp(t, r) {
      {
        var u = Hi.current;
        return u !== null ? (u.push(r), wp) : Bl(t, r);
      }
    }
    function Wy(t) {
      if (t !== wp)
        return xd(t);
    }
    function _y() {
      return Hi.current !== null;
    }
    function Bk(t) {
      {
        if (t.mode & je) {
          if (!vy())
            return;
        } else if (!ok() || ht !== R2 || t.tag !== h && t.tag !== _ && t.tag !== Y)
          return;
        if (Hi.current === null) {
          var r = En;
          try {
            Nt(t), c(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Fe(t));
          } finally {
            r ? Nt(t) : jn();
          }
        }
      }
    }
    function Hk(t) {
      t.tag !== To && vy() && Hi.current === null && c(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Wg(t) {
      Ey = t;
    }
    var ti = null, lc = null, Uk = function(t) {
      ti = t;
    };
    function uc(t) {
      {
        if (ti === null)
          return t;
        var r = ti(t);
        return r === void 0 ? t : r.current;
      }
    }
    function Sp(t) {
      return uc(t);
    }
    function Ep(t) {
      {
        if (ti === null)
          return t;
        var r = ti(t);
        if (r === void 0) {
          if (t != null && typeof t.render == "function") {
            var u = uc(t.render);
            if (t.render !== u) {
              var f = {
                $$typeof: re,
                render: u
              };
              return t.displayName !== void 0 && (f.displayName = t.displayName), f;
            }
          }
          return t;
        }
        return r.current;
      }
    }
    function Vy(t, r) {
      {
        if (ti === null)
          return !1;
        var u = t.elementType, f = r.type, C = !1, p = typeof f == "object" && f !== null ? f.$$typeof : null;
        switch (t.tag) {
          case m: {
            typeof f == "function" && (C = !0);
            break;
          }
          case h: {
            (typeof f == "function" || p === He) && (C = !0);
            break;
          }
          case _: {
            (p === re || p === He) && (C = !0);
            break;
          }
          case Z:
          case Y: {
            (p === ft || p === He) && (C = !0);
            break;
          }
          default:
            return !1;
        }
        if (C) {
          var b = ti(u);
          if (b !== void 0 && b === ti(f))
            return !0;
        }
        return !1;
      }
    }
    function Ky(t) {
      {
        if (ti === null || typeof WeakSet != "function")
          return;
        lc === null && (lc = /* @__PURE__ */ new WeakSet()), lc.add(t);
      }
    }
    var Wk = function(t, r) {
      {
        if (ti === null)
          return;
        var u = r.staleFamilies, f = r.updatedFamilies;
        Sa(), xa(function() {
          Mp(t.current, f, u);
        });
      }
    }, _k = function(t, r) {
      {
        if (t.context !== M3)
          return;
        Sa(), xa(function() {
          _g(r, t, null, null);
        });
      }
    };
    function Mp(t, r, u) {
      {
        var f = t.alternate, C = t.child, p = t.sibling, b = t.tag, T = t.type, D = null;
        switch (b) {
          case h:
          case Y:
          case m:
            D = T;
            break;
          case _:
            D = T.render;
            break;
        }
        if (ti === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var P = !1, F = !1;
        if (D !== null) {
          var i1 = ti(D);
          i1 !== void 0 && (u.has(i1) ? F = !0 : r.has(i1) && (b === m ? F = !0 : P = !0));
        }
        if (lc !== null && (lc.has(t) || f !== null && lc.has(f)) && (F = !0), F && (t._debugNeedsRemount = !0), F || P) {
          var n1 = C3(t, Ne);
          n1 !== null && k2(n1, t, Ne, un);
        }
        C !== null && !F && Mp(C, r, u), p !== null && Mp(p, r, u);
      }
    }
    var Vk = function(t, r) {
      {
        var u = /* @__PURE__ */ new Set(), f = new Set(r.map(function(C) {
          return C.current;
        }));
        return Tp(t.current, f, u), u;
      }
    };
    function Tp(t, r, u) {
      {
        var f = t.child, C = t.sibling, p = t.tag, b = t.type, T = null;
        switch (p) {
          case h:
          case Y:
          case m:
            T = b;
            break;
          case _:
            T = b.render;
            break;
        }
        var D = !1;
        T !== null && r.has(T) && (D = !0), D ? Kk(t, u) : f !== null && Tp(f, r, u), C !== null && Tp(C, r, u);
      }
    }
    function Kk(t, r) {
      {
        var u = Jk(t, r);
        if (u)
          return;
        for (var f = t; ; ) {
          switch (f.tag) {
            case O:
              r.add(f.stateNode);
              return;
            case M:
              r.add(f.stateNode.containerInfo);
              return;
            case x:
              r.add(f.stateNode.containerInfo);
              return;
          }
          if (f.return === null)
            throw new Error("Expected to reach root first.");
          f = f.return;
        }
      }
    }
    function Jk(t, r) {
      for (var u = t, f = !1; ; ) {
        if (u.tag === O)
          f = !0, r.add(u.stateNode);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === t)
          return f;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === t)
            return f;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
      return !1;
    }
    var Lp;
    {
      Lp = !1;
      try {
        var Jy = Object.preventExtensions({});
      } catch {
        Lp = !0;
      }
    }
    function Yk(t, r, u, f) {
      this.tag = t, this.key = u, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = r, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = f, this.flags = Ue, this.subtreeFlags = Ue, this.deletions = null, this.lanes = z1, this.childLanes = z1, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Lp && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var T3 = function(t, r, u, f) {
      return new Yk(t, r, u, f);
    };
    function Rp(t) {
      var r = t.prototype;
      return !!(r && r.isReactComponent);
    }
    function Qk(t) {
      return typeof t == "function" && !Rp(t) && t.defaultProps === void 0;
    }
    function Xk(t) {
      if (typeof t == "function")
        return Rp(t) ? m : h;
      if (t != null) {
        var r = t.$$typeof;
        if (r === re)
          return _;
        if (r === ft)
          return Z;
      }
      return w;
    }
    function il(t, r) {
      var u = t.alternate;
      u === null ? (u = T3(t.tag, r, t.key, t.mode), u.elementType = t.elementType, u.type = t.type, u.stateNode = t.stateNode, u._debugSource = t._debugSource, u._debugOwner = t._debugOwner, u._debugHookTypes = t._debugHookTypes, u.alternate = t, t.alternate = u) : (u.pendingProps = r, u.type = t.type, u.flags = Ue, u.subtreeFlags = Ue, u.deletions = null, u.actualDuration = 0, u.actualStartTime = -1), u.flags = t.flags & w2, u.childLanes = t.childLanes, u.lanes = t.lanes, u.child = t.child, u.memoizedProps = t.memoizedProps, u.memoizedState = t.memoizedState, u.updateQueue = t.updateQueue;
      var f = t.dependencies;
      switch (u.dependencies = f === null ? null : {
        lanes: f.lanes,
        firstContext: f.firstContext
      }, u.sibling = t.sibling, u.index = t.index, u.ref = t.ref, u.selfBaseDuration = t.selfBaseDuration, u.treeBaseDuration = t.treeBaseDuration, u._debugNeedsRemount = t._debugNeedsRemount, u.tag) {
        case w:
        case h:
        case Y:
          u.type = uc(t.type);
          break;
        case m:
          u.type = Sp(t.type);
          break;
        case _:
          u.type = Ep(t.type);
          break;
      }
      return u;
    }
    function Gk(t, r) {
      t.flags &= w2 | cn;
      var u = t.alternate;
      if (u === null)
        t.childLanes = z1, t.lanes = r, t.child = null, t.subtreeFlags = Ue, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null, t.selfBaseDuration = 0, t.treeBaseDuration = 0;
      else {
        t.childLanes = u.childLanes, t.lanes = u.lanes, t.child = u.child, t.subtreeFlags = Ue, t.deletions = null, t.memoizedProps = u.memoizedProps, t.memoizedState = u.memoizedState, t.updateQueue = u.updateQueue, t.type = u.type;
        var f = u.dependencies;
        t.dependencies = f === null ? null : {
          lanes: f.lanes,
          firstContext: f.firstContext
        }, t.selfBaseDuration = u.selfBaseDuration, t.treeBaseDuration = u.treeBaseDuration;
      }
      return t;
    }
    function qk(t, r, u) {
      var f;
      return t === L9 ? (f = je, r === !0 && (f |= ct, f |= Hr)) : f = Re, Br && (f |= Ge), T3(x, null, null, f);
    }
    function Op(t, r, u, f, C, p) {
      var b = w, T = t;
      if (typeof t == "function")
        Rp(t) ? (b = m, T = Sp(T)) : T = uc(T);
      else if (typeof t == "string")
        b = O;
      else
        e: switch (t) {
          case N2:
            return Uo(u.children, C, p, r);
          case Gr:
            b = N, C |= ct, (C & je) !== Re && (C |= Hr);
            break;
          case fi:
            return Zk(u, C, p, r);
          case be:
            return $k(u, C, p, r);
          case st:
            return ej(u, C, p, r);
          case Wt:
            return Yy(u, C, p, r);
          case rn:
          case nt:
          case P2:
          case B3:
          case Un:
          default: {
            if (typeof t == "object" && t !== null)
              switch (t.$$typeof) {
                case G:
                  b = Q;
                  break e;
                case P1:
                  b = U;
                  break e;
                case re:
                  b = _, T = Ep(T);
                  break e;
                case ft:
                  b = Z;
                  break e;
                case He:
                  b = V, T = null;
                  break e;
              }
            var D = "";
            {
              (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (D += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var P = f ? Fe(f) : null;
              P && (D += `

Check the render method of \`` + P + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (t == null ? t : typeof t) + "." + D));
          }
        }
      var F = T3(b, u, r, C);
      return F.elementType = t, F.type = T, F.lanes = p, F._debugOwner = f, F;
    }
    function Dp(t, r, u) {
      var f = null;
      f = t._owner;
      var C = t.type, p = t.key, b = t.props, T = Op(C, p, b, f, r, u);
      return T._debugSource = t._source, T._debugOwner = t._owner, T;
    }
    function Uo(t, r, u, f) {
      var C = T3(z, t, f, r);
      return C.lanes = u, C;
    }
    function Zk(t, r, u, f) {
      typeof t.id != "string" && c('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof t.id);
      var C = T3(X, t, f, r | Ge);
      return C.elementType = fi, C.lanes = u, C.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, C;
    }
    function $k(t, r, u, f) {
      var C = T3(B, t, f, r);
      return C.elementType = be, C.lanes = u, C;
    }
    function ej(t, r, u, f) {
      var C = T3(f1, t, f, r);
      return C.elementType = st, C.lanes = u, C;
    }
    function Yy(t, r, u, f) {
      var C = T3(a1, t, f, r);
      C.elementType = Wt, C.lanes = u;
      var p = {
        isHidden: !1
      };
      return C.stateNode = p, C;
    }
    function kp(t, r, u) {
      var f = T3(k, t, null, r);
      return f.lanes = u, f;
    }
    function tj() {
      var t = T3(O, null, null, Re);
      return t.elementType = "DELETED", t;
    }
    function nj(t) {
      var r = T3(e1, null, null, Re);
      return r.stateNode = t, r;
    }
    function jp(t, r, u) {
      var f = t.children !== null ? t.children : [], C = T3(M, f, t.key, r);
      return C.lanes = u, C.stateNode = {
        containerInfo: t.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: t.implementation
      }, C;
    }
    function Qy(t, r) {
      return t === null && (t = T3(w, null, null, Re)), t.tag = r.tag, t.key = r.key, t.elementType = r.elementType, t.type = r.type, t.stateNode = r.stateNode, t.return = r.return, t.child = r.child, t.sibling = r.sibling, t.index = r.index, t.ref = r.ref, t.pendingProps = r.pendingProps, t.memoizedProps = r.memoizedProps, t.updateQueue = r.updateQueue, t.memoizedState = r.memoizedState, t.dependencies = r.dependencies, t.mode = r.mode, t.flags = r.flags, t.subtreeFlags = r.subtreeFlags, t.deletions = r.deletions, t.lanes = r.lanes, t.childLanes = r.childLanes, t.alternate = r.alternate, t.actualDuration = r.actualDuration, t.actualStartTime = r.actualStartTime, t.selfBaseDuration = r.selfBaseDuration, t.treeBaseDuration = r.treeBaseDuration, t._debugSource = r._debugSource, t._debugOwner = r._debugOwner, t._debugNeedsRemount = r._debugNeedsRemount, t._debugHookTypes = r._debugHookTypes, t;
    }
    function rj(t, r, u, f, C) {
      this.tag = r, this.containerInfo = t, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = AI, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Vn, this.eventTimes = Ls(z1), this.expirationTimes = Ls(un), this.pendingLanes = z1, this.suspendedLanes = z1, this.pingedLanes = z1, this.expiredLanes = z1, this.mutableReadLanes = z1, this.finishedLanes = z1, this.entangledLanes = z1, this.entanglements = Ls(z1), this.identifierPrefix = f, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var p = this.pendingUpdatersLaneMap = [], b = 0; b < ws; b++)
          p.push(/* @__PURE__ */ new Set());
      }
      switch (r) {
        case L9:
          this._debugRootType = u ? "hydrateRoot()" : "createRoot()";
          break;
        case To:
          this._debugRootType = u ? "hydrate()" : "render()";
          break;
      }
    }
    function Xy(t, r, u, f, C, p, b, T, D, P) {
      var F = new rj(t, r, u, T, D), i1 = qk(r, p);
      F.current = i1, i1.stateNode = F;
      {
        var n1 = {
          element: f,
          isDehydrated: u,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        i1.memoizedState = n1;
      }
      return YI(i1), F;
    }
    var zp = "18.3.1";
    function ij(t, r, u) {
      var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return me(f), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: z2,
        key: f == null ? null : "" + f,
        children: t,
        containerInfo: r,
        implementation: u
      };
    }
    var Np, Pp;
    Np = !1, Pp = {};
    function Gy(t) {
      if (!t)
        return M3;
      var r = e3(t), u = HR(r);
      if (r.tag === m) {
        var f = r.type;
        if (d0(f))
          return w8(r, f, u);
      }
      return u;
    }
    function aj(t, r) {
      {
        var u = e3(t);
        if (u === void 0) {
          if (typeof t.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var f = Object.keys(t).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + f);
        }
        var C = i3(u);
        if (C === null)
          return null;
        if (C.mode & ct) {
          var p = Fe(u) || "Component";
          if (!Pp[p]) {
            Pp[p] = !0;
            var b = En;
            try {
              Nt(C), u.mode & ct ? c("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, p) : c("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", r, r, p);
            } finally {
              b ? Nt(b) : jn();
            }
          }
        }
        return C.stateNode;
      }
    }
    function qy(t, r, u, f, C, p, b, T) {
      var D = !1, P = null;
      return Xy(t, r, D, P, u, f, C, p, b);
    }
    function Zy(t, r, u, f, C, p, b, T, D, P) {
      var F = !0, i1 = Xy(u, f, F, t, C, p, b, T, D);
      i1.context = Gy(null);
      var n1 = i1.current, A1 = Vr(), m1 = Bo(n1), M1 = va(A1, m1);
      return M1.callback = r ?? null, Oo(n1, M1, m1), fk(i1, m1, A1), i1;
    }
    function _g(t, r, u, f) {
      v4(r, t);
      var C = r.current, p = Vr(), b = Bo(C);
      w4(b);
      var T = Gy(u);
      r.context === null ? r.context = T : r.pendingContext = T, fr && En !== null && !Np && (Np = !0, c(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Fe(En) || "Unknown"));
      var D = va(p, b);
      D.payload = {
        element: t
      }, f = f === void 0 ? null : f, f !== null && (typeof f != "function" && c("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", f), D.callback = f);
      var P = Oo(C, D, b);
      return P !== null && (k2(P, C, b, p), V9(P, C, b)), b;
    }
    function kC(t) {
      var r = t.current;
      if (!r.child)
        return null;
      switch (r.child.tag) {
        case O:
          return r.child.stateNode;
        default:
          return r.child.stateNode;
      }
    }
    function oj(t) {
      switch (t.tag) {
        case x: {
          var r = t.stateNode;
          if (Au(r)) {
            var u = E4(r);
            Ik(r, u);
          }
          break;
        }
        case B: {
          xa(function() {
            var C = C3(t, Ne);
            if (C !== null) {
              var p = Vr();
              k2(C, t, Ne, p);
            }
          });
          var f = Ne;
          Fp(t, f);
          break;
        }
      }
    }
    function $y(t, r) {
      var u = t.memoizedState;
      u !== null && u.dehydrated !== null && (u.retryLane = Ud(u.retryLane, r));
    }
    function Fp(t, r) {
      $y(t, r);
      var u = t.alternate;
      u && $y(u, r);
    }
    function sj(t) {
      if (t.tag === B) {
        var r = Ss, u = C3(t, r);
        if (u !== null) {
          var f = Vr();
          k2(u, t, r, f);
        }
        Fp(t, r);
      }
    }
    function lj(t) {
      if (t.tag === B) {
        var r = Bo(t), u = C3(t, r);
        if (u !== null) {
          var f = Vr();
          k2(u, t, r, f);
        }
        Fp(t, r);
      }
    }
    function eb(t) {
      var r = wd(t);
      return r === null ? null : r.stateNode;
    }
    var tb = function(t) {
      return null;
    };
    function uj(t) {
      return tb(t);
    }
    var nb = function(t) {
      return !1;
    };
    function cj(t) {
      return nb(t);
    }
    var rb = null, ib = null, ab = null, ob = null, sb = null, lb = null, ub = null, cb = null, gb = null;
    {
      var fb = function(t, r, u) {
        var f = r[u], C = g2(t) ? t.slice() : it({}, t);
        return u + 1 === r.length ? (g2(C) ? C.splice(f, 1) : delete C[f], C) : (C[f] = fb(t[f], r, u + 1), C);
      }, db = function(t, r) {
        return fb(t, r, 0);
      }, Cb = function(t, r, u, f) {
        var C = r[f], p = g2(t) ? t.slice() : it({}, t);
        if (f + 1 === r.length) {
          var b = u[f];
          p[b] = p[C], g2(p) ? p.splice(C, 1) : delete p[C];
        } else
          p[C] = Cb(
            // $FlowFixMe number or string is fine here
            t[C],
            r,
            u,
            f + 1
          );
        return p;
      }, Ab = function(t, r, u) {
        if (r.length !== u.length) {
          g("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var f = 0; f < u.length - 1; f++)
            if (r[f] !== u[f]) {
              g("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return Cb(t, r, u, 0);
      }, Ib = function(t, r, u, f) {
        if (u >= r.length)
          return f;
        var C = r[u], p = g2(t) ? t.slice() : it({}, t);
        return p[C] = Ib(t[C], r, u + 1, f), p;
      }, pb = function(t, r, u) {
        return Ib(t, r, 0, u);
      }, Bp = function(t, r) {
        for (var u = t.memoizedState; u !== null && r > 0; )
          u = u.next, r--;
        return u;
      };
      rb = function(t, r, u, f) {
        var C = Bp(t, r);
        if (C !== null) {
          var p = pb(C.memoizedState, u, f);
          C.memoizedState = p, C.baseState = p, t.memoizedProps = it({}, t.memoizedProps);
          var b = C3(t, Ne);
          b !== null && k2(b, t, Ne, un);
        }
      }, ib = function(t, r, u) {
        var f = Bp(t, r);
        if (f !== null) {
          var C = db(f.memoizedState, u);
          f.memoizedState = C, f.baseState = C, t.memoizedProps = it({}, t.memoizedProps);
          var p = C3(t, Ne);
          p !== null && k2(p, t, Ne, un);
        }
      }, ab = function(t, r, u, f) {
        var C = Bp(t, r);
        if (C !== null) {
          var p = Ab(C.memoizedState, u, f);
          C.memoizedState = p, C.baseState = p, t.memoizedProps = it({}, t.memoizedProps);
          var b = C3(t, Ne);
          b !== null && k2(b, t, Ne, un);
        }
      }, ob = function(t, r, u) {
        t.pendingProps = pb(t.memoizedProps, r, u), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var f = C3(t, Ne);
        f !== null && k2(f, t, Ne, un);
      }, sb = function(t, r) {
        t.pendingProps = db(t.memoizedProps, r), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var u = C3(t, Ne);
        u !== null && k2(u, t, Ne, un);
      }, lb = function(t, r, u) {
        t.pendingProps = Ab(t.memoizedProps, r, u), t.alternate && (t.alternate.pendingProps = t.pendingProps);
        var f = C3(t, Ne);
        f !== null && k2(f, t, Ne, un);
      }, ub = function(t) {
        var r = C3(t, Ne);
        r !== null && k2(r, t, Ne, un);
      }, cb = function(t) {
        tb = t;
      }, gb = function(t) {
        nb = t;
      };
    }
    function gj(t) {
      var r = i3(t);
      return r === null ? null : r.stateNode;
    }
    function fj(t) {
      return null;
    }
    function dj() {
      return En;
    }
    function Cj(t) {
      var r = t.findFiberByHostInstance, u = i.ReactCurrentDispatcher;
      return m4({
        bundleType: t.bundleType,
        version: t.version,
        rendererPackageName: t.rendererPackageName,
        rendererConfig: t.rendererConfig,
        overrideHookState: rb,
        overrideHookStateDeletePath: ib,
        overrideHookStateRenamePath: ab,
        overrideProps: ob,
        overridePropsDeletePath: sb,
        overridePropsRenamePath: lb,
        setErrorHandler: cb,
        setSuspenseHandler: gb,
        scheduleUpdate: ub,
        currentDispatcherRef: u,
        findHostInstanceByFiber: gj,
        findFiberByHostInstance: r || fj,
        // React Refresh
        findHostInstancesForRefresh: Vk,
        scheduleRefresh: Wk,
        scheduleRoot: _k,
        setRefreshHandler: Uk,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: dj,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: zp
      });
    }
    var hb = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(t) {
      console.error(t);
    };
    function Hp(t) {
      this._internalRoot = t;
    }
    jC.prototype.render = Hp.prototype.render = function(t) {
      var r = this._internalRoot;
      if (r === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? c("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : zC(arguments[1]) ? c("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && c("You passed a second argument to root.render(...) but it only accepts one argument.");
        var u = r.containerInfo;
        if (u.nodeType !== Wn) {
          var f = eb(r.current);
          f && f.parentNode !== u && c("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      _g(t, r, null, null);
    }, jC.prototype.unmount = Hp.prototype.unmount = function() {
      typeof arguments[0] == "function" && c("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var t = this._internalRoot;
      if (t !== null) {
        this._internalRoot = null;
        var r = t.containerInfo;
        Ry() && c("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), xa(function() {
          _g(null, t, null, null);
        }), h8(r);
      }
    };
    function Aj(t, r) {
      if (!zC(t))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      mb(t);
      var u = !1, f = !1, C = "", p = hb;
      r != null && (r.hydrate ? g("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof r == "object" && r !== null && r.$$typeof === Xr && c(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), r.unstable_strictMode === !0 && (u = !0), r.identifierPrefix !== void 0 && (C = r.identifierPrefix), r.onRecoverableError !== void 0 && (p = r.onRecoverableError), r.transitionCallbacks !== void 0 && r.transitionCallbacks);
      var b = qy(t, L9, null, u, f, C, p);
      b9(b.current, t);
      var T = t.nodeType === Wn ? t.parentNode : t;
      return X4(T), new Hp(b);
    }
    function jC(t) {
      this._internalRoot = t;
    }
    function Ij(t) {
      t && W6(t);
    }
    jC.prototype.unstable_scheduleHydration = Ij;
    function pj(t, r, u) {
      if (!zC(t))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      mb(t), r === void 0 && c("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var f = u ?? null, C = u != null && u.hydratedSources || null, p = !1, b = !1, T = "", D = hb;
      u != null && (u.unstable_strictMode === !0 && (p = !0), u.identifierPrefix !== void 0 && (T = u.identifierPrefix), u.onRecoverableError !== void 0 && (D = u.onRecoverableError));
      var P = Zy(r, null, t, L9, f, p, b, T, D);
      if (b9(P.current, t), X4(t), C)
        for (var F = 0; F < C.length; F++) {
          var i1 = C[F];
          yO(P, i1);
        }
      return new jC(P);
    }
    function zC(t) {
      return !!(t && (t.nodeType === Cr || t.nodeType === w3 || t.nodeType === K0 || !w1));
    }
    function Vg(t) {
      return !!(t && (t.nodeType === Cr || t.nodeType === w3 || t.nodeType === K0 || t.nodeType === Wn && t.nodeValue === " react-mount-point-unstable "));
    }
    function mb(t) {
      t.nodeType === Cr && t.tagName && t.tagName.toUpperCase() === "BODY" && c("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), og(t) && (t._reactRootContainer ? c("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : c("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var hj = i.ReactCurrentOwner, vb;
    vb = function(t) {
      if (t._reactRootContainer && t.nodeType !== Wn) {
        var r = eb(t._reactRootContainer.current);
        r && r.parentNode !== t && c("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var u = !!t._reactRootContainer, f = Up(t), C = !!(f && Eo(f));
      C && !u && c("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), t.nodeType === Cr && t.tagName && t.tagName.toUpperCase() === "BODY" && c("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function Up(t) {
      return t ? t.nodeType === w3 ? t.documentElement : t.firstChild : null;
    }
    function yb() {
    }
    function mj(t, r, u, f, C) {
      if (C) {
        if (typeof f == "function") {
          var p = f;
          f = function() {
            var n1 = kC(b);
            p.call(n1);
          };
        }
        var b = Zy(
          r,
          f,
          t,
          To,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          yb
        );
        t._reactRootContainer = b, b9(b.current, t);
        var T = t.nodeType === Wn ? t.parentNode : t;
        return X4(T), xa(), b;
      } else {
        for (var D; D = t.lastChild; )
          t.removeChild(D);
        if (typeof f == "function") {
          var P = f;
          f = function() {
            var n1 = kC(F);
            P.call(n1);
          };
        }
        var F = qy(
          t,
          To,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          yb
        );
        t._reactRootContainer = F, b9(F.current, t);
        var i1 = t.nodeType === Wn ? t.parentNode : t;
        return X4(i1), xa(function() {
          _g(r, F, u, f);
        }), F;
      }
    }
    function vj(t, r) {
      t !== null && typeof t != "function" && c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", r, t);
    }
    function NC(t, r, u, f, C) {
      vb(u), vj(C === void 0 ? null : C, "render");
      var p = u._reactRootContainer, b;
      if (!p)
        b = mj(u, r, t, C, f);
      else {
        if (b = p, typeof C == "function") {
          var T = C;
          C = function() {
            var D = kC(b);
            T.call(D);
          };
        }
        _g(r, b, t, C);
      }
      return kC(b);
    }
    var bb = !1;
    function yj(t) {
      {
        bb || (bb = !0, c("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var r = hj.current;
        if (r !== null && r.stateNode !== null) {
          var u = r.stateNode._warnedAboutRefsInRender;
          u || c("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Mt(r.type) || "A component"), r.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return t == null ? null : t.nodeType === Cr ? t : aj(t, "findDOMNode");
    }
    function bj(t, r, u) {
      if (c("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vg(r))
        throw new Error("Target container is not a DOM element.");
      {
        var f = og(r) && r._reactRootContainer === void 0;
        f && c("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return NC(null, t, r, !0, u);
    }
    function wj(t, r, u) {
      if (c("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vg(r))
        throw new Error("Target container is not a DOM element.");
      {
        var f = og(r) && r._reactRootContainer === void 0;
        f && c("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return NC(null, t, r, !1, u);
    }
    function xj(t, r, u, f) {
      if (c("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Vg(u))
        throw new Error("Target container is not a DOM element.");
      if (t == null || !Is(t))
        throw new Error("parentComponent must be a valid React Component");
      return NC(t, r, u, !1, f);
    }
    var wb = !1;
    function Sj(t) {
      if (wb || (wb = !0, c("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Vg(t))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var r = og(t) && t._reactRootContainer === void 0;
        r && c("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (t._reactRootContainer) {
        {
          var u = Up(t), f = u && !Eo(u);
          f && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return xa(function() {
          NC(null, null, t, !1, function() {
            t._reactRootContainer = null, h8(t);
          });
        }), !0;
      } else {
        {
          var C = Up(t), p = !!(C && Eo(C)), b = t.nodeType === Cr && Vg(t.parentNode) && !!t.parentNode._reactRootContainer;
          p && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", b ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    go(oj), H6(sj), pu(lj), Vd(l3), Kd(W2), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && c("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), vd(ML), jl(hp, pk, xa);
    function Ej(t, r) {
      var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!zC(r))
        throw new Error("Target container is not a DOM element.");
      return ij(t, r, null, u);
    }
    function Mj(t, r, u, f) {
      return xj(t, r, u, f);
    }
    var Wp = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Eo, Hu, w9, kl, ds, hp]
    };
    function Tj(t, r) {
      return Wp.usingClientEntryPoint || c('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), Aj(t, r);
    }
    function Lj(t, r, u) {
      return Wp.usingClientEntryPoint || c('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), pj(t, r, u);
    }
    function Rj(t) {
      return Ry() && c("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), xa(t);
    }
    var Oj = Cj({
      findFiberByHostInstance: _s,
      bundleType: 1,
      version: zp,
      rendererPackageName: "react-dom"
    });
    if (!Oj && $1 && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var xb = window.location.protocol;
      /^(https?|file):$/.test(xb) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (xb === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    m3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Wp, m3.createPortal = Ej, m3.createRoot = Tj, m3.findDOMNode = yj, m3.flushSync = Rj, m3.hydrate = bj, m3.hydrateRoot = Lj, m3.render = wj, m3.unmountComponentAtNode = Sj, m3.unstable_batchedUpdates = hp, m3.unstable_renderSubtreeIntoContainer = Mj, m3.version = zp, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), m3;
}
function vM() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(vM);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (vM(), wh.exports = OK()) : wh.exports = DK();
var yM = wh.exports;
const KC = /* @__PURE__ */ _A(yM), ax = {
  disabled: !1
};
var kK = process.env.NODE_ENV !== "production" ? E.oneOfType([E.number, E.shape({
  enter: E.number,
  exit: E.number,
  appear: E.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && E.oneOfType([E.string, E.shape({
  enter: E.string,
  exit: E.string,
  active: E.string
}), E.shape({
  enter: E.string,
  enterDone: E.string,
  enterActive: E.string,
  exit: E.string,
  exitDone: E.string,
  exitActive: E.string
})]);
const MA = nn.createContext(null);
var jK = function(n) {
  return n.scrollTop;
}, uf = "unmounted", ol = "exited", sl = "entering", mc = "entered", xh = "exiting", N0 = /* @__PURE__ */ function(e) {
  sm(n, e);
  function n(a, s) {
    var g;
    g = e.call(this, a, s) || this;
    var c = s, I = c && !c.isMounting ? a.enter : a.appear, h;
    return g.appearStatus = null, a.in ? I ? (h = ol, g.appearStatus = sl) : h = mc : a.unmountOnExit || a.mountOnEnter ? h = uf : h = ol, g.state = {
      status: h
    }, g.nextCallback = null, g;
  }
  n.getDerivedStateFromProps = function(s, g) {
    var c = s.in;
    return c && g.status === uf ? {
      status: ol
    } : null;
  };
  var i = n.prototype;
  return i.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, i.componentDidUpdate = function(s) {
    var g = null;
    if (s !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== sl && c !== mc && (g = sl) : (c === sl || c === mc) && (g = xh);
    }
    this.updateStatus(!1, g);
  }, i.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, i.getTimeouts = function() {
    var s = this.props.timeout, g, c, I;
    return g = c = I = s, s != null && typeof s != "number" && (g = s.exit, c = s.enter, I = s.appear !== void 0 ? s.appear : c), {
      exit: g,
      enter: c,
      appear: I
    };
  }, i.updateStatus = function(s, g) {
    if (s === void 0 && (s = !1), g !== null)
      if (this.cancelNextCallback(), g === sl) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : KC.findDOMNode(this);
          c && jK(c);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === ol && this.setState({
      status: uf
    });
  }, i.performEnter = function(s) {
    var g = this, c = this.props.enter, I = this.context ? this.context.isMounting : s, h = this.props.nodeRef ? [I] : [KC.findDOMNode(this), I], m = h[0], w = h[1], x = this.getTimeouts(), M = I ? x.appear : x.enter;
    if (!s && !c || ax.disabled) {
      this.safeSetState({
        status: mc
      }, function() {
        g.props.onEntered(m);
      });
      return;
    }
    this.props.onEnter(m, w), this.safeSetState({
      status: sl
    }, function() {
      g.props.onEntering(m, w), g.onTransitionEnd(M, function() {
        g.safeSetState({
          status: mc
        }, function() {
          g.props.onEntered(m, w);
        });
      });
    });
  }, i.performExit = function() {
    var s = this, g = this.props.exit, c = this.getTimeouts(), I = this.props.nodeRef ? void 0 : KC.findDOMNode(this);
    if (!g || ax.disabled) {
      this.safeSetState({
        status: ol
      }, function() {
        s.props.onExited(I);
      });
      return;
    }
    this.props.onExit(I), this.safeSetState({
      status: xh
    }, function() {
      s.props.onExiting(I), s.onTransitionEnd(c.exit, function() {
        s.safeSetState({
          status: ol
        }, function() {
          s.props.onExited(I);
        });
      });
    });
  }, i.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, i.safeSetState = function(s, g) {
    g = this.setNextCallback(g), this.setState(s, g);
  }, i.setNextCallback = function(s) {
    var g = this, c = !0;
    return this.nextCallback = function(I) {
      c && (c = !1, g.nextCallback = null, s(I));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, i.onTransitionEnd = function(s, g) {
    this.setNextCallback(g);
    var c = this.props.nodeRef ? this.props.nodeRef.current : KC.findDOMNode(this), I = s == null && !this.props.addEndListener;
    if (!c || I) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var h = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], m = h[0], w = h[1];
      this.props.addEndListener(m, w);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, i.render = function() {
    var s = this.state.status;
    if (s === uf)
      return null;
    var g = this.props, c = g.children;
    g.in, g.mountOnEnter, g.unmountOnExit, g.appear, g.enter, g.exit, g.timeout, g.addEndListener, g.onEnter, g.onEntering, g.onEntered, g.onExit, g.onExiting, g.onExited, g.nodeRef;
    var I = Dt(g, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ nn.createElement(MA.Provider, {
        value: null
      }, typeof c == "function" ? c(s, I) : nn.cloneElement(nn.Children.only(c), I))
    );
  }, n;
}(nn.Component);
N0.contextType = MA;
N0.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: E.shape({
    current: typeof Element > "u" ? E.any : function(e, n, i, a, s, g) {
      var c = e[n];
      return E.instanceOf(c && "ownerDocument" in c ? c.ownerDocument.defaultView.Element : Element)(e, n, i, a, s, g);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: E.oneOfType([E.func.isRequired, E.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: E.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: E.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: E.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: E.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: E.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: E.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(n) {
    var i = kK;
    n.addEndListener || (i = i.isRequired);
    for (var a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), g = 1; g < a; g++)
      s[g - 1] = arguments[g];
    return i.apply(void 0, [n].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: E.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: E.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: E.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: E.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: E.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: E.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: E.func
} : {};
function Ic() {
}
N0.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ic,
  onEntering: Ic,
  onEntered: Ic,
  onExit: Ic,
  onExiting: Ic,
  onExited: Ic
};
N0.UNMOUNTED = uf;
N0.EXITED = ol;
N0.ENTERING = sl;
N0.ENTERED = mc;
N0.EXITING = xh;
function bm(e, n) {
  var i = function(g) {
    return n && nA(g) ? n(g) : g;
  }, a = /* @__PURE__ */ Object.create(null);
  return e && bz.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    a[s.key] = i(s);
  }), a;
}
function zK(e, n) {
  e = e || {}, n = n || {};
  function i(w) {
    return w in n ? n[w] : e[w];
  }
  var a = /* @__PURE__ */ Object.create(null), s = [];
  for (var g in e)
    g in n ? s.length && (a[g] = s, s = []) : s.push(g);
  var c, I = {};
  for (var h in n) {
    if (a[h])
      for (c = 0; c < a[h].length; c++) {
        var m = a[h][c];
        I[a[h][c]] = i(m);
      }
    I[h] = i(h);
  }
  for (c = 0; c < s.length; c++)
    I[s[c]] = i(s[c]);
  return I;
}
function gl(e, n, i) {
  return i[n] != null ? i[n] : e.props[n];
}
function NK(e, n) {
  return bm(e.children, function(i) {
    return rA(i, {
      onExited: n.bind(null, i),
      in: !0,
      appear: gl(i, "appear", e),
      enter: gl(i, "enter", e),
      exit: gl(i, "exit", e)
    });
  });
}
function PK(e, n, i) {
  var a = bm(e.children), s = zK(n, a);
  return Object.keys(s).forEach(function(g) {
    var c = s[g];
    if (nA(c)) {
      var I = g in n, h = g in a, m = n[g], w = nA(m) && !m.props.in;
      h && (!I || w) ? s[g] = rA(c, {
        onExited: i.bind(null, c),
        in: !0,
        exit: gl(c, "exit", e),
        enter: gl(c, "enter", e)
      }) : !h && I && !w ? s[g] = rA(c, {
        in: !1
      }) : h && I && nA(m) && (s[g] = rA(c, {
        onExited: i.bind(null, c),
        in: m.props.in,
        exit: gl(c, "exit", e),
        enter: gl(c, "enter", e)
      }));
    }
  }), s;
}
var FK = Object.values || function(e) {
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}, BK = {
  component: "div",
  childFactory: function(n) {
    return n;
  }
}, wm = /* @__PURE__ */ function(e) {
  sm(n, e);
  function n(a, s) {
    var g;
    g = e.call(this, a, s) || this;
    var c = g.handleExited.bind(xe(g));
    return g.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: c,
      firstRender: !0
    }, g;
  }
  var i = n.prototype;
  return i.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, i.componentWillUnmount = function() {
    this.mounted = !1;
  }, n.getDerivedStateFromProps = function(s, g) {
    var c = g.children, I = g.handleExited, h = g.firstRender;
    return {
      children: h ? NK(s, I) : PK(s, c, I),
      firstRender: !1
    };
  }, i.handleExited = function(s, g) {
    var c = bm(this.props.children);
    s.key in c || (s.props.onExited && s.props.onExited(g), this.mounted && this.setState(function(I) {
      var h = k1({}, I.children);
      return delete h[s.key], {
        children: h
      };
    }));
  }, i.render = function() {
    var s = this.props, g = s.component, c = s.childFactory, I = Dt(s, ["component", "childFactory"]), h = this.state.contextValue, m = FK(this.state.children).map(c);
    return delete I.appear, delete I.enter, delete I.exit, g === null ? /* @__PURE__ */ nn.createElement(MA.Provider, {
      value: h
    }, m) : /* @__PURE__ */ nn.createElement(MA.Provider, {
      value: h
    }, /* @__PURE__ */ nn.createElement(g, I, m));
  }, n;
}(nn.Component);
wm.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: E.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: E.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: E.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: E.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: E.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: E.func
} : {};
wm.defaultProps = BK;
function bM(e) {
  const {
    className: n,
    classes: i,
    pulsate: a = !1,
    rippleX: s,
    rippleY: g,
    rippleSize: c,
    in: I,
    onExited: h,
    timeout: m
  } = e, [w, x] = o1.useState(!1), M = tn(n, i.ripple, i.rippleVisible, a && i.ripplePulsate), O = {
    width: c,
    height: c,
    top: -(c / 2) + g,
    left: -(c / 2) + s
  }, k = tn(i.child, w && i.childLeaving, a && i.childPulsate);
  return !I && !w && x(!0), o1.useEffect(() => {
    if (!I && h != null) {
      const z = setTimeout(h, m);
      return () => {
        clearTimeout(z);
      };
    }
  }, [h, I, m]), /* @__PURE__ */ v.jsx("span", {
    className: M,
    style: O,
    children: /* @__PURE__ */ v.jsx("span", {
      className: k
    })
  });
}
process.env.NODE_ENV !== "production" && (bM.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object.isRequired,
  className: E.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: E.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: E.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: E.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: E.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: E.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: E.number,
  /**
   * exit delay
   */
  timeout: E.number.isRequired
});
const ii = y2("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), HK = ["center", "classes", "className"];
let g6 = (e) => e, ox, sx, lx, ux;
const Sh = 550, UK = 80, WK = WA(ox || (ox = g6`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), _K = WA(sx || (sx = g6`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), VK = WA(lx || (lx = g6`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), KK = kn("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), JK = kn(bM, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(ux || (ux = g6`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), ii.rippleVisible, WK, Sh, ({
  theme: e
}) => e.transitions.easing.easeInOut, ii.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, ii.child, ii.childLeaving, _K, Sh, ({
  theme: e
}) => e.transitions.easing.easeInOut, ii.childPulsate, VK, ({
  theme: e
}) => e.transitions.easing.easeInOut), wM = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: g = {},
    className: c
  } = a, I = Dt(a, HK), [h, m] = o1.useState([]), w = o1.useRef(0), x = o1.useRef(null);
  o1.useEffect(() => {
    x.current && (x.current(), x.current = null);
  }, [h]);
  const M = o1.useRef(!1), O = fE(), k = o1.useRef(null), z = o1.useRef(null), N = o1.useCallback((X) => {
    const {
      pulsate: B,
      rippleX: Z,
      rippleY: Y,
      rippleSize: V,
      cb: J
    } = X;
    m((e1) => [...e1, /* @__PURE__ */ v.jsx(JK, {
      classes: {
        ripple: tn(g.ripple, ii.ripple),
        rippleVisible: tn(g.rippleVisible, ii.rippleVisible),
        ripplePulsate: tn(g.ripplePulsate, ii.ripplePulsate),
        child: tn(g.child, ii.child),
        childLeaving: tn(g.childLeaving, ii.childLeaving),
        childPulsate: tn(g.childPulsate, ii.childPulsate)
      },
      timeout: Sh,
      pulsate: B,
      rippleX: Z,
      rippleY: Y,
      rippleSize: V
    }, w.current)]), w.current += 1, x.current = J;
  }, [g]), U = o1.useCallback((X = {}, B = {}, Z = () => {
  }) => {
    const {
      pulsate: Y = !1,
      center: V = s || B.pulsate,
      fakeElement: J = !1
      // For test purposes
    } = B;
    if ((X == null ? void 0 : X.type) === "mousedown" && M.current) {
      M.current = !1;
      return;
    }
    (X == null ? void 0 : X.type) === "touchstart" && (M.current = !0);
    const e1 = J ? null : z.current, f1 = e1 ? e1.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let v1, a1, d1;
    if (V || X === void 0 || X.clientX === 0 && X.clientY === 0 || !X.clientX && !X.touches)
      v1 = Math.round(f1.width / 2), a1 = Math.round(f1.height / 2);
    else {
      const {
        clientX: S1,
        clientY: h1
      } = X.touches && X.touches.length > 0 ? X.touches[0] : X;
      v1 = Math.round(S1 - f1.left), a1 = Math.round(h1 - f1.top);
    }
    if (V)
      d1 = Math.sqrt((2 * f1.width ** 2 + f1.height ** 2) / 3), d1 % 2 === 0 && (d1 += 1);
    else {
      const S1 = Math.max(Math.abs((e1 ? e1.clientWidth : 0) - v1), v1) * 2 + 2, h1 = Math.max(Math.abs((e1 ? e1.clientHeight : 0) - a1), a1) * 2 + 2;
      d1 = Math.sqrt(S1 ** 2 + h1 ** 2);
    }
    X != null && X.touches ? k.current === null && (k.current = () => {
      N({
        pulsate: Y,
        rippleX: v1,
        rippleY: a1,
        rippleSize: d1,
        cb: Z
      });
    }, O.start(UK, () => {
      k.current && (k.current(), k.current = null);
    })) : N({
      pulsate: Y,
      rippleX: v1,
      rippleY: a1,
      rippleSize: d1,
      cb: Z
    });
  }, [s, N, O]), Q = o1.useCallback(() => {
    U({}, {
      pulsate: !0
    });
  }, [U]), _ = o1.useCallback((X, B) => {
    if (O.clear(), (X == null ? void 0 : X.type) === "touchend" && k.current) {
      k.current(), k.current = null, O.start(0, () => {
        _(X, B);
      });
      return;
    }
    k.current = null, m((Z) => Z.length > 0 ? Z.slice(1) : Z), x.current = B;
  }, [O]);
  return o1.useImperativeHandle(i, () => ({
    pulsate: Q,
    start: U,
    stop: _
  }), [Q, U, _]), /* @__PURE__ */ v.jsx(KK, k1({
    className: tn(ii.root, g.root, c),
    ref: z
  }, I, {
    children: /* @__PURE__ */ v.jsx(wm, {
      component: null,
      exit: !0,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (wM.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: E.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string
});
function YK(e) {
  return lr("MuiButtonBase", e);
}
const QK = y2("MuiButtonBase", ["root", "disabled", "focusVisible"]), XK = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], GK = (e) => {
  const {
    disabled: n,
    focusVisible: i,
    focusVisibleClassName: a,
    classes: s
  } = e, c = Qr({
    root: ["root", n && "disabled", i && "focusVisible"]
  }, YK, s);
  return i && a && (c.root += ` ${a}`), c;
}, qK = kn("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${QK.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), xm = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: g = !1,
    children: c,
    className: I,
    component: h = "button",
    disabled: m = !1,
    disableRipple: w = !1,
    disableTouchRipple: x = !1,
    focusRipple: M = !1,
    LinkComponent: O = "a",
    onBlur: k,
    onClick: z,
    onContextMenu: N,
    onDragLeave: U,
    onFocus: Q,
    onFocusVisible: _,
    onKeyDown: X,
    onKeyUp: B,
    onMouseDown: Z,
    onMouseLeave: Y,
    onMouseUp: V,
    onTouchEnd: J,
    onTouchMove: e1,
    onTouchStart: f1,
    tabIndex: v1 = 0,
    TouchRippleProps: a1,
    touchRippleRef: d1,
    type: S1
  } = a, h1 = Dt(a, XK), L1 = o1.useRef(null), c1 = o1.useRef(null), b1 = _i(c1, d1), {
    isFocusVisibleRef: t1,
    onFocus: C1,
    onBlur: w1,
    ref: E1
  } = uF(), [V1, K1] = o1.useState(!1);
  m && V1 && K1(!1), o1.useImperativeHandle(s, () => ({
    focusVisible: () => {
      K1(!0), L1.current.focus();
    }
  }), []);
  const [B1, te] = o1.useState(!1);
  o1.useEffect(() => {
    te(!0);
  }, []);
  const R1 = B1 && !w && !m;
  o1.useEffect(() => {
    V1 && M && !w && B1 && c1.current.pulsate();
  }, [w, M, V1, B1]);
  function x1(Pe, yn, ee = x) {
    return vc((ge) => (yn && yn(ge), !ee && c1.current && c1.current[Pe](ge), !0));
  }
  const J1 = x1("start", Z), X1 = x1("stop", N), D1 = x1("stop", U), $1 = x1("stop", V), y1 = x1("stop", (Pe) => {
    V1 && Pe.preventDefault(), Y && Y(Pe);
  }), ie = x1("start", f1), ae = x1("stop", J), H1 = x1("stop", e1), Y1 = x1("stop", (Pe) => {
    w1(Pe), t1.current === !1 && K1(!1), k && k(Pe);
  }, !1), me = vc((Pe) => {
    L1.current || (L1.current = Pe.currentTarget), C1(Pe), t1.current === !0 && (K1(!0), _ && _(Pe)), Q && Q(Pe);
  }), ut = () => {
    const Pe = L1.current;
    return h && h !== "button" && !(Pe.tagName === "A" && Pe.href);
  }, Qe = o1.useRef(!1), Ae = vc((Pe) => {
    M && !Qe.current && V1 && c1.current && Pe.key === " " && (Qe.current = !0, c1.current.stop(Pe, () => {
      c1.current.start(Pe);
    })), Pe.target === Pe.currentTarget && ut() && Pe.key === " " && Pe.preventDefault(), X && X(Pe), Pe.target === Pe.currentTarget && ut() && Pe.key === "Enter" && !m && (Pe.preventDefault(), z && z(Pe));
  }), Bt = vc((Pe) => {
    M && Pe.key === " " && c1.current && V1 && !Pe.defaultPrevented && (Qe.current = !1, c1.current.stop(Pe, () => {
      c1.current.pulsate(Pe);
    })), B && B(Pe), z && Pe.target === Pe.currentTarget && ut() && Pe.key === " " && !Pe.defaultPrevented && z(Pe);
  });
  let ke = h;
  ke === "button" && (h1.href || h1.to) && (ke = O);
  const bt = {};
  ke === "button" ? (bt.type = S1 === void 0 ? "button" : S1, bt.disabled = m) : (!h1.href && !h1.to && (bt.role = "button"), m && (bt["aria-disabled"] = m));
  const pt = _i(i, E1, L1);
  process.env.NODE_ENV !== "production" && o1.useEffect(() => {
    R1 && !c1.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [R1]);
  const rt = k1({}, a, {
    centerRipple: g,
    component: h,
    disabled: m,
    disableRipple: w,
    disableTouchRipple: x,
    focusRipple: M,
    tabIndex: v1,
    focusVisible: V1
  }), Jt = GK(rt);
  return /* @__PURE__ */ v.jsxs(qK, k1({
    as: ke,
    className: tn(Jt.root, I),
    ownerState: rt,
    onBlur: Y1,
    onClick: z,
    onContextMenu: X1,
    onFocus: me,
    onKeyDown: Ae,
    onKeyUp: Bt,
    onMouseDown: J1,
    onMouseLeave: y1,
    onMouseUp: $1,
    onDragLeave: D1,
    onTouchEnd: ae,
    onTouchMove: H1,
    onTouchStart: ie,
    ref: pt,
    tabIndex: m ? -1 : v1,
    type: S1
  }, bt, h1, {
    children: [c, R1 ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ v.jsx(wM, k1({
        ref: b1,
        center: g
      }, a1))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (xm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: gE,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: E.bool,
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: uE,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: E.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: E.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: E.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: E.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: E.string,
  /**
   * @ignore
   */
  href: E.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: E.elementType,
  /**
   * @ignore
   */
  onBlur: E.func,
  /**
   * @ignore
   */
  onClick: E.func,
  /**
   * @ignore
   */
  onContextMenu: E.func,
  /**
   * @ignore
   */
  onDragLeave: E.func,
  /**
   * @ignore
   */
  onFocus: E.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: E.func,
  /**
   * @ignore
   */
  onKeyDown: E.func,
  /**
   * @ignore
   */
  onKeyUp: E.func,
  /**
   * @ignore
   */
  onMouseDown: E.func,
  /**
   * @ignore
   */
  onMouseLeave: E.func,
  /**
   * @ignore
   */
  onMouseUp: E.func,
  /**
   * @ignore
   */
  onTouchEnd: E.func,
  /**
   * @ignore
   */
  onTouchMove: E.func,
  /**
   * @ignore
   */
  onTouchStart: E.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * @default 0
   */
  tabIndex: E.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: E.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: E.oneOfType([E.func, E.shape({
    current: E.shape({
      pulsate: E.func.isRequired,
      start: E.func.isRequired,
      stop: E.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: E.oneOfType([E.oneOf(["button", "reset", "submit"]), E.string])
});
function ZK(e) {
  return lr("MuiIconButton", e);
}
const $K = y2("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), eJ = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], tJ = (e) => {
  const {
    classes: n,
    disabled: i,
    color: a,
    edge: s,
    size: g
  } = e, c = {
    root: ["root", i && "disabled", a !== "default" && `color${sr(a)}`, s && `edge${sr(s)}`, `size${sr(g)}`]
  };
  return Qr(c, ZK, n);
}, nJ = kn(xm, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.color !== "default" && n[`color${sr(i.color)}`], i.edge && n[`edge${sr(i.edge)}`], n[`size${sr(i.size)}`]];
  }
})(({
  theme: e,
  ownerState: n
}) => k1({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !n.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : oi(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, n.edge === "start" && {
  marginLeft: n.size === "small" ? -3 : -12
}, n.edge === "end" && {
  marginRight: n.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: n
}) => {
  var i;
  const a = (i = (e.vars || e).palette) == null ? void 0 : i[n.color];
  return k1({}, n.color === "inherit" && {
    color: "inherit"
  }, n.color !== "inherit" && n.color !== "default" && k1({
    color: a == null ? void 0 : a.main
  }, !n.disableRipple && {
    "&:hover": k1({}, a && {
      backgroundColor: e.vars ? `rgba(${a.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : oi(a.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), n.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, n.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${$K.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), xM = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: g,
    className: c,
    color: I = "default",
    disabled: h = !1,
    disableFocusRipple: m = !1,
    size: w = "medium"
  } = a, x = Dt(a, eJ), M = k1({}, a, {
    edge: s,
    color: I,
    disabled: h,
    disableFocusRipple: m,
    size: w
  }), O = tJ(M);
  return /* @__PURE__ */ v.jsx(nJ, k1({
    className: tn(O.root, c),
    centerRipple: !0,
    focusRipple: !m,
    disabled: h,
    ref: i
  }, x, {
    ownerState: M,
    children: g
  }));
});
process.env.NODE_ENV !== "production" && (xM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Fc(E.node, (e) => o1.Children.toArray(e.children).some((i) => /* @__PURE__ */ o1.isValidElement(i) && i.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: E.oneOfType([E.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), E.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: E.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: E.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: E.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: E.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: E.oneOfType([E.oneOf(["small", "medium", "large"]), E.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const Be1 = (e) => {
  const [n, i] = Tz(), a = m2(() => {
    const h = {};
    for (const [m, w] of n.entries())
      h[m] = w;
    return h;
  }, [n]), s = V2(a, [a]), g = m2(
    (h) => {
      Object.keys(h).forEach((m) => {
        n.set(m, h[m] || "");
      }), i(n, { replace: !0 });
    },
    [i]
  ), c = m2(
    (h) => {
      const w = {
        ...a(),
        ...h
      };
      g(w);
    },
    [a, g]
  ), I = m2(() => {
    const h = [];
    for (const [m, w] of n.entries()) {
      const x = e[m];
      (x !== w || x === void 0) && h.push(m);
    }
    return h;
  }, [n]);
  return pf(() => {
    const h = a(), m = {
      ...e,
      ...h
    };
    g(m);
  }, [a, g]), {
    state: s,
    getState: a,
    setState: g,
    updateState: c,
    listChangedParams: I
  };
}, rJ = () => {
  const e = ka(), n = hc(e.breakpoints.only("xs")), i = hc(e.breakpoints.only("sm")), a = hc(e.breakpoints.only("md")), s = hc(e.breakpoints.only("lg")), g = hc(e.breakpoints.only("xl")), c = n || i;
  return {
    isXs: n,
    isSm: i,
    isMd: a,
    isLg: s,
    isXl: g,
    isMobile: c,
    isTablet: a,
    isDesktop: !c
  };
}, iJ = typeof window > "u" ? vn : pf;
function cx() {
  var e, n, i, a;
  return typeof window > "u" ? { height: 430, width: 320, top: 0, left: 0, layoutHeight: 430 } : {
    height: ((e = window.visualViewport) == null ? void 0 : e.height) ?? window.innerHeight,
    width: ((n = window.visualViewport) == null ? void 0 : n.width) ?? window.innerWidth,
    top: ((i = window.visualViewport) == null ? void 0 : i.offsetTop) ?? 0,
    left: ((a = window.visualViewport) == null ? void 0 : a.offsetLeft) ?? 0,
    layoutHeight: window.innerHeight
  };
}
function aJ(e, n, i, a) {
  const [s, g] = gt(cx), [c, I] = gt(null);
  iJ(() => {
    var x, M;
    if (!e || !n) return;
    const w = () => {
      g(cx()), I((i == null ? void 0 : i.getBoundingClientRect().left) ?? null);
    };
    return w(), (x = window.visualViewport) == null || x.addEventListener("resize", w), (M = window.visualViewport) == null || M.addEventListener("scroll", w), window.addEventListener("resize", w), window.addEventListener("scroll", w), () => {
      var O, k;
      (O = window.visualViewport) == null || O.removeEventListener("resize", w), (k = window.visualViewport) == null || k.removeEventListener("scroll", w), window.removeEventListener("resize", w), window.removeEventListener("scroll", w);
    };
  }, [e, n, i]);
  const h = Math.min(a, Math.max(0, s.width - 16)), m = Math.max(s.left + 8, Math.min(
    c ?? s.left + 8,
    s.left + s.width - h - 8
  ));
  return {
    viewport: s,
    // Landscape or keyboard-shrunken viewports need a predictable bottom edge.
    compact: s.height <= 430 || s.height < s.layoutHeight - 100,
    veryShort: s.height < 220,
    anchorPosition: {
      top: Math.round(s.top + s.height - 8),
      left: Math.round(m)
    }
  };
}
const Sm = ja(
  ({
    icon: e,
    to: n,
    href: i,
    state: a = {},
    target: s,
    children: g,
    ...c
  }, I) => {
    const h = a6({ to: n, href: i, state: a, target: s }), m = V2(() => e ? /* @__PURE__ */ v.jsx(De, { icon: e }) : g, [e, g]);
    return /* @__PURE__ */ v.jsx(xM, { ref: I, ...c, ...h, children: m });
  }
), He1 = ({
  ariaLabel: e = "",
  children: n
}) => /* @__PURE__ */ v.jsx(Wj, { "aria-label": e, children: n });
function Em(e) {
  return /* @__PURE__ */ v.jsx(dl, { ...e });
}
function kt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var n = Number(e);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function ue(e, n) {
  if (n.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function de(e) {
  ue(1, arguments);
  var n = Object.prototype.toString.call(e);
  return e instanceof Date || Ra(e) === "object" && n === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || n === "[object Number]" ? new Date(e) : ((typeof e == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function fA(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && i.setDate(i.getDate() + a), i);
}
function f6(e, n) {
  ue(2, arguments);
  var i = de(e).getTime(), a = kt(n);
  return new Date(i + a);
}
function oJ(e, n) {
  ue(2, arguments);
  var i = kt(n);
  return f6(e, i * 1e3);
}
var sJ = 6e4;
function lJ(e, n) {
  ue(2, arguments);
  var i = kt(n);
  return f6(e, i * sJ);
}
var uJ = 36e5;
function cJ(e, n) {
  ue(2, arguments);
  var i = kt(n);
  return f6(e, i * uJ);
}
function gJ(e, n) {
  ue(2, arguments);
  var i = kt(n), a = i * 7;
  return fA(e, a);
}
function dA(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return i;
  var s = i.getDate(), g = new Date(i.getTime());
  g.setMonth(i.getMonth() + a + 1, 0);
  var c = g.getDate();
  return s >= c ? g : (i.setFullYear(g.getFullYear(), g.getMonth(), s), i);
}
function gx(e, n) {
  ue(2, arguments);
  var i = kt(n);
  return dA(e, i * 12);
}
function fJ(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n);
  return i.getFullYear() - a.getFullYear();
}
function df(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n), s = i.getTime() - a.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function dJ(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n), s = df(i, a), g = Math.abs(fJ(i, a));
  i.setFullYear(1584), a.setFullYear(1584);
  var c = df(i, a) === -s, I = s * (g - Number(c));
  return I === 0 ? 0 : I;
}
function CJ(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n), s = i.getFullYear() - a.getFullYear(), g = i.getMonth() - a.getMonth();
  return s * 12 + g;
}
function Eh(e) {
  ue(1, arguments);
  var n = de(e);
  return n.setHours(23, 59, 59, 999), n;
}
function Mh(e) {
  ue(1, arguments);
  var n = de(e), i = n.getMonth();
  return n.setFullYear(n.getFullYear(), i + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function AJ(e) {
  ue(1, arguments);
  var n = de(e);
  return Eh(n).getTime() === Mh(n).getTime();
}
function SM(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n), s = df(i, a), g = Math.abs(CJ(i, a)), c;
  if (g < 1)
    c = 0;
  else {
    i.getMonth() === 1 && i.getDate() > 27 && i.setDate(30), i.setMonth(i.getMonth() - s * g);
    var I = df(i, a) === -s;
    AJ(de(e)) && g === 1 && df(e, a) === 1 && (I = !1), c = s * (g - Number(I));
  }
  return c === 0 ? 0 : c;
}
var fx = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(n) {
    return n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  // Math.trunc is not supported by IE
}, IJ = "trunc";
function Bf(e) {
  return e ? fx[e] : fx[IJ];
}
function pJ(e, n, i) {
  ue(2, arguments);
  var a = SM(e, n) / 3;
  return Bf(void 0)(a);
}
function TA(e) {
  var n = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return n.setUTCFullYear(e.getFullYear()), e.getTime() - n.getTime();
}
function jc(e) {
  ue(1, arguments);
  var n = de(e);
  return n.setHours(0, 0, 0, 0), n;
}
var hJ = 864e5;
function mJ(e, n) {
  ue(2, arguments);
  var i = jc(e), a = jc(n), s = i.getTime() - TA(i), g = a.getTime() - TA(a);
  return Math.round((s - g) / hJ);
}
function dx(e, n) {
  var i = e.getFullYear() - n.getFullYear() || e.getMonth() - n.getMonth() || e.getDate() - n.getDate() || e.getHours() - n.getHours() || e.getMinutes() - n.getMinutes() || e.getSeconds() - n.getSeconds() || e.getMilliseconds() - n.getMilliseconds();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function EM(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n), s = dx(i, a), g = Math.abs(mJ(i, a));
  i.setDate(i.getDate() - s * g);
  var c = +(dx(i, a) === -s), I = s * (g - c);
  return I === 0 ? 0 : I;
}
function vJ(e, n, i) {
  ue(2, arguments);
  var a = EM(e, n) / 7;
  return Bf(void 0)(a);
}
var d6 = 6e4, C6 = 36e5, yJ = 1e3;
function A6(e, n) {
  return ue(2, arguments), de(e).getTime() - de(n).getTime();
}
function bJ(e, n, i) {
  ue(2, arguments);
  var a = A6(e, n) / C6;
  return Bf(void 0)(a);
}
function wJ(e, n, i) {
  ue(2, arguments);
  var a = A6(e, n) / d6;
  return Bf(void 0)(a);
}
function xJ(e, n, i) {
  ue(2, arguments);
  var a = A6(e, n) / 1e3;
  return Bf(void 0)(a);
}
function SJ(e, n) {
  var i;
  ue(1, arguments);
  var a = e || {}, s = de(a.start), g = de(a.end), c = g.getTime();
  if (!(s.getTime() <= c))
    throw new RangeError("Invalid interval");
  var I = [], h = s;
  h.setHours(0, 0, 0, 0);
  var m = Number((i = void 0) !== null && i !== void 0 ? i : 1);
  if (m < 1 || isNaN(m)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; h.getTime() <= c; )
    I.push(de(h)), h.setDate(h.getDate() + m), h.setHours(0, 0, 0, 0);
  return I;
}
var EJ = {};
function P0() {
  return EJ;
}
function f7(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = P0(), x = kt((i = (a = (s = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && i !== void 0 ? i : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var M = de(e), O = M.getDay(), k = (O < x ? -7 : 0) + 6 - (O - x);
  return M.setDate(M.getDate() + k), M.setHours(23, 59, 59, 999), M;
}
function d7(e) {
  ue(1, arguments);
  var n = de(e), i = n.getFullYear();
  return n.setFullYear(i + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function MJ(e) {
  return ue(1, arguments), e instanceof Date || Ra(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function MM(e) {
  if (ue(1, arguments), !MJ(e) && typeof e != "number")
    return !1;
  var n = de(e);
  return !isNaN(Number(n));
}
function TM(e, n) {
  ue(2, arguments);
  var i = kt(n);
  return f6(e, -i);
}
var TJ = 864e5;
function LJ(e) {
  ue(1, arguments);
  var n = de(e), i = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var a = n.getTime(), s = i - a;
  return Math.floor(s / TJ) + 1;
}
function zc(e) {
  ue(1, arguments);
  var n = 1, i = de(e), a = i.getUTCDay(), s = (a < n ? 7 : 0) + a - n;
  return i.setUTCDate(i.getUTCDate() - s), i.setUTCHours(0, 0, 0, 0), i;
}
function LM(e) {
  ue(1, arguments);
  var n = de(e), i = n.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(i + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var s = zc(a), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(i, 0, 4), g.setUTCHours(0, 0, 0, 0);
  var c = zc(g);
  return n.getTime() >= s.getTime() ? i + 1 : n.getTime() >= c.getTime() ? i : i - 1;
}
function RJ(e) {
  ue(1, arguments);
  var n = LM(e), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var a = zc(i);
  return a;
}
var OJ = 6048e5;
function RM(e) {
  ue(1, arguments);
  var n = de(e), i = zc(n).getTime() - RJ(n).getTime();
  return Math.round(i / OJ) + 1;
}
function pl(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = P0(), x = kt((i = (a = (s = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && i !== void 0 ? i : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var M = de(e), O = M.getUTCDay(), k = (O < x ? 7 : 0) + O - x;
  return M.setUTCDate(M.getUTCDate() - k), M.setUTCHours(0, 0, 0, 0), M;
}
function Mm(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = de(e), x = w.getUTCFullYear(), M = P0(), O = kt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : M.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = M.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = /* @__PURE__ */ new Date(0);
  k.setUTCFullYear(x + 1, 0, O), k.setUTCHours(0, 0, 0, 0);
  var z = pl(k, n), N = /* @__PURE__ */ new Date(0);
  N.setUTCFullYear(x, 0, O), N.setUTCHours(0, 0, 0, 0);
  var U = pl(N, n);
  return w.getTime() >= z.getTime() ? x + 1 : w.getTime() >= U.getTime() ? x : x - 1;
}
function DJ(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = P0(), x = kt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1), M = Mm(e, n), O = /* @__PURE__ */ new Date(0);
  O.setUTCFullYear(M, 0, x), O.setUTCHours(0, 0, 0, 0);
  var k = pl(O, n);
  return k;
}
var kJ = 6048e5;
function OM(e, n) {
  ue(1, arguments);
  var i = de(e), a = pl(i, n).getTime() - DJ(i, n).getTime();
  return Math.round(a / kJ) + 1;
}
function yt(e, n) {
  for (var i = e < 0 ? "-" : "", a = Math.abs(e).toString(); a.length < n; )
    a = "0" + a;
  return i + a;
}
var _o = {
  // Year
  y: function(n, i) {
    var a = n.getUTCFullYear(), s = a > 0 ? a : 1 - a;
    return yt(i === "yy" ? s % 100 : s, i.length);
  },
  // Month
  M: function(n, i) {
    var a = n.getUTCMonth();
    return i === "M" ? String(a + 1) : yt(a + 1, 2);
  },
  // Day of the month
  d: function(n, i) {
    return yt(n.getUTCDate(), i.length);
  },
  // AM or PM
  a: function(n, i) {
    var a = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (i) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, i) {
    return yt(n.getUTCHours() % 12 || 12, i.length);
  },
  // Hour [0-23]
  H: function(n, i) {
    return yt(n.getUTCHours(), i.length);
  },
  // Minute
  m: function(n, i) {
    return yt(n.getUTCMinutes(), i.length);
  },
  // Second
  s: function(n, i) {
    return yt(n.getUTCSeconds(), i.length);
  },
  // Fraction of second
  S: function(n, i) {
    var a = i.length, s = n.getUTCMilliseconds(), g = Math.floor(s * Math.pow(10, a - 3));
    return yt(g, i.length);
  }
}, pc = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, jJ = {
  // Era
  G: function(n, i, a) {
    var s = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (i) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, i, a) {
    if (i === "yo") {
      var s = n.getUTCFullYear(), g = s > 0 ? s : 1 - s;
      return a.ordinalNumber(g, {
        unit: "year"
      });
    }
    return _o.y(n, i);
  },
  // Local week-numbering year
  Y: function(n, i, a, s) {
    var g = Mm(n, s), c = g > 0 ? g : 1 - g;
    if (i === "YY") {
      var I = c % 100;
      return yt(I, 2);
    }
    return i === "Yo" ? a.ordinalNumber(c, {
      unit: "year"
    }) : yt(c, i.length);
  },
  // ISO week-numbering year
  R: function(n, i) {
    var a = LM(n);
    return yt(a, i.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, i) {
    var a = n.getUTCFullYear();
    return yt(a, i.length);
  },
  // Quarter
  Q: function(n, i, a) {
    var s = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (i) {
      case "Q":
        return String(s);
      case "QQ":
        return yt(s, 2);
      case "Qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, i, a) {
    var s = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (i) {
      case "q":
        return String(s);
      case "qq":
        return yt(s, 2);
      case "qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, i, a) {
    var s = n.getUTCMonth();
    switch (i) {
      case "M":
      case "MM":
        return _o.M(n, i);
      case "Mo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, i, a) {
    var s = n.getUTCMonth();
    switch (i) {
      case "L":
        return String(s + 1);
      case "LL":
        return yt(s + 1, 2);
      case "Lo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, i, a, s) {
    var g = OM(n, s);
    return i === "wo" ? a.ordinalNumber(g, {
      unit: "week"
    }) : yt(g, i.length);
  },
  // ISO week of year
  I: function(n, i, a) {
    var s = RM(n);
    return i === "Io" ? a.ordinalNumber(s, {
      unit: "week"
    }) : yt(s, i.length);
  },
  // Day of the month
  d: function(n, i, a) {
    return i === "do" ? a.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : _o.d(n, i);
  },
  // Day of year
  D: function(n, i, a) {
    var s = LJ(n);
    return i === "Do" ? a.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : yt(s, i.length);
  },
  // Day of week
  E: function(n, i, a) {
    var s = n.getUTCDay();
    switch (i) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, i, a, s) {
    var g = n.getUTCDay(), c = (g - s.weekStartsOn + 8) % 7 || 7;
    switch (i) {
      case "e":
        return String(c);
      case "ee":
        return yt(c, 2);
      case "eo":
        return a.ordinalNumber(c, {
          unit: "day"
        });
      case "eee":
        return a.day(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(g, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(g, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, i, a, s) {
    var g = n.getUTCDay(), c = (g - s.weekStartsOn + 8) % 7 || 7;
    switch (i) {
      case "c":
        return String(c);
      case "cc":
        return yt(c, i.length);
      case "co":
        return a.ordinalNumber(c, {
          unit: "day"
        });
      case "ccc":
        return a.day(g, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(g, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(g, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(g, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, i, a) {
    var s = n.getUTCDay(), g = s === 0 ? 7 : s;
    switch (i) {
      case "i":
        return String(g);
      case "ii":
        return yt(g, i.length);
      case "io":
        return a.ordinalNumber(g, {
          unit: "day"
        });
      case "iii":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, i, a) {
    var s = n.getUTCHours(), g = s / 12 >= 1 ? "pm" : "am";
    switch (i) {
      case "a":
      case "aa":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(g, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, i, a) {
    var s = n.getUTCHours(), g;
    switch (s === 12 ? g = pc.noon : s === 0 ? g = pc.midnight : g = s / 12 >= 1 ? "pm" : "am", i) {
      case "b":
      case "bb":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(g, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, i, a) {
    var s = n.getUTCHours(), g;
    switch (s >= 17 ? g = pc.evening : s >= 12 ? g = pc.afternoon : s >= 4 ? g = pc.morning : g = pc.night, i) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(g, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(g, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(g, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, i, a) {
    if (i === "ho") {
      var s = n.getUTCHours() % 12;
      return s === 0 && (s = 12), a.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return _o.h(n, i);
  },
  // Hour [0-23]
  H: function(n, i, a) {
    return i === "Ho" ? a.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : _o.H(n, i);
  },
  // Hour [0-11]
  K: function(n, i, a) {
    var s = n.getUTCHours() % 12;
    return i === "Ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : yt(s, i.length);
  },
  // Hour [1-24]
  k: function(n, i, a) {
    var s = n.getUTCHours();
    return s === 0 && (s = 24), i === "ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : yt(s, i.length);
  },
  // Minute
  m: function(n, i, a) {
    return i === "mo" ? a.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : _o.m(n, i);
  },
  // Second
  s: function(n, i, a) {
    return i === "so" ? a.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : _o.s(n, i);
  },
  // Fraction of second
  S: function(n, i) {
    return _o.S(n, i);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    if (c === 0)
      return "Z";
    switch (i) {
      case "X":
        return Ax(c);
      case "XXXX":
      case "XX":
        return ll(c);
      case "XXXXX":
      case "XXX":
      default:
        return ll(c, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    switch (i) {
      case "x":
        return Ax(c);
      case "xxxx":
      case "xx":
        return ll(c);
      case "xxxxx":
      case "xxx":
      default:
        return ll(c, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    switch (i) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Cx(c, ":");
      case "OOOO":
      default:
        return "GMT" + ll(c, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTimezoneOffset();
    switch (i) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Cx(c, ":");
      case "zzzz":
      default:
        return "GMT" + ll(c, ":");
    }
  },
  // Seconds timestamp
  t: function(n, i, a, s) {
    var g = s._originalDate || n, c = Math.floor(g.getTime() / 1e3);
    return yt(c, i.length);
  },
  // Milliseconds timestamp
  T: function(n, i, a, s) {
    var g = s._originalDate || n, c = g.getTime();
    return yt(c, i.length);
  }
};
function Cx(e, n) {
  var i = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.floor(a / 60), g = a % 60;
  if (g === 0)
    return i + String(s);
  var c = n;
  return i + String(s) + c + yt(g, 2);
}
function Ax(e, n) {
  if (e % 60 === 0) {
    var i = e > 0 ? "-" : "+";
    return i + yt(Math.abs(e) / 60, 2);
  }
  return ll(e, n);
}
function ll(e, n) {
  var i = n || "", a = e > 0 ? "-" : "+", s = Math.abs(e), g = yt(Math.floor(s / 60), 2), c = yt(s % 60, 2);
  return a + g + i + c;
}
var Ix = function(n, i) {
  switch (n) {
    case "P":
      return i.date({
        width: "short"
      });
    case "PP":
      return i.date({
        width: "medium"
      });
    case "PPP":
      return i.date({
        width: "long"
      });
    case "PPPP":
    default:
      return i.date({
        width: "full"
      });
  }
}, DM = function(n, i) {
  switch (n) {
    case "p":
      return i.time({
        width: "short"
      });
    case "pp":
      return i.time({
        width: "medium"
      });
    case "ppp":
      return i.time({
        width: "long"
      });
    case "pppp":
    default:
      return i.time({
        width: "full"
      });
  }
}, zJ = function(n, i) {
  var a = n.match(/(P+)(p+)?/) || [], s = a[1], g = a[2];
  if (!g)
    return Ix(n, i);
  var c;
  switch (s) {
    case "P":
      c = i.dateTime({
        width: "short"
      });
      break;
    case "PP":
      c = i.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      c = i.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      c = i.dateTime({
        width: "full"
      });
      break;
  }
  return c.replace("{{date}}", Ix(s, i)).replace("{{time}}", DM(g, i));
}, Th = {
  p: DM,
  P: zJ
}, NJ = ["D", "DD"], PJ = ["YY", "YYYY"];
function kM(e) {
  return NJ.indexOf(e) !== -1;
}
function jM(e) {
  return PJ.indexOf(e) !== -1;
}
function LA(e, n, i) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(i, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var FJ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, BJ = function(n, i, a) {
  var s, g = FJ[n];
  return typeof g == "string" ? s = g : i === 1 ? s = g.one : s = g.other.replace("{{count}}", i.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + s : s + " ago" : s;
};
function C7(e) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = n.width ? String(n.width) : e.defaultWidth, a = e.formats[i] || e.formats[e.defaultWidth];
    return a;
  };
}
var HJ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, UJ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, WJ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _J = {
  date: C7({
    formats: HJ,
    defaultWidth: "full"
  }),
  time: C7({
    formats: UJ,
    defaultWidth: "full"
  }),
  dateTime: C7({
    formats: WJ,
    defaultWidth: "full"
  })
}, VJ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, KJ = function(n, i, a, s) {
  return VJ[n];
};
function qg(e) {
  return function(n, i) {
    var a = i != null && i.context ? String(i.context) : "standalone", s;
    if (a === "formatting" && e.formattingValues) {
      var g = e.defaultFormattingWidth || e.defaultWidth, c = i != null && i.width ? String(i.width) : g;
      s = e.formattingValues[c] || e.formattingValues[g];
    } else {
      var I = e.defaultWidth, h = i != null && i.width ? String(i.width) : e.defaultWidth;
      s = e.values[h] || e.values[I];
    }
    var m = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[m];
  };
}
var JJ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, YJ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, QJ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, XJ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, GJ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qJ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ZJ = function(n, i) {
  var a = Number(n), s = a % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, $J = {
  ordinalNumber: ZJ,
  era: qg({
    values: JJ,
    defaultWidth: "wide"
  }),
  quarter: qg({
    values: YJ,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: qg({
    values: QJ,
    defaultWidth: "wide"
  }),
  day: qg({
    values: XJ,
    defaultWidth: "wide"
  }),
  dayPeriod: qg({
    values: GJ,
    defaultWidth: "wide",
    formattingValues: qJ,
    defaultFormattingWidth: "wide"
  })
};
function Zg(e) {
  return function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = i.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], g = n.match(s);
    if (!g)
      return null;
    var c = g[0], I = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], h = Array.isArray(I) ? tY(I, function(x) {
      return x.test(c);
    }) : eY(I, function(x) {
      return x.test(c);
    }), m;
    m = e.valueCallback ? e.valueCallback(h) : h, m = i.valueCallback ? i.valueCallback(m) : m;
    var w = n.slice(c.length);
    return {
      value: m,
      rest: w
    };
  };
}
function eY(e, n) {
  for (var i in e)
    if (e.hasOwnProperty(i) && n(e[i]))
      return i;
}
function tY(e, n) {
  for (var i = 0; i < e.length; i++)
    if (n(e[i]))
      return i;
}
function nY(e) {
  return function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.match(e.matchPattern);
    if (!a) return null;
    var s = a[0], g = n.match(e.parsePattern);
    if (!g) return null;
    var c = e.valueCallback ? e.valueCallback(g[0]) : g[0];
    c = i.valueCallback ? i.valueCallback(c) : c;
    var I = n.slice(s.length);
    return {
      value: c,
      rest: I
    };
  };
}
var rY = /^(\d+)(th|st|nd|rd)?/i, iY = /\d+/i, aY = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, oY = {
  any: [/^b/i, /^(a|c)/i]
}, sY = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, lY = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, uY = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, cY = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, gY = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, fY = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, dY = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, CY = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, AY = {
  ordinalNumber: nY({
    matchPattern: rY,
    parsePattern: iY,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: Zg({
    matchPatterns: aY,
    defaultMatchWidth: "wide",
    parsePatterns: oY,
    defaultParseWidth: "any"
  }),
  quarter: Zg({
    matchPatterns: sY,
    defaultMatchWidth: "wide",
    parsePatterns: lY,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: Zg({
    matchPatterns: uY,
    defaultMatchWidth: "wide",
    parsePatterns: cY,
    defaultParseWidth: "any"
  }),
  day: Zg({
    matchPatterns: gY,
    defaultMatchWidth: "wide",
    parsePatterns: fY,
    defaultParseWidth: "any"
  }),
  dayPeriod: Zg({
    matchPatterns: dY,
    defaultMatchWidth: "any",
    parsePatterns: CY,
    defaultParseWidth: "any"
  })
}, Tm = {
  code: "en-US",
  formatDistance: BJ,
  formatLong: _J,
  formatRelative: KJ,
  localize: $J,
  match: AY,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, IY = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pY = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hY = /^'([^]*?)'?$/, mY = /''/g, vY = /[a-zA-Z]/;
function yY(e, n, i) {
  var a, s, g, c, I, h, m, w, x, M, O, k, z, N, U, Q, _, X;
  ue(2, arguments);
  var B = String(n), Z = P0(), Y = (a = (s = i == null ? void 0 : i.locale) !== null && s !== void 0 ? s : Z.locale) !== null && a !== void 0 ? a : Tm, V = kt((g = (c = (I = (h = i == null ? void 0 : i.firstWeekContainsDate) !== null && h !== void 0 ? h : i == null || (m = i.locale) === null || m === void 0 || (w = m.options) === null || w === void 0 ? void 0 : w.firstWeekContainsDate) !== null && I !== void 0 ? I : Z.firstWeekContainsDate) !== null && c !== void 0 ? c : (x = Z.locale) === null || x === void 0 || (M = x.options) === null || M === void 0 ? void 0 : M.firstWeekContainsDate) !== null && g !== void 0 ? g : 1);
  if (!(V >= 1 && V <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var J = kt((O = (k = (z = (N = i == null ? void 0 : i.weekStartsOn) !== null && N !== void 0 ? N : i == null || (U = i.locale) === null || U === void 0 || (Q = U.options) === null || Q === void 0 ? void 0 : Q.weekStartsOn) !== null && z !== void 0 ? z : Z.weekStartsOn) !== null && k !== void 0 ? k : (_ = Z.locale) === null || _ === void 0 || (X = _.options) === null || X === void 0 ? void 0 : X.weekStartsOn) !== null && O !== void 0 ? O : 0);
  if (!(J >= 0 && J <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!Y.localize)
    throw new RangeError("locale must contain localize property");
  if (!Y.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var e1 = de(e);
  if (!MM(e1))
    throw new RangeError("Invalid time value");
  var f1 = TA(e1), v1 = TM(e1, f1), a1 = {
    firstWeekContainsDate: V,
    weekStartsOn: J,
    locale: Y,
    _originalDate: e1
  }, d1 = B.match(pY).map(function(S1) {
    var h1 = S1[0];
    if (h1 === "p" || h1 === "P") {
      var L1 = Th[h1];
      return L1(S1, Y.formatLong);
    }
    return S1;
  }).join("").match(IY).map(function(S1) {
    if (S1 === "''")
      return "'";
    var h1 = S1[0];
    if (h1 === "'")
      return bY(S1);
    var L1 = jJ[h1];
    if (L1)
      return !(i != null && i.useAdditionalWeekYearTokens) && jM(S1) && LA(S1, n, String(e)), !(i != null && i.useAdditionalDayOfYearTokens) && kM(S1) && LA(S1, n, String(e)), L1(v1, S1, Y.localize, a1);
    if (h1.match(vY))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + h1 + "`");
    return S1;
  }).join("");
  return d1;
}
function bY(e) {
  var n = e.match(hY);
  return n ? n[1].replace(mY, "'") : e;
}
function wY(e) {
  ue(1, arguments);
  var n = de(e), i = n.getDate();
  return i;
}
function zM(e) {
  ue(1, arguments);
  var n = de(e), i = n.getFullYear(), a = n.getMonth(), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(i, a + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function xY(e) {
  ue(1, arguments);
  var n = de(e), i = n.getHours();
  return i;
}
function SY(e) {
  ue(1, arguments);
  var n = de(e), i = n.getMinutes();
  return i;
}
function EY(e) {
  ue(1, arguments);
  var n = de(e), i = n.getMonth();
  return i;
}
function MY(e) {
  ue(1, arguments);
  var n = de(e), i = n.getSeconds();
  return i;
}
function TY(e) {
  ue(1, arguments);
  var n = de(e), i = n.getMilliseconds();
  return i;
}
function fl(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = P0(), x = kt((i = (a = (s = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && i !== void 0 ? i : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var M = de(e), O = M.getDay(), k = (O < x ? 7 : 0) + O - x;
  return M.setDate(M.getDate() - k), M.setHours(0, 0, 0, 0), M;
}
function LY(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = de(e), x = w.getFullYear(), M = P0(), O = kt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : M.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = M.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = /* @__PURE__ */ new Date(0);
  k.setFullYear(x + 1, 0, O), k.setHours(0, 0, 0, 0);
  var z = fl(k, n), N = /* @__PURE__ */ new Date(0);
  N.setFullYear(x, 0, O), N.setHours(0, 0, 0, 0);
  var U = fl(N, n);
  return w.getTime() >= z.getTime() ? x + 1 : w.getTime() >= U.getTime() ? x : x - 1;
}
function RY(e, n) {
  var i, a, s, g, c, I, h, m;
  ue(1, arguments);
  var w = P0(), x = kt((i = (a = (s = (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0 ? g : n == null || (c = n.locale) === null || c === void 0 || (I = c.options) === null || I === void 0 ? void 0 : I.firstWeekContainsDate) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = w.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1), M = LY(e, n), O = /* @__PURE__ */ new Date(0);
  O.setFullYear(M, 0, x), O.setHours(0, 0, 0, 0);
  var k = fl(O, n);
  return k;
}
var OY = 6048e5;
function DY(e, n) {
  ue(1, arguments);
  var i = de(e), a = fl(i, n).getTime() - RY(i, n).getTime();
  return Math.round(a / OY) + 1;
}
function kY(e) {
  return ue(1, arguments), de(e).getFullYear();
}
function A7(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n);
  return i.getTime() > a.getTime();
}
function $g(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n);
  return i.getTime() < a.getTime();
}
function jY(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n);
  return i.getTime() === a.getTime();
}
function zY(e, n) {
  ue(2, arguments);
  var i = jc(e), a = jc(n);
  return i.getTime() === a.getTime();
}
function NY(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n);
  return i.getFullYear() === a.getFullYear();
}
function PY(e, n) {
  ue(2, arguments);
  var i = de(e), a = de(n);
  return i.getFullYear() === a.getFullYear() && i.getMonth() === a.getMonth();
}
function px(e) {
  ue(1, arguments);
  var n = de(e);
  return n.setMinutes(0, 0, 0), n;
}
function FY(e, n) {
  ue(2, arguments);
  var i = px(e), a = px(n);
  return i.getTime() === a.getTime();
}
function hx(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, a = Array(n); i < n; i++) a[i] = e[i];
  return a;
}
function BY(e, n) {
  if (e) {
    if (typeof e == "string") return hx(e, n);
    var i = {}.toString.call(e).slice(8, -1);
    return i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set" ? Array.from(e) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? hx(e, n) : void 0;
  }
}
function mx(e, n) {
  var i = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!i) {
    if (Array.isArray(e) || (i = BY(e)) || n) {
      i && (e = i);
      var a = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return a >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[a++]
          };
        },
        e: function(m) {
          throw m;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var g, c = !0, I = !1;
  return {
    s: function() {
      i = i.call(e);
    },
    n: function() {
      var m = i.next();
      return c = m.done, m;
    },
    e: function(m) {
      I = !0, g = m;
    },
    f: function() {
      try {
        c || i.return == null || i.return();
      } finally {
        if (I) throw g;
      }
    }
  };
}
function HY(e, n) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var i in n)
    Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  return e;
}
function jt(e, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), n && Oc(e, n);
}
function UY(e, n) {
  if (n && (Ra(n) == "object" || typeof n == "function")) return n;
  if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return xe(e);
}
function zt(e) {
  var n = lm();
  return function() {
    var i, a = wf(e);
    if (n) {
      var s = wf(this).constructor;
      i = Reflect.construct(a, arguments, s);
    } else i = a.apply(this, arguments);
    return UY(this, i);
  };
}
function xt(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function WY(e, n) {
  for (var i = 0; i < n.length; i++) {
    var a = n[i];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, mE(a.key), a);
  }
}
function St(e, n, i) {
  return n && WY(e.prototype, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ye(e, n, i) {
  return (n = mE(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
var _Y = 10, NM = /* @__PURE__ */ function() {
  function e() {
    xt(this, e), ye(this, "priority", void 0), ye(this, "subPriority", 0);
  }
  return St(e, [{
    key: "validate",
    value: function(i, a) {
      return !0;
    }
  }]), e;
}(), VY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i(a, s, g, c, I) {
    var h;
    return xt(this, i), h = n.call(this), h.value = a, h.validateValue = s, h.setValue = g, h.priority = c, I && (h.subPriority = I), h;
  }
  return St(i, [{
    key: "validate",
    value: function(s, g) {
      return this.validateValue(s, this.value, g);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return this.setValue(s, g, this.value, c);
    }
  }]), i;
}(NM), KY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", _Y), ye(xe(a), "subPriority", -1), a;
  }
  return St(i, [{
    key: "set",
    value: function(s, g) {
      if (g.timestampIsSet)
        return s;
      var c = /* @__PURE__ */ new Date(0);
      return c.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), c.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), c;
    }
  }]), i;
}(NM), Kt = /* @__PURE__ */ function() {
  function e() {
    xt(this, e), ye(this, "incompatibleTokens", void 0), ye(this, "priority", void 0), ye(this, "subPriority", void 0);
  }
  return St(e, [{
    key: "run",
    value: function(i, a, s, g) {
      var c = this.parse(i, a, s, g);
      return c ? {
        setter: new VY(c.value, this.validate, this.set, this.priority, this.subPriority),
        rest: c.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(i, a, s) {
      return !0;
    }
  }]), e;
}(), JY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 140), ye(xe(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "G":
        case "GG":
        case "GGG":
          return c.era(s, {
            width: "abbreviated"
          }) || c.era(s, {
            width: "narrow"
          });
        case "GGGGG":
          return c.era(s, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return c.era(s, {
            width: "wide"
          }) || c.era(s, {
            width: "abbreviated"
          }) || c.era(s, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return g.era = c, s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), a2 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, E0 = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function o2(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function Bn(e, n) {
  var i = n.match(e);
  return i ? {
    value: parseInt(i[0], 10),
    rest: n.slice(i[0].length)
  } : null;
}
function M0(e, n) {
  var i = n.match(e);
  if (!i)
    return null;
  if (i[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  var a = i[1] === "+" ? 1 : -1, s = i[2] ? parseInt(i[2], 10) : 0, g = i[3] ? parseInt(i[3], 10) : 0, c = i[5] ? parseInt(i[5], 10) : 0;
  return {
    value: a * (s * C6 + g * d6 + c * yJ),
    rest: n.slice(i[0].length)
  };
}
function PM(e) {
  return Bn(a2.anyDigitsSigned, e);
}
function Qn(e, n) {
  switch (e) {
    case 1:
      return Bn(a2.singleDigit, n);
    case 2:
      return Bn(a2.twoDigits, n);
    case 3:
      return Bn(a2.threeDigits, n);
    case 4:
      return Bn(a2.fourDigits, n);
    default:
      return Bn(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function RA(e, n) {
  switch (e) {
    case 1:
      return Bn(a2.singleDigitSigned, n);
    case 2:
      return Bn(a2.twoDigitsSigned, n);
    case 3:
      return Bn(a2.threeDigitsSigned, n);
    case 4:
      return Bn(a2.fourDigitsSigned, n);
    default:
      return Bn(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Lm(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function FM(e, n) {
  var i = n > 0, a = i ? n : 1 - n, s;
  if (a <= 50)
    s = e || 100;
  else {
    var g = a + 50, c = Math.floor(g / 100) * 100, I = e >= g % 100;
    s = e + c - (I ? 100 : 0);
  }
  return i ? s : 1 - s;
}
function BM(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var YY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 130), ye(xe(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return {
          year: m,
          isTwoDigitYear: g === "yy"
        };
      };
      switch (g) {
        case "y":
          return o2(Qn(4, s), I);
        case "yo":
          return o2(c.ordinalNumber(s, {
            unit: "year"
          }), I);
        default:
          return o2(Qn(g.length, s), I);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g.isTwoDigitYear || g.year > 0;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = s.getUTCFullYear();
      if (c.isTwoDigitYear) {
        var h = FM(c.year, I);
        return s.setUTCFullYear(h, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
      }
      var m = !("era" in g) || g.era === 1 ? c.year : 1 - c.year;
      return s.setUTCFullYear(m, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), QY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 130), ye(xe(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return {
          year: m,
          isTwoDigitYear: g === "YY"
        };
      };
      switch (g) {
        case "Y":
          return o2(Qn(4, s), I);
        case "Yo":
          return o2(c.ordinalNumber(s, {
            unit: "year"
          }), I);
        default:
          return o2(Qn(g.length, s), I);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g.isTwoDigitYear || g.year > 0;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      var h = Mm(s, I);
      if (c.isTwoDigitYear) {
        var m = FM(c.year, h);
        return s.setUTCFullYear(m, 0, I.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), pl(s, I);
      }
      var w = !("era" in g) || g.era === 1 ? c.year : 1 - c.year;
      return s.setUTCFullYear(w, 0, I.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), pl(s, I);
    }
  }]), i;
}(Kt), XY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 130), ye(xe(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g) {
      return RA(g === "R" ? 4 : g.length, s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = /* @__PURE__ */ new Date(0);
      return I.setUTCFullYear(c, 0, 4), I.setUTCHours(0, 0, 0, 0), zc(I);
    }
  }]), i;
}(Kt), GY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 130), ye(xe(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g) {
      return RA(g === "u" ? 4 : g.length, s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), qY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 120), ye(xe(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "Q":
        case "QQ":
          return Qn(g.length, s);
        case "Qo":
          return c.ordinalNumber(s, {
            unit: "quarter"
          });
        case "QQQ":
          return c.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return c.quarter(s, {
            width: "wide",
            context: "formatting"
          }) || c.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 4;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth((c - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), ZY = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 120), ye(xe(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "q":
        case "qq":
          return Qn(g.length, s);
        case "qo":
          return c.ordinalNumber(s, {
            unit: "quarter"
          });
        case "qqq":
          return c.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return c.quarter(s, {
            width: "wide",
            context: "standalone"
          }) || c.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 4;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth((c - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), $Y = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ye(xe(a), "priority", 110), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return m - 1;
      };
      switch (g) {
        case "M":
          return o2(Bn(a2.month, s), I);
        case "MM":
          return o2(Qn(2, s), I);
        case "Mo":
          return o2(c.ordinalNumber(s, {
            unit: "month"
          }), I);
        case "MMM":
          return c.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return c.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return c.month(s, {
            width: "wide",
            context: "formatting"
          }) || c.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.month(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 11;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth(c, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), eQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 110), ye(xe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return m - 1;
      };
      switch (g) {
        case "L":
          return o2(Bn(a2.month, s), I);
        case "LL":
          return o2(Qn(2, s), I);
        case "Lo":
          return o2(c.ordinalNumber(s, {
            unit: "month"
          }), I);
        case "LLL":
          return c.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return c.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return c.month(s, {
            width: "wide",
            context: "standalone"
          }) || c.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.month(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 11;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth(c, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt);
function tQ(e, n, i) {
  ue(2, arguments);
  var a = de(e), s = kt(n), g = OM(a, i) - s;
  return a.setUTCDate(a.getUTCDate() - g * 7), a;
}
var nQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 100), ye(xe(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "w":
          return Bn(a2.week, s);
        case "wo":
          return c.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 53;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return pl(tQ(s, c, I), I);
    }
  }]), i;
}(Kt);
function rQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n), s = RM(i) - a;
  return i.setUTCDate(i.getUTCDate() - s * 7), i;
}
var iQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 100), ye(xe(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "I":
          return Bn(a2.week, s);
        case "Io":
          return c.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 53;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return zc(rQ(s, c));
    }
  }]), i;
}(Kt), aQ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], oQ = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], sQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 90), ye(xe(a), "subPriority", 1), ye(xe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "d":
          return Bn(a2.date, s);
        case "do":
          return c.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      var c = s.getUTCFullYear(), I = BM(c), h = s.getUTCMonth();
      return I ? g >= 1 && g <= oQ[h] : g >= 1 && g <= aQ[h];
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCDate(c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), lQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 90), ye(xe(a), "subpriority", 1), ye(xe(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "D":
        case "DD":
          return Bn(a2.dayOfYear, s);
        case "Do":
          return c.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      var c = s.getUTCFullYear(), I = BM(c);
      return I ? g >= 1 && g <= 366 : g >= 1 && g <= 365;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMonth(0, c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt);
function Rm(e, n, i) {
  var a, s, g, c, I, h, m, w;
  ue(2, arguments);
  var x = P0(), M = kt((a = (s = (g = (c = i == null ? void 0 : i.weekStartsOn) !== null && c !== void 0 ? c : i == null || (I = i.locale) === null || I === void 0 || (h = I.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && g !== void 0 ? g : x.weekStartsOn) !== null && s !== void 0 ? s : (m = x.locale) === null || m === void 0 || (w = m.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(M >= 0 && M <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var O = de(e), k = kt(n), z = O.getUTCDay(), N = k % 7, U = (N + 7) % 7, Q = (U < M ? 7 : 0) + k - z;
  return O.setUTCDate(O.getUTCDate() + Q), O;
}
var uQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 90), ye(xe(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "E":
        case "EE":
        case "EEE":
          return c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 6;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return s = Rm(s, c, I), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), cQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 90), ye(xe(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c, I) {
      var h = function(w) {
        var x = Math.floor((w - 1) / 7) * 7;
        return (w + I.weekStartsOn + 6) % 7 + x;
      };
      switch (g) {
        case "e":
        case "ee":
          return o2(Qn(g.length, s), h);
        case "eo":
          return o2(c.ordinalNumber(s, {
            unit: "day"
          }), h);
        case "eee":
          return c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 6;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return s = Rm(s, c, I), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), gQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 90), ye(xe(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c, I) {
      var h = function(w) {
        var x = Math.floor((w - 1) / 7) * 7;
        return (w + I.weekStartsOn + 6) % 7 + x;
      };
      switch (g) {
        case "c":
        case "cc":
          return o2(Qn(g.length, s), h);
        case "co":
          return o2(c.ordinalNumber(s, {
            unit: "day"
          }), h);
        case "ccc":
          return c.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return c.day(s, {
            width: "wide",
            context: "standalone"
          }) || c.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || c.day(s, {
            width: "short",
            context: "standalone"
          }) || c.day(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 6;
    }
  }, {
    key: "set",
    value: function(s, g, c, I) {
      return s = Rm(s, c, I), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt);
function fQ(e, n) {
  ue(2, arguments);
  var i = kt(n);
  i % 7 === 0 && (i = i - 7);
  var a = 1, s = de(e), g = s.getUTCDay(), c = i % 7, I = (c + 7) % 7, h = (I < a ? 7 : 0) + i - g;
  return s.setUTCDate(s.getUTCDate() + h), s;
}
var dQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 90), ye(xe(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      var I = function(m) {
        return m === 0 ? 7 : m;
      };
      switch (g) {
        case "i":
        case "ii":
          return Qn(g.length, s);
        case "io":
          return c.ordinalNumber(s, {
            unit: "day"
          });
        case "iii":
          return o2(c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
        case "iiiii":
          return o2(c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
        case "iiiiii":
          return o2(c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
        case "iiii":
        default:
          return o2(c.day(s, {
            width: "wide",
            context: "formatting"
          }) || c.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.day(s, {
            width: "short",
            context: "formatting"
          }) || c.day(s, {
            width: "narrow",
            context: "formatting"
          }), I);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 7;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s = fQ(s, c), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), i;
}(Kt), CQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 80), ye(xe(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "a":
        case "aa":
        case "aaa":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(Lm(c), 0, 0, 0), s;
    }
  }]), i;
}(Kt), AQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 80), ye(xe(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "b":
        case "bb":
        case "bbb":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(Lm(c), 0, 0, 0), s;
    }
  }]), i;
}(Kt), IQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 80), ye(xe(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "B":
        case "BB":
        case "BBB":
          return c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return c.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || c.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(Lm(c), 0, 0, 0), s;
    }
  }]), i;
}(Kt), pQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 70), ye(xe(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "h":
          return Bn(a2.hour12h, s);
        case "ho":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 12;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = s.getUTCHours() >= 12;
      return I && c < 12 ? s.setUTCHours(c + 12, 0, 0, 0) : !I && c === 12 ? s.setUTCHours(0, 0, 0, 0) : s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), i;
}(Kt), hQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 70), ye(xe(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "H":
          return Bn(a2.hour23h, s);
        case "Ho":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 23;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), i;
}(Kt), mQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 70), ye(xe(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "K":
          return Bn(a2.hour11h, s);
        case "Ko":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 11;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = s.getUTCHours() >= 12;
      return I && c < 12 ? s.setUTCHours(c + 12, 0, 0, 0) : s.setUTCHours(c, 0, 0, 0), s;
    }
  }]), i;
}(Kt), vQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 70), ye(xe(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "k":
          return Bn(a2.hour24h, s);
        case "ko":
          return c.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 1 && g <= 24;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      var I = c <= 24 ? c % 24 : c;
      return s.setUTCHours(I, 0, 0, 0), s;
    }
  }]), i;
}(Kt), yQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 60), ye(xe(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "m":
          return Bn(a2.minute, s);
        case "mo":
          return c.ordinalNumber(s, {
            unit: "minute"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 59;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMinutes(c, 0, 0), s;
    }
  }]), i;
}(Kt), bQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 50), ye(xe(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g, c) {
      switch (g) {
        case "s":
          return Bn(a2.second, s);
        case "so":
          return c.ordinalNumber(s, {
            unit: "second"
          });
        default:
          return Qn(g.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, g) {
      return g >= 0 && g <= 59;
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCSeconds(c, 0), s;
    }
  }]), i;
}(Kt), wQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 30), ye(xe(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g) {
      var c = function(h) {
        return Math.floor(h * Math.pow(10, -g.length + 3));
      };
      return o2(Qn(g.length, s), c);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return s.setUTCMilliseconds(c), s;
    }
  }]), i;
}(Kt), xQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 10), ye(xe(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g) {
      switch (g) {
        case "X":
          return M0(E0.basicOptionalMinutes, s);
        case "XX":
          return M0(E0.basic, s);
        case "XXXX":
          return M0(E0.basicOptionalSeconds, s);
        case "XXXXX":
          return M0(E0.extendedOptionalSeconds, s);
        case "XXX":
        default:
          return M0(E0.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return g.timestampIsSet ? s : new Date(s.getTime() - c);
    }
  }]), i;
}(Kt), SQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 10), ye(xe(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s, g) {
      switch (g) {
        case "x":
          return M0(E0.basicOptionalMinutes, s);
        case "xx":
          return M0(E0.basic, s);
        case "xxxx":
          return M0(E0.basicOptionalSeconds, s);
        case "xxxxx":
          return M0(E0.extendedOptionalSeconds, s);
        case "xxx":
        default:
          return M0(E0.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return g.timestampIsSet ? s : new Date(s.getTime() - c);
    }
  }]), i;
}(Kt), EQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 40), ye(xe(a), "incompatibleTokens", "*"), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s) {
      return PM(s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return [new Date(c * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), i;
}(Kt), MQ = /* @__PURE__ */ function(e) {
  jt(i, e);
  var n = zt(i);
  function i() {
    var a;
    xt(this, i);
    for (var s = arguments.length, g = new Array(s), c = 0; c < s; c++)
      g[c] = arguments[c];
    return a = n.call.apply(n, [this].concat(g)), ye(xe(a), "priority", 20), ye(xe(a), "incompatibleTokens", "*"), a;
  }
  return St(i, [{
    key: "parse",
    value: function(s) {
      return PM(s);
    }
  }, {
    key: "set",
    value: function(s, g, c) {
      return [new Date(c), {
        timestampIsSet: !0
      }];
    }
  }]), i;
}(Kt), TQ = {
  G: new JY(),
  y: new YY(),
  Y: new QY(),
  R: new XY(),
  u: new GY(),
  Q: new qY(),
  q: new ZY(),
  M: new $Y(),
  L: new eQ(),
  w: new nQ(),
  I: new iQ(),
  d: new sQ(),
  D: new lQ(),
  E: new uQ(),
  e: new cQ(),
  c: new gQ(),
  i: new dQ(),
  a: new CQ(),
  b: new AQ(),
  B: new IQ(),
  h: new pQ(),
  H: new hQ(),
  K: new mQ(),
  k: new vQ(),
  m: new yQ(),
  s: new bQ(),
  S: new wQ(),
  X: new xQ(),
  x: new SQ(),
  t: new EQ(),
  T: new MQ()
}, LQ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, RQ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, OQ = /^'([^]*?)'?$/, DQ = /''/g, kQ = /\S/, jQ = /[a-zA-Z]/;
function zQ(e, n, i, a) {
  var s, g, c, I, h, m, w, x, M, O, k, z, N, U, Q, _, X, B;
  ue(3, arguments);
  var Z = String(e), Y = String(n), V = P0(), J = (s = (g = a == null ? void 0 : a.locale) !== null && g !== void 0 ? g : V.locale) !== null && s !== void 0 ? s : Tm;
  if (!J.match)
    throw new RangeError("locale must contain match property");
  var e1 = kt((c = (I = (h = (m = a == null ? void 0 : a.firstWeekContainsDate) !== null && m !== void 0 ? m : a == null || (w = a.locale) === null || w === void 0 || (x = w.options) === null || x === void 0 ? void 0 : x.firstWeekContainsDate) !== null && h !== void 0 ? h : V.firstWeekContainsDate) !== null && I !== void 0 ? I : (M = V.locale) === null || M === void 0 || (O = M.options) === null || O === void 0 ? void 0 : O.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
  if (!(e1 >= 1 && e1 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var f1 = kt((k = (z = (N = (U = a == null ? void 0 : a.weekStartsOn) !== null && U !== void 0 ? U : a == null || (Q = a.locale) === null || Q === void 0 || (_ = Q.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && N !== void 0 ? N : V.weekStartsOn) !== null && z !== void 0 ? z : (X = V.locale) === null || X === void 0 || (B = X.options) === null || B === void 0 ? void 0 : B.weekStartsOn) !== null && k !== void 0 ? k : 0);
  if (!(f1 >= 0 && f1 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (Y === "")
    return Z === "" ? de(i) : /* @__PURE__ */ new Date(NaN);
  var v1 = {
    firstWeekContainsDate: e1,
    weekStartsOn: f1,
    locale: J
  }, a1 = [new KY()], d1 = Y.match(RQ).map(function(R1) {
    var x1 = R1[0];
    if (x1 in Th) {
      var J1 = Th[x1];
      return J1(R1, J.formatLong);
    }
    return R1;
  }).join("").match(LQ), S1 = [], h1 = mx(d1), L1;
  try {
    var c1 = function() {
      var x1 = L1.value;
      !(a != null && a.useAdditionalWeekYearTokens) && jM(x1) && LA(x1, Y, e), !(a != null && a.useAdditionalDayOfYearTokens) && kM(x1) && LA(x1, Y, e);
      var J1 = x1[0], X1 = TQ[J1];
      if (X1) {
        var D1 = X1.incompatibleTokens;
        if (Array.isArray(D1)) {
          var $1 = S1.find(function(ie) {
            return D1.includes(ie.token) || ie.token === J1;
          });
          if ($1)
            throw new RangeError("The format string mustn't contain `".concat($1.fullToken, "` and `").concat(x1, "` at the same time"));
        } else if (X1.incompatibleTokens === "*" && S1.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(x1, "` and any other token at the same time"));
        S1.push({
          token: J1,
          fullToken: x1
        });
        var y1 = X1.run(Z, x1, J.match, v1);
        if (!y1)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        a1.push(y1.setter), Z = y1.rest;
      } else {
        if (J1.match(jQ))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + J1 + "`");
        if (x1 === "''" ? x1 = "'" : J1 === "'" && (x1 = NQ(x1)), Z.indexOf(x1) === 0)
          Z = Z.slice(x1.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (h1.s(); !(L1 = h1.n()).done; ) {
      var b1 = c1();
      if (Ra(b1) === "object") return b1.v;
    }
  } catch (R1) {
    h1.e(R1);
  } finally {
    h1.f();
  }
  if (Z.length > 0 && kQ.test(Z))
    return /* @__PURE__ */ new Date(NaN);
  var t1 = a1.map(function(R1) {
    return R1.priority;
  }).sort(function(R1, x1) {
    return x1 - R1;
  }).filter(function(R1, x1, J1) {
    return J1.indexOf(R1) === x1;
  }).map(function(R1) {
    return a1.filter(function(x1) {
      return x1.priority === R1;
    }).sort(function(x1, J1) {
      return J1.subPriority - x1.subPriority;
    });
  }).map(function(R1) {
    return R1[0];
  }), C1 = de(i);
  if (isNaN(C1.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var w1 = TM(C1, TA(C1)), E1 = {}, V1 = mx(t1), K1;
  try {
    for (V1.s(); !(K1 = V1.n()).done; ) {
      var B1 = K1.value;
      if (!B1.validate(w1, v1))
        return /* @__PURE__ */ new Date(NaN);
      var te = B1.set(w1, E1, v1);
      Array.isArray(te) ? (w1 = te[0], HY(E1, te[1])) : w1 = te;
    }
  } catch (R1) {
    V1.e(R1);
  } finally {
    V1.f();
  }
  return w1;
}
function NQ(e) {
  return e.match(OQ)[1].replace(DQ, "'");
}
function PQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return i.setDate(a), i;
}
function FQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return i.setHours(a), i;
}
function BQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return i.setMinutes(a), i;
}
function HQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n), s = i.getFullYear(), g = i.getDate(), c = /* @__PURE__ */ new Date(0);
  c.setFullYear(s, a, 15), c.setHours(0, 0, 0, 0);
  var I = zM(c);
  return i.setMonth(a, Math.min(g, I)), i;
}
function UQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return i.setSeconds(a), i;
}
function WQ(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return i.setMilliseconds(a), i;
}
function _Q(e, n) {
  ue(2, arguments);
  var i = de(e), a = kt(n);
  return isNaN(i.getTime()) ? /* @__PURE__ */ new Date(NaN) : (i.setFullYear(a), i);
}
function vx(e) {
  ue(1, arguments);
  var n = de(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function JC(e) {
  ue(1, arguments);
  var n = de(e), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(n.getFullYear(), 0, 1), i.setHours(0, 0, 0, 0), i;
}
function VQ(e, n) {
  var i;
  ue(1, arguments);
  var a = kt((i = void 0) !== null && i !== void 0 ? i : 2);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = QQ(e), g;
  if (s.date) {
    var c = XQ(s.date, a);
    g = GQ(c.restDateString, c.year);
  }
  if (!g || isNaN(g.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var I = g.getTime(), h = 0, m;
  if (s.time && (h = qQ(s.time), isNaN(h)))
    return /* @__PURE__ */ new Date(NaN);
  if (s.timezone) {
    if (m = ZQ(s.timezone), isNaN(m))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var w = new Date(I + h), x = /* @__PURE__ */ new Date(0);
    return x.setFullYear(w.getUTCFullYear(), w.getUTCMonth(), w.getUTCDate()), x.setHours(w.getUTCHours(), w.getUTCMinutes(), w.getUTCSeconds(), w.getUTCMilliseconds()), x;
  }
  return new Date(I + h + m);
}
var YC = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, KQ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, JQ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, YQ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function QQ(e) {
  var n = {}, i = e.split(YC.dateTimeDelimiter), a;
  if (i.length > 2)
    return n;
  if (/:/.test(i[0]) ? a = i[0] : (n.date = i[0], a = i[1], YC.timeZoneDelimiter.test(n.date) && (n.date = e.split(YC.timeZoneDelimiter)[0], a = e.substr(n.date.length, e.length))), a) {
    var s = YC.timezone.exec(a);
    s ? (n.time = a.replace(s[1], ""), n.timezone = s[1]) : n.time = a;
  }
  return n;
}
function XQ(e, n) {
  var i = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"), a = e.match(i);
  if (!a) return {
    year: NaN,
    restDateString: ""
  };
  var s = a[1] ? parseInt(a[1]) : null, g = a[2] ? parseInt(a[2]) : null;
  return {
    year: g === null ? s : g * 100,
    restDateString: e.slice((a[1] || a[2]).length)
  };
}
function GQ(e, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  var i = e.match(KQ);
  if (!i) return /* @__PURE__ */ new Date(NaN);
  var a = !!i[4], s = ef(i[1]), g = ef(i[2]) - 1, c = ef(i[3]), I = ef(i[4]), h = ef(i[5]) - 1;
  if (a)
    return rX(n, I, h) ? $Q(n, I, h) : /* @__PURE__ */ new Date(NaN);
  var m = /* @__PURE__ */ new Date(0);
  return !tX(n, g, c) || !nX(n, s) ? /* @__PURE__ */ new Date(NaN) : (m.setUTCFullYear(n, g, Math.max(s, c)), m);
}
function ef(e) {
  return e ? parseInt(e) : 1;
}
function qQ(e) {
  var n = e.match(JQ);
  if (!n) return NaN;
  var i = I7(n[1]), a = I7(n[2]), s = I7(n[3]);
  return iX(i, a, s) ? i * C6 + a * d6 + s * 1e3 : NaN;
}
function I7(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function ZQ(e) {
  if (e === "Z") return 0;
  var n = e.match(YQ);
  if (!n) return 0;
  var i = n[1] === "+" ? -1 : 1, a = parseInt(n[2]), s = n[3] && parseInt(n[3]) || 0;
  return aX(a, s) ? i * (a * C6 + s * d6) : NaN;
}
function $Q(e, n, i) {
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var s = a.getUTCDay() || 7, g = (n - 1) * 7 + i + 1 - s;
  return a.setUTCDate(a.getUTCDate() + g), a;
}
var eX = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function HM(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function tX(e, n, i) {
  return n >= 0 && n <= 11 && i >= 1 && i <= (eX[n] || (HM(e) ? 29 : 28));
}
function nX(e, n) {
  return n >= 1 && n <= (HM(e) ? 366 : 365);
}
function rX(e, n, i) {
  return n >= 1 && n <= 53 && i >= 0 && i <= 6;
}
function iX(e, n, i) {
  return e === 24 ? n === 0 && i === 0 : i >= 0 && i < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function aX(e, n) {
  return n >= 0 && n <= 59;
}
function oX(e, n) {
  var i, a;
  ue(1, arguments);
  var s = de(e);
  if (isNaN(s.getTime()))
    throw new RangeError("Invalid time value");
  var g = String((i = n == null ? void 0 : n.format) !== null && i !== void 0 ? i : "extended"), c = String((a = n == null ? void 0 : n.representation) !== null && a !== void 0 ? a : "complete");
  if (g !== "extended" && g !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (c !== "date" && c !== "time" && c !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var I = "", h = "", m = g === "extended" ? "-" : "", w = g === "extended" ? ":" : "";
  if (c !== "time") {
    var x = yt(s.getDate(), 2), M = yt(s.getMonth() + 1, 2), O = yt(s.getFullYear(), 4);
    I = "".concat(O).concat(m).concat(M).concat(m).concat(x);
  }
  if (c !== "date") {
    var k = s.getTimezoneOffset();
    if (k !== 0) {
      var z = Math.abs(k), N = yt(Math.floor(z / 60), 2), U = yt(z % 60, 2), Q = k < 0 ? "+" : "-";
      h = "".concat(Q).concat(N, ":").concat(U);
    } else
      h = "Z";
    var _ = yt(s.getHours(), 2), X = yt(s.getMinutes(), 2), B = yt(s.getSeconds(), 2), Z = I === "" ? "" : "T", Y = [_, X, B].join(w);
    I = "".concat(I).concat(Z).concat(Y).concat(h);
  }
  return I;
}
function sX(e, n) {
  ue(2, arguments);
  var i = de(e).getTime(), a = de(n.start).getTime(), s = de(n.end).getTime();
  if (!(a <= s))
    throw new RangeError("Invalid interval");
  return i >= a && i <= s;
}
var Lh = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = void 0;
  var i = function(h, m) {
    switch (h) {
      case "P":
        return m.date({
          width: "short"
        });
      case "PP":
        return m.date({
          width: "medium"
        });
      case "PPP":
        return m.date({
          width: "long"
        });
      case "PPPP":
      default:
        return m.date({
          width: "full"
        });
    }
  }, a = function(h, m) {
    switch (h) {
      case "p":
        return m.time({
          width: "short"
        });
      case "pp":
        return m.time({
          width: "medium"
        });
      case "ppp":
        return m.time({
          width: "long"
        });
      case "pppp":
      default:
        return m.time({
          width: "full"
        });
    }
  }, s = function(h, m) {
    var w = h.match(/(P+)(p+)?/) || [], x = w[1], M = w[2];
    if (!M)
      return i(h, m);
    var O;
    switch (x) {
      case "P":
        O = m.dateTime({
          width: "short"
        });
        break;
      case "PP":
        O = m.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        O = m.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        O = m.dateTime({
          width: "full"
        });
        break;
    }
    return O.replace("{{date}}", i(x, m)).replace("{{time}}", a(M, m));
  }, g = {
    p: a,
    P: s
  }, c = g;
  n.default = c, e.exports = n.default;
})(Lh, Lh.exports);
var lX = Lh.exports;
const uX = /* @__PURE__ */ _A(lX), cX = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, gX = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  monthAndYear: "LLLL yyyy",
  monthAndDate: "MMMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aa",
  fullDateTime24h: "PP HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class fX {
  constructor(n) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = "date-fns", this.locale = void 0, this.formats = void 0, this.formatTokenMap = cX, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (g) => typeof g > "u" ? /* @__PURE__ */ new Date() : g === null ? null : new Date(g), this.dateWithTimezone = (g) => this.date(g), this.getTimezone = () => "default", this.setTimezone = (g) => g, this.toJsDate = (g) => g, this.getCurrentLocaleCode = () => {
      var g;
      return ((g = this.locale) == null ? void 0 : g.code) || "en-US";
    }, this.is12HourCycleInCurrentLocale = () => this.locale ? /a/.test(this.locale.formatLong.time({
      width: "short"
    })) : !0, this.expandFormat = (g) => {
      const c = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return g.match(c).map((I) => {
        const h = I[0];
        if (h === "p" || h === "P") {
          const m = this.longFormatters[h];
          return m(I, this.locale.formatLong);
        }
        return I;
      }).join("");
    }, this.getFormatHelperText = (g) => this.expandFormat(g).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase(), this.isNull = (g) => g === null, this.formatNumber = (g) => g, this.getMeridiemText = (g) => g === "am" ? "AM" : "PM";
    const {
      locale: i,
      formats: a,
      longFormatters: s
    } = n;
    this.locale = i, this.formats = k1({}, gX, a), this.longFormatters = s;
  }
}
class Ue1 extends fX {
  constructor({
    locale: n,
    formats: i
  } = {}) {
    if (typeof fA != "function")
      throw new Error(["MUI: The `date-fns` package v3.x is not compatible with this adapter.", "Please, install v2.x of the package or use the `AdapterDateFnsV3` instead."].join(`
`));
    super({
      locale: n ?? Tm,
      formats: i,
      longFormatters: uX
    }), this.parseISO = (a) => VQ(a), this.toISO = (a) => oX(a, {
      format: "extended"
    }), this.parse = (a, s) => a === "" ? null : zQ(a, s, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (a) => MM(this.date(a)), this.format = (a, s) => this.formatByString(a, this.formats[s]), this.formatByString = (a, s) => yY(a, s, {
      locale: this.locale
    }), this.getDiff = (a, s, g) => {
      switch (g) {
        case "years":
          return dJ(a, this.date(s));
        case "quarters":
          return pJ(a, this.date(s));
        case "months":
          return SM(a, this.date(s));
        case "weeks":
          return vJ(a, this.date(s));
        case "days":
          return EM(a, this.date(s));
        case "hours":
          return bJ(a, this.date(s));
        case "minutes":
          return wJ(a, this.date(s));
        case "seconds":
          return xJ(a, this.date(s));
        default:
          return A6(a, this.date(s));
      }
    }, this.isEqual = (a, s) => a === null && s === null ? !0 : jY(a, s), this.isSameYear = (a, s) => NY(a, s), this.isSameMonth = (a, s) => PY(a, s), this.isSameDay = (a, s) => zY(a, s), this.isSameHour = (a, s) => FY(a, s), this.isAfter = (a, s) => A7(a, s), this.isAfterYear = (a, s) => A7(a, d7(s)), this.isAfterDay = (a, s) => A7(a, Eh(s)), this.isBefore = (a, s) => $g(a, s), this.isBeforeYear = (a, s) => $g(a, JC(s)), this.isBeforeDay = (a, s) => $g(a, jc(s)), this.isWithinRange = (a, [s, g]) => sX(a, {
      start: s,
      end: g
    }), this.startOfYear = (a) => JC(a), this.startOfMonth = (a) => vx(a), this.startOfWeek = (a) => fl(a, {
      locale: this.locale
    }), this.startOfDay = (a) => jc(a), this.endOfYear = (a) => d7(a), this.endOfMonth = (a) => Mh(a), this.endOfWeek = (a) => f7(a, {
      locale: this.locale
    }), this.endOfDay = (a) => Eh(a), this.addYears = (a, s) => gx(a, s), this.addMonths = (a, s) => dA(a, s), this.addWeeks = (a, s) => gJ(a, s), this.addDays = (a, s) => fA(a, s), this.addHours = (a, s) => cJ(a, s), this.addMinutes = (a, s) => lJ(a, s), this.addSeconds = (a, s) => oJ(a, s), this.getYear = (a) => kY(a), this.getMonth = (a) => EY(a), this.getDate = (a) => wY(a), this.getHours = (a) => xY(a), this.getMinutes = (a) => SY(a), this.getSeconds = (a) => MY(a), this.getMilliseconds = (a) => TY(a), this.setYear = (a, s) => _Q(a, s), this.setMonth = (a, s) => HQ(a, s), this.setDate = (a, s) => PQ(a, s), this.setHours = (a, s) => FQ(a, s), this.setMinutes = (a, s) => BQ(a, s), this.setSeconds = (a, s) => UQ(a, s), this.setMilliseconds = (a, s) => WQ(a, s), this.getDaysInMonth = (a) => zM(a), this.getNextMonth = (a) => dA(a, 1), this.getPreviousMonth = (a) => dA(a, -1), this.getMonthArray = (a) => {
      const g = [JC(a)];
      for (; g.length < 12; ) {
        const c = g[g.length - 1];
        g.push(this.getNextMonth(c));
      }
      return g;
    }, this.mergeDateAndTime = (a, s) => this.setSeconds(this.setMinutes(this.setHours(a, this.getHours(s)), this.getMinutes(s)), this.getSeconds(s)), this.getWeekdays = () => {
      const a = /* @__PURE__ */ new Date();
      return SJ({
        start: fl(a, {
          locale: this.locale
        }),
        end: f7(a, {
          locale: this.locale
        })
      }).map((s) => this.formatByString(s, "EEEEEE"));
    }, this.getWeekArray = (a) => {
      const s = fl(vx(a), {
        locale: this.locale
      }), g = f7(Mh(a), {
        locale: this.locale
      });
      let c = 0, I = s;
      const h = [];
      for (; $g(I, g); ) {
        const m = Math.floor(c / 7);
        h[m] = h[m] || [], h[m].push(I), I = fA(I, 1), c += 1;
      }
      return h;
    }, this.getWeekNumber = (a) => DY(a, {
      locale: this.locale
    }), this.getYearRange = (a, s) => {
      const g = JC(a), c = d7(s), I = [];
      let h = g;
      for (; $g(h, c); )
        I.push(h), h = gx(h, 1);
      return I;
    };
  }
}
const UM = () => /* @__PURE__ */ v.jsx(_1, { display: "flex", flexDirection: "column", width: "100%", children: /* @__PURE__ */ v.jsx(
  _1,
  {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "52px",
    sx: { backgroundColor: (e) => {
      var n, i;
      return (i = (n = e.palette.common) == null ? void 0 : n.error) == null ? void 0 : i[50];
    } },
    px: 1,
    children: /* @__PURE__ */ v.jsx(_1, { children: /* @__PURE__ */ v.jsxs(le, { display: "flex", alignItems: "center", gap: 1, children: [
      /* @__PURE__ */ v.jsx(De, { icon: "danger" }),
      " Error Loading File"
    ] }) })
  }
) }), Om = ja(
  (e, n) => /* @__PURE__ */ v.jsx(
    _1,
    {
      boxSizing: "border-box",
      position: "relative",
      width: "100%",
      p: 2,
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: (i) => {
        var a, s, g;
        return `1px dashed ${(g = (s = (a = i.palette) == null ? void 0 : a.common) == null ? void 0 : s.neutrals) == null ? void 0 : g[200]}`;
      },
      borderRadius: 1,
      ...e,
      ref: n
    }
  )
);
Om.displayName = "DragAndDropBox";
const WM = ({ mimeType: e = "", ...n }) => {
  const i = V2(() => /^image\//.test(e) ? "fileImage" : e === "application/pdf" ? "filePdf" : "file", [e]);
  return /* @__PURE__ */ v.jsx(De, { ...n, icon: i });
};
WM.displayName = "FileTypeIcon";
const dX = (e) => /* @__PURE__ */ o1.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", strokeWidth: 1.5, ...e }, /* @__PURE__ */ o1.createElement("path", { d: "M7 3H5C3.89543 3 3 3.89543 3 5V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M17 3H19C20.1046 3 21 3.89543 21 5V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M16 8L16 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M8 8L8 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M9 16C9 16 10 17 12 17C14 17 15 16 15 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M12 8L12 13L11 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M7 21H5C3.89543 21 3 20.1046 3 19V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o1.createElement("path", { d: "M17 21H19C20.1046 21 21 20.1046 21 19V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })), We1 = (e = {}) => /* @__PURE__ */ v.jsx(BA, { ...e, children: /* @__PURE__ */ v.jsx(dX, {}) }), CX = (e) => /* @__PURE__ */ o1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 186.69 190.5", ...e }, /* @__PURE__ */ o1.createElement("g", { transform: "translate(1184.583 765.171)" }, /* @__PURE__ */ o1.createElement("path", { clipPath: "none", mask: "none", d: "M-1089.333-687.239v36.888h51.262c-2.251 11.863-9.006 21.908-19.137 28.662l30.913 23.986c18.011-16.625 28.402-41.044 28.402-70.052 0-6.754-.606-13.249-1.732-19.483z", fill: "#4285f4" }), /* @__PURE__ */ o1.createElement("path", { clipPath: "none", mask: "none", d: "M-1142.714-651.791l-6.972 5.337-24.679 19.223h0c15.673 31.086 47.796 52.561 85.03 52.561 25.717 0 47.278-8.486 63.038-23.033l-30.913-23.986c-8.486 5.715-19.31 9.179-32.125 9.179-24.765 0-45.806-16.712-53.34-39.226z", fill: "#34a853" }), /* @__PURE__ */ o1.createElement("path", { clipPath: "none", mask: "none", d: "M-1174.365-712.61c-6.494 12.815-10.217 27.276-10.217 42.689s3.723 29.874 10.217 42.689c0 .086 31.693-24.592 31.693-24.592-1.905-5.715-3.031-11.776-3.031-18.098s1.126-12.383 3.031-18.098z", fill: "#fbbc05" }), /* @__PURE__ */ o1.createElement("path", { d: "M-1089.333-727.244c14.028 0 26.497 4.849 36.455 14.201l27.276-27.276c-16.539-15.413-38.013-24.852-63.731-24.852-37.234 0-69.359 21.388-85.032 52.561l31.692 24.592c7.533-22.514 28.575-39.226 53.34-39.226z", fill: "#ea4335", clipPath: "none", mask: "none" }))), _e1 = (e = {}) => /* @__PURE__ */ v.jsx(BA, { ...e, children: /* @__PURE__ */ v.jsx(CX, {}) }), AX = (e) => /* @__PURE__ */ o1.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ o1.createElement("rect", { y: 0.0625, width: 24, height: 24, fill: "url(#pattern0)" }), /* @__PURE__ */ o1.createElement("defs", null, /* @__PURE__ */ o1.createElement("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ o1.createElement("use", { xlinkHref: "#image0_578_25", transform: "scale(0.00195312)" })), /* @__PURE__ */ o1.createElement("image", { id: "image0_578_25", width: 512, height: 512, xlinkHref: "data:image/png;base64,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" }))), Ve1 = (e = {}) => /* @__PURE__ */ v.jsx(BA, { ...e, children: /* @__PURE__ */ v.jsx(AX, {}) }), Ke1 = ({
  fontSize: e = "inherit",
  animate: n = "spin",
  ...i
}) => /* @__PURE__ */ v.jsxs(
  _1,
  {
    fontSize: e,
    lineHeight: 1,
    position: "relative",
    display: "inline-block",
    className: "outer-box",
    width: "1em",
    height: "1em",
    children: [
      /* @__PURE__ */ v.jsx(
        De,
        {
          ...i,
          icon: "cloud",
          display: "block",
          sx: { fontSize: "inherit" }
        }
      ),
      /* @__PURE__ */ v.jsx(
        _1,
        {
          position: "absolute",
          top: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          height: "1em",
          width: "1em",
          alignItems: "center",
          children: /* @__PURE__ */ v.jsx(
            De,
            {
              icon: "arrowsRotate",
              animate: n,
              sx: { fontSize: "0.4em", mt: "0.15em" }
            }
          )
        }
      )
    ]
  }
), Dm = (e) => /* @__PURE__ */ v.jsx(pS, { color: "secondary", variant: "determinate", ...e });
Dm.displayName = "ProgressBar";
const IX = ({
  value: e = 0,
  label: n,
  labelProps: i = {},
  ...a
}) => {
  const s = n ?? `${Math.round(e)}%`;
  return /* @__PURE__ */ v.jsxs(_1, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ v.jsx(_1, { width: "100%", mr: 1, children: /* @__PURE__ */ v.jsx(Dm, { ...a, value: e }) }),
    /* @__PURE__ */ v.jsx(_1, { minWidth: 38, children: /* @__PURE__ */ v.jsx(le, { variant: "subtitle2", textAlign: "right", ...i, children: s }) })
  ] });
};
IX.displayName = "ProgressBarWithLabel";
const pX = (e = 0) => kz(e), hX = q1(qe)(({ onClick: e, theme: n }) => ({
  minWidth: 0,
  maxWidth: "100%",
  boxSizing: "border-box",
  // Add Custom Styles when interactive
  ...e ? {
    cursor: "pointer",
    transition: n.transitions.create("background-color"),
    "&:hover": {
      backgroundColor: n.palette.divider
    }
  } : {}
})), km = ({
  filename: e,
  mimeType: n,
  size: i,
  sizeFormat: a = pX,
  progress: s,
  onClick: g,
  onCancel: c,
  onPreview: I,
  previewButtonTestId: h,
  onDelete: m,
  deleteDisabled: w,
  disabled: x,
  iconProps: M = {},
  filenameProps: O = {},
  sizeProps: k = {},
  cancelBtnProps: z = {},
  progressBarProps: N = {},
  uploadCancelled: U,
  ...Q
}) => {
  const _ = V2(() => a(i), [a, i]), X = m2(
    (Y) => {
      iA(Y), c && c();
    },
    [c]
  ), B = m2(
    (Y) => {
      iA(Y), I == null || I();
    },
    [I]
  ), Z = m2(
    (Y) => {
      iA(Y), m == null || m();
    },
    [m]
  );
  return /* @__PURE__ */ v.jsxs(
    hX,
    {
      minHeight: 42,
      bgcolor: (Y) => Y.palette.background.paper,
      border: 1,
      borderRadius: 1,
      borderColor: (Y) => Y.palette.divider,
      px: 1,
      position: "relative",
      overflow: "hidden",
      onClick: g,
      ...Q,
      children: [
        /* @__PURE__ */ v.jsx(qe, { direction: "row", flex: 1, minWidth: 0, children: /* @__PURE__ */ v.jsxs(
          qe,
          {
            direction: "row",
            flex: 1,
            minWidth: 0,
            alignItems: "center",
            gap: 1,
            color: (Y) => Y.palette.common.neutrals[600],
            children: [
              /* @__PURE__ */ v.jsx(_1, { sx: { display: "inline-flex", flexShrink: 0 }, children: /* @__PURE__ */ v.jsx(WM, { ...M, mimeType: n }) }),
              /* @__PURE__ */ v.jsx(
                le,
                {
                  flex: 1,
                  minWidth: 0,
                  noWrap: !0,
                  textAlign: "left",
                  color: (Y) => Y.palette.text.primary,
                  ...O,
                  children: e
                }
              ),
              /* @__PURE__ */ v.jsx(le, { textAlign: "right", noWrap: !0, sx: { flexShrink: 0 }, ...k, children: _ }),
              I && /* @__PURE__ */ v.jsx(
                j2,
                {
                  variant: "text",
                  size: "small",
                  startIcon: /* @__PURE__ */ v.jsx(De, { icon: "preview" }),
                  "data-testid": h,
                  onClick: B,
                  "aria-label": "Preview",
                  sx: { flexShrink: 0 },
                  children: "Preview"
                }
              ),
              m && /* @__PURE__ */ v.jsx(
                j2,
                {
                  variant: "text",
                  color: "error",
                  size: "small",
                  disabled: w,
                  startIcon: /* @__PURE__ */ v.jsx(De, { icon: "delete" }),
                  onClick: Z,
                  "aria-label": "Delete",
                  sx: { flexShrink: 0 },
                  children: "Delete"
                }
              ),
              c && !U && /* @__PURE__ */ v.jsx(
                Sm,
                {
                  icon: "close",
                  disabled: x,
                  title: "Cancel",
                  sx: { flexShrink: 0 },
                  ...z,
                  onClick: X
                }
              )
            ]
          }
        ) }),
        s !== void 0 && /* @__PURE__ */ v.jsx(qe, { position: "absolute", left: 0, right: 0, bottom: 0, height: 4, children: /* @__PURE__ */ v.jsx(Dm, { ...N, value: s }) })
      ]
    }
  );
};
km.displayName = "FileAttachmentItem";
const mX = q1(_j)(({ theme: e }) => ({
  cursor: "pointer",
  "&.disabled": {
    pointerEvents: "none",
    cursor: "default",
    color: e.palette.text.disabled,
    textDecoration: "none"
  }
})), yx = ({ to: e, state: n, disabled: i, ...a }) => {
  const s = e ? Yh : void 0;
  return /* @__PURE__ */ v.jsx(
    mX,
    {
      underline: "hover",
      role: a.onClick ? "button" : void 0,
      component: s,
      className: i ? "disabled" : "",
      ...e ? { to: e, state: n } : {},
      ...a,
      onClick: i ? (g) => g.preventDefault() : a.onClick
    }
  );
}, vX = nn.forwardRef(
  ({
    attachments: e = [],
    onBrowse: n,
    onVaultClick: i,
    vaultDisabled: a,
    extraSource: s,
    children: g,
    hideFilesList: c,
    disabled: I,
    ...h
  }, m) => {
    const w = e.length > 0 && !c;
    return /* @__PURE__ */ v.jsxs(
      Om,
      {
        ref: m,
        ...h,
        sx: {
          ...h.sx
        },
        children: [
          g,
          /* @__PURE__ */ v.jsxs(qe, { width: "100%", children: [
            /* @__PURE__ */ v.jsxs(
              _1,
              {
                display: "flex",
                alignItems: "center",
                justifyContent: w ? "space-between" : "center",
                children: [
                  w && /* @__PURE__ */ v.jsx(le, { variant: "body2", children: "Attachments" }),
                  /* @__PURE__ */ v.jsxs(_1, { display: "flex", justifyContent: "flex-end", alignItems: "center", children: [
                    /* @__PURE__ */ v.jsx(
                      De,
                      {
                        icon: "upload",
                        sx: {
                          color: (x) => {
                            var M, O;
                            return (O = (M = x.palette.common) == null ? void 0 : M.neutrals) == null ? void 0 : O[300];
                          },
                          mr: 0.5
                        }
                      }
                    ),
                    " ",
                    "Drop files to attach",
                    i && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                      ", ",
                      a ? "Liscio Vault" : /* @__PURE__ */ v.jsx(yx, { onClick: i, children: "Liscio Vault" })
                    ] }),
                    s ? /* @__PURE__ */ v.jsx(v.Fragment, { children: ", " }) : /* @__PURE__ */ v.jsx(v.Fragment, { children: " or " }),
                    I ? "Browse" : /* @__PURE__ */ v.jsx(yx, { onClick: n, children: "Browse" }),
                    s && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                      " or ",
                      s
                    ] })
                  ] })
                ]
              }
            ),
            w && /* @__PURE__ */ v.jsx(qe, { gap: 1, mt: 1, "data-testid": "dnd-attachments", children: e.map((x, M) => !x.filename && !x.mimeType ? /* @__PURE__ */ v.jsx(
              UM,
              {},
              `${M}-${x.filename}-error`
            ) : /* @__PURE__ */ TS(
              km,
              {
                ...x,
                key: `${M}-${x.filename}`
              }
            )) })
          ] })
        ]
      }
    );
  }
), yX = q1(v2)(({ theme: e }) => {
  const n = e.palette.common.neutrals[300];
  return {
    margin: "0 auto",
    width: "100%",
    marginTop: e.spacing(2),
    color: n,
    border: `solid 1px ${n}`,
    "&:hover": {
      border: `solid 1px ${n}`
    }
  };
}), bX = nn.forwardRef(
  ({
    attachments: e = [],
    onBrowse: n,
    extraSource: i,
    children: a,
    hideFilesList: s,
    ...g
  }, c) => {
    const I = e.length > 0 && !s;
    return /* @__PURE__ */ v.jsxs(Om, { ref: c, border: "none", ...g, children: [
      a,
      /* @__PURE__ */ v.jsxs(qe, { width: "100%", children: [
        /* @__PURE__ */ v.jsx(
          _1,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: I ? "space-between" : "center"
          }
        ),
        I && /* @__PURE__ */ v.jsx(qe, { gap: 2, mt: 1, "data-testid": "dnd-attachments", children: e.map((h, m) => !h.filename && !h.mimeType ? /* @__PURE__ */ v.jsx(UM, {}) : /* @__PURE__ */ v.jsx(
          km,
          {
            ...h
          },
          `${m}-${h.filename}`
        )) }),
        /* @__PURE__ */ v.jsx(
          yX,
          {
            startIcon: /* @__PURE__ */ v.jsx(De, { icon: "paperclip" }),
            variant: "outlined",
            onClick: n,
            children: "Add files"
          }
        ),
        i && /* @__PURE__ */ v.jsxs(
          _1,
          {
            sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 0.5,
              mt: 1
            },
            children: [
              "or ",
              i
            ]
          }
        )
      ] })
    ] });
  }
), Je1 = nn.forwardRef(
  (e, n) => {
    const { isMobile: i } = rJ();
    return i ? /* @__PURE__ */ v.jsx(bX, { ...e, ref: n }) : /* @__PURE__ */ v.jsx(vX, { ...e, ref: n });
  }
), _M = ({
  open: e,
  onClick: n
}) => /* @__PURE__ */ v.jsx(
  Vj,
  {
    sx: {
      color: (i) => i.palette.primary.dark,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      zIndex: (i) => i.zIndex.modal + 9999
    },
    open: e,
    onClick: n,
    children: /* @__PURE__ */ v.jsx(D3, { color: "inherit", "data-testid": "global-loader" })
  }
), wX = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, xX = [
  "color",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight"
], QC = {
  open: !1,
  anchorEl: null,
  textStyle: {},
  width: 0
}, SX = (e) => e.scrollWidth > e.clientWidth, EX = (e) => {
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
};
function MX(e, { enabled: n, triggerRef: i }) {
  const [a, s] = gt(QC);
  return vn(() => {
    const g = e.current, c = (i == null ? void 0 : i.current) ?? g;
    if (!n || !g || !c) {
      s(QC);
      return;
    }
    let I = !1, h = !1, m = !1;
    const w = (X) => {
      X.target instanceof Node && X.target.contains(g) && z();
    }, x = (X) => {
      X !== m && (m = X, X ? document.addEventListener("scroll", w, !0) : document.removeEventListener("scroll", w, !0));
    };
    let M = null;
    const O = (X) => {
      if (X !== (M != null))
        if (X) {
          if (typeof ResizeObserver > "u") return;
          M = new ResizeObserver(() => k()), M.observe(g);
        } else
          M == null || M.disconnect(), M = null;
    }, k = () => {
      if (O(I || h), (I || h) && SX(g)) {
        const X = window.getComputedStyle(g), B = {};
        xX.forEach((Z) => {
          B[Z] = X[Z];
        }), s({
          open: !0,
          anchorEl: g,
          textStyle: B,
          width: g.getBoundingClientRect().width
        }), x(!0);
      } else
        s(QC), x(!1);
    }, z = () => {
      I = !1, h = !1, k();
    }, N = () => {
      I = !0, k();
    }, U = () => {
      I = !1, k();
    }, Q = () => {
      h = EX(c), k();
    }, _ = () => {
      h = !1, k();
    };
    return c.addEventListener("pointerenter", N), c.addEventListener("pointerleave", U), c.addEventListener("focus", Q), c.addEventListener("blur", _), c.addEventListener("dragstart", z), () => {
      c.removeEventListener("pointerenter", N), c.removeEventListener("pointerleave", U), c.removeEventListener("focus", Q), c.removeEventListener("blur", _), c.removeEventListener("dragstart", z), x(!1), O(!1), s(QC);
    };
  }, [n, e, i]), a;
}
const TX = q1(le)(wX), bx = 0.5, VM = ja(({ revealOnHover: e = !1, revealTriggerRef: n, revealWithinWidth: i = !1, children: a, ...s }, g) => {
  const c = ka(), I = Cn(null), h = Kj(g, I), m = MX(I, {
    enabled: e,
    triggerRef: n
  }), w = V2(
    () => LX(parseFloat(c.spacing(bx))),
    [c]
  );
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(TX, { ref: h, ...s, children: a }),
    e && /* @__PURE__ */ v.jsx(
      hS,
      {
        open: m.open,
        anchorEl: m.anchorEl,
        placement: "bottom-start",
        modifiers: w,
        "aria-hidden": !0,
        "data-testid": "overflow-reveal",
        sx: { zIndex: "tooltip", pointerEvents: "none" },
        children: /* @__PURE__ */ v.jsx(
          _1,
          {
            sx: {
              ...m.textStyle,
              px: bx,
              width: "max-content",
              maxWidth: `calc(100vw - ${c.spacing(2)})`,
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              bgcolor: "background.paper",
              borderRadius: 0.5,
              boxShadow: 2,
              // The text's own width, with the padding outside it.
              ...i && {
                boxSizing: "content-box",
                width: `${m.width}px`
              }
            },
            children: a
          }
        )
      }
    )
  ] });
});
VM.displayName = "OverflowTypography";
const LX = (e) => [
  {
    name: "offset",
    options: {
      offset: ({ reference: n }) => [
        -e,
        -n.height
      ]
    }
  },
  { name: "flip", enabled: !1 },
  { name: "preventOverflow", options: { padding: 8, altAxis: !0 } }
], RX = q1(_1)({
  width: "10px",
  height: "10px",
  borderRadius: "50%"
}), OX = ({ color: e }) => /* @__PURE__ */ v.jsx(
  RX,
  {
    "data-testid": e ? "unread-dot" : "",
    sx: { backgroundColor: e || "transparent" }
  }
), Rh = ({
  numberOfElements: e = 2,
  mt: n = 8
}) => /* @__PURE__ */ v.jsx(qe, { gap: 2, alignItems: "center", mt: n, role: "progressbar", children: Array(e).fill("").map((i, a) => /* @__PURE__ */ v.jsx(_h, { height: 60, width: "80%" }, a)) });
var DX = Object.defineProperty, kX = Object.defineProperties, jX = Object.getOwnPropertyDescriptors, OA = Object.getOwnPropertySymbols, KM = Object.prototype.hasOwnProperty, JM = Object.prototype.propertyIsEnumerable, wx = (e, n, i) => n in e ? DX(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, Ko = (e, n) => {
  for (var i in n || (n = {}))
    KM.call(n, i) && wx(e, i, n[i]);
  if (OA)
    for (var i of OA(n))
      JM.call(n, i) && wx(e, i, n[i]);
  return e;
}, zX = (e, n) => kX(e, jX(n)), YM = (e, n) => {
  var i = {};
  for (var a in e)
    KM.call(e, a) && n.indexOf(a) < 0 && (i[a] = e[a]);
  if (e != null && OA)
    for (var a of OA(e))
      n.indexOf(a) < 0 && JM.call(e, a) && (i[a] = e[a]);
  return i;
}, NX = Object.defineProperty, PX = Object.defineProperties, FX = Object.getOwnPropertyDescriptors, DA = Object.getOwnPropertySymbols, QM = Object.prototype.hasOwnProperty, XM = Object.prototype.propertyIsEnumerable, Oh = (e, n, i) => n in e ? NX(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, ar = (e, n) => {
  for (var i in n || (n = {}))
    QM.call(n, i) && Oh(e, i, n[i]);
  if (DA)
    for (var i of DA(n))
      XM.call(n, i) && Oh(e, i, n[i]);
  return e;
}, v3 = (e, n) => PX(e, FX(n)), GM = (e, n) => {
  var i = {};
  for (var a in e)
    QM.call(e, a) && n.indexOf(a) < 0 && (i[a] = e[a]);
  if (e != null && DA)
    for (var a of DA(e))
      n.indexOf(a) < 0 && XM.call(e, a) && (i[a] = e[a]);
  return i;
}, dt = (e, n, i) => Oh(e, typeof n != "symbol" ? n + "" : n, i), vt = (e, n, i) => new Promise((a, s) => {
  var g = (h) => {
    try {
      I(i.next(h));
    } catch (m) {
      s(m);
    }
  }, c = (h) => {
    try {
      I(i.throw(h));
    } catch (m) {
      s(m);
    }
  }, I = (h) => h.done ? a(h.value) : Promise.resolve(h.value).then(g, c);
  I((i = i.apply(e, n)).next());
}), BX = class {
  requestAnimationFrame(e) {
    return requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    cancelAnimationFrame(e);
  }
}, HX = class {
  constructor() {
    dt(this, "_lastHandleId", 0), dt(this, "_lastImmediate", null);
  }
  requestAnimationFrame(e) {
    return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(() => {
      e(Date.now());
    }), this._lastHandleId;
  }
  cancelAnimationFrame(e) {
    this._lastImmediate && clearImmediate(this._lastImmediate);
  }
}, UX = class {
  constructor() {
    dt(this, "_strategy"), this._strategy = typeof requestAnimationFrame == "function" ? new BX() : new HX();
  }
  requestAnimationFrame(e) {
    return this._strategy.requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    this._strategy.cancelAnimationFrame(e);
  }
}, Dr = typeof window < "u" && typeof window.document < "u", p7 = new Uint8Array([80, 75, 3, 4]), WX = ["v", "ip", "op", "layers", "fr", "w", "h"], qM = "0.35.0", ZM = "@lottiefiles/dotlottie-web", _X = 0.75, VX = (() => {
  var e, n = typeof document < "u" ? (e = document.currentScript) == null ? void 0 : e.src : void 0;
  return function(i = {}) {
    var a, s = i, g, c, I = new Promise((L, R) => {
      g = L, c = R;
    }), h = Object.assign({}, s), m = "./this.program", w = "", x;
    typeof document < "u" && document.currentScript && (w = document.currentScript.src), n && (w = n), w.startsWith("blob:") ? w = "" : w = w.substr(0, w.replace(/[?#].*/, "").lastIndexOf("/") + 1), x = (L) => fetch(L, { credentials: "same-origin" }).then((R) => R.ok ? R.arrayBuffer() : Promise.reject(Error(R.status + " : " + R.url)));
    var M = s.print || console.log.bind(console), O = s.printErr || console.error.bind(console);
    Object.assign(s, h), h = null, s.thisProgram && (m = s.thisProgram);
    var k = s.wasmBinary, z, N = !1, U, Q, _, X, B, Z, Y, V, J;
    function e1() {
      var L = z.buffer;
      s.HEAP8 = Q = new Int8Array(L), s.HEAP16 = X = new Int16Array(L), s.HEAPU8 = _ = new Uint8Array(L), s.HEAPU16 = B = new Uint16Array(L), s.HEAP32 = Z = new Int32Array(L), s.HEAPU32 = Y = new Uint32Array(L), s.HEAPF32 = V = new Float32Array(L), s.HEAPF64 = J = new Float64Array(L);
    }
    var f1 = [], v1 = [], a1 = [];
    function d1() {
      var L = s.preRun.shift();
      f1.unshift(L);
    }
    var S1 = 0, h1 = null;
    function L1(L) {
      var R;
      throw (R = s.onAbort) == null || R.call(s, L), L = "Aborted(" + L + ")", O(L), N = !0, L = new WebAssembly.RuntimeError(L + ". Build with -sASSERTIONS for more info."), c(L), L;
    }
    var c1 = (L) => L.startsWith("data:application/octet-stream;base64,"), b1;
    function t1(L) {
      if (L == b1 && k)
        return new Uint8Array(k);
      throw "both async and sync fetching of the wasm failed";
    }
    function C1(L) {
      return k ? Promise.resolve().then(() => t1(L)) : x(L).then((R) => new Uint8Array(R), () => t1(L));
    }
    function w1(L, R, H) {
      return C1(L).then((W) => WebAssembly.instantiate(W, R)).then(H, (W) => {
        O(`failed to asynchronously prepare wasm: ${W}`), L1(W);
      });
    }
    function E1(L, R) {
      var H = b1;
      return k || typeof WebAssembly.instantiateStreaming != "function" || c1(H) || typeof fetch != "function" ? w1(H, L, R) : fetch(H, { credentials: "same-origin" }).then((W) => WebAssembly.instantiateStreaming(W, L).then(R, function($) {
        return O(`wasm streaming compile failed: ${$}`), O("falling back to ArrayBuffer instantiation"), w1(H, L, R);
      }));
    }
    function V1(L) {
      this.name = "ExitStatus", this.message = `Program terminated with exit(${L})`, this.status = L;
    }
    var K1 = (L) => {
      for (; 0 < L.length; )
        L.shift()(s);
    }, B1 = s.noExitRuntime || !0, te = typeof TextDecoder < "u" ? new TextDecoder() : void 0, R1 = (L, R, H) => {
      var W = R + H;
      for (H = R; L[H] && !(H >= W); )
        ++H;
      if (16 < H - R && L.buffer && te)
        return te.decode(L.subarray(R, H));
      for (W = ""; R < H; ) {
        var $ = L[R++];
        if ($ & 128) {
          var I1 = L[R++] & 63;
          if (($ & 224) == 192)
            W += String.fromCharCode(($ & 31) << 6 | I1);
          else {
            var U1 = L[R++] & 63;
            $ = ($ & 240) == 224 ? ($ & 15) << 12 | I1 << 6 | U1 : ($ & 7) << 18 | I1 << 12 | U1 << 6 | L[R++] & 63, 65536 > $ ? W += String.fromCharCode($) : ($ -= 65536, W += String.fromCharCode(55296 | $ >> 10, 56320 | $ & 1023));
          }
        } else
          W += String.fromCharCode($);
      }
      return W;
    };
    class x1 {
      constructor(R) {
        this.Ca = R - 24;
      }
    }
    var J1 = 0, X1 = (L, R, H) => {
      var W = _;
      if (0 < H) {
        H = R + H - 1;
        for (var $ = 0; $ < L.length; ++$) {
          var I1 = L.charCodeAt($);
          if (55296 <= I1 && 57343 >= I1) {
            var U1 = L.charCodeAt(++$);
            I1 = 65536 + ((I1 & 1023) << 10) | U1 & 1023;
          }
          if (127 >= I1) {
            if (R >= H)
              break;
            W[R++] = I1;
          } else {
            if (2047 >= I1) {
              if (R + 1 >= H)
                break;
              W[R++] = 192 | I1 >> 6;
            } else {
              if (65535 >= I1) {
                if (R + 2 >= H)
                  break;
                W[R++] = 224 | I1 >> 12;
              } else {
                if (R + 3 >= H)
                  break;
                W[R++] = 240 | I1 >> 18, W[R++] = 128 | I1 >> 12 & 63;
              }
              W[R++] = 128 | I1 >> 6 & 63;
            }
            W[R++] = 128 | I1 & 63;
          }
        }
        W[R] = 0;
      }
    }, D1 = {}, $1 = (L) => {
      for (; L.length; ) {
        var R = L.pop();
        L.pop()(R);
      }
    };
    function y1(L) {
      return this.fromWireType(Y[L >> 2]);
    }
    var ie = {}, ae = {}, H1 = {}, Y1, me = (L, R, H) => {
      function W(O1) {
        if (O1 = H(O1), O1.length !== L.length)
          throw new Y1("Mismatched type converter count");
        for (var ce = 0; ce < L.length; ++ce)
          ke(L[ce], O1[ce]);
      }
      L.forEach((O1) => H1[O1] = R);
      var $ = Array(R.length), I1 = [], U1 = 0;
      R.forEach((O1, ce) => {
        ae.hasOwnProperty(O1) ? $[ce] = ae[O1] : (I1.push(O1), ie.hasOwnProperty(O1) || (ie[O1] = []), ie[O1].push(() => {
          $[ce] = ae[O1], ++U1, U1 === I1.length && W($);
        }));
      }), I1.length === 0 && W($);
    }, ut, Qe = (L) => {
      for (var R = ""; _[L]; )
        R += ut[_[L++]];
      return R;
    }, Ae;
    function Bt(L, R, H = {}) {
      var W = R.name;
      if (!L)
        throw new Ae(`type "${W}" must have a positive integer typeid pointer`);
      if (ae.hasOwnProperty(L)) {
        if (H.hb)
          return;
        throw new Ae(`Cannot register type '${W}' twice`);
      }
      ae[L] = R, delete H1[L], ie.hasOwnProperty(L) && (R = ie[L], delete ie[L], R.forEach(($) => $()));
    }
    function ke(L, R, H = {}) {
      return Bt(L, R, H);
    }
    var bt = (L) => {
      throw new Ae(L.Aa.Da.Ba.name + " instance already deleted");
    }, pt = !1, rt = () => {
    }, Jt = (L, R, H) => R === H ? L : H.Ga === void 0 ? null : (L = Jt(L, R, H.Ga), L === null ? null : H.$a(L)), Pe = {}, yn = [], ee = () => {
      for (; yn.length; ) {
        var L = yn.pop();
        L.Aa.Ma = !1, L.delete();
      }
    }, ge, _e = {}, wt = (L, R) => {
      if (R === void 0)
        throw new Ae("ptr should not be undefined");
      for (; L.Ga; )
        R = L.Pa(R), L = L.Ga;
      return _e[R];
    }, Yt = (L, R) => {
      if (!R.Da || !R.Ca)
        throw new Y1("makeClassHandle requires ptr and ptrType");
      if (!!R.Ha != !!R.Ea)
        throw new Y1("Both smartPtrType and smartPtr must be specified");
      return R.count = { value: 1 }, An(Object.create(L, { Aa: { value: R, writable: !0 } }));
    }, An = (L) => typeof FinalizationRegistry > "u" ? (An = (R) => R, L) : (pt = new FinalizationRegistry((R) => {
      R = R.Aa, --R.count.value, R.count.value === 0 && (R.Ea ? R.Ha.Ka(R.Ea) : R.Da.Ba.Ka(R.Ca));
    }), An = (R) => {
      var H = R.Aa;
      return H.Ea && pt.register(R, { Aa: H }, R), R;
    }, rt = (R) => {
      pt.unregister(R);
    }, An(L));
    function sn() {
    }
    var Hn = (L, R) => Object.defineProperty(R, "name", { value: L }), Ht = (L, R, H) => {
      if (L[R].Fa === void 0) {
        var W = L[R];
        L[R] = function(...$) {
          if (!L[R].Fa.hasOwnProperty($.length))
            throw new Ae(`Function '${H}' called with an invalid number of arguments (${$.length}) - expects one of (${L[R].Fa})!`);
          return L[R].Fa[$.length].apply(this, $);
        }, L[R].Fa = [], L[R].Fa[W.Qa] = W;
      }
    }, b2 = (L, R, H) => {
      if (s.hasOwnProperty(L)) {
        if (H === void 0 || s[L].Fa !== void 0 && s[L].Fa[H] !== void 0)
          throw new Ae(`Cannot register public name '${L}' twice`);
        if (Ht(s, L, L), s.hasOwnProperty(H))
          throw new Ae(`Cannot register multiple overloads of a function with the same number of arguments (${H})!`);
        s[L].Fa[H] = R;
      } else
        s[L] = R, H !== void 0 && (s[L].qb = H);
    }, Ut = (L) => {
      if (L === void 0)
        return "_unknown";
      L = L.replace(/[^a-zA-Z0-9_]/g, "$");
      var R = L.charCodeAt(0);
      return 48 <= R && 57 >= R ? `_${L}` : L;
    };
    function Qt(L, R, H, W, $, I1, U1, O1) {
      this.name = L, this.constructor = R, this.Na = H, this.Ka = W, this.Ga = $, this.bb = I1, this.Pa = U1, this.$a = O1, this.jb = [];
    }
    var N3 = (L, R, H) => {
      for (; R !== H; ) {
        if (!R.Pa)
          throw new Ae(`Expected null or instance of ${H.name}, got an instance of ${R.name}`);
        L = R.Pa(L), R = R.Ga;
      }
      return L;
    };
    function ci(L, R) {
      if (R === null) {
        if (this.Ta)
          throw new Ae(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!R.Aa)
        throw new Ae(`Cannot pass "${rn(R)}" as a ${this.name}`);
      if (!R.Aa.Ca)
        throw new Ae(`Cannot pass deleted object as a pointer of type ${this.name}`);
      return N3(R.Aa.Ca, R.Aa.Da.Ba, this.Ba);
    }
    function Vi(L, R) {
      if (R === null) {
        if (this.Ta)
          throw new Ae(`null is not a valid ${this.name}`);
        if (this.Sa) {
          var H = this.Ua();
          return L !== null && L.push(this.Ka, H), H;
        }
        return 0;
      }
      if (!R || !R.Aa)
        throw new Ae(`Cannot pass "${rn(R)}" as a ${this.name}`);
      if (!R.Aa.Ca)
        throw new Ae(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (!this.Ra && R.Aa.Da.Ra)
        throw new Ae(`Cannot convert argument of type ${R.Aa.Ha ? R.Aa.Ha.name : R.Aa.Da.name} to parameter type ${this.name}`);
      if (H = N3(R.Aa.Ca, R.Aa.Da.Ba, this.Ba), this.Sa) {
        if (R.Aa.Ea === void 0)
          throw new Ae("Passing raw pointer to smart pointer is illegal");
        switch (this.ob) {
          case 0:
            if (R.Aa.Ha === this)
              H = R.Aa.Ea;
            else
              throw new Ae(`Cannot convert argument of type ${R.Aa.Ha ? R.Aa.Ha.name : R.Aa.Da.name} to parameter type ${this.name}`);
            break;
          case 1:
            H = R.Aa.Ea;
            break;
          case 2:
            if (R.Aa.Ha === this)
              H = R.Aa.Ea;
            else {
              var W = R.clone();
              H = this.kb(H, He(() => W.delete())), L !== null && L.push(this.Ka, H);
            }
            break;
          default:
            throw new Ae("Unsupporting sharing policy");
        }
      }
      return H;
    }
    function F0(L, R) {
      if (R === null) {
        if (this.Ta)
          throw new Ae(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!R.Aa)
        throw new Ae(`Cannot pass "${rn(R)}" as a ${this.name}`);
      if (!R.Aa.Ca)
        throw new Ae(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (R.Aa.Da.Ra)
        throw new Ae(`Cannot convert argument of type ${R.Aa.Da.name} to parameter type ${this.name}`);
      return N3(R.Aa.Ca, R.Aa.Da.Ba, this.Ba);
    }
    function P3(L, R, H, W, $, I1, U1, O1, ce, fe, Le) {
      this.name = L, this.Ba = R, this.Ta = H, this.Ra = W, this.Sa = $, this.ib = I1, this.ob = U1, this.Ya = O1, this.Ua = ce, this.kb = fe, this.Ka = Le, $ || R.Ga !== void 0 ? this.toWireType = Vi : (this.toWireType = W ? ci : F0, this.Ja = null);
    }
    var F3 = (L, R, H) => {
      if (!s.hasOwnProperty(L))
        throw new Y1("Replacing nonexistent public symbol");
      s[L].Fa !== void 0 && H !== void 0 ? s[L].Fa[H] = R : (s[L] = R, s[L].Qa = H);
    }, Xn, gi = (L, R, H = []) => (L.includes("j") ? (L = L.replace(/p/g, "i"), R = (0, s["dynCall_" + L])(R, ...H)) : R = Xn.get(R)(...H), R), Ki = (L, R) => (...H) => gi(L, R, H), ln = (L, R) => {
      L = Qe(L);
      var H = L.includes("j") ? Ki(L, R) : Xn.get(R);
      if (typeof H != "function")
        throw new Ae(`unknown function pointer with signature ${L}: ${R}`);
      return H;
    }, Xr, z2 = (L) => {
      L = is(L);
      var R = Qe(L);
      return cr(L), R;
    }, N2 = (L, R) => {
      function H(I1) {
        $[I1] || ae[I1] || (H1[I1] ? H1[I1].forEach(H) : (W.push(I1), $[I1] = !0));
      }
      var W = [], $ = {};
      throw R.forEach(H), new Xr(`${L}: ` + W.map(z2).join([", "]));
    }, Gr = (L, R) => {
      for (var H = [], W = 0; W < L; W++)
        H.push(Y[R + 4 * W >> 2]);
      return H;
    };
    function fi(L) {
      for (var R = 1; R < L.length; ++R)
        if (L[R] !== null && L[R].Ja === void 0)
          return !0;
      return !1;
    }
    function G(L, R, H, W, $) {
      var I1 = R.length;
      if (2 > I1)
        throw new Ae("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var U1 = R[1] !== null && H !== null, O1 = fi(R), ce = R[0].name !== "void", fe = I1 - 2, Le = Array(fe), lt = [], Ct = [];
      return Hn(L, function(...qn) {
        if (Ct.length = 0, lt.length = U1 ? 2 : 1, lt[0] = $, U1) {
          var an = R[1].toWireType(Ct, this);
          lt[1] = an;
        }
        for (var In = 0; In < fe; ++In)
          Le[In] = R[In + 2].toWireType(Ct, qn[In]), lt.push(Le[In]);
        if (qn = W(...lt), O1)
          $1(Ct);
        else
          for (In = U1 ? 1 : 2; In < R.length; In++) {
            var c2 = In === 1 ? an : Le[In - 2];
            R[In].Ja !== null && R[In].Ja(c2);
          }
        return an = ce ? R[0].fromWireType(qn) : void 0, an;
      });
    }
    var P1 = (L) => {
      L = L.trim();
      let R = L.indexOf("(");
      return R !== -1 ? L.substr(0, R) : L;
    }, re = [], be = [], st = (L) => {
      9 < L && --be[L + 1] === 0 && (be[L] = void 0, re.push(L));
    }, ft = (L) => {
      if (!L)
        throw new Ae("Cannot use deleted val. handle = " + L);
      return be[L];
    }, He = (L) => {
      switch (L) {
        case void 0:
          return 2;
        case null:
          return 4;
        case !0:
          return 6;
        case !1:
          return 8;
        default:
          let R = re.pop() || be.length;
          return be[R] = L, be[R + 1] = 1, R;
      }
    }, nt = { name: "emscripten::val", fromWireType: (L) => {
      var R = ft(L);
      return st(L), R;
    }, toWireType: (L, R) => He(R), Ia: 8, readValueFromPointer: y1, Ja: null }, Un = (L, R, H) => {
      switch (R) {
        case 1:
          return H ? function(W) {
            return this.fromWireType(Q[W]);
          } : function(W) {
            return this.fromWireType(_[W]);
          };
        case 2:
          return H ? function(W) {
            return this.fromWireType(X[W >> 1]);
          } : function(W) {
            return this.fromWireType(B[W >> 1]);
          };
        case 4:
          return H ? function(W) {
            return this.fromWireType(Z[W >> 2]);
          } : function(W) {
            return this.fromWireType(Y[W >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${R}): ${L}`);
      }
    }, Wt = (L, R) => {
      var H = ae[L];
      if (H === void 0)
        throw L = `${R} has unknown type ${z2(L)}`, new Ae(L);
      return H;
    }, rn = (L) => {
      if (L === null)
        return "null";
      var R = typeof L;
      return R === "object" || R === "array" || R === "function" ? L.toString() : "" + L;
    }, P2 = (L, R) => {
      switch (R) {
        case 4:
          return function(H) {
            return this.fromWireType(V[H >> 2]);
          };
        case 8:
          return function(H) {
            return this.fromWireType(J[H >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${R}): ${L}`);
      }
    }, B3 = (L, R, H) => {
      switch (R) {
        case 1:
          return H ? (W) => Q[W] : (W) => _[W];
        case 2:
          return H ? (W) => X[W >> 1] : (W) => B[W >> 1];
        case 4:
          return H ? (W) => Z[W >> 2] : (W) => Y[W >> 2];
        default:
          throw new TypeError(`invalid integer width (${R}): ${L}`);
      }
    }, Et = Object.assign({ optional: !0 }, nt), Gn = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, K2 = (L, R) => {
      for (var H = L >> 1, W = H + R / 2; !(H >= W) && B[H]; )
        ++H;
      if (H <<= 1, 32 < H - L && Gn)
        return Gn.decode(_.subarray(L, H));
      for (H = "", W = 0; !(W >= R / 2); ++W) {
        var $ = X[L + 2 * W >> 1];
        if ($ == 0)
          break;
        H += String.fromCharCode($);
      }
      return H;
    }, it = (L, R, H) => {
      if (H != null || (H = 2147483647), 2 > H)
        return 0;
      H -= 2;
      var W = R;
      H = H < 2 * L.length ? H / 2 : L.length;
      for (var $ = 0; $ < H; ++$)
        X[R >> 1] = L.charCodeAt($), R += 2;
      return X[R >> 1] = 0, R - W;
    }, qr = (L) => 2 * L.length, ml = (L, R) => {
      for (var H = 0, W = ""; !(H >= R / 4); ) {
        var $ = Z[L + 4 * H >> 2];
        if ($ == 0)
          break;
        ++H, 65536 <= $ ? ($ -= 65536, W += String.fromCharCode(55296 | $ >> 10, 56320 | $ & 1023)) : W += String.fromCharCode($);
      }
      return W;
    }, ns = (L, R, H) => {
      if (H != null || (H = 2147483647), 4 > H)
        return 0;
      var W = R;
      H = W + H - 4;
      for (var $ = 0; $ < L.length; ++$) {
        var I1 = L.charCodeAt($);
        if (55296 <= I1 && 57343 >= I1) {
          var U1 = L.charCodeAt(++$);
          I1 = 65536 + ((I1 & 1023) << 10) | U1 & 1023;
        }
        if (Z[R >> 2] = I1, R += 4, R + 4 > H)
          break;
      }
      return Z[R >> 2] = 0, R - W;
    }, B0 = (L) => {
      for (var R = 0, H = 0; H < L.length; ++H) {
        var W = L.charCodeAt(H);
        55296 <= W && 57343 >= W && ++H, R += 4;
      }
      return R;
    }, J2 = [], vl = (L) => {
      var R = J2.length;
      return J2.push(L), R;
    }, ur = (L, R) => {
      for (var H = Array(L), W = 0; W < L; ++W)
        H[W] = Wt(Y[R + 4 * W >> 2], "parameter " + W);
      return H;
    }, yl = Reflect.construct, Ji = {}, bl = (L) => {
      if (!(L instanceof V1 || L == "unwind"))
        throw L;
    }, Yi = 0, di = (L) => {
      var R;
      throw U = L, B1 || 0 < Yi || ((R = s.onExit) == null || R.call(s, L), N = !0), new V1(L);
    }, Ci = (L) => {
      if (!N)
        try {
          if (L(), !(B1 || 0 < Yi))
            try {
              U = L = U, di(L);
            } catch (R) {
              bl(R);
            }
        } catch (R) {
          bl(R);
        }
    }, Y2 = {}, Na = () => {
      if (!Qi) {
        var L = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: m || "./this.program" }, R;
        for (R in Y2)
          Y2[R] === void 0 ? delete L[R] : L[R] = Y2[R];
        var H = [];
        for (R in L)
          H.push(`${R}=${L[R]}`);
        Qi = H;
      }
      return Qi;
    }, Qi, rs = [null, [], []], Pa = () => {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
        return (L) => crypto.getRandomValues(L);
      L1("initRandomDevice");
    }, Fa = (L) => (Fa = Pa())(L);
    Y1 = s.InternalError = class extends Error {
      constructor(L) {
        super(L), this.name = "InternalError";
      }
    };
    for (var H3 = Array(256), Ba = 0; 256 > Ba; ++Ba)
      H3[Ba] = String.fromCharCode(Ba);
    ut = H3, Ae = s.BindingError = class extends Error {
      constructor(L) {
        super(L), this.name = "BindingError";
      }
    }, Object.assign(sn.prototype, { isAliasOf: function(L) {
      if (!(this instanceof sn && L instanceof sn))
        return !1;
      var R = this.Aa.Da.Ba, H = this.Aa.Ca;
      L.Aa = L.Aa;
      var W = L.Aa.Da.Ba;
      for (L = L.Aa.Ca; R.Ga; )
        H = R.Pa(H), R = R.Ga;
      for (; W.Ga; )
        L = W.Pa(L), W = W.Ga;
      return R === W && H === L;
    }, clone: function() {
      if (this.Aa.Ca || bt(this), this.Aa.Oa)
        return this.Aa.count.value += 1, this;
      var L = An, R = Object, H = R.create, W = Object.getPrototypeOf(this), $ = this.Aa;
      return L = L(H.call(R, W, { Aa: { value: { count: $.count, Ma: $.Ma, Oa: $.Oa, Ca: $.Ca, Da: $.Da, Ea: $.Ea, Ha: $.Ha } } })), L.Aa.count.value += 1, L.Aa.Ma = !1, L;
    }, delete() {
      if (this.Aa.Ca || bt(this), this.Aa.Ma && !this.Aa.Oa)
        throw new Ae("Object already scheduled for deletion");
      rt(this);
      var L = this.Aa;
      --L.count.value, L.count.value === 0 && (L.Ea ? L.Ha.Ka(L.Ea) : L.Da.Ba.Ka(L.Ca)), this.Aa.Oa || (this.Aa.Ea = void 0, this.Aa.Ca = void 0);
    }, isDeleted: function() {
      return !this.Aa.Ca;
    }, deleteLater: function() {
      if (this.Aa.Ca || bt(this), this.Aa.Ma && !this.Aa.Oa)
        throw new Ae("Object already scheduled for deletion");
      return yn.push(this), yn.length === 1 && ge && ge(ee), this.Aa.Ma = !0, this;
    } }), s.getInheritedInstanceCount = () => Object.keys(_e).length, s.getLiveInheritedInstances = () => {
      var L = [], R;
      for (R in _e)
        _e.hasOwnProperty(R) && L.push(_e[R]);
      return L;
    }, s.flushPendingDeletes = ee, s.setDelayFunction = (L) => {
      ge = L, yn.length && ge && ge(ee);
    }, Object.assign(P3.prototype, { cb(L) {
      return this.Ya && (L = this.Ya(L)), L;
    }, Wa(L) {
      var R;
      (R = this.Ka) == null || R.call(this, L);
    }, Ia: 8, readValueFromPointer: y1, fromWireType: function(L) {
      function R() {
        return this.Sa ? Yt(this.Ba.Na, { Da: this.ib, Ca: H, Ha: this, Ea: L }) : Yt(this.Ba.Na, { Da: this, Ca: L });
      }
      var H = this.cb(L);
      if (!H)
        return this.Wa(L), null;
      var W = wt(this.Ba, H);
      if (W !== void 0)
        return W.Aa.count.value === 0 ? (W.Aa.Ca = H, W.Aa.Ea = L, W.clone()) : (W = W.clone(), this.Wa(L), W);
      if (W = this.Ba.bb(H), W = Pe[W], !W)
        return R.call(this);
      W = this.Ra ? W.Za : W.pointerType;
      var $ = Jt(H, this.Ba, W.Ba);
      return $ === null ? R.call(this) : this.Sa ? Yt(W.Ba.Na, { Da: W, Ca: $, Ha: this, Ea: L }) : Yt(W.Ba.Na, { Da: W, Ca: $ });
    } }), Xr = s.UnboundTypeError = ((L, R) => {
      var H = Hn(R, function(W) {
        this.name = R, this.message = W, W = Error(W).stack, W !== void 0 && (this.stack = this.toString() + `
` + W.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return H.prototype = Object.create(L.prototype), H.prototype.constructor = H, H.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, H;
    })(Error, "UnboundTypeError"), be.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), s.count_emval_handles = () => be.length / 2 - 5 - re.length;
    var H0 = { c: (L, R, H, W) => {
      L1(`Assertion failed: ${L ? R1(_, L) : ""}, at: ` + [R ? R ? R1(_, R) : "" : "unknown filename", H, W ? W ? R1(_, W) : "" : "unknown function"]);
    }, m: (L, R, H) => {
      var W = new x1(L);
      throw Y[W.Ca + 16 >> 2] = 0, Y[W.Ca + 4 >> 2] = R, Y[W.Ca + 8 >> 2] = H, J1 = L, J1;
    }, C: function() {
      return 0;
    }, S: () => {
    }, P: () => {
    }, T: function() {
      return 0;
    }, Q: () => {
    }, B: function() {
    }, R: () => {
    }, U: () => {
      L1("");
    }, v: (L) => {
      var R = D1[L];
      delete D1[L];
      var H = R.Ua, W = R.Ka, $ = R.Xa, I1 = $.map((U1) => U1.gb).concat($.map((U1) => U1.mb));
      me([L], I1, (U1) => {
        var O1 = {};
        return $.forEach((ce, fe) => {
          var Le = U1[fe], lt = ce.eb, Ct = ce.fb, qn = U1[fe + $.length], an = ce.lb, In = ce.nb;
          O1[ce.ab] = { read: (c2) => Le.fromWireType(lt(Ct, c2)), write: (c2, b3) => {
            var F2 = [];
            an(In, c2, qn.toWireType(F2, b3)), $1(F2);
          } };
        }), [{ name: R.name, fromWireType: (ce) => {
          var fe = {}, Le;
          for (Le in O1)
            fe[Le] = O1[Le].read(ce);
          return W(ce), fe;
        }, toWireType: (ce, fe) => {
          for (var Le in O1)
            if (!(Le in fe))
              throw new TypeError(`Missing field: "${Le}"`);
          var lt = H();
          for (Le in O1)
            O1[Le].write(lt, fe[Le]);
          return ce !== null && ce.push(W, lt), lt;
        }, Ia: 8, readValueFromPointer: y1, Ja: W }];
      });
    }, J: () => {
    }, _: (L, R, H, W) => {
      R = Qe(R), ke(L, { name: R, fromWireType: function($) {
        return !!$;
      }, toWireType: function($, I1) {
        return I1 ? H : W;
      }, Ia: 8, readValueFromPointer: function($) {
        return this.fromWireType(_[$]);
      }, Ja: null });
    }, r: (L, R, H, W, $, I1, U1, O1, ce, fe, Le, lt, Ct) => {
      Le = Qe(Le), I1 = ln($, I1), O1 && (O1 = ln(U1, O1)), fe && (fe = ln(ce, fe)), Ct = ln(lt, Ct);
      var qn = Ut(Le);
      b2(qn, function() {
        N2(`Cannot construct ${Le} due to unbound types`, [W]);
      }), me([L, R, H], W ? [W] : [], (an) => {
        if (an = an[0], W)
          var In = an.Ba, c2 = In.Na;
        else
          c2 = sn.prototype;
        an = Hn(Le, function(...Zr) {
          if (Object.getPrototypeOf(this) !== b3)
            throw new Ae("Use 'new' to construct " + Le);
          if (F2.La === void 0)
            throw new Ae(Le + " has no accessible constructor");
          var V0 = F2.La[Zr.length];
          if (V0 === void 0)
            throw new Ae(`Tried to invoke ctor of ${Le} with invalid number of parameters (${Zr.length}) - expected (${Object.keys(F2.La).toString()}) parameters instead!`);
          return V0.apply(this, Zr);
        });
        var b3 = Object.create(c2, { constructor: { value: an } });
        an.prototype = b3;
        var F2 = new Qt(Le, an, b3, Ct, In, I1, O1, fe);
        if (F2.Ga) {
          var Zn;
          (Zn = F2.Ga).Va != null || (Zn.Va = []), F2.Ga.Va.push(F2);
        }
        return In = new P3(Le, F2, !0, !1, !1), Zn = new P3(Le + "*", F2, !1, !1, !1), c2 = new P3(Le + " const*", F2, !1, !0, !1), Pe[L] = { pointerType: Zn, Za: c2 }, F3(qn, an), [In, Zn, c2];
      });
    }, q: (L, R, H, W, $, I1) => {
      var U1 = Gr(R, H);
      $ = ln(W, $), me([], [L], (O1) => {
        O1 = O1[0];
        var ce = `constructor ${O1.name}`;
        if (O1.Ba.La === void 0 && (O1.Ba.La = []), O1.Ba.La[R - 1] !== void 0)
          throw new Ae(`Cannot register multiple constructors with identical number of parameters (${R - 1}) for class '${O1.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return O1.Ba.La[R - 1] = () => {
          N2(`Cannot construct ${O1.name} due to unbound types`, U1);
        }, me([], U1, (fe) => (fe.splice(1, 0, null), O1.Ba.La[R - 1] = G(ce, fe, null, $, I1), [])), [];
      });
    }, f: (L, R, H, W, $, I1, U1, O1) => {
      var ce = Gr(H, W);
      R = Qe(R), R = P1(R), I1 = ln($, I1), me([], [L], (fe) => {
        function Le() {
          N2(`Cannot call ${lt} due to unbound types`, ce);
        }
        fe = fe[0];
        var lt = `${fe.name}.${R}`;
        R.startsWith("@@") && (R = Symbol[R.substring(2)]), O1 && fe.Ba.jb.push(R);
        var Ct = fe.Ba.Na, qn = Ct[R];
        return qn === void 0 || qn.Fa === void 0 && qn.className !== fe.name && qn.Qa === H - 2 ? (Le.Qa = H - 2, Le.className = fe.name, Ct[R] = Le) : (Ht(Ct, R, lt), Ct[R].Fa[H - 2] = Le), me([], ce, (an) => (an = G(lt, an, fe, I1, U1), Ct[R].Fa === void 0 ? (an.Qa = H - 2, Ct[R] = an) : Ct[R].Fa[H - 2] = an, [])), [];
      });
    }, Z: (L) => ke(L, nt), x: (L, R, H, W) => {
      function $() {
      }
      R = Qe(R), $.values = {}, ke(L, { name: R, constructor: $, fromWireType: function(I1) {
        return this.constructor.values[I1];
      }, toWireType: (I1, U1) => U1.value, Ia: 8, readValueFromPointer: Un(R, H, W), Ja: null }), b2(R, $);
    }, k: (L, R, H) => {
      var W = Wt(L, "enum");
      R = Qe(R), L = W.constructor, W = Object.create(W.constructor.prototype, { value: { value: H }, constructor: { value: Hn(`${W.name}_${R}`, function() {
      }) } }), L.values[H] = W, L[R] = W;
    }, D: (L, R, H) => {
      R = Qe(R), ke(L, { name: R, fromWireType: (W) => W, toWireType: (W, $) => $, Ia: 8, readValueFromPointer: P2(R, H), Ja: null });
    }, F: (L, R, H, W, $, I1) => {
      var U1 = Gr(R, H);
      L = Qe(L), L = P1(L), $ = ln(W, $), b2(L, function() {
        N2(`Cannot call ${L} due to unbound types`, U1);
      }, R - 1), me([], U1, (O1) => (F3(L, G(L, [O1[0], null].concat(O1.slice(1)), null, $, I1), R - 1), []));
    }, l: (L, R, H, W, $) => {
      if (R = Qe(R), $ === -1 && ($ = 4294967295), $ = (O1) => O1, W === 0) {
        var I1 = 32 - 8 * H;
        $ = (O1) => O1 << I1 >>> I1;
      }
      var U1 = R.includes("unsigned") ? function(O1, ce) {
        return ce >>> 0;
      } : function(O1, ce) {
        return ce;
      };
      ke(L, { name: R, fromWireType: $, toWireType: U1, Ia: 8, readValueFromPointer: B3(R, H, W !== 0), Ja: null });
    }, h: (L, R, H) => {
      function W(I1) {
        return new $(Q.buffer, Y[I1 + 4 >> 2], Y[I1 >> 2]);
      }
      var $ = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][R];
      H = Qe(H), ke(L, { name: H, fromWireType: W, Ia: 8, readValueFromPointer: W }, { hb: !0 });
    }, u: (L) => {
      ke(L, Et);
    }, ea: (L, R, H, W, $, I1, U1, O1, ce, fe, Le, lt) => {
      H = Qe(H), I1 = ln($, I1), O1 = ln(U1, O1), fe = ln(ce, fe), lt = ln(Le, lt), me([L], [R], (Ct) => (Ct = Ct[0], [new P3(H, Ct.Ba, !1, !1, !0, Ct, W, I1, O1, fe, lt)]));
    }, E: (L, R) => {
      R = Qe(R);
      var H = R === "std::string";
      ke(L, { name: R, fromWireType: function(W) {
        var $ = Y[W >> 2], I1 = W + 4;
        if (H)
          for (var U1 = I1, O1 = 0; O1 <= $; ++O1) {
            var ce = I1 + O1;
            if (O1 == $ || _[ce] == 0) {
              if (U1 = U1 ? R1(_, U1, ce - U1) : "", fe === void 0)
                var fe = U1;
              else
                fe += "\0", fe += U1;
              U1 = ce + 1;
            }
          }
        else {
          for (fe = Array($), O1 = 0; O1 < $; ++O1)
            fe[O1] = String.fromCharCode(_[I1 + O1]);
          fe = fe.join("");
        }
        return cr(W), fe;
      }, toWireType: function(W, $) {
        $ instanceof ArrayBuffer && ($ = new Uint8Array($));
        var I1, U1 = typeof $ == "string";
        if (!(U1 || $ instanceof Uint8Array || $ instanceof Uint8ClampedArray || $ instanceof Int8Array))
          throw new Ae("Cannot pass non-string to std::string");
        if (H && U1)
          for (var O1 = I1 = 0; O1 < $.length; ++O1) {
            var ce = $.charCodeAt(O1);
            127 >= ce ? I1++ : 2047 >= ce ? I1 += 2 : 55296 <= ce && 57343 >= ce ? (I1 += 4, ++O1) : I1 += 3;
          }
        else
          I1 = $.length;
        if (O1 = U0(4 + I1 + 1), ce = O1 + 4, Y[O1 >> 2] = I1, H && U1)
          X1($, ce, I1 + 1);
        else if (U1)
          for (U1 = 0; U1 < I1; ++U1) {
            var fe = $.charCodeAt(U1);
            if (255 < fe)
              throw cr(ce), new Ae("String has UTF-16 code units that do not fit in 8 bits");
            _[ce + U1] = fe;
          }
        else
          for (U1 = 0; U1 < I1; ++U1)
            _[ce + U1] = $[U1];
        return W !== null && W.push(cr, O1), O1;
      }, Ia: 8, readValueFromPointer: y1, Ja(W) {
        cr(W);
      } });
    }, t: (L, R, H) => {
      if (H = Qe(H), R === 2)
        var W = K2, $ = it, I1 = qr, U1 = (O1) => B[O1 >> 1];
      else
        R === 4 && (W = ml, $ = ns, I1 = B0, U1 = (O1) => Y[O1 >> 2]);
      ke(L, { name: H, fromWireType: (O1) => {
        for (var ce = Y[O1 >> 2], fe, Le = O1 + 4, lt = 0; lt <= ce; ++lt) {
          var Ct = O1 + 4 + lt * R;
          (lt == ce || U1(Ct) == 0) && (Le = W(Le, Ct - Le), fe === void 0 ? fe = Le : (fe += "\0", fe += Le), Le = Ct + R);
        }
        return cr(O1), fe;
      }, toWireType: (O1, ce) => {
        if (typeof ce != "string")
          throw new Ae(`Cannot pass non-string to C++ string type ${H}`);
        var fe = I1(ce), Le = U0(4 + fe + R);
        return Y[Le >> 2] = fe / R, $(ce, Le + 4, fe + R), O1 !== null && O1.push(cr, Le), Le;
      }, Ia: 8, readValueFromPointer: y1, Ja(O1) {
        cr(O1);
      } });
    }, w: (L, R, H, W, $, I1) => {
      D1[L] = { name: Qe(R), Ua: ln(H, W), Ka: ln($, I1), Xa: [] };
    }, j: (L, R, H, W, $, I1, U1, O1, ce, fe) => {
      D1[L].Xa.push({ ab: Qe(R), gb: H, eb: ln(W, $), fb: I1, mb: U1, lb: ln(O1, ce), nb: fe });
    }, $: (L, R) => {
      R = Qe(R), ke(L, { pb: !0, name: R, Ia: 0, fromWireType: () => {
      }, toWireType: () => {
      } });
    }, O: () => {
      B1 = !1, Yi = 0;
    }, K: () => {
      throw 1 / 0;
    }, ca: (L, R, H, W) => (L = J2[L], R = ft(R), L(null, R, H, W)), G: st, ba: (L, R, H) => {
      var W = ur(L, R), $ = W.shift();
      L--;
      var I1 = Array(L);
      return R = `methodCaller<(${W.map((U1) => U1.name).join(", ")}) => ${$.name}>`, vl(Hn(R, (U1, O1, ce, fe) => {
        for (var Le = 0, lt = 0; lt < L; ++lt)
          I1[lt] = W[lt].readValueFromPointer(fe + Le), Le += W[lt].Ia;
        return O1 = H === 1 ? yl(O1, I1) : O1.apply(U1, I1), U1 = [], O1 = $.toWireType(U1, O1), U1.length && (Y[ce >> 2] = He(U1)), O1;
      }));
    }, da: (L) => {
      9 < L && (be[L + 1] += 1);
    }, aa: (L) => {
      var R = ft(L);
      $1(R), st(L);
    }, o: (L, R) => (L = Wt(L, "_emval_take_value"), L = L.readValueFromPointer(R), He(L)), L: (L, R) => {
      if (Ji[L] && (clearTimeout(Ji[L].id), delete Ji[L]), !R)
        return 0;
      var H = setTimeout(() => {
        delete Ji[L], Ci(() => Mt(L, performance.now()));
      }, R);
      return Ji[L] = { id: H, rb: R }, 0;
    }, M: (L, R, H, W) => {
      var $ = (/* @__PURE__ */ new Date()).getFullYear(), I1 = new Date($, 0, 1).getTimezoneOffset();
      $ = new Date($, 6, 1).getTimezoneOffset(), Y[L >> 2] = 60 * Math.max(I1, $), Z[R >> 2] = +(I1 != $), R = (U1) => {
        var O1 = Math.abs(U1);
        return `UTC${0 <= U1 ? "-" : "+"}${String(Math.floor(O1 / 60)).padStart(2, "0")}${String(O1 % 60).padStart(2, "0")}`;
      }, L = R(I1), R = R($), $ < I1 ? (X1(L, H, 17), X1(R, W, 17)) : (X1(L, W, 17), X1(R, H, 17));
    }, fa: () => performance.now(), N: (L) => {
      var R = _.length;
      if (L >>>= 0, 2147483648 < L)
        return !1;
      for (var H = 1; 4 >= H; H *= 2) {
        var W = R * (1 + 0.2 / H);
        W = Math.min(W, L + 100663296);
        e: {
          W = (Math.min(2147483648, 65536 * Math.ceil(Math.max(L, W) / 65536)) - z.buffer.byteLength + 65535) / 65536;
          try {
            z.grow(W), e1();
            var $ = 1;
            break e;
          } catch {
          }
          $ = void 0;
        }
        if ($)
          return !0;
      }
      return !1;
    }, W: (L, R) => {
      var H = 0;
      return Na().forEach((W, $) => {
        var I1 = R + H;
        for ($ = Y[L + 4 * $ >> 2] = I1, I1 = 0; I1 < W.length; ++I1)
          Q[$++] = W.charCodeAt(I1);
        Q[$] = 0, H += W.length + 1;
      }), 0;
    }, X: (L, R) => {
      var H = Na();
      Y[L >> 2] = H.length;
      var W = 0;
      return H.forEach(($) => W += $.length + 1), Y[R >> 2] = W, 0;
    }, s: () => 52, A: () => 52, I: function() {
      return 70;
    }, z: (L, R, H, W) => {
      for (var $ = 0, I1 = 0; I1 < H; I1++) {
        var U1 = Y[R >> 2], O1 = Y[R + 4 >> 2];
        R += 8;
        for (var ce = 0; ce < O1; ce++) {
          var fe = L, Le = _[U1 + ce], lt = rs[fe];
          Le === 0 || Le === 10 ? ((fe === 1 ? M : O)(R1(lt, 0)), lt.length = 0) : lt.push(Le);
        }
        $ += O1;
      }
      return Y[W >> 2] = $, 0;
    }, Y: (L, R) => (Fa(_.subarray(L, L + R)), 0), i: jn, d: W0, e: dr, p: Nt, y: u2, b: En, a: fr, g: zr, n: _c, H: U3, V: di }, Ve = function() {
      var L;
      function R(W) {
        var $;
        return Ve = W.exports, z = Ve.ga, e1(), Xn = Ve.ka, v1.unshift(Ve.ha), S1--, ($ = s.monitorRunDependencies) == null || $.call(s, S1), S1 == 0 && h1 && (W = h1, h1 = null, W()), Ve;
      }
      var H = { a: H0 };
      if (S1++, (L = s.monitorRunDependencies) == null || L.call(s, S1), s.instantiateWasm)
        try {
          return s.instantiateWasm(H, R);
        } catch (W) {
          O(`Module.instantiateWasm callback failed with error: ${W}`), c(W);
        }
      return b1 != null || (b1 = c1("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : s.locateFile ? s.locateFile("DotLottiePlayer.wasm", w) : w + "DotLottiePlayer.wasm"), E1(H, function(W) {
        R(W.instance);
      }).catch(c), {};
    }(), U0 = (L) => (U0 = Ve.ia)(L), is = (L) => (is = Ve.ja)(L), cr = (L) => (cr = Ve.la)(L), Mt = (L, R) => (Mt = Ve.ma)(L, R), gr = (L, R) => (gr = Ve.na)(L, R), Q2 = (L) => (Q2 = Ve.oa)(L), Fe = () => (Fe = Ve.pa)();
    s.dynCall_iijj = (L, R, H, W, $, I1) => (s.dynCall_iijj = Ve.qa)(L, R, H, W, $, I1), s.dynCall_vijj = (L, R, H, W, $, I1) => (s.dynCall_vijj = Ve.ra)(L, R, H, W, $, I1), s.dynCall_jiii = (L, R, H, W) => (s.dynCall_jiii = Ve.sa)(L, R, H, W), s.dynCall_jii = (L, R, H) => (s.dynCall_jii = Ve.ta)(L, R, H);
    var Xi = s.dynCall_vijjj = (L, R, H, W, $, I1, U1, O1) => (Xi = s.dynCall_vijjj = Ve.ua)(L, R, H, W, $, I1, U1, O1);
    s.dynCall_jiji = (L, R, H, W, $) => (s.dynCall_jiji = Ve.va)(L, R, H, W, $), s.dynCall_viijii = (L, R, H, W, $, I1, U1) => (s.dynCall_viijii = Ve.wa)(L, R, H, W, $, I1, U1), s.dynCall_iiiiij = (L, R, H, W, $, I1, U1) => (s.dynCall_iiiiij = Ve.xa)(L, R, H, W, $, I1, U1), s.dynCall_iiiiijj = (L, R, H, W, $, I1, U1, O1, ce) => (s.dynCall_iiiiijj = Ve.ya)(L, R, H, W, $, I1, U1, O1, ce), s.dynCall_iiiiiijj = (L, R, H, W, $, I1, U1, O1, ce, fe) => (s.dynCall_iiiiiijj = Ve.za)(L, R, H, W, $, I1, U1, O1, ce, fe);
    function En(L, R) {
      var H = Fe();
      try {
        Xn.get(L)(R);
      } catch (W) {
        if (Q2(H), W !== W + 0)
          throw W;
        gr(1, 0);
      }
    }
    function fr(L, R, H) {
      var W = Fe();
      try {
        Xn.get(L)(R, H);
      } catch ($) {
        if (Q2(W), $ !== $ + 0)
          throw $;
        gr(1, 0);
      }
    }
    function dr(L, R, H, W) {
      var $ = Fe();
      try {
        return Xn.get(L)(R, H, W);
      } catch (I1) {
        if (Q2($), I1 !== I1 + 0)
          throw I1;
        gr(1, 0);
      }
    }
    function W0(L, R, H) {
      var W = Fe();
      try {
        return Xn.get(L)(R, H);
      } catch ($) {
        if (Q2(W), $ !== $ + 0)
          throw $;
        gr(1, 0);
      }
    }
    function jn(L, R) {
      var H = Fe();
      try {
        return Xn.get(L)(R);
      } catch (W) {
        if (Q2(H), W !== W + 0)
          throw W;
        gr(1, 0);
      }
    }
    function Nt(L, R, H, W, $, I1) {
      var U1 = Fe();
      try {
        return Xn.get(L)(R, H, W, $, I1);
      } catch (O1) {
        if (Q2(U1), O1 !== O1 + 0)
          throw O1;
        gr(1, 0);
      }
    }
    function _c(L, R, H, W, $) {
      var I1 = Fe();
      try {
        Xn.get(L)(R, H, W, $);
      } catch (U1) {
        if (Q2(I1), U1 !== U1 + 0)
          throw U1;
        gr(1, 0);
      }
    }
    function zr(L, R, H, W) {
      var $ = Fe();
      try {
        Xn.get(L)(R, H, W);
      } catch (I1) {
        if (Q2($), I1 !== I1 + 0)
          throw I1;
        gr(1, 0);
      }
    }
    function u2(L) {
      var R = Fe();
      try {
        Xn.get(L)();
      } catch (H) {
        if (Q2(R), H !== H + 0)
          throw H;
        gr(1, 0);
      }
    }
    function U3(L, R, H, W, $, I1, U1, O1) {
      var ce = Fe();
      try {
        Xi(L, R, H, W, $, I1, U1, O1);
      } catch (fe) {
        if (Q2(ce), fe !== fe + 0)
          throw fe;
        gr(1, 0);
      }
    }
    var _0;
    h1 = function L() {
      _0 || Ai(), _0 || (h1 = L);
    };
    function Ai() {
      function L() {
        var R;
        if (!_0 && (_0 = !0, s.calledRun = !0, !N)) {
          if (K1(v1), g(s), (R = s.onRuntimeInitialized) == null || R.call(s), s.postRun)
            for (typeof s.postRun == "function" && (s.postRun = [s.postRun]); s.postRun.length; ) {
              var H = s.postRun.shift();
              a1.unshift(H);
            }
          K1(a1);
        }
      }
      if (!(0 < S1)) {
        if (s.preRun)
          for (typeof s.preRun == "function" && (s.preRun = [s.preRun]); s.preRun.length; )
            d1();
        K1(f1), 0 < S1 || (s.setStatus ? (s.setStatus("Running..."), setTimeout(() => {
          setTimeout(() => s.setStatus(""), 1), L();
        }, 1)) : L());
      }
    }
    if (s.preInit)
      for (typeof s.preInit == "function" && (s.preInit = [s.preInit]); 0 < s.preInit.length; )
        s.preInit.pop()();
    return Ai(), a = I, a;
  };
})(), KX = VX, kA = class {
  constructor() {
    throw new Error("RendererLoader is a static class and cannot be instantiated.");
  }
  static _tryLoad(e) {
    return vt(this, null, function* () {
      return yield KX({ locateFile: () => e });
    });
  }
  static _loadWithBackup() {
    return vt(this, null, function* () {
      return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch((e) => vt(this, null, function* () {
        let n = `https://unpkg.com/${ZM}@${qM}/dist/dotlottie-player.wasm`;
        console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${e.message}`), console.warn(`Attempting to load WASM from backup URL: ${n}`);
        try {
          return yield this._tryLoad(n);
        } catch (i) {
          throw console.error(`Primary WASM URL failed: ${e.message}`), console.error(`Backup WASM URL failed: ${i.message}`), new Error("WASM loading failed from all sources.");
        }
      }))), this._ModulePromise;
    });
  }
  static load() {
    return vt(this, null, function* () {
      return this._loadWithBackup();
    });
  }
  static setWasmUrl(e) {
    this._wasmURL = e, this._ModulePromise = null;
  }
};
dt(kA, "_ModulePromise", null), dt(kA, "_wasmURL", `https://cdn.jsdelivr.net/npm/${ZM}@${qM}/dist/dotlottie-player.wasm`);
var $M = class {
  constructor() {
    dt(this, "_eventListeners", /* @__PURE__ */ new Map());
  }
  addEventListener(e, n) {
    let i = this._eventListeners.get(e);
    i || (i = /* @__PURE__ */ new Set(), this._eventListeners.set(e, i)), i.add(n);
  }
  removeEventListener(e, n) {
    let i = this._eventListeners.get(e);
    i && (n ? (i.delete(n), i.size === 0 && this._eventListeners.delete(e)) : this._eventListeners.delete(e));
  }
  dispatch(e) {
    let n = this._eventListeners.get(e.type);
    n == null || n.forEach((i) => i(e));
  }
  removeAllEventListeners() {
    this._eventListeners.clear();
  }
}, D0 = class {
  static _initializeObserver() {
    if (this._observer)
      return;
    let e = (n) => {
      n.forEach((i) => {
        let a = this._observedCanvases.get(i.target);
        a && (i.isIntersecting ? a.unfreeze() : a.freeze());
      });
    };
    this._observer = new IntersectionObserver(e, { threshold: 0 });
  }
  static observe(e, n) {
    var i;
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, n), (i = this._observer) == null || i.observe(e));
  }
  static unobserve(e) {
    var n, i;
    (n = this._observer) == null || n.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && ((i = this._observer) == null || i.disconnect(), this._observer = null);
  }
};
dt(D0, "_observer", null), dt(D0, "_observedCanvases", /* @__PURE__ */ new Map());
var k0 = class {
  static _initializeObserver() {
    if (this._observer)
      return;
    let e = (n) => {
      n.forEach((i) => {
        let a = this._observedCanvases.get(i.target);
        if (!a)
          return;
        let [s, g] = a;
        clearTimeout(g);
        let c = setTimeout(() => {
          s.resize();
        }, 100);
        this._observedCanvases.set(i.target, [s, c]);
      });
    };
    this._observer = new ResizeObserver(e);
  }
  static observe(e, n) {
    var i;
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, [n, 0]), (i = this._observer) == null || i.observe(e));
  }
  static unobserve(e) {
    var n, i;
    (n = this._observer) == null || n.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && ((i = this._observer) == null || i.disconnect(), this._observer = null);
  }
};
dt(k0, "_observer", null), dt(k0, "_observedCanvases", /* @__PURE__ */ new Map());
function JX(e) {
  return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(e);
}
function YX(e) {
  if (!JX(e))
    return 0;
  let n = e.replace("#", "");
  return n = n.length === 6 ? `${n}ff` : n, parseInt(n, 16);
}
function xx(e) {
  if (e.byteLength < 4)
    return !1;
  let n = new Uint8Array(e.slice(0, p7.byteLength));
  for (let i = 0; i < p7.length; i += 1)
    if (p7[i] !== n[i])
      return !1;
  return !0;
}
function Sx(e) {
  return WX.every((n) => Object.prototype.hasOwnProperty.call(e, n));
}
function Ex(e) {
  if (typeof e == "string")
    try {
      return Sx(JSON.parse(e));
    } catch {
      return !1;
    }
  else
    return Sx(e);
}
function Cf() {
  return 1 + ((Dr ? window.devicePixelRatio : 1) - 1) * _X;
}
function eT(e) {
  let n = e.getBoundingClientRect();
  return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var h7 = (e, n) => e === "reverse" ? n.Mode.Reverse : e === "bounce" ? n.Mode.Bounce : e === "reverse-bounce" ? n.Mode.ReverseBounce : n.Mode.Forward, m7 = (e, n) => e === "contain" ? n.Fit.Contain : e === "cover" ? n.Fit.Cover : e === "fill" ? n.Fit.Fill : e === "fit-height" ? n.Fit.FitHeight : e === "fit-width" ? n.Fit.FitWidth : n.Fit.None, v7 = (e, n) => {
  let i = new n.VectorFloat();
  return i.push_back(e[0]), i.push_back(e[1]), i;
}, y7 = (e, n) => {
  let i = new n.VectorFloat();
  return e.length !== 2 || (i.push_back(e[0]), i.push_back(e[1])), i;
}, tT = class Dn {
  constructor(n) {
    dt(this, "_canvas"), dt(this, "_context", null), dt(this, "_eventManager"), dt(this, "_animationFrameId", null), dt(this, "_frameManager"), dt(this, "_dotLottieCore", null), dt(this, "_renderConfig", {}), dt(this, "_isFrozen", !1), dt(this, "_backgroundColor", null), dt(this, "_pointerUpMethod"), dt(this, "_pointerDownMethod"), dt(this, "_pointerMoveMethod"), dt(this, "_pointerEnterMethod"), dt(this, "_pointerExitMethod");
    var i, a, s;
    this._canvas = n.canvas, this._context = this._canvas.getContext("2d"), this._eventManager = new $M(), this._frameManager = new UX(), this._renderConfig = v3(ar({}, n.renderConfig), { devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || Cf(), freezeOnOffscreen: (s = (a = n.renderConfig) == null ? void 0 : a.freezeOnOffscreen) != null ? s : !0 }), kA.load().then((g) => {
      var c, I, h, m, w, x, M;
      Dn._wasmModule = g, this._dotLottieCore = new g.DotLottiePlayer({ autoplay: (c = n.autoplay) != null ? c : !1, backgroundColor: 0, loopAnimation: (I = n.loop) != null ? I : !1, mode: h7((h = n.mode) != null ? h : "forward", g), segment: y7((m = n.segment) != null ? m : [], g), speed: (w = n.speed) != null ? w : 1, useFrameInterpolation: (x = n.useFrameInterpolation) != null ? x : !0, marker: (M = n.marker) != null ? M : "", layout: n.layout ? { align: v7(n.layout.align, g), fit: m7(n.layout.fit, g) } : g.createDefaultLayout() }), this._eventManager.dispatch({ type: "ready" }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), n.backgroundColor && this.setBackgroundColor(n.backgroundColor);
    }).catch((g) => {
      this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to load wasm module: ${g}`) });
    }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _dispatchError(n) {
    console.error(n), this._eventManager.dispatch({ type: "loadError", error: new Error(n) });
  }
  _fetchData(n) {
    return vt(this, null, function* () {
      let i = yield fetch(n);
      if (!i.ok)
        throw new Error(`Failed to fetch animation data from URL: ${n}. ${i.status}: ${i.statusText}`);
      let a = yield i.arrayBuffer();
      return xx(a) ? a : new TextDecoder().decode(a);
    });
  }
  _loadFromData(n) {
    if (this._dotLottieCore === null)
      return;
    let i = this._canvas.width, a = this._canvas.height, s = !1;
    if (typeof n == "string") {
      if (!Ex(n)) {
        this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
        return;
      }
      s = this._dotLottieCore.loadAnimationData(n, i, a);
    } else if (n instanceof ArrayBuffer) {
      if (!xx(n)) {
        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
        return;
      }
      s = this._dotLottieCore.loadDotLottieData(n, i, a);
    } else if (typeof n == "object") {
      if (!Ex(n)) {
        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
        return;
      }
      s = this._dotLottieCore.loadAnimationData(JSON.stringify(n), i, a);
    } else {
      this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof n}`);
      return;
    }
    s ? (this._eventManager.dispatch({ type: "load" }), Dr && this.resize(), this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), Dr && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && D0.observe(this._canvas, this), this._renderConfig.autoResize && k0.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
  }
  _loadFromSrc(n) {
    this._fetchData(n).then((i) => this._loadFromData(i)).catch((i) => this._dispatchError(`Failed to load animation data from URL: ${n}. ${i}`));
  }
  get activeAnimationId() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.activeAnimationId();
  }
  get activeThemeId() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.activeThemeId();
  }
  get layout() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.config().layout;
    if (i)
      return { align: [i.align.get(0), i.align.get(1)], fit: (() => {
        var a, s, g, c, I, h;
        switch (i.fit) {
          case ((a = Dn._wasmModule) == null ? void 0 : a.Fit.Contain):
            return "contain";
          case ((s = Dn._wasmModule) == null ? void 0 : s.Fit.Cover):
            return "cover";
          case ((g = Dn._wasmModule) == null ? void 0 : g.Fit.Fill):
            return "fill";
          case ((c = Dn._wasmModule) == null ? void 0 : c.Fit.FitHeight):
            return "fit-height";
          case ((I = Dn._wasmModule) == null ? void 0 : I.Fit.FitWidth):
            return "fit-width";
          case ((h = Dn._wasmModule) == null ? void 0 : h.Fit.None):
            return "none";
          default:
            return "contain";
        }
      })() };
  }
  get marker() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.config().marker;
  }
  get manifest() {
    var n;
    try {
      let i = (n = this._dotLottieCore) == null ? void 0 : n.manifestString();
      if (this._dotLottieCore === null || !i)
        return null;
      let a = JSON.parse(i);
      return Object.keys(a).length === 0 ? null : a;
    } catch {
      return null;
    }
  }
  get renderConfig() {
    return this._renderConfig;
  }
  get segment() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.config().segment;
    if (i && i.size() === 2)
      return [i.get(0), i.get(1)];
  }
  get loop() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().loopAnimation) != null ? i : !1;
  }
  get mode() {
    var n, i, a, s;
    let g = (n = this._dotLottieCore) == null ? void 0 : n.config().mode;
    return g === ((i = Dn._wasmModule) == null ? void 0 : i.Mode.Reverse) ? "reverse" : g === ((a = Dn._wasmModule) == null ? void 0 : a.Mode.Bounce) ? "bounce" : g === ((s = Dn._wasmModule) == null ? void 0 : s.Mode.ReverseBounce) ? "reverse-bounce" : "forward";
  }
  get isFrozen() {
    return this._isFrozen;
  }
  get backgroundColor() {
    var n;
    return (n = this._backgroundColor) != null ? n : "";
  }
  get autoplay() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().autoplay) != null ? i : !1;
  }
  get useFrameInterpolation() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().useFrameInterpolation) != null ? i : !1;
  }
  get speed() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().speed) != null ? i : 0;
  }
  get isReady() {
    return this._dotLottieCore !== null;
  }
  get isLoaded() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isLoaded()) != null ? i : !1;
  }
  get isPlaying() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPlaying()) != null ? i : !1;
  }
  get isPaused() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPaused()) != null ? i : !1;
  }
  get isStopped() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isStopped()) != null ? i : !1;
  }
  get currentFrame() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.currentFrame()) != null ? i : 0;
  }
  get loopCount() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.loopCount()) != null ? i : 0;
  }
  get totalFrames() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.totalFrames()) != null ? i : 0;
  }
  get duration() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.duration()) != null ? i : 0;
  }
  get segmentDuration() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.segmentDuration()) != null ? i : 0;
  }
  get canvas() {
    return this._canvas;
  }
  load(n) {
    var i, a, s, g, c, I, h, m;
    this._dotLottieCore === null || Dn._wasmModule === null || (this._dotLottieCore.setConfig({ autoplay: (i = n.autoplay) != null ? i : !1, backgroundColor: 0, loopAnimation: (a = n.loop) != null ? a : !1, mode: h7((s = n.mode) != null ? s : "forward", Dn._wasmModule), segment: y7((g = n.segment) != null ? g : [], Dn._wasmModule), speed: (c = n.speed) != null ? c : 1, useFrameInterpolation: (I = n.useFrameInterpolation) != null ? I : !0, marker: (h = n.marker) != null ? h : "", layout: n.layout ? { align: v7(n.layout.align, Dn._wasmModule), fit: m7(n.layout.fit, Dn._wasmModule) } : Dn._wasmModule.createDefaultLayout() }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), this.setBackgroundColor((m = n.backgroundColor) != null ? m : ""));
  }
  _render() {
    if (this._dotLottieCore === null || this._context === null)
      return !1;
    if (this._dotLottieCore.render()) {
      let n = this._dotLottieCore.buffer(), i = new Uint8ClampedArray(n, 0, this._canvas.width * this._canvas.height * 4), a = null;
      return typeof ImageData > "u" ? (a = this._context.createImageData(this._canvas.width, this._canvas.height), a.data.set(i)) : a = new ImageData(i, this._canvas.width, this._canvas.height), this._context.putImageData(a, 0, 0), this._eventManager.dispatch({ type: "render", currentFrame: this._dotLottieCore.currentFrame() }), !0;
    }
    return !1;
  }
  _draw() {
    if (this._dotLottieCore === null || this._context === null || !this._dotLottieCore.isPlaying())
      return;
    let n = this._dotLottieCore.requestFrame();
    this._dotLottieCore.setFrame(n) && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render() && this._dotLottieCore.isComplete() && (this._dotLottieCore.config().loopAnimation ? this._eventManager.dispatch({ type: "loop", loopCount: this._dotLottieCore.loopCount() }) : this._eventManager.dispatch({ type: "complete" }))), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
  }
  play() {
    this._dotLottieCore !== null && ((this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = !1, this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), Dr && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !eT(this._canvas) && this.freeze());
  }
  pause() {
    this._dotLottieCore !== null && (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({ type: "pause" });
  }
  stop() {
    this._dotLottieCore !== null && this._dotLottieCore.stop() && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render(), this._eventManager.dispatch({ type: "stop" }));
  }
  setFrame(n) {
    this._dotLottieCore === null || n < 0 || n > this._dotLottieCore.totalFrames() || this._dotLottieCore.seek(n) && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render());
  }
  setSpeed(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { speed: n }));
  }
  setBackgroundColor(n) {
    this._dotLottieCore !== null && (Dr && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = n : this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { backgroundColor: YX(n) })), this._backgroundColor = n);
  }
  setLoop(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { loopAnimation: n }));
  }
  setUseFrameInterpolation(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { useFrameInterpolation: n }));
  }
  addEventListener(n, i) {
    this._eventManager.addEventListener(n, i);
  }
  removeEventListener(n, i) {
    this._eventManager.removeEventListener(n, i);
  }
  destroy() {
    var n;
    Dr && this._canvas instanceof HTMLCanvasElement && (D0.unobserve(this._canvas), k0.unobserve(this._canvas)), (n = this._dotLottieCore) == null || n.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({ type: "destroy" }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
  }
  freeze() {
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = !0, this._eventManager.dispatch({ type: "freeze" }));
  }
  unfreeze() {
    this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = !1, this._eventManager.dispatch({ type: "unfreeze" }));
  }
  resize() {
    if (!(!this._dotLottieCore || !this.isLoaded)) {
      if (Dr && this._canvas instanceof HTMLCanvasElement) {
        let n = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: i, width: a } = this._canvas.getBoundingClientRect();
        this._canvas.width = a * n, this._canvas.height = i * n;
      }
      this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
    }
  }
  setSegment(n, i) {
    this._dotLottieCore === null || Dn._wasmModule === null || this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { segment: y7([n, i], Dn._wasmModule) }));
  }
  setMode(n) {
    this._dotLottieCore === null || Dn._wasmModule === null || this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { mode: h7(n, Dn._wasmModule) }));
  }
  setRenderConfig(n) {
    let i = n, { devicePixelRatio: a, freezeOnOffscreen: s } = i, g = GM(i, ["devicePixelRatio", "freezeOnOffscreen"]);
    this._renderConfig = v3(ar(ar({}, this._renderConfig), g), { devicePixelRatio: a || Cf(), freezeOnOffscreen: s ?? !0 }), Dr && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? k0.observe(this._canvas, this) : k0.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? D0.observe(this._canvas, this) : (D0.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
  }
  loadAnimation(n) {
    this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === n || (this._dotLottieCore.loadAnimation(n, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({ type: "load" }), this.resize()) : this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to animation :${n}`) }));
  }
  setMarker(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { marker: n }));
  }
  markers() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.markers();
    if (i) {
      let a = [];
      for (let s = 0; s < i.size(); s += 1) {
        let g = i.get(s);
        a.push({ name: g.name, time: g.time, duration: g.duration });
      }
      return a;
    }
    return [];
  }
  loadTheme(n) {
    if (this._dotLottieCore === null)
      return !1;
    let i = this._dotLottieCore.loadTheme(n);
    return this._render(), i;
  }
  loadThemeData(n) {
    if (this._dotLottieCore === null)
      return !1;
    let i = this._dotLottieCore.loadThemeData(n);
    return this._render(), i;
  }
  setLayout(n) {
    this._dotLottieCore === null || Dn._wasmModule === null || this._dotLottieCore.setConfig(v3(ar({}, this._dotLottieCore.config()), { layout: { align: v7(n.align, Dn._wasmModule), fit: m7(n.fit, Dn._wasmModule) } }));
  }
  setViewport(n, i, a, s) {
    return this._dotLottieCore === null ? !1 : this._dotLottieCore.setViewport(n, i, a, s);
  }
  static setWasmUrl(n) {
    kA.setWasmUrl(n);
  }
  loadStateMachine(n) {
    var i, a;
    return (a = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachine(n)) != null ? a : !1;
  }
  startStateMachine() {
    var n, i;
    let a = (i = (n = this._dotLottieCore) == null ? void 0 : n.startStateMachine()) != null ? i : !1;
    return a && this._setupStateMachineListeners(), a;
  }
  stopStateMachine() {
    var n, i;
    let a = (i = (n = this._dotLottieCore) == null ? void 0 : n.stopStateMachine()) != null ? i : !1;
    return a && this._cleanupStateMachineListeners(), a;
  }
  _getPointerPosition(n) {
    let i = this._canvas.getBoundingClientRect(), a = this._canvas.width / i.width, s = this._canvas.height / i.height, g = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, c = (n.clientX - i.left) * a / g, I = (n.clientY - i.top) * s / g;
    return { x: c, y: I };
  }
  _onPointerUp(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerUpEvent(i, a);
  }
  _onPointerDown(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerDownEvent(i, a);
  }
  _onPointerMove(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerMoveEvent(i, a);
  }
  _onPointerEnter(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerEnterEvent(i, a);
  }
  _onPointerLeave(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this.postPointerExitEvent(i, a);
  }
  postPointerUpEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerUpEvent(n, i);
  }
  postPointerDownEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerDownEvent(n, i);
  }
  postPointerMoveEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerMoveEvent(n, i);
  }
  postPointerEnterEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerEnterEvent(n, i);
  }
  postPointerExitEvent(n, i) {
    var a;
    return (a = this._dotLottieCore) == null ? void 0 : a.postPointerExitEvent(n, i);
  }
  getStateMachineListeners() {
    if (!this._dotLottieCore)
      return [];
    let n = this._dotLottieCore.stateMachineFrameworkSetup(), i = [];
    for (let a = 0; a < n.size(); a += 1)
      i.push(n.get(a));
    return i;
  }
  _setupStateMachineListeners() {
    if (Dr && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
      let n = this.getStateMachineListeners();
      n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
    }
  }
  _cleanupStateMachineListeners() {
    Dr && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
  loadStateMachineData(n) {
    var i, a;
    return (a = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachineData(n)) != null ? a : !1;
  }
  animationSize() {
    var n, i, a, s;
    let g = (i = (n = this._dotLottieCore) == null ? void 0 : n.animationSize().get(0)) != null ? i : 0, c = (s = (a = this._dotLottieCore) == null ? void 0 : a.animationSize().get(1)) != null ? s : 0;
    return { width: g, height: c };
  }
  setStateMachineBooleanContext(n, i) {
    var a, s;
    return (s = (a = this._dotLottieCore) == null ? void 0 : a.setStateMachineBooleanContext(n, i)) != null ? s : !1;
  }
  setStateMachineNumericContext(n, i) {
    var a, s;
    return (s = (a = this._dotLottieCore) == null ? void 0 : a.setStateMachineNumericContext(n, i)) != null ? s : !1;
  }
  setStateMachineStringContext(n, i) {
    var a, s;
    return (s = (a = this._dotLottieCore) == null ? void 0 : a.setStateMachineStringContext(n, i)) != null ? s : !1;
  }
};
dt(tT, "_wasmModule", null);
var QX = tT, XX = class {
  constructor() {
    if (typeof Worker > "u")
      throw new Error("Worker is not supported in this environment.");
    let e = new Blob([new Uint8Array([34, 117, 115, 101, 32, 115, 116, 114, 105, 99, 116, 34, 59, 10, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 105, 101, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 68, 101, 115, 99, 114, 105, 112, 116, 111, 114, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 83, 121, 109, 98, 111, 108, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 112, 114, 111, 112, 101, 114, 116, 121, 73, 115, 69, 110, 117, 109, 101, 114, 97, 98, 108, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 107, 101, 121, 32, 105, 110, 32, 111, 98, 106, 32, 63, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 123, 32, 101, 110, 117, 109, 101, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 99, 111, 110, 102, 105, 103, 117, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 118, 97, 108, 117, 101, 32, 125, 41, 32, 58, 32, 111, 98, 106, 91, 107, 101, 121, 93, 32, 61, 32, 118, 97, 108, 117, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 98, 32, 124, 124, 32, 40, 98, 32, 61, 32, 123, 125, 41, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 98, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 40, 97, 44, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 40, 98, 41, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 32, 61, 32, 40, 115, 111, 117, 114, 99, 101, 44, 32, 101, 120, 99, 108, 117, 100, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 116, 97, 114, 103, 101, 116, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 115, 111, 117, 114, 99, 101, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 32, 38, 38, 32, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 111, 117, 114, 99, 101, 32, 33, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 115, 111, 117, 114, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 32, 38, 38, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 97, 114, 103, 101, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 116, 121, 112, 101, 111, 102, 32, 107, 101, 121, 32, 33, 61, 61, 32, 34, 115, 121, 109, 98, 111, 108, 34, 32, 63, 32, 107, 101, 121, 32, 43, 32, 34, 34, 32, 58, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 97, 115, 121, 110, 99, 32, 61, 32, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 44, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 114, 101, 115, 111, 108, 118, 101, 44, 32, 114, 101, 106, 101, 99, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 117, 108, 102, 105, 108, 108, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 110, 101, 120, 116, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 101, 106, 101, 99, 116, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 116, 104, 114, 111, 119, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 116, 101, 112, 32, 61, 32, 40, 120, 41, 32, 61, 62, 32, 120, 46, 100, 111, 110, 101, 32, 63, 32, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 46, 116, 104, 101, 110, 40, 102, 117, 108, 102, 105, 108, 108, 101, 100, 44, 32, 114, 101, 106, 101, 99, 116, 101, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 32, 61, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 97, 112, 112, 108, 121, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 41, 41, 46, 110, 101, 120, 116, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 97, 110, 105, 109, 97, 116, 105, 111, 110, 45, 102, 114, 97, 109, 101, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 34, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 62, 61, 32, 78, 117, 109, 98, 101, 114, 46, 77, 65, 88, 95, 83, 65, 70, 69, 95, 73, 78, 84, 69, 71, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 32, 61, 32, 115, 101, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 108, 108, 98, 97, 99, 107, 40, 68, 97, 116, 101, 46, 110, 111, 119, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 95, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 115, 116, 114, 97, 116, 101, 103, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 63, 32, 110, 101, 119, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 32, 58, 32, 110, 101, 119, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 110, 115, 116, 97, 110, 116, 115, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 46, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 59, 10, 32, 32, 118, 97, 114, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 91, 56, 48, 44, 32, 55, 53, 44, 32, 51, 44, 32, 52, 93, 41, 59, 10, 32, 32, 118, 97, 114, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 32, 61, 32, 91, 34, 118, 34, 44, 32, 34, 105, 112, 34, 44, 32, 34, 111, 112, 34, 44, 32, 34, 108, 97, 121, 101, 114, 115, 34, 44, 32, 34, 102, 114, 34, 44, 32, 34, 119, 34, 44, 32, 34, 104, 34, 93, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 32, 61, 32, 34, 48, 46, 51, 53, 46, 48, 34, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 32, 61, 32, 34, 64, 108, 111, 116, 116, 105, 101, 102, 105, 108, 101, 115, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 101, 98, 34, 59, 10, 32, 32, 118, 97, 114, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 32, 61, 32, 48, 46, 55, 53, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 106, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 32, 61, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 63, 32, 40, 95, 97, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 114, 99, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 109, 111, 100, 117, 108, 101, 65, 114, 103, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 109, 111, 100, 117, 108, 101, 65, 114, 103, 44, 32, 97, 97, 44, 32, 98, 97, 44, 32, 99, 97, 32, 61, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 44, 32, 100, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 125, 44, 32, 107, 41, 44, 32, 101, 97, 32, 61, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 44, 32, 112, 32, 61, 32, 34, 34, 44, 32, 102, 97, 59, 10, 32, 32, 32, 32, 32, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 38, 38, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 32, 38, 38, 32, 40, 112, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 38, 38, 32, 40, 112, 32, 61, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 112, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 98, 108, 111, 98, 58, 34, 41, 32, 63, 32, 112, 32, 61, 32, 34, 34, 32, 58, 32, 112, 32, 61, 32, 112, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 112, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 63, 35, 93, 46, 42, 47, 44, 32, 34, 34, 41, 46, 108, 97, 115, 116, 73, 110, 100, 101, 120, 79, 102, 40, 34, 47, 34, 41, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 102, 101, 116, 99, 104, 40, 97, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 98, 46, 111, 107, 32, 63, 32, 98, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 106, 101, 99, 116, 40, 69, 114, 114, 111, 114, 40, 98, 46, 115, 116, 97, 116, 117, 115, 32, 43, 32, 34, 32, 58, 32, 34, 32, 43, 32, 98, 46, 117, 114, 108, 41, 41, 10, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 106, 97, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 108, 111, 103, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 44, 32, 116, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 69, 114, 114, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 107, 44, 32, 100, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 100, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 32, 38, 38, 32, 40, 101, 97, 32, 61, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 97, 32, 61, 32, 107, 46, 119, 97, 115, 109, 66, 105, 110, 97, 114, 121, 44, 32, 108, 97, 44, 32, 109, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 110, 97, 44, 32, 117, 44, 32, 120, 44, 32, 121, 44, 32, 122, 44, 32, 67, 44, 32, 68, 44, 32, 111, 97, 44, 32, 112, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 56, 32, 61, 32, 117, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 49, 54, 32, 61, 32, 121, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 56, 32, 61, 32, 120, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 49, 54, 32, 61, 32, 122, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 51, 50, 32, 61, 32, 67, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 51, 50, 32, 61, 32, 68, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 51, 50, 32, 61, 32, 111, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 54, 52, 32, 61, 32, 112, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 97, 32, 61, 32, 91, 93, 44, 32, 115, 97, 32, 61, 32, 91, 93, 44, 32, 116, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 70, 32, 61, 32, 48, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 44, 32, 71, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 65, 98, 111, 114, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 34, 65, 98, 111, 114, 116, 101, 100, 40, 34, 32, 43, 32, 97, 32, 43, 32, 34, 41, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 110, 101, 119, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 40, 97, 32, 43, 32, 34, 46, 32, 66, 117, 105, 108, 100, 32, 119, 105, 116, 104, 32, 45, 115, 65, 83, 83, 69, 82, 84, 73, 79, 78, 83, 32, 102, 111, 114, 32, 109, 111, 114, 101, 32, 105, 110, 102, 111, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 97, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 100, 97, 116, 97, 58, 97, 112, 112, 108, 105, 99, 97, 116, 105, 111, 110, 47, 111, 99, 116, 101, 116, 45, 115, 116, 114, 101, 97, 109, 59, 98, 97, 115, 101, 54, 52, 44, 34, 41, 44, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 122, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 32, 61, 61, 32, 121, 97, 32, 38, 38, 32, 107, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 107, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 34, 98, 111, 116, 104, 32, 97, 115, 121, 110, 99, 32, 97, 110, 100, 32, 115, 121, 110, 99, 32, 102, 101, 116, 99, 104, 105, 110, 103, 32, 111, 102, 32, 116, 104, 101, 32, 119, 97, 115, 109, 32, 102, 97, 105, 108, 101, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 97, 32, 63, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 41, 46, 116, 104, 101, 110, 40, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 41, 32, 58, 32, 102, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 66, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 65, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 40, 100, 44, 32, 98, 41, 41, 46, 116, 104, 101, 110, 40, 99, 44, 32, 40, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 102, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 115, 121, 110, 99, 104, 114, 111, 110, 111, 117, 115, 108, 121, 32, 112, 114, 101, 112, 97, 114, 101, 32, 119, 97, 115, 109, 58, 32, 36, 123, 100, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 67, 97, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 97, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 32, 124, 124, 32, 120, 97, 40, 99, 41, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 102, 101, 116, 99, 104, 32, 63, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 32, 58, 32, 102, 101, 116, 99, 104, 40, 99, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 40, 100, 44, 32, 97, 41, 46, 116, 104, 101, 110, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 119, 97, 115, 109, 32, 115, 116, 114, 101, 97, 109, 105, 110, 103, 32, 99, 111, 109, 112, 105, 108, 101, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 34, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 68, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 69, 120, 105, 116, 83, 116, 97, 116, 117, 115, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 96, 80, 114, 111, 103, 114, 97, 109, 32, 116, 101, 114, 109, 105, 110, 97, 116, 101, 100, 32, 119, 105, 116, 104, 32, 101, 120, 105, 116, 40, 36, 123, 97, 125, 41, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 116, 97, 116, 117, 115, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 48, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 97, 46, 115, 104, 105, 102, 116, 40, 41, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 97, 32, 61, 32, 107, 46, 110, 111, 69, 120, 105, 116, 82, 117, 110, 116, 105, 109, 101, 32, 124, 124, 32, 116, 114, 117, 101, 44, 32, 71, 97, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 72, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 99, 32, 61, 32, 98, 59, 32, 97, 91, 99, 93, 32, 38, 38, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 54, 32, 60, 32, 99, 32, 45, 32, 98, 32, 38, 38, 32, 97, 46, 98, 117, 102, 102, 101, 114, 32, 38, 38, 32, 71, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 71, 97, 46, 100, 101, 99, 111, 100, 101, 40, 97, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 98, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 34, 34, 59, 32, 98, 32, 60, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 97, 91, 98, 43, 43, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 38, 32, 49, 50, 56, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 57, 50, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 50, 52, 41, 41, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 40, 101, 32, 38, 32, 51, 49, 41, 32, 60, 60, 32, 54, 32, 124, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 50, 50, 52, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 52, 48, 41, 32, 63, 32, 40, 101, 32, 38, 32, 49, 53, 41, 32, 60, 60, 32, 49, 50, 32, 124, 32, 102, 32, 60, 60, 32, 54, 32, 124, 32, 104, 32, 58, 32, 40, 101, 32, 38, 32, 55, 41, 32, 60, 60, 32, 49, 56, 32, 124, 32, 102, 32, 60, 60, 32, 49, 50, 32, 124, 32, 104, 32, 60, 60, 32, 54, 32, 124, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 62, 32, 101, 32, 63, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 32, 58, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 72, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 67, 97, 32, 61, 32, 97, 32, 45, 32, 50, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 73, 97, 32, 61, 32, 48, 44, 32, 74, 97, 32, 61, 32, 48, 44, 32, 73, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 120, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 60, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 32, 43, 32, 99, 32, 45, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 50, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 48, 52, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 49, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 57, 50, 32, 124, 32, 102, 32, 62, 62, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 54, 53, 53, 51, 53, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 50, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 50, 52, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 51, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 52, 48, 32, 124, 32, 102, 32, 62, 62, 32, 49, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 54, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 97, 32, 61, 32, 123, 125, 44, 32, 76, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 112, 111, 112, 40, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 74, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 68, 91, 97, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 75, 32, 61, 32, 123, 125, 44, 32, 76, 32, 61, 32, 123, 125, 44, 32, 77, 97, 32, 61, 32, 123, 125, 44, 32, 77, 44, 32, 79, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 99, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 97, 46, 108, 101, 110, 103, 116, 104, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 77, 105, 115, 109, 97, 116, 99, 104, 101, 100, 32, 116, 121, 112, 101, 32, 99, 111, 110, 118, 101, 114, 116, 101, 114, 32, 99, 111, 117, 110, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 108, 41, 32, 78, 40, 97, 91, 108, 93, 44, 32, 103, 91, 108, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 41, 32, 61, 62, 32, 77, 97, 91, 103, 93, 32, 61, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 114, 114, 97, 121, 40, 98, 46, 108, 101, 110, 103, 116, 104, 41, 44, 32, 102, 32, 61, 32, 91, 93, 44, 32, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 63, 32, 101, 91, 108, 93, 32, 61, 32, 76, 91, 103, 93, 32, 58, 32, 40, 102, 46, 112, 117, 115, 104, 40, 103, 41, 44, 32, 75, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 124, 124, 32, 40, 75, 91, 103, 93, 32, 61, 32, 91, 93, 41, 44, 32, 75, 91, 103, 93, 46, 112, 117, 115, 104, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 108, 93, 32, 61, 32, 76, 91, 103, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 97, 44, 32, 80, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 34, 34, 59, 32, 120, 91, 97, 93, 59, 32, 41, 32, 98, 32, 43, 61, 32, 78, 97, 91, 120, 91, 97, 43, 43, 93, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 79, 97, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 110, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 116, 121, 112, 101, 32, 34, 36, 123, 100, 125, 34, 32, 109, 117, 115, 116, 32, 104, 97, 118, 101, 32, 97, 32, 112, 111, 115, 105, 116, 105, 118, 101, 32, 105, 110, 116, 101, 103, 101, 114, 32, 116, 121, 112, 101, 105, 100, 32, 112, 111, 105, 110, 116, 101, 114, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 76, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 46, 104, 98, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 116, 121, 112, 101, 32, 39, 36, 123, 100, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 91, 97, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 77, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 75, 91, 97, 93, 44, 32, 100, 101, 108, 101, 116, 101, 32, 75, 91, 97, 93, 44, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 101, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 78, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 79, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 80, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 97, 46, 65, 97, 46, 68, 97, 46, 66, 97, 46, 110, 97, 109, 101, 32, 43, 32, 34, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 97, 108, 114, 101, 97, 100, 121, 32, 100, 101, 108, 101, 116, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 82, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 84, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 61, 61, 61, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 46, 71, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 84, 97, 40, 97, 44, 32, 98, 44, 32, 99, 46, 71, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 32, 63, 32, 110, 117, 108, 108, 32, 58, 32, 99, 46, 36, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 97, 32, 61, 32, 123, 125, 44, 32, 82, 32, 61, 32, 91, 93, 44, 32, 86, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 82, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 82, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 46, 77, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 97, 44, 32, 88, 97, 32, 61, 32, 123, 125, 44, 32, 89, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 112, 116, 114, 32, 115, 104, 111, 117, 108, 100, 32, 110, 111, 116, 32, 98, 101, 32, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 71, 97, 59, 32, 41, 32, 98, 32, 61, 32, 97, 46, 80, 97, 40, 98, 41, 44, 32, 97, 32, 61, 32, 97, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 36, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 68, 97, 32, 124, 124, 32, 33, 98, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 109, 97, 107, 101, 67, 108, 97, 115, 115, 72, 97, 110, 100, 108, 101, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 112, 116, 114, 32, 97, 110, 100, 32, 112, 116, 114, 84, 121, 112, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 33, 98, 46, 72, 97, 32, 33, 61, 61, 32, 33, 33, 98, 46, 69, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 66, 111, 116, 104, 32, 115, 109, 97, 114, 116, 80, 116, 114, 84, 121, 112, 101, 32, 97, 110, 100, 32, 115, 109, 97, 114, 116, 80, 116, 114, 32, 109, 117, 115, 116, 32, 98, 101, 32, 115, 112, 101, 99, 105, 102, 105, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 99, 111, 117, 110, 116, 32, 61, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 49, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 97, 40, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 44, 32, 123, 32, 65, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 32, 125, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 61, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 41, 32, 114, 101, 116, 117, 114, 110, 32, 90, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 98, 44, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 32, 61, 32, 110, 101, 119, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 40, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 98, 46, 69, 97, 32, 63, 32, 98, 46, 72, 97, 46, 75, 97, 40, 98, 46, 69, 97, 41, 32, 58, 32, 98, 46, 68, 97, 46, 66, 97, 46, 75, 97, 40, 98, 46, 67, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 69, 97, 32, 38, 38, 32, 81, 97, 46, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 44, 32, 123, 32, 65, 97, 58, 32, 99, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 46, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 97, 32, 125, 41, 44, 32, 99, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 70, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 91, 98, 93, 46, 70, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 101, 46, 108, 101, 110, 103, 116, 104, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 70, 117, 110, 99, 116, 105, 111, 110, 32, 39, 36, 123, 99, 125, 39, 32, 99, 97, 108, 108, 101, 100, 32, 119, 105, 116, 104, 32, 97, 110, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 101, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 115, 32, 111, 110, 101, 32, 111, 102, 32, 40, 36, 123, 97, 91, 98, 93, 46, 70, 97, 125, 41, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 91, 98, 93, 46, 70, 97, 91, 101, 46, 108, 101, 110, 103, 116, 104, 93, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 70, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 70, 97, 91, 100, 46, 81, 97, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 100, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 70, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 70, 97, 91, 99, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 112, 117, 98, 108, 105, 99, 32, 110, 97, 109, 101, 32, 39, 36, 123, 97, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 107, 44, 32, 97, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 99, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 111, 118, 101, 114, 108, 111, 97, 100, 115, 32, 111, 102, 32, 97, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 105, 116, 104, 32, 116, 104, 101, 32, 115, 97, 109, 101, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 99, 125, 41, 33, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 91, 97, 93, 46, 70, 97, 91, 99, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 38, 38, 32, 40, 107, 91, 97, 93, 46, 113, 98, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 101, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 95, 117, 110, 107, 110, 111, 119, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 94, 97, 45, 122, 65, 45, 90, 48, 45, 57, 95, 93, 47, 103, 44, 32, 34, 36, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 56, 32, 60, 61, 32, 98, 32, 38, 38, 32, 53, 55, 32, 62, 61, 32, 98, 32, 63, 32, 96, 95, 36, 123, 97, 125, 96, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 102, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 78, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 75, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 71, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 98, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 80, 97, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 36, 97, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 106, 98, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 98, 32, 33, 61, 61, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 80, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 69, 120, 112, 101, 99, 116, 101, 100, 32, 110, 117, 108, 108, 32, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 99, 46, 110, 97, 109, 101, 125, 44, 32, 103, 111, 116, 32, 97, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 98, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 46, 80, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 105, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 98, 40, 98, 46, 65, 97, 46, 67, 97, 44, 32, 98, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 116, 104, 105, 115, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 85, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 75, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 32, 124, 124, 32, 33, 98, 46, 65, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 105, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 82, 97, 32, 38, 38, 32, 98, 46, 65, 97, 46, 68, 97, 46, 82, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 65, 97, 46, 72, 97, 32, 63, 32, 98, 46, 65, 97, 46, 72, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 65, 97, 46, 68, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 103, 98, 40, 98, 46, 65, 97, 46, 67, 97, 44, 32, 98, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 116, 104, 105, 115, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 46, 65, 97, 46, 69, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 80, 97, 115, 115, 105, 110, 103, 32, 114, 97, 119, 32, 112, 111, 105, 110, 116, 101, 114, 32, 116, 111, 32, 115, 109, 97, 114, 116, 32, 112, 111, 105, 110, 116, 101, 114, 32, 105, 115, 32, 105, 108, 108, 101, 103, 97, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 116, 104, 105, 115, 46, 111, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 65, 97, 46, 72, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 65, 97, 46, 69, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 65, 97, 46, 72, 97, 32, 63, 32, 98, 46, 65, 97, 46, 72, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 65, 97, 46, 68, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 46, 65, 97, 46, 69, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 65, 97, 46, 72, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 65, 97, 46, 69, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 107, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 98, 40, 40, 41, 32, 61, 62, 32, 100, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 75, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 85, 110, 115, 117, 112, 112, 111, 114, 116, 105, 110, 103, 32, 115, 104, 97, 114, 105, 110, 103, 32, 112, 111, 108, 105, 99, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 84, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 105, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 65, 97, 46, 67, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 65, 97, 46, 68, 97, 46, 82, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 65, 97, 46, 68, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 98, 40, 98, 46, 65, 97, 46, 67, 97, 44, 32, 98, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 116, 104, 105, 115, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 66, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 84, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 82, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 83, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 105, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 111, 98, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 85, 97, 32, 61, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 107, 98, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 75, 97, 32, 61, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 98, 46, 71, 97, 32, 63, 32, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 106, 98, 32, 58, 32, 40, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 100, 32, 63, 32, 104, 98, 32, 58, 32, 108, 98, 44, 32, 116, 104, 105, 115, 46, 74, 97, 32, 61, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 82, 101, 112, 108, 97, 99, 105, 110, 103, 32, 110, 111, 110, 101, 120, 105, 115, 116, 101, 110, 116, 32, 112, 117, 98, 108, 105, 99, 32, 115, 121, 109, 98, 111, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 70, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 63, 32, 107, 91, 97, 93, 46, 70, 97, 91, 99, 93, 32, 61, 32, 98, 32, 58, 32, 40, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 107, 91, 97, 93, 46, 81, 97, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 44, 32, 111, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 91, 93, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 40, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 112, 47, 103, 44, 32, 34, 105, 34, 41, 44, 32, 98, 32, 61, 32, 40, 48, 44, 32, 107, 91, 34, 100, 121, 110, 67, 97, 108, 108, 95, 34, 32, 43, 32, 97, 93, 41, 40, 98, 44, 32, 46, 46, 46, 99, 41, 41, 32, 58, 32, 98, 32, 61, 32, 83, 46, 103, 101, 116, 40, 98, 41, 40, 46, 46, 46, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 112, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 46, 46, 46, 99, 41, 32, 61, 62, 32, 111, 98, 40, 97, 44, 32, 98, 44, 32, 99, 41, 44, 32, 84, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 112, 98, 40, 97, 44, 32, 98, 41, 32, 58, 32, 83, 46, 103, 101, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 111, 105, 110, 116, 101, 114, 32, 119, 105, 116, 104, 32, 115, 105, 103, 110, 97, 116, 117, 114, 101, 32, 36, 123, 97, 125, 58, 32, 36, 123, 98, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 113, 98, 44, 32, 115, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 114, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 99, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 102, 93, 32, 124, 124, 32, 76, 91, 102, 93, 32, 124, 124, 32, 40, 77, 97, 91, 102, 93, 32, 63, 32, 77, 97, 91, 102, 93, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 32, 58, 32, 40, 100, 46, 112, 117, 115, 104, 40, 102, 41, 44, 32, 101, 91, 102, 93, 32, 61, 32, 116, 114, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 44, 32, 101, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 113, 98, 40, 96, 36, 123, 97, 125, 58, 32, 96, 32, 43, 32, 100, 46, 109, 97, 112, 40, 115, 98, 41, 46, 106, 111, 105, 110, 40, 91, 34, 44, 32, 34, 93, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 117, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 100, 43, 43, 41, 32, 99, 46, 112, 117, 115, 104, 40, 68, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 49, 59, 32, 98, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 98, 41, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 91, 98, 93, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 74, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 102, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 97, 114, 103, 84, 121, 112, 101, 115, 32, 97, 114, 114, 97, 121, 32, 115, 105, 122, 101, 32, 109, 105, 115, 109, 97, 116, 99, 104, 33, 32, 77, 117, 115, 116, 32, 97, 116, 32, 108, 101, 97, 115, 116, 32, 103, 101, 116, 32, 114, 101, 116, 117, 114, 110, 32, 118, 97, 108, 117, 101, 32, 97, 110, 100, 32, 39, 116, 104, 105, 115, 39, 32, 116, 121, 112, 101, 115, 33, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 49, 93, 32, 38, 38, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 99, 44, 32, 103, 32, 61, 32, 118, 98, 40, 98, 41, 44, 32, 108, 32, 61, 32, 34, 118, 111, 105, 100, 34, 32, 33, 61, 61, 32, 98, 91, 48, 93, 46, 110, 97, 109, 101, 44, 32, 109, 32, 61, 32, 102, 32, 45, 32, 50, 44, 32, 110, 32, 61, 32, 65, 114, 114, 97, 121, 40, 109, 41, 44, 32, 113, 32, 61, 32, 91, 93, 44, 32, 114, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 98, 40, 97, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 65, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 104, 32, 63, 32, 50, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 91, 48, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 98, 91, 49, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 91, 49, 93, 32, 61, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 119, 32, 61, 32, 48, 59, 32, 119, 32, 60, 32, 109, 59, 32, 43, 43, 119, 41, 32, 110, 91, 119, 93, 32, 61, 32, 98, 91, 119, 32, 43, 32, 50, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 44, 32, 65, 91, 119, 93, 41, 44, 32, 113, 46, 112, 117, 115, 104, 40, 110, 91, 119, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 32, 61, 32, 100, 40, 46, 46, 46, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 41, 32, 76, 97, 40, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 119, 32, 61, 32, 104, 32, 63, 32, 49, 32, 58, 32, 50, 59, 32, 119, 32, 60, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 32, 119, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 49, 32, 61, 61, 61, 32, 119, 32, 63, 32, 118, 32, 58, 32, 110, 91, 119, 32, 45, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 119, 93, 46, 74, 97, 32, 38, 38, 32, 98, 91, 119, 93, 46, 74, 97, 40, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 108, 32, 63, 32, 98, 91, 48, 93, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 65, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 114, 105, 109, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 97, 46, 105, 110, 100, 101, 120, 79, 102, 40, 34, 40, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 45, 49, 32, 33, 61, 61, 32, 98, 32, 63, 32, 97, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 98, 41, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 121, 98, 32, 61, 32, 91, 93, 44, 32, 86, 32, 61, 32, 91, 93, 44, 32, 122, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 48, 32, 61, 61, 61, 32, 45, 45, 86, 91, 97, 32, 43, 32, 49, 93, 32, 38, 38, 32, 40, 86, 91, 97, 93, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 121, 98, 46, 112, 117, 115, 104, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 66, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 67, 97, 110, 110, 111, 116, 32, 117, 115, 101, 32, 100, 101, 108, 101, 116, 101, 100, 32, 118, 97, 108, 46, 32, 104, 97, 110, 100, 108, 101, 32, 61, 32, 34, 32, 43, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 86, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 107, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 118, 111, 105, 100, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 110, 117, 108, 108, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 116, 114, 117, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 102, 97, 108, 115, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 121, 98, 46, 112, 111, 112, 40, 41, 32, 124, 124, 32, 86, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 93, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 32, 43, 32, 49, 93, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 67, 98, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 34, 101, 109, 115, 99, 114, 105, 112, 116, 101, 110, 58, 58, 118, 97, 108, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 66, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 107, 98, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 68, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 117, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 121, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 122, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 67, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 68, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 69, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 76, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 97, 32, 61, 32, 96, 36, 123, 98, 125, 32, 104, 97, 115, 32, 117, 110, 107, 110, 111, 119, 110, 32, 116, 121, 112, 101, 32, 36, 123, 115, 98, 40, 97, 41, 125, 96, 44, 32, 110, 101, 119, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 105, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 117, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 97, 114, 114, 97, 121, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 61, 32, 98, 32, 63, 32, 97, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 58, 32, 34, 34, 32, 43, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 111, 97, 91, 99, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 56, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 112, 97, 91, 99, 32, 62, 62, 32, 51, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 102, 108, 111, 97, 116, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 71, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 117, 91, 100, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 120, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 121, 91, 100, 32, 62, 62, 32, 49, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 122, 91, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 67, 91, 100, 32, 62, 62, 32, 50, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 72, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 32, 111, 112, 116, 105, 111, 110, 97, 108, 58, 32, 116, 114, 117, 101, 32, 125, 44, 32, 67, 98, 41, 44, 32, 73, 98, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 34, 117, 116, 102, 45, 49, 54, 108, 101, 34, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 74, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 32, 62, 62, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 32, 61, 32, 99, 32, 43, 32, 98, 32, 47, 32, 50, 59, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 32, 38, 38, 32, 122, 91, 99, 93, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 60, 60, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 51, 50, 32, 60, 32, 99, 32, 45, 32, 97, 32, 38, 38, 32, 73, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 73, 98, 46, 100, 101, 99, 111, 100, 101, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 48, 59, 32, 33, 40, 100, 32, 62, 61, 32, 98, 32, 47, 32, 50, 41, 59, 32, 43, 43, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 121, 91, 97, 32, 43, 32, 50, 32, 42, 32, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 45, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 99, 32, 60, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 32, 63, 32, 99, 32, 47, 32, 50, 32, 58, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 99, 59, 32, 43, 43, 101, 41, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 44, 32, 98, 32, 43, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 76, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 44, 32, 77, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 48, 44, 32, 100, 32, 61, 32, 34, 34, 59, 32, 33, 40, 99, 32, 62, 61, 32, 98, 32, 47, 32, 52, 41, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 67, 91, 97, 32, 43, 32, 52, 32, 42, 32, 99, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 60, 61, 32, 101, 32, 63, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 32, 58, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 52, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 100, 32, 43, 32, 99, 32, 45, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 52, 32, 62, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 79, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 48, 59, 32, 99, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 100, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 100, 32, 38, 38, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 80, 98, 32, 61, 32, 91, 93, 44, 32, 81, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 80, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 98, 46, 112, 117, 115, 104, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 43, 43, 100, 41, 32, 99, 91, 100, 93, 32, 61, 32, 69, 98, 40, 68, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 44, 32, 34, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 34, 32, 43, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 98, 32, 61, 32, 82, 101, 102, 108, 101, 99, 116, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 44, 32, 84, 98, 32, 61, 32, 123, 125, 44, 32, 85, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 68, 97, 32, 124, 124, 32, 34, 117, 110, 119, 105, 110, 100, 34, 32, 61, 61, 32, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 86, 98, 32, 61, 32, 48, 44, 32, 87, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 86, 98, 32, 124, 124, 32, 40, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 69, 120, 105, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 97, 41, 44, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 68, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 109, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 40, 41, 44, 32, 33, 40, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 86, 98, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 32, 61, 32, 110, 97, 44, 32, 87, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 89, 98, 32, 61, 32, 123, 125, 44, 32, 36, 98, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 90, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 83, 69, 82, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 79, 71, 78, 65, 77, 69, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 65, 84, 72, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 87, 68, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 79, 77, 69, 58, 32, 34, 47, 104, 111, 109, 101, 47, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 65, 78, 71, 58, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 91, 48, 93, 32, 124, 124, 32, 34, 67, 34, 41, 46, 114, 101, 112, 108, 97, 99, 101, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 45, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 95, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 32, 43, 32, 34, 46, 85, 84, 70, 45, 56, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 101, 97, 32, 124, 124, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 89, 98, 41, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 89, 98, 91, 98, 93, 32, 63, 32, 100, 101, 108, 101, 116, 101, 32, 97, 91, 98, 93, 32, 58, 32, 97, 91, 98, 93, 32, 61, 32, 89, 98, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 97, 41, 32, 99, 46, 112, 117, 115, 104, 40, 96, 36, 123, 98, 125, 61, 36, 123, 97, 91, 98, 93, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 90, 98, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 90, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 90, 98, 44, 32, 97, 99, 32, 61, 32, 91, 110, 117, 108, 108, 44, 32, 91, 93, 44, 32, 91, 93, 93, 44, 32, 98, 99, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 97, 41, 32, 61, 62, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 34, 105, 110, 105, 116, 82, 97, 110, 100, 111, 109, 68, 101, 118, 105, 99, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 99, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 99, 99, 32, 61, 32, 98, 99, 40, 41, 41, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 77, 32, 61, 32, 107, 46, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 50, 53, 54, 41, 44, 32, 101, 99, 32, 61, 32, 48, 59, 32, 50, 53, 54, 32, 62, 32, 101, 99, 59, 32, 43, 43, 101, 99, 41, 32, 100, 99, 91, 101, 99, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 78, 97, 32, 61, 32, 100, 99, 59, 10, 32, 32, 32, 32, 32, 32, 81, 32, 61, 32, 107, 46, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 97, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 65, 108, 105, 97, 115, 79, 102, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 116, 104, 105, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 97, 98, 32, 38, 38, 32, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 97, 98, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 46, 68, 97, 46, 66, 97, 44, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 32, 61, 32, 97, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 65, 97, 46, 68, 97, 46, 66, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 97, 32, 61, 32, 97, 46, 65, 97, 46, 67, 97, 59, 32, 98, 46, 71, 97, 59, 32, 41, 32, 99, 32, 61, 32, 98, 46, 80, 97, 40, 99, 41, 44, 32, 98, 32, 61, 32, 98, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 100, 46, 71, 97, 59, 32, 41, 32, 97, 32, 61, 32, 100, 46, 80, 97, 40, 97, 41, 44, 32, 100, 32, 61, 32, 100, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 61, 61, 61, 32, 100, 32, 38, 38, 32, 99, 32, 61, 61, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 111, 110, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 124, 124, 32, 80, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 65, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 44, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 90, 97, 44, 32, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 44, 32, 99, 32, 61, 32, 98, 46, 99, 114, 101, 97, 116, 101, 44, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 44, 32, 101, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 99, 97, 108, 108, 40, 98, 44, 32, 100, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 99, 111, 117, 110, 116, 58, 32, 101, 46, 99, 111, 117, 110, 116, 44, 32, 77, 97, 58, 32, 101, 46, 77, 97, 44, 32, 79, 97, 58, 32, 101, 46, 79, 97, 44, 32, 67, 97, 58, 32, 101, 46, 67, 97, 44, 32, 68, 97, 58, 32, 101, 46, 68, 97, 44, 32, 69, 97, 58, 32, 101, 46, 69, 97, 44, 32, 72, 97, 58, 32, 101, 46, 72, 97, 32, 125, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 65, 97, 46, 77, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 124, 124, 32, 80, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 77, 97, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 116, 104, 105, 115, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 97, 46, 69, 97, 32, 63, 32, 97, 46, 72, 97, 46, 75, 97, 40, 97, 46, 69, 97, 41, 32, 58, 32, 97, 46, 68, 97, 46, 66, 97, 46, 75, 97, 40, 97, 46, 67, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 32, 124, 124, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 69, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 68, 101, 108, 101, 116, 101, 100, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 76, 97, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 67, 97, 32, 124, 124, 32, 80, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 65, 97, 46, 77, 97, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 65, 97, 46, 79, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 32, 61, 61, 61, 32, 82, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 87, 97, 32, 38, 38, 32, 87, 97, 40, 86, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 46, 77, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 103, 101, 116, 73, 110, 104, 101, 114, 105, 116, 101, 100, 73, 110, 115, 116, 97, 110, 99, 101, 67, 111, 117, 110, 116, 32, 61, 32, 40, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 88, 97, 41, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 103, 101, 116, 76, 105, 118, 101, 73, 110, 104, 101, 114, 105, 116, 101, 100, 73, 110, 115, 116, 97, 110, 99, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 91, 93, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 88, 97, 41, 32, 88, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 41, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 88, 97, 91, 98, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 102, 108, 117, 115, 104, 80, 101, 110, 100, 105, 110, 103, 68, 101, 108, 101, 116, 101, 115, 32, 61, 32, 86, 97, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 115, 101, 116, 68, 101, 108, 97, 121, 70, 117, 110, 99, 116, 105, 111, 110, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 87, 97, 32, 38, 38, 32, 87, 97, 40, 86, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 109, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 89, 97, 32, 38, 38, 32, 40, 97, 32, 61, 32, 116, 104, 105, 115, 46, 89, 97, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 116, 104, 105, 115, 46, 75, 97, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 83, 97, 32, 63, 32, 36, 97, 40, 116, 104, 105, 115, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 116, 104, 105, 115, 46, 105, 98, 44, 32, 67, 97, 58, 32, 99, 44, 32, 72, 97, 58, 32, 116, 104, 105, 115, 44, 32, 69, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 36, 97, 40, 116, 104, 105, 115, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 116, 104, 105, 115, 44, 32, 67, 97, 58, 32, 97, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 99, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 87, 97, 40, 97, 41, 44, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 89, 97, 40, 116, 104, 105, 115, 46, 66, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 46, 65, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 100, 46, 65, 97, 46, 67, 97, 32, 61, 32, 99, 44, 32, 100, 46, 65, 97, 46, 69, 97, 32, 61, 32, 97, 44, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 87, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 66, 97, 46, 98, 98, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 85, 97, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 82, 97, 32, 63, 32, 100, 46, 90, 97, 32, 58, 32, 100, 46, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 84, 97, 40, 99, 44, 32, 116, 104, 105, 115, 46, 66, 97, 44, 32, 100, 46, 66, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 101, 32, 63, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 32, 58, 32, 116, 104, 105, 115, 46, 83, 97, 32, 63, 32, 36, 97, 40, 100, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 100, 44, 32, 67, 97, 58, 32, 101, 44, 32, 72, 97, 58, 32, 116, 104, 105, 115, 44, 32, 69, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 36, 97, 40, 100, 46, 66, 97, 46, 78, 97, 44, 32, 123, 32, 68, 97, 58, 32, 100, 44, 32, 67, 97, 58, 32, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 113, 98, 32, 61, 32, 107, 46, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 32, 61, 32, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 98, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 69, 114, 114, 111, 114, 40, 100, 41, 46, 115, 116, 97, 99, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 40, 116, 104, 105, 115, 46, 115, 116, 97, 99, 107, 32, 61, 32, 116, 104, 105, 115, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 43, 32, 34, 92, 110, 34, 32, 43, 32, 100, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 94, 69, 114, 114, 111, 114, 40, 58, 91, 94, 92, 110, 93, 42, 41, 63, 92, 110, 47, 44, 32, 34, 34, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 116, 111, 83, 116, 114, 105, 110, 103, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 63, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 58, 32, 96, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 58, 32, 36, 123, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 40, 69, 114, 114, 111, 114, 44, 32, 34, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 86, 46, 112, 117, 115, 104, 40, 48, 44, 32, 49, 44, 32, 118, 111, 105, 100, 32, 48, 44, 32, 49, 44, 32, 110, 117, 108, 108, 44, 32, 49, 44, 32, 116, 114, 117, 101, 44, 32, 49, 44, 32, 102, 97, 108, 115, 101, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 99, 111, 117, 110, 116, 95, 101, 109, 118, 97, 108, 95, 104, 97, 110, 100, 108, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 86, 46, 108, 101, 110, 103, 116, 104, 32, 47, 32, 50, 32, 45, 32, 53, 32, 45, 32, 121, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 99, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 65, 115, 115, 101, 114, 116, 105, 111, 110, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 97, 32, 63, 32, 72, 40, 120, 44, 32, 97, 41, 32, 58, 32, 34, 34, 125, 44, 32, 97, 116, 58, 32, 96, 32, 43, 32, 91, 98, 32, 63, 32, 98, 32, 63, 32, 72, 40, 120, 44, 32, 98, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 105, 108, 101, 110, 97, 109, 101, 34, 44, 32, 99, 44, 32, 100, 32, 63, 32, 100, 32, 63, 32, 72, 40, 120, 44, 32, 100, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 34, 93, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 110, 101, 119, 32, 72, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 67, 97, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 67, 97, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 67, 97, 32, 43, 32, 56, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 84, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 34, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 75, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 75, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 85, 97, 44, 32, 100, 32, 61, 32, 98, 46, 75, 97, 44, 32, 101, 32, 61, 32, 98, 46, 88, 97, 44, 32, 102, 32, 61, 32, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 103, 98, 41, 46, 99, 111, 110, 99, 97, 116, 40, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 109, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 93, 44, 32, 102, 44, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 104, 91, 109, 93, 44, 32, 113, 32, 61, 32, 108, 46, 101, 98, 44, 32, 114, 32, 61, 32, 108, 46, 102, 98, 44, 32, 65, 32, 61, 32, 104, 91, 109, 32, 43, 32, 101, 46, 108, 101, 110, 103, 116, 104, 93, 44, 32, 118, 32, 61, 32, 108, 46, 108, 98, 44, 32, 119, 32, 61, 32, 108, 46, 110, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 91, 108, 46, 97, 98, 93, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 58, 32, 40, 69, 41, 32, 61, 62, 32, 110, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 113, 40, 114, 44, 32, 69, 41, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 114, 105, 116, 101, 58, 32, 40, 69, 44, 32, 104, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 66, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 40, 119, 44, 32, 69, 44, 32, 65, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 44, 32, 104, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 40, 66, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 123, 125, 44, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 109, 91, 110, 93, 32, 61, 32, 103, 91, 110, 93, 46, 114, 101, 97, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 105, 110, 32, 103, 41, 32, 105, 102, 32, 40, 33, 40, 110, 32, 105, 110, 32, 109, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 77, 105, 115, 115, 105, 110, 103, 32, 102, 105, 101, 108, 100, 58, 32, 34, 36, 123, 110, 125, 34, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 113, 32, 61, 32, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 103, 91, 110, 93, 46, 119, 114, 105, 116, 101, 40, 113, 44, 32, 109, 91, 110, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 108, 32, 38, 38, 32, 108, 46, 112, 117, 115, 104, 40, 100, 44, 32, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 113, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 33, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 32, 63, 32, 99, 32, 58, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 101, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 113, 44, 32, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 80, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 40, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 38, 38, 32, 40, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 32, 61, 32, 84, 40, 113, 44, 32, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 65, 32, 61, 32, 101, 98, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 40, 65, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 110, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 44, 32, 98, 44, 32, 99, 93, 44, 32, 100, 32, 63, 32, 91, 100, 93, 32, 58, 32, 91, 93, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 118, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 119, 32, 61, 32, 118, 46, 66, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 119, 46, 78, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 69, 32, 61, 32, 97, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 98, 98, 40, 110, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 83, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 32, 33, 61, 61, 32, 104, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 85, 115, 101, 32, 39, 110, 101, 119, 39, 32, 116, 111, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 34, 32, 43, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 66, 46, 76, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 110, 32, 43, 32, 34, 32, 104, 97, 115, 32, 110, 111, 32, 97, 99, 99, 101, 115, 115, 105, 98, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 65, 98, 32, 61, 32, 66, 46, 76, 97, 91, 83, 97, 46, 108, 101, 110, 103, 116, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 98, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 105, 110, 118, 111, 107, 101, 32, 99, 116, 111, 114, 32, 111, 102, 32, 36, 123, 110, 125, 32, 119, 105, 116, 104, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 83, 97, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 101, 100, 32, 40, 36, 123, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 66, 46, 76, 97, 41, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 125, 41, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 105, 110, 115, 116, 101, 97, 100, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 65, 98, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 83, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 69, 44, 32, 123, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 118, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 104, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 66, 32, 61, 32, 110, 101, 119, 32, 102, 98, 40, 110, 44, 32, 118, 44, 32, 104, 97, 44, 32, 114, 44, 32, 119, 44, 32, 102, 44, 32, 103, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 66, 46, 71, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 105, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 40, 105, 97, 32, 61, 32, 66, 46, 71, 97, 41, 46, 86, 97, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 105, 97, 46, 86, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 46, 71, 97, 46, 86, 97, 46, 112, 117, 115, 104, 40, 66, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 32, 61, 32, 110, 101, 119, 32, 109, 98, 40, 110, 44, 32, 66, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 97, 32, 61, 32, 110, 101, 119, 32, 109, 98, 40, 110, 32, 43, 32, 34, 42, 34, 44, 32, 66, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 32, 61, 32, 110, 101, 119, 32, 109, 98, 40, 110, 32, 43, 32, 34, 32, 99, 111, 110, 115, 116, 42, 34, 44, 32, 66, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 97, 91, 97, 93, 32, 61, 32, 123, 32, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 58, 32, 105, 97, 44, 32, 90, 97, 58, 32, 69, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 98, 40, 65, 44, 32, 118, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 119, 44, 32, 105, 97, 44, 32, 69, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 117, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 103, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 96, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 103, 46, 66, 97, 46, 76, 97, 32, 38, 38, 32, 40, 103, 46, 66, 97, 46, 76, 97, 32, 61, 32, 91, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 103, 46, 66, 97, 46, 76, 97, 91, 98, 32, 45, 32, 49, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 119, 105, 116, 104, 32, 105, 100, 101, 110, 116, 105, 99, 97, 108, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 98, 32, 45, 32, 49, 125, 41, 32, 102, 111, 114, 32, 99, 108, 97, 115, 115, 32, 39, 36, 123, 103, 46, 110, 97, 109, 101, 125, 39, 33, 32, 79, 118, 101, 114, 108, 111, 97, 100, 32, 114, 101, 115, 111, 108, 117, 116, 105, 111, 110, 32, 105, 115, 32, 99, 117, 114, 114, 101, 110, 116, 108, 121, 32, 111, 110, 108, 121, 32, 112, 101, 114, 102, 111, 114, 109, 101, 100, 32, 117, 115, 105, 110, 103, 32, 116, 104, 101, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 99, 111, 117, 110, 116, 44, 32, 110, 111, 116, 32, 97, 99, 116, 117, 97, 108, 32, 116, 121, 112, 101, 32, 105, 110, 102, 111, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 66, 97, 46, 76, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 104, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 46, 115, 112, 108, 105, 99, 101, 40, 49, 44, 32, 48, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 66, 97, 46, 76, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 119, 98, 40, 108, 44, 32, 109, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 117, 98, 40, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 120, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 113, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 113, 32, 61, 32, 96, 36, 123, 109, 46, 110, 97, 109, 101, 125, 46, 36, 123, 98, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 64, 64, 34, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 83, 121, 109, 98, 111, 108, 91, 98, 46, 115, 117, 98, 115, 116, 114, 105, 110, 103, 40, 50, 41, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 109, 46, 66, 97, 46, 106, 98, 46, 112, 117, 115, 104, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 32, 61, 32, 109, 46, 66, 97, 46, 78, 97, 44, 32, 65, 32, 61, 32, 114, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 46, 70, 97, 32, 38, 38, 32, 65, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 33, 61, 61, 32, 109, 46, 110, 97, 109, 101, 32, 38, 38, 32, 65, 46, 81, 97, 32, 61, 61, 61, 32, 99, 32, 45, 32, 50, 32, 63, 32, 40, 110, 46, 81, 97, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 110, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 61, 32, 109, 46, 110, 97, 109, 101, 44, 32, 114, 91, 98, 93, 32, 61, 32, 110, 41, 32, 58, 32, 40, 99, 98, 40, 114, 44, 32, 98, 44, 32, 113, 41, 44, 32, 114, 91, 98, 93, 46, 70, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 108, 44, 32, 40, 118, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 119, 98, 40, 113, 44, 32, 118, 44, 32, 109, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 114, 91, 98, 93, 46, 70, 97, 32, 63, 32, 40, 118, 46, 81, 97, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 114, 91, 98, 93, 32, 61, 32, 118, 41, 32, 58, 32, 114, 91, 98, 93, 46, 70, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 118, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 58, 32, 40, 97, 41, 32, 61, 62, 32, 78, 40, 97, 44, 32, 67, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 118, 97, 108, 117, 101, 115, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 118, 97, 108, 117, 101, 115, 91, 102, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 102, 44, 32, 104, 41, 32, 61, 62, 32, 104, 46, 118, 97, 108, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 68, 98, 40, 98, 44, 32, 99, 44, 32, 100, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 40, 98, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 69, 98, 40, 97, 44, 32, 34, 101, 110, 117, 109, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 99, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 98, 40, 96, 36, 123, 100, 46, 110, 97, 109, 101, 125, 95, 36, 123, 98, 125, 96, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 118, 97, 108, 117, 101, 115, 91, 99, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 41, 32, 61, 62, 32, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 70, 98, 40, 98, 44, 32, 99, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 117, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 120, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 97, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 45, 32, 49, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 104, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 98, 40, 97, 44, 32, 119, 98, 40, 97, 44, 32, 91, 103, 91, 48, 93, 44, 32, 110, 117, 108, 108, 93, 46, 99, 111, 110, 99, 97, 116, 40, 103, 46, 115, 108, 105, 99, 101, 40, 49, 41, 41, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 44, 32, 98, 32, 45, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 49, 32, 61, 61, 61, 32, 101, 32, 38, 38, 32, 40, 101, 32, 61, 32, 52, 50, 57, 52, 57, 54, 55, 50, 57, 53, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 51, 50, 32, 45, 32, 56, 32, 42, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 32, 60, 60, 32, 102, 32, 62, 62, 62, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 98, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 117, 110, 115, 105, 103, 110, 101, 100, 34, 41, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 32, 62, 62, 62, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 101, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 104, 44, 32, 73, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 71, 98, 40, 98, 44, 32, 99, 44, 32, 48, 32, 33, 61, 61, 32, 100, 41, 44, 32, 74, 97, 58, 32, 110, 117, 108, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 101, 40, 117, 46, 98, 117, 102, 102, 101, 114, 44, 32, 68, 91, 102, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 44, 32, 68, 91, 102, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 91, 73, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 93, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 99, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 100, 44, 32, 73, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 100, 32, 125, 44, 32, 123, 32, 104, 98, 58, 32, 116, 114, 117, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 72, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 113, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 32, 61, 32, 84, 40, 110, 44, 32, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 93, 44, 32, 91, 98, 93, 44, 32, 40, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 32, 61, 32, 114, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 110, 101, 119, 32, 109, 98, 40, 99, 44, 32, 114, 46, 66, 97, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 114, 44, 32, 100, 44, 32, 102, 44, 32, 103, 44, 32, 109, 44, 32, 113, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 69, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 34, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 44, 32, 102, 32, 61, 32, 100, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 104, 32, 61, 32, 102, 44, 32, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 61, 32, 101, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 102, 32, 43, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 61, 61, 32, 101, 32, 124, 124, 32, 48, 32, 61, 61, 32, 120, 91, 108, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 104, 32, 63, 32, 72, 40, 120, 44, 32, 104, 44, 32, 108, 32, 45, 32, 104, 41, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 41, 32, 118, 97, 114, 32, 109, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 108, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 65, 114, 114, 97, 121, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 59, 32, 43, 43, 103, 41, 32, 109, 91, 103, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 120, 91, 102, 32, 43, 32, 103, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 46, 106, 111, 105, 110, 40, 34, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 38, 38, 32, 40, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 44, 32, 104, 32, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 104, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 103, 32, 61, 32, 102, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 50, 55, 32, 62, 61, 32, 108, 32, 63, 32, 102, 43, 43, 32, 58, 32, 50, 48, 52, 55, 32, 62, 61, 32, 108, 32, 63, 32, 102, 32, 43, 61, 32, 50, 32, 58, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 108, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 108, 32, 63, 32, 40, 102, 32, 43, 61, 32, 52, 44, 32, 43, 43, 103, 41, 32, 58, 32, 102, 32, 43, 61, 32, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 32, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 102, 99, 40, 52, 32, 43, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 32, 61, 32, 103, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 32, 73, 40, 101, 44, 32, 108, 44, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 53, 53, 32, 60, 32, 109, 41, 32, 116, 104, 114, 111, 119, 32, 85, 40, 108, 41, 44, 32, 110, 101, 119, 32, 81, 40, 34, 83, 116, 114, 105, 110, 103, 32, 104, 97, 115, 32, 85, 84, 70, 45, 49, 54, 32, 99, 111, 100, 101, 32, 117, 110, 105, 116, 115, 32, 116, 104, 97, 116, 32, 100, 111, 32, 110, 111, 116, 32, 102, 105, 116, 32, 105, 110, 32, 56, 32, 98, 105, 116, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 120, 91, 108, 32, 43, 32, 104, 93, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 120, 91, 108, 32, 43, 32, 104, 93, 32, 61, 32, 101, 91, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 100, 46, 112, 117, 115, 104, 40, 85, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 74, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 75, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 76, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 122, 91, 103, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 52, 32, 61, 61, 61, 32, 98, 32, 38, 38, 32, 40, 100, 32, 61, 32, 77, 98, 44, 32, 101, 32, 61, 32, 78, 98, 44, 32, 102, 32, 61, 32, 79, 98, 44, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 44, 32, 109, 44, 32, 110, 32, 61, 32, 103, 32, 43, 32, 52, 44, 32, 113, 32, 61, 32, 48, 59, 32, 113, 32, 60, 61, 32, 108, 59, 32, 43, 43, 113, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 32, 61, 32, 103, 32, 43, 32, 52, 32, 43, 32, 113, 32, 42, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 113, 32, 61, 61, 32, 108, 32, 124, 124, 32, 48, 32, 61, 61, 32, 104, 40, 114, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 100, 40, 110, 44, 32, 114, 32, 45, 32, 110, 41, 44, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 32, 63, 32, 109, 32, 61, 32, 110, 32, 58, 32, 40, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 110, 41, 44, 32, 110, 32, 61, 32, 114, 32, 43, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 115, 116, 114, 105, 110, 103, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 67, 43, 43, 32, 115, 116, 114, 105, 110, 103, 32, 116, 121, 112, 101, 32, 36, 123, 99, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 102, 40, 108, 41, 44, 32, 110, 32, 61, 32, 102, 99, 40, 52, 32, 43, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 110, 32, 62, 62, 32, 50, 93, 32, 61, 32, 109, 32, 47, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 40, 108, 44, 32, 110, 32, 43, 32, 52, 44, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 103, 32, 38, 38, 32, 103, 46, 112, 117, 115, 104, 40, 85, 44, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 91, 97, 93, 32, 61, 32, 123, 32, 110, 97, 109, 101, 58, 32, 80, 40, 98, 41, 44, 32, 85, 97, 58, 32, 84, 40, 99, 44, 32, 100, 41, 44, 32, 75, 97, 58, 32, 84, 40, 101, 44, 32, 102, 41, 44, 32, 88, 97, 58, 32, 91, 93, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 91, 97, 93, 46, 88, 97, 46, 112, 117, 115, 104, 40, 123, 32, 97, 98, 58, 32, 80, 40, 98, 41, 44, 32, 103, 98, 58, 32, 99, 44, 32, 101, 98, 58, 32, 84, 40, 100, 44, 32, 101, 41, 44, 32, 102, 98, 58, 32, 102, 44, 32, 109, 98, 58, 32, 104, 44, 32, 108, 98, 58, 32, 84, 40, 103, 44, 32, 108, 41, 44, 32, 110, 98, 58, 32, 109, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 112, 98, 58, 32, 116, 114, 117, 101, 44, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 73, 97, 58, 32, 48, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 98, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 110, 102, 105, 110, 105, 116, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 66, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 40, 110, 117, 108, 108, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 71, 58, 32, 122, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 82, 98, 40, 97, 44, 32, 98, 41, 44, 32, 101, 32, 61, 32, 100, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 96, 109, 101, 116, 104, 111, 100, 67, 97, 108, 108, 101, 114, 60, 40, 36, 123, 100, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 110, 97, 109, 101, 41, 46, 106, 111, 105, 110, 40, 34, 44, 32, 34, 41, 125, 41, 32, 61, 62, 32, 36, 123, 101, 46, 110, 97, 109, 101, 125, 62, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 81, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 40, 98, 44, 32, 40, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 61, 32, 48, 44, 32, 113, 32, 61, 32, 48, 59, 32, 113, 32, 60, 32, 97, 59, 32, 43, 43, 113, 41, 32, 102, 91, 113, 93, 32, 61, 32, 100, 91, 113, 93, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 109, 32, 43, 32, 110, 41, 44, 32, 110, 32, 43, 61, 32, 100, 91, 113, 93, 46, 73, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 49, 32, 61, 61, 61, 32, 99, 32, 63, 32, 83, 98, 40, 103, 44, 32, 102, 41, 32, 58, 32, 103, 46, 97, 112, 112, 108, 121, 40, 104, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 101, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 40, 68, 91, 108, 32, 62, 62, 32, 50, 93, 32, 61, 32, 107, 98, 40, 104, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 40, 86, 91, 97, 32, 43, 32, 49, 93, 32, 43, 61, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 66, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 111, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 69, 98, 40, 97, 44, 32, 34, 95, 101, 109, 118, 97, 108, 95, 116, 97, 107, 101, 95, 118, 97, 108, 117, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 98, 91, 97, 93, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 84, 98, 91, 97, 93, 46, 105, 100, 41, 44, 32, 100, 101, 108, 101, 116, 101, 32, 84, 98, 91, 97, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 84, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 98, 40, 40, 41, 32, 61, 62, 32, 103, 99, 40, 97, 44, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 98, 91, 97, 93, 32, 61, 32, 123, 32, 105, 100, 58, 32, 99, 44, 32, 114, 98, 58, 32, 98, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 40, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 41, 41, 46, 103, 101, 116, 70, 117, 108, 108, 89, 101, 97, 114, 40, 41, 44, 32, 102, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 48, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 54, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 54, 48, 32, 42, 32, 77, 97, 116, 104, 46, 109, 97, 120, 40, 102, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 78, 117, 109, 98, 101, 114, 40, 102, 32, 33, 61, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 77, 97, 116, 104, 46, 97, 98, 115, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 96, 85, 84, 67, 36, 123, 48, 32, 60, 61, 32, 104, 32, 63, 32, 34, 45, 34, 32, 58, 32, 34, 43, 34, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 77, 97, 116, 104, 46, 102, 108, 111, 111, 114, 40, 103, 32, 47, 32, 54, 48, 41, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 50, 44, 32, 34, 48, 34, 41, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 103, 32, 37, 32, 54, 48, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 48, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 60, 32, 102, 32, 63, 32, 40, 73, 40, 97, 44, 32, 99, 44, 32, 49, 55, 41, 44, 32, 73, 40, 98, 44, 32, 100, 44, 32, 49, 55, 41, 41, 32, 58, 32, 40, 73, 40, 97, 44, 32, 100, 44, 32, 49, 55, 41, 44, 32, 73, 40, 98, 44, 32, 99, 44, 32, 49, 55, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 97, 58, 32, 40, 41, 32, 61, 62, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 120, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 62, 62, 62, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 32, 60, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 49, 59, 32, 52, 32, 62, 61, 32, 99, 59, 32, 99, 32, 42, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 42, 32, 40, 49, 32, 43, 32, 48, 46, 50, 32, 47, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 77, 97, 116, 104, 46, 109, 105, 110, 40, 100, 44, 32, 97, 32, 43, 32, 49, 48, 48, 54, 54, 51, 50, 57, 54, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 40, 77, 97, 116, 104, 46, 109, 105, 110, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 44, 32, 54, 53, 53, 51, 54, 32, 42, 32, 77, 97, 116, 104, 46, 99, 101, 105, 108, 40, 77, 97, 116, 104, 46, 109, 97, 120, 40, 97, 44, 32, 100, 41, 32, 47, 32, 54, 53, 53, 51, 54, 41, 41, 32, 45, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 43, 32, 54, 53, 53, 51, 53, 41, 32, 47, 32, 54, 53, 53, 51, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 46, 103, 114, 111, 119, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 98, 40, 41, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 68, 91, 97, 32, 43, 32, 52, 32, 42, 32, 101, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 102, 41, 32, 117, 91, 101, 43, 43, 93, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 91, 101, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 36, 98, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 100, 32, 43, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 55, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 44, 32, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 99, 59, 32, 102, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 68, 91, 98, 32, 62, 62, 32, 50, 93, 44, 32, 103, 32, 61, 32, 68, 91, 98, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 103, 59, 32, 108, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 97, 44, 32, 110, 32, 61, 32, 120, 91, 104, 32, 43, 32, 108, 93, 44, 32, 113, 32, 61, 32, 97, 99, 91, 109, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 110, 32, 124, 124, 32, 49, 48, 32, 61, 61, 61, 32, 110, 32, 63, 32, 40, 40, 49, 32, 61, 61, 61, 32, 109, 32, 63, 32, 106, 97, 32, 58, 32, 116, 41, 40, 72, 40, 113, 44, 32, 48, 41, 41, 44, 32, 113, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 41, 32, 58, 32, 113, 46, 112, 117, 115, 104, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 43, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 99, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 97, 32, 43, 32, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 58, 32, 104, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 58, 32, 105, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 58, 32, 106, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 58, 32, 107, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 58, 32, 108, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 58, 32, 109, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 110, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 58, 32, 111, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 58, 32, 112, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 72, 58, 32, 113, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 86, 58, 32, 87, 98, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 32, 61, 32, 99, 46, 101, 120, 112, 111, 114, 116, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 32, 61, 32, 87, 46, 103, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 32, 61, 32, 87, 46, 107, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 87, 46, 104, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 51, 32, 61, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 51, 46, 99, 97, 108, 108, 40, 107, 44, 32, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 32, 70, 32, 38, 38, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 118, 97, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 73, 110, 116, 101, 114, 118, 97, 108, 40, 118, 97, 41, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 41, 44, 32, 71, 32, 38, 38, 32, 40, 99, 32, 61, 32, 71, 44, 32, 71, 32, 61, 32, 110, 117, 108, 108, 44, 32, 99, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 87, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 123, 32, 97, 58, 32, 114, 99, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 40, 98, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 77, 111, 100, 117, 108, 101, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 32, 99, 97, 108, 108, 98, 97, 99, 107, 32, 102, 97, 105, 108, 101, 100, 32, 119, 105, 116, 104, 32, 101, 114, 114, 111, 114, 58, 32, 36, 123, 99, 125, 96, 41, 44, 32, 98, 97, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 97, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 121, 97, 32, 58, 32, 121, 97, 32, 61, 32, 120, 97, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 41, 32, 63, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 32, 58, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 32, 63, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 44, 32, 112, 41, 32, 58, 32, 112, 32, 43, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 99, 46, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 98, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 40, 41, 44, 32, 102, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 102, 99, 32, 61, 32, 87, 46, 105, 97, 41, 40, 97, 41, 44, 32, 114, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 114, 98, 32, 61, 32, 87, 46, 106, 97, 41, 40, 97, 41, 44, 32, 85, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 85, 32, 61, 32, 87, 46, 108, 97, 41, 40, 97, 41, 44, 32, 103, 99, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 103, 99, 32, 61, 32, 87, 46, 109, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 88, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 88, 32, 61, 32, 87, 46, 110, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 89, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 89, 32, 61, 32, 87, 46, 111, 97, 41, 40, 97, 41, 44, 32, 90, 32, 61, 32, 40, 41, 32, 61, 62, 32, 40, 90, 32, 61, 32, 87, 46, 112, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 87, 46, 113, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 87, 46, 114, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 87, 46, 115, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 87, 46, 116, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 99, 32, 61, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 40, 115, 99, 32, 61, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 106, 32, 61, 32, 87, 46, 117, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 106, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 106, 105, 32, 61, 32, 87, 46, 118, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 87, 46, 119, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 87, 46, 120, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 121, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 122, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 111, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 33, 61, 61, 32, 99, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 109, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 32, 33, 61, 61, 32, 109, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 116, 99, 59, 10, 32, 32, 32, 32, 32, 32, 71, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 99, 32, 124, 124, 32, 118, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 99, 32, 124, 124, 32, 40, 71, 32, 61, 32, 117, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 118, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 99, 32, 38, 38, 32, 40, 116, 99, 32, 61, 32, 116, 114, 117, 101, 44, 32, 107, 46, 99, 97, 108, 108, 101, 100, 82, 117, 110, 32, 61, 32, 116, 114, 117, 101, 44, 32, 33, 109, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 115, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 82, 117, 110, 116, 105, 109, 101, 73, 110, 105, 116, 105, 97, 108, 105, 122, 101, 100, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 111, 115, 116, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 48, 32, 60, 32, 70, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 41, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 114, 101, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 117, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 114, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 60, 32, 70, 32, 124, 124, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 32, 63, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 82, 117, 110, 110, 105, 110, 103, 46, 46, 46, 34, 41, 44, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 34, 41, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 49, 41, 41, 32, 58, 32, 97, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 61, 32, 91, 107, 46, 112, 114, 101, 73, 110, 105, 116, 93, 41, 59, 32, 48, 32, 60, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 112, 111, 112, 40, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 32, 61, 32, 99, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 41, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 97, 115, 109, 45, 108, 111, 97, 100, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 82, 101, 110, 100, 101, 114, 101, 114, 76, 111, 97, 100, 101, 114, 32, 105, 115, 32, 97, 32, 115, 116, 97, 116, 105, 99, 32, 99, 108, 97, 115, 115, 32, 97, 110, 100, 32, 99, 97, 110, 110, 111, 116, 32, 98, 101, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 100, 46, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 116, 114, 121, 76, 111, 97, 100, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 117, 108, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 40, 123, 32, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 58, 32, 40, 41, 32, 61, 62, 32, 117, 114, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 84, 114, 105, 101, 115, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 109, 111, 100, 117, 108, 101, 32, 102, 114, 111, 109, 32, 116, 104, 101, 32, 112, 114, 105, 109, 97, 114, 121, 32, 85, 82, 76, 44, 32, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 97, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 105, 102, 32, 110, 101, 99, 101, 115, 115, 97, 114, 121, 46, 10, 32, 32, 32, 32, 32, 42, 32, 84, 104, 114, 111, 119, 115, 32, 97, 110, 32, 101, 114, 114, 111, 114, 32, 105, 102, 32, 98, 111, 116, 104, 32, 85, 82, 76, 115, 32, 102, 97, 105, 108, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 46, 99, 97, 116, 99, 104, 40, 40, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 41, 32, 61, 62, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 117, 112, 85, 114, 108, 32, 61, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 117, 110, 112, 107, 103, 46, 99, 111, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 108, 111, 97, 100, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 36, 123, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 125, 46, 32, 69, 114, 114, 111, 114, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 65, 116, 116, 101, 109, 112, 116, 105, 110, 103, 32, 116, 111, 32, 108, 111, 97, 100, 32, 87, 65, 83, 77, 32, 102, 114, 111, 109, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 85, 114, 108, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 121, 105, 101, 108, 100, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 98, 97, 99, 107, 117, 112, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 66, 97, 99, 107, 117, 112, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 87, 65, 83, 77, 32, 108, 111, 97, 100, 105, 110, 103, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 97, 108, 108, 32, 115, 111, 117, 114, 99, 101, 115, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 80, 117, 98, 108, 105, 99, 32, 109, 101, 116, 104, 111, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 85, 116, 105, 108, 105, 122, 101, 115, 32, 97, 32, 112, 114, 105, 109, 97, 114, 121, 32, 97, 110, 100, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 102, 111, 114, 32, 114, 111, 98, 117, 115, 116, 110, 101, 115, 115, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 108, 111, 97, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 83, 101, 116, 115, 32, 97, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 32, 97, 110, 100, 32, 105, 110, 118, 97, 108, 105, 100, 97, 116, 101, 115, 32, 116, 104, 101, 32, 99, 117, 114, 114, 101, 110, 116, 32, 109, 111, 100, 117, 108, 101, 32, 112, 114, 111, 109, 105, 115, 101, 46, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 115, 116, 114, 105, 110, 103, 32, 45, 32, 32, 84, 104, 101, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 32, 61, 32, 117, 114, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 47, 47, 32, 101, 115, 108, 105, 110, 116, 45, 100, 105, 115, 97, 98, 108, 101, 45, 110, 101, 120, 116, 45, 108, 105, 110, 101, 32, 64, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 45, 101, 115, 108, 105, 110, 116, 47, 110, 97, 109, 105, 110, 103, 45, 99, 111, 110, 118, 101, 110, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 47, 47, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 44, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 101, 100, 32, 117, 115, 105, 110, 103, 32, 112, 97, 99, 107, 97, 103, 101, 32, 105, 110, 102, 111, 114, 109, 97, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 119, 97, 115, 109, 85, 82, 76, 34, 44, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 99, 100, 110, 46, 106, 115, 100, 101, 108, 105, 118, 114, 46, 110, 101, 116, 47, 110, 112, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 101, 118, 101, 110, 116, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 83, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 101, 116, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 97, 100, 100, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 105, 115, 112, 97, 116, 99, 104, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 101, 118, 101, 110, 116, 46, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 61, 62, 32, 108, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 99, 108, 101, 97, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 111, 102, 102, 115, 99, 114, 101, 101, 110, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 110, 116, 114, 121, 46, 105, 115, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 110, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 40, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 101, 115, 104, 111, 108, 100, 58, 32, 48, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 114, 101, 115, 105, 122, 101, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 32, 61, 32, 49, 48, 48, 59, 10, 32, 32, 118, 97, 114, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 101, 108, 101, 109, 101, 110, 116, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 116, 105, 109, 101, 111, 117, 116, 93, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 48, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 117, 116, 105, 108, 115, 46, 116, 115, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 47, 94, 35, 40, 91, 92, 100, 97, 45, 102, 93, 123, 54, 125, 124, 91, 92, 100, 97, 45, 102, 93, 123, 56, 125, 41, 36, 47, 105, 117, 46, 116, 101, 115, 116, 40, 99, 111, 108, 111, 114, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 101, 116, 32, 104, 101, 120, 32, 61, 32, 99, 111, 108, 111, 114, 72, 101, 120, 46, 114, 101, 112, 108, 97, 99, 101, 40, 34, 35, 34, 44, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 104, 101, 120, 32, 61, 32, 104, 101, 120, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 54, 32, 63, 32, 96, 36, 123, 104, 101, 120, 125, 102, 102, 96, 32, 58, 32, 104, 101, 120, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 97, 114, 115, 101, 73, 110, 116, 40, 104, 101, 120, 44, 32, 49, 54, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 60, 32, 52, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 115, 108, 105, 99, 101, 40, 48, 44, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 41, 41, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 108, 101, 110, 103, 116, 104, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 91, 105, 93, 32, 33, 61, 61, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 91, 105, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 106, 115, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 46, 101, 118, 101, 114, 121, 40, 40, 102, 105, 101, 108, 100, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 46, 99, 97, 108, 108, 40, 106, 115, 111, 110, 44, 32, 102, 105, 101, 108, 100, 41, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 102, 105, 108, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 63, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 49, 32, 43, 32, 40, 100, 112, 114, 32, 45, 32, 49, 41, 32, 42, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 99, 116, 46, 116, 111, 112, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 98, 111, 116, 116, 111, 109, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 72, 101, 105, 103, 104, 116, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 41, 32, 38, 38, 32, 114, 101, 99, 116, 46, 114, 105, 103, 104, 116, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 87, 105, 100, 116, 104, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 41, 59, 10, 32, 32, 125, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 32, 61, 32, 40, 109, 111, 100, 101, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 70, 111, 114, 119, 97, 114, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 32, 61, 32, 40, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 118, 101, 114, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 108, 108, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 108, 108, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 78, 111, 110, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 40, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 115, 101, 103, 109, 101, 110, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 50, 41, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 99, 108, 97, 115, 115, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 97, 110, 118, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 111, 110, 116, 101, 120, 116, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 34, 44, 32, 123, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 105, 115, 70, 114, 111, 122, 101, 110, 34, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 40, 34, 50, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 40, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 41, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 105, 115, 32, 116, 114, 117, 101, 32, 98, 121, 32, 100, 101, 102, 97, 117, 108, 116, 32, 116, 111, 32, 112, 114, 101, 118, 101, 110, 116, 32, 117, 110, 110, 101, 99, 101, 115, 115, 97, 114, 121, 32, 114, 101, 110, 100, 101, 114, 105, 110, 103, 32, 119, 104, 101, 110, 32, 116, 104, 101, 32, 99, 97, 110, 118, 97, 115, 32, 105, 115, 32, 111, 102, 102, 115, 99, 114, 101, 101, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 40, 95, 99, 32, 61, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 108, 111, 97, 100, 40, 41, 46, 116, 104, 101, 110, 40, 40, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 50, 44, 32, 95, 99, 50, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 97, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 98, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 99, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 50, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 91, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 32, 63, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 109, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 97, 100, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 119, 97, 115, 109, 32, 109, 111, 100, 117, 108, 101, 58, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 102, 101, 116, 99, 104, 40, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 114, 101, 115, 112, 111, 110, 115, 101, 46, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 102, 101, 116, 99, 104, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 125, 58, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 84, 101, 120, 116, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 97, 116, 97, 32, 61, 32, 121, 105, 101, 108, 100, 32, 114, 101, 115, 112, 111, 110, 115, 101, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 46, 100, 101, 99, 111, 100, 101, 40, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 115, 116, 114, 105, 110, 103, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 115, 116, 114, 105, 110, 103, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 100, 97, 116, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 68, 111, 116, 76, 111, 116, 116, 105, 101, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 111, 98, 106, 101, 99, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 111, 98, 106, 101, 99, 116, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 74, 83, 79, 78, 46, 115, 116, 114, 105, 110, 103, 105, 102, 121, 40, 100, 97, 116, 97, 41, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 85, 110, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 100, 97, 116, 97, 32, 116, 121, 112, 101, 32, 102, 111, 114, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 46, 32, 69, 120, 112, 101, 99, 116, 101, 100, 58, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 115, 116, 114, 105, 110, 103, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 40, 100, 111, 116, 76, 111, 116, 116, 105, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 111, 98, 106, 101, 99, 116, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 46, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 101, 99, 101, 105, 118, 101, 100, 58, 32, 36, 123, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 115, 111, 109, 101, 116, 104, 105, 110, 103, 32, 119, 101, 110, 116, 32, 119, 114, 111, 110, 103, 44, 32, 116, 104, 101, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 119, 97, 115, 32, 115, 117, 112, 112, 111, 115, 101, 32, 116, 111, 32, 97, 117, 116, 111, 112, 108, 97, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 34, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 46, 116, 104, 101, 110, 40, 40, 100, 97, 116, 97, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 97, 121, 111, 117, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 91, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 48, 41, 44, 32, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 49, 41, 93, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 97, 50, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 118, 101, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 70, 105, 116, 46, 70, 105, 108, 108, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 102, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 102, 46, 70, 105, 116, 46, 78, 111, 110, 101, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 111, 110, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 114, 107, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 110, 105, 102, 101, 115, 116, 83, 116, 114, 105, 110, 103, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 109, 97, 110, 105, 102, 101, 115, 116, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 32, 61, 32, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 109, 97, 110, 105, 102, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 41, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 48, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 114, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 32, 38, 38, 32, 115, 101, 103, 109, 101, 110, 116, 46, 115, 105, 122, 101, 40, 41, 32, 61, 61, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 48, 41, 44, 32, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 49, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 111, 100, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 70, 114, 111, 122, 101, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 117, 116, 111, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 112, 101, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 82, 101, 97, 100, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 97, 110, 118, 97, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 44, 32, 95, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 99, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 91, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 32, 63, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 40, 95, 104, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 104, 32, 58, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 114, 101, 110, 100, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 117, 102, 102, 101, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 40, 98, 117, 102, 102, 101, 114, 44, 32, 48, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 42, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 42, 32, 52, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 99, 114, 101, 97, 116, 101, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 46, 100, 97, 116, 97, 46, 115, 101, 116, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 101, 119, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 112, 117, 116, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 105, 109, 97, 103, 101, 68, 97, 116, 97, 44, 32, 48, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 114, 97, 119, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 120, 116, 70, 114, 97, 109, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 113, 117, 101, 115, 116, 70, 114, 97, 109, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 112, 100, 97, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 110, 101, 120, 116, 70, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 112, 100, 97, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 67, 111, 109, 112, 108, 101, 116, 101, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 38, 38, 32, 33, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 97, 117, 115, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 115, 116, 111, 112, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 114, 97, 109, 101, 32, 60, 32, 48, 32, 124, 124, 32, 102, 114, 97, 109, 101, 32, 62, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 101, 107, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 115, 116, 121, 108, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 108, 111, 111, 112, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 108, 101, 116, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 104, 101, 105, 103, 104, 116, 58, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 44, 32, 119, 105, 100, 116, 104, 58, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 105, 122, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 91, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 109, 111, 100, 101, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 44, 32, 123, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 44, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 125, 32, 61, 32, 95, 97, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 40, 95, 97, 44, 32, 91, 34, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 34, 44, 32, 34, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 34, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 105, 115, 32, 97, 32, 115, 112, 101, 99, 105, 97, 108, 32, 99, 97, 115, 101, 44, 32, 105, 116, 32, 115, 104, 111, 117, 108, 100, 32, 98, 101, 32, 115, 101, 116, 32, 116, 111, 32, 116, 104, 101, 32, 100, 101, 102, 97, 117, 108, 116, 32, 118, 97, 108, 117, 101, 32, 105, 102, 32, 105, 116, 39, 115, 32, 110, 111, 116, 32, 112, 114, 111, 118, 105, 100, 101, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 61, 61, 61, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 58, 36, 123, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 115, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 97, 114, 107, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 109, 97, 114, 107, 101, 114, 115, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 109, 97, 114, 107, 101, 114, 115, 46, 103, 101, 116, 40, 105, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 46, 112, 117, 115, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 105, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 116, 105, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 109, 97, 114, 107, 101, 114, 46, 100, 117, 114, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 115, 117, 108, 116, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 114, 116, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 97, 114, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 97, 114, 116, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 112, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 111, 112, 112, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 111, 112, 112, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 88, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 47, 32, 114, 101, 99, 116, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 89, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 47, 32, 114, 101, 99, 116, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 88, 32, 45, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 41, 32, 42, 32, 115, 99, 97, 108, 101, 88, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 89, 32, 45, 32, 114, 101, 99, 116, 46, 116, 111, 112, 41, 32, 42, 32, 115, 99, 97, 108, 101, 89, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 70, 114, 97, 109, 101, 119, 111, 114, 107, 83, 101, 116, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 112, 117, 115, 104, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 85, 112, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 48, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 40, 95, 100, 32, 61, 32, 40, 95, 99, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 49, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 44, 32, 34, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 119, 111, 114, 107, 101, 114, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 119, 111, 114, 107, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 32, 61, 32, 123, 10, 32, 32, 32, 32, 114, 101, 97, 100, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 97, 100, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 111, 109, 112, 108, 101, 116, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 67, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 83, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 97, 109, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 85, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 68, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 111, 109, 109, 97, 110, 100, 115, 32, 61, 32, 123, 10, 32, 32, 32, 32, 103, 101, 116, 68, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 83, 116, 97, 116, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 76, 111, 97, 100, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 76, 111, 97, 100, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 97, 117, 115, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 70, 114, 111, 122, 101, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 70, 114, 111, 122, 101, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 111, 100, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 112, 101, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 117, 116, 111, 112, 108, 97, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 97, 121, 111, 117, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 82, 101, 97, 100, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 82, 101, 97, 100, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 110, 105, 102, 101, 115, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 110, 105, 102, 101, 115, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 114, 101, 97, 116, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 104, 97, 115, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 97, 108, 114, 101, 97, 100, 121, 32, 101, 120, 105, 115, 116, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 110, 101, 119, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 115, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 32, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 118, 101, 110, 116, 115, 32, 61, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 115, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 97, 100, 121, 34, 10, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 44, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 91, 101, 118, 101, 110, 116, 93, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 100, 101, 108, 101, 116, 101, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 102, 114, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 44, 32, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 112, 101, 101, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 112, 101, 101, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 111, 111, 112, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 101, 116, 104, 111, 100, 32, 61, 32, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 46, 109, 101, 116, 104, 111, 100, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 77, 101, 116, 104, 111, 100, 32, 36, 123, 109, 101, 116, 104, 111, 100, 125, 32, 105, 115, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 105, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 115, 101, 108, 102, 46, 111, 110, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 101, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 100, 117, 109, 109, 121, 32, 61, 32, 34, 34, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 119, 111, 114, 107, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 100, 117, 109, 109, 121, 59, 10, 125, 41, 40, 41, 59, 10])], { type: "application/javascript" }), n = URL.createObjectURL(e), i = new Worker(n);
    return URL.revokeObjectURL(n), i;
  }
}, GX = XX, qX = class {
  constructor() {
    dt(this, "_workers", /* @__PURE__ */ new Map()), dt(this, "_animationWorkerMap", /* @__PURE__ */ new Map());
  }
  getWorker(e) {
    return this._workers.has(e) || this._workers.set(e, new GX()), this._workers.get(e);
  }
  assignAnimationToWorker(e, n) {
    this._animationWorkerMap.set(e, n);
  }
  unassignAnimationFromWorker(e) {
    this._animationWorkerMap.delete(e);
  }
  sendMessage(e, n, i) {
    this.getWorker(e).postMessage(n, i || []);
  }
  terminateWorker(e) {
    let n = this._workers.get(e);
    n && (n.terminate(), this._workers.delete(e));
  }
};
function Mx(e) {
  if (e instanceof OffscreenCanvas)
    return { width: e.width, height: e.height };
  let { height: n, width: i } = e.getBoundingClientRect();
  return { width: i * window.devicePixelRatio, height: n * window.devicePixelRatio };
}
function Tx() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var Lx = class ul {
  constructor(n) {
    dt(this, "_eventManager", new $M()), dt(this, "_id"), dt(this, "_worker"), dt(this, "_canvas"), dt(this, "_dotLottieInstanceState", { markers: [], autoplay: !1, backgroundColor: "", currentFrame: 0, duration: 0, loop: !1, mode: "forward", segment: [0, 0], segmentDuration: 0, speed: 1, totalFrames: 0, isLoaded: !1, isPlaying: !1, isPaused: !1, isStopped: !0, isFrozen: !1, useFrameInterpolation: !1, renderConfig: { devicePixelRatio: Cf() }, activeAnimationId: "", activeThemeId: "", layout: void 0, marker: void 0, isReady: !1, manifest: null }), dt(this, "_created", !1), dt(this, "_pointerUpMethod"), dt(this, "_pointerDownMethod"), dt(this, "_pointerMoveMethod"), dt(this, "_pointerEnterMethod"), dt(this, "_pointerExitMethod");
    var i, a, s;
    this._canvas = n.canvas, this._id = `dotlottie-${Tx()}`;
    let g = n.workerId || "defaultWorker";
    this._worker = ul._workerManager.getWorker(g), ul._workerManager.assignAnimationToWorker(this._id, g), ul._wasmUrl && this._sendMessage("setWasmUrl", { url: ul._wasmUrl }), this._create(v3(ar({}, n), { renderConfig: v3(ar({}, n.renderConfig), { devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || Cf(), freezeOnOffscreen: (s = (a = n.renderConfig) == null ? void 0 : a.freezeOnOffscreen) != null ? s : !0 }) })), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _handleWorkerEvent(n) {
    return vt(this, null, function* () {
      let i = n.data;
      i.id || (i.method === "onLoad" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event), Dr && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && D0.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && k0.observe(this._canvas, this))), i.method === "onComplete" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onDestroy" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onUnfreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = !1, this._eventManager.dispatch(i.result.event)), i.method === "onFrame" && i.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = i.result.event.currentFrame, this._eventManager.dispatch(i.result.event)), i.method === "onRender" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onFreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPause" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPlay" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStop" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onLoadError" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onReady" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)));
    });
  }
  _create(n) {
    return vt(this, null, function* () {
      let i;
      this._canvas instanceof HTMLCanvasElement ? i = this._canvas.transferControlToOffscreen() : i = this._canvas;
      let { instanceId: a } = yield this._sendMessage("create", ar({ instanceId: this._id, config: v3(ar({}, n), { canvas: i }) }, Mx(this._canvas)), [i]);
      if (a !== this._id)
        throw new Error("Instance ID mismatch");
      this._created = !0, yield this._updateDotLottieInstanceState();
    });
  }
  get isLoaded() {
    return this._dotLottieInstanceState.isLoaded;
  }
  get isPlaying() {
    return this._dotLottieInstanceState.isPlaying;
  }
  get isPaused() {
    return this._dotLottieInstanceState.isPaused;
  }
  get isStopped() {
    return this._dotLottieInstanceState.isStopped;
  }
  get currentFrame() {
    return this._dotLottieInstanceState.currentFrame;
  }
  get isFrozen() {
    return this._dotLottieInstanceState.isFrozen;
  }
  get segmentDuration() {
    return this._dotLottieInstanceState.segmentDuration;
  }
  get totalFrames() {
    return this._dotLottieInstanceState.totalFrames;
  }
  get segment() {
    return this._dotLottieInstanceState.segment;
  }
  get speed() {
    return this._dotLottieInstanceState.speed;
  }
  get duration() {
    return this._dotLottieInstanceState.duration;
  }
  get isReady() {
    return this._dotLottieInstanceState.isReady;
  }
  get mode() {
    return this._dotLottieInstanceState.mode;
  }
  get canvas() {
    return this._canvas;
  }
  get autoplay() {
    return this._dotLottieInstanceState.autoplay;
  }
  get backgroundColor() {
    return this._dotLottieInstanceState.backgroundColor;
  }
  get loop() {
    return this._dotLottieInstanceState.loop;
  }
  get useFrameInterpolation() {
    return this._dotLottieInstanceState.useFrameInterpolation;
  }
  get renderConfig() {
    return this._dotLottieInstanceState.renderConfig;
  }
  get manifest() {
    return this._dotLottieInstanceState.manifest;
  }
  get activeAnimationId() {
    return this._dotLottieInstanceState.activeAnimationId;
  }
  get marker() {
    return this._dotLottieInstanceState.marker;
  }
  get activeThemeId() {
    return this._dotLottieInstanceState.activeThemeId;
  }
  get layout() {
    return this._dotLottieInstanceState.layout;
  }
  play() {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("play", { instanceId: this._id }), yield this._updateDotLottieInstanceState(), Dr && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !eT(this._canvas) && (yield this.freeze()));
    });
  }
  pause() {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("pause", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  stop() {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("stop", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSpeed(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setSpeed", { instanceId: this._id, speed: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setMode(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setMode", { instanceId: this._id, mode: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setFrame(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setFrame", { frame: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSegment(n, i) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setSegment", { instanceId: this._id, segment: [n, i] }), yield this._updateDotLottieInstanceState());
    });
  }
  setRenderConfig(n) {
    return vt(this, null, function* () {
      if (!this._created)
        return;
      let i = n, { devicePixelRatio: a, freezeOnOffscreen: s } = i, g = GM(i, ["devicePixelRatio", "freezeOnOffscreen"]);
      yield this._sendMessage("setRenderConfig", { instanceId: this._id, renderConfig: v3(ar(ar({}, this._dotLottieInstanceState.renderConfig), g), { devicePixelRatio: a || Cf(), freezeOnOffscreen: s ?? !0 }) }), yield this._updateDotLottieInstanceState(), Dr && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? k0.observe(this._canvas, this) : k0.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? D0.observe(this._canvas, this) : (D0.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && (yield this.unfreeze())));
    });
  }
  setUseFrameInterpolation(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setUseFrameInterpolation", { instanceId: this._id, useFrameInterpolation: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadTheme(n) {
    return vt(this, null, function* () {
      if (!this._created)
        return !1;
      let i = this._sendMessage("loadTheme", { instanceId: this._id, themeId: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  load(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("load", { config: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLoop(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setLoop", { instanceId: this._id, loop: n }), yield this._updateDotLottieInstanceState());
    });
  }
  resize() {
    return vt(this, null, function* () {
      if (!this._created)
        return;
      let { height: n, width: i } = Mx(this._canvas);
      yield this._sendMessage("resize", { height: n, instanceId: this._id, width: i }), yield this._updateDotLottieInstanceState();
    });
  }
  destroy() {
    return vt(this, null, function* () {
      this._created && (this._created = !1, yield this._sendMessage("destroy", { instanceId: this._id }), this._cleanupStateMachineListeners(), ul._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), Dr && this._canvas instanceof HTMLCanvasElement && (D0.unobserve(this._canvas), k0.unobserve(this._canvas)));
    });
  }
  freeze() {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("freeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  unfreeze() {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("unfreeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setBackgroundColor(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setBackgroundColor", { instanceId: this._id, backgroundColor: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadAnimation(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("loadAnimation", { animationId: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLayout(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setLayout", { instanceId: this._id, layout: n }), yield this._updateDotLottieInstanceState());
    });
  }
  _updateDotLottieInstanceState() {
    return vt(this, null, function* () {
      if (!this._created)
        return;
      let n = yield this._sendMessage("getDotLottieInstanceState", { instanceId: this._id });
      this._dotLottieInstanceState = n.state;
    });
  }
  markers() {
    return this._dotLottieInstanceState.markers;
  }
  setMarker(n) {
    return vt(this, null, function* () {
      this._created && (yield this._sendMessage("setMarker", { instanceId: this._id, marker: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadThemeData(n) {
    return vt(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadThemeData", { instanceId: this._id, themeData: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  setViewport(n, i, a, s) {
    return vt(this, null, function* () {
      return this._created ? this._sendMessage("setViewport", { x: n, y: i, width: a, height: s, instanceId: this._id }) : !1;
    });
  }
  _sendMessage(n, i, a) {
    return vt(this, null, function* () {
      let s = { id: `dotlottie-request-${Tx()}`, method: n, params: i };
      return this._worker.postMessage(s, a || []), new Promise((g, c) => {
        let I = (h) => {
          let m = h.data;
          m.id === s.id && (this._worker.removeEventListener("message", I), m.error ? c(new Error(`Failed to execute method ${n}: ${m.error}`)) : g(m.result));
        };
        this._worker.addEventListener("message", I);
      });
    });
  }
  addEventListener(n, i) {
    this._eventManager.addEventListener(n, i);
  }
  removeEventListener(n, i) {
    this._eventManager.removeEventListener(n, i);
  }
  static setWasmUrl(n) {
    ul._wasmUrl = n;
  }
  loadStateMachine(n) {
    return vt(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadStateMachine", { instanceId: this._id, stateMachineId: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  loadStateMachineData(n) {
    return vt(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadStateMachineData", { instanceId: this._id, stateMachineData: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  startStateMachine() {
    return vt(this, null, function* () {
      if (!this._created)
        return !1;
      this._setupStateMachineListeners();
      let n = yield this._sendMessage("startStateMachine", { instanceId: this._id });
      return yield this._updateDotLottieInstanceState(), n;
    });
  }
  stopStateMachine() {
    return vt(this, null, function* () {
      return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", { instanceId: this._id })) : !1;
    });
  }
  getStateMachineListeners() {
    return vt(this, null, function* () {
      return this._created ? this._sendMessage("getStateMachineListeners", { instanceId: this._id }) : [];
    });
  }
  _getPointerPosition(n) {
    let i = this._canvas.getBoundingClientRect(), a = this._canvas.width / i.width, s = this._canvas.height / i.height, g = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, c = (n.clientX - i.left) * a / g, I = (n.clientY - i.top) * s / g;
    return { x: c, y: I };
  }
  _onPointerUp(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerUpEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerDown(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerDownEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerMove(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerMoveEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerEnter(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerEnterEvent", { instanceId: this._id, x: i, y: a });
  }
  _onPointerLeave(n) {
    let { x: i, y: a } = this._getPointerPosition(n);
    this._sendMessage("postPointerExitEvent", { instanceId: this._id, x: i, y: a });
  }
  _setupStateMachineListeners() {
    return vt(this, null, function* () {
      if (Dr && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
        let n = yield this._sendMessage("getStateMachineListeners", { instanceId: this._id });
        n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
      }
    });
  }
  _cleanupStateMachineListeners() {
    Dr && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
};
dt(Lx, "_workerManager", new qX()), dt(Lx, "_wasmUrl", "");
function ZX(e) {
  var n = e, {
    children: i,
    className: a = "",
    setCanvasRef: s,
    setContainerRef: g,
    style: c
  } = n, I = YM(n, [
    "children",
    "className",
    "setCanvasRef",
    "setContainerRef",
    "style"
  ]);
  const h = Ko({
    width: "100%",
    height: "100%",
    lineHeight: 0
  }, c);
  return /* @__PURE__ */ nn.createElement("div", Ko({ ref: g, className: a }, !a && { style: h }), /* @__PURE__ */ nn.createElement(
    "canvas",
    Ko({
      ref: s,
      style: {
        width: "100%",
        height: "100%"
      }
    }, I),
    i
  ));
}
var $X = (e) => {
  const [n, i] = gt(null), a = Cn(null), s = Cn(e), g = Cn(null), c = Cn(null);
  a.current = n, s.current = e;
  const I = m2((x) => {
    var M, O;
    !((M = s.current) != null && M.playOnHover) || !((O = a.current) != null && O.isLoaded) || (x.type === "mouseenter" ? a.current.play() : x.type === "mouseleave" && a.current.pause());
  }, []), h = m2((x) => {
    g.current = x;
  }, []), m = m2((x) => {
    c.current = x;
  }, []), w = m2(
    (x) => /* @__PURE__ */ nn.createElement(ZX, Ko({ setContainerRef: m, setCanvasRef: h }, x)),
    [h, m]
  );
  return vn(() => {
    const x = g.current;
    let M = null;
    return x && (M = new QX(zX(Ko({}, s.current), {
      canvas: x
    })), x.addEventListener("mouseenter", I), x.addEventListener("mouseleave", I), i(M)), () => {
      M == null || M.destroy(), i(null), x == null || x.removeEventListener("mouseenter", I), x == null || x.removeEventListener("mouseleave", I);
    };
  }, [I]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.speed) == "number" && e.speed !== a.current.speed && a.current.setSpeed(e.speed);
  }, [e == null ? void 0 : e.speed]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.mode) == "string" && e.mode !== a.current.mode && a.current.setMode(e.mode);
  }, [e == null ? void 0 : e.mode]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.loop) == "boolean" && e.loop !== a.current.loop && a.current.setLoop(e.loop);
  }, [e == null ? void 0 : e.loop]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.useFrameInterpolation) == "boolean" && e.useFrameInterpolation !== a.current.useFrameInterpolation && a.current.setUseFrameInterpolation(e.useFrameInterpolation);
  }, [e == null ? void 0 : e.useFrameInterpolation]), vn(() => {
    var x, M;
    if (!a.current)
      return;
    const O = (x = e == null ? void 0 : e.segment) == null ? void 0 : x[0], k = (M = e == null ? void 0 : e.segment) == null ? void 0 : M[1];
    typeof O == "number" && typeof k == "number" && a.current.setSegment(O, k);
  }, [e == null ? void 0 : e.segment]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.backgroundColor) == "string" && e.backgroundColor !== a.current.backgroundColor && a.current.setBackgroundColor(e.backgroundColor);
  }, [e == null ? void 0 : e.backgroundColor]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.renderConfig) == "object" && a.current.setRenderConfig(e.renderConfig);
  }, [JSON.stringify(e == null ? void 0 : e.renderConfig)]), vn(() => {
    a.current && (typeof (e == null ? void 0 : e.data) == "string" || (e == null ? void 0 : e.data) instanceof ArrayBuffer) && a.current.load(Ko({
      data: e.data
    }, s.current || {}));
  }, [e == null ? void 0 : e.data]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.src) == "string" && a.current.load(Ko({
      src: e.src
    }, s.current || {}));
  }, [e == null ? void 0 : e.src]), vn(() => {
    a.current && typeof (e == null ? void 0 : e.marker) == "string" && a.current.setMarker(e.marker);
  }, [e == null ? void 0 : e.marker]), vn(() => {
    a.current && a.current.isLoaded && e != null && e.animationId && a.current.activeAnimationId !== e.animationId && a.current.loadAnimation(e.animationId);
  }, [e == null ? void 0 : e.animationId]), vn(() => {
    a.current && a.current.isLoaded && a.current.activeThemeId !== (e == null ? void 0 : e.themeId) && a.current.loadTheme((e == null ? void 0 : e.themeId) || "");
  }, [e == null ? void 0 : e.themeId]), vn(() => {
    a.current && a.current.isLoaded && a.current.loadThemeData((e == null ? void 0 : e.themeData) || "");
  }, [e == null ? void 0 : e.themeData]), {
    dotLottie: n,
    setCanvasRef: h,
    setContainerRef: m,
    canvas: g.current,
    container: c.current,
    DotLottieComponent: w
  };
}, eG = typeof window < "u" ? pf : vn;
function tG(e) {
  const n = Cn(e);
  return eG(() => {
    n.current = e;
  }), m2((...i) => n.current(...i), [n]);
}
var Hf = (e) => {
  var n = e, {
    animationId: i,
    autoplay: a,
    backgroundColor: s,
    data: g,
    dotLottieRefCallback: c,
    loop: I,
    marker: h,
    mode: m,
    playOnHover: w,
    renderConfig: x,
    segment: M,
    speed: O,
    src: k,
    themeData: z,
    themeId: N,
    useFrameInterpolation: U
  } = n, Q = YM(n, [
    "animationId",
    "autoplay",
    "backgroundColor",
    "data",
    "dotLottieRefCallback",
    "loop",
    "marker",
    "mode",
    "playOnHover",
    "renderConfig",
    "segment",
    "speed",
    "src",
    "themeData",
    "themeId",
    "useFrameInterpolation"
  ]);
  const { DotLottieComponent: _, dotLottie: X } = $X({
    data: g,
    mode: m,
    speed: O,
    src: k,
    autoplay: a,
    loop: I,
    segment: M,
    renderConfig: x,
    backgroundColor: s,
    useFrameInterpolation: U,
    playOnHover: w,
    marker: h,
    themeId: N,
    animationId: i,
    themeData: z
  }), B = typeof c == "function" ? tG(c) : void 0;
  return nn.useEffect(() => {
    typeof B == "function" && B(X);
  }, [B, X]), /* @__PURE__ */ nn.createElement(_, Ko({}, Q));
};
const nG = "data:application/octet-stream;base64,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", Ye1 = (e) => /* @__PURE__ */ v.jsx(Hf, { ...e, src: nG }), rG = "data:application/json;base64,eyJ2IjoiNS43LjMiLCJpcCI6MCwib3AiOjYxLCJmciI6MzAsInciOjkwMCwiaCI6OTAwLCJubSI6IlMiLCJhc3NldHMiOltdLCJsYXllcnMiOlt7ImluZCI6MSwidHkiOjQsIm5tIjoiQyIsInNyIjoxLCJrcyI6eyJvIjp7ImEiOjAsImsiOjEwMH0sInIiOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6WzQ1MCw0MzUuMywwXX0sImEiOnsiYSI6MCwiayI6WzAsMCwwXX0sInMiOnsiYSI6MCwiayI6WzEyMi4wMSwxMjIuMDEsMTAwXX19LCJzaGFwZXMiOlt7InR5IjoiZ3IiLCJubSI6IlMiLCJpdCI6W3sidHkiOiJzaCIsIm5tIjoiUCIsImluZCI6MCwia3MiOnsiayI6eyJpIjpbWzAsMF0sWzAsMF0sWzAsMF1dLCJvIjpbWzAsMF0sWzAsMF0sWzAsMF1dLCJ2IjpbWy0xMDAuNSwyOS41XSxbLTUyLDg1LjVdLFs4OC41NDgsLTQ0LjAxMl1dLCJjIjpmYWxzZX0sImEiOjB9fSx7InR5Ijoic3QiLCJubSI6IlMiLCJsYyI6MiwibGoiOjIsIm8iOnsiYSI6MCwiayI6MTAwfSwidyI6eyJhIjowLCJrIjozMH0sImMiOnsiYSI6MCwiayI6WzAuNzY5LDAuOTAyLDAuOTkyLDFdfX0seyJ0eSI6InRyIiwibyI6eyJhIjowLCJrIjoxMDB9LCJyIjp7ImEiOjAsImsiOjB9LCJwIjp7ImEiOjAsImsiOlswLDBdfSwiYSI6eyJhIjowLCJrIjpbMCwwXX0sInMiOnsiYSI6MCwiayI6WzEwMCwxMDBdfSwibm0iOiJUIiwic2siOnsiYSI6MCwiayI6MH0sInNhIjp7ImEiOjAsImsiOjB9fV19LHsidHkiOiJ0bSIsIm5tIjoiVCIsInMiOnsiYSI6MCwiayI6MH0sImUiOnsiYSI6MSwiayI6W3siaSI6eyJ4IjpbMF0sInkiOlsxXX0sIm8iOnsieCI6WzAuMzMzXSwieSI6WzBdfSwidCI6OSwicyI6WzBdfSx7InQiOjI5LCJzIjpbMTAwXX1dfSwibyI6eyJhIjowLCJrIjowfSwibSI6MX1dLCJpcCI6MCwib3AiOjEwOCwic3QiOjB9LHsiaW5kIjoyLCJ0eSI6NCwibm0iOiJGIiwic3IiOjEsImtzIjp7Im8iOnsiYSI6MCwiayI6MTAwfSwiciI6eyJhIjowLCJrIjowfSwicCI6eyJhIjowLCJrIjpbNDQxLjE4LDQ0NC4xMiwwXX0sImEiOnsiYSI6MCwiayI6Wy01NC41MzEsMjcuNDY5LDBdfSwicyI6eyJhIjowLCJrIjpbMjI0LjAyNywyMjQuMDI3LDEwMF19fSwic2hhcGVzIjpbeyJ0eSI6ImdyIiwibm0iOiJFIiwiaXQiOlt7InR5IjoiZWwiLCJubSI6IkUiLCJkIjoxLCJwIjp7ImEiOjAsImsiOlswLDBdfSwicyI6eyJhIjowLCJrIjpbMjYyLjkzOCwyNjIuOTM4XX19LHsidHkiOiJzdCIsIm5tIjoiUyIsImxjIjoyLCJsaiI6MSwibWwiOjQsIm8iOnsiYSI6MCwiayI6MTAwfSwidyI6eyJhIjowLCJrIjo0fSwiYyI6eyJhIjowLCJrIjpbMC4wNjcsMC4zOTYsMC42MTIsMV19fSx7InR5IjoidHIiLCJvIjp7ImEiOjAsImsiOjEwMH0sInIiOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6Wy01NC41MzEsMjcuNDY5XX0sImEiOnsiYSI6MCwiayI6WzAsMF19LCJzIjp7ImEiOjAsImsiOlsxMDAsMTAwXX0sIm5tIjoiVCIsInNrIjp7ImEiOjAsImsiOjB9LCJzYSI6eyJhIjowLCJrIjowfX1dfSx7InR5IjoidG0iLCJubSI6IlQiLCJzIjp7ImEiOjEsImsiOlt7ImkiOnsieCI6WzAuMDQxXSwieSI6WzFdfSwibyI6eyJ4IjpbMC4zMzNdLCJ5IjpbMF19LCJ0Ijo3LjYwMSwicyI6WzBdfSx7InQiOjI4LCJzIjpbMTAwXX1dfSwiZSI6eyJhIjoxLCJrIjpbeyJpIjp7IngiOlswLjA5M10sInkiOlsxXX0sIm8iOnsieCI6WzAuMzMzXSwieSI6WzBdfSwidCI6MCwicyI6WzBdfSx7InQiOjIyLjgsInMiOlsxMDBdfV19LCJvIjp7ImEiOjAsImsiOjB9LCJtIjoxfV0sImlwIjowLCJvcCI6NDgwLCJzdCI6MH0seyJpbmQiOjUsInR5Ijo0LCJubSI6IkMiLCJzciI6MSwia3MiOnsibyI6eyJhIjowLCJrIjoxMDB9LCJyIjp7ImEiOjAsImsiOjB9LCJwIjp7ImEiOjAsImsiOls0NDEuMTgsNDQ0LjEyLDBdfSwiYSI6eyJhIjowLCJrIjpbLTU0LjUzMSwyNy40NjksMF19LCJzIjp7ImsiOlt7ImkiOnsieCI6WzAsMCwwLjY2N10sInkiOlsxLDEsMV19LCJvIjp7IngiOlswLjMzMywwLjMzMywwLjMzM10sInkiOlswLDAsMF19LCJ0IjowLCJzIjpbMCwwLDEwMF19LHsidCI6MzAuNCwicyI6WzIwOC40OTcsMjA4LjQ5NywxMDBdfV0sImEiOjF9fSwic2hhcGVzIjpbeyJ0eSI6ImdyIiwibm0iOiJFIiwiaXQiOlt7InR5IjoiZWwiLCJubSI6IkUiLCJkIjoxLCJwIjp7ImEiOjAsImsiOlswLDBdfSwicyI6eyJhIjowLCJrIjpbMjYyLjkzOCwyNjIuOTM4XX19LHsidHkiOiJmbCIsIm5tIjoiRiIsImMiOnsiYSI6MCwiayI6WzAuMDc4LDAuNDYzLDAuNzIyLDFdfSwibyI6eyJhIjowLCJrIjoxMDB9LCJyIjoxfSx7InR5IjoidHIiLCJvIjp7ImEiOjAsImsiOjEwMH0sInIiOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6Wy01NC41MzEsMjcuNDY5XX0sImEiOnsiYSI6MCwiayI6WzAsMF19LCJzIjp7ImEiOjAsImsiOlsxMDAsMTAwXX0sIm5tIjoiVCIsInNrIjp7ImEiOjAsImsiOjB9LCJzYSI6eyJhIjowLCJrIjowfX1dfV0sImlwIjowLCJvcCI6NDgwLCJzdCI6MH1dLCJtYXJrZXJzIjpbXX0=", iG = (e) => /* @__PURE__ */ v.jsx(Hf, { ...e, src: rG }), aG = "data:application/json;base64,eyJubSI6IlMiLCJoIjoxMDAsInciOjEwMCwibWV0YSI6eyJnIjoiQGxvdHRpZWZpbGVzL3Rvb2xraXQtanMgMC4zMy4yIn0sImxheWVycyI6W3sidHkiOjQsIm5tIjoicyIsInNyIjoxLCJzdCI6MCwib3AiOjYwLCJpcCI6MCwiaGFzTWFzayI6ZmFsc2UsImFvIjowLCJrcyI6eyJhIjp7ImEiOjAsImsiOlsxNjAsMjg0LDBdfSwicyI6eyJhIjowLCJrIjpbMTAwLDEwMCwxMDBdfSwic2siOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6WzUwLDUwLDBdfSwiciI6eyJhIjowLCJrIjowfSwic2EiOnsiYSI6MCwiayI6MH0sIm8iOnsiYSI6MCwiayI6MTAwfX0sImVmIjpbXSwic2hhcGVzIjpbeyJ0eSI6ImdyIiwibm0iOiJHIiwiaXQiOlt7InR5Ijoic2giLCJubSI6IlAiLCJkIjoxLCJrcyI6eyJhIjowLCJrIjp7ImMiOnRydWUsImkiOltbMCwxOS44ODJdLFsxOS44ODIsMF0sWzAsLTE5Ljg4Ml0sWy0xOS44ODIsMF1dLCJvIjpbWzAsLTE5Ljg4Ml0sWy0xOS44ODIsMF0sWzAsMTkuODgyXSxbMTkuODgyLDBdXSwidiI6W1szNiwwXSxbMCwtMzZdLFstMzYsMF0sWzAsMzZdXX19fSx7InR5IjoidG0iLCJubSI6IlQiLCJlIjp7ImEiOjEsImsiOlt7Im8iOnsieCI6MC4zMzMsInkiOjB9LCJpIjp7IngiOjAuODMzLCJ5IjowLjgzM30sInMiOlsxMDBdLCJ0IjoyMH0seyJzIjpbMV0sInQiOjYwfV19LCJvIjp7ImEiOjAsImsiOjB9LCJzIjp7ImEiOjEsImsiOlt7Im8iOnsieCI6MC4xNjcsInkiOjAuMTY3fSwiaSI6eyJ4IjowLjY2NywieSI6MX0sInMiOlsxMDBdLCJ0IjowfSx7Im8iOnsieCI6MC4xNjcsInkiOjB9LCJpIjp7IngiOjAuODMzLCJ5IjoxfSwicyI6WzBdLCJ0IjoyOX0seyJzIjpbMF0sInQiOjUxfV19LCJtIjoxfSx7InR5Ijoic3QiLCJubSI6IlMiLCJsYyI6MiwibGoiOjEsIm1sIjoxMCwibyI6eyJhIjowLCJrIjoxMDB9LCJ3Ijp7ImEiOjAsImsiOjEwfSwiYyI6eyJhIjowLCJrIjpbMC4wNzgsMC40NjMsMC43MjJdfX0seyJ0eSI6InRyIiwiYSI6eyJhIjowLCJrIjpbMCwwXX0sInMiOnsiYSI6MCwiayI6WzEwMCwxMDBdfSwic2siOnsiYSI6MCwiayI6MH0sInAiOnsiYSI6MCwiayI6WzE2MCwyODRdfSwiciI6eyJhIjoxLCJrIjpbeyJvIjp7IngiOjAuMTY3LCJ5IjowLjE2N30sImkiOnsieCI6MC42NjcsInkiOjF9LCJzIjpbLTkwXSwidCI6MH0seyJzIjpbMjcwXSwidCI6NTl9XX0sInNhIjp7ImEiOjAsImsiOjB9LCJvIjp7ImEiOjAsImsiOjEwMH19XX1dLCJpbmQiOjF9XSwidiI6IjUuMS44IiwiZnIiOjI5Ljk3LCJvcCI6NjAsImlwIjowLCJhc3NldHMiOltdfQ==", oG = (e) => /* @__PURE__ */ v.jsx(Hf, { ...e, src: aG }), sG = "data:application/json;base64,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", Qe1 = (e) => /* @__PURE__ */ v.jsx(Hf, { ...e, src: sG }), lG = "data:application/json;base64,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", Xe1 = (e) => /* @__PURE__ */ v.jsx(Hf, { ...e, src: lG }), nT = {
  position: "absolute",
  top: "0%"
}, uG = {
  ...nT,
  transform: "scale(1.3)",
  top: "2%",
  left: "1%"
}, cG = q1(qe)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[200],
  width: "75px",
  height: "75px",
  transform: "translate(75px, -150px)"
})), gG = q1(qe)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[200],
  borderRadius: "100%",
  width: "150px",
  height: "150px"
})), Ge1 = ({
  delay: e = 3e3,
  finalDelay: n = 2e3,
  progressCaptions: i = [
    "Fetching data...",
    "Processing response...",
    "Wrapping up..."
  ],
  progressTitle: a = "We are preparing your data",
  isLoading: s,
  successTitle: g = "Your data is ready",
  successCaption: c = "All set and ready to go",
  onShouldVanish: I = () => {
  }
}) => {
  const [h, m] = gt(0), [w, x] = gt(!1);
  if (pf(() => {
    const O = setInterval(() => {
      h < i.length - 1 && m((k) => k + 1);
    }, e);
    return () => {
      clearInterval(O);
    };
  }, [e, i, h]), pf(() => {
    if (!s) {
      const O = setTimeout(() => {
        I(), x(!0);
      }, n);
      return () => clearTimeout(O);
    }
  }, [n, I, s]), w)
    return null;
  const M = s ? a : g;
  return /* @__PURE__ */ v.jsxs(
    qe,
    {
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      role: "progressbar",
      "aria-valuetext": "title",
      "aria-valuemin": s ? 0 : 100,
      children: [
        /* @__PURE__ */ v.jsxs(_1, { position: "relative", height: "150px", children: [
          /* @__PURE__ */ v.jsx(gG, {}),
          /* @__PURE__ */ v.jsx(cG, {}),
          s ? /* @__PURE__ */ v.jsx(oG, { autoplay: !0, loop: !0, style: nT }) : /* @__PURE__ */ v.jsx(iG, { autoplay: !0, style: uG })
        ] }),
        /* @__PURE__ */ v.jsx(le, { variant: "h5", p: 2, textAlign: "center", children: M }),
        /* @__PURE__ */ v.jsx(le, { textAlign: "center", children: s ? i[h] : c })
      ]
    }
  );
}, fG = q1(pS)(({ theme: e }) => ({
  position: "fixed",
  top: 0,
  "html.native-android &": {
    top: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))"
  },
  left: 0,
  right: 0,
  zIndex: e.zIndex.appBar + 1
}));
function qe1({ open: e, ...n }) {
  return e ? /* @__PURE__ */ v.jsx(fG, { ...n }) : null;
}
const Rx = q1(Jj)(({ theme: e }) => ({
  ...e.typography.body1,
  margin: "0px 10px",
  color: e.palette.primary.main,
  width: "32px",
  height: "32px",
  padding: 0,
  "&.Mui-disabled": {
    color: e.palette.common.neutrals[500]
  },
  "&.MuiPaginationItem-previousNext": {
    width: "32px",
    height: "32px",
    padding: 0
  },
  "&.Mui-selected": {
    "&:hover": {
      color: e.palette.primary.main[500]
    },
    backgroundColor: e.palette.primary.main,
    color: e.palette.common.neutrals[100]
  }
})), XC = q1(qe)(() => ({
  borderRadius: "4px",
  width: "32px",
  height: "32px",
  justifyContent: "center",
  alignItems: "center"
}));
function dG({
  sx: e,
  page: n,
  count: i,
  onChange: a,
  ...s
}) {
  const [g, c] = nn.useState(String(n || 1));
  nn.useEffect(() => {
    c(String(n || 1));
  }, [n]);
  const I = (m) => {
    const w = typeof i == "number" && i > 0 ? i : 1;
    return Number.isNaN(m) ? n || 1 : Math.min(Math.max(m, 1), w);
  }, h = (m) => {
    const w = I(parseInt(m, 10));
    w && w !== n && typeof a == "function" && a(null, w);
  };
  return /* @__PURE__ */ v.jsxs(qe, { direction: "row", alignItems: "center", justifyContent: "center", sx: e, children: [
    /* @__PURE__ */ v.jsx(
      Eb,
      {
        sx: {
          "&:ul": {
            height: "32px",
            "&:li": {
              height: "32px"
            }
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        shape: "rounded",
        showFirstButton: !0,
        showLastButton: !0,
        siblingCount: 0,
        boundaryCount: 0,
        page: n,
        count: i,
        onChange: a,
        renderItem: (m) => m.type === "page" || m.type === "next" || m.type === "last" || m.type === "start-ellipsis" || m.type === "end-ellipsis" ? /* @__PURE__ */ v.jsx("span", {}) : /* @__PURE__ */ v.jsx(
          Rx,
          {
            slots: {
              previous: () => /* @__PURE__ */ v.jsx(XC, { children: /* @__PURE__ */ v.jsx(De, { icon: "chevronLeft" }) }),
              next: () => /* @__PURE__ */ v.jsx(XC, { children: /* @__PURE__ */ v.jsx(De, { icon: "chevronRight" }) })
            },
            ...m
          }
        ),
        ...s
      }
    ),
    /* @__PURE__ */ v.jsxs(qe, { direction: "row", alignItems: "center", ml: 2, gap: 1, children: [
      /* @__PURE__ */ v.jsx(le, { color: (m) => m.palette.common.neutrals[500], children: "Page" }),
      /* @__PURE__ */ v.jsx(
        Mf,
        {
          value: g,
          onChange: (m) => {
            const w = m.target.value.replace(/[^0-9]/g, "");
            c(w);
          },
          onBlur: () => h(g),
          onKeyDown: (m) => {
            m.key === "Enter" && h(g);
          },
          inputProps: {
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: { textAlign: "center" }
          },
          sx: {
            width: 72,
            "& .MuiInputBase-root": { height: 52 }
          }
        }
      ),
      /* @__PURE__ */ v.jsx(le, { color: (m) => m.palette.common.neutrals[500], children: `of ${i || 1}` })
    ] }),
    /* @__PURE__ */ v.jsx(
      Eb,
      {
        sx: {
          "&:ul": {
            height: "32px",
            "&:li": {
              height: "32px"
            }
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        shape: "rounded",
        showFirstButton: !0,
        showLastButton: !0,
        siblingCount: 0,
        boundaryCount: 0,
        page: n,
        count: i,
        onChange: a,
        renderItem: (m) => m.type === "page" || m.type === "previous" || m.type === "first" || m.type === "start-ellipsis" || m.type === "end-ellipsis" ? /* @__PURE__ */ v.jsx("span", {}) : /* @__PURE__ */ v.jsx(
          Rx,
          {
            slots: {
              previous: () => /* @__PURE__ */ v.jsx(XC, { children: /* @__PURE__ */ v.jsx(De, { icon: "chevronLeft" }) }),
              next: () => /* @__PURE__ */ v.jsx(XC, { children: /* @__PURE__ */ v.jsx(De, { icon: "chevronRight" }) })
            },
            ...m
          }
        )
      }
    )
  ] });
}
const CG = q1(UA)({
  pointerEvents: "none"
}), AG = q1(UA)({
  pointerEvents: "none",
  "& .MuiPopover-paper": {
    pointerEvents: "auto"
  }
}), Ox = q1(_1)(({ theme: e }) => ({
  minWidth: 280,
  padding: e.spacing(2)
})), IG = ({
  children: e,
  variant: n = "default",
  ...i
}) => n === "entityPreview" ? /* @__PURE__ */ v.jsx(CG, { ...i, children: /* @__PURE__ */ v.jsx(Ox, { children: e }) }) : n === "interactiveEntityPreview" ? /* @__PURE__ */ v.jsx(
  AG,
  {
    ...i,
    disableAutoFocus: !0,
    disableEnforceFocus: !0,
    disableScrollLock: !0,
    children: /* @__PURE__ */ v.jsx(Ox, { children: e })
  }
) : /* @__PURE__ */ v.jsx(UA, { ...i, children: e }), Ze1 = ({
  SmallView: e = null,
  LargeView: n = null,
  ExtraLargeView: i = null,
  fallbackComponent: a = /* @__PURE__ */ v.jsx(_M, { open: !0 })
}) => {
  const s = r6(), g = Gb(s.breakpoints.up("md")), c = Gb(s.breakpoints.up("lg")), I = V2(() => g && !c ? n : c ? i || n : e, [g, c, n, i, e]);
  return /* @__PURE__ */ v.jsx(nn.Suspense, { fallback: a, children: I });
};
function $e1({
  sx: e,
  onChange: n = () => {
  },
  debounceTime: i = 500,
  ...a
}) {
  const s = ka(), g = V2(
    () => Yj(n, i),
    [n, i]
  );
  return /* @__PURE__ */ v.jsx(
    Mf,
    {
      placeholder: "Search",
      sx: {
        marginRight: "48px",
        ".MuiOutlinedInput-notchedOutline": {
          border: 0
        },
        ...e
      },
      InputProps: {
        sx: {
          background: s.palette.common.neutrals[100],
          borderRadius: "24px",
          paddingLeft: "12px"
        },
        endAdornment: /* @__PURE__ */ v.jsx(Vh, { position: "start", children: /* @__PURE__ */ v.jsx(
          De,
          {
            icon: "search",
            sx: { color: s.palette.common.neutrals[300] }
          }
        ) })
      },
      onChange: g,
      ...a
    }
  );
}
const b7 = { marginRight: "10px" };
function et1({ isPdf: e, isImage: n }) {
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    e && /* @__PURE__ */ v.jsx(De, { icon: "filePdf", sx: b7 }),
    n && /* @__PURE__ */ v.jsx(De, { icon: "fileImage", sx: b7 }),
    !e && !n && /* @__PURE__ */ v.jsx(De, { icon: "file", sx: b7 })
  ] });
}
function tt1({
  label: e,
  onClick: n,
  sortDirection: i,
  variant: a = "standalone"
}) {
  const s = a === "inherit", g = i === "asc" ? "sortDown" : i ? "sortUp" : null;
  return /* @__PURE__ */ v.jsx(
    Kh,
    {
      type: "button",
      disableRipple: !0,
      onClick: n,
      sx: {
        justifyContent: "flex-start",
        gap: s ? 0.5 : 0,
        maxWidth: "100%",
        borderRadius: 0.5,
        // A native button resets these; the label belongs to its header cell.
        font: "inherit",
        letterSpacing: "inherit",
        textTransform: "inherit",
        "&.Mui-focusVisible": {
          outline: (c) => `2px solid ${c.palette.primary.main}`,
          outlineOffset: 2
        },
        ...s ? {
          color: "inherit",
          "&:hover": { color: "text.primary" }
        } : {
          width: "100%",
          color: i ? "text.primary" : "text.secondary"
        }
      },
      children: s ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(
          _1,
          {
            component: "span",
            sx: {
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: e
          }
        ),
        /* @__PURE__ */ v.jsx(
          _1,
          {
            component: "span",
            "aria-hidden": !0,
            sx: {
              color: "secondary.main",
              visibility: i ? "visible" : "hidden"
            },
            children: i === "asc" ? "↑" : "↓"
          }
        )
      ] }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(le, { variant: "body2", children: e }),
        /* @__PURE__ */ v.jsx(De, { icon: g ?? "sort" })
      ] })
    }
  );
}
const jm = /* @__PURE__ */ o1.createContext();
process.env.NODE_ENV !== "production" && (jm.displayName = "TableContext");
function pG(e) {
  return lr("MuiTable", e);
}
y2("MuiTable", ["root", "stickyHeader"]);
const hG = ["className", "component", "padding", "size", "stickyHeader"], mG = (e) => {
  const {
    classes: n,
    stickyHeader: i
  } = e;
  return Qr({
    root: ["root", i && "stickyHeader"]
  }, pG, n);
}, vG = kn("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.stickyHeader && n.stickyHeader];
  }
})(({
  theme: e,
  ownerState: n
}) => k1({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": k1({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, n.stickyHeader && {
  borderCollapse: "separate"
})), Dx = "table", rT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTable"
  }), {
    className: s,
    component: g = Dx,
    padding: c = "normal",
    size: I = "medium",
    stickyHeader: h = !1
  } = a, m = Dt(a, hG), w = k1({}, a, {
    component: g,
    padding: c,
    size: I,
    stickyHeader: h
  }), x = mG(w), M = o1.useMemo(() => ({
    padding: c,
    size: I,
    stickyHeader: h
  }), [c, I, h]);
  return /* @__PURE__ */ v.jsx(jm.Provider, {
    value: M,
    children: /* @__PURE__ */ v.jsx(vG, k1({
      as: g,
      role: g === Dx ? null : "table",
      ref: i,
      className: tn(x.root, s),
      ownerState: w
    }, m))
  });
});
process.env.NODE_ENV !== "production" && (rT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: E.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: E.oneOfType([E.oneOf(["medium", "small"]), E.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const Uf = /* @__PURE__ */ o1.createContext();
process.env.NODE_ENV !== "production" && (Uf.displayName = "Tablelvl2Context");
function yG(e) {
  return lr("MuiTableBody", e);
}
y2("MuiTableBody", ["root"]);
const bG = ["className", "component"], wG = (e) => {
  const {
    classes: n
  } = e;
  return Qr({
    root: ["root"]
  }, yG, n);
}, xG = kn("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "table-row-group"
}), SG = {
  variant: "body"
}, kx = "tbody", iT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableBody"
  }), {
    className: s,
    component: g = kx
  } = a, c = Dt(a, bG), I = k1({}, a, {
    component: g
  }), h = wG(I);
  return /* @__PURE__ */ v.jsx(Uf.Provider, {
    value: SG,
    children: /* @__PURE__ */ v.jsx(xG, k1({
      className: tn(h.root, s),
      as: g,
      ref: i,
      role: g === kx ? null : "rowgroup",
      ownerState: I
    }, c))
  });
});
process.env.NODE_ENV !== "production" && (iT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function EG() {
  return {
    accessor: (e, n) => typeof e == "function" ? {
      ...n,
      accessorFn: e
    } : {
      ...n,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Jo(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function k3(e, n) {
  return (i) => {
    n.setState((a) => ({
      ...a,
      [e]: Jo(i, a[e])
    }));
  };
}
function I6(e) {
  return e instanceof Function;
}
function MG(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function at(e, n, i) {
  let a = [], s;
  return (g) => {
    let c;
    i.key && i.debug && (c = Date.now());
    const I = e(g);
    if (!(I.length !== a.length || I.some((w, x) => a[x] !== w)))
      return s;
    a = I;
    let m;
    if (i.key && i.debug && (m = Date.now()), s = n(...I), i == null || i.onChange == null || i.onChange(s), i.key && i.debug && i != null && i.debug()) {
      const w = Math.round((Date.now() - c) * 100) / 100, x = Math.round((Date.now() - m) * 100) / 100, M = x / 16, O = (k, z) => {
        for (k = String(k); k.length < z; )
          k = " " + k;
        return k;
      };
      console.info(`%c⏱ ${O(x, 5)} /${O(w, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * M, 120))}deg 100% 31%);`, i == null ? void 0 : i.key);
    }
    return s;
  };
}
function ot(e, n, i, a) {
  return {
    debug: () => {
      var s;
      return (s = e == null ? void 0 : e.debugAll) != null ? s : e[n];
    },
    key: process.env.NODE_ENV === "development" && i,
    onChange: a
  };
}
function TG(e, n, i, a) {
  var s, g;
  const I = {
    ...e._getDefaultColumnDef(),
    ...n
  }, h = I.accessorKey;
  let m = (s = (g = I.id) != null ? g : h ? typeof String.prototype.replaceAll == "function" ? h.replaceAll(".", "_") : h.replace(/\./g, "_") : void 0) != null ? s : typeof I.header == "string" ? I.header : void 0, w;
  if (I.accessorFn ? w = I.accessorFn : h && (h.includes(".") ? w = (M) => {
    let O = M;
    for (const z of h.split(".")) {
      var k;
      O = (k = O) == null ? void 0 : k[z], process.env.NODE_ENV !== "production" && O === void 0 && console.warn(`"${z}" in deeply nested key "${h}" returned undefined.`);
    }
    return O;
  } : w = (M) => M[I.accessorKey]), !m)
    throw process.env.NODE_ENV !== "production" ? new Error(I.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let x = {
    id: `${String(m)}`,
    accessorFn: w,
    parent: a,
    depth: i,
    columnDef: I,
    columns: [],
    getFlatColumns: at(() => [!0], () => {
      var M;
      return [x, ...(M = x.columns) == null ? void 0 : M.flatMap((O) => O.getFlatColumns())];
    }, ot(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: at(() => [e._getOrderColumnsFn()], (M) => {
      var O;
      if ((O = x.columns) != null && O.length) {
        let k = x.columns.flatMap((z) => z.getLeafColumns());
        return M(k);
      }
      return [x];
    }, ot(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const M of e._features)
    M.createColumn == null || M.createColumn(x, e);
  return x;
}
const Rr = "debugHeaders";
function jx(e, n, i) {
  var a;
  let g = {
    id: (a = i.id) != null ? a : n.id,
    column: n,
    index: i.index,
    isPlaceholder: !!i.isPlaceholder,
    placeholderId: i.placeholderId,
    depth: i.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const c = [], I = (h) => {
        h.subHeaders && h.subHeaders.length && h.subHeaders.map(I), c.push(h);
      };
      return I(g), c;
    },
    getContext: () => ({
      table: e,
      header: g,
      column: n
    })
  };
  return e._features.forEach((c) => {
    c.createHeader == null || c.createHeader(g, e);
  }), g;
}
const LG = {
  createTable: (e) => {
    e.getHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, i, a, s) => {
      var g, c;
      const I = (g = a == null ? void 0 : a.map((x) => i.find((M) => M.id === x)).filter(Boolean)) != null ? g : [], h = (c = s == null ? void 0 : s.map((x) => i.find((M) => M.id === x)).filter(Boolean)) != null ? c : [], m = i.filter((x) => !(a != null && a.includes(x.id)) && !(s != null && s.includes(x.id)));
      return GC(n, [...I, ...m, ...h], e);
    }, ot(e.options, Rr, "getHeaderGroups")), e.getCenterHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, i, a, s) => (i = i.filter((g) => !(a != null && a.includes(g.id)) && !(s != null && s.includes(g.id))), GC(n, i, e, "center")), ot(e.options, Rr, "getCenterHeaderGroups")), e.getLeftHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, i, a) => {
      var s;
      const g = (s = a == null ? void 0 : a.map((c) => i.find((I) => I.id === c)).filter(Boolean)) != null ? s : [];
      return GC(n, g, e, "left");
    }, ot(e.options, Rr, "getLeftHeaderGroups")), e.getRightHeaderGroups = at(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, i, a) => {
      var s;
      const g = (s = a == null ? void 0 : a.map((c) => i.find((I) => I.id === c)).filter(Boolean)) != null ? s : [];
      return GC(n, g, e, "right");
    }, ot(e.options, Rr, "getRightHeaderGroups")), e.getFooterGroups = at(() => [e.getHeaderGroups()], (n) => [...n].reverse(), ot(e.options, Rr, "getFooterGroups")), e.getLeftFooterGroups = at(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), ot(e.options, Rr, "getLeftFooterGroups")), e.getCenterFooterGroups = at(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), ot(e.options, Rr, "getCenterFooterGroups")), e.getRightFooterGroups = at(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), ot(e.options, Rr, "getRightFooterGroups")), e.getFlatHeaders = at(() => [e.getHeaderGroups()], (n) => n.map((i) => i.headers).flat(), ot(e.options, Rr, "getFlatHeaders")), e.getLeftFlatHeaders = at(() => [e.getLeftHeaderGroups()], (n) => n.map((i) => i.headers).flat(), ot(e.options, Rr, "getLeftFlatHeaders")), e.getCenterFlatHeaders = at(() => [e.getCenterHeaderGroups()], (n) => n.map((i) => i.headers).flat(), ot(e.options, Rr, "getCenterFlatHeaders")), e.getRightFlatHeaders = at(() => [e.getRightHeaderGroups()], (n) => n.map((i) => i.headers).flat(), ot(e.options, Rr, "getRightFlatHeaders")), e.getCenterLeafHeaders = at(() => [e.getCenterFlatHeaders()], (n) => n.filter((i) => {
      var a;
      return !((a = i.subHeaders) != null && a.length);
    }), ot(e.options, Rr, "getCenterLeafHeaders")), e.getLeftLeafHeaders = at(() => [e.getLeftFlatHeaders()], (n) => n.filter((i) => {
      var a;
      return !((a = i.subHeaders) != null && a.length);
    }), ot(e.options, Rr, "getLeftLeafHeaders")), e.getRightLeafHeaders = at(() => [e.getRightFlatHeaders()], (n) => n.filter((i) => {
      var a;
      return !((a = i.subHeaders) != null && a.length);
    }), ot(e.options, Rr, "getRightLeafHeaders")), e.getLeafHeaders = at(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, i, a) => {
      var s, g, c, I, h, m;
      return [...(s = (g = n[0]) == null ? void 0 : g.headers) != null ? s : [], ...(c = (I = i[0]) == null ? void 0 : I.headers) != null ? c : [], ...(h = (m = a[0]) == null ? void 0 : m.headers) != null ? h : []].map((w) => w.getLeafHeaders()).flat();
    }, ot(e.options, Rr, "getLeafHeaders"));
  }
};
function GC(e, n, i, a) {
  var s, g;
  let c = 0;
  const I = function(M, O) {
    O === void 0 && (O = 1), c = Math.max(c, O), M.filter((k) => k.getIsVisible()).forEach((k) => {
      var z;
      (z = k.columns) != null && z.length && I(k.columns, O + 1);
    }, 0);
  };
  I(e);
  let h = [];
  const m = (M, O) => {
    const k = {
      depth: O,
      id: [a, `${O}`].filter(Boolean).join("_"),
      headers: []
    }, z = [];
    M.forEach((N) => {
      const U = [...z].reverse()[0], Q = N.column.depth === k.depth;
      let _, X = !1;
      if (Q && N.column.parent ? _ = N.column.parent : (_ = N.column, X = !0), U && (U == null ? void 0 : U.column) === _)
        U.subHeaders.push(N);
      else {
        const B = jx(i, _, {
          id: [a, O, _.id, N == null ? void 0 : N.id].filter(Boolean).join("_"),
          isPlaceholder: X,
          placeholderId: X ? `${z.filter((Z) => Z.column === _).length}` : void 0,
          depth: O,
          index: z.length
        });
        B.subHeaders.push(N), z.push(B);
      }
      k.headers.push(N), N.headerGroup = k;
    }), h.push(k), O > 0 && m(z, O - 1);
  }, w = n.map((M, O) => jx(i, M, {
    depth: c,
    index: O
  }));
  m(w, c - 1), h.reverse();
  const x = (M) => M.filter((k) => k.column.getIsVisible()).map((k) => {
    let z = 0, N = 0, U = [0];
    k.subHeaders && k.subHeaders.length ? (U = [], x(k.subHeaders).forEach((_) => {
      let {
        colSpan: X,
        rowSpan: B
      } = _;
      z += X, U.push(B);
    })) : z = 1;
    const Q = Math.min(...U);
    return N = N + Q, k.colSpan = z, k.rowSpan = N, {
      colSpan: z,
      rowSpan: N
    };
  });
  return x((s = (g = h[0]) == null ? void 0 : g.headers) != null ? s : []), h;
}
const RG = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, aT = (e, n, i) => {
  var a, s;
  const g = i == null || (a = i.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((s = e.getValue(n)) == null || (s = s.toString()) == null || (s = s.toLowerCase()) == null) && s.includes(g));
};
aT.autoRemove = (e) => Wi(e);
const oT = (e, n, i) => {
  var a;
  return !!(!((a = e.getValue(n)) == null || (a = a.toString()) == null) && a.includes(i));
};
oT.autoRemove = (e) => Wi(e);
const sT = (e, n, i) => {
  var a;
  return ((a = e.getValue(n)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === (i == null ? void 0 : i.toLowerCase());
};
sT.autoRemove = (e) => Wi(e);
const lT = (e, n, i) => {
  var a;
  return (a = e.getValue(n)) == null ? void 0 : a.includes(i);
};
lT.autoRemove = (e) => Wi(e) || !(e != null && e.length);
const uT = (e, n, i) => !i.some((a) => {
  var s;
  return !((s = e.getValue(n)) != null && s.includes(a));
});
uT.autoRemove = (e) => Wi(e) || !(e != null && e.length);
const cT = (e, n, i) => i.some((a) => {
  var s;
  return (s = e.getValue(n)) == null ? void 0 : s.includes(a);
});
cT.autoRemove = (e) => Wi(e) || !(e != null && e.length);
const gT = (e, n, i) => e.getValue(n) === i;
gT.autoRemove = (e) => Wi(e);
const fT = (e, n, i) => e.getValue(n) == i;
fT.autoRemove = (e) => Wi(e);
const zm = (e, n, i) => {
  let [a, s] = i;
  const g = e.getValue(n);
  return g >= a && g <= s;
};
zm.resolveFilterValue = (e) => {
  let [n, i] = e, a = typeof n != "number" ? parseFloat(n) : n, s = typeof i != "number" ? parseFloat(i) : i, g = n === null || Number.isNaN(a) ? -1 / 0 : a, c = i === null || Number.isNaN(s) ? 1 / 0 : s;
  if (g > c) {
    const I = g;
    g = c, c = I;
  }
  return [g, c];
};
zm.autoRemove = (e) => Wi(e) || Wi(e[0]) && Wi(e[1]);
const Ma = {
  includesString: aT,
  includesStringSensitive: oT,
  equalsString: sT,
  arrIncludes: lT,
  arrIncludesAll: uT,
  arrIncludesSome: cT,
  equals: gT,
  weakEquals: fT,
  inNumberRange: zm
};
function Wi(e) {
  return e == null || e === "";
}
const OG = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: k3("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const i = n.getCoreRowModel().flatRows[0], a = i == null ? void 0 : i.getValue(e.id);
      return typeof a == "string" ? Ma.includesString : typeof a == "number" ? Ma.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? Ma.equals : Array.isArray(a) ? Ma.arrIncludes : Ma.weakEquals;
    }, e.getFilterFn = () => {
      var i, a;
      return I6(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (i = (a = n.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? i : Ma[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var i, a, s;
      return ((i = e.columnDef.enableColumnFilter) != null ? i : !0) && ((a = n.options.enableColumnFilters) != null ? a : !0) && ((s = n.options.enableFilters) != null ? s : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var i;
      return (i = n.getState().columnFilters) == null || (i = i.find((a) => a.id === e.id)) == null ? void 0 : i.value;
    }, e.getFilterIndex = () => {
      var i, a;
      return (i = (a = n.getState().columnFilters) == null ? void 0 : a.findIndex((s) => s.id === e.id)) != null ? i : -1;
    }, e.setFilterValue = (i) => {
      n.setColumnFilters((a) => {
        const s = e.getFilterFn(), g = a == null ? void 0 : a.find((w) => w.id === e.id), c = Jo(i, g ? g.value : void 0);
        if (zx(s, c, e)) {
          var I;
          return (I = a == null ? void 0 : a.filter((w) => w.id !== e.id)) != null ? I : [];
        }
        const h = {
          id: e.id,
          value: c
        };
        if (g) {
          var m;
          return (m = a == null ? void 0 : a.map((w) => w.id === e.id ? h : w)) != null ? m : [];
        }
        return a != null && a.length ? [...a, h] : [h];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const i = e.getAllLeafColumns(), a = (s) => {
        var g;
        return (g = Jo(n, s)) == null ? void 0 : g.filter((c) => {
          const I = i.find((h) => h.id === c.id);
          if (I) {
            const h = I.getFilterFn();
            if (zx(h, c.value, I))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (n) => {
      var i, a;
      e.setColumnFilters(n ? [] : (i = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? i : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function zx(e, n, i) {
  return (e && e.autoRemove ? e.autoRemove(n, i) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const DG = (e, n, i) => i.reduce((a, s) => {
  const g = s.getValue(e);
  return a + (typeof g == "number" ? g : 0);
}, 0), kG = (e, n, i) => {
  let a;
  return i.forEach((s) => {
    const g = s.getValue(e);
    g != null && (a > g || a === void 0 && g >= g) && (a = g);
  }), a;
}, jG = (e, n, i) => {
  let a;
  return i.forEach((s) => {
    const g = s.getValue(e);
    g != null && (a < g || a === void 0 && g >= g) && (a = g);
  }), a;
}, zG = (e, n, i) => {
  let a, s;
  return i.forEach((g) => {
    const c = g.getValue(e);
    c != null && (a === void 0 ? c >= c && (a = s = c) : (a > c && (a = c), s < c && (s = c)));
  }), [a, s];
}, NG = (e, n) => {
  let i = 0, a = 0;
  if (n.forEach((s) => {
    let g = s.getValue(e);
    g != null && (g = +g) >= g && (++i, a += g);
  }), i) return a / i;
}, PG = (e, n) => {
  if (!n.length)
    return;
  const i = n.map((g) => g.getValue(e));
  if (!MG(i))
    return;
  if (i.length === 1)
    return i[0];
  const a = Math.floor(i.length / 2), s = i.sort((g, c) => g - c);
  return i.length % 2 !== 0 ? s[a] : (s[a - 1] + s[a]) / 2;
}, FG = (e, n) => Array.from(new Set(n.map((i) => i.getValue(e))).values()), BG = (e, n) => new Set(n.map((i) => i.getValue(e))).size, HG = (e, n) => n.length, w7 = {
  sum: DG,
  min: kG,
  max: jG,
  extent: zG,
  mean: NG,
  median: PG,
  unique: FG,
  uniqueCount: BG,
  count: HG
}, UG = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, i;
      return (n = (i = e.getValue()) == null || i.toString == null ? void 0 : i.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: k3("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((i) => i != null && i.includes(e.id) ? i.filter((a) => a !== e.id) : [...i ?? [], e.id]);
    }, e.getCanGroup = () => {
      var i, a;
      return ((i = e.columnDef.enableGrouping) != null ? i : !0) && ((a = n.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var i;
      return (i = n.getState().grouping) == null ? void 0 : i.includes(e.id);
    }, e.getGroupedIndex = () => {
      var i;
      return (i = n.getState().grouping) == null ? void 0 : i.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const i = e.getCanGroup();
      return () => {
        i && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const i = n.getCoreRowModel().flatRows[0], a = i == null ? void 0 : i.getValue(e.id);
      if (typeof a == "number")
        return w7.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return w7.extent;
    }, e.getAggregationFn = () => {
      var i, a;
      if (!e)
        throw new Error();
      return I6(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (i = (a = n.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? i : w7[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var i, a;
      e.setGrouping(n ? [] : (i = (a = e.initialState) == null ? void 0 : a.grouping) != null ? i : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (i) => {
      if (e._groupingValuesCache.hasOwnProperty(i))
        return e._groupingValuesCache[i];
      const a = n.getColumn(i);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[i] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[i]) : e.getValue(i);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, i, a) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === i.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var s;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((s = i.subRows) != null && s.length);
    };
  }
};
function WG(e, n, i) {
  if (!(n != null && n.length) || !i)
    return e;
  const a = e.filter((g) => !n.includes(g.id));
  return i === "remove" ? a : [...n.map((g) => e.find((c) => c.id === g)).filter(Boolean), ...a];
}
const _G = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: k3("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = at((i) => [Af(n, i)], (i) => i.findIndex((a) => a.id === e.id), ot(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (i) => {
      var a;
      return ((a = Af(n, i)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (i) => {
      var a;
      const s = Af(n, i);
      return ((a = s[s.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var i;
      e.setColumnOrder(n ? [] : (i = e.initialState.columnOrder) != null ? i : []);
    }, e._getOrderColumnsFn = at(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, i, a) => (s) => {
      let g = [];
      if (!(n != null && n.length))
        g = s;
      else {
        const c = [...n], I = [...s];
        for (; I.length && c.length; ) {
          const h = c.shift(), m = I.findIndex((w) => w.id === h);
          m > -1 && g.push(I.splice(m, 1)[0]);
        }
        g = [...g, ...I];
      }
      return WG(g, i, a);
    }, ot(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, x7 = () => ({
  left: [],
  right: []
}), VG = {
  getInitialState: (e) => ({
    columnPinning: x7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: k3("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (i) => {
      const a = e.getLeafColumns().map((s) => s.id).filter(Boolean);
      n.setColumnPinning((s) => {
        var g, c;
        if (i === "right") {
          var I, h;
          return {
            left: ((I = s == null ? void 0 : s.left) != null ? I : []).filter((x) => !(a != null && a.includes(x))),
            right: [...((h = s == null ? void 0 : s.right) != null ? h : []).filter((x) => !(a != null && a.includes(x))), ...a]
          };
        }
        if (i === "left") {
          var m, w;
          return {
            left: [...((m = s == null ? void 0 : s.left) != null ? m : []).filter((x) => !(a != null && a.includes(x))), ...a],
            right: ((w = s == null ? void 0 : s.right) != null ? w : []).filter((x) => !(a != null && a.includes(x)))
          };
        }
        return {
          left: ((g = s == null ? void 0 : s.left) != null ? g : []).filter((x) => !(a != null && a.includes(x))),
          right: ((c = s == null ? void 0 : s.right) != null ? c : []).filter((x) => !(a != null && a.includes(x)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var s, g, c;
      return ((s = a.columnDef.enablePinning) != null ? s : !0) && ((g = (c = n.options.enableColumnPinning) != null ? c : n.options.enablePinning) != null ? g : !0);
    }), e.getIsPinned = () => {
      const i = e.getLeafColumns().map((I) => I.id), {
        left: a,
        right: s
      } = n.getState().columnPinning, g = i.some((I) => a == null ? void 0 : a.includes(I)), c = i.some((I) => s == null ? void 0 : s.includes(I));
      return g ? "left" : c ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var i, a;
      const s = e.getIsPinned();
      return s ? (i = (a = n.getState().columnPinning) == null || (a = a[s]) == null ? void 0 : a.indexOf(e.id)) != null ? i : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = at(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (i, a, s) => {
      const g = [...a ?? [], ...s ?? []];
      return i.filter((c) => !g.includes(c.column.id));
    }, ot(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = at(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (i, a) => (a ?? []).map((g) => i.find((c) => c.column.id === g)).filter(Boolean).map((g) => ({
      ...g,
      position: "left"
    })), ot(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = at(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (i, a) => (a ?? []).map((g) => i.find((c) => c.column.id === g)).filter(Boolean).map((g) => ({
      ...g,
      position: "right"
    })), ot(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var i, a;
      return e.setColumnPinning(n ? x7() : (i = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? i : x7());
    }, e.getIsSomeColumnsPinned = (n) => {
      var i;
      const a = e.getState().columnPinning;
      if (!n) {
        var s, g;
        return !!((s = a.left) != null && s.length || (g = a.right) != null && g.length);
      }
      return !!((i = a[n]) != null && i.length);
    }, e.getLeftLeafColumns = at(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, i) => (i ?? []).map((a) => n.find((s) => s.id === a)).filter(Boolean), ot(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = at(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, i) => (i ?? []).map((a) => n.find((s) => s.id === a)).filter(Boolean), ot(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = at(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, i, a) => {
      const s = [...i ?? [], ...a ?? []];
      return n.filter((g) => !s.includes(g.id));
    }, ot(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, qC = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, S7 = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), KG = {
  getDefaultColumnDef: () => qC,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: S7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: k3("columnSizing", e),
    onColumnSizingInfoChange: k3("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var i, a, s;
      const g = n.getState().columnSizing[e.id];
      return Math.min(Math.max((i = e.columnDef.minSize) != null ? i : qC.minSize, (a = g ?? e.columnDef.size) != null ? a : qC.size), (s = e.columnDef.maxSize) != null ? s : qC.maxSize);
    }, e.getStart = at((i) => [i, Af(n, i), n.getState().columnSizing], (i, a) => a.slice(0, e.getIndex(i)).reduce((s, g) => s + g.getSize(), 0), ot(n.options, "debugColumns", "getStart")), e.getAfter = at((i) => [i, Af(n, i), n.getState().columnSizing], (i, a) => a.slice(e.getIndex(i) + 1).reduce((s, g) => s + g.getSize(), 0), ot(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((i) => {
        let {
          [e.id]: a,
          ...s
        } = i;
        return s;
      });
    }, e.getCanResize = () => {
      var i, a;
      return ((i = e.columnDef.enableResizing) != null ? i : !0) && ((a = n.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let i = 0;
      const a = (s) => {
        if (s.subHeaders.length)
          s.subHeaders.forEach(a);
        else {
          var g;
          i += (g = s.column.getSize()) != null ? g : 0;
        }
      };
      return a(e), i;
    }, e.getStart = () => {
      if (e.index > 0) {
        const i = e.headerGroup.headers[e.index - 1];
        return i.getStart() + i.getSize();
      }
      return 0;
    }, e.getResizeHandler = (i) => {
      const a = n.getColumn(e.column.id), s = a == null ? void 0 : a.getCanResize();
      return (g) => {
        if (!a || !s || (g.persist == null || g.persist(), E7(g) && g.touches && g.touches.length > 1))
          return;
        const c = e.getSize(), I = e ? e.getLeafHeaders().map((U) => [U.column.id, U.column.getSize()]) : [[a.id, a.getSize()]], h = E7(g) ? Math.round(g.touches[0].clientX) : g.clientX, m = {}, w = (U, Q) => {
          typeof Q == "number" && (n.setColumnSizingInfo((_) => {
            var X, B;
            const Z = n.options.columnResizeDirection === "rtl" ? -1 : 1, Y = (Q - ((X = _ == null ? void 0 : _.startOffset) != null ? X : 0)) * Z, V = Math.max(Y / ((B = _ == null ? void 0 : _.startSize) != null ? B : 0), -0.999999);
            return _.columnSizingStart.forEach((J) => {
              let [e1, f1] = J;
              m[e1] = Math.round(Math.max(f1 + f1 * V, 0) * 100) / 100;
            }), {
              ..._,
              deltaOffset: Y,
              deltaPercentage: V
            };
          }), (n.options.columnResizeMode === "onChange" || U === "end") && n.setColumnSizing((_) => ({
            ..._,
            ...m
          })));
        }, x = (U) => w("move", U), M = (U) => {
          w("end", U), n.setColumnSizingInfo((Q) => ({
            ...Q,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, O = i || typeof document < "u" ? document : null, k = {
          moveHandler: (U) => x(U.clientX),
          upHandler: (U) => {
            O == null || O.removeEventListener("mousemove", k.moveHandler), O == null || O.removeEventListener("mouseup", k.upHandler), M(U.clientX);
          }
        }, z = {
          moveHandler: (U) => (U.cancelable && (U.preventDefault(), U.stopPropagation()), x(U.touches[0].clientX), !1),
          upHandler: (U) => {
            var Q;
            O == null || O.removeEventListener("touchmove", z.moveHandler), O == null || O.removeEventListener("touchend", z.upHandler), U.cancelable && (U.preventDefault(), U.stopPropagation()), M((Q = U.touches[0]) == null ? void 0 : Q.clientX);
          }
        }, N = JG() ? {
          passive: !1
        } : !1;
        E7(g) ? (O == null || O.addEventListener("touchmove", z.moveHandler, N), O == null || O.addEventListener("touchend", z.upHandler, N)) : (O == null || O.addEventListener("mousemove", k.moveHandler, N), O == null || O.addEventListener("mouseup", k.upHandler, N)), n.setColumnSizingInfo((U) => ({
          ...U,
          startOffset: h,
          startSize: c,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: I,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var i;
      e.setColumnSizing(n ? {} : (i = e.initialState.columnSizing) != null ? i : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var i;
      e.setColumnSizingInfo(n ? S7() : (i = e.initialState.columnSizingInfo) != null ? i : S7());
    }, e.getTotalSize = () => {
      var n, i;
      return (n = (i = e.getHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, i;
      return (n = (i = e.getLeftHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, i;
      return (n = (i = e.getCenterHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, i;
      return (n = (i = e.getRightHeaderGroups()[0]) == null ? void 0 : i.headers.reduce((a, s) => a + s.getSize(), 0)) != null ? n : 0;
    };
  }
};
let ZC = null;
function JG() {
  if (typeof ZC == "boolean") return ZC;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, i = () => {
    };
    window.addEventListener("test", i, n), window.removeEventListener("test", i);
  } catch {
    e = !1;
  }
  return ZC = e, ZC;
}
function E7(e) {
  return e.type === "touchstart";
}
const YG = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: k3("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (i) => {
      e.getCanHide() && n.setColumnVisibility((a) => ({
        ...a,
        [e.id]: i ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var i, a;
      const s = e.columns;
      return (i = s.length ? s.some((g) => g.getIsVisible()) : (a = n.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? i : !0;
    }, e.getCanHide = () => {
      var i, a;
      return ((i = e.columnDef.enableHiding) != null ? i : !0) && ((a = n.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (i) => {
      e.toggleVisibility == null || e.toggleVisibility(i.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = at(() => [e.getAllCells(), n.getState().columnVisibility], (i) => i.filter((a) => a.column.getIsVisible()), ot(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = at(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (i, a, s) => [...i, ...a, ...s], ot(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (i, a) => at(() => [a(), a().filter((s) => s.getIsVisible()).map((s) => s.id).join("_")], (s) => s.filter((g) => g.getIsVisible == null ? void 0 : g.getIsVisible()), ot(e.options, "debugColumns", i));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (i) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(i), e.resetColumnVisibility = (i) => {
      var a;
      e.setColumnVisibility(i ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (i) => {
      var a;
      i = (a = i) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((s, g) => ({
        ...s,
        [g.id]: i || !(g.getCanHide != null && g.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((i) => !(i.getIsVisible != null && i.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (i) => {
      var a;
      e.toggleAllColumnsVisible((a = i.target) == null ? void 0 : a.checked);
    };
  }
};
function Af(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const QG = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, XG = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: k3("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var i;
      const a = (i = e.getCoreRowModel().flatRows[0]) == null || (i = i._getAllCellsByColumnId()[n.id]) == null ? void 0 : i.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var i, a, s, g;
      return ((i = e.columnDef.enableGlobalFilter) != null ? i : !0) && ((a = n.options.enableGlobalFilter) != null ? a : !0) && ((s = n.options.enableFilters) != null ? s : !0) && ((g = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? g : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Ma.includesString, e.getGlobalFilterFn = () => {
      var n, i;
      const {
        globalFilterFn: a
      } = e.options;
      return I6(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (n = (i = e.options.filterFns) == null ? void 0 : i[a]) != null ? n : Ma[a];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, GG = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: k3("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, i = !1;
    e._autoResetExpanded = () => {
      var a, s;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (s = e.options.autoResetAll) != null ? s : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (i) return;
        i = !0, e._queue(() => {
          e.resetExpanded(), i = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var s, g;
      e.setExpanded(a ? {} : (s = (g = e.initialState) == null ? void 0 : g.expanded) != null ? s : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((s) => !s.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((g) => {
        const c = g.split(".");
        a = Math.max(a, c.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (i) => {
      n.setExpanded((a) => {
        var s;
        const g = a === !0 ? !0 : !!(a != null && a[e.id]);
        let c = {};
        if (a === !0 ? Object.keys(n.getRowModel().rowsById).forEach((I) => {
          c[I] = !0;
        }) : c = a, i = (s = i) != null ? s : !g, !g && i)
          return {
            ...c,
            [e.id]: !0
          };
        if (g && !i) {
          const {
            [e.id]: I,
            ...h
          } = c;
          return h;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var i;
      const a = n.getState().expanded;
      return !!((i = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? i : a === !0 || a != null && a[e.id]);
    }, e.getCanExpand = () => {
      var i, a, s;
      return (i = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? i : ((a = n.options.enableExpanding) != null ? a : !0) && !!((s = e.subRows) != null && s.length);
    }, e.getIsAllParentsExpanded = () => {
      let i = !0, a = e;
      for (; i && a.parentId; )
        a = n.getRow(a.parentId, !0), i = a.getIsExpanded();
      return i;
    }, e.getToggleExpandedHandler = () => {
      const i = e.getCanExpand();
      return () => {
        i && e.toggleExpanded();
      };
    };
  }
}, Dh = 0, kh = 10, M7 = () => ({
  pageIndex: Dh,
  pageSize: kh
}), qG = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...M7(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: k3("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, i = !1;
    e._autoResetPageIndex = () => {
      var a, s;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (s = e.options.autoResetAll) != null ? s : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (i) return;
        i = !0, e._queue(() => {
          e.resetPageIndex(), i = !1;
        });
      }
    }, e.setPagination = (a) => {
      const s = (g) => Jo(a, g);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(s);
    }, e.resetPagination = (a) => {
      var s;
      e.setPagination(a ? M7() : (s = e.initialState.pagination) != null ? s : M7());
    }, e.setPageIndex = (a) => {
      e.setPagination((s) => {
        let g = Jo(a, s.pageIndex);
        const c = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return g = Math.max(0, Math.min(g, c)), {
          ...s,
          pageIndex: g
        };
      });
    }, e.resetPageIndex = (a) => {
      var s, g;
      e.setPageIndex(a ? Dh : (s = (g = e.initialState) == null || (g = g.pagination) == null ? void 0 : g.pageIndex) != null ? s : Dh);
    }, e.resetPageSize = (a) => {
      var s, g;
      e.setPageSize(a ? kh : (s = (g = e.initialState) == null || (g = g.pagination) == null ? void 0 : g.pageSize) != null ? s : kh);
    }, e.setPageSize = (a) => {
      e.setPagination((s) => {
        const g = Math.max(1, Jo(a, s.pageSize)), c = s.pageSize * s.pageIndex, I = Math.floor(c / g);
        return {
          ...s,
          pageIndex: I,
          pageSize: g
        };
      });
    }, e.setPageCount = (a) => e.setPagination((s) => {
      var g;
      let c = Jo(a, (g = e.options.pageCount) != null ? g : -1);
      return typeof c == "number" && (c = Math.max(-1, c)), {
        ...s,
        pageCount: c
      };
    }), e.getPageOptions = at(() => [e.getPageCount()], (a) => {
      let s = [];
      return a && a > 0 && (s = [...new Array(a)].fill(null).map((g, c) => c)), s;
    }, ot(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, s = e.getPageCount();
      return s === -1 ? !0 : s === 0 ? !1 : a < s - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, T7 = () => ({
  top: [],
  bottom: []
}), ZG = {
  getInitialState: (e) => ({
    rowPinning: T7(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: k3("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (i, a, s) => {
      const g = a ? e.getLeafRows().map((h) => {
        let {
          id: m
        } = h;
        return m;
      }) : [], c = s ? e.getParentRows().map((h) => {
        let {
          id: m
        } = h;
        return m;
      }) : [], I = /* @__PURE__ */ new Set([...c, e.id, ...g]);
      n.setRowPinning((h) => {
        var m, w;
        if (i === "bottom") {
          var x, M;
          return {
            top: ((x = h == null ? void 0 : h.top) != null ? x : []).filter((z) => !(I != null && I.has(z))),
            bottom: [...((M = h == null ? void 0 : h.bottom) != null ? M : []).filter((z) => !(I != null && I.has(z))), ...Array.from(I)]
          };
        }
        if (i === "top") {
          var O, k;
          return {
            top: [...((O = h == null ? void 0 : h.top) != null ? O : []).filter((z) => !(I != null && I.has(z))), ...Array.from(I)],
            bottom: ((k = h == null ? void 0 : h.bottom) != null ? k : []).filter((z) => !(I != null && I.has(z)))
          };
        }
        return {
          top: ((m = h == null ? void 0 : h.top) != null ? m : []).filter((z) => !(I != null && I.has(z))),
          bottom: ((w = h == null ? void 0 : h.bottom) != null ? w : []).filter((z) => !(I != null && I.has(z)))
        };
      });
    }, e.getCanPin = () => {
      var i;
      const {
        enableRowPinning: a,
        enablePinning: s
      } = n.options;
      return typeof a == "function" ? a(e) : (i = a ?? s) != null ? i : !0;
    }, e.getIsPinned = () => {
      const i = [e.id], {
        top: a,
        bottom: s
      } = n.getState().rowPinning, g = i.some((I) => a == null ? void 0 : a.includes(I)), c = i.some((I) => s == null ? void 0 : s.includes(I));
      return g ? "top" : c ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var i, a;
      const s = e.getIsPinned();
      if (!s) return -1;
      const g = (i = s === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : i.map((c) => {
        let {
          id: I
        } = c;
        return I;
      });
      return (a = g == null ? void 0 : g.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var i, a;
      return e.setRowPinning(n ? T7() : (i = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? i : T7());
    }, e.getIsSomeRowsPinned = (n) => {
      var i;
      const a = e.getState().rowPinning;
      if (!n) {
        var s, g;
        return !!((s = a.top) != null && s.length || (g = a.bottom) != null && g.length);
      }
      return !!((i = a[n]) != null && i.length);
    }, e._getPinnedRows = (n, i, a) => {
      var s;
      return ((s = e.options.keepPinnedRows) == null || s ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (i ?? []).map((c) => {
          const I = e.getRow(c, !0);
          return I.getIsAllParentsExpanded() ? I : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (i ?? []).map((c) => n.find((I) => I.id === c))
      )).filter(Boolean).map((c) => ({
        ...c,
        position: a
      }));
    }, e.getTopRows = at(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, i) => e._getPinnedRows(n, i, "top"), ot(e.options, "debugRows", "getTopRows")), e.getBottomRows = at(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, i) => e._getPinnedRows(n, i, "bottom"), ot(e.options, "debugRows", "getBottomRows")), e.getCenterRows = at(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, i, a) => {
      const s = /* @__PURE__ */ new Set([...i ?? [], ...a ?? []]);
      return n.filter((g) => !s.has(g.id));
    }, ot(e.options, "debugRows", "getCenterRows"));
  }
}, $G = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: k3("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var i;
      return e.setRowSelection(n ? {} : (i = e.initialState.rowSelection) != null ? i : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((i) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const a = {
          ...i
        }, s = e.getPreGroupedRowModel().flatRows;
        return n ? s.forEach((g) => {
          g.getCanSelect() && (a[g.id] = !0);
        }) : s.forEach((g) => {
          delete a[g.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((i) => {
      const a = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), s = {
        ...i
      };
      return e.getRowModel().rows.forEach((g) => {
        jh(s, g.id, a, !0, e);
      }), s;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = at(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, i) => Object.keys(n).length ? L7(e, i) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ot(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = at(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, i) => Object.keys(n).length ? L7(e, i) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ot(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = at(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, i) => Object.keys(n).length ? L7(e, i) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ot(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: i
      } = e.getState();
      let a = !!(n.length && Object.keys(i).length);
      return a && n.some((s) => s.getCanSelect() && !i[s.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((s) => s.getCanSelect()), {
        rowSelection: i
      } = e.getState();
      let a = !!n.length;
      return a && n.some((s) => !i[s.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const i = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return i > 0 && i < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((i) => i.getCanSelect()).some((i) => i.getIsSelected() || i.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (i, a) => {
      const s = e.getIsSelected();
      n.setRowSelection((g) => {
        var c;
        if (i = typeof i < "u" ? i : !s, e.getCanSelect() && s === i)
          return g;
        const I = {
          ...g
        };
        return jh(I, e.id, i, (c = a == null ? void 0 : a.selectChildren) != null ? c : !0, n), I;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: i
      } = n.getState();
      return Nm(e, i);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: i
      } = n.getState();
      return zh(e, i) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: i
      } = n.getState();
      return zh(e, i) === "all";
    }, e.getCanSelect = () => {
      var i;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (i = n.options.enableRowSelection) != null ? i : !0;
    }, e.getCanSelectSubRows = () => {
      var i;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (i = n.options.enableSubRowSelection) != null ? i : !0;
    }, e.getCanMultiSelect = () => {
      var i;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (i = n.options.enableMultiRowSelection) != null ? i : !0;
    }, e.getToggleSelectedHandler = () => {
      const i = e.getCanSelect();
      return (a) => {
        var s;
        i && e.toggleSelected((s = a.target) == null ? void 0 : s.checked);
      };
    };
  }
}, jh = (e, n, i, a, s) => {
  var g;
  const c = s.getRow(n, !0);
  i ? (c.getCanMultiSelect() || Object.keys(e).forEach((I) => delete e[I]), c.getCanSelect() && (e[n] = !0)) : delete e[n], a && (g = c.subRows) != null && g.length && c.getCanSelectSubRows() && c.subRows.forEach((I) => jh(e, I.id, i, a, s));
};
function L7(e, n) {
  const i = e.getState().rowSelection, a = [], s = {}, g = function(c, I) {
    return c.map((h) => {
      var m;
      const w = Nm(h, i);
      if (w && (a.push(h), s[h.id] = h), (m = h.subRows) != null && m.length && (h = {
        ...h,
        subRows: g(h.subRows)
      }), w)
        return h;
    }).filter(Boolean);
  };
  return {
    rows: g(n.rows),
    flatRows: a,
    rowsById: s
  };
}
function Nm(e, n) {
  var i;
  return (i = n[e.id]) != null ? i : !1;
}
function zh(e, n, i) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let s = !0, g = !1;
  return e.subRows.forEach((c) => {
    if (!(g && !s) && (c.getCanSelect() && (Nm(c, n) ? g = !0 : s = !1), c.subRows && c.subRows.length)) {
      const I = zh(c, n);
      I === "all" ? g = !0 : (I === "some" && (g = !0), s = !1);
    }
  }), s ? "all" : g ? "some" : !1;
}
const Nh = /([0-9]+)/gm, eq = (e, n, i) => dT(Go(e.getValue(i)).toLowerCase(), Go(n.getValue(i)).toLowerCase()), tq = (e, n, i) => dT(Go(e.getValue(i)), Go(n.getValue(i))), nq = (e, n, i) => Pm(Go(e.getValue(i)).toLowerCase(), Go(n.getValue(i)).toLowerCase()), rq = (e, n, i) => Pm(Go(e.getValue(i)), Go(n.getValue(i))), iq = (e, n, i) => {
  const a = e.getValue(i), s = n.getValue(i);
  return a > s ? 1 : a < s ? -1 : 0;
}, aq = (e, n, i) => Pm(e.getValue(i), n.getValue(i));
function Pm(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Go(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function dT(e, n) {
  const i = e.split(Nh).filter(Boolean), a = n.split(Nh).filter(Boolean);
  for (; i.length && a.length; ) {
    const s = i.shift(), g = a.shift(), c = parseInt(s, 10), I = parseInt(g, 10), h = [c, I].sort();
    if (isNaN(h[0])) {
      if (s > g)
        return 1;
      if (g > s)
        return -1;
      continue;
    }
    if (isNaN(h[1]))
      return isNaN(c) ? -1 : 1;
    if (c > I)
      return 1;
    if (I > c)
      return -1;
  }
  return i.length - a.length;
}
const tf = {
  alphanumeric: eq,
  alphanumericCaseSensitive: tq,
  text: nq,
  textCaseSensitive: rq,
  datetime: iq,
  basic: aq
}, oq = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: k3("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const i = n.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const s of i) {
        const g = s == null ? void 0 : s.getValue(e.id);
        if (Object.prototype.toString.call(g) === "[object Date]")
          return tf.datetime;
        if (typeof g == "string" && (a = !0, g.split(Nh).length > 1))
          return tf.alphanumeric;
      }
      return a ? tf.text : tf.basic;
    }, e.getAutoSortDir = () => {
      const i = n.getFilteredRowModel().flatRows[0];
      return typeof (i == null ? void 0 : i.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var i, a;
      if (!e)
        throw new Error();
      return I6(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (i = (a = n.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? i : tf[e.columnDef.sortingFn];
    }, e.toggleSorting = (i, a) => {
      const s = e.getNextSortingOrder(), g = typeof i < "u" && i !== null;
      n.setSorting((c) => {
        const I = c == null ? void 0 : c.find((O) => O.id === e.id), h = c == null ? void 0 : c.findIndex((O) => O.id === e.id);
        let m = [], w, x = g ? i : s === "desc";
        if (c != null && c.length && e.getCanMultiSort() && a ? I ? w = "toggle" : w = "add" : c != null && c.length && h !== c.length - 1 ? w = "replace" : I ? w = "toggle" : w = "replace", w === "toggle" && (g || s || (w = "remove")), w === "add") {
          var M;
          m = [...c, {
            id: e.id,
            desc: x
          }], m.splice(0, m.length - ((M = n.options.maxMultiSortColCount) != null ? M : Number.MAX_SAFE_INTEGER));
        } else w === "toggle" ? m = c.map((O) => O.id === e.id ? {
          ...O,
          desc: x
        } : O) : w === "remove" ? m = c.filter((O) => O.id !== e.id) : m = [{
          id: e.id,
          desc: x
        }];
        return m;
      });
    }, e.getFirstSortDir = () => {
      var i, a;
      return ((i = (a = e.columnDef.sortDescFirst) != null ? a : n.options.sortDescFirst) != null ? i : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (i) => {
      var a, s;
      const g = e.getFirstSortDir(), c = e.getIsSorted();
      return c ? c !== g && ((a = n.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(i && (s = n.options.enableMultiRemove) != null) || s) ? !1 : c === "desc" ? "asc" : "desc" : g;
    }, e.getCanSort = () => {
      var i, a;
      return ((i = e.columnDef.enableSorting) != null ? i : !0) && ((a = n.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var i, a;
      return (i = (a = e.columnDef.enableMultiSort) != null ? a : n.options.enableMultiSort) != null ? i : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var i;
      const a = (i = n.getState().sorting) == null ? void 0 : i.find((s) => s.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var i, a;
      return (i = (a = n.getState().sorting) == null ? void 0 : a.findIndex((s) => s.id === e.id)) != null ? i : -1;
    }, e.clearSorting = () => {
      n.setSorting((i) => i != null && i.length ? i.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const i = e.getCanSort();
      return (a) => {
        i && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var i, a;
      e.setSorting(n ? [] : (i = (a = e.initialState) == null ? void 0 : a.sorting) != null ? i : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, sq = [
  LG,
  YG,
  _G,
  VG,
  RG,
  OG,
  QG,
  //depends on ColumnFaceting
  XG,
  //depends on ColumnFiltering
  oq,
  UG,
  //depends on RowSorting
  GG,
  qG,
  ZG,
  $G,
  KG
];
function lq(e) {
  var n, i;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...sq, ...(n = e._features) != null ? n : []];
  let s = {
    _features: a
  };
  const g = s._features.reduce((M, O) => Object.assign(M, O.getDefaultOptions == null ? void 0 : O.getDefaultOptions(s)), {}), c = (M) => s.options.mergeOptions ? s.options.mergeOptions(g, M) : {
    ...g,
    ...M
  };
  let h = {
    ...{},
    ...(i = e.initialState) != null ? i : {}
  };
  s._features.forEach((M) => {
    var O;
    h = (O = M.getInitialState == null ? void 0 : M.getInitialState(h)) != null ? O : h;
  });
  const m = [];
  let w = !1;
  const x = {
    _features: a,
    options: {
      ...g,
      ...e
    },
    initialState: h,
    _queue: (M) => {
      m.push(M), w || (w = !0, Promise.resolve().then(() => {
        for (; m.length; )
          m.shift()();
        w = !1;
      }).catch((O) => setTimeout(() => {
        throw O;
      })));
    },
    reset: () => {
      s.setState(s.initialState);
    },
    setOptions: (M) => {
      const O = Jo(M, s.options);
      s.options = c(O);
    },
    getState: () => s.options.state,
    setState: (M) => {
      s.options.onStateChange == null || s.options.onStateChange(M);
    },
    _getRowId: (M, O, k) => {
      var z;
      return (z = s.options.getRowId == null ? void 0 : s.options.getRowId(M, O, k)) != null ? z : `${k ? [k.id, O].join(".") : O}`;
    },
    getCoreRowModel: () => (s._getCoreRowModel || (s._getCoreRowModel = s.options.getCoreRowModel(s)), s._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => s.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (M, O) => {
      let k = (O ? s.getPrePaginationRowModel() : s.getRowModel()).rowsById[M];
      if (!k && (k = s.getCoreRowModel().rowsById[M], !k))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${M}`) : new Error();
      return k;
    },
    _getDefaultColumnDef: at(() => [s.options.defaultColumn], (M) => {
      var O;
      return M = (O = M) != null ? O : {}, {
        header: (k) => {
          const z = k.header.column.columnDef;
          return z.accessorKey ? z.accessorKey : z.accessorFn ? z.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (k) => {
          var z, N;
          return (z = (N = k.renderValue()) == null || N.toString == null ? void 0 : N.toString()) != null ? z : null;
        },
        ...s._features.reduce((k, z) => Object.assign(k, z.getDefaultColumnDef == null ? void 0 : z.getDefaultColumnDef()), {}),
        ...M
      };
    }, ot(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => s.options.columns,
    getAllColumns: at(() => [s._getColumnDefs()], (M) => {
      const O = function(k, z, N) {
        return N === void 0 && (N = 0), k.map((U) => {
          const Q = TG(s, U, N, z), _ = U;
          return Q.columns = _.columns ? O(_.columns, Q, N + 1) : [], Q;
        });
      };
      return O(M);
    }, ot(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: at(() => [s.getAllColumns()], (M) => M.flatMap((O) => O.getFlatColumns()), ot(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: at(() => [s.getAllFlatColumns()], (M) => M.reduce((O, k) => (O[k.id] = k, O), {}), ot(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: at(() => [s.getAllColumns(), s._getOrderColumnsFn()], (M, O) => {
      let k = M.flatMap((z) => z.getLeafColumns());
      return O(k);
    }, ot(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (M) => {
      const O = s._getAllFlatColumnsById()[M];
      return process.env.NODE_ENV !== "production" && !O && console.error(`[Table] Column with id '${M}' does not exist.`), O;
    }
  };
  Object.assign(s, x);
  for (let M = 0; M < s._features.length; M++) {
    const O = s._features[M];
    O == null || O.createTable == null || O.createTable(s);
  }
  return s;
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function CT(e, n) {
  return e ? uq(e) ? /* @__PURE__ */ o1.createElement(e, n) : e : null;
}
function uq(e) {
  return cq(e) || typeof e == "function" || gq(e);
}
function cq(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function gq(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function fq(e) {
  const n = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [i] = o1.useState(() => ({
    current: lq(n)
  })), [a, s] = o1.useState(() => i.current.initialState);
  return i.current.setOptions((g) => ({
    ...g,
    ...e,
    state: {
      ...a,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (c) => {
      s(c), e.onStateChange == null || e.onStateChange(c);
    }
  })), i.current;
}
function dq(e) {
  return lr("MuiTableRow", e);
}
const Nx = y2("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), Cq = ["className", "component", "hover", "selected"], Aq = (e) => {
  const {
    classes: n,
    selected: i,
    hover: a,
    head: s,
    footer: g
  } = e;
  return Qr({
    root: ["root", i && "selected", a && "hover", s && "head", g && "footer"]
  }, dq, n);
}, Iq = kn("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.head && n.head, i.footer && n.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${Nx.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Nx.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : oi(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : oi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), Px = "tr", Fm = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableRow"
  }), {
    className: s,
    component: g = Px,
    hover: c = !1,
    selected: I = !1
  } = a, h = Dt(a, Cq), m = o1.useContext(Uf), w = k1({}, a, {
    component: g,
    hover: c,
    selected: I,
    head: m && m.variant === "head",
    footer: m && m.variant === "footer"
  }), x = Aq(w);
  return /* @__PURE__ */ v.jsx(Iq, k1({
    as: g,
    ref: i,
    className: tn(x.root, s),
    role: g === Px ? null : "row",
    ownerState: w
  }, h));
});
process.env.NODE_ENV !== "production" && (Fm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: E.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
function pq(e) {
  return lr("MuiTableCell", e);
}
const hq = y2("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), mq = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], vq = (e) => {
  const {
    classes: n,
    variant: i,
    align: a,
    padding: s,
    size: g,
    stickyHeader: c
  } = e, I = {
    root: ["root", i, c && "stickyHeader", a !== "inherit" && `align${sr(a)}`, s !== "normal" && `padding${sr(s)}`, `size${sr(g)}`]
  };
  return Qr(I, pq, n);
}, yq = kn("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, n[i.variant], n[`size${sr(i.size)}`], i.padding !== "normal" && n[`padding${sr(i.padding)}`], i.align !== "inherit" && n[`align${sr(i.align)}`], i.stickyHeader && n.stickyHeader];
  }
})(({
  theme: e,
  ownerState: n
}) => k1({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? xE(oi(e.palette.divider, 1), 0.88) : wE(oi(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, n.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, n.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, n.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, n.size === "small" && {
  padding: "6px 16px",
  [`&.${hq.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, n.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, n.padding === "none" && {
  padding: 0
}, n.align === "left" && {
  textAlign: "left"
}, n.align === "center" && {
  textAlign: "center"
}, n.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, n.align === "justify" && {
  textAlign: "justify"
}, n.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), AT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableCell"
  }), {
    align: s = "inherit",
    className: g,
    component: c,
    padding: I,
    scope: h,
    size: m,
    sortDirection: w,
    variant: x
  } = a, M = Dt(a, mq), O = o1.useContext(jm), k = o1.useContext(Uf), z = k && k.variant === "head";
  let N;
  c ? N = c : N = z ? "th" : "td";
  let U = h;
  N === "td" ? U = void 0 : !U && z && (U = "col");
  const Q = x || k && k.variant, _ = k1({}, a, {
    align: s,
    component: N,
    padding: I || (O && O.padding ? O.padding : "normal"),
    size: m || (O && O.size ? O.size : "medium"),
    sortDirection: w,
    stickyHeader: Q === "head" && O && O.stickyHeader,
    variant: Q
  }), X = vq(_);
  let B = null;
  return w && (B = w === "asc" ? "ascending" : "descending"), /* @__PURE__ */ v.jsx(yq, k1({
    as: N,
    ref: i,
    className: tn(X.root, g),
    "aria-sort": B,
    scope: U,
    ownerState: _
  }, M));
});
process.env.NODE_ENV !== "production" && (AT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: E.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: E.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: E.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: E.oneOfType([E.oneOf(["medium", "small"]), E.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: E.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: E.oneOfType([E.oneOf(["body", "footer", "head"]), E.string])
});
function IT({ sx: e, ...n }) {
  return /* @__PURE__ */ v.jsx(
    AT,
    {
      padding: "none",
      sx: { padding: "16px 0px 16px 0px", ...e },
      ...n
    }
  );
}
const bq = q1(le)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
});
function wq({
  row: e,
  navigateTo: n,
  onClick: i,
  checkIsUnread: a,
  filterRows: s,
  dataTestRowPrefix: g = "table_row"
}) {
  const c = ka(), I = e.original, h = typeof a == "function" ? a(I) : !1;
  if (!(typeof s == "function" ? s(I) : !0))
    return null;
  const w = typeof n == "function" ? n(I) : n;
  return /* @__PURE__ */ TS(
    Fm,
    {
      component: w ? Yh : void 0,
      ...w ? { to: w } : {},
      sx: {
        borderBottom: `solid 1px ${c.palette.common.neutrals[200]}`,
        alignItems: "center",
        padding: "16px 0px 16px 0px",
        transition: ".2s ease-in-out",
        "&:hover": {
          cursor: typeof i == "function" ? "pointer" : "initial",
          borderTop: `solid 1px ${c.palette.common.neutrals[500]}`,
          boxShadow: "12.5px 12.5px 10px rgba(0, 0, 0, 0.035)"
        },
        textDecoration: "none"
      },
      key: e.id,
      "data-testid": `${g}_${e.id}`
    },
    e.getVisibleCells().map((x) => {
      const M = x.column.columnDef.cell, O = CT(M, x.getContext()), k = typeof M == "function" ? typeof M(x.getContext()) : "string", z = k === "string" || k === "number", N = String(x.id).includes(hT);
      return /* @__PURE__ */ v.jsx(
        IT,
        {
          sx: {
            width: `${x.column.getSize()}%`
          },
          onClick: typeof i == "function" && !N ? () => i(I) : () => {
          },
          children: z ? /* @__PURE__ */ v.jsx(
            bq,
            {
              sx: {
                fontWeight: h ? 600 : 400
              },
              children: O
            }
          ) : O
        },
        x.id
      );
    })
  );
}
function xq(e) {
  return lr("MuiTableHead", e);
}
y2("MuiTableHead", ["root"]);
const Sq = ["className", "component"], Eq = (e) => {
  const {
    classes: n
  } = e;
  return Qr({
    root: ["root"]
  }, xq, n);
}, Mq = kn("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({
  display: "table-header-group"
}), Tq = {
  variant: "head"
}, Fx = "thead", pT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTableHead"
  }), {
    className: s,
    component: g = Fx
  } = a, c = Dt(a, Sq), I = k1({}, a, {
    component: g
  }), h = Eq(I);
  return /* @__PURE__ */ v.jsx(Uf.Provider, {
    value: Tq,
    children: /* @__PURE__ */ v.jsx(Mq, k1({
      as: g,
      className: tn(h.root, s),
      ref: i,
      role: g === Fx ? null : "rowgroup",
      ownerState: I
    }, c))
  });
});
process.env.NODE_ENV !== "production" && (pT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const Lq = q1(pT)(({ theme: e }) => ({
  backgroundColor: e.palette.common.neutrals[50],
  color: e.palette.common.neutrals[500]
})), Rq = q1(le)(({ theme: e }) => ({
  fontWeight: 600,
  color: e.palette.text.secondary
}));
function Oq({ headerGroup: e }) {
  return /* @__PURE__ */ v.jsx(Lq, { children: /* @__PURE__ */ v.jsx(Fm, { children: e.headers.map((n) => /* @__PURE__ */ v.jsx(
    IT,
    {
      sx: {
        width: `${n.getSize()}%`
      },
      children: /* @__PURE__ */ v.jsx(Rq, { variant: "body2", children: CT(n.column.columnDef.header, n.getContext()) }, n.id)
    },
    n.id
  )) }) }, e.id);
}
const hT = "__row_checkbox", Dq = q1(iT)(({ theme: e }) => ({
  borderTop: `solid 1px ${e.palette.common.neutrals[200]}`
}));
function nt1({
  onRowClick: e,
  onRowSelect: n,
  selectedRows: i,
  checkIsUnread: a,
  filterRows: s,
  onPageChange: g,
  pageCount: c,
  enableRowSelect: I,
  isLoading: h,
  pageSize: m = 10,
  sx: w = {},
  page: x,
  navigateTo: M,
  data: O = [],
  dataTestRowPrefix: k,
  ...z
}) {
  var a1;
  const [N, U] = gt({}), [{ pageIndex: Q, pageSize: _ }, X] = gt({
    pageIndex: x && !Number.isNaN(x) && x - 1 || 0,
    pageSize: m
  }), B = V2(
    () => ({
      pageIndex: Q,
      pageSize: _
    }),
    [Q, _]
  ), Z = V2(
    () => N,
    [N]
  );
  function Y() {
    typeof g == "function" && g(Q + 1);
  }
  function V() {
    const d1 = Object.keys(N);
    I && typeof n == "function" ? n(d1) : I && console.error(
      "In StaticTable, onRowSelect is required if enableRowSelect is true."
    );
  }
  vn(Y, [B.pageIndex]), vn(V, [N]), vn(() => {
    typeof x == "number" && !Number.isNaN(x) && x !== Q + 1 && f1.setPageIndex(x - 1);
  }, [x]);
  let J = { ...z };
  const e1 = m2(
    (d1) => ({
      ...z,
      enableMultiRowSelection: !0,
      onRowSelectionChange: U,
      state: {
        rowSelection: Z
      },
      columns: [
        d1.display({
          id: hT,
          header: (S1) => /* @__PURE__ */ v.jsx(
            IA,
            {
              onChange: () => S1.table.toggleAllPageRowsSelected(),
              checked: S1.table.getIsAllPageRowsSelected()
            }
          ),
          cell: (S1) => /* @__PURE__ */ v.jsx(
            IA,
            {
              onChange: () => S1.row.toggleSelected(),
              checked: S1.row.getIsSelected()
            }
          ),
          minSize: 4,
          size: 4
        }),
        ...z.columns
      ]
    }),
    [z, Z]
  );
  if (I) {
    const d1 = EG();
    J = e1(d1);
  }
  const f1 = fq({
    getRowId: (d1) => String(d1.id),
    manualPagination: !0,
    manualSorting: !0,
    pageCount: c,
    ...J,
    state: {
      ...J.state,
      pagination: B
    },
    onPaginationChange: X,
    defaultColumn: {
      minSize: 0
    },
    data: O
  }), v1 = ((a1 = f1 == null ? void 0 : f1.getRowModel()) == null ? void 0 : a1.rows) || [];
  return /* @__PURE__ */ v.jsxs(qe, { children: [
    h ? /* @__PURE__ */ v.jsx(Rh, {}) : /* @__PURE__ */ v.jsxs(
      rT,
      {
        sx: {
          ...w,
          tableLayout: "fixed"
        },
        children: [
          f1.getHeaderGroups().map((d1) => /* @__PURE__ */ v.jsx(Oq, { headerGroup: d1 }, d1.id)),
          /* @__PURE__ */ v.jsx(Dq, { children: v1.map((d1) => /* @__PURE__ */ v.jsx(
            wq,
            {
              row: d1,
              navigateTo: M,
              onClick: e,
              checkIsUnread: a,
              filterRows: s,
              dataTestRowPrefix: k
            },
            d1.id
          )) })
        ]
      }
    ),
    !!(c && c > 1 && m) && /* @__PURE__ */ v.jsx(qe, { p: "20px", children: /* @__PURE__ */ v.jsx(
      dG,
      {
        onChange: (d1, S1) => f1.setPageIndex(S1 - 1),
        page: Number.isNaN(B.pageIndex) ? 1 : B.pageIndex + 1,
        count: c
      }
    ) })
  ] });
}
const kq = q1(_1)(({ theme: e }) => ({
  overflowX: "auto",
  width: "100%",
  padding: "20px",
  [e.breakpoints.down("md")]: {
    padding: "10px"
  }
})), jq = q1(Qj)(({ theme: e }) => ({
  [`& .${Jg.root}`]: {
    fontSize: "2.1rem",
    cursor: "pointer",
    color: e.palette.common.white,
    border: `2px solid ${e.palette.common.neutrals[400]}`,
    borderRadius: "50%",
    [`&.${Jg.active}`]: {
      border: `2px solid ${e.palette.common.primary[400]}`,
      fill: "none",
      [`& .${Jg.text}`]: {
        fill: e.palette.common.black
      }
    }
  },
  [`& .${Xj.root}`]: {
    minWidth: "60px",
    cursor: "pointer"
  },
  [`& .${_p.root}`]: {
    top: "1rem",
    [`& .${_p.line}`]: {
      borderColor: e.palette.common.neutrals[400]
    }
  },
  [`& .${Vp.completed}`]: {
    svg: {
      border: `2px solid ${e.palette.common.primary[400]}`,
      fill: e.palette.common.primary[50],
      text: {
        fill: e.palette.common.primary[400]
      }
    }
  },
  [`& .${_p.line}`]: {
    borderTopWidth: "2px"
  },
  [`& .${Jg.text}`]: {
    fill: e.palette.common.black
  },
  [`& .${Vp.label}`]: {
    marginTop: "8px",
    cursor: "pointer",
    color: e.palette.common.black,
    fontWeight: "normal",
    [`&.${Jg.active}`]: {
      color: e.palette.common.primary[500]
    },
    [`&.${Vp.alternativeLabel}`]: {
      textTransform: "none",
      fontSize: "1rem",
      color: e.palette.common.black,
      marginTop: "8px"
    }
  },
  [`& .${Gj.root}`]: {
    padding: "0",
    margin: "0"
  }
}));
function rt1({ activeStep: e, steps: n, onClick: i }) {
  const a = ka(), s = (g) => {
    n[g].disabled || i(g);
  };
  return /* @__PURE__ */ v.jsx(kq, { children: /* @__PURE__ */ v.jsx(jq, { activeStep: e, alternativeLabel: !0, children: n.map((g, c) => /* @__PURE__ */ v.jsx(
    qj,
    {
      disabled: g.disabled,
      "data-tour-id": g.tourTargetId,
      children: /* @__PURE__ */ v.jsx(
        Zj,
        {
          disabled: g.disabled,
          onClick: () => s(c),
          children: /* @__PURE__ */ v.jsx(
            $j,
            {
              icon: g.error ? /* @__PURE__ */ v.jsx(
                De,
                {
                  icon: "close",
                  sx: {
                    fontSize: "2.1rem",
                    background: a.palette.common.error[100],
                    borderRadius: "50%",
                    path: {
                      transform: "scale(0.7) translate(5px, 5px)"
                    },
                    border: `2px solid ${a.palette.common.error[400]}`,
                    fill: `${a.palette.common.error[400]}`
                  }
                }
              ) : c + 1,
              error: g.error,
              StepIconProps: {
                completed: !1,
                error: !1
              },
              children: g.label
            }
          )
        }
      )
    },
    g.label
  )) }) });
}
const it1 = ({
  isUnread: e,
  color: n
}) => {
  const i = ka(), a = n || i.palette.common.accent[500], s = e ? a : null;
  return /* @__PURE__ */ v.jsx(OX, { color: s });
}, zq = q1(ez)({ ml: 0 }), Nq = q1(tz)(({ theme: e }) => ({
  marginBottom: 4,
  color: e.palette.text.primary
})), Bm = ({
  children: e,
  label: n,
  error: i,
  labelProps: a = {},
  stacked: s = !1,
  ...g
}) => /* @__PURE__ */ v.jsxs(nz, { ...g, error: !!i, children: [
  s ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(Nq, { children: n }),
    e
  ] }) : /* @__PURE__ */ v.jsx(
    Jh,
    {
      labelPlacement: "top",
      ...a,
      control: e,
      label: n
    }
  ),
  i && i !== !0 && /* @__PURE__ */ v.jsx(zq, { "data-testid": "field-error", children: i })
] }), Wf = nn.forwardRef(
  ({ name: e, label: n, error: i, fullWidth: a = !0, ...s }, g) => /* @__PURE__ */ v.jsx(
    Bm,
    {
      name: e,
      label: n,
      error: i,
      fullWidth: a,
      children: /* @__PURE__ */ v.jsx(
        Mf,
        {
          ...s,
          ref: g,
          name: e,
          fullWidth: !0,
          error: !!i
        }
      )
    }
  )
), Pq = ({
  name: e,
  label: n,
  error: i,
  placeholder: a,
  options: s = [],
  renderInputProps: g,
  ...c
}) => {
  const I = Object.prototype.hasOwnProperty.call(
    g ?? {},
    "startAdornment"
  ), h = Object.prototype.hasOwnProperty.call(
    g ?? {},
    "endAdornment"
  );
  return /* @__PURE__ */ v.jsx(
    rz,
    {
      ...c,
      options: s,
      renderInput: (m) => /* @__PURE__ */ v.jsx(
        Wf,
        {
          ...m,
          name: e,
          placeholder: a,
          label: n,
          error: i,
          onKeyDown: g == null ? void 0 : g.onKeyDown,
          InputProps: {
            ...m.InputProps,
            ...I ? { startAdornment: g == null ? void 0 : g.startAdornment } : {},
            ...h ? { endAdornment: g == null ? void 0 : g.endAdornment } : {}
          }
        }
      )
    }
  );
}, at1 = ({
  name: e,
  control: n,
  required: i,
  validate: a,
  ...s
}) => {
  const {
    field: g,
    fieldState: { error: c }
  } = Qh({
    name: e || "",
    control: n,
    rules: { required: i, validate: a }
  });
  return /* @__PURE__ */ v.jsx(Pq, { ...g, error: c == null ? void 0 : c.type, ...s });
}, Fq = nn.forwardRef(({ name: e, label: n, error: i, labelPlacement: a = "end", ...s }, g) => /* @__PURE__ */ v.jsx(
  Bm,
  {
    name: e,
    label: n,
    error: i,
    labelProps: {
      labelPlacement: a,
      sx: { alignItems: "center" }
    },
    sx: { flexDirection: "row" },
    children: /* @__PURE__ */ v.jsx(IA, { ref: g, ...s })
  }
)), Bq = ({
  name: e,
  ...n
}) => {
  var g;
  const { field: i, fieldState: a } = Qh({ name: e }), s = (g = a.error) == null ? void 0 : g.message;
  return /* @__PURE__ */ v.jsx(
    Fq,
    {
      error: s,
      ...n,
      checked: !!i.value,
      onChange: (c, I) => i.onChange(I)
    }
  );
}, ot1 = ({
  label: e,
  items: n = [],
  disabled: i,
  direction: a = "row"
}) => /* @__PURE__ */ v.jsx(
  Jh,
  {
    labelPlacement: "top",
    label: e,
    disabled: i,
    control: /* @__PURE__ */ v.jsx(qe, { direction: a, gap: 2, flexWrap: "wrap", children: n.map(({ name: s, label: g }) => /* @__PURE__ */ v.jsx(
      Bq,
      {
        name: s,
        label: g,
        labelPlacement: "end",
        disabled: i
      },
      s
    )) })
  }
), st1 = ({ name: e, ...n }) => {
  var g, c;
  const { register: i, formState: a } = Lf(), s = (c = (g = a.errors) == null ? void 0 : g[e]) == null ? void 0 : c.message;
  return /* @__PURE__ */ v.jsx(
    Wf,
    {
      disabled: a.isSubmitting,
      ...n,
      ...i(e),
      error: s
    }
  );
}, Hq = nn.forwardRef(
  ({
    visible: e,
    onVisible: n,
    visibleIcon: i = /* @__PURE__ */ v.jsx(De, { icon: "hide" }),
    hiddenIcon: a = /* @__PURE__ */ v.jsx(De, { icon: "show" }),
    adornmentProps: s,
    ...g
  }, c) => {
    const [I, h] = gt(e || !1), m = e ?? I, w = m2(() => {
      n ? n(m) : h(!m);
    }, [m, n, h]);
    return /* @__PURE__ */ v.jsx(
      Wf,
      {
        ref: c,
        ...g,
        type: m ? "text" : "password",
        autoComplete: "off",
        InputProps: {
          endAdornment: /* @__PURE__ */ v.jsx(
            Vh,
            {
              style: {
                color: "inherit"
              },
              ...s || {},
              position: (s == null ? void 0 : s.position) || "end",
              children: /* @__PURE__ */ v.jsx(
                xc,
                {
                  "aria-label": "toggle password visibility",
                  onClick: w,
                  edge: "end",
                  color: "inherit",
                  title: m ? "Hide password" : "Show password",
                  children: m ? i : a
                }
              )
            }
          )
        }
      }
    );
  }
), lt1 = ({
  name: e,
  inputRef: n,
  ...i
}) => {
  var c, I;
  const { register: a, formState: s } = Lf(), g = (I = (c = s.errors) == null ? void 0 : c[e]) == null ? void 0 : I.message;
  return /* @__PURE__ */ v.jsx(
    Hq,
    {
      disabled: s.isSubmitting,
      error: g,
      inputRef: n,
      ...i,
      ...a(e)
    }
  );
};
var Ph = function() {
  return Ph = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, Ph.apply(this, arguments);
}, mT = {
  onActivate: F1.func,
  onAddUndo: F1.func,
  onBeforeAddUndo: F1.func,
  onBeforeExecCommand: F1.func,
  onBeforeGetContent: F1.func,
  onBeforeRenderUI: F1.func,
  onBeforeSetContent: F1.func,
  onBeforePaste: F1.func,
  onBlur: F1.func,
  onChange: F1.func,
  onClearUndos: F1.func,
  onClick: F1.func,
  onContextMenu: F1.func,
  onCommentChange: F1.func,
  onCopy: F1.func,
  onCut: F1.func,
  onDblclick: F1.func,
  onDeactivate: F1.func,
  onDirty: F1.func,
  onDrag: F1.func,
  onDragDrop: F1.func,
  onDragEnd: F1.func,
  onDragGesture: F1.func,
  onDragOver: F1.func,
  onDrop: F1.func,
  onExecCommand: F1.func,
  onFocus: F1.func,
  onFocusIn: F1.func,
  onFocusOut: F1.func,
  onGetContent: F1.func,
  onHide: F1.func,
  onInit: F1.func,
  onKeyDown: F1.func,
  onKeyPress: F1.func,
  onKeyUp: F1.func,
  onLoadContent: F1.func,
  onMouseDown: F1.func,
  onMouseEnter: F1.func,
  onMouseLeave: F1.func,
  onMouseMove: F1.func,
  onMouseOut: F1.func,
  onMouseOver: F1.func,
  onMouseUp: F1.func,
  onNodeChange: F1.func,
  onObjectResizeStart: F1.func,
  onObjectResized: F1.func,
  onObjectSelected: F1.func,
  onPaste: F1.func,
  onPostProcess: F1.func,
  onPostRender: F1.func,
  onPreProcess: F1.func,
  onProgressState: F1.func,
  onRedo: F1.func,
  onRemove: F1.func,
  onReset: F1.func,
  onSaveContent: F1.func,
  onSelectionChange: F1.func,
  onSetAttrib: F1.func,
  onSetContent: F1.func,
  onShow: F1.func,
  onSubmit: F1.func,
  onUndo: F1.func,
  onVisualAid: F1.func,
  onSkinLoadError: F1.func,
  onThemeLoadError: F1.func,
  onModelLoadError: F1.func,
  onPluginLoadError: F1.func,
  onIconsLoadError: F1.func,
  onLanguageLoadError: F1.func,
  onScriptsLoad: F1.func,
  onScriptsLoadError: F1.func
}, Uq = Ph({ apiKey: F1.string, id: F1.string, inline: F1.bool, init: F1.object, initialValue: F1.string, onEditorChange: F1.func, value: F1.string, tagName: F1.string, cloudChannel: F1.string, plugins: F1.oneOfType([F1.string, F1.array]), toolbar: F1.oneOfType([F1.string, F1.array]), disabled: F1.bool, textareaName: F1.string, tinymceScriptSrc: F1.oneOfType([
  F1.string,
  F1.arrayOf(F1.string),
  F1.arrayOf(F1.shape({
    src: F1.string,
    async: F1.bool,
    defer: F1.bool
  }))
]), rollback: F1.oneOfType([F1.number, F1.oneOf([!1])]), scriptLoading: F1.shape({
  async: F1.bool,
  defer: F1.bool,
  delay: F1.number
}) }, mT), R7 = function(e) {
  return typeof e == "function";
}, Bx = function(e) {
  return e in mT;
}, Hx = function(e) {
  return e.substr(2);
}, Wq = function(e, n, i, a, s, g, c) {
  var I = Object.keys(s).filter(Bx), h = Object.keys(g).filter(Bx), m = I.filter(function(x) {
    return g[x] === void 0;
  }), w = h.filter(function(x) {
    return s[x] === void 0;
  });
  m.forEach(function(x) {
    var M = Hx(x), O = c[M];
    i(M, O), delete c[M];
  }), w.forEach(function(x) {
    var M = a(e, x), O = Hx(x);
    c[O] = M, n(O, M);
  });
}, _q = function(e, n, i, a, s) {
  return Wq(
    s,
    e.on.bind(e),
    e.off.bind(e),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    function(g, c) {
      return function(I) {
        var h;
        return (h = g(c)) === null || h === void 0 ? void 0 : h(I, e);
      };
    },
    n,
    i,
    a
  );
}, Ux = 0, vT = function(e) {
  var n = Date.now(), i = Math.floor(Math.random() * 1e9);
  return Ux++, e + "_" + i + Ux + String(n);
}, Wx = function(e) {
  return e !== null && (e.tagName.toLowerCase() === "textarea" || e.tagName.toLowerCase() === "input");
}, _x = function(e) {
  return typeof e > "u" || e === "" ? [] : Array.isArray(e) ? e : e.split(" ");
}, Vq = function(e, n) {
  return _x(e).concat(_x(n));
}, Kq = function() {
  return window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}, Jq = function(e) {
  if (!("isConnected" in Node.prototype)) {
    for (var n = e, i = e.parentNode; i != null; )
      n = i, i = n.parentNode;
    return n === e.ownerDocument;
  }
  return e.isConnected;
}, Vx = function(e, n) {
  e !== void 0 && (e.mode != null && typeof e.mode == "object" && typeof e.mode.set == "function" ? e.mode.set(n) : e.setMode(n));
}, Fh = function() {
  return Fh = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, Fh.apply(this, arguments);
}, Yq = function(e, n, i) {
  var a, s, g = e.createElement("script");
  g.referrerPolicy = "origin", g.type = "application/javascript", g.id = n.id, g.src = n.src, g.async = (a = n.async) !== null && a !== void 0 ? a : !1, g.defer = (s = n.defer) !== null && s !== void 0 ? s : !1;
  var c = function() {
    g.removeEventListener("load", c), g.removeEventListener("error", I), i(n.src);
  }, I = function(h) {
    g.removeEventListener("load", c), g.removeEventListener("error", I), i(n.src, h);
  };
  g.addEventListener("load", c), g.addEventListener("error", I), e.head && e.head.appendChild(g);
}, Qq = function(e) {
  var n = {}, i = function(c, I) {
    var h = n[c];
    h.done = !0, h.error = I;
    for (var m = 0, w = h.handlers; m < w.length; m++) {
      var x = w[m];
      x(c, I);
    }
    h.handlers = [];
  }, a = function(c, I, h) {
    var m = function(Q) {
      return h !== void 0 ? h(Q) : console.error(Q);
    };
    if (c.length === 0) {
      m(new Error("At least one script must be provided"));
      return;
    }
    for (var w = 0, x = !1, M = function(Q, _) {
      x || (_ ? (x = !0, m(_)) : ++w === c.length && I());
    }, O = 0, k = c; O < k.length; O++) {
      var z = k[O], N = n[z.src];
      if (N)
        N.done ? M(z.src, N.error) : N.handlers.push(M);
      else {
        var U = vT("tiny-");
        n[z.src] = {
          id: U,
          src: z.src,
          done: !1,
          error: null,
          handlers: [M]
        }, Yq(e, Fh({ id: U }, z), i);
      }
    }
  }, s = function() {
    for (var c, I = 0, h = Object.values(n); I < h.length; I++) {
      var m = h[I], w = e.getElementById(m.id);
      w != null && w.tagName === "SCRIPT" && ((c = w.parentNode) === null || c === void 0 || c.removeChild(w));
    }
    n = {};
  }, g = function() {
    return e;
  };
  return {
    loadScripts: a,
    deleteScripts: s,
    getDocument: g
  };
}, Xq = function() {
  var e = [], n = function(s) {
    var g = e.find(function(c) {
      return c.getDocument() === s;
    });
    return g === void 0 && (g = Qq(s), e.push(g)), g;
  }, i = function(s, g, c, I, h) {
    var m = function() {
      return n(s).loadScripts(g, I, h);
    };
    c > 0 ? setTimeout(m, c) : m();
  }, a = function() {
    for (var s = e.pop(); s != null; s = e.pop())
      s.deleteScripts();
  };
  return {
    loadList: i,
    reinitialize: a
  };
}, Gq = Xq(), O7 = function(e) {
  var n = e;
  return n && n.tinymce ? n.tinymce : null;
}, qq = /* @__PURE__ */ function() {
  var e = function(n, i) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, s) {
      a.__proto__ = s;
    } || function(a, s) {
      for (var g in s) Object.prototype.hasOwnProperty.call(s, g) && (a[g] = s[g]);
    }, e(n, i);
  };
  return function(n, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    e(n, i);
    function a() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (a.prototype = i.prototype, new a());
  };
}(), jA = function() {
  return jA = Object.assign || function(e) {
    for (var n, i = 1, a = arguments.length; i < a; i++) {
      n = arguments[i];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, jA.apply(this, arguments);
}, Zq = (
  /** @class */
  function(e) {
    qq(n, e);
    function n(i) {
      var a, s, g, c = e.call(this, i) || this;
      return c.rollbackTimer = void 0, c.valueCursor = void 0, c.rollbackChange = function() {
        var I = c.editor, h = c.props.value;
        I && h && h !== c.currentContent && I.undoManager.ignore(function() {
          if (I.setContent(h), c.valueCursor && (!c.inline || I.hasFocus()))
            try {
              I.selection.moveToBookmark(c.valueCursor);
            } catch {
            }
        }), c.rollbackTimer = void 0;
      }, c.handleBeforeInput = function(I) {
        if (c.props.value !== void 0 && c.props.value === c.currentContent && c.editor && (!c.inline || c.editor.hasFocus()))
          try {
            c.valueCursor = c.editor.selection.getBookmark(3);
          } catch {
          }
      }, c.handleBeforeInputSpecial = function(I) {
        (I.key === "Enter" || I.key === "Backspace" || I.key === "Delete") && c.handleBeforeInput(I);
      }, c.handleEditorChange = function(I) {
        var h = c.editor;
        if (h && h.initialized) {
          var m = h.getContent();
          c.props.value !== void 0 && c.props.value !== m && c.props.rollback !== !1 && (c.rollbackTimer || (c.rollbackTimer = window.setTimeout(c.rollbackChange, typeof c.props.rollback == "number" ? c.props.rollback : 200))), m !== c.currentContent && (c.currentContent = m, R7(c.props.onEditorChange) && c.props.onEditorChange(m, h));
        }
      }, c.handleEditorChangeSpecial = function(I) {
        (I.key === "Backspace" || I.key === "Delete") && c.handleEditorChange(I);
      }, c.initialise = function(I) {
        var h, m, w;
        I === void 0 && (I = 0);
        var x = c.elementRef.current;
        if (x) {
          if (!Jq(x)) {
            if (I === 0)
              setTimeout(function() {
                return c.initialise(1);
              }, 1);
            else if (I < 100)
              setTimeout(function() {
                return c.initialise(I + 1);
              }, 100);
            else
              throw new Error("tinymce can only be initialised when in a document");
            return;
          }
          var M = O7(c.view);
          if (!M)
            throw new Error("tinymce should have been loaded into global scope");
          var O = jA(jA({}, c.props.init), { selector: void 0, target: x, readonly: c.props.disabled, inline: c.inline, plugins: Vq((h = c.props.init) === null || h === void 0 ? void 0 : h.plugins, c.props.plugins), toolbar: (m = c.props.toolbar) !== null && m !== void 0 ? m : (w = c.props.init) === null || w === void 0 ? void 0 : w.toolbar, setup: function(k) {
            c.editor = k, c.bindHandlers({}), c.inline && !Wx(x) && k.once("PostRender", function(z) {
              k.setContent(c.getInitialValue(), { no_events: !0 });
            }), c.props.init && R7(c.props.init.setup) && c.props.init.setup(k);
          }, init_instance_callback: function(k) {
            var z, N, U = c.getInitialValue();
            c.currentContent = (z = c.currentContent) !== null && z !== void 0 ? z : k.getContent(), c.currentContent !== U && (c.currentContent = U, k.setContent(U), k.undoManager.clear(), k.undoManager.add(), k.setDirty(!1));
            var Q = (N = c.props.disabled) !== null && N !== void 0 ? N : !1;
            Vx(c.editor, Q ? "readonly" : "design"), c.props.init && R7(c.props.init.init_instance_callback) && c.props.init.init_instance_callback(k);
          } });
          c.inline || (x.style.visibility = ""), Wx(x) && (x.value = c.getInitialValue()), M.init(O);
        }
      }, c.id = c.props.id || vT("tiny-react"), c.elementRef = o1.createRef(), c.inline = (g = (a = c.props.inline) !== null && a !== void 0 ? a : (s = c.props.init) === null || s === void 0 ? void 0 : s.inline) !== null && g !== void 0 ? g : !1, c.boundHandlers = {}, c;
    }
    return Object.defineProperty(n.prototype, "view", {
      get: function() {
        var i, a;
        return (a = (i = this.elementRef.current) === null || i === void 0 ? void 0 : i.ownerDocument.defaultView) !== null && a !== void 0 ? a : window;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.componentDidUpdate = function(i) {
      var a = this, s, g;
      if (this.rollbackTimer && (clearTimeout(this.rollbackTimer), this.rollbackTimer = void 0), this.editor && (this.bindHandlers(i), this.editor.initialized)) {
        if (this.currentContent = (s = this.currentContent) !== null && s !== void 0 ? s : this.editor.getContent(), typeof this.props.initialValue == "string" && this.props.initialValue !== i.initialValue)
          this.editor.setContent(this.props.initialValue), this.editor.undoManager.clear(), this.editor.undoManager.add(), this.editor.setDirty(!1);
        else if (typeof this.props.value == "string" && this.props.value !== this.currentContent) {
          var c = this.editor;
          c.undoManager.transact(function() {
            var h;
            if (!a.inline || c.hasFocus())
              try {
                h = c.selection.getBookmark(3);
              } catch {
              }
            var m = a.valueCursor;
            if (c.setContent(a.props.value), !a.inline || c.hasFocus())
              for (var w = 0, x = [h, m]; w < x.length; w++) {
                var M = x[w];
                if (M)
                  try {
                    c.selection.moveToBookmark(M), a.valueCursor = M;
                    break;
                  } catch {
                  }
              }
          });
        }
        if (this.props.disabled !== i.disabled) {
          var I = (g = this.props.disabled) !== null && g !== void 0 ? g : !1;
          Vx(this.editor, I ? "readonly" : "design");
        }
      }
    }, n.prototype.componentDidMount = function() {
      var i = this, a, s, g, c, I;
      if (O7(this.view) !== null)
        this.initialise();
      else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0)
        (s = (a = this.props).onScriptsLoadError) === null || s === void 0 || s.call(a, new Error("No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array."));
      else if (!((g = this.elementRef.current) === null || g === void 0) && g.ownerDocument) {
        var h = function() {
          var w, x;
          (x = (w = i.props).onScriptsLoad) === null || x === void 0 || x.call(w), i.initialise();
        }, m = function(w) {
          var x, M;
          (M = (x = i.props).onScriptsLoadError) === null || M === void 0 || M.call(x, w);
        };
        Gq.loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (I = (c = this.props.scriptLoading) === null || c === void 0 ? void 0 : c.delay) !== null && I !== void 0 ? I : 0, h, m);
      }
    }, n.prototype.componentWillUnmount = function() {
      var i = this, a = this.editor;
      a && (a.off(this.changeEvents(), this.handleEditorChange), a.off(this.beforeInputEvent(), this.handleBeforeInput), a.off("keypress", this.handleEditorChangeSpecial), a.off("keydown", this.handleBeforeInputSpecial), a.off("NewBlock", this.handleEditorChange), Object.keys(this.boundHandlers).forEach(function(s) {
        a.off(s, i.boundHandlers[s]);
      }), this.boundHandlers = {}, a.remove(), this.editor = void 0);
    }, n.prototype.render = function() {
      return this.inline ? this.renderInline() : this.renderIframe();
    }, n.prototype.changeEvents = function() {
      var i, a, s, g = (s = (a = (i = O7(this.view)) === null || i === void 0 ? void 0 : i.Env) === null || a === void 0 ? void 0 : a.browser) === null || s === void 0 ? void 0 : s.isIE();
      return g ? "change keyup compositionend setcontent CommentChange" : "change input compositionend setcontent CommentChange";
    }, n.prototype.beforeInputEvent = function() {
      return Kq() ? "beforeinput SelectionChange" : "SelectionChange";
    }, n.prototype.renderInline = function() {
      var i = this.props.tagName, a = i === void 0 ? "div" : i;
      return o1.createElement(a, {
        ref: this.elementRef,
        id: this.id
      });
    }, n.prototype.renderIframe = function() {
      return o1.createElement("textarea", {
        ref: this.elementRef,
        style: { visibility: "hidden" },
        name: this.props.textareaName,
        id: this.id
      });
    }, n.prototype.getScriptSources = function() {
      var i, a, s = (i = this.props.scriptLoading) === null || i === void 0 ? void 0 : i.async, g = (a = this.props.scriptLoading) === null || a === void 0 ? void 0 : a.defer;
      if (this.props.tinymceScriptSrc !== void 0)
        return typeof this.props.tinymceScriptSrc == "string" ? [{ src: this.props.tinymceScriptSrc, async: s, defer: g }] : this.props.tinymceScriptSrc.map(function(m) {
          return typeof m == "string" ? { src: m, async: s, defer: g } : m;
        });
      var c = this.props.cloudChannel, I = this.props.apiKey ? this.props.apiKey : "no-api-key", h = "https://cdn.tiny.cloud/1/".concat(I, "/tinymce/").concat(c, "/tinymce.min.js");
      return [{ src: h, async: s, defer: g }];
    }, n.prototype.getInitialValue = function() {
      return typeof this.props.initialValue == "string" ? this.props.initialValue : typeof this.props.value == "string" ? this.props.value : "";
    }, n.prototype.bindHandlers = function(i) {
      var a = this;
      if (this.editor !== void 0) {
        _q(this.editor, i, this.props, this.boundHandlers, function(I) {
          return a.props[I];
        });
        var s = function(I) {
          return I.onEditorChange !== void 0 || I.value !== void 0;
        }, g = s(i), c = s(this.props);
        !g && c ? (this.editor.on(this.changeEvents(), this.handleEditorChange), this.editor.on(this.beforeInputEvent(), this.handleBeforeInput), this.editor.on("keydown", this.handleBeforeInputSpecial), this.editor.on("keyup", this.handleEditorChangeSpecial), this.editor.on("NewBlock", this.handleEditorChange)) : g && !c && (this.editor.off(this.changeEvents(), this.handleEditorChange), this.editor.off(this.beforeInputEvent(), this.handleBeforeInput), this.editor.off("keydown", this.handleBeforeInputSpecial), this.editor.off("keyup", this.handleEditorChangeSpecial), this.editor.off("NewBlock", this.handleEditorChange));
      }
    }, n.propTypes = Uq, n.defaultProps = {
      cloudChannel: "6"
    }, n;
  }(o1.Component)
);
const $q = {
  "Heading 1": "H1: Heading 1",
  "Heading 2": "H2: Heading 2",
  "Heading 3": "H3: Heading 3"
}, eZ = ["aria-label", "aria-placeholder"];
function tZ(e) {
  e.editorManager.addI18n("en", $q);
}
function nZ(e) {
  const n = () => {
    const i = e.getBody();
    eZ.forEach((a) => i == null ? void 0 : i.removeAttribute(a));
  };
  n(), e.on("PlaceholderToggle", n);
}
const Kx = 512 * 1024, rZ = {
  left: "JustifyLeft",
  center: "JustifyCenter",
  right: "JustifyRight",
  justify: "JustifyFull"
}, iZ = [
  "JustifyLeft",
  "JustifyCenter",
  "JustifyRight",
  "JustifyFull"
];
function aZ(e) {
  return typeof e != "string" ? "" : e.replace(/[<>]/g, "").trim().toLowerCase();
}
function Jx(e, n) {
  if (e !== "mceToggleFormat" && e !== "FormatBlock") return !1;
  const i = aZ(n);
  return i === "h1" || i === "h2" || i === "h3";
}
function oZ(e) {
  for (const n of iZ)
    if (e.queryCommandState(n))
      return n;
  return null;
}
const sZ = q1(_1)(({ theme: e }) => ({
  "& .tox-tinymce": {
    fontFamily: "inherit !important",
    border: `solid 1px ${e.palette.common.neutrals[200]}`
  },
  "& .tox-tinymce:hover": {
    border: `solid 1px ${e.palette.common.neutrals[500]}`
  },
  "& .tox:not(.tox-tinymce-inline) .tox-editor-header": {
    padding: "0px !important"
  },
  "& .tox .tox-statusbar": {
    display: "none"
  }
})), lZ = ({
  initialValue: e,
  value: n,
  onChange: i = (M) => console.log("RTE:", { html: M }),
  onBlur: a,
  disabled: s,
  height: g = "300px",
  inlineImages: c = !0,
  hideToolbar: I,
  placeholder: h = "",
  defaultTextAlign: m,
  defaultBold: w = !1,
  ...x
}) => {
  const M = ka(), O = V2(() => {
    const k = [], z = [
      "h1",
      "h2",
      "h3",
      "bold",
      "italic",
      "underline",
      "forecolor",
      "backcolor",
      "bullist",
      "numlist",
      "alignleft",
      "aligncenter",
      "alignright",
      "alignjustify",
      "lineheight",
      "link"
    ], N = ["quickimage"];
    return I || (k.push(...z), c && k.push(...N)), k.join(" ");
  }, [I, c]);
  return /* @__PURE__ */ v.jsx(sZ, { ...x, tabIndex: 0, children: /* @__PURE__ */ v.jsx(
    Zq,
    {
      disabled: s,
      tinymceScriptSrc: "https://turmericp.liscio.me/tinymce/js/tinymce/tinymce.min.js",
      initialValue: e,
      value: n,
      onBlur: a,
      init: {
        placeholder: h,
        images_replace_blob_uris: !1,
        convert_urls: !1,
        paste_data_images: c,
        height: g,
        menubar: !1,
        paste_retain_style_properties: "all",
        paste_webkit_styles: "all",
        paste_convert_word_fake_lists: !1,
        // open embedded link in new tab
        link_target_list: [{ title: "New window", value: "_blank" }],
        contextmenu: !1,
        paste_postprocess(k, z) {
          z.node.querySelectorAll("a").forEach((N) => {
            N.innerHTML || N.remove();
          });
        },
        plugins: [
          "link",
          "autolink",
          "lists",
          "media",
          "advlist",
          ...c ? ["image", "quickbars"] : []
        ],
        browser_spellcheck: !0,
        toolbar: O,
        content_style: `@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700');
            body {
              font-family:Source Sans Pro, sans-serif;
              font-size:0.94rem;
              color: rgb(33, 43, 54);
              margin:0;
              padding: 0.5rem;
            }
    
            p {
              color: rgb(33, 43, 54);
              margin: 0px;
            }

            a, a:visited {
              color: ${M.palette.info.light};
            }
    
            #tinymce * {
              text-indent: 0 !important;
            }
    
            .mce-item-table, .mce-item-table td, .mce-item-table tr {
              border: inherit !important;
              outline: inherit !important;
            }
    
            .mce-content-body {
              min-height:210px;
            }

            .mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {
              left: 12px;
            }
            `,
        quickbars_selection_toolbar: !1,
        link_assume_external_targets: !0,
        toolbar_location: "bottom",
        quickbars_insert_toolbar: !1,
        quickbars_image_toolbar: !1,
        elementpath: !1,
        branding: !1,
        resize: !1,
        autoresize: !0,
        images_file_types: "jpg,png,jpeg",
        image_description: !1,
        image_dimensions: !1,
        image_title: !1,
        a11y_advanced_options: !0,
        // NOTE: This is currently only being used by Email editor.
        // Omitting until it is necessary
        // images_upload_handler: imageUploadHandler || undefined,
        object_resizing: !0,
        forced_root_block: "div",
        init_instance_callback: (k) => {
          nZ(k);
          let z = null, N = !1;
          const U = k.getContent({ format: "text" }).trim().length > 0, Q = k.getBody(), _ = !!(Q != null && Q.querySelector(
            "img,table,iframe,embed,video,audio,object,svg,canvas"
          )), X = Array.from((Q == null ? void 0 : Q.children) ?? []).some(
            (Z) => !(Z instanceof HTMLElement) || Z.tagName.toLowerCase() === "br" ? !1 : (Z.textContent || "").replace(/\u00a0/g, "").trim().length > 0 ? !0 : !!Z.querySelector(
              "img,table,iframe,embed,video,audio,object,svg,canvas,li,blockquote,pre,code,hr"
            )
          );
          if (!U && !_ && !X) {
            if (m) {
              const Z = rZ[m];
              Z && k.execCommand(Z);
            }
            w && k.execCommand("Bold");
          }
          k.on("BeforeExecCommand", (Z) => {
            N || Jx(Z.command, Z.value) && (z = oZ(k));
          }), k.on("ExecCommand", (Z) => {
            if (N || !Jx(Z.command, Z.value)) return;
            const Y = z;
            if (z = null, !!Y && !k.queryCommandState(Y)) {
              N = !0;
              try {
                k.execCommand(Y);
              } finally {
                N = !1;
              }
            }
          }), k.on("GetContent", (Z) => {
            if (Z.content.includes("a")) {
              const V = Z.content.replace(
                /<a/g,
                '<a style="text-decoration: underline"'
              );
              Z.content = V;
            }
          }), k.on("ObjectResized", (Z) => {
            Z.target.dataset.mceStyle = 'style="max-width: none; max-height: none"';
          }), k.on("focus", function() {
            const Z = k.getContainer();
            Z && (Z.style.border = `1px solid ${M.palette.common.primary[500]}`);
          }), k.on("blur", function() {
            const Z = k.getContainer();
            Z && (Z.style.border = `1px solid ${M.palette.common.neutrals[300]}`);
          }), c && k.on("paste", (Z) => {
            const { clipboardData: Y } = Z;
            if (Y && Y.items) {
              let V = !1;
              Array.from(Y.items).forEach((J) => {
                if (J.type.indexOf("image") !== -1) {
                  const e1 = J.getAsFile();
                  e1 && e1.size > Kx && (Z.preventDefault(), V = !0);
                }
              }), V && k.notificationManager.open({
                text: "Image size exceeds the maximum allowed size of 0.5MB",
                type: "error",
                timeout: 3e3
              });
            }
          });
        },
        setup(k) {
          tZ(k), k.ui.registry.addContextMenu("useBrowserSpellcheck", {
            update() {
              return k.selection.isCollapsed() ? ["useBrowserSpellcheck"] : [];
            }
          });
        },
        ...c ? {
          images_upload_handler: (k) => {
            if (k.blob().size > Kx) {
              const z = new Error(
                "Image size exceeds the maximum allowed size of 0.5MB"
              );
              return z.remove = !0, Promise.reject(z);
            }
            return new Promise((z, N) => {
              if (!k || !k.blob())
                return N(new Error("Invalid image data"));
              const U = new FileReader();
              U.onload = () => {
                try {
                  if (!U.result)
                    throw new Error("Empty result from file reader");
                  if (typeof U.result == "string")
                    z(U.result);
                  else
                    throw new Error(
                      "reader.result is an ArrayBuffer, which is not expected with readAsDataURL"
                    );
                } catch (Q) {
                  N(
                    Q instanceof Error ? Q : new Error("Unknown error processing image")
                  );
                }
              }, U.onerror = () => {
                var Q;
                return N(
                  new Error(
                    `Failed to read image: ${((Q = U.error) == null ? void 0 : Q.message) || "unknown error"}`
                  )
                );
              }, U.onabort = () => N(new Error("Image reading was aborted")), U.readAsDataURL(k.blob());
            });
          }
        } : {}
      },
      onEditorChange: i
    }
  ) });
}, ut1 = ({
  name: e,
  label: n,
  error: i,
  ...a
}) => {
  var I;
  const { control: s, formState: g } = Lf(), c = i || ((I = g.errors[e]) == null ? void 0 : I.message);
  return /* @__PURE__ */ v.jsx(
    Bm,
    {
      name: e,
      label: n,
      error: c,
      sx: { width: "100%" },
      children: /* @__PURE__ */ v.jsx(
        zz,
        {
          name: e,
          control: s,
          render: ({ field: h }) => /* @__PURE__ */ v.jsx(
            lZ,
            {
              width: "100%",
              ...a,
              value: h.value,
              onChange: h.onChange,
              onBlur: h.onBlur
            }
          )
        }
      )
    }
  );
}, uZ = nn.forwardRef(
  ({ rows: e = 3, ...n }, i) => /* @__PURE__ */ v.jsx(Wf, { rows: e, multiline: !0, ...n, ref: i })
), ct1 = ({
  name: e,
  ...n
}) => {
  var g, c;
  const { register: i, formState: a } = Lf(), s = (c = (g = a.errors) == null ? void 0 : g[e]) == null ? void 0 : c.message;
  return /* @__PURE__ */ v.jsx(
    uZ,
    {
      disabled: a.isSubmitting,
      ...n,
      ...i(e),
      error: s
    }
  );
}, cZ = ({ children: e, ...n }) => /* @__PURE__ */ v.jsx(j2, { type: "submit", variant: "contained", color: "primary", ...n, children: e || "Submit" }), gt1 = ({
  submittingProps: e = {},
  ...n
}) => {
  const {
    formState: { isSubmitting: i }
  } = Lf(), a = V2(
    () => ({
      ...n,
      ...i ? e : {}
    }),
    [n, e, i]
  );
  return /* @__PURE__ */ v.jsx(cZ, { disabled: i, ...a });
}, gZ = {
  medium: { label: "body2", value: "body1", gap: 1 },
  small: { label: "caption", value: "caption", gap: 1.25 }
}, fZ = q1(le, {
  shouldForwardProp: (e) => e !== "compact"
})(({ theme: e, compact: n }) => ({
  color: e.palette.common.neutrals[300],
  ...n && { flexShrink: 0 }
})), dZ = q1(le, {
  shouldForwardProp: (e) => e !== "compact"
})(({ compact: e }) => ({
  ...e && { minWidth: 0, overflowWrap: "anywhere" }
})), ft1 = ({
  label: e,
  value: n,
  labelWidth: i = "160px",
  emptyValuePlaceholder: a = "-",
  alignItems: s,
  size: g = "medium"
}) => {
  const c = gZ[g], I = g === "small";
  return /* @__PURE__ */ v.jsxs(qe, { direction: "row", gap: c.gap, alignItems: s, children: [
    /* @__PURE__ */ v.jsx(
      fZ,
      {
        sx: { width: i },
        variant: c.label,
        compact: I,
        children: e
      }
    ),
    typeof n == "string" || n === null ? /* @__PURE__ */ v.jsx(dZ, { variant: c.value, compact: I, children: n || a }) : n
  ] });
}, Yx = (e) => typeof e == "string" ? !1 : "collapsed" in e && "expanded" in e, dt1 = ({
  children: e,
  summary: n,
  expanded: i,
  defaultExpanded: a = !1,
  expandIcon: s = /* @__PURE__ */ v.jsx(De, { icon: "chevronDown" }),
  onChange: g,
  summaryProps: c = {},
  detailsProps: I = {},
  ...h
}) => {
  const [m, w] = gt(a), x = i ?? m, M = m2(
    (z, N) => {
      g && g(z, N), w(N);
    },
    [g, w, x]
  ), O = V2(() => s && Yx(s) ? x ? s.expanded : s.collapsed : s, [s, x]), k = V2(() => n && Yx(n) ? x ? n == null ? void 0 : n.expanded : n == null ? void 0 : n.collapsed : n, [x, n]);
  return /* @__PURE__ */ v.jsxs(
    iz,
    {
      disableGutters: !0,
      square: !0,
      elevation: 0,
      expanded: x,
      onChange: M,
      ...h,
      children: [
        /* @__PURE__ */ v.jsx(az, { ...c, expandIcon: O, children: typeof k == "string" ? /* @__PURE__ */ v.jsx(le, { children: k }) : k }),
        /* @__PURE__ */ v.jsx(oz, { ...I, children: e })
      ]
    }
  );
}, Ct1 = q1(_1)({
  display: "none",
  width: "750px",
  "@media print": {
    display: "block"
  },
  "@page": {
    margin: "10mm"
  }
}), At1 = ({
  variant: e = "logoExpanded",
  ...n
}) => {
  const i = ka(), a = V2(() => {
    var s, g, c;
    switch (e) {
      case "logoExpanded":
        return (s = i.assets) == null ? void 0 : s.logoExpanded;
      case "logoSplash":
        return (g = i.assets) == null ? void 0 : g.logoSplash;
      case "logo":
      default:
        return (c = i.assets) == null ? void 0 : c.logo;
    }
  }, [e]);
  return /* @__PURE__ */ v.jsx(
    _1,
    {
      "data-testid": "logo",
      component: "img",
      src: a,
      width: "100%",
      ...n
    }
  );
}, yT = ({
  type: e = "default",
  icon: n,
  variant: i = "body2",
  children: a,
  ...s
}) => /* @__PURE__ */ v.jsxs(
  le,
  {
    gap: 1,
    display: "flex",
    alignItems: "center",
    variant: i,
    color: (g) => e === "default" ? g.palette.text.primary : g.palette[e].main,
    ...s,
    children: [
      e !== "default" && /* @__PURE__ */ v.jsx(De, { icon: n || e }),
      a
    ]
  }
);
yT.displayName = "AlertHeading";
const zA = /* @__PURE__ */ o1.createContext({});
process.env.NODE_ENV !== "production" && (zA.displayName = "ListContext");
function CZ(e) {
  return lr("MuiList", e);
}
y2("MuiList", ["root", "padding", "dense", "subheader"]);
const AZ = ["children", "className", "component", "dense", "disablePadding", "subheader"], IZ = (e) => {
  const {
    classes: n,
    disablePadding: i,
    dense: a,
    subheader: s
  } = e;
  return Qr({
    root: ["root", !i && "padding", a && "dense", s && "subheader"]
  }, CZ, n);
}, pZ = kn("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, !i.disablePadding && n.padding, i.dense && n.dense, i.subheader && n.subheader];
  }
})(({
  ownerState: e
}) => k1({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), bT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiList"
  }), {
    children: s,
    className: g,
    component: c = "ul",
    dense: I = !1,
    disablePadding: h = !1,
    subheader: m
  } = a, w = Dt(a, AZ), x = o1.useMemo(() => ({
    dense: I
  }), [I]), M = k1({}, a, {
    component: c,
    dense: I,
    disablePadding: h
  }), O = IZ(M);
  return /* @__PURE__ */ v.jsx(zA.Provider, {
    value: x,
    children: /* @__PURE__ */ v.jsxs(pZ, k1({
      as: c,
      className: tn(O.root, g),
      ref: i,
      ownerState: M
    }, w, {
      children: [m, s]
    }))
  });
});
process.env.NODE_ENV !== "production" && (bT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: E.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: E.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: E.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
const hZ = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function D7(e, n, i) {
  return e === n ? e.firstChild : n && n.nextElementSibling ? n.nextElementSibling : i ? null : e.firstChild;
}
function Qx(e, n, i) {
  return e === n ? i ? e.firstChild : e.lastChild : n && n.previousElementSibling ? n.previousElementSibling : i ? null : e.lastChild;
}
function wT(e, n) {
  if (n === void 0)
    return !0;
  let i = e.innerText;
  return i === void 0 && (i = e.textContent), i = i.trim().toLowerCase(), i.length === 0 ? !1 : n.repeating ? i[0] === n.keys[0] : i.indexOf(n.keys.join("")) === 0;
}
function nf(e, n, i, a, s, g) {
  let c = !1, I = s(e, n, n ? i : !1);
  for (; I; ) {
    if (I === e.firstChild) {
      if (c)
        return !1;
      c = !0;
    }
    const h = a ? !1 : I.disabled || I.getAttribute("aria-disabled") === "true";
    if (!I.hasAttribute("tabindex") || !wT(I, g) || h)
      I = s(e, I, i);
    else
      return I.focus(), !0;
  }
  return !1;
}
const xT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: a,
    autoFocus: s = !1,
    autoFocusItem: g = !1,
    children: c,
    className: I,
    disabledItemsFocusable: h = !1,
    disableListWrap: m = !1,
    onKeyDown: w,
    variant: x = "selectedMenu"
  } = n, M = Dt(n, hZ), O = o1.useRef(null), k = o1.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Lc(() => {
    s && O.current.focus();
  }, [s]), o1.useImperativeHandle(a, () => ({
    adjustStyleForScrollbar: (_, {
      direction: X
    }) => {
      const B = !O.current.style.width;
      if (_.clientHeight < O.current.clientHeight && B) {
        const Z = `${dE(si(_))}px`;
        O.current.style[X === "rtl" ? "paddingLeft" : "paddingRight"] = Z, O.current.style.width = `calc(100% + ${Z})`;
      }
      return O.current;
    }
  }), []);
  const z = (_) => {
    const X = O.current, B = _.key, Z = si(X).activeElement;
    if (B === "ArrowDown")
      _.preventDefault(), nf(X, Z, m, h, D7);
    else if (B === "ArrowUp")
      _.preventDefault(), nf(X, Z, m, h, Qx);
    else if (B === "Home")
      _.preventDefault(), nf(X, null, m, h, D7);
    else if (B === "End")
      _.preventDefault(), nf(X, null, m, h, Qx);
    else if (B.length === 1) {
      const Y = k.current, V = B.toLowerCase(), J = performance.now();
      Y.keys.length > 0 && (J - Y.lastTime > 500 ? (Y.keys = [], Y.repeating = !0, Y.previousKeyMatched = !0) : Y.repeating && V !== Y.keys[0] && (Y.repeating = !1)), Y.lastTime = J, Y.keys.push(V);
      const e1 = Z && !Y.repeating && wT(Z, Y);
      Y.previousKeyMatched && (e1 || nf(X, Z, !1, h, D7, Y)) ? _.preventDefault() : Y.previousKeyMatched = !1;
    }
    w && w(_);
  }, N = _i(O, i);
  let U = -1;
  o1.Children.forEach(c, (_, X) => {
    if (!/* @__PURE__ */ o1.isValidElement(_)) {
      U === X && (U += 1, U >= c.length && (U = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && vA.isFragment(_) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), _.props.disabled || (x === "selectedMenu" && _.props.selected || U === -1) && (U = X), U === X && (_.props.disabled || _.props.muiSkipListHighlight || _.type.muiSkipListHighlight) && (U += 1, U >= c.length && (U = -1));
  });
  const Q = o1.Children.map(c, (_, X) => {
    if (X === U) {
      const B = {};
      return g && (B.autoFocus = !0), _.props.tabIndex === void 0 && x === "selectedMenu" && (B.tabIndex = 0), /* @__PURE__ */ o1.cloneElement(_, B);
    }
    return _;
  });
  return /* @__PURE__ */ v.jsx(bT, k1({
    role: "menu",
    ref: N,
    className: I,
    onKeyDown: z,
    tabIndex: s ? 0 : -1
  }, M, {
    children: Q
  }));
});
process.env.NODE_ENV !== "production" && (xT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: E.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: E.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: E.node,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: E.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: E.bool,
  /**
   * @ignore
   */
  onKeyDown: E.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: E.oneOf(["menu", "selectedMenu"])
});
const ST = (e) => e.scrollTop;
function NA(e, n) {
  var i, a;
  const {
    timeout: s,
    easing: g,
    style: c = {}
  } = e;
  return {
    duration: (i = c.transitionDuration) != null ? i : typeof s == "number" ? s : s[n.mode] || 0,
    easing: (a = c.transitionTimingFunction) != null ? a : typeof g == "object" ? g[n.mode] : g,
    delay: c.transitionDelay
  };
}
const mZ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function Bh(e) {
  return `scale(${e}, ${e ** 2})`;
}
const vZ = {
  entering: {
    opacity: 1,
    transform: Bh(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, k7 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Hm = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const {
    addEndListener: a,
    appear: s = !0,
    children: g,
    easing: c,
    in: I,
    onEnter: h,
    onEntered: m,
    onEntering: w,
    onExit: x,
    onExited: M,
    onExiting: O,
    style: k,
    timeout: z = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: N = N0
  } = n, U = Dt(n, mZ), Q = fE(), _ = o1.useRef(), X = r6(), B = o1.useRef(null), Z = _i(B, g.ref, i), Y = (S1) => (h1) => {
    if (S1) {
      const L1 = B.current;
      h1 === void 0 ? S1(L1) : S1(L1, h1);
    }
  }, V = Y(w), J = Y((S1, h1) => {
    ST(S1);
    const {
      duration: L1,
      delay: c1,
      easing: b1
    } = NA({
      style: k,
      timeout: z,
      easing: c
    }, {
      mode: "enter"
    });
    let t1;
    z === "auto" ? (t1 = X.transitions.getAutoHeightDuration(S1.clientHeight), _.current = t1) : t1 = L1, S1.style.transition = [X.transitions.create("opacity", {
      duration: t1,
      delay: c1
    }), X.transitions.create("transform", {
      duration: k7 ? t1 : t1 * 0.666,
      delay: c1,
      easing: b1
    })].join(","), h && h(S1, h1);
  }), e1 = Y(m), f1 = Y(O), v1 = Y((S1) => {
    const {
      duration: h1,
      delay: L1,
      easing: c1
    } = NA({
      style: k,
      timeout: z,
      easing: c
    }, {
      mode: "exit"
    });
    let b1;
    z === "auto" ? (b1 = X.transitions.getAutoHeightDuration(S1.clientHeight), _.current = b1) : b1 = h1, S1.style.transition = [X.transitions.create("opacity", {
      duration: b1,
      delay: L1
    }), X.transitions.create("transform", {
      duration: k7 ? b1 : b1 * 0.666,
      delay: k7 ? L1 : L1 || b1 * 0.333,
      easing: c1
    })].join(","), S1.style.opacity = 0, S1.style.transform = Bh(0.75), x && x(S1);
  }), a1 = Y(M), d1 = (S1) => {
    z === "auto" && Q.start(_.current || 0, S1), a && a(B.current, S1);
  };
  return /* @__PURE__ */ v.jsx(N, k1({
    appear: s,
    in: I,
    nodeRef: B,
    onEnter: J,
    onEntered: e1,
    onEntering: V,
    onExit: v1,
    onExited: a1,
    onExiting: f1,
    addEndListener: d1,
    timeout: z === "auto" ? null : z
  }, U, {
    children: (S1, h1) => /* @__PURE__ */ o1.cloneElement(g, k1({
      style: k1({
        opacity: 0,
        transform: Bh(0.75),
        visibility: S1 === "exited" && !I ? "hidden" : void 0
      }, vZ[S1], k, g.props.style),
      ref: Z
    }, h1))
  }));
});
process.env.NODE_ENV !== "production" && (Hm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: E.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: E.bool,
  /**
   * A single child content element.
   */
  children: zf.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: E.oneOfType([E.shape({
    enter: E.string,
    exit: E.string
  }), E.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: E.bool,
  /**
   * @ignore
   */
  onEnter: E.func,
  /**
   * @ignore
   */
  onEntered: E.func,
  /**
   * @ignore
   */
  onEntering: E.func,
  /**
   * @ignore
   */
  onExit: E.func,
  /**
   * @ignore
   */
  onExited: E.func,
  /**
   * @ignore
   */
  onExiting: E.func,
  /**
   * @ignore
   */
  style: E.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: E.oneOfType([E.oneOf(["auto"]), E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })])
});
Hm.muiSupportAuto = !0;
function yZ(e) {
  const n = si(e);
  return n.body === e ? yf(e).innerWidth > n.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function If(e, n) {
  n ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Xx(e) {
  return parseInt(yf(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function bZ(e) {
  const i = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, a = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return i || a;
}
function Gx(e, n, i, a, s) {
  const g = [n, i, ...a];
  [].forEach.call(e.children, (c) => {
    const I = g.indexOf(c) === -1, h = !bZ(c);
    I && h && If(c, s);
  });
}
function j7(e, n) {
  let i = -1;
  return e.some((a, s) => n(a) ? (i = s, !0) : !1), i;
}
function wZ(e, n) {
  const i = [], a = e.container;
  if (!n.disableScrollLock) {
    if (yZ(a)) {
      const c = dE(si(a));
      i.push({
        value: a.style.paddingRight,
        property: "padding-right",
        el: a
      }), a.style.paddingRight = `${Xx(a) + c}px`;
      const I = si(a).querySelectorAll(".mui-fixed");
      [].forEach.call(I, (h) => {
        i.push({
          value: h.style.paddingRight,
          property: "padding-right",
          el: h
        }), h.style.paddingRight = `${Xx(h) + c}px`;
      });
    }
    let g;
    if (a.parentNode instanceof DocumentFragment)
      g = si(a).body;
    else {
      const c = a.parentElement, I = yf(a);
      g = (c == null ? void 0 : c.nodeName) === "HTML" && I.getComputedStyle(c).overflowY === "scroll" ? c : a;
    }
    i.push({
      value: g.style.overflow,
      property: "overflow",
      el: g
    }, {
      value: g.style.overflowX,
      property: "overflow-x",
      el: g
    }, {
      value: g.style.overflowY,
      property: "overflow-y",
      el: g
    }), g.style.overflow = "hidden";
  }
  return () => {
    i.forEach(({
      value: g,
      el: c,
      property: I
    }) => {
      g ? c.style.setProperty(I, g) : c.style.removeProperty(I);
    });
  };
}
function xZ(e) {
  const n = [];
  return [].forEach.call(e.children, (i) => {
    i.getAttribute("aria-hidden") === "true" && n.push(i);
  }), n;
}
class SZ {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(n, i) {
    let a = this.modals.indexOf(n);
    if (a !== -1)
      return a;
    a = this.modals.length, this.modals.push(n), n.modalRef && If(n.modalRef, !1);
    const s = xZ(i);
    Gx(i, n.mount, n.modalRef, s, !0);
    const g = j7(this.containers, (c) => c.container === i);
    return g !== -1 ? (this.containers[g].modals.push(n), a) : (this.containers.push({
      modals: [n],
      container: i,
      restore: null,
      hiddenSiblings: s
    }), a);
  }
  mount(n, i) {
    const a = j7(this.containers, (g) => g.modals.indexOf(n) !== -1), s = this.containers[a];
    s.restore || (s.restore = wZ(s, i));
  }
  remove(n, i = !0) {
    const a = this.modals.indexOf(n);
    if (a === -1)
      return a;
    const s = j7(this.containers, (c) => c.modals.indexOf(n) !== -1), g = this.containers[s];
    if (g.modals.splice(g.modals.indexOf(n), 1), this.modals.splice(a, 1), g.modals.length === 0)
      g.restore && g.restore(), n.modalRef && If(n.modalRef, i), Gx(g.container, n.mount, n.modalRef, g.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const c = g.modals[g.modals.length - 1];
      c.modalRef && If(c.modalRef, !1);
    }
    return a;
  }
  isTopModal(n) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === n;
  }
}
const EZ = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function MZ(e) {
  const n = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(n) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : n;
}
function TZ(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const n = (a) => e.ownerDocument.querySelector(`input[type="radio"]${a}`);
  let i = n(`[name="${e.name}"]:checked`);
  return i || (i = n(`[name="${e.name}"]`)), i !== e;
}
function LZ(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || TZ(e));
}
function RZ(e) {
  const n = [], i = [];
  return Array.from(e.querySelectorAll(EZ)).forEach((a, s) => {
    const g = MZ(a);
    g === -1 || !LZ(a) || (g === 0 ? n.push(a) : i.push({
      documentOrder: s,
      tabIndex: g,
      node: a
    }));
  }), i.sort((a, s) => a.tabIndex === s.tabIndex ? a.documentOrder - s.documentOrder : a.tabIndex - s.tabIndex).map((a) => a.node).concat(n);
}
function OZ() {
  return !0;
}
function PA(e) {
  const {
    children: n,
    disableAutoFocus: i = !1,
    disableEnforceFocus: a = !1,
    disableRestoreFocus: s = !1,
    getTabbable: g = RZ,
    isEnabled: c = OZ,
    open: I
  } = e, h = o1.useRef(!1), m = o1.useRef(null), w = o1.useRef(null), x = o1.useRef(null), M = o1.useRef(null), O = o1.useRef(!1), k = o1.useRef(null), z = _i(n.ref, k), N = o1.useRef(null);
  o1.useEffect(() => {
    !I || !k.current || (O.current = !i);
  }, [i, I]), o1.useEffect(() => {
    if (!I || !k.current)
      return;
    const _ = si(k.current);
    return k.current.contains(_.activeElement) || (k.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), k.current.setAttribute("tabIndex", "-1")), O.current && k.current.focus()), () => {
      s || (x.current && x.current.focus && (h.current = !0, x.current.focus()), x.current = null);
    };
  }, [I]), o1.useEffect(() => {
    if (!I || !k.current)
      return;
    const _ = si(k.current), X = (Y) => {
      N.current = Y, !(a || !c() || Y.key !== "Tab") && _.activeElement === k.current && Y.shiftKey && (h.current = !0, w.current && w.current.focus());
    }, B = () => {
      const Y = k.current;
      if (Y === null)
        return;
      if (!_.hasFocus() || !c() || h.current) {
        h.current = !1;
        return;
      }
      if (Y.contains(_.activeElement) || a && _.activeElement !== m.current && _.activeElement !== w.current)
        return;
      if (_.activeElement !== M.current)
        M.current = null;
      else if (M.current !== null)
        return;
      if (!O.current)
        return;
      let V = [];
      if ((_.activeElement === m.current || _.activeElement === w.current) && (V = g(k.current)), V.length > 0) {
        var J, e1;
        const f1 = !!((J = N.current) != null && J.shiftKey && ((e1 = N.current) == null ? void 0 : e1.key) === "Tab"), v1 = V[0], a1 = V[V.length - 1];
        typeof v1 != "string" && typeof a1 != "string" && (f1 ? a1.focus() : v1.focus());
      } else
        Y.focus();
    };
    _.addEventListener("focusin", B), _.addEventListener("keydown", X, !0);
    const Z = setInterval(() => {
      _.activeElement && _.activeElement.tagName === "BODY" && B();
    }, 50);
    return () => {
      clearInterval(Z), _.removeEventListener("focusin", B), _.removeEventListener("keydown", X, !0);
    };
  }, [i, a, s, c, I, g]);
  const U = (_) => {
    x.current === null && (x.current = _.relatedTarget), O.current = !0, M.current = _.target;
    const X = n.props.onFocus;
    X && X(_);
  }, Q = (_) => {
    x.current === null && (x.current = _.relatedTarget), O.current = !0;
  };
  return /* @__PURE__ */ v.jsxs(o1.Fragment, {
    children: [/* @__PURE__ */ v.jsx("div", {
      tabIndex: I ? 0 : -1,
      onFocus: Q,
      ref: m,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ o1.cloneElement(n, {
      ref: z,
      onFocus: U
    }), /* @__PURE__ */ v.jsx("div", {
      tabIndex: I ? 0 : -1,
      onFocus: Q,
      ref: w,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (PA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: zf,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: E.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: E.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: E.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: E.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: E.func,
  /**
   * If `true`, focus is locked.
   */
  open: E.bool.isRequired
});
process.env.NODE_ENV !== "production" && (PA.propTypes = cE(PA.propTypes));
function DZ(e) {
  return typeof e == "function" ? e() : e;
}
const FA = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const {
    children: a,
    container: s,
    disablePortal: g = !1
  } = n, [c, I] = o1.useState(null), h = _i(/* @__PURE__ */ o1.isValidElement(a) ? a.ref : null, i);
  if (Lc(() => {
    g || I(DZ(s) || document.body);
  }, [s, g]), Lc(() => {
    if (c && !g)
      return G7(i, c), () => {
        G7(i, null);
      };
  }, [i, c, g]), g) {
    if (/* @__PURE__ */ o1.isValidElement(a)) {
      const m = {
        ref: h
      };
      return /* @__PURE__ */ o1.cloneElement(a, m);
    }
    return /* @__PURE__ */ v.jsx(o1.Fragment, {
      children: a
    });
  }
  return /* @__PURE__ */ v.jsx(o1.Fragment, {
    children: c && /* @__PURE__ */ yM.createPortal(a, c)
  });
});
process.env.NODE_ENV !== "production" && (FA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: E.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: E.oneOfType([vf, E.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: E.bool
});
process.env.NODE_ENV !== "production" && (FA.propTypes = cE(FA.propTypes));
const kZ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], jZ = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ET = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = r6(), s = {
    enter: a.transitions.duration.enteringScreen,
    exit: a.transitions.duration.leavingScreen
  }, {
    addEndListener: g,
    appear: c = !0,
    children: I,
    easing: h,
    in: m,
    onEnter: w,
    onEntered: x,
    onEntering: M,
    onExit: O,
    onExited: k,
    onExiting: z,
    style: N,
    timeout: U = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Q = N0
  } = n, _ = Dt(n, kZ), X = o1.useRef(null), B = _i(X, I.ref, i), Z = (d1) => (S1) => {
    if (d1) {
      const h1 = X.current;
      S1 === void 0 ? d1(h1) : d1(h1, S1);
    }
  }, Y = Z(M), V = Z((d1, S1) => {
    ST(d1);
    const h1 = NA({
      style: N,
      timeout: U,
      easing: h
    }, {
      mode: "enter"
    });
    d1.style.webkitTransition = a.transitions.create("opacity", h1), d1.style.transition = a.transitions.create("opacity", h1), w && w(d1, S1);
  }), J = Z(x), e1 = Z(z), f1 = Z((d1) => {
    const S1 = NA({
      style: N,
      timeout: U,
      easing: h
    }, {
      mode: "exit"
    });
    d1.style.webkitTransition = a.transitions.create("opacity", S1), d1.style.transition = a.transitions.create("opacity", S1), O && O(d1);
  }), v1 = Z(k), a1 = (d1) => {
    g && g(X.current, d1);
  };
  return /* @__PURE__ */ v.jsx(Q, k1({
    appear: c,
    in: m,
    nodeRef: X,
    onEnter: V,
    onEntered: J,
    onEntering: Y,
    onExit: f1,
    onExited: v1,
    onExiting: e1,
    addEndListener: a1,
    timeout: U
  }, _, {
    children: (d1, S1) => /* @__PURE__ */ o1.cloneElement(I, k1({
      style: k1({
        opacity: 0,
        visibility: d1 === "exited" && !m ? "hidden" : void 0
      }, jZ[d1], N, I.props.style),
      ref: B
    }, S1))
  }));
});
process.env.NODE_ENV !== "production" && (ET.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: E.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: E.bool,
  /**
   * A single child content element.
   */
  children: zf.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: E.oneOfType([E.shape({
    enter: E.string,
    exit: E.string
  }), E.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: E.bool,
  /**
   * @ignore
   */
  onEnter: E.func,
  /**
   * @ignore
   */
  onEntered: E.func,
  /**
   * @ignore
   */
  onEntering: E.func,
  /**
   * @ignore
   */
  onExit: E.func,
  /**
   * @ignore
   */
  onExited: E.func,
  /**
   * @ignore
   */
  onExiting: E.func,
  /**
   * @ignore
   */
  style: E.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: E.oneOfType([E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })])
});
function zZ(e) {
  return lr("MuiBackdrop", e);
}
y2("MuiBackdrop", ["root", "invisible"]);
const NZ = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], PZ = (e) => {
  const {
    classes: n,
    invisible: i
  } = e;
  return Qr({
    root: ["root", i && "invisible"]
  }, zZ, n);
}, FZ = kn("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.invisible && n.invisible];
  }
})(({
  ownerState: e
}) => k1({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), MT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  var a, s, g;
  const c = jr({
    props: n,
    name: "MuiBackdrop"
  }), {
    children: I,
    className: h,
    component: m = "div",
    components: w = {},
    componentsProps: x = {},
    invisible: M = !1,
    open: O,
    slotProps: k = {},
    slots: z = {},
    TransitionComponent: N = ET,
    transitionDuration: U
  } = c, Q = Dt(c, NZ), _ = k1({}, c, {
    component: m,
    invisible: M
  }), X = PZ(_), B = (a = k.root) != null ? a : x.root;
  return /* @__PURE__ */ v.jsx(N, k1({
    in: O,
    timeout: U
  }, Q, {
    children: /* @__PURE__ */ v.jsx(FZ, k1({
      "aria-hidden": !0
    }, B, {
      as: (s = (g = z.root) != null ? g : w.Root) != null ? s : m,
      className: tn(X.root, h, B == null ? void 0 : B.className),
      ownerState: k1({}, _, B == null ? void 0 : B.ownerState),
      classes: X,
      ref: i,
      children: I
    }))
  }));
});
process.env.NODE_ENV !== "production" && (MT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: E.shape({
    Root: E.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: E.shape({
    root: E.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: E.bool,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: E.shape({
    root: E.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: E.shape({
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: E.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: E.oneOfType([E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })])
});
function BZ(e) {
  return typeof e == "function" ? e() : e;
}
function HZ(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const UZ = new SZ();
function WZ(e) {
  const {
    container: n,
    disableEscapeKeyDown: i = !1,
    disableScrollLock: a = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: s = UZ,
    closeAfterTransition: g = !1,
    onTransitionEnter: c,
    onTransitionExited: I,
    children: h,
    onClose: m,
    open: w,
    rootRef: x
  } = e, M = o1.useRef({}), O = o1.useRef(null), k = o1.useRef(null), z = _i(k, x), [N, U] = o1.useState(!w), Q = HZ(h);
  let _ = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (_ = !1);
  const X = () => si(O.current), B = () => (M.current.modalRef = k.current, M.current.mount = O.current, M.current), Z = () => {
    s.mount(B(), {
      disableScrollLock: a
    }), k.current && (k.current.scrollTop = 0);
  }, Y = vc(() => {
    const h1 = BZ(n) || X().body;
    s.add(B(), h1), k.current && Z();
  }), V = o1.useCallback(() => s.isTopModal(B()), [s]), J = vc((h1) => {
    O.current = h1, h1 && (w && V() ? Z() : k.current && If(k.current, _));
  }), e1 = o1.useCallback(() => {
    s.remove(B(), _);
  }, [_, s]);
  o1.useEffect(() => () => {
    e1();
  }, [e1]), o1.useEffect(() => {
    w ? Y() : (!Q || !g) && e1();
  }, [w, e1, Q, g, Y]);
  const f1 = (h1) => (L1) => {
    var c1;
    (c1 = h1.onKeyDown) == null || c1.call(h1, L1), !(L1.key !== "Escape" || L1.which === 229 || // Wait until IME is settled.
    !V()) && (i || (L1.stopPropagation(), m && m(L1, "escapeKeyDown")));
  }, v1 = (h1) => (L1) => {
    var c1;
    (c1 = h1.onClick) == null || c1.call(h1, L1), L1.target === L1.currentTarget && m && m(L1, "backdropClick");
  };
  return {
    getRootProps: (h1 = {}) => {
      const L1 = hE(e);
      delete L1.onTransitionEnter, delete L1.onTransitionExited;
      const c1 = k1({}, L1, h1);
      return k1({
        role: "presentation"
      }, c1, {
        onKeyDown: f1(c1),
        ref: z
      });
    },
    getBackdropProps: (h1 = {}) => {
      const L1 = h1;
      return k1({
        "aria-hidden": !0
      }, L1, {
        onClick: v1(L1),
        open: w
      });
    },
    getTransitionProps: () => {
      const h1 = () => {
        U(!1), c && c();
      }, L1 = () => {
        U(!0), I && I(), g && e1();
      };
      return {
        onEnter: qb(h1, h == null ? void 0 : h.props.onEnter),
        onExited: qb(L1, h == null ? void 0 : h.props.onExited)
      };
    },
    rootRef: z,
    portalRef: J,
    isTopModal: V,
    exited: N,
    hasTransition: Q
  };
}
function _Z(e) {
  return lr("MuiModal", e);
}
y2("MuiModal", ["root", "hidden", "backdrop"]);
const VZ = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], KZ = (e) => {
  const {
    open: n,
    exited: i,
    classes: a
  } = e;
  return Qr({
    root: ["root", !n && i && "hidden"],
    backdrop: ["backdrop"]
  }, _Z, a);
}, JZ = kn("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, !i.open && i.exited && n.hidden];
  }
})(({
  theme: e,
  ownerState: n
}) => k1({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !n.open && n.exited && {
  visibility: "hidden"
})), YZ = kn(MT, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, n) => n.backdrop
})({
  zIndex: -1
}), TT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  var a, s, g, c, I, h;
  const m = jr({
    name: "MuiModal",
    props: n
  }), {
    BackdropComponent: w = YZ,
    BackdropProps: x,
    className: M,
    closeAfterTransition: O = !1,
    children: k,
    container: z,
    component: N,
    components: U = {},
    componentsProps: Q = {},
    disableAutoFocus: _ = !1,
    disableEnforceFocus: X = !1,
    disableEscapeKeyDown: B = !1,
    disablePortal: Z = !1,
    disableRestoreFocus: Y = !1,
    disableScrollLock: V = !1,
    hideBackdrop: J = !1,
    keepMounted: e1 = !1,
    onBackdropClick: f1,
    open: v1,
    slotProps: a1,
    slots: d1
    // eslint-disable-next-line react/prop-types
  } = m, S1 = Dt(m, VZ), h1 = k1({}, m, {
    closeAfterTransition: O,
    disableAutoFocus: _,
    disableEnforceFocus: X,
    disableEscapeKeyDown: B,
    disablePortal: Z,
    disableRestoreFocus: Y,
    disableScrollLock: V,
    hideBackdrop: J,
    keepMounted: e1
  }), {
    getRootProps: L1,
    getBackdropProps: c1,
    getTransitionProps: b1,
    portalRef: t1,
    isTopModal: C1,
    exited: w1,
    hasTransition: E1
  } = WZ(k1({}, h1, {
    rootRef: i
  })), V1 = k1({}, h1, {
    exited: w1
  }), K1 = KZ(V1), B1 = {};
  if (k.props.tabIndex === void 0 && (B1.tabIndex = "-1"), E1) {
    const {
      onEnter: $1,
      onExited: y1
    } = b1();
    B1.onEnter = $1, B1.onExited = y1;
  }
  const te = (a = (s = d1 == null ? void 0 : d1.root) != null ? s : U.Root) != null ? a : JZ, R1 = (g = (c = d1 == null ? void 0 : d1.backdrop) != null ? c : U.Backdrop) != null ? g : w, x1 = (I = a1 == null ? void 0 : a1.root) != null ? I : Q.root, J1 = (h = a1 == null ? void 0 : a1.backdrop) != null ? h : Q.backdrop, X1 = Rc({
    elementType: te,
    externalSlotProps: x1,
    externalForwardedProps: S1,
    getSlotProps: L1,
    additionalProps: {
      ref: i,
      as: N
    },
    ownerState: V1,
    className: tn(M, x1 == null ? void 0 : x1.className, K1 == null ? void 0 : K1.root, !V1.open && V1.exited && (K1 == null ? void 0 : K1.hidden))
  }), D1 = Rc({
    elementType: R1,
    externalSlotProps: J1,
    additionalProps: x,
    getSlotProps: ($1) => c1(k1({}, $1, {
      onClick: (y1) => {
        f1 && f1(y1), $1 != null && $1.onClick && $1.onClick(y1);
      }
    })),
    className: tn(J1 == null ? void 0 : J1.className, x == null ? void 0 : x.className, K1 == null ? void 0 : K1.backdrop),
    ownerState: V1
  });
  return !e1 && !v1 && (!E1 || w1) ? null : /* @__PURE__ */ v.jsx(FA, {
    ref: t1,
    container: z,
    disablePortal: Z,
    children: /* @__PURE__ */ v.jsxs(te, k1({}, X1, {
      children: [!J && w ? /* @__PURE__ */ v.jsx(R1, k1({}, D1)) : null, /* @__PURE__ */ v.jsx(PA, {
        disableEnforceFocus: X,
        disableAutoFocus: _,
        disableRestoreFocus: Y,
        isEnabled: C1,
        open: v1,
        children: /* @__PURE__ */ o1.cloneElement(k, B1)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (TT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: E.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: E.object,
  /**
   * A single child content element.
   */
  children: zf.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: E.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: E.shape({
    Backdrop: E.elementType,
    Root: E.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: E.shape({
    backdrop: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: E.oneOfType([vf, E.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: E.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: E.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: E.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: E.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: E.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: E.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: E.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: E.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: E.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: E.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: E.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: E.func,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: E.shape({
    backdrop: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: E.shape({
    backdrop: E.elementType,
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object])
});
function QZ(e) {
  return lr("MuiPaper", e);
}
y2("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const XZ = ["className", "component", "elevation", "square", "variant"], GZ = (e) => {
  const {
    square: n,
    elevation: i,
    variant: a,
    classes: s
  } = e, g = {
    root: ["root", a, !n && "rounded", a === "elevation" && `elevation${i}`]
  };
  return Qr(g, QZ, s);
}, qZ = kn("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, n[i.variant], !i.square && n.rounded, i.variant === "elevation" && n[`elevation${i.elevation}`]];
  }
})(({
  theme: e,
  ownerState: n
}) => {
  var i;
  return k1({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !n.square && {
    borderRadius: e.shape.borderRadius
  }, n.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, n.variant === "elevation" && k1({
    boxShadow: (e.vars || e).shadows[n.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${oi("#fff", gw(n.elevation))}, ${oi("#fff", gw(n.elevation))})`
  }, e.vars && {
    backgroundImage: (i = e.vars.overlays) == null ? void 0 : i[n.elevation]
  }));
}), LT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiPaper"
  }), {
    className: s,
    component: g = "div",
    elevation: c = 1,
    square: I = !1,
    variant: h = "elevation"
  } = a, m = Dt(a, XZ), w = k1({}, a, {
    component: g,
    elevation: c,
    square: I,
    variant: h
  }), x = GZ(w);
  return process.env.NODE_ENV !== "production" && r6().shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ v.jsx(qZ, k1({
    as: g,
    ownerState: w,
    className: tn(x.root, s),
    ref: i
  }, m));
});
process.env.NODE_ENV !== "production" && (LT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Fc(IE, (e) => {
    const {
      elevation: n,
      variant: i
    } = e;
    return n > 0 && i === "outlined" ? new Error(`MUI: Combining \`elevation={${n}}\` with \`variant="${i}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: E.oneOfType([E.oneOf(["elevation", "outlined"]), E.string])
});
function ZZ(e) {
  return lr("MuiPopover", e);
}
y2("MuiPopover", ["root", "paper"]);
const $Z = ["onEntering"], e$ = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], t$ = ["slotProps"];
function qx(e, n) {
  let i = 0;
  return typeof n == "number" ? i = n : n === "center" ? i = e.height / 2 : n === "bottom" && (i = e.height), i;
}
function Zx(e, n) {
  let i = 0;
  return typeof n == "number" ? i = n : n === "center" ? i = e.width / 2 : n === "right" && (i = e.width), i;
}
function $x(e) {
  return [e.horizontal, e.vertical].map((n) => typeof n == "number" ? `${n}px` : n).join(" ");
}
function CA(e) {
  return typeof e == "function" ? e() : e;
}
const n$ = (e) => {
  const {
    classes: n
  } = e;
  return Qr({
    root: ["root"],
    paper: ["paper"]
  }, ZZ, n);
}, r$ = kn(TT, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({}), RT = kn(LT, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, n) => n.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), OT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  var a, s, g;
  const c = jr({
    props: n,
    name: "MuiPopover"
  }), {
    action: I,
    anchorEl: h,
    anchorOrigin: m = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: w,
    anchorReference: x = "anchorEl",
    children: M,
    className: O,
    container: k,
    elevation: z = 8,
    marginThreshold: N = 16,
    open: U,
    PaperProps: Q = {},
    slots: _,
    slotProps: X,
    transformOrigin: B = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: Z = Hm,
    transitionDuration: Y = "auto",
    TransitionProps: {
      onEntering: V
    } = {},
    disableScrollLock: J = !1
  } = c, e1 = Dt(c.TransitionProps, $Z), f1 = Dt(c, e$), v1 = (a = X == null ? void 0 : X.paper) != null ? a : Q, a1 = o1.useRef(), d1 = _i(a1, v1.ref), S1 = k1({}, c, {
    anchorOrigin: m,
    anchorReference: x,
    elevation: z,
    marginThreshold: N,
    externalPaperSlotProps: v1,
    transformOrigin: B,
    TransitionComponent: Z,
    transitionDuration: Y,
    TransitionProps: e1
  }), h1 = n$(S1), L1 = o1.useCallback(() => {
    if (x === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (w || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), w;
    const $1 = CA(h), y1 = $1 && $1.nodeType === 1 ? $1 : si(a1.current).body, ie = y1.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ae = y1.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ae.top === 0 && ae.left === 0 && ae.right === 0 && ae.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: ie.top + qx(ie, m.vertical),
      left: ie.left + Zx(ie, m.horizontal)
    };
  }, [h, m.horizontal, m.vertical, w, x]), c1 = o1.useCallback(($1) => ({
    vertical: qx($1, B.vertical),
    horizontal: Zx($1, B.horizontal)
  }), [B.horizontal, B.vertical]), b1 = o1.useCallback(($1) => {
    const y1 = {
      width: $1.offsetWidth,
      height: $1.offsetHeight
    }, ie = c1(y1);
    if (x === "none")
      return {
        top: null,
        left: null,
        transformOrigin: $x(ie)
      };
    const ae = L1();
    let H1 = ae.top - ie.vertical, Y1 = ae.left - ie.horizontal;
    const me = H1 + y1.height, ut = Y1 + y1.width, Qe = yf(CA(h)), Ae = Qe.innerHeight - N, Bt = Qe.innerWidth - N;
    if (N !== null && H1 < N) {
      const ke = H1 - N;
      H1 -= ke, ie.vertical += ke;
    } else if (N !== null && me > Ae) {
      const ke = me - Ae;
      H1 -= ke, ie.vertical += ke;
    }
    if (process.env.NODE_ENV !== "production" && y1.height > Ae && y1.height && Ae && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${y1.height - Ae}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), N !== null && Y1 < N) {
      const ke = Y1 - N;
      Y1 -= ke, ie.horizontal += ke;
    } else if (ut > Bt) {
      const ke = ut - Bt;
      Y1 -= ke, ie.horizontal += ke;
    }
    return {
      top: `${Math.round(H1)}px`,
      left: `${Math.round(Y1)}px`,
      transformOrigin: $x(ie)
    };
  }, [h, x, L1, c1, N]), [t1, C1] = o1.useState(U), w1 = o1.useCallback(() => {
    const $1 = a1.current;
    if (!$1)
      return;
    const y1 = b1($1);
    y1.top !== null && ($1.style.top = y1.top), y1.left !== null && ($1.style.left = y1.left), $1.style.transformOrigin = y1.transformOrigin, C1(!0);
  }, [b1]);
  o1.useEffect(() => (J && window.addEventListener("scroll", w1), () => window.removeEventListener("scroll", w1)), [h, J, w1]);
  const E1 = ($1, y1) => {
    V && V($1, y1), w1();
  }, V1 = () => {
    C1(!1);
  };
  o1.useEffect(() => {
    U && w1();
  }), o1.useImperativeHandle(I, () => U ? {
    updatePosition: () => {
      w1();
    }
  } : null, [U, w1]), o1.useEffect(() => {
    if (!U)
      return;
    const $1 = ZP(() => {
      w1();
    }), y1 = yf(h);
    return y1.addEventListener("resize", $1), () => {
      $1.clear(), y1.removeEventListener("resize", $1);
    };
  }, [h, U, w1]);
  let K1 = Y;
  Y === "auto" && !Z.muiSupportAuto && (K1 = void 0);
  const B1 = k || (h ? si(CA(h)).body : void 0), te = (s = _ == null ? void 0 : _.root) != null ? s : r$, R1 = (g = _ == null ? void 0 : _.paper) != null ? g : RT, x1 = Rc({
    elementType: R1,
    externalSlotProps: k1({}, v1, {
      style: t1 ? v1.style : k1({}, v1.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: z,
      ref: d1
    },
    ownerState: S1,
    className: tn(h1.paper, v1 == null ? void 0 : v1.className)
  }), J1 = Rc({
    elementType: te,
    externalSlotProps: (X == null ? void 0 : X.root) || {},
    externalForwardedProps: f1,
    additionalProps: {
      ref: i,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: B1,
      open: U
    },
    ownerState: S1,
    className: tn(h1.root, O)
  }), {
    slotProps: X1
  } = J1, D1 = Dt(J1, t$);
  return /* @__PURE__ */ v.jsx(te, k1({}, D1, !pE(te) && {
    slotProps: X1,
    disableScrollLock: J
  }, {
    children: /* @__PURE__ */ v.jsx(Z, k1({
      appear: !0,
      in: U,
      onEntering: E1,
      onExited: V1,
      timeout: K1
    }, e1, {
      children: /* @__PURE__ */ v.jsx(R1, k1({}, x1, {
        children: M
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (OT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: gE,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Fc(E.oneOfType([vf, E.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const n = CA(e.anchorEl);
      if (n && n.nodeType === 1) {
        const i = n.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && i.top === 0 && i.left === 0 && i.right === 0 && i.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${n}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: E.shape({
    horizontal: E.oneOfType([E.oneOf(["center", "left", "right"]), E.number]).isRequired,
    vertical: E.oneOfType([E.oneOf(["bottom", "center", "top"]), E.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: E.shape({
    left: E.number.isRequired,
    top: E.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: E.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: E.oneOfType([vf, E.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: E.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: IE,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: E.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: E.func,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: E.shape({
    component: uE
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: E.shape({
    paper: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: E.shape({
    paper: E.elementType,
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: E.shape({
    horizontal: E.oneOfType([E.oneOf(["center", "left", "right"]), E.number]).isRequired,
    vertical: E.oneOfType([E.oneOf(["bottom", "center", "top"]), E.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: E.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: E.oneOfType([E.oneOf(["auto"]), E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: E.object
});
function i$(e) {
  return lr("MuiMenu", e);
}
y2("MuiMenu", ["root", "paper", "list"]);
const a$ = ["onEntering"], o$ = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], s$ = {
  vertical: "top",
  horizontal: "right"
}, l$ = {
  vertical: "top",
  horizontal: "left"
}, u$ = (e) => {
  const {
    classes: n
  } = e;
  return Qr({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, i$, n);
}, c$ = kn(OT, {
  shouldForwardProp: (e) => om(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, n) => n.root
})({}), g$ = kn(RT, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, n) => n.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), f$ = kn(xT, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, n) => n.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), DT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  var a, s;
  const g = jr({
    props: n,
    name: "MuiMenu"
  }), {
    autoFocus: c = !0,
    children: I,
    className: h,
    disableAutoFocusItem: m = !1,
    MenuListProps: w = {},
    onClose: x,
    open: M,
    PaperProps: O = {},
    PopoverClasses: k,
    transitionDuration: z = "auto",
    TransitionProps: {
      onEntering: N
    } = {},
    variant: U = "selectedMenu",
    slots: Q = {},
    slotProps: _ = {}
  } = g, X = Dt(g.TransitionProps, a$), B = Dt(g, o$), Z = hF(), Y = k1({}, g, {
    autoFocus: c,
    disableAutoFocusItem: m,
    MenuListProps: w,
    onEntering: N,
    PaperProps: O,
    transitionDuration: z,
    TransitionProps: X,
    variant: U
  }), V = u$(Y), J = c && !m && M, e1 = o1.useRef(null), f1 = (c1, b1) => {
    e1.current && e1.current.adjustStyleForScrollbar(c1, {
      direction: Z ? "rtl" : "ltr"
    }), N && N(c1, b1);
  }, v1 = (c1) => {
    c1.key === "Tab" && (c1.preventDefault(), x && x(c1, "tabKeyDown"));
  };
  let a1 = -1;
  o1.Children.map(I, (c1, b1) => {
    /* @__PURE__ */ o1.isValidElement(c1) && (process.env.NODE_ENV !== "production" && vA.isFragment(c1) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), c1.props.disabled || (U === "selectedMenu" && c1.props.selected || a1 === -1) && (a1 = b1));
  });
  const d1 = (a = Q.paper) != null ? a : g$, S1 = (s = _.paper) != null ? s : O, h1 = Rc({
    elementType: Q.root,
    externalSlotProps: _.root,
    ownerState: Y,
    className: [V.root, h]
  }), L1 = Rc({
    elementType: d1,
    externalSlotProps: S1,
    ownerState: Y,
    className: V.paper
  });
  return /* @__PURE__ */ v.jsx(c$, k1({
    onClose: x,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: Z ? "right" : "left"
    },
    transformOrigin: Z ? s$ : l$,
    slots: {
      paper: d1,
      root: Q.root
    },
    slotProps: {
      root: h1,
      paper: L1
    },
    open: M,
    ref: i,
    transitionDuration: z,
    TransitionProps: k1({
      onEntering: f1
    }, X),
    ownerState: Y
  }, B, {
    classes: k,
    children: /* @__PURE__ */ v.jsx(f$, k1({
      onKeyDown: v1,
      actions: e1,
      autoFocus: c && (a1 === -1 || m),
      autoFocusItem: J,
      variant: U
    }, w, {
      className: tn(V.list, w.className),
      children: I
    }))
  }));
});
process.env.NODE_ENV !== "production" && (DT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: E.oneOfType([vf, E.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: E.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: E.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: E.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: E.func,
  /**
   * If `true`, the component is shown.
   */
  open: E.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: E.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: E.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: E.shape({
    paper: E.oneOfType([E.func, E.object]),
    root: E.oneOfType([E.func, E.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: E.shape({
    paper: E.elementType,
    root: E.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: E.oneOfType([E.oneOf(["auto"]), E.number, E.shape({
    appear: E.number,
    enter: E.number,
    exit: E.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: E.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: E.oneOf(["menu", "selectedMenu"])
});
const eS = y2("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), tS = y2("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function d$(e) {
  return lr("MuiTypography", e);
}
y2("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const C$ = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], A$ = (e) => {
  const {
    align: n,
    gutterBottom: i,
    noWrap: a,
    paragraph: s,
    variant: g,
    classes: c
  } = e, I = {
    root: ["root", g, e.align !== "inherit" && `align${sr(n)}`, i && "gutterBottom", a && "noWrap", s && "paragraph"]
  };
  return Qr(I, d$, c);
}, I$ = kn("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, n) => {
    const {
      ownerState: i
    } = e;
    return [n.root, i.variant && n[i.variant], i.align !== "inherit" && n[`align${sr(i.align)}`], i.noWrap && n.noWrap, i.gutterBottom && n.gutterBottom, i.paragraph && n.paragraph];
  }
})(({
  theme: e,
  ownerState: n
}) => k1({
  margin: 0
}, n.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, n.variant !== "inherit" && e.typography[n.variant], n.align !== "inherit" && {
  textAlign: n.align
}, n.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, n.gutterBottom && {
  marginBottom: "0.35em"
}, n.paragraph && {
  marginBottom: 16
})), nS = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, p$ = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, h$ = (e) => p$[e] || e, kT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiTypography"
  }), s = h$(a.color), g = nm(k1({}, a, {
    color: s
  })), {
    align: c = "inherit",
    className: I,
    component: h,
    gutterBottom: m = !1,
    noWrap: w = !1,
    paragraph: x = !1,
    variant: M = "body1",
    variantMapping: O = nS
  } = g, k = Dt(g, C$), z = k1({}, g, {
    align: c,
    color: s,
    className: I,
    component: h,
    gutterBottom: m,
    noWrap: w,
    paragraph: x,
    variant: M,
    variantMapping: O
  }), N = h || (x ? "p" : O[M] || nS[M]) || "span", U = A$(z);
  return /* @__PURE__ */ v.jsx(I$, k1({
    as: N,
    ref: i,
    ownerState: z,
    className: tn(U.root, I)
  }, k));
});
process.env.NODE_ENV !== "production" && (kT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: E.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: E.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: E.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: E.oneOfType([E.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), E.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: E.object
});
const rS = y2("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function m$(e) {
  return lr("MuiMenuItem", e);
}
const rf = y2("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), v$ = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], y$ = (e, n) => {
  const {
    ownerState: i
  } = e;
  return [n.root, i.dense && n.dense, i.divider && n.divider, !i.disableGutters && n.gutters];
}, b$ = (e) => {
  const {
    disabled: n,
    dense: i,
    divider: a,
    disableGutters: s,
    selected: g,
    classes: c
  } = e, h = Qr({
    root: ["root", i && "dense", n && "disabled", !s && "gutters", a && "divider", g && "selected"]
  }, m$, c);
  return k1({}, c, h);
}, w$ = kn(xm, {
  shouldForwardProp: (e) => om(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: y$
})(({
  theme: e,
  ownerState: n
}) => k1({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !n.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, n.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${rf.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : oi(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${rf.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : oi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${rf.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : oi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : oi(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${rf.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${rf.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${eS.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${eS.inset}`]: {
    marginLeft: 52
  },
  [`& .${rS.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${rS.inset}`]: {
    paddingLeft: 36
  },
  [`& .${tS.root}`]: {
    minWidth: 36
  }
}, !n.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, n.dense && k1({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${tS.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), jT = /* @__PURE__ */ o1.forwardRef(function(n, i) {
  const a = jr({
    props: n,
    name: "MuiMenuItem"
  }), {
    autoFocus: s = !1,
    component: g = "li",
    dense: c = !1,
    divider: I = !1,
    disableGutters: h = !1,
    focusVisibleClassName: m,
    role: w = "menuitem",
    tabIndex: x,
    className: M
  } = a, O = Dt(a, v$), k = o1.useContext(zA), z = o1.useMemo(() => ({
    dense: c || k.dense || !1,
    disableGutters: h
  }), [k.dense, c, h]), N = o1.useRef(null);
  Lc(() => {
    s && (N.current ? N.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [s]);
  const U = k1({}, a, {
    dense: z.dense,
    divider: I,
    disableGutters: h
  }), Q = b$(a), _ = _i(N, i);
  let X;
  return a.disabled || (X = x !== void 0 ? x : -1), /* @__PURE__ */ v.jsx(zA.Provider, {
    value: z,
    children: /* @__PURE__ */ v.jsx(w$, k1({
      ref: _,
      role: w,
      tabIndex: X,
      component: g,
      focusVisibleClassName: tn(Q.focusVisible, m),
      className: tn(Q.root, M)
    }, O, {
      ownerState: U,
      classes: Q
    }))
  });
});
process.env.NODE_ENV !== "production" && (jT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: E.bool,
  /**
   * The content of the component.
   */
  children: E.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: E.object,
  /**
   * @ignore
   */
  className: E.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: E.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: E.bool,
  /**
   * @ignore
   */
  disabled: E.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: E.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: E.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: E.string,
  /**
   * @ignore
   */
  role: E.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: E.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: E.oneOfType([E.arrayOf(E.oneOfType([E.func, E.object, E.bool])), E.func, E.object]),
  /**
   * @default 0
   */
  tabIndex: E.number
});
const x$ = kn(jT)({
  display: "flex",
  justifyContent: "space-between",
  paddingLeft: "4px",
  paddingRight: "4px"
}), S$ = kn(kT)({
  paddingLeft: "8px",
  paddingRight: "8px",
  textAlign: "left"
}), E$ = kn(nE)({
  display: "flex"
}), M$ = ja(
  function({
    MenuItemProps: n,
    className: i,
    label: a,
    leftIcon: s,
    renderLabel: g,
    rightIcon: c,
    ...I
  }, h) {
    return /* @__PURE__ */ v.jsxs(
      x$,
      {
        ...n,
        ref: h,
        className: i,
        ...I,
        children: [
          /* @__PURE__ */ v.jsxs(E$, { children: [
            s,
            g ? g() : /* @__PURE__ */ v.jsx(S$, { children: a })
          ] }),
          c
        ]
      }
    );
  }
), T$ = ja(
  function(n, i) {
    const {
      parentMenuOpen: a,
      label: s,
      renderLabel: g,
      rightIcon: c = /* @__PURE__ */ v.jsx(De, { icon: "chevronRight" }),
      leftIcon: I = null,
      children: h,
      className: m,
      tabIndex: w,
      ContainerProps: x = {},
      slotProps: M,
      MenuProps: O,
      ...k
    } = n, { ref: z, ...N } = x, U = Cn(null);
    Mb(i, () => U.current);
    const Q = Cn(null);
    Mb(
      z,
      () => Q.current
    );
    const _ = Cn(null), [X, B] = gt(!1), Z = (a1) => {
      B(!0), N.onMouseEnter && N.onMouseEnter(a1);
    }, Y = (a1) => {
      B(!1), N.onMouseLeave && N.onMouseLeave(a1);
    }, V = () => {
      var d1;
      const a1 = ((d1 = Q.current) == null ? void 0 : d1.ownerDocument.activeElement) ?? null;
      if (_.current == null)
        return !1;
      for (const S1 of _.current.children)
        if (S1 === a1)
          return !0;
      return !1;
    }, J = (a1) => {
      a1.target === Q.current && B(!0), N.onFocus && N.onFocus(a1);
    }, e1 = (a1) => {
      var S1, h1, L1;
      if (a1.key === "Escape")
        return;
      V() && a1.stopPropagation();
      const d1 = (S1 = Q.current) == null ? void 0 : S1.ownerDocument.activeElement;
      if (a1.key === "ArrowLeft" && V() && ((h1 = Q.current) == null || h1.focus()), a1.key === "ArrowRight" && a1.target === Q.current && a1.target === d1) {
        const c1 = (L1 = _.current) == null ? void 0 : L1.children[0];
        c1 == null || c1.focus();
      }
    }, f1 = X && a;
    let v1;
    return n.disabled || (v1 = w !== void 0 ? w : -1), /* @__PURE__ */ v.jsxs(
      "div",
      {
        ...N,
        ref: Q,
        onFocus: J,
        tabIndex: v1,
        onMouseEnter: Z,
        onMouseLeave: Y,
        onKeyDown: e1,
        children: [
          /* @__PURE__ */ v.jsx(
            M$,
            {
              MenuItemProps: k,
              className: m,
              ref: U,
              leftIcon: I,
              rightIcon: c,
              label: s,
              renderLabel: g
            }
          ),
          /* @__PURE__ */ v.jsx(
            DT,
            {
              style: { pointerEvents: "none" },
              anchorEl: U.current,
              anchorOrigin: {
                horizontal: "right",
                vertical: "top"
              },
              transformOrigin: {
                horizontal: "left",
                vertical: "top"
              },
              open: f1,
              autoFocus: !1,
              disableAutoFocus: !0,
              disableEnforceFocus: !0,
              onClose: () => {
                B(!1);
              },
              slotProps: M,
              ...O,
              children: /* @__PURE__ */ v.jsx("div", { ref: _, style: { pointerEvents: "auto" }, children: h })
            }
          )
        ]
      }
    );
  }
);
T$.displayName = "NestedMenuItem";
const L$ = ({
  to: e,
  selected: n,
  href: i,
  target: a,
  state: s,
  ...g
}) => {
  const c = a6({
    to: e,
    selected: n,
    href: i,
    target: a,
    state: s
  });
  return /* @__PURE__ */ v.jsx(sz, { ...g, ...c });
}, It1 = q1(mS)(({ theme: e }) => ({
  padding: "16px 0px 16px 0px",
  borderBottom: `solid 1px ${e.palette.common.neutrals[200]}`,
  alignItems: "center"
})), R$ = q1(_1)({
  position: "absolute",
  width: "100%",
  height: "70%",
  display: "flex",
  alignItems: "center",
  alignSelf: "center",
  justifyContent: "center"
}), pt1 = ({
  label: e
}) => /* @__PURE__ */ v.jsx(R$, { children: /* @__PURE__ */ v.jsx(le, { children: e }) }), iS = q1(lz)({
  color: "inherit"
}), ht1 = ({
  to: e,
  selected: n,
  href: i,
  target: a,
  children: s,
  color: g = "inherit",
  label: c,
  iconBefore: I,
  iconAfter: h,
  state: m,
  ...w
}) => {
  const x = a6({
    to: e,
    selected: n,
    href: i,
    target: a,
    state: m
  });
  return /* @__PURE__ */ v.jsx(Ta, { ...w, ...x, children: c || I || h ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    I && /* @__PURE__ */ v.jsx(iS, { sx: { color: g }, children: I }),
    c && /* @__PURE__ */ v.jsx(vS, { sx: { color: g }, children: c }),
    h && /* @__PURE__ */ v.jsx(iS, { sx: { color: g }, children: h })
  ] }) : s });
}, O$ = () => {
  const [e, n] = gt(null);
  return {
    anchorEl: e,
    open: !!e,
    onOpen: (g) => {
      n(g.currentTarget);
    },
    onClose: () => n(null)
  };
};
function mt1({
  id: e,
  menuId: n,
  label: i = "Actions",
  disabled: a,
  sx: s,
  children: g
}) {
  const { anchorEl: c, open: I, onOpen: h, onClose: m } = O$();
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      j2,
      {
        id: e,
        variant: "outlined",
        color: "inherit",
        disabled: a,
        "aria-haspopup": "menu",
        "aria-controls": I ? n : void 0,
        "aria-expanded": I,
        endIcon: /* @__PURE__ */ v.jsx(De, { icon: "chevronDown", fontSize: "small" }),
        onClick: h,
        sx: [
          {
            px: 2,
            flexShrink: 0,
            whiteSpace: "nowrap",
            textTransform: "none",
            color: "text.primary",
            borderColor: "divider",
            bgcolor: I ? "action.selected" : void 0,
            "&:hover": {
              borderColor: "divider",
              bgcolor: I ? "action.selected" : "action.hover"
            },
            "&.Mui-focusVisible": {
              outline: 2,
              outlineColor: "primary.main",
              outlineOffset: 2
            },
            "& .MuiButton-endIcon": {
              transition: (w) => w.transitions.create("transform", {
                duration: w.transitions.duration.shorter
              }),
              transform: I ? "rotate(180deg)" : "none"
            }
          },
          ...Array.isArray(s) ? s : [s]
        ],
        children: i
      }
    ),
    /* @__PURE__ */ v.jsx(
      U7,
      {
        anchorEl: c,
        open: I,
        onClose: m,
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        transformOrigin: { vertical: "top", horizontal: "right" },
        MenuListProps: { id: n, "aria-labelledby": e, onClick: m },
        slotProps: {
          paper: {
            sx: {
              mt: 0.5,
              minWidth: 200,
              "& .MuiMenuItem-root": { minHeight: 44, px: 2, gap: 1.5 }
            }
          }
        },
        children: g
      }
    )
  ] });
}
const D$ = q1(yS)(({ theme: e }) => {
  var n, i;
  return {
    borderColor: (i = (n = e.palette) == null ? void 0 : n.primary) == null ? void 0 : i.main,
    borderWidth: "2px",
    borderStyle: "solid"
  };
}), k$ = q1("span")({
  minWidth: "20px"
}), j$ = (e, n) => n ? /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
  /* @__PURE__ */ v.jsx("span", { children: "|" }),
  e == null && /* @__PURE__ */ v.jsx(_h, { width: 20 }),
  e != null && /* @__PURE__ */ v.jsx(k$, { children: e })
] }) : "", z$ = q1(bS)({
  flexDirection: "row",
  columnGap: "8px"
}), N$ = ({
  label: e,
  isCountVisible: n,
  count: i,
  ...a
}) => {
  const s = Cn(i);
  vn(() => {
    i != null && (s.current = i);
  }, [i]);
  const g = i ?? s.current, c = /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx("span", { children: e }),
    " ",
    j$(g, n)
  ] });
  return /* @__PURE__ */ v.jsx(z$, { label: c, ...a });
}, vt1 = ({
  options: e,
  selectedOptionValue: n,
  onNavigationClick: i,
  sx: a,
  singleTabSx: s,
  variant: g = "scrollable",
  ariaLabel: c = "tabs"
}) => {
  const I = (h, m) => {
    i && i(m);
  };
  return /* @__PURE__ */ v.jsx(
    wS,
    {
      value: n || !1,
      onChange: I,
      "aria-label": c,
      variant: g,
      allowScrollButtonsMobile: !0,
      scrollButtons: "auto",
      sx: a,
      children: e.map(({ label: h, value: m, count: w, isCountVisible: x, dataTestId: M }) => /* @__PURE__ */ v.jsx(
        N$,
        {
          label: h,
          count: w,
          isCountVisible: x,
          value: m,
          sx: s,
          "data-testid": M
        },
        m
      ))
    }
  );
}, qo = (e, n) => jE(e).typography[n], Um = (e) => Tf(e.palette.common.black, e.palette.action.hoverOpacity), zT = (e) => `${e / 16}rem`, z7 = 48, _f = 32, P$ = 320, NT = 34, yt1 = q1("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: e.spacing(2),
  flexWrap: "wrap",
  padding: e.spacing(0, 2.5),
  borderBottom: `1px solid ${e.palette.divider}`
})), bt1 = q1("div")(({ theme: e }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: e.spacing(1),
  flexWrap: "wrap",
  padding: e.spacing(1.5, 2.5),
  borderBottom: `1px solid ${e.palette.common.neutrals[200]}`
})), PT = q1(Kh)(({ theme: e }) => ({
  height: _f,
  // Centres the 32px pill on the 34px search box while the toolbar stays top-aligned.
  marginTop: 1,
  padding: e.spacing(0, 1.5),
  gap: e.spacing(0.75),
  flexShrink: 0,
  whiteSpace: "nowrap",
  borderRadius: e.shape.borderRadius * 10,
  border: `1px solid ${e.palette.common.neutrals[200]}`,
  fontFamily: e.typography.body1.fontFamily,
  fontSize: e.typography.pxToRem(14),
  lineHeight: 1.5,
  color: e.palette.text.primary,
  "&:hover": { backgroundColor: Um(e) },
  "&.Mui-focusVisible": {
    outline: `2px solid ${e.palette.primary.main}`,
    outlineOffset: 2
  }
})), F$ = q1(PT)(({ theme: e }) => ({
  gap: e.spacing(0.5),
  borderStyle: "dashed",
  borderColor: e.palette.common.neutrals[300],
  color: e.palette.secondary.main,
  fontWeight: 600,
  "&:hover": { backgroundColor: Tf(e.palette.secondary.main, 0.1) }
})), wt1 = q1(PT)(({ theme: e }) => ({
  width: _f,
  padding: 0,
  borderRadius: e.shape.borderRadius,
  color: e.palette.secondary.main,
  "&:hover": { backgroundColor: Tf(e.palette.secondary.main, 0.1) },
  '&[aria-pressed="true"]': {
    color: e.palette.common.white,
    backgroundColor: e.palette.secondary.main,
    borderColor: e.palette.secondary.main
  }
})), xt1 = q1(Kh)(({ theme: e }) => ({
  height: _f,
  padding: e.spacing(0, 1),
  flexShrink: 0,
  whiteSpace: "nowrap",
  borderRadius: e.shape.borderRadius * 10,
  fontFamily: e.typography.body1.fontFamily,
  fontSize: e.typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: 1.5,
  color: e.palette.secondary.main,
  "&:hover": { backgroundColor: Tf(e.palette.secondary.main, 0.1) },
  "&.Mui-focusVisible": {
    outline: `2px solid ${e.palette.primary.main}`,
    outlineOffset: 2
  }
})), St1 = q1(v2)(({ theme: e }) => ({
  height: _f,
  paddingLeft: e.spacing(1.75),
  paddingRight: e.spacing(1.75),
  gap: e.spacing(0.75),
  flexShrink: 0,
  fontFamily: e.typography.body1.fontFamily,
  fontSize: e.typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: 1.5
})), B$ = q1(dl)(({ theme: e }) => ({
  ...qo(e, "body2"),
  height: _f,
  borderRadius: e.shape.borderRadius * 10,
  padding: e.spacing(0, 0.5),
  color: e.palette.text.primary,
  backgroundColor: e.brandColors.secondaryContainer,
  border: `1px solid ${e.palette.secondary.main}`,
  "& .MuiChip-icon": {
    color: e.palette.secondary.main,
    fontSize: "inherit"
  },
  "& .MuiChip-deleteIcon": {
    color: e.palette.text.secondary,
    "&:hover": { color: e.palette.text.primary }
  }
})), H$ = q1(wS)(({ theme: e }) => ({
  // Doubled class: the theme's Tabs overrides (72px from `sm` up) apply after these styles.
  "&&": { minHeight: z7, height: z7 },
  "& .MuiTabs-flexContainer": { gap: e.spacing(3) },
  "& .MuiTabs-indicator": {
    height: 2,
    backgroundColor: e.palette.primary.main
  },
  "& .MuiTab-root": {
    minHeight: z7,
    minWidth: 0,
    padding: 0,
    flexDirection: "row",
    gap: e.spacing(1),
    // MUI buttons default to the theme's base (Roboto) family; the header uses the body font.
    fontFamily: e.typography.body1.fontFamily,
    fontSize: zT(16),
    fontWeight: 600,
    lineHeight: 1.5,
    // The ui theme's button case and spacing and its text colours (text.secondary, text.primary):
    // the legacy app's theme replaces them with uppercase, unspaced buttons and darker text.
    textTransform: "none",
    letterSpacing: "0.02857em",
    // Link tabs: an app's global link styles (the legacy app underlines links on hover).
    textDecoration: "none",
    color: e.palette.common.neutrals[500],
    "&.Mui-selected": { color: e.palette.common.neutrals[800] }
  }
})), U$ = q1("span")(({ theme: e }) => ({
  padding: e.spacing(0, 0.875),
  borderRadius: e.shape.borderRadius * 10,
  fontSize: zT(12),
  lineHeight: 1.5,
  fontVariantNumeric: "tabular-nums",
  color: e.palette.common.neutrals[700],
  backgroundColor: e.palette.common.neutrals[100],
  ".Mui-selected > &": {
    color: e.palette.primary.main,
    backgroundColor: Tf(e.palette.primary.main, 0.1)
  }
})), aS = (e) => {
  const { button: n, metaKey: i, ctrlKey: a, shiftKey: s, altKey: g } = e;
  return n > 0 || i || a || s || g;
}, Et1 = ({
  options: e,
  value: n,
  onChange: i,
  "aria-label": a
}) => /* @__PURE__ */ v.jsx(
  H$,
  {
    value: n,
    onChange: (s, g) => {
      const c = e.find((I) => I.value === g);
      c != null && c.href && aS(s) || i(g);
    },
    "aria-label": a,
    variant: "scrollable",
    children: e.map(({ value: s, label: g, count: c, id: I, href: h, ...m }) => /* @__PURE__ */ v.jsx(
      bS,
      {
        value: s,
        id: I,
        "aria-controls": m["aria-controls"],
        ...h ? {
          href: h,
          onClick: (w) => {
            aS(w) || w.preventDefault();
          },
          // Space selects a tab button, but on a link it scrolls the page instead (MUI only
          // clicks non-native buttons on Space): select it on key up, as a button does.
          onKeyDown: (w) => {
            w.key === " " && w.preventDefault();
          },
          onKeyUp: (w) => {
            w.key === " " && w.currentTarget.click();
          }
        } : {},
        label: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
          g,
          c != null && /* @__PURE__ */ v.jsx(U$, { children: c })
        ] })
      },
      s
    ))
  }
), FT = 34, W$ = 36, _$ = q1("div")(({ theme: e }) => ({
  position: "relative",
  flex: `0 1 ${P$}px`,
  minWidth: 0,
  height: NT,
  backgroundColor: e.palette.background.paper,
  border: `1px solid ${e.palette.common.neutrals[200]}`,
  borderRadius: e.shape.borderRadius,
  "&:focus-within": { borderColor: e.palette.primary.main }
})), V$ = q1("div")(({ theme: e }) => ({
  position: "absolute",
  left: 10,
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex",
  color: e.palette.common.neutrals[700]
})), K$ = q1("div")({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  paddingLeft: FT,
  fontSize: 14,
  whiteSpace: "pre",
  overflow: "hidden",
  pointerEvents: "none"
}), J$ = q1("input", {
  shouldForwardProp: (e) => e !== "hasEndAdornment"
})(({ theme: e, hasEndAdornment: n }) => ({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  paddingLeft: FT,
  paddingRight: n ? W$ : e.spacing(1.25),
  border: 0,
  outline: 0,
  backgroundColor: "transparent",
  fontSize: 14,
  fontFamily: "inherit",
  color: e.palette.text.primary,
  "&::placeholder": { color: e.palette.text.secondary, opacity: 1 }
})), Y$ = q1("div")({
  position: "absolute",
  right: 2,
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex"
}), Mt1 = ja(function({ overlay: n, endAdornment: i, sx: a, ...s }, g) {
  return /* @__PURE__ */ v.jsxs(_$, { sx: a, children: [
    /* @__PURE__ */ v.jsx(V$, { children: /* @__PURE__ */ v.jsx(De, { icon: "search", sx: { fontSize: 16 } }) }),
    n != null && /* @__PURE__ */ v.jsx(K$, { "aria-hidden": !0, children: n }),
    /* @__PURE__ */ v.jsx(
      J$,
      {
        ref: g,
        hasEndAdornment: i != null,
        ...s
      }
    ),
    i != null && /* @__PURE__ */ v.jsx(Y$, { children: i })
  ] });
}), Tt1 = ({
  children: e,
  action: n,
  component: i = "div",
  singleRow: a = !1,
  "aria-label": s,
  sx: g = []
}) => /* @__PURE__ */ v.jsxs(
  _1,
  {
    component: i,
    "aria-label": s,
    sx: [
      {
        display: "flex",
        flex: "1 1 0",
        minWidth: 240,
        minHeight: NT,
        flexWrap: "wrap",
        alignItems: "center",
        // Rows pack from the top, the first one centred on the search box: its 32px chips sit
        // 1px into the 34px box height, level with the Filter pill.
        alignContent: "flex-start",
        gap: 1,
        m: 0,
        px: 0,
        py: "1px",
        listStyle: "none",
        // Chip groups render a wrapper span; lay their chips out as items of this row.
        "& > span": { display: "contents" }
      },
      a && {
        flex: "0 1 auto",
        minWidth: 0,
        flexWrap: "nowrap",
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" }
      },
      ...Array.isArray(g) ? g : [g]
    ],
    children: [
      e,
      n
    ]
  }
), Lt1 = ({
  labelKey: e,
  labelValue: n,
  onDelete: i
}) => /* @__PURE__ */ v.jsx(
  B$,
  {
    label: `${e}: ${n}`,
    onDelete: i,
    deleteIcon: /* @__PURE__ */ v.jsx(De, { icon: "close", titleAccess: `Remove ${e}: ${n}` })
  }
), oS = q1("span")(({ theme: e }) => ({
  ...qo(e, "caption"),
  minWidth: 20,
  padding: e.spacing(0, 0.75),
  borderRadius: e.shape.borderRadius * 10,
  textAlign: "center",
  fontVariantNumeric: "tabular-nums",
  color: e.palette.info.contrastText,
  backgroundColor: e.palette.info.main
})), Q$ = q1("label")(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1.25),
  padding: e.spacing(1.25, 2),
  cursor: "pointer",
  '&:hover:not([data-disabled="true"])': {
    backgroundColor: Um(e)
  },
  '&[data-disabled="true"]': {
    cursor: "default",
    color: e.palette.text.disabled
  }
})), X$ = q1("span")(({ theme: e }) => ({
  width: 28,
  height: 28,
  flexShrink: 0,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: e.palette.action.selected,
  color: e.palette.text.secondary,
  ...qo(e, "caption")
})), sS = q1("div")(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(0.75),
  padding: e.spacing(1.25, 2, 0.5),
  ...qo(e, "caption"),
  textTransform: "uppercase",
  color: e.palette.text.secondary
})), AA = 1, G$ = q1(_1)(({ theme: e }) => ({
  position: "sticky",
  top: e.spacing(-AA),
  zIndex: 1,
  marginTop: e.spacing(-AA),
  backgroundColor: e.palette.background.paper,
  padding: e.spacing(0.5 + AA, 2, 1)
})), Hh = {
  "& .MuiOutlinedInput-root": {
    height: 32,
    pl: 1.25,
    borderRadius: 1,
    fontSize: (e) => e.typography.pxToRem(14)
  },
  // Outranks the theme's `.MuiInputBase-input.MuiOutlinedInput-input` padding.
  "& .MuiInputBase-input.MuiOutlinedInput-input": { p: 0 },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "common.neutrals.200"
  },
  "& input::placeholder": { color: "text.secondary", opacity: 1 }
}, lS = 16, p6 = q1("span")(({ theme: e }) => ({
  width: lS,
  height: lS,
  boxSizing: "border-box",
  display: "grid",
  placeItems: "center",
  ".Mui-disabled &": { opacity: 0.5 },
  color: e.palette.common.white
})), q$ = q1(p6)(({ theme: e }) => ({
  borderRadius: e.shape.borderRadius,
  border: `1.5px solid ${e.palette.common.neutrals[600]}`
})), Z$ = q1(p6)(({ theme: e }) => ({
  borderRadius: e.shape.borderRadius,
  backgroundColor: e.palette.secondary.main,
  fontSize: 10
})), $$ = q1(p6)(({ theme: e }) => ({
  borderRadius: "50%",
  border: `1.5px solid ${e.palette.common.neutrals[600]}`
})), e11 = q1(p6)(({ theme: e }) => ({
  borderRadius: "50%",
  border: `2px solid ${e.palette.secondary.main}`,
  "&::after": {
    content: '""',
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: e.palette.secondary.main
  }
})), t11 = q1("div")(({ theme: e }) => ({
  padding: e.spacing(1.5, 2),
  ...qo(e, "body1"),
  color: e.palette.text.secondary
}));
function n11({
  control: e,
  name: n,
  label: i,
  checked: a,
  onChange: s,
  disabled: g = !1,
  secondary: c,
  initials: I,
  title: h,
  describedBy: m
}) {
  const w = e === "radio" ? uz : IA;
  return /* @__PURE__ */ v.jsxs(Q$, { "data-disabled": g, title: h, children: [
    I && /* @__PURE__ */ v.jsx(X$, { "aria-hidden": !0, children: I }),
    /* @__PURE__ */ v.jsxs(_1, { sx: { flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }, children: [
      /* @__PURE__ */ v.jsx(
        le,
        {
          variant: "body1",
          noWrap: !0,
          color: "inherit",
          sx: (x) => ({ ...qo(x, "body1"), fontWeight: 600 }),
          children: i
        }
      ),
      c && /* @__PURE__ */ v.jsx(
        le,
        {
          variant: "caption",
          noWrap: !0,
          color: "text.secondary",
          sx: (x) => qo(x, "caption"),
          children: c
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(
      w,
      {
        icon: e === "radio" ? /* @__PURE__ */ v.jsx($$, {}) : /* @__PURE__ */ v.jsx(q$, {}),
        checkedIcon: e === "radio" ? /* @__PURE__ */ v.jsx(e11, {}) : /* @__PURE__ */ v.jsx(Z$, { children: /* @__PURE__ */ v.jsx(De, { icon: "check", fontSize: "inherit" }) }),
        sx: { p: 0 },
        name: n,
        checked: a,
        disabled: g,
        onChange: s,
        disableRipple: !0,
        inputProps: m ? { "aria-describedby": m } : void 0
      }
    )
  ] });
}
function r11({
  value: e,
  onChange: n,
  placeholder: i,
  label: a,
  onFocus: s,
  onClick: g
}) {
  return /* @__PURE__ */ v.jsx(G$, { children: /* @__PURE__ */ v.jsx(
    Wf,
    {
      size: "small",
      fullWidth: !0,
      sx: Hh,
      value: e,
      onChange: (c) => n(c.target.value),
      onFocus: s,
      onClick: g,
      placeholder: i,
      inputProps: { "aria-label": a },
      InputProps: {
        startAdornment: /* @__PURE__ */ v.jsx(Vh, { position: "start", sx: { mr: 1 }, children: /* @__PURE__ */ v.jsx(
          De,
          {
            icon: "search",
            sx: { fontSize: 14, color: "common.neutrals.700" }
          }
        ) })
      }
    }
  ) });
}
function Rt1({
  noun: e,
  searchLabel: n,
  options: i,
  selected: a,
  onToggle: s,
  header: g
}) {
  const [c, I] = gt(""), h = c.trim().toLowerCase(), m = i.filter(
    (w) => !h || w.label.toLowerCase().includes(h)
  );
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      r11,
      {
        value: c,
        onChange: I,
        placeholder: `Search ${e}…`,
        label: n
      }
    ),
    g,
    m.map((w) => /* @__PURE__ */ v.jsx(
      n11,
      {
        control: "checkbox",
        label: w.label,
        checked: a.includes(w.value),
        onChange: () => s(w.value)
      },
      w.value
    )),
    m.length === 0 && /* @__PURE__ */ v.jsx(t11, { children: `No matches for '${c.trim()}'` })
  ] });
}
const uS = (e) => {
  switch (e) {
    case "maxDate":
      return 'Please select a date that is before the "to" date';
    case "minDate":
      return 'Please select a date that is after the "from" date';
    case "invalidDate":
      return "Please select a valid date";
    default:
      return "";
  }
};
function Ot1({
  from: e,
  to: n,
  onFromChange: i,
  onToChange: a,
  disableFuture: s,
  disabled: g
}) {
  const [c, I] = gt(null), [h, m] = gt(null), w = (x) => ({
    field: { clearable: !0 },
    textField: { helperText: x }
  });
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(sS, { children: "From" }),
    /* @__PURE__ */ v.jsx(_1, { sx: { px: 2, pb: 1 }, children: /* @__PURE__ */ v.jsx(
      Tb,
      {
        disableFuture: s,
        disabled: g,
        maxDate: n ?? void 0,
        value: e,
        onChange: i,
        onError: I,
        sx: [Hh, { width: "100%" }],
        slotProps: w(uS(c))
      }
    ) }),
    /* @__PURE__ */ v.jsx(sS, { children: "To" }),
    /* @__PURE__ */ v.jsx(_1, { sx: { px: 2, pb: 1 }, children: /* @__PURE__ */ v.jsx(
      Tb,
      {
        disableFuture: s,
        disabled: g,
        minDate: e ?? void 0,
        value: n,
        onChange: a,
        onError: m,
        sx: [Hh, { width: "100%" }],
        slotProps: w(uS(h))
      }
    ) })
  ] });
}
function Dt1({
  dialogLabel: e,
  categories: n,
  renderCategory: i,
  count: a = 0,
  footer: s,
  onOpenChange: g
}) {
  var O;
  const [c, I] = gt(null), [h, m] = gt(n[0].id), w = c != null, x = (k) => {
    I(k.currentTarget), g == null || g(!0);
  }, M = () => {
    I(null), g == null || g(!1);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(
      F$,
      {
        onClick: x,
        "aria-haspopup": "dialog",
        "aria-expanded": w,
        "aria-label": a > 0 ? `Filter, ${a} active` : "Filter",
        children: [
          "+ Filter",
          a > 0 && /* @__PURE__ */ v.jsx(oS, { "aria-hidden": !0, sx: { ml: 0.5 }, children: a })
        ]
      }
    ),
    /* @__PURE__ */ v.jsxs(
      IG,
      {
        role: "dialog",
        "aria-label": e,
        open: w,
        anchorEl: c,
        onClose: M,
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: -4, horizontal: "left" },
        elevation: 8,
        slotProps: {
          paper: {
            sx: {
              overflow: "hidden",
              width: 536,
              height: 400,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column"
            }
          }
        },
        children: [
          /* @__PURE__ */ v.jsxs(qe, { direction: "row", sx: { flex: 1, minHeight: 0 }, children: [
            /* @__PURE__ */ v.jsx(
              _1,
              {
                sx: {
                  width: 190,
                  flexShrink: 0,
                  borderRight: 1,
                  borderColor: "divider"
                },
                children: /* @__PURE__ */ v.jsx(cz, { "aria-label": "Filter categories", sx: { py: 0 }, children: n.map(({ id: k, label: z, count: N = 0 }) => {
                  const U = k === h;
                  return /* @__PURE__ */ v.jsx(mS, { disableGutters: !0, disablePadding: !0, children: /* @__PURE__ */ v.jsxs(
                    L$,
                    {
                      selected: U,
                      "aria-current": U ? "true" : void 0,
                      onClick: () => m(k),
                      disableRipple: !0,
                      sx: {
                        gap: 1,
                        py: 1.25,
                        px: 2,
                        color: U ? "text.primary" : "common.neutrals.700",
                        "&:hover": { bgcolor: Um },
                        "&.Mui-selected, &.Mui-selected:hover": {
                          bgcolor: "common.neutrals.100"
                        }
                      },
                      children: [
                        /* @__PURE__ */ v.jsx(
                          vS,
                          {
                            primary: z,
                            sx: { my: 0 },
                            primaryTypographyProps: {
                              variant: "body1",
                              sx: (Q) => ({
                                ...qo(Q, "body1"),
                                fontWeight: U ? 600 : 400
                              })
                            }
                          }
                        ),
                        N > 0 && /* @__PURE__ */ v.jsx(oS, { "aria-label": `${N} selected`, children: N })
                      ]
                    }
                  ) }, k);
                }) })
              }
            ),
            /* @__PURE__ */ v.jsx(
              _1,
              {
                role: "tabpanel",
                "aria-label": (O = n.find(({ id: k }) => k === h)) == null ? void 0 : O.label,
                sx: {
                  flex: 1,
                  minWidth: 0,
                  overflowY: "auto",
                  py: AA
                },
                children: i(h)
              }
            )
          ] }),
          /* @__PURE__ */ v.jsxs(
            qe,
            {
              direction: "row",
              sx: {
                alignItems: "center",
                px: 2,
                py: 1.25,
                borderTop: 1,
                borderColor: "divider"
              },
              children: [
                s,
                /* @__PURE__ */ v.jsx(
                  j2,
                  {
                    variant: "contained",
                    onClick: M,
                    sx: {
                      ml: "auto",
                      px: 2.25,
                      borderRadius: 1,
                      py: 1,
                      lineHeight: 1.5,
                      fontFamily: (k) => k.typography.body1.fontFamily,
                      fontSize: (k) => k.typography.pxToRem(15),
                      fontWeight: 600
                    },
                    children: "Done"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}
const kt1 = (e) => /* @__PURE__ */ v.jsx(gz, { ...e, children: e.children }), jt1 = q1(sf)(() => ({})), zt1 = q1(xS)({
  maxHeight: 400
}), Nt1 = q1(W7)(({ theme: e }) => ({
  "&:hover": {
    backgroundColor: e.palette.action.hover
  },
  "&.Mui-selected": {
    backgroundColor: e.palette.action.selected
  }
})), i11 = q1("div")(({ theme: e }) => ({
  width: 30,
  height: 6,
  backgroundColor: e.palette.common.neutrals[500],
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)"
})), a11 = q1(_1)(({ theme: e }) => ({
  backgroundColor: e.palette.background.paper,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  visibility: "visible",
  right: 0,
  left: 0
})), BT = ({
  children: e,
  swipeable: n,
  ...i
}) => /* @__PURE__ */ v.jsxs(a11, { ...i, children: [
  n && /* @__PURE__ */ v.jsx(i11, {}),
  e
] }), HT = ({
  children: e,
  open: n,
  containerProps: i = {},
  ...a
}) => /* @__PURE__ */ v.jsx(
  fz,
  {
    PaperProps: { sx: { backgroundColor: "transparent" } },
    ...a,
    anchor: "bottom",
    open: n,
    children: /* @__PURE__ */ v.jsx(BT, { ...i, children: e })
  }
);
HT.displayName = "MobileBottomDrawer";
const o11 = ({
  children: e,
  open: n,
  onClose: i = () => {
  },
  containerProps: a = {},
  ...s
}) => /* @__PURE__ */ v.jsx(
  dz,
  {
    PaperProps: { sx: { backgroundColor: "transparent" } },
    ...s,
    anchor: "bottom",
    open: n,
    onClose: i,
    onOpen: () => {
    },
    disableSwipeToOpen: !0,
    disableDiscovery: !0,
    children: /* @__PURE__ */ v.jsx(BT, { ...a, swipeable: !0, children: e })
  }
);
o11.displayName = "SwipeableMobileBottomDrawer";
const s11 = ({
  open: e,
  cancelLabel: n = "Cancel",
  onCancel: i,
  confirmLabel: a = "Confirm",
  onConfirm: s,
  title: g,
  type: c = "default",
  children: I,
  titleProps: h = {},
  contentProps: m = {},
  stackProps: w = {},
  cancelBtnProps: x = {},
  confirmBtnProps: M = {}
}) => /* @__PURE__ */ v.jsx(
  HT,
  {
    open: e,
    sx: (O) => ({ zIndex: O.zIndex.modal + 1 }),
    children: /* @__PURE__ */ v.jsxs(qe, { p: 2, gap: 2, alignItems: "center", ...w, children: [
      g && /* @__PURE__ */ v.jsx(yT, { ...h, type: c, children: g }),
      typeof I == "string" ? /* @__PURE__ */ v.jsx(
        le,
        {
          variant: "body1",
          color: (O) => O.palette.text.primary,
          ...m,
          children: I
        }
      ) : I,
      i && /* @__PURE__ */ v.jsx(
        j2,
        {
          variant: "outlined",
          fullWidth: !0,
          ...x,
          onClick: i,
          children: n
        }
      ),
      s && /* @__PURE__ */ v.jsx(
        j2,
        {
          variant: "contained",
          fullWidth: !0,
          color: c !== "default" ? c : void 0,
          ...M,
          onClick: s,
          children: a
        }
      )
    ] })
  }
);
s11.displayName = "MobileConfirmationDrawer";
const Uh = "slidingViewsTransitionType", Pt1 = (e) => ({ [Uh]: e }), UT = () => {
  const e = RS();
  return V2(() => {
    var i;
    switch ((i = e.state) == null ? void 0 : i[Uh]) {
      case "slide-in":
      case "slide-out":
        return e.state[Uh];
      default:
        return;
    }
  }, [e.state]);
}, Ft1 = ({ children: e }) => {
  const n = UT();
  return /* @__PURE__ */ v.jsx(Nz, { initial: !1, custom: n, children: e });
}, Bt1 = ({ children: e, ...n }) => {
  const i = ka(), a = UT();
  return /* @__PURE__ */ v.jsx(
    Pz.div,
    {
      style: {
        backgroundColor: i.palette.background.default,
        boxShadow: i.shadows[10],
        ...n.style || {},
        flex: 1,
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      },
      transition: { duration: 0.3 },
      ...n,
      custom: a,
      variants: {
        initial: (s) => ({
          x: s === "slide-out" ? "-50%" : "100%",
          zIndex: s === "slide-out" ? i.zIndex.slidingViews - 1 : i.zIndex.slidingViews + 1,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }),
        target: (s) => ({
          x: "0%",
          zIndex: s === "slide-out" ? i.zIndex.slidingViews - 1 : i.zIndex.slidingViews + 1,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          transitionEnd: {
            position: "relative",
            zIndex: i.zIndex.slidingViews
          }
        }),
        exit: (s) => ({
          x: s === "slide-out" ? "100%" : "-50%"
        })
      },
      initial: "initial",
      animate: "target",
      exit: "exit",
      children: e
    }
  );
}, l11 = ({
  targetId: e,
  children: n,
  fullWidth: i = !1,
  showHighlight: a = !0
}) => /* @__PURE__ */ v.jsx(
  _1,
  {
    "data-guided-file-rename-target": e,
    tabIndex: -1,
    sx: {
      flex: i ? 1 : void 0,
      minWidth: 0,
      borderRadius: 1,
      outline: a ? "2px solid transparent" : "none",
      outlineOffset: 3,
      transition: "outline-color 180ms ease",
      ...a && {
        '&:focus, &[data-guided-highlight="true"]': {
          outlineColor: "primary.main"
        }
      }
    },
    children: n
  }
), Ht1 = ({
  targetId: e,
  label: n,
  showHighlight: i = !0,
  fullWidth: a = !0,
  revealOnHover: s = !1,
  revealTriggerRef: g,
  revealWithinWidth: c
}) => /* @__PURE__ */ v.jsx(
  l11,
  {
    targetId: e,
    fullWidth: a,
    showHighlight: i,
    children: /* @__PURE__ */ v.jsx(
      VM,
      {
        variant: "body2",
        revealOnHover: s,
        revealTriggerRef: g,
        revealWithinWidth: c,
        sx: { flex: 1, minWidth: 0, fontWeight: 400 },
        children: n
      }
    )
  }
), Ut1 = ja(
  ({
    open: e,
    originalName: n,
    suggestedName: i,
    foundInDocumentLabels: a,
    onDismiss: s,
    onComplete: g,
    showBackdrop: c = !0,
    completeLabel: I = "Show me where to accept"
  }, h) => /* @__PURE__ */ v.jsxs(
    hl,
    {
      open: e,
      onClose: s,
      maxWidth: !1,
      "aria-labelledby": "guided-file-rename-title",
      "aria-describedby": "guided-file-rename-description",
      BackdropProps: {
        sx: {
          opacity: c ? 1 : 0,
          backgroundColor: "rgba(33, 43, 54, 0.55)",
          transition: "opacity 0.25s ease"
        }
      },
      PaperProps: {
        sx: {
          width: "min(780px, calc(100vw - 32px))",
          maxWidth: "none",
          borderRadius: 2.5,
          overflow: "visible",
          boxShadow: "0 24px 48px rgba(33, 43, 54, 0.18)"
        }
      },
      children: [
        /* @__PURE__ */ v.jsxs(T0, { sx: { px: 4, pt: 4.5, pb: 3 }, children: [
          /* @__PURE__ */ v.jsxs(qe, { alignItems: "center", spacing: 2, textAlign: "center", sx: { mb: 4 }, children: [
            /* @__PURE__ */ v.jsx(
              _1,
              {
                sx: {
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "linear-gradient(135deg, #eef6ff 0%, #f5efff 100%)",
                  border: "1px solid #d8e7fa",
                  boxShadow: "0 4px 16px rgba(25, 118, 210, 0.1)"
                },
                children: /* @__PURE__ */ v.jsx(De, { icon: "sparkles", color: "primary", sx: { fontSize: 40 } })
              }
            ),
            /* @__PURE__ */ v.jsx(
              le,
              {
                id: "guided-file-rename-title",
                variant: "h5",
                component: "h2",
                fontWeight: 700,
                children: "Liscio found a better file name"
              }
            ),
            /* @__PURE__ */ v.jsx(
              le,
              {
                id: "guided-file-rename-description",
                variant: "body1",
                color: "text.secondary",
                sx: { maxWidth: 520, lineHeight: 1.55 },
                children: "We read the document and suggested a clearer name so your files stay organized."
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            _1,
            {
              sx: {
                p: 2.5,
                borderRadius: 2,
                bgcolor: "common.neutrals.100",
                border: 1,
                borderColor: "divider"
              },
              children: /* @__PURE__ */ v.jsxs(qe, { direction: "row", alignItems: "stretch", spacing: 1.5, sx: { minHeight: 88 }, children: [
                /* @__PURE__ */ v.jsxs(
                  _1,
                  {
                    sx: {
                      flex: 1,
                      minWidth: 0,
                      px: 2,
                      py: 2,
                      borderRadius: 1.5,
                      border: 1,
                      borderColor: "divider",
                      bgcolor: "common.white"
                    },
                    children: [
                      /* @__PURE__ */ v.jsx(le, { variant: "overline", color: "text.disabled", display: "block", children: "Original file name" }),
                      /* @__PURE__ */ v.jsx(le, { variant: "body1", color: "text.secondary", sx: { wordBreak: "break-word" }, children: n })
                    ]
                  }
                ),
                /* @__PURE__ */ v.jsx(qe, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ v.jsx(De, { icon: "arrowRight", color: "primary" }) }),
                /* @__PURE__ */ v.jsxs(
                  _1,
                  {
                    ref: h,
                    sx: {
                      flex: 1.15,
                      minWidth: 0,
                      px: 2.5,
                      py: 2.25,
                      borderRadius: 1.5,
                      border: 2,
                      borderColor: "primary.main",
                      bgcolor: "primary.lighter",
                      boxShadow: "0 2px 12px rgba(25, 118, 210, 0.12)"
                    },
                    children: [
                      /* @__PURE__ */ v.jsx(le, { variant: "overline", color: "primary", display: "block", children: "Suggested file name" }),
                      /* @__PURE__ */ v.jsx(le, { variant: "h6", component: "p", fontWeight: 700, sx: { wordBreak: "break-word" }, children: i })
                    ]
                  }
                )
              ] })
            }
          ),
          a.length > 0 && /* @__PURE__ */ v.jsxs(_1, { sx: { mt: 3.5, pt: 2.5, borderTop: 1, borderColor: "divider" }, children: [
            /* @__PURE__ */ v.jsx(le, { variant: "subtitle2", fontWeight: 600, sx: { mb: 1.75 }, children: "Liscio found in this document" }),
            /* @__PURE__ */ v.jsx(qe, { direction: "row", flexWrap: "wrap", gap: 1.25, children: a.map((m) => /* @__PURE__ */ v.jsx(
              _1,
              {
                component: "span",
                sx: {
                  px: 1.75,
                  py: 0.875,
                  borderRadius: 999,
                  fontSize: "0.9375rem",
                  border: 1,
                  borderColor: "divider",
                  bgcolor: "common.white"
                },
                children: m
              },
              m
            )) })
          ] })
        ] }),
        /* @__PURE__ */ v.jsxs(Nc, { sx: { px: 4, pb: 4, justifyContent: "space-between" }, children: [
          /* @__PURE__ */ v.jsx(v2, { color: "inherit", onClick: s, children: "Maybe later" }),
          /* @__PURE__ */ v.jsx(v2, { variant: "contained", size: "large", onClick: g, children: I })
        ] })
      ]
    }
  )
), Wt1 = ({
  label: e,
  top: n,
  left: i,
  width: a,
  height: s,
  opacity: g,
  transition: c
}) => /* @__PURE__ */ v.jsx(
  _1,
  {
    "aria-hidden": !0,
    sx: {
      position: "fixed",
      zIndex: 1400,
      top: n,
      left: i,
      width: a,
      height: s,
      opacity: g,
      transition: c,
      pointerEvents: "none",
      px: 2.5,
      py: 2,
      borderRadius: 1.5,
      border: 2,
      borderColor: "primary.main",
      bgcolor: "primary.lighter",
      boxShadow: "0 8px 24px rgba(25, 118, 210, 0.2)",
      display: "flex",
      alignItems: "center",
      overflow: "hidden"
    },
    children: /* @__PURE__ */ v.jsx(_1, { component: "span", sx: { fontWeight: 700, fontSize: "1.0625rem", wordBreak: "break-word" }, children: e })
  }
), _t1 = ({
  accept: e,
  disabled: n = !1,
  onFileSelected: i
}) => {
  const a = Cn(null), [s, g] = gt(!1), c = (w) => {
    w && !n && i(w);
  }, I = (w) => {
    var x;
    c((x = w.target.files) == null ? void 0 : x[0]), w.target.value = "";
  }, h = (w) => {
    var x;
    w.preventDefault(), g(!1), c((x = w.dataTransfer.files) == null ? void 0 : x[0]);
  }, m = (w) => {
    var x;
    w.key !== "Enter" && w.key !== " " || (w.preventDefault(), (x = a.current) == null || x.click());
  };
  return /* @__PURE__ */ v.jsxs(
    _1,
    {
      component: "label",
      role: "button",
      tabIndex: n ? -1 : 0,
      "aria-disabled": n,
      onKeyDown: m,
      onDragEnter: (w) => {
        w.preventDefault(), n || g(!0);
      },
      onDragOver: (w) => w.preventDefault(),
      onDragLeave: (w) => {
        w.currentTarget.contains(w.relatedTarget) || g(!1);
      },
      onDrop: h,
      sx: {
        display: "grid",
        placeItems: "center",
        minHeight: 118,
        px: 2,
        py: 3,
        mb: 2.25,
        border: "1.5px dashed",
        borderColor: s ? "primary.main" : "grey.300",
        borderRadius: 1.5,
        bgcolor: s ? "primary.50" : "grey.50",
        cursor: n ? "default" : "pointer",
        textAlign: "center",
        transition: "border-color 120ms ease, background-color 120ms ease",
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: 2
        }
      },
      children: [
        /* @__PURE__ */ v.jsx(
          "input",
          {
            ref: a,
            type: "file",
            accept: e,
            "aria-label": "Upload a file",
            disabled: n,
            hidden: !0,
            onChange: I
          }
        ),
        /* @__PURE__ */ v.jsxs(qe, { alignItems: "center", gap: 0.75, children: [
          /* @__PURE__ */ v.jsx(De, { icon: "upload", sx: { fontSize: 26, color: "primary.main" } }),
          /* @__PURE__ */ v.jsxs(le, { variant: "body2", fontWeight: 600, color: "primary.dark", children: [
            "Drag & drop a file, or",
            " ",
            /* @__PURE__ */ v.jsx(_1, { component: "span", sx: { textDecoration: "underline" }, children: "browse" })
          ] })
        ] })
      ]
    }
  );
}, $C = ({
  label: e,
  onClick: n
}) => /* @__PURE__ */ v.jsx(
  v2,
  {
    color: "inherit",
    fullWidth: !0,
    onClick: n,
    endIcon: /* @__PURE__ */ v.jsx(De, { icon: "chevronRight" }),
    sx: {
      justifyContent: "space-between",
      px: 0.25,
      py: 1.5,
      borderBottom: 1,
      borderColor: "divider",
      borderRadius: 0,
      fontSize: 15,
      fontWeight: 400,
      textTransform: "none",
      "&:last-of-type": { borderBottom: 0 }
    },
    children: e
  }
), Vt1 = ({
  open: e,
  state: n,
  uploadContent: i,
  samples: a,
  activeSampleId: s,
  samplesDisabled: g = !1,
  uploadError: c,
  result: I,
  onClose: h,
  onSample: m,
  onTryAnother: w,
  onOpenFolder: x,
  onOpenTemplate: M,
  onSend: O
}) => /* @__PURE__ */ v.jsxs(
  hl,
  {
    open: e,
    onClose: h,
    maxWidth: !1,
    PaperProps: {
      "aria-label": "File Intelligence",
      sx: {
        width: n === "result" ? "min(720px, calc(100% - 32px))" : "min(520px, calc(100% - 32px))",
        maxHeight: "86vh",
        borderRadius: 1.5,
        boxShadow: 24
      }
    },
    children: [
      /* @__PURE__ */ v.jsx(
        _1,
        {
          component: "header",
          sx: { px: 2.75, py: 2.5, borderBottom: 1, borderColor: "divider" },
          children: /* @__PURE__ */ v.jsxs(qe, { direction: "row", alignItems: "center", gap: 1.5, children: [
            /* @__PURE__ */ v.jsxs(
              _1,
              {
                sx: {
                  position: "relative",
                  display: "grid",
                  placeItems: "center",
                  width: 36,
                  height: 36,
                  flexShrink: 0,
                  borderRadius: 1.25,
                  bgcolor: "primary.50",
                  color: "primary.main"
                },
                children: [
                  /* @__PURE__ */ v.jsx(De, { icon: "fileLines", sx: { fontSize: 19 } }),
                  /* @__PURE__ */ v.jsx(
                    De,
                    {
                      icon: "check",
                      sx: {
                        position: "absolute",
                        right: 4,
                        bottom: 4,
                        fontSize: 10,
                        strokeWidth: 2
                      }
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ v.jsxs(_1, { sx: { flex: 1, minWidth: 0 }, children: [
              /* @__PURE__ */ v.jsx(
                le,
                {
                  variant: "h6",
                  component: "h2",
                  fontWeight: 600,
                  sx: { fontSize: 17, lineHeight: 1.35 },
                  children: "File Intelligence"
                }
              ),
              /* @__PURE__ */ v.jsx(
                le,
                {
                  variant: "caption",
                  color: "text.secondary",
                  sx: { display: "block" },
                  children: "Reads, classifies, and renames accounting documents in seconds."
                }
              )
            ] }),
            /* @__PURE__ */ v.jsx(xc, { size: "small", onClick: h, "aria-label": "Close", children: /* @__PURE__ */ v.jsx(De, { icon: "close" }) })
          ] })
        }
      ),
      n === "upload" && /* @__PURE__ */ v.jsxs(T0, { sx: { p: 2.75 }, children: [
        c && /* @__PURE__ */ v.jsx(Yr, { severity: "error", sx: { mb: 2 }, children: c }),
        i,
        a.length > 0 && /* @__PURE__ */ v.jsx(
          le,
          {
            variant: "caption",
            color: "text.secondary",
            fontWeight: 600,
            sx: { display: "block", mb: 1 },
            children: "Or try a sample:"
          }
        ),
        /* @__PURE__ */ v.jsx(qe, { gap: 1, children: a.map((k) => /* @__PURE__ */ v.jsxs(
          v2,
          {
            variant: "outlined",
            onClick: () => m(k.id),
            disabled: g || !!s,
            "aria-label": `${k.title}, ${k.detectedType}`,
            sx: {
              minHeight: 42,
              justifyContent: "space-between",
              px: 1.5,
              py: 1.25,
              borderRadius: 1,
              borderColor: "divider",
              bgcolor: "common.white",
              textAlign: "left",
              textTransform: "none"
            },
            children: [
              /* @__PURE__ */ v.jsx(le, { variant: "body2", color: "text.primary", fontWeight: 400, children: k.title }),
              s === k.id ? /* @__PURE__ */ v.jsx(D3, { size: 18 }) : /* @__PURE__ */ v.jsx(le, { variant: "caption", color: "text.secondary", children: k.detectedType })
            ]
          },
          k.id
        )) })
      ] }),
      (n === "uploading" || n === "processing") && /* @__PURE__ */ v.jsx(
        T0,
        {
          sx: { display: "grid", placeItems: "center", minHeight: 300 },
          children: /* @__PURE__ */ v.jsxs(qe, { alignItems: "center", gap: 2.5, children: [
            /* @__PURE__ */ v.jsx(D3, { size: 52, thickness: 3 }),
            /* @__PURE__ */ v.jsx(le, { color: "text.secondary", fontSize: 18, children: "Reading your document…" })
          ] })
        }
      ),
      (n === "no-name" || n === "failed") && /* @__PURE__ */ v.jsx(T0, { children: /* @__PURE__ */ v.jsxs(Yr, { severity: n === "no-name" ? "warning" : "error", children: [
        /* @__PURE__ */ v.jsx(le, { fontWeight: 600, children: n === "no-name" ? "No file name to suggest" : "Processing failed" }),
        /* @__PURE__ */ v.jsx(le, { variant: "body2", sx: { mt: 1 }, children: n === "no-name" ? "Your file does not look like a supported document for naming. Try another file to continue." : "Your file could not be analyzed. Try another file to continue." }),
        /* @__PURE__ */ v.jsx(
          v2,
          {
            variant: "outlined",
            color: "inherit",
            size: "small",
            onClick: w,
            sx: { mt: 2 },
            children: "Try another file"
          }
        )
      ] }) }),
      n === "result" && I && /* @__PURE__ */ v.jsxs(T0, { sx: { px: 3.5, py: 3 }, children: [
        /* @__PURE__ */ v.jsxs(
          qe,
          {
            direction: "row",
            alignItems: "center",
            gap: 1,
            sx: { mb: 2.5, color: "success.main" },
            children: [
              /* @__PURE__ */ v.jsx(De, { icon: "check", sx: { fontSize: 18 } }),
              /* @__PURE__ */ v.jsx(
                le,
                {
                  variant: "caption",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  color: "text.secondary",
                  children: "RENAMED AND FILED"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ v.jsx(
          le,
          {
            component: "p",
            fontFamily: "monospace",
            fontSize: 22,
            fontWeight: 700,
            sx: { mb: 2 },
            children: I.suggestedName
          }
        ),
        /* @__PURE__ */ v.jsxs(qe, { gap: 1, sx: { mb: 2.5 }, children: [
          /* @__PURE__ */ v.jsxs(qe, { direction: "row", gap: 2, children: [
            /* @__PURE__ */ v.jsx(le, { color: "text.secondary", sx: { width: 72 }, children: "Original" }),
            /* @__PURE__ */ v.jsx(le, { color: "text.secondary", children: I.originalName })
          ] }),
          /* @__PURE__ */ v.jsxs(qe, { direction: "row", gap: 2, children: [
            /* @__PURE__ */ v.jsx(le, { color: "text.secondary", sx: { width: 72 }, children: "Filed to" }),
            /* @__PURE__ */ v.jsx(le, { color: "text.secondary", children: I.filedLocation })
          ] })
        ] }),
        /* @__PURE__ */ v.jsxs(qe, { sx: { borderTop: 1, borderColor: "divider" }, children: [
          /* @__PURE__ */ v.jsx($C, { label: "Open the folder", onClick: x }),
          /* @__PURE__ */ v.jsx(
            $C,
            {
              label: "Change the naming template",
              onClick: M
            }
          ),
          O && /* @__PURE__ */ v.jsx($C, { label: "Send to a client or teammate", onClick: O }),
          /* @__PURE__ */ v.jsx($C, { label: "Name another file", onClick: w })
        ] })
      ] })
    ]
  }
), u11 = ({
  open: e,
  title: n,
  content: i,
  confirmLabel: a = "OK",
  cancelLabel: s = "Cancel",
  disabled: g,
  onConfirm: c,
  onCancel: I,
  isLoading: h,
  confirmColor: m,
  confirmBtnProps: w = {},
  cancelBtnProps: x = {}
}) => /* @__PURE__ */ v.jsxs(
  hl,
  {
    onClick: iA,
    open: e,
    onClose: I,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    children: [
      /* @__PURE__ */ v.jsx(HA, { id: "alert-dialog-title", children: n }),
      /* @__PURE__ */ v.jsx(T0, { children: /* @__PURE__ */ v.jsx(SS, { id: "alert-dialog-description", children: i }) }),
      /* @__PURE__ */ v.jsxs(Nc, { children: [
        I && /* @__PURE__ */ v.jsx(j2, { ...x, onClick: I, disabled: g, children: s }),
        /* @__PURE__ */ v.jsx(
          j2,
          {
            autoFocus: !0,
            color: m,
            disabled: g,
            "data-testid": "dialog-confirm",
            variant: "contained",
            ...w,
            onClick: c,
            children: a
          }
        )
      ] }),
      /* @__PURE__ */ v.jsx(_M, { open: !!h })
    ]
  }
), cS = [
  { value: " ", label: "Space", display: " " },
  { value: "-", label: "Dash", display: "–" },
  { value: "_", label: "Underscore", display: "_" },
  { value: ".", label: "Period", display: "." }
], N7 = "application/x-liscio-naming-token", Kt1 = ({
  open: e,
  loading: n = !1,
  saving: i = !1,
  dirty: a,
  canRetrySave: s = !1,
  tokens: g,
  options: c,
  separators: I,
  detectedFields: h,
  originalName: m,
  previewName: w,
  error: x,
  onClose: M,
  onReset: O,
  onAdd: k,
  onRemove: z,
  onReorder: N,
  onFormatChange: U,
  onSeparatorChange: Q,
  onSave: _
}) => {
  const [X, B] = gt(null), [Z, Y] = gt(null), [V, J] = gt(!1), e1 = () => {
    if (!i) {
      if (a) {
        J(!0);
        return;
      }
      M();
    }
  }, f1 = (a1, d1, S1) => {
    B({
      anchor: a1.currentTarget,
      options: d1.formatOptions,
      tokenIndex: S1
    });
  }, v1 = (a1, d1) => {
    if (!d1.formatOptions.length) {
      k(d1.value);
      return;
    }
    B({
      anchor: a1.currentTarget,
      options: d1.formatOptions,
      variable: d1.value
    });
  };
  return /* @__PURE__ */ v.jsxs(
    hl,
    {
      open: e,
      onClose: e1,
      maxWidth: "md",
      fullWidth: !0,
      sx: { "& .MuiDialog-container": { alignItems: "flex-start", pt: "8vh" } },
      PaperProps: {
        "aria-label": "File naming pattern",
        sx: { borderRadius: 1, overflow: "hidden", maxHeight: "84vh" }
      },
      children: [
        /* @__PURE__ */ v.jsx(
          _1,
          {
            sx: {
              bgcolor: "#f4f6fa",
              px: 3,
              py: 1.5,
              borderBottom: "1px solid #e4e9f0"
            },
            children: /* @__PURE__ */ v.jsxs(qe, { direction: "row", alignItems: "center", gap: 1.5, children: [
              /* @__PURE__ */ v.jsx(
                _1,
                {
                  sx: {
                    display: "grid",
                    placeItems: "center",
                    width: 40,
                    height: 40,
                    flexShrink: 0,
                    borderRadius: 1,
                    bgcolor: "#e7eefc",
                    color: "#3366cc"
                  },
                  children: /* @__PURE__ */ v.jsx(De, { icon: "sparkles", sx: { fontSize: 22 } })
                }
              ),
              /* @__PURE__ */ v.jsxs(
                qe,
                {
                  direction: "row",
                  alignItems: "center",
                  gap: 1.5,
                  flexWrap: "wrap",
                  sx: { flex: 1, minWidth: 0 },
                  children: [
                    /* @__PURE__ */ v.jsx(
                      le,
                      {
                        component: "h2",
                        variant: "h6",
                        fontWeight: 600,
                        fontSize: 18,
                        children: "File naming pattern"
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(
                      qe,
                      {
                        direction: "row",
                        alignItems: "center",
                        gap: 0.5,
                        sx: {
                          px: 1,
                          py: 0.25,
                          border: "1px solid #dbe2f2",
                          borderRadius: 0.75,
                          bgcolor: "#eef2fb",
                          color: "#4759a8"
                        },
                        children: [
                          /* @__PURE__ */ v.jsx(De, { icon: "userGroup", sx: { fontSize: 14 } }),
                          /* @__PURE__ */ v.jsx(le, { fontSize: 12, fontWeight: 600, children: "Firm-wide setting" })
                        ]
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ v.jsx(
                xc,
                {
                  "aria-label": "Close",
                  onClick: e1,
                  disabled: i,
                  children: /* @__PURE__ */ v.jsx(De, { icon: "close" })
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ v.jsx(T0, { sx: { px: 3, py: 3.5 }, children: n ? /* @__PURE__ */ v.jsx(qe, { alignItems: "center", py: 6, children: /* @__PURE__ */ v.jsx(D3, { size: 28 }) }) : /* @__PURE__ */ v.jsxs(qe, { gap: 3, children: [
          x && /* @__PURE__ */ v.jsx(Yr, { severity: "error", children: x }),
          /* @__PURE__ */ v.jsxs(_1, { children: [
            /* @__PURE__ */ v.jsx(le, { fontWeight: 600, children: "Naming pattern" }),
            /* @__PURE__ */ v.jsx(
              le,
              {
                variant: "body2",
                color: "text.secondary",
                sx: { mt: 0.5, mb: 1.75 },
                children: "Arrange the fields once. Liscio will use this structure for future file name suggestions."
              }
            ),
            /* @__PURE__ */ v.jsxs(
              _1,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minHeight: 44,
                  px: 1.5,
                  py: 1.25,
                  border: `1px solid ${a ? "#90caf9" : "#dfe3ea"}`,
                  borderRadius: 1,
                  bgcolor: a ? "#fafcff" : "#fafbfc"
                },
                children: [
                  /* @__PURE__ */ v.jsx(
                    _1,
                    {
                      sx: {
                        display: "flex",
                        flex: 1,
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 0.75
                      },
                      children: g.length ? g.map((a1, d1) => {
                        var S1;
                        return /* @__PURE__ */ v.jsxs(wz, { children: [
                          /* @__PURE__ */ v.jsxs(
                            _1,
                            {
                              draggable: !i,
                              onDragStart: (h1) => h1.dataTransfer.setData(
                                N7,
                                String(d1)
                              ),
                              onDragOver: (h1) => {
                                h1.preventDefault(), (i || !h1.dataTransfer.types.includes(N7)) && (h1.dataTransfer.dropEffect = "none");
                              },
                              onDrop: (h1) => {
                                h1.preventDefault();
                                const L1 = h1.dataTransfer.getData(N7);
                                i || !/^\d+$/.test(L1) || N(Number(L1), d1);
                              },
                              sx: {
                                position: "relative",
                                "&:hover .remove-field, &:focus-within .remove-field": { opacity: 1 },
                                "@media (hover: none)": {
                                  "& .remove-field": { opacity: 1 }
                                }
                              },
                              children: [
                                /* @__PURE__ */ v.jsx(
                                  dl,
                                  {
                                    label: `${a1.label}${a1.formatOptions.length ? " ▾" : ""}`,
                                    variant: "outlined",
                                    disabled: i,
                                    onClick: a1.formatOptions.length ? (h1) => f1(h1, a1, d1) : void 0,
                                    sx: {
                                      height: 30,
                                      borderRadius: 0.75,
                                      bgcolor: "common.white",
                                      cursor: "grab"
                                    }
                                  }
                                ),
                                /* @__PURE__ */ v.jsx(
                                  xc,
                                  {
                                    className: "remove-field",
                                    "aria-label": `Remove ${a1.label}`,
                                    disabled: i,
                                    onClick: () => z(d1),
                                    sx: {
                                      position: "absolute",
                                      top: -7,
                                      right: -7,
                                      width: 18,
                                      height: 18,
                                      p: 0,
                                      opacity: 0,
                                      bgcolor: "grey.500",
                                      color: "common.white",
                                      "&:hover": { bgcolor: "grey.700" }
                                    },
                                    children: /* @__PURE__ */ v.jsx(De, { icon: "close", sx: { fontSize: 10 } })
                                  }
                                )
                              ]
                            }
                          ),
                          d1 < g.length - 1 && /* @__PURE__ */ v.jsx(
                            _1,
                            {
                              component: "button",
                              type: "button",
                              "aria-label": `Separator after ${a1.label}`,
                              disabled: i,
                              onClick: (h1) => Y({
                                anchor: h1.currentTarget,
                                index: d1
                              }),
                              sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                minWidth: 20,
                                height: 24,
                                px: 0.5,
                                border: "1px dashed #c4c9d0",
                                borderRadius: 0.5,
                                bgcolor: "transparent",
                                color: "text.secondary",
                                fontFamily: "monospace",
                                cursor: "pointer"
                              },
                              children: ((S1 = cS.find(
                                (h1) => h1.value === (I[d1] ?? " ")
                              )) == null ? void 0 : S1.display) ?? I[d1]
                            }
                          )
                        ] }, a1.id);
                      }) : /* @__PURE__ */ v.jsx(le, { variant: "body2", color: "text.secondary", children: "Click a field below to start building your template" })
                    }
                  ),
                  a && /* @__PURE__ */ v.jsx(
                    xc,
                    {
                      "aria-label": "Reset template",
                      onClick: O,
                      disabled: i,
                      children: /* @__PURE__ */ v.jsx(De, { icon: "arrowRotateRightDuotone" })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ v.jsxs(_1, { sx: { mt: 2 }, children: [
              /* @__PURE__ */ v.jsx(
                le,
                {
                  variant: "body2",
                  color: "text.secondary",
                  fontWeight: 600,
                  sx: { mb: 1 },
                  children: "Available fields"
                }
              ),
              /* @__PURE__ */ v.jsx(_1, { sx: { display: "flex", flexWrap: "wrap", gap: 0.75 }, children: c.map((a1) => /* @__PURE__ */ v.jsx(
                dl,
                {
                  label: `+ ${a1.label}${a1.formatOptions.length ? " ▾" : ""}`,
                  variant: "outlined",
                  disabled: i,
                  onClick: (d1) => v1(d1, a1),
                  sx: {
                    height: 30,
                    borderRadius: 0.75,
                    bgcolor: "#fafbfc"
                  }
                },
                a1.value
              )) })
            ] })
          ] }),
          /* @__PURE__ */ v.jsx(pA, {}),
          /* @__PURE__ */ v.jsxs(_1, { children: [
            /* @__PURE__ */ v.jsx(le, { fontWeight: 600, sx: { mb: 1.75 }, children: "File name preview" }),
            /* @__PURE__ */ v.jsxs(
              _1,
              {
                sx: {
                  p: 2.25,
                  border: "1px solid #cddaea",
                  borderRadius: 1,
                  bgcolor: "#eef4fb"
                },
                children: [
                  /* @__PURE__ */ v.jsxs(
                    qe,
                    {
                      direction: { xs: "column", sm: "row" },
                      alignItems: "stretch",
                      gap: 1.75,
                      children: [
                        /* @__PURE__ */ v.jsxs(
                          _1,
                          {
                            sx: {
                              flex: 1,
                              minWidth: 0,
                              p: 1.75,
                              border: "1px solid #d8dee8",
                              borderRadius: 1,
                              bgcolor: "common.white"
                            },
                            children: [
                              /* @__PURE__ */ v.jsx(
                                le,
                                {
                                  variant: "caption",
                                  fontWeight: 700,
                                  color: "text.secondary",
                                  children: "ORIGINAL FILE NAME"
                                }
                              ),
                              /* @__PURE__ */ v.jsx(le, { sx: { mt: 0.75, wordBreak: "break-word" }, children: m })
                            ]
                          }
                        ),
                        /* @__PURE__ */ v.jsx(
                          _1,
                          {
                            sx: {
                              display: "grid",
                              placeItems: "center",
                              color: "#3366cc"
                            },
                            children: /* @__PURE__ */ v.jsx(De, { icon: "arrowRight", sx: { fontSize: 22 } })
                          }
                        ),
                        /* @__PURE__ */ v.jsxs(
                          _1,
                          {
                            sx: {
                              flex: 1.05,
                              minWidth: 0,
                              p: 1.75,
                              border: "2px solid #7eb3ea",
                              borderRadius: 1,
                              bgcolor: "#e3f0ff"
                            },
                            children: [
                              /* @__PURE__ */ v.jsx(
                                le,
                                {
                                  variant: "caption",
                                  fontWeight: 700,
                                  color: "#3366cc",
                                  children: "NEW FILE NAME"
                                }
                              ),
                              /* @__PURE__ */ v.jsx(
                                le,
                                {
                                  fontWeight: 600,
                                  sx: { mt: 0.75, wordBreak: "break-word" },
                                  children: w || "File name preview"
                                }
                              )
                            ]
                          }
                        )
                      ]
                    }
                  ),
                  h.length > 0 && /* @__PURE__ */ v.jsxs(_1, { sx: { mt: 2.25, pt: 2, borderTop: "1px solid #d8dee8" }, children: [
                    /* @__PURE__ */ v.jsx(
                      le,
                      {
                        variant: "body2",
                        color: "text.secondary",
                        fontWeight: 600,
                        sx: { mb: 1.25 },
                        children: "Fields Liscio found"
                      }
                    ),
                    /* @__PURE__ */ v.jsx(qe, { direction: "row", flexWrap: "wrap", gap: 1, children: h.map((a1) => /* @__PURE__ */ v.jsxs(
                      _1,
                      {
                        sx: {
                          minWidth: 76,
                          px: 1.5,
                          py: 1,
                          border: "1px solid #d8dee8",
                          borderRadius: 1,
                          bgcolor: "common.white",
                          textAlign: "center"
                        },
                        children: [
                          /* @__PURE__ */ v.jsx(le, { variant: "body2", fontWeight: 600, children: a1.value }),
                          /* @__PURE__ */ v.jsx(le, { variant: "caption", color: "text.secondary", children: a1.label })
                        ]
                      },
                      a1.label
                    )) })
                  ] })
                ]
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          Nc,
          {
            sx: {
              justifyContent: "flex-end",
              px: 3,
              py: 2.25,
              borderTop: "1px solid #eef0f2"
            },
            children: /* @__PURE__ */ v.jsxs(qe, { direction: "row", gap: 1, children: [
              /* @__PURE__ */ v.jsx(v2, { color: "inherit", onClick: e1, disabled: i, children: "Cancel" }),
              /* @__PURE__ */ v.jsx(
                v2,
                {
                  variant: "contained",
                  onClick: _,
                  disabled: !a && !s || i || g.length === 0,
                  children: i ? "Saving..." : "Save pattern"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ v.jsx(
          U7,
          {
            anchorEl: X == null ? void 0 : X.anchor,
            open: !!X,
            onClose: () => B(null),
            children: X == null ? void 0 : X.options.map((a1) => /* @__PURE__ */ v.jsxs(
              Ta,
              {
                onClick: () => {
                  X.tokenIndex != null && U(X.tokenIndex, a1.value), X.variable && k(X.variable, a1.value), B(null);
                },
                sx: { display: "flex", justifyContent: "space-between", gap: 3 },
                children: [
                  /* @__PURE__ */ v.jsx(le, { variant: "body2", children: a1.label }),
                  a1.example && /* @__PURE__ */ v.jsx(
                    le,
                    {
                      variant: "caption",
                      color: "text.secondary",
                      fontFamily: "monospace",
                      children: a1.example
                    }
                  )
                ]
              },
              a1.value
            ))
          }
        ),
        /* @__PURE__ */ v.jsx(
          U7,
          {
            anchorEl: Z == null ? void 0 : Z.anchor,
            open: !!Z,
            onClose: () => Y(null),
            children: cS.map((a1) => /* @__PURE__ */ v.jsxs(
              Ta,
              {
                onClick: () => {
                  Z && Q(Z.index, a1.value), Y(null);
                },
                sx: { display: "flex", justifyContent: "space-between", gap: 3 },
                children: [
                  /* @__PURE__ */ v.jsx(le, { variant: "body2", children: a1.label }),
                  /* @__PURE__ */ v.jsx(
                    le,
                    {
                      variant: "body2",
                      color: "text.secondary",
                      fontFamily: "monospace",
                      children: a1.display
                    }
                  )
                ]
              },
              a1.value
            ))
          }
        ),
        /* @__PURE__ */ v.jsx(
          u11,
          {
            open: V,
            title: "Discard unsaved changes?",
            content: "Your changes to the naming pattern have not been saved.",
            confirmLabel: "Discard",
            cancelLabel: "Keep editing",
            onConfirm: () => {
              J(!1), M();
            },
            onCancel: () => J(!1)
          }
        )
      ]
    }
  );
}, Jt1 = ({
  open: e,
  title: n,
  options: i,
  isLoading: a = !1,
  loadErrorText: s,
  onRetryLoad: g,
  isSaving: c = !1,
  disabled: I = !1,
  errorText: h,
  onClose: m,
  onSelect: w
}) => /* @__PURE__ */ v.jsxs(
  hl,
  {
    open: e,
    onClose: c ? void 0 : m,
    maxWidth: "xs",
    fullWidth: !0,
    "aria-labelledby": "folder-picker-dialog-title",
    children: [
      /* @__PURE__ */ v.jsx(HA, { id: "folder-picker-dialog-title", children: n }),
      /* @__PURE__ */ v.jsxs(T0, { sx: { pt: 0 }, children: [
        h && /* @__PURE__ */ v.jsx(Yr, { severity: "error", sx: { mb: 1 }, children: h }),
        a ? /* @__PURE__ */ v.jsx(_1, { sx: { display: "flex", justifyContent: "center", py: 3 }, children: /* @__PURE__ */ v.jsx(D3, { size: 22 }) }) : s ? /* @__PURE__ */ v.jsx(
          Yr,
          {
            severity: "error",
            action: g && /* @__PURE__ */ v.jsx(v2, { color: "inherit", size: "small", onClick: g, children: "Try again" }),
            children: s
          }
        ) : (
          // MenuList owns focus: it moves focus into the list on open and gives
          // the menu items arrow-key navigation, so destinations stay reachable
          // without a pointer.
          /* @__PURE__ */ v.jsx(ES, { autoFocusItem: !0, disablePadding: !0, children: i.map((x) => /* @__PURE__ */ v.jsxs(
            Ta,
            {
              disabled: x.disabled || c || I,
              onClick: () => w(x.id),
              sx: { pl: 2 + x.depth * 2.5, borderRadius: 1 },
              children: [
                /* @__PURE__ */ v.jsx(
                  De,
                  {
                    icon: x.id == null ? "folderOpen" : "folder",
                    sx: { mr: 1, fontSize: 16, color: "text.secondary" }
                  }
                ),
                x.label
              ]
            },
            x.id ?? "root"
          )) })
        )
      ] }),
      /* @__PURE__ */ v.jsx(Nc, { children: /* @__PURE__ */ v.jsx(v2, { color: "inherit", onClick: m, disabled: c, children: "Cancel" }) })
    ]
  }
), Yt1 = ja(
  function({
    label: n,
    value: i,
    emptyText: a = "—",
    extraCount: s = 0,
    saving: g = !1,
    disabled: c = !1,
    readOnly: I = !1,
    wide: h = !1,
    shrinkable: m = !1,
    expanded: w,
    error: x = !1,
    title: M,
    onClick: O
  }, k) {
    const z = !!i, N = /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx(d11, { error: x, children: n }),
      /* @__PURE__ */ v.jsx(
        C11,
        {
          wide: h,
          capped: !I,
          hasValue: z,
          error: x,
          children: z ? i : a
        }
      ),
      s > 0 && /* @__PURE__ */ v.jsxs(A11, { children: [
        "+",
        s
      ] })
    ] });
    return I ? /* @__PURE__ */ v.jsx(f11, { title: M ?? i, children: N }) : /* @__PURE__ */ v.jsx(
      g11,
      {
        ref: k,
        size: "small",
        variant: "outlined",
        color: "inherit",
        onClick: O,
        disabled: c,
        "aria-haspopup": "listbox",
        "aria-expanded": w,
        title: M,
        wide: h,
        shrinkable: m,
        hasValue: z,
        error: x,
        endIcon: g ? /* @__PURE__ */ v.jsx(D3, { size: 10, color: "inherit" }) : /* @__PURE__ */ v.jsx(De, { icon: "chevronDown" }),
        children: N
      }
    );
  }
), c11 = 180, WT = (e) => ({
  borderRadius: 999,
  minHeight: 24,
  fontFamily: e.typography.button.fontFamily,
  fontSize: 12,
  fontWeight: e.typography.fontWeightRegular,
  letterSpacing: e.typography.button.letterSpacing,
  lineHeight: 1.9,
  color: e.palette.text.primary,
  whiteSpace: "nowrap",
  minWidth: 0
}), g11 = q1(v2, {
  shouldForwardProp: (e) => e !== "wide" && e !== "shrinkable" && e !== "hasValue" && e !== "error"
})(
  ({ theme: e, wide: n, shrinkable: i, hasValue: a, error: s }) => ({
    ...WT(e),
    // Non-wide chips hug their content so a squeezed row ellipsizes the wide
    // chip instead of short values like "Year 2024".
    ...!n && !i && { flexShrink: 0 },
    textTransform: "none",
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: e.spacing(1.25),
    paddingRight: e.spacing(1.25),
    borderColor: e.palette.divider,
    "& .MuiButton-endIcon": {
      marginLeft: e.spacing(0.5),
      "& svg": { fontSize: 10 }
    },
    // The chevron inherits `color`. Hover restates the colors so the outlined
    // variant's neutral hover doesn't wash out the error state.
    ...s && {
      borderColor: e.palette.common.error[600],
      color: e.palette.common.error[600],
      backgroundColor: e.palette.common.error[50],
      "&:hover": {
        borderColor: e.palette.common.error[600],
        backgroundColor: e.palette.common.error[100]
      }
    },
    // Grow-but-shrinkable up to 290px when a value is set: flex-shrink plus
    // minWidth 0 keep the min-content near zero so a long label can never push
    // the surrounding row's min width around. Unset hugs content.
    ...n && {
      flex: a ? "1 1 auto" : "0 1 auto",
      maxWidth: 290,
      justifyContent: "flex-start"
    }
  })
), f11 = q1("span")(({ theme: e }) => ({
  ...WT(e),
  display: "inline-flex",
  alignItems: "center",
  border: `1px solid ${e.palette.divider}`,
  paddingLeft: e.spacing(1.25),
  paddingRight: e.spacing(1.25),
  maxWidth: "100%",
  flex: "0 1 auto"
})), d11 = q1("span", {
  shouldForwardProp: (e) => e !== "error"
})(({ theme: e, error: n }) => ({
  color: n ? e.palette.common.error[600] : e.palette.common.fieldChipMutedText ?? e.palette.text.secondary,
  marginRight: e.spacing(0.5),
  flexShrink: 0
})), C11 = q1("span", {
  shouldForwardProp: (e) => e !== "wide" && e !== "capped" && e !== "hasValue" && e !== "error"
})(
  ({ theme: e, wide: n, capped: i, hasValue: a, error: s }) => ({
    fontWeight: 600,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    ...!a && {
      color: e.palette.common.fieldChipMutedText ?? e.palette.text.secondary
    },
    ...s && { color: e.palette.common.error[600] },
    ...n ? { flex: 1 } : i && { maxWidth: c11 }
  })
), A11 = q1("span")(({ theme: e }) => ({
  flexShrink: 0,
  marginLeft: e.spacing(0.5),
  fontWeight: 600
})), I11 = 48, _T = 300, af = { kind: "clear" }, P7 = (e, n) => e.kind === "clear" ? n.kind === "clear" : n.kind === "option" && e.id === n.id;
function Qt1({
  open: e,
  anchorEl: n,
  onClose: i,
  onDone: a,
  label: s,
  searchLabel: g,
  searchPlaceholder: c,
  query: I,
  onQueryChange: h,
  options: m,
  selectionMode: w = "single",
  selectedIds: x,
  onSelect: M,
  defaultActiveId: O,
  emptyText: k,
  isLoading: z = !1,
  errorText: N,
  onRetry: U,
  onClear: Q,
  clearLabel: _ = "Clear",
  clearAriaLabel: X,
  onEndReached: B,
  isLoadingMore: Z = !1,
  loadMoreErrorText: Y,
  onRetryLoadMore: V,
  disabled: J = !1
}) {
  const e1 = LS(), f1 = Cn(null), v1 = Cn(null), a1 = Cn(null), d1 = Cn(null), [S1, h1] = gt(null), L1 = hc("(pointer: coarse), (hover: none)"), { viewport: c1, compact: b1, veryShort: t1, anchorPosition: C1 } = aJ(
    e,
    L1,
    n,
    _T
  ), w1 = !z && !N, E1 = w1 ? m : [], V1 = E1.filter((H1) => !H1.disabled).map(({ id: H1 }) => ({ kind: "option", id: H1 })), K1 = Q && V1.length > 0 ? [...V1, af] : V1, B1 = S1 ?? (O === void 0 ? null : { kind: "option", id: O }), te = B1 === null ? null : K1.find((H1) => P7(H1, B1)) ?? null, R1 = (H1) => te !== null && P7(te, H1), x1 = (H1) => H1.kind === "clear" ? `${e1}-clear` : `${e1}-option-${E1.findIndex(
    (Y1) => Y1.id === H1.id
  )}`, J1 = (H1) => {
    var Y1, me, ut;
    if (!J) {
      if (H1.kind === "clear") {
        L1 ? (me = a1.current ?? ((Y1 = f1.current) == null ? void 0 : Y1.querySelector(
          '[role="option"]:not([aria-disabled="true"]):not([id$="-clear"])'
        )) ?? d1.current) == null || me.focus() : (ut = v1.current) == null || ut.focus(), Q == null || Q();
        return;
      }
      E1.some((Qe) => Qe.id === H1.id && !Qe.disabled) && M(H1.id);
    }
  }, X1 = (H1) => {
    var Qe, Ae, Bt;
    if (K1.length === 0) {
      h1(null);
      return;
    }
    const Y1 = te === null ? -1 : K1.findIndex((ke) => P7(ke, te)), me = H1 === 1 ? Math.min(Y1 + 1, K1.length - 1) : Math.max(Y1 - 1, 0), ut = K1[me];
    h1(ut), (Bt = (Ae = (Qe = f1.current) == null ? void 0 : Qe.ownerDocument.getElementById(x1(ut))) == null ? void 0 : Ae.scrollIntoView) == null || Bt.call(Ae, { block: "nearest" });
  }, D1 = (H1) => {
    H1.key === "ArrowDown" || H1.key === "ArrowUp" ? (H1.preventDefault(), X1(H1.key === "ArrowDown" ? 1 : -1)) : H1.key === "Enter" && te !== null && (H1.preventDefault(), J1(te));
  }, $1 = (H1) => {
    var Y1;
    L1 || (H1.preventDefault(), (Y1 = v1.current) == null || Y1.focus());
  }, y1 = (H1) => {
    if (!B) return;
    const { clientHeight: Y1, scrollHeight: me, scrollTop: ut } = H1.currentTarget;
    me - ut - Y1 <= I11 && B();
  }, ie = E1.reduce((H1, Y1, me) => {
    const ut = H1[H1.length - 1];
    return ut && ut.group === Y1.group ? ut.options.push(Y1) : H1.push({ group: Y1.group, start: me, options: [Y1] }), H1;
  }, []), ae = (H1) => {
    const Y1 = x.includes(H1.id), me = { kind: "option", id: H1.id };
    return /* @__PURE__ */ v.jsxs(
      w11,
      {
        dense: !0,
        id: x1(me),
        role: "option",
        tabIndex: -1,
        "aria-selected": Y1,
        selected: Y1,
        disabled: J || H1.disabled,
        active: R1(me),
        onMouseDown: $1,
        onClick: () => J1(me),
        onMouseEnter: () => h1(me),
        children: [
          /* @__PURE__ */ v.jsx(gS, { children: Y1 && /* @__PURE__ */ v.jsx(De, { icon: "check" }) }),
          /* @__PURE__ */ v.jsxs(E11, { children: [
            /* @__PURE__ */ v.jsx(M11, { emphasized: H1.emphasized, children: H1.label }),
            H1.description && /* @__PURE__ */ v.jsx(T11, { children: H1.description })
          ] })
        ]
      },
      `option-${String(H1.id)}`
    );
  };
  return /* @__PURE__ */ v.jsxs(
    p11,
    {
      open: e,
      anchorEl: n,
      anchorReference: L1 && b1 ? "anchorPosition" : "anchorEl",
      anchorPosition: L1 && b1 ? C1 : void 0,
      onClose: i,
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
      transformOrigin: L1 && b1 ? { vertical: "bottom", horizontal: "left" } : { vertical: -4, horizontal: "left" },
      slotProps: L1 ? { paper: { ref: d1, tabIndex: -1, sx: {
        maxHeight: Math.max(0, c1.height - 16),
        maxWidth: Math.max(0, c1.width - 16),
        overflow: "hidden"
      } } } : void 0,
      TransitionProps: {
        onEnter: () => h1(null),
        onEntered: (H1) => {
          var Y1, me;
          if (L1) {
            H1.contains(document.activeElement) || (Y1 = d1.current) == null || Y1.focus();
            return;
          }
          !L1 && (H1 === document.activeElement || !H1.contains(document.activeElement)) && ((me = v1.current) == null || me.focus());
        }
      },
      onKeyDown: (H1) => {
        H1.key === "Escape" && (H1.stopPropagation(), i());
      },
      children: [
        /* @__PURE__ */ v.jsxs(h11, { sx: L1 ? { flexShrink: 0, ...t1 && { p: 0.5 } } : void 0, children: [
          /* @__PURE__ */ v.jsx(m11, { icon: "search" }),
          /* @__PURE__ */ v.jsx(
            v11,
            {
              autoFocus: !L1,
              fullWidth: !0,
              size: "small",
              inputRef: v1,
              value: I,
              disabled: J,
              placeholder: c,
              onChange: (H1) => {
                h(H1.target.value), h1(null);
              },
              onKeyDown: D1,
              inputProps: {
                "aria-label": g,
                role: "combobox",
                "aria-autocomplete": "list",
                "aria-expanded": !0,
                "aria-controls": e1,
                "aria-activedescendant": te === null ? void 0 : x1(te)
              }
            }
          )
        ] }),
        /* @__PURE__ */ v.jsxs(
          y11,
          {
            ref: f1,
            id: e1,
            role: "listbox",
            "aria-label": s,
            "aria-multiselectable": w === "multiple" || void 0,
            onMouseLeave: () => h1(null),
            sx: L1 ? {
              flex: "1 1 auto",
              minHeight: t1 && a ? 32 : 64,
              overflow: "hidden"
            } : void 0,
            children: [
              /* @__PURE__ */ v.jsxs(
                b11,
                {
                  role: "presentation",
                  onScroll: y1,
                  sx: L1 ? {
                    flex: "1 1 auto",
                    minHeight: 0,
                    maxHeight: "none"
                  } : void 0,
                  children: [
                    z && /* @__PURE__ */ v.jsx(of, { children: /* @__PURE__ */ v.jsx(D3, { size: 18 }) }),
                    !z && N && /* @__PURE__ */ v.jsxs(of, { children: [
                      /* @__PURE__ */ v.jsx(le, { variant: "caption", color: "error", children: N }),
                      U && /* @__PURE__ */ v.jsx(v2, { size: "small", onClick: U, children: "Retry" })
                    ] }),
                    w1 && m.length === 0 && /* @__PURE__ */ v.jsx(of, { children: /* @__PURE__ */ v.jsx(
                      le,
                      {
                        role: "status",
                        variant: "caption",
                        color: "text.secondary",
                        children: k
                      }
                    ) }),
                    ie.map((H1) => {
                      const Y1 = H1.options.map(ae);
                      if (H1.group === void 0) return Y1;
                      const me = `${e1}-group-${H1.start}`;
                      return /* @__PURE__ */ v.jsxs(
                        _1,
                        {
                          role: "group",
                          "aria-labelledby": me,
                          children: [
                            /* @__PURE__ */ v.jsx(
                              x11,
                              {
                                id: me,
                                component: "div",
                                role: "presentation",
                                disableSticky: !0,
                                children: H1.group
                              }
                            ),
                            Y1
                          ]
                        },
                        `group-${H1.start}`
                      );
                    }),
                    w1 && Z && /* @__PURE__ */ v.jsx(of, { children: /* @__PURE__ */ v.jsx(D3, { size: 18 }) }),
                    w1 && Y && /* @__PURE__ */ v.jsxs(of, { children: [
                      /* @__PURE__ */ v.jsx(le, { variant: "caption", color: "error", children: Y }),
                      V && /* @__PURE__ */ v.jsx(v2, { size: "small", onClick: V, children: "Retry" })
                    ] })
                  ]
                }
              ),
              Q && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
                /* @__PURE__ */ v.jsx(pA, { role: "presentation" }),
                /* @__PURE__ */ v.jsxs(
                  S11,
                  {
                    dense: !0,
                    id: x1(af),
                    role: "option",
                    tabIndex: 0,
                    "aria-selected": !1,
                    "aria-label": X,
                    disabled: J,
                    active: R1(af),
                    onMouseDown: $1,
                    onClick: () => J1(af),
                    onMouseEnter: () => h1(af),
                    children: [
                      /* @__PURE__ */ v.jsx(gS, {}),
                      _
                    ]
                  }
                )
              ] })
            ]
          }
        ),
        a && /* @__PURE__ */ v.jsx(_1, { sx: { display: "flex", justifyContent: "flex-end", p: t1 && L1 ? 0.5 : 1, borderTop: 1, borderColor: "divider", flexShrink: 0 }, children: /* @__PURE__ */ v.jsx(v2, { ref: a1, size: "small", variant: "contained", onClick: a, children: "Done" }) })
      ]
    }
  );
}
const p11 = q1(UA)({
  "& .MuiPopover-paper": {
    width: _T,
    display: "flex",
    flexDirection: "column"
  }
}), h11 = q1(_1)(({ theme: e }) => ({
  position: "relative",
  padding: e.spacing(1),
  borderBottom: `1px solid ${e.palette.divider}`
})), m11 = q1(De)(({ theme: e }) => ({
  position: "absolute",
  left: e.spacing(2.5),
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 14,
  color: e.palette.text.secondary,
  pointerEvents: "none",
  zIndex: 1
})), v11 = q1(Mf)(({ theme: e }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: e.palette.background.default,
    borderRadius: 6,
    "& fieldset": { borderColor: e.palette.divider }
  },
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    padding: e.spacing(1.25, 1, 1.25, 4),
    fontSize: 13,
    "&::placeholder": { fontSize: 13 }
  }
})), y11 = q1(_1)({
  display: "flex",
  flexDirection: "column",
  minHeight: 0
}), b11 = q1(_1)(({ theme: e }) => ({
  overflow: "auto",
  maxHeight: 336,
  padding: e.spacing(0.5, 0)
})), of = q1(_1)(({ theme: e }) => ({
  minHeight: 64,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: e.spacing(1),
  padding: e.spacing(2)
})), w11 = q1(Ta, {
  shouldForwardProp: (e) => e !== "active"
})(({ theme: e, active: n }) => ({
  "&&": {
    minHeight: 32,
    padding: e.spacing(0.5, 2, 0.5, 1.25),
    fontSize: 13,
    fontWeight: e.typography.fontWeightRegular,
    lineHeight: 1.4,
    borderRadius: 0
  },
  ...n && { backgroundColor: e.palette.action.hover },
  "&&.Mui-selected": { fontWeight: 600 }
})), x11 = q1(Cz)(({ theme: e }) => ({
  ...e.typography.caption,
  padding: e.spacing(1.25, 2, 0.5),
  // Line the heading up with option labels, past the row inset and check gutter.
  paddingLeft: `calc(${e.spacing(1.25)} + 14px)`,
  textTransform: "uppercase",
  color: e.palette.text.secondary,
  backgroundColor: "transparent"
})), S11 = q1(Ta, {
  shouldForwardProp: (e) => e !== "active"
})(({ theme: e, active: n }) => ({
  flexShrink: 0,
  color: e.palette.text.secondary,
  "&&": {
    minHeight: 36,
    padding: e.spacing(0, 2, 0, 1.25),
    fontSize: 13,
    fontWeight: e.typography.fontWeightRegular,
    lineHeight: 1.4,
    borderRadius: 0
  },
  ...n && { backgroundColor: e.palette.action.hover }
})), gS = q1("span")({
  width: 14,
  display: "inline-flex",
  flexShrink: 0,
  alignItems: "center",
  fontSize: 10
}), E11 = q1("span")({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0
}), M11 = q1("span", {
  shouldForwardProp: (e) => e !== "emphasized"
})(({ theme: e, emphasized: n }) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  ...n && { fontWeight: e.typography.fontWeightBold }
})), T11 = q1("span")(({ theme: e }) => ({
  fontSize: 12,
  color: e.palette.text.secondary
})), Xt1 = ({ text: e }) => /* @__PURE__ */ v.jsxs(_1, { display: "flex", alignItems: "center", width: "100%", children: [
  /* @__PURE__ */ v.jsx(pA, { sx: { flexGrow: 1 } }),
  /* @__PURE__ */ v.jsx(le, { mx: 3, children: e }),
  /* @__PURE__ */ v.jsx(pA, { sx: { flexGrow: 1 } })
] }), L11 = q1(_1)(({ theme: e }) => {
  var n, i;
  return {
    display: "flex",
    flexDirection: "column",
    backgroundColor: (i = (n = e.palette.common) == null ? void 0 : n.neutrals) == null ? void 0 : i[50],
    minHeight: "100vh",
    "@supports (height: -webkit-fill-available)": {
      minHeight: "-webkit-fill-available"
    },
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    [e.breakpoints.down("md")]: {
      "html.native-android &": {
        top: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))",
        bottom: "var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))",
        minHeight: "var(--liscio-app-viewport-height, 100vh)"
      }
    },
    // Change position to fit mobile views in desktop layout
    [e.breakpoints.up("md")]: {
      position: "relative",
      minHeight: "calc(100vh - 50px)"
      // The desktop view has a footer that is 50 pixels high
    }
  };
}), Gt1 = ({
  children: e,
  dataTestId: n = "ScreenWrapper",
  ...i
}) => /* @__PURE__ */ v.jsx(L11, { ...i, "data-testid": n, children: e }), R11 = q1(_1)(({ theme: e }) => ({
  alignItems: "stretch",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: e.spacing(3),
  padding: e.spacing(4)
})), qt1 = ({ children: e, ...n }) => /* @__PURE__ */ v.jsx(R11, { ...n, children: e });
q1(_1)({
  position: "relative"
});
q1(MS)(({ theme: e }) => ({
  position: "absolute",
  left: "calc(50% - 20px)",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: e.zIndex.modal + 10
}));
const O11 = q1(_1)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}), D11 = 5, k11 = ({
  touchDiff: e,
  reloadThreshold: n
}) => /* @__PURE__ */ v.jsx(O11, { sx: { height: e }, children: e > n - D11 && /* @__PURE__ */ v.jsx(D3, { variant: "indeterminate", disableShrink: !0, size: 30 }) }), F7 = 100, j11 = 20, z11 = ({
  bodyNodeRef: e,
  reloadFunction: n
}) => {
  const [i, a] = gt(0), s = Cn(i), g = (x) => {
    a(x), s.current = x;
  }, c = Cn(0), I = Cn(0), h = m2(
    (x) => {
      var M;
      c.current = x.touches[0].clientY, I.current = ((M = e == null ? void 0 : e.current) == null ? void 0 : M.scrollTop) || 0;
    },
    [e]
  ), m = m2(
    (x) => {
      var z;
      const M = ((z = e == null ? void 0 : e.current) == null ? void 0 : z.scrollTop) || 0, k = x.touches[0].clientY - c.current - I.current;
      k > 0 && M === 0 && k < F7 + j11 && g(Math.floor(k)), x.stopPropagation();
    },
    [e]
  ), w = m2(() => {
    s.current >= F7 && n(), g(0), c.current = 0, I.current = 0;
  }, [n]);
  return vn(() => {
    const x = e.current;
    return x && (x.addEventListener("touchstart", h), x.addEventListener("touchmove", m), x.addEventListener("touchend", w)), () => {
      x && (x.removeEventListener("touchstart", h), x.removeEventListener("touchmove", m), x.removeEventListener("touchend", w));
    };
  }, [e, w, m, h]), /* @__PURE__ */ v.jsx(k11, { touchDiff: i, reloadThreshold: F7 });
}, N11 = q1(_1)(({ theme: e }) => ({
  flexGrow: 1,
  overflowY: "auto",
  overflowX: "hidden",
  paddingBottom: "8px",
  position: "relative",
  overscrollBehavior: "none",
  [e.breakpoints.up("md")]: {
    overflow: "visible"
  }
})), Zt1 = ({
  children: e,
  reloadFunction: n,
  id: i = "body-wrapper",
  ...a
}) => {
  const s = Cn();
  return /* @__PURE__ */ v.jsxs(N11, { ref: s, id: i, ...a, children: [
    n && /* @__PURE__ */ v.jsx(
      z11,
      {
        bodyNodeRef: s,
        reloadFunction: n
      }
    ),
    e
  ] });
}, $t1 = q1(_1)(({ theme: e }) => ({
  borderTop: `solid 1px ${e.palette.common.blueGray[200]}`,
  padding: "16px 8px 32px 8px",
  textAlign: "center"
})), en1 = q1(_1)(() => ({
  padding: "16px 8px 32px 8px",
  textAlign: "center"
}));
function tn1({ tags: e, getLabel: n = (i) => i }) {
  return !e || e.length < 1 ? null : /* @__PURE__ */ v.jsx(v.Fragment, { children: e == null ? void 0 : e.map((i) => /* @__PURE__ */ v.jsx(Em, { label: n(i) }, i)) });
}
const P11 = ({
  error: e,
  parseError: n = DS,
  errorContent: i,
  title: a = "Submission Error",
  onClose: s = () => {
  },
  closeLabel: g = "Close",
  secondaryAction: c,
  secondaryLabel: I,
  defaultMessage: h = _7
}) => {
  const [m, w] = gt(!1), x = m2(async () => {
    await s(), w(!1);
  }, [s, w]), M = V2(
    () => n(e, h),
    [n, e, h]
  );
  return vn(() => {
    (i || M) && w(!0);
  }, [i, M, w]), /* @__PURE__ */ v.jsxs(
    hl,
    {
      open: m,
      onClose: x,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description",
      children: [
        /* @__PURE__ */ v.jsx(HA, { id: "alert-dialog-title", children: a }),
        /* @__PURE__ */ v.jsx(T0, { children: i || /* @__PURE__ */ v.jsx(SS, { id: "alert-dialog-description", children: M }) }),
        /* @__PURE__ */ v.jsxs(Nc, { children: [
          c && I && /* @__PURE__ */ v.jsx(j2, { onClick: c, children: I }),
          /* @__PURE__ */ v.jsx(j2, { onClick: x, children: g })
        ] })
      ]
    }
  );
}, nn1 = ({
  hasError: e
}) => /* @__PURE__ */ v.jsx(
  P11,
  {
    title: "Network problem",
    error: e,
    defaultMessage: "Please check your internet connection",
    onClose: () => window.location.reload(),
    closeLabel: "Reload"
  }
), rn1 = ({
  error: e,
  parseError: n = DS,
  defaultMessage: i = _7
}) => {
  const a = V2(
    () => n(e, i),
    [n, e, i]
  );
  return e ? /* @__PURE__ */ v.jsx(Yr, { severity: "error", children: a || _7 }) : null;
};
function in1({
  title: e,
  description: n,
  ctaLabel: i,
  activateLabel: a,
  removeLabel: s,
  icon: g,
  disabled: c,
  onActivate: I,
  onRemove: h
}) {
  return /* @__PURE__ */ v.jsxs(
    _1,
    {
      component: "article",
      sx: {
        position: "relative",
        display: "flex",
        minWidth: 0,
        minHeight: 220,
        flexDirection: "column",
        gap: 1.5,
        border: 1,
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: "0 2px 8px rgba(28, 31, 54, 0.08)",
        p: 2.25
      },
      children: [
        /* @__PURE__ */ v.jsx(
          Sm,
          {
            icon: "close",
            size: "small",
            "aria-label": s,
            disabled: c,
            onClick: h,
            sx: {
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary"
            }
          }
        ),
        /* @__PURE__ */ v.jsx(
          _1,
          {
            sx: {
              display: "grid",
              width: 40,
              height: 40,
              placeItems: "center",
              borderRadius: 2,
              bgcolor: "common.primary.50",
              color: "common.primary.500"
            },
            children: /* @__PURE__ */ v.jsx(De, { icon: g, fontSize: "small" })
          }
        ),
        /* @__PURE__ */ v.jsx(
          le,
          {
            component: "h3",
            variant: "subtitle1",
            sx: { pr: 2, fontWeight: 600 },
            children: e
          }
        ),
        /* @__PURE__ */ v.jsx(
          le,
          {
            variant: "body2",
            color: "text.secondary",
            sx: { fontWeight: 400, lineHeight: 1.5 },
            children: n
          }
        ),
        /* @__PURE__ */ v.jsx(
          j2,
          {
            variant: "contained",
            size: "small",
            "aria-label": a,
            onClick: I,
            endIcon: /* @__PURE__ */ v.jsx(De, { icon: "arrowRight", fontSize: "small" }),
            sx: { alignSelf: "flex-start", mt: "auto" },
            children: i
          }
        )
      ]
    }
  );
}
function an1({
  title: e,
  description: n,
  icon: i,
  statusLabel: a,
  ctaLabel: s,
  activateAriaLabel: g,
  actionLabel: c,
  actionAriaLabel: I,
  dismissAriaLabel: h,
  visible: m,
  disabled: w,
  onActivate: x,
  onAction: M
}) {
  return /* @__PURE__ */ v.jsxs(
    _1,
    {
      component: "article",
      sx: {
        position: "relative",
        display: "flex",
        minWidth: 0,
        minHeight: 206,
        flexDirection: "column",
        gap: 1.5,
        border: 1,
        borderColor: "divider",
        borderRadius: "8px",
        bgcolor: "background.paper",
        boxShadow: "0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.12)",
        px: 2.25,
        pt: 2.25,
        pb: 2,
        ...m && {
          "&::after": {
            position: "absolute",
            inset: -1,
            border: 2,
            borderStyle: "dashed",
            borderColor: "common.accent.400",
            borderRadius: "8px",
            content: '""',
            pointerEvents: "none"
          }
        }
      },
      children: [
        m ? /* @__PURE__ */ v.jsx(
          Sm,
          {
            icon: "close",
            size: "small",
            "aria-label": h,
            disabled: w,
            onClick: M,
            sx: {
              position: "absolute",
              zIndex: 1,
              top: 8,
              right: 8,
              color: "text.secondary"
            }
          }
        ) : /* @__PURE__ */ v.jsx(
          Em,
          {
            size: "small",
            label: a,
            sx: { position: "absolute", top: 12, right: 12, fontWeight: 600 }
          }
        ),
        /* @__PURE__ */ v.jsx(
          _1,
          {
            sx: {
              display: "grid",
              width: 38,
              height: 38,
              placeItems: "center",
              borderRadius: "9px",
              bgcolor: "common.primary.50",
              color: "common.primary.500"
            },
            children: /* @__PURE__ */ v.jsx(De, { icon: i, fontSize: "small" })
          }
        ),
        /* @__PURE__ */ v.jsx(
          le,
          {
            component: "h4",
            variant: "subtitle1",
            sx: { pr: 2.5, fontSize: 15.5, fontWeight: 600 },
            children: e
          }
        ),
        /* @__PURE__ */ v.jsx(
          le,
          {
            variant: "body2",
            color: "text.secondary",
            sx: { fontSize: 12.5, fontWeight: 400, lineHeight: 1.5 },
            children: n
          }
        ),
        m && /* @__PURE__ */ v.jsx(
          j2,
          {
            variant: "contained",
            size: "small",
            disabled: w,
            "aria-label": g,
            onClick: x,
            endIcon: /* @__PURE__ */ v.jsx(De, { icon: "arrowRight", fontSize: "small" }),
            sx: { zIndex: 1, alignSelf: "flex-start", mt: "auto" },
            children: s
          }
        ),
        /* @__PURE__ */ v.jsx(
          j2,
          {
            variant: m ? "text" : "contained",
            size: "small",
            disabled: w,
            "aria-label": I,
            onClick: M,
            startIcon: /* @__PURE__ */ v.jsx(De, { icon: m ? "close" : "add", fontSize: "small" }),
            sx: {
              zIndex: 1,
              alignSelf: "flex-start",
              mt: m ? 0 : "auto",
              ...m && {
                px: 0,
                color: "common.accent.600",
                "&:hover": { bgcolor: "transparent", color: "common.accent.700" }
              }
            },
            children: c
          }
        )
      ]
    }
  );
}
const fS = {
  display: "grid",
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    md: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))"
  },
  gap: 2
}, F11 = {
  display: "grid",
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    md: "repeat(4, minmax(0, 1fr))"
  },
  gap: 2
};
function on1({
  heading: e,
  description: n,
  headerAction: i,
  errorMessage: a,
  onClearError: s,
  isLoading: g,
  loadingRegionLabel: c,
  loadingItems: I,
  settingsContent: h,
  isEmpty: m,
  emptyMessage: w,
  emptyActionLabel: x,
  emptyActionIcon: M,
  onEmptyAction: O,
  children: k
}) {
  const z = LS();
  return /* @__PURE__ */ v.jsxs(_1, { component: "section", "aria-labelledby": z, children: [
    h ? /* @__PURE__ */ v.jsxs(
      qe,
      {
        direction: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 2,
        sx: {
          mb: 2,
          border: 1,
          borderColor: "common.primary.100",
          borderRadius: "10px",
          bgcolor: "common.primary.50",
          px: 2.25,
          py: 1.75
        },
        children: [
          /* @__PURE__ */ v.jsx(
            De,
            {
              icon: "sliders",
              sx: { color: "common.primary.500", fontSize: 20 }
            }
          ),
          /* @__PURE__ */ v.jsxs(_1, { sx: { minWidth: 0, flex: 1 }, children: [
            /* @__PURE__ */ v.jsx(
              le,
              {
                id: z,
                component: "h2",
                variant: "body2",
                sx: { color: "common.primary.700", fontWeight: 600 },
                children: h.heading
              }
            ),
            /* @__PURE__ */ v.jsx(
              le,
              {
                variant: "body2",
                color: "text.secondary",
                sx: { fontSize: 13, fontWeight: 400 },
                children: h.description
              }
            )
          ] }),
          i
        ]
      }
    ) : /* @__PURE__ */ v.jsxs(
      qe,
      {
        direction: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 2,
        sx: { mb: 2 },
        children: [
          /* @__PURE__ */ v.jsxs(_1, { children: [
            /* @__PURE__ */ v.jsx(
              le,
              {
                id: z,
                component: "h2",
                variant: "h5",
                sx: { fontWeight: 700 },
                children: e
              }
            ),
            /* @__PURE__ */ v.jsx(le, { variant: "body2", color: "text.secondary", sx: { mt: 0.5 }, children: n })
          ] }),
          i
        ]
      }
    ),
    a && /* @__PURE__ */ v.jsx(Yr, { severity: "error", onClose: s, sx: { mb: 2 }, children: a }),
    g ? /* @__PURE__ */ v.jsx(_1, { role: "status", "aria-label": c, sx: fS, children: I.map((N) => /* @__PURE__ */ v.jsx(
      _h,
      {
        variant: "rounded",
        height: 220,
        "aria-label": N.label
      },
      N.key
    )) }) : h ? /* @__PURE__ */ v.jsxs(_1, { children: [
      /* @__PURE__ */ v.jsx(
        le,
        {
          component: "h3",
          variant: "body2",
          color: "text.secondary",
          sx: { mb: 1, fontWeight: 600 },
          children: h.label
        }
      ),
      /* @__PURE__ */ v.jsx(_1, { sx: F11, children: h.children })
    ] }) : m ? /* @__PURE__ */ v.jsxs(
      _1,
      {
        sx: {
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
          bgcolor: "background.paper",
          p: 3,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ v.jsx(le, { variant: "body2", color: "text.secondary", children: w }),
          /* @__PURE__ */ v.jsx(
            j2,
            {
              variant: "text",
              startIcon: /* @__PURE__ */ v.jsx(De, { icon: M }),
              onClick: O,
              sx: { mt: 1 },
              children: x
            }
          )
        ]
      }
    ) : /* @__PURE__ */ v.jsx(_1, { sx: fS, children: k })
  ] });
}
const B11 = q1(Jh)({
  display: "flex"
}), H11 = ({
  label: e,
  labelStyles: n,
  ...i
}) => /* @__PURE__ */ v.jsx(
  B11,
  {
    control: /* @__PURE__ */ v.jsx(Az, { ...i }),
    label: e,
    sx: {
      ...n,
      // Gross, yes, but the padding on switches is weird and I expect our design system
      // will want toggles to hug the left side of their container flush.
      // Manipulating the padding directly in the MUI switch uglifies the component in other ways.
      position: "relative",
      right: "8px"
    }
  }
), sn1 = ({
  control: e,
  name: n,
  ...i
}) => {
  const { field: a } = Qh({ name: n, control: e });
  return /* @__PURE__ */ v.jsx(
    H11,
    {
      ...i,
      value: a.value || !1,
      checked: a.value || !1,
      onChange: a.onChange
    }
  );
}, U11 = q1(_1)({
  display: "flex",
  alignItems: "center"
}), W11 = q1(le)(({ theme: e }) => ({
  color: e.palette.grey[500]
})), ln1 = ({
  initials: e,
  name: n,
  avatar: i,
  accountName: a
}) => /* @__PURE__ */ v.jsxs(U11, { children: [
  /* @__PURE__ */ v.jsx(D$, { src: i, sx: { width: 24, height: 24, fontSize: "12px" }, children: i ? null : e }),
  /* @__PURE__ */ v.jsxs(_1, { sx: { paddingLeft: "15px" }, children: [
    /* @__PURE__ */ v.jsx(le, { children: n }),
    a && /* @__PURE__ */ v.jsx(W11, { children: a })
  ] })
] }), un1 = ({
  userName: e,
  accountName: n,
  onRemoveClick: i
}) => {
  const a = n ? `${e} • ${n}` : e;
  return /* @__PURE__ */ v.jsx(dl, { sx: { width: "auto" }, label: a, onDelete: i });
}, cn1 = q1(Em)(({ theme: e }) => ({
  ...e.typography.body2,
  padding: 0,
  textTransform: "uppercase",
  letterSpacing: "1px"
}));
var _11 = Object.defineProperty, V11 = (e, n, i) => n in e ? _11(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, eA = (e, n, i) => V11(e, typeof n != "symbol" ? n + "" : n, i), Wh = /* @__PURE__ */ new Map(), tA = /* @__PURE__ */ new WeakMap(), dS = 0, K11 = void 0;
function J11(e) {
  return e ? (tA.has(e) || (dS += 1, tA.set(e, dS.toString())), tA.get(e)) : "0";
}
function Y11(e) {
  return Object.keys(e).sort().filter(
    (n) => e[n] !== void 0
  ).map((n) => `${n}_${n === "root" ? J11(e.root) : e[n]}`).toString();
}
function Q11(e) {
  const n = Y11(e);
  let i = Wh.get(n);
  if (!i) {
    const a = /* @__PURE__ */ new Map();
    let s;
    const g = new IntersectionObserver((c) => {
      c.forEach((I) => {
        var h;
        const m = I.isIntersecting && s.some((w) => I.intersectionRatio >= w);
        e.trackVisibility && typeof I.isVisible > "u" && (I.isVisible = m), (h = a.get(I.target)) == null || h.forEach((w) => {
          w(m, I);
        });
      });
    }, e);
    s = g.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), i = {
      id: n,
      observer: g,
      elements: a
    }, Wh.set(n, i);
  }
  return i;
}
function X11(e, n, i = {}, a = K11) {
  if (typeof window.IntersectionObserver > "u" && a !== void 0) {
    const h = e.getBoundingClientRect();
    return n(a, {
      isIntersecting: a,
      target: e,
      intersectionRatio: typeof i.threshold == "number" ? i.threshold : 0,
      time: 0,
      boundingClientRect: h,
      intersectionRect: h,
      rootBounds: h
    }), () => {
    };
  }
  const { id: s, observer: g, elements: c } = Q11(i), I = c.get(e) || [];
  return c.has(e) || c.set(e, I), I.push(n), g.observe(e), function() {
    I.splice(I.indexOf(n), 1), I.length === 0 && (c.delete(e), g.unobserve(e)), c.size === 0 && (g.disconnect(), Wh.delete(s));
  };
}
function G11(e) {
  return typeof e.children != "function";
}
var q11 = class extends o1.Component {
  constructor(e) {
    super(e), eA(this, "node", null), eA(this, "_unobserveCb", null), eA(this, "handleNode", (n) => {
      this.node && (this.unobserve(), !n && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = n || null, this.observeNode();
    }), eA(this, "handleChange", (n, i) => {
      n && this.props.triggerOnce && this.unobserve(), G11(this.props) || this.setState({ inView: n, entry: i }), this.props.onChange && this.props.onChange(n, i);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold: e,
      root: n,
      rootMargin: i,
      trackVisibility: a,
      delay: s,
      fallbackInView: g
    } = this.props;
    this._unobserveCb = X11(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: n,
        rootMargin: i,
        // @ts-ignore
        trackVisibility: a,
        // @ts-ignore
        delay: s
      },
      g
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: O, entry: k } = this.state;
      return e({ inView: O, entry: k, ref: this.handleNode });
    }
    const {
      as: n,
      triggerOnce: i,
      threshold: a,
      root: s,
      rootMargin: g,
      onChange: c,
      skip: I,
      trackVisibility: h,
      delay: m,
      initialInView: w,
      fallbackInView: x,
      ...M
    } = this.props;
    return o1.createElement(
      n || "div",
      { ref: this.handleNode, ...M },
      e
    );
  }
};
const gn1 = ({
  isFetchingNextPage: e,
  fetchNextPage: n,
  isLoading: i,
  hasNextPage: a,
  root: s,
  children: g
}) => {
  const c = i;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    c && /* @__PURE__ */ v.jsx(Rh, {}),
    !c && g,
    e && /* @__PURE__ */ v.jsx(Rh, { numberOfElements: 1, mt: 1 }),
    !i && !e && (a ?? !0) && /* @__PURE__ */ v.jsx(q11, { root: s, onChange: (I) => I && n() })
  ] });
};
function fn1({
  chips: e,
  disabled: n,
  onRemoveChip: i,
  onRemoveAccount: a,
  onAssignAccount: s,
  onRefreshAccountOptions: g,
  renderChip: c,
  accountAssignmentDisplay: I = "hover"
}) {
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: Z11(e).map(
    ({ accountId: h, accountName: m, chips: w }) => {
      if (h > 0 && m) {
        const x = w.every(
          (M) => M.canRemove !== !1
        );
        return /* @__PURE__ */ v.jsxs(
          _1,
          {
            component: "span",
            role: "group",
            "aria-label": `${m} recipients`,
            "data-testid": `recipient-account-group-${h}`,
            sx: {
              display: "inline-flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 0.5,
              maxWidth: "100%",
              p: 0.5,
              border: 1,
              borderColor: "primary.light",
              borderRadius: "21px",
              bgcolor: (M) => YP(M.palette.primary.main, 0.08)
            },
            children: [
              /* @__PURE__ */ v.jsx(
                dl,
                {
                  label: m,
                  size: "small",
                  "data-recipient-chip-variant": "account",
                  onDelete: n || !a || !x ? void 0 : (M) => {
                    M.stopPropagation(), a(h);
                  },
                  deleteIcon: /* @__PURE__ */ v.jsx(De, { icon: "close", fontSize: "small" }),
                  sx: {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    height: 32,
                    borderRadius: "999px",
                    fontWeight: 700,
                    "& .MuiChip-deleteIcon": {
                      color: "primary.contrastText",
                      opacity: 0.8
                    }
                  }
                }
              ),
              w.map(
                (M) => CS(
                  M,
                  n,
                  i,
                  s,
                  g,
                  c,
                  I
                )
              )
            ]
          },
          h
        );
      }
      return w.map(
        (x) => CS(
          x,
          n,
          i,
          s,
          g,
          c,
          I
        )
      );
    }
  ) });
}
function Z11(e) {
  const n = /* @__PURE__ */ new Map();
  return e.forEach((i) => {
    const a = i.key.accountId, s = n.get(a) || {
      accountId: a,
      accountName: i.accountName,
      chips: []
    };
    s.chips.push(i), n.set(a, s);
  }), [...n.values()];
}
function CS(e, n, i, a, s, g, c) {
  var x;
  const I = e.canRemove !== !1 && !n, h = e.key.accountId <= 0, m = e.canAssignAccount === !0 || !!((x = e.accountOptions) != null && x.length) || e.canAssignAccount == null && !!s, w = /* @__PURE__ */ v.jsx(
    dl,
    {
      "data-recipient-chip-variant": h ? "accountless" : "contact",
      avatar: e.initials || e.avatar ? /* @__PURE__ */ v.jsx(
        yS,
        {
          src: e.avatar ?? void 0,
          sx: {
            width: 24,
            height: 24,
            bgcolor: "secondary.main",
            color: "common.white",
            fontSize: "0.65rem",
            fontWeight: 600
          },
          children: e.initials
        }
      ) : void 0,
      label: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        e.label,
        e.isFirmEmployee ? /* @__PURE__ */ v.jsx(
          _1,
          {
            component: "span",
            "data-testid": "firm-recipient-badge",
            sx: {
              ml: 0.75,
              px: 0.5,
              py: 0.125,
              borderRadius: "4px",
              bgcolor: "primary.main",
              color: "primary.contrastText",
              fontSize: "0.625rem",
              fontWeight: 700,
              lineHeight: 1.4
            },
            children: "FIRM"
          }
        ) : null
      ] }),
      size: "small",
      onDelete: I ? (M) => {
        M.stopPropagation(), i(e.key);
      } : void 0,
      deleteIcon: /* @__PURE__ */ v.jsx(De, { icon: "close", fontSize: "small" }),
      onClick: (M) => M.stopPropagation(),
      sx: {
        bgcolor: h ? "action.hover" : "background.paper",
        border: 1,
        borderColor: h ? "secondary.light" : "primary.light",
        borderStyle: h ? "dashed" : "solid",
        borderRadius: "999px",
        height: 32,
        maxWidth: "100%",
        fontWeight: 600,
        "& .MuiChip-label": {
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        "& .MuiChip-avatar": {
          color: "common.white"
        }
      }
    },
    `${e.key.accountId}:${e.key.contactId}`
  );
  return !h || e.canRemove === !1 || !a || !m ? g ? g(e, w) : w : /* @__PURE__ */ v.jsx(
    $11,
    {
      chip: e,
      chipElement: g ? g(e, w) : w,
      disabled: n,
      onAssignAccount: a,
      onRefreshAccountOptions: s,
      accountAssignmentDisplay: c
    },
    `${e.key.accountId}:${e.key.contactId}`
  );
}
function $11({
  chip: e,
  chipElement: n,
  disabled: i,
  onAssignAccount: a,
  onRefreshAccountOptions: s,
  accountAssignmentDisplay: g
}) {
  const [c, I] = gt(!1), [h, m] = gt(!1), [w, x] = gt(!1), [M, O] = gt(!1), k = Cn(null), z = g === "visible", N = z || c || h || w || M, U = z ? M : N;
  return vn(() => {
    if (!U) return;
    const Q = (_) => {
      var B;
      const X = _.target;
      !((B = k.current) != null && B.contains(X)) && !X.closest(
        ".MuiPopover-root, .MuiAutocomplete-popper, .contact-card-popper, .recipient-account-options"
      ) && (x(!1), I(!1), O(!1));
    };
    return document.addEventListener("pointerdown", Q), () => document.removeEventListener("pointerdown", Q);
  }, [U]), /* @__PURE__ */ v.jsxs(
    _1,
    {
      ref: k,
      component: "span",
      "data-testid": "accountless-recipient-container",
      "data-account-assignment-display": g,
      onPointerEnter: z ? void 0 : () => I(!0),
      onPointerLeave: z ? void 0 : () => I(!1),
      onFocusCapture: z ? void 0 : () => m(!0),
      onBlurCapture: z ? void 0 : (Q) => {
        Q.currentTarget.contains(Q.relatedTarget) || m(!1);
      },
      onPointerDownCapture: z ? void 0 : (Q) => {
        Q.target.closest('button, [role="combobox"]') || Q.pointerType === "touch" && x((X) => !X);
      },
      sx: {
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.5,
        minWidth: 0,
        maxWidth: "100%",
        boxSizing: "border-box",
        p: 0.25,
        border: 1,
        borderColor: "secondary.light",
        borderStyle: "dashed",
        borderRadius: "18px",
        bgcolor: "action.hover",
        '& [data-recipient-chip-variant="accountless"]': {
          border: 0,
          bgcolor: "transparent"
        }
      },
      children: [
        n,
        N ? /* @__PURE__ */ v.jsx(
          ee1,
          {
            chip: e,
            disabled: i,
            open: M,
            onAssignAccount: (Q, _) => {
              a(Q, _), O(!1), x(!1);
            },
            onRefreshAccountOptions: s,
            onOpenChange: O,
            accountAssignmentDisplay: g
          }
        ) : null
      ]
    }
  );
}
function ee1({
  chip: e,
  disabled: n,
  onAssignAccount: i,
  onRefreshAccountOptions: a,
  open: s,
  onOpenChange: g,
  accountAssignmentDisplay: c
}) {
  var _, X;
  const I = c === "visible", [h, m] = gt(!1), [w, x] = gt(""), M = Cn(null), O = Cn(e.key);
  O.current = e.key;
  const { accountId: k, contactId: z } = e.key, N = Cn(0), U = Cn(null), Q = Cn(null);
  return vn(() => {
    if (!s) {
      x(""), M.current = null;
      return;
    }
    if (!a) return;
    const B = setTimeout(
      async () => {
        const Z = w.trim();
        if (M.current === Z) return;
        M.current = Z;
        const Y = ++N.current;
        m(!0);
        try {
          await a(O.current, Z);
        } catch {
        } finally {
          N.current === Y && m(!1);
        }
      },
      w ? 250 : 0
    );
    return () => clearTimeout(B);
  }, [k, z, w, a, s]), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      Mf,
      {
        inputRef: U,
        disabled: n,
        value: w,
        placeholder: s ? "Search accounts" : I ? "Which account?" : "+ Account",
        inputProps: {
          "aria-label": I ? `Which account for ${e.label}?` : `Add account for ${e.label}`,
          role: "combobox",
          "aria-expanded": s
        },
        InputProps: {
          endAdornment: h ? /* @__PURE__ */ v.jsx(D3, { size: 14 }) : I ? /* @__PURE__ */ v.jsx(
            De,
            {
              icon: "chevronDown",
              fontSize: "small",
              sx: { pointerEvents: "none", color: "error.dark" }
            }
          ) : null
        },
        onFocus: () => {
          g(!0);
        },
        onChange: (B) => x(B.target.value),
        onClick: (B) => {
          B.stopPropagation(), I && !s && !n && g(!0);
        },
        onKeyDown: (B) => {
          var Z, Y;
          B.key === "Escape" ? (x(""), g(!1)) : B.key === "ArrowDown" && (B.preventDefault(), (Y = (Z = Q.current) == null ? void 0 : Z.querySelector('[role="option"]')) == null || Y.focus());
        },
        sx: {
          // Leave slack for font metrics: Firefox clipped "Which account?" at 150.
          width: s ? 180 : I ? 168 : 104,
          maxWidth: I ? "100%" : void 0,
          "& .MuiInputBase-root": {
            height: 32,
            paddingRight: I ? 1 : void 0,
            borderRadius: "999px",
            bgcolor: "background.paper",
            color: I ? "error.dark" : "primary.main",
            fontSize: "0.875rem",
            fontWeight: 600,
            cursor: I ? "pointer" : void 0
          },
          "& .MuiInputBase-input::placeholder": I ? { color: "error.dark", opacity: 1 } : void 0,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: I ? "error.main" : "primary.main",
            borderStyle: I ? "solid" : "dashed"
          }
        }
      }
    ),
    /* @__PURE__ */ v.jsx(
      hS,
      {
        open: s,
        anchorEl: U.current,
        placement: "bottom-start",
        className: "recipient-account-options",
        sx: { zIndex: "modal" },
        children: /* @__PURE__ */ v.jsx(MS, { sx: { minWidth: 180, maxHeight: 240, overflowY: "auto" }, children: /* @__PURE__ */ v.jsxs(
          ES,
          {
            ref: Q,
            role: "listbox",
            onKeyDown: (B) => {
              var Z;
              B.key === "Escape" && (B.preventDefault(), x(""), g(!1), (Z = U.current) == null || Z.focus());
            },
            children: [
              (_ = e.accountOptions) == null ? void 0 : _.map((B) => /* @__PURE__ */ v.jsx(
                Ta,
                {
                  role: "option",
                  onClick: (Z) => {
                    Z.stopPropagation(), i(e.key, B), x(""), g(!1);
                  },
                  children: B.name
                },
                B.id
              )),
              h ? null : e.accountOptionsError ? /* @__PURE__ */ v.jsx(Ta, { disabled: !0, children: "Couldn't load accounts" }) : ((X = e.accountOptions) == null ? void 0 : X.length) === 0 ? /* @__PURE__ */ v.jsx(Ta, { disabled: !0, children: "No accounts found" }) : null
            ]
          }
        ) })
      }
    )
  ] });
}
function Wm({
  url: e,
  title: n,
  onError: i,
  onDownloadError: a,
  onDownload: s
}) {
  const [g, c] = gt(!1), I = async () => {
    c(!0), i(!1);
    try {
      await (s ? s() : jz(e, n));
    } catch (h) {
      i(!0), a == null || a(h);
    } finally {
      c(!1);
    }
  };
  return /* @__PURE__ */ v.jsx(
    v2,
    {
      onClick: g ? void 0 : I,
      "aria-disabled": g,
      color: "inherit",
      children: g ? "Downloading…" : "Download"
    }
  );
}
function dn1(e) {
  return /* @__PURE__ */ v.jsx(te1, { ...e }, e.url);
}
function te1({
  url: e,
  title: n,
  sx: i = [],
  onLoadError: a,
  onDownload: s,
  onError: g
}) {
  const [c, I] = gt(
    "loading"
  ), [h, m] = gt(0), [w, x] = gt(!1);
  return /* @__PURE__ */ v.jsxs(
    _1,
    {
      sx: [
        {
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column"
        },
        ...Array.isArray(i) ? i : [i]
      ],
      children: [
        /* @__PURE__ */ v.jsx(_1, { sx: { display: "flex", justifyContent: "flex-end", p: 1 }, children: /* @__PURE__ */ v.jsx(
          Wm,
          {
            url: e,
            title: n,
            onError: x,
            onDownloadError: (M) => g == null ? void 0 : g("download", M),
            onDownload: s
          }
        ) }),
        w && /* @__PURE__ */ v.jsx(Yr, { severity: "error", children: "Couldn't download this image. Please try again." }),
        /* @__PURE__ */ v.jsxs(
          _1,
          {
            sx: {
              flex: 1,
              minHeight: 0,
              position: "relative",
              p: 2,
              display: "grid",
              placeItems: "center",
              overflow: "hidden"
            },
            children: [
              c === "loading" && /* @__PURE__ */ v.jsx(
                D3,
                {
                  "aria-label": "Loading image",
                  sx: { position: "absolute" }
                }
              ),
              c === "error" ? /* @__PURE__ */ v.jsx(
                Yr,
                {
                  severity: "error",
                  action: /* @__PURE__ */ v.jsx(
                    v2,
                    {
                      onClick: () => {
                        I("loading"), m(h + 1);
                      },
                      children: "Retry"
                    }
                  ),
                  children: "Couldn't load this image."
                }
              ) : /* @__PURE__ */ v.jsx(
                _1,
                {
                  component: "img",
                  src: e,
                  alt: n,
                  onLoad: () => I("ready"),
                  onError: () => {
                    I("error"), a == null || a(e), g == null || g("load", new Error("Image failed to load"));
                  },
                  sx: {
                    width: "100%",
                    height: "100%",
                    minHeight: 0,
                    objectFit: "contain"
                  }
                },
                h
              )
            ]
          }
        )
      ]
    }
  );
}
var VT = { exports: {} };
/* @license
Papa Parse
v5.7.0
https://github.com/mholt/PapaParse
License: MIT
*/
(function(e, n) {
  ((i, a) => {
    e.exports = a();
  })(Hz, function i() {
    var a = typeof self < "u" ? self : typeof window < "u" ? window : a !== void 0 ? a : {}, s = !a.document && !!a.postMessage, g = a.IS_PAPA_WORKER || !1, c = {}, I = 0, h = {};
    function m(V) {
      return V.charCodeAt(0) === 65279 ? V.slice(1) : V;
    }
    function w(V) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(J) {
        var e1 = B(J);
        e1.chunkSize = parseInt(e1.chunkSize), J.step || J.chunk || (e1.chunkSize = null), this._handle = new z(e1), (this._handle.streamer = this)._config = e1;
      }).call(this, V), this.parseChunk = function(J, e1) {
        var f1 = parseInt(this._config.skipFirstNLines) || 0;
        if (this.isFirstChunk && 0 < f1) {
          let a1 = this._config.newline;
          a1 || (v1 = this._config.quoteChar || '"', a1 = this._handle.guessLineEndings(J, v1)), J = [...J.split(a1).slice(f1)].join(a1);
        }
        this.isFirstChunk && Y(this._config.beforeFirstChunk) && (v1 = this._config.beforeFirstChunk(J)) !== void 0 && (J = v1), this.isFirstChunk = !1, this._halted = !1;
        var f1 = this._partialLine + J, v1 = (this._partialLine = "", this._handle.parse(f1, this._baseIndex, !this._finished));
        if (!this._handle.paused() && !this._handle.aborted()) {
          if (J = v1.meta.cursor, f1 = (this._finished || (this._partialLine = f1.substring(J - this._baseIndex), this._baseIndex = J), v1 && v1.data && (this._rowCount += v1.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), g) a.postMessage({ results: v1, workerId: h.WORKER_ID, finished: f1 });
          else if (Y(this._config.chunk) && !e1) {
            if (this._config.chunk(v1, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
            this._completeResults = v1 = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(v1.data), this._completeResults.errors = this._completeResults.errors.concat(v1.errors), this._completeResults.meta = v1.meta), this._completed || !f1 || !Y(this._config.complete) || v1 && v1.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), f1 || v1 && v1.meta.paused || this._nextChunk(), v1;
        }
        this._halted = !0;
      }, this._sendError = function(J) {
        Y(this._config.error) ? this._config.error(J) : g && this._config.error && a.postMessage({ workerId: h.WORKER_ID, error: J, finished: !1 });
      };
    }
    function x(V) {
      var J;
      (V = V || {}).chunkSize || (V.chunkSize = h.RemoteChunkSize), w.call(this, V), this._nextChunk = s ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(e1) {
        this._input = e1, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished) this._chunkLoaded();
        else {
          if (J = new XMLHttpRequest(), this._config.withCredentials && (J.withCredentials = this._config.withCredentials), s || (J.onload = Z(this._chunkLoaded, this), J.onerror = Z(this._chunkError, this)), J.ontimeout = Z(this._chunkTimeout, this), J.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadTimeout && !s && (J.timeout = this._config.downloadTimeout), this._config.downloadRequestHeaders) {
            var e1, f1 = this._config.downloadRequestHeaders;
            for (e1 in f1) J.setRequestHeader(e1, f1[e1]);
          }
          var v1;
          this._config.chunkSize && (v1 = this._start + this._config.chunkSize - 1, J.setRequestHeader("Range", "bytes=" + this._start + "-" + v1));
          try {
            J.send(this._config.downloadRequestBody);
          } catch (a1) {
            this._chunkError(a1.message);
          }
          s && J.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        J.readyState === 4 && (J.status < 200 || 400 <= J.status ? this._chunkError() : (this._start += this._config.chunkSize || J.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e1) => (e1 = e1.getResponseHeader("Content-Range")) !== null ? parseInt(e1.substring(e1.lastIndexOf("/") + 1)) : -1)(J), this.parseChunk(J.responseText)));
      }, this._chunkError = function(e1) {
        e1 = J.statusText || e1, this._sendError(new Error(e1));
      }, this._chunkTimeout = function() {
        this._chunkError("Request timed out after " + this._config.downloadTimeout + "ms");
      };
    }
    function M(V) {
      (V = V || {}).chunkSize || (V.chunkSize = h.LocalChunkSize), w.call(this, V);
      var J, e1, f1 = typeof FileReader < "u";
      this.stream = function(v1) {
        this._input = v1, e1 = v1.slice || v1.webkitSlice || v1.mozSlice, f1 ? ((J = new FileReader()).onload = Z(this._chunkLoaded, this), J.onerror = Z(this._chunkError, this)) : J = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var v1 = this._input, a1 = (this._config.chunkSize && (a1 = Math.min(this._start + this._config.chunkSize, this._input.size), v1 = e1.call(v1, this._start, a1)), J.readAsText(v1, this._config.encoding));
        f1 || this._chunkLoaded({ target: { result: a1 } });
      }, this._chunkLoaded = function(v1) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(v1.target.result);
      }, this._chunkError = function() {
        this._sendError(J.error);
      };
    }
    function O(V) {
      var J;
      w.call(this, V = V || {}), this.stream = function(e1) {
        return J = e1, this._nextChunk();
      }, this._nextChunk = function() {
        var e1, f1;
        if (!this._finished) return e1 = this._config.chunkSize, J = e1 ? (f1 = J.substring(0, e1), J.substring(e1)) : (f1 = J, ""), this._finished = !J, this.parseChunk(f1);
      };
    }
    function k(V) {
      w.call(this, V = V || {});
      var J = [], e1 = !0, f1 = !1;
      this.pause = function() {
        w.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        w.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(v1) {
        this._input = v1, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        f1 && J.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), J.length ? this.parseChunk(J.shift()) : e1 = !0;
      }, this._streamData = Z(function(v1) {
        try {
          J.push(typeof v1 == "string" ? v1 : v1.toString(this._config.encoding)), e1 && (e1 = !1, this._checkIsFinished(), this.parseChunk(J.shift()));
        } catch (a1) {
          this._streamError(a1);
        }
      }, this), this._streamError = Z(function(v1) {
        this._streamCleanUp(), this._sendError(v1);
      }, this), this._streamEnd = Z(function() {
        this._streamCleanUp(), f1 = !0, this._streamData("");
      }, this), this._streamCleanUp = Z(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function z(V) {
      var J, e1, f1, v1, a1 = Math.pow(2, 53), d1 = -a1, S1 = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h1 = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, L1 = this, c1 = 0, b1 = 0, t1 = !1, C1 = !1, w1 = [], E1 = { data: [], errors: [], meta: {} };
      function V1(R1) {
        return V.skipEmptyLines === "greedy" ? R1.join("").trim() === "" : R1.length === 1 && R1[0].length === 0;
      }
      function K1() {
        if (E1 && f1 && (te("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + h.DefaultDelimiter + "'"), f1 = !1), V.skipEmptyLines && (E1.data = E1.data.filter(function(X1) {
          return !V1(X1);
        })), B1()) {
          let X1 = function(D1) {
            w1.push(D1);
          };
          if (E1) if (Array.isArray(E1.data[0])) {
            for (var R1 = 0; B1() && R1 < E1.data.length; R1++) E1.data[R1].forEach(X1);
            E1.data.splice(0, 1);
          } else E1.data.forEach(X1);
        }
        function x1(X1, D1) {
          for (var $1 = V.header ? {} : [], y1 = 0; y1 < X1.length; y1++) {
            var ie = y1, ae = X1[y1], ae = ((H1, Y1) => ((me) => (V.dynamicTypingFunction && V.dynamicTyping[me] === void 0 && (V.dynamicTyping[me] = V.dynamicTypingFunction(me)), (V.dynamicTyping[me] || V.dynamicTyping) === !0))(H1) ? Y1 === "true" || Y1 === "TRUE" || Y1 !== "false" && Y1 !== "FALSE" && (((me) => {
              if (S1.test(me) && (me = parseFloat(me), d1 < me && me < a1))
                return 1;
            })(Y1) ? parseFloat(Y1) : h1.test(Y1) ? new Date(Y1) : Y1 === "" ? null : Y1) : Y1)(ie = V.header ? y1 >= w1.length ? "__parsed_extra" : w1[y1] : ie, ae = V.transform ? V.transform(ae, ie) : ae);
            ie === "__parsed_extra" ? ($1[ie] = $1[ie] || [], $1[ie].push(ae)) : $1[ie] = ae;
          }
          return V.header && (y1 > w1.length ? te("FieldMismatch", "TooManyFields", "Too many fields: expected " + w1.length + " fields but parsed " + y1, b1 + D1) : y1 < w1.length && te("FieldMismatch", "TooFewFields", "Too few fields: expected " + w1.length + " fields but parsed " + y1, b1 + D1)), $1;
        }
        var J1;
        E1 && (V.header || V.dynamicTyping || V.transform) && (J1 = 1, !E1.data.length || Array.isArray(E1.data[0]) ? (E1.data = E1.data.map(x1), J1 = E1.data.length) : E1.data = x1(E1.data, 0), V.header && E1.meta && (E1.meta.fields = w1), b1 += J1);
      }
      function B1() {
        return V.header && w1.length === 0;
      }
      function te(R1, x1, J1, X1) {
        R1 = { type: R1, code: x1, message: J1 }, X1 !== void 0 && (R1.row = X1), E1.errors.push(R1);
      }
      Y(V.step) && (v1 = V.step, V.step = function(R1) {
        E1 = R1, B1() ? K1() : (K1(), E1.data.length !== 0 && (c1 += R1.data.length, V.preview && c1 > V.preview ? e1.abort() : (E1.data = E1.data[0], v1(E1, L1))));
      }), this.parse = function(R1, x1, J1) {
        var X1 = V.quoteChar || '"', X1 = (V.newline || (V.newline = this.guessLineEndings(R1, X1)), f1 = !1, V.delimiter ? Y(V.delimiter) && (V.delimiter = V.delimiter(R1), E1.meta.delimiter = V.delimiter) : ((X1 = ((D1, $1, y1, ie, ae) => {
          var H1, Y1, me, ut;
          ae = ae || [",", "	", "|", ";", h.RECORD_SEP, h.UNIT_SEP];
          for (var Qe = 0; Qe < ae.length; Qe++) {
            for (var Ae, Bt = ae[Qe], ke = 0, bt = 0, pt = 0, rt = (me = void 0, new U({ comments: ie, delimiter: Bt, newline: $1, preview: 10 }).parse(D1)), Jt = 0; Jt < rt.data.length; Jt++) y1 && V1(rt.data[Jt]) ? pt++ : (Ae = rt.data[Jt].length, bt += Ae, me === void 0 ? me = Ae : 0 < Ae && (ke += Math.abs(Ae - me), me = Ae));
            0 < rt.data.length && (bt /= rt.data.length - pt), 1.99 < bt && (Y1 === void 0 || ke < Y1 || ke === Y1 && ut < bt) && (Y1 = ke, H1 = Bt, ut = bt);
          }
          return { successful: !!(V.delimiter = H1), bestDelimiter: H1 };
        })(R1, V.newline, V.skipEmptyLines, V.comments, V.delimitersToGuess)).successful ? V.delimiter = X1.bestDelimiter : (f1 = !0, V.delimiter = h.DefaultDelimiter), E1.meta.delimiter = V.delimiter), B(V));
        return X1.header = B1(), V.preview && V.header && X1.preview++, J = R1, e1 = new U(X1), E1 = e1.parse(J, x1, J1), K1(), t1 ? { meta: { paused: !0 } } : E1 || { meta: { paused: !1 } };
      }, this.paused = function() {
        return t1;
      }, this.pause = function() {
        t1 = !0, e1.abort(), J = Y(V.chunk) ? "" : J.substring(e1.getCharIndex());
      }, this.resume = function() {
        L1.streamer._halted ? (t1 = !1, L1.streamer.parseChunk(J, !0)) : setTimeout(L1.resume, 3);
      }, this.aborted = function() {
        return C1;
      }, this.abort = function() {
        C1 = !0, e1.abort(), E1.meta.aborted = !0, Y(V.complete) && V.complete(E1), J = "";
      }, this.guessLineEndings = function(D1, X1) {
        D1 = D1.substring(0, 1048576);
        var X1 = new RegExp(N(X1) + "([^]*?)" + N(X1), "gm"), J1 = (D1 = D1.replace(X1, "")).split("\r"), X1 = D1.split(`
`), D1 = 1 < X1.length && X1[0].length < J1[0].length;
        if (J1.length === 1 || D1) return `
`;
        for (var $1 = 0, y1 = 0; y1 < J1.length; y1++) J1[y1][0] === `
` && $1++;
        return $1 >= J1.length / 2 ? `\r
` : "\r";
      };
    }
    function N(V) {
      return V.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function U(V) {
      var J = (V = V || {}).delimiter, e1 = V.newline, f1 = V.comments, v1 = V.step, a1 = V.preview, d1 = V.fastMode, S1 = null, h1 = !1, L1 = V.quoteChar == null ? '"' : V.quoteChar, c1 = L1;
      if (V.escapeChar !== void 0 && (c1 = V.escapeChar), (typeof J != "string" || -1 < h.BAD_DELIMITERS.indexOf(J)) && (J = ","), f1 === J) throw new Error("Comment character same as delimiter");
      f1 === !0 ? f1 = "#" : (typeof f1 != "string" || -1 < h.BAD_DELIMITERS.indexOf(f1)) && (f1 = !1), e1 !== `
` && e1 !== "\r" && e1 !== `\r
` && (e1 = `
`);
      var b1 = 0, t1 = !1;
      this.parse = function(C1, w1, E1) {
        if (typeof C1 != "string") throw new Error("Input must be a string");
        var V1 = C1.length, K1 = J.length, B1 = e1.length, te = f1.length, R1 = Y(v1), x1 = [], J1 = [], X1 = [], D1 = b1 = 0;
        if (!C1) return ke();
        if (d1 || d1 !== !1 && C1.indexOf(L1) === -1) {
          for (var $1 = C1.split(e1), y1 = 0; y1 < $1.length; y1++) {
            if (X1 = $1[y1], b1 += X1.length, y1 !== $1.length - 1) b1 += e1.length;
            else if (E1) return ke();
            if (!f1 || X1.substring(0, te) !== f1) {
              if (R1) {
                if (x1 = [], ut(X1.split(J)), bt(), t1) return ke();
              } else ut(X1.split(J));
              if (a1 && a1 <= y1) return x1 = x1.slice(0, a1), ke(!0);
            }
          }
          return ke();
        }
        for (var ie = C1.indexOf(J, b1), ae = C1.indexOf(e1, b1), H1 = new RegExp(N(c1) + N(L1), "g"), Y1 = C1.indexOf(L1, b1); ; ) if (C1[b1] === L1) for (Y1 = b1, b1++; ; ) {
          if ((Y1 = C1.indexOf(L1, Y1 + 1)) === -1) return E1 || J1.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: x1.length, index: b1 }), Ae();
          if (Y1 === V1 - 1) return Ae(C1.substring(b1, Y1).replace(H1, L1));
          if (L1 === c1 && C1[Y1 + 1] === c1) Y1++;
          else if (L1 === c1 || Y1 === 0 || C1[Y1 - 1] !== c1) {
            ie !== -1 && ie < Y1 + 1 && (ie = C1.indexOf(J, Y1 + 1));
            var me = Qe((ae = ae !== -1 && ae < Y1 + 1 ? C1.indexOf(e1, Y1 + 1) : ae) === -1 ? ie : Math.min(ie, ae));
            if (C1.substr(Y1 + 1 + me, K1) === J) {
              X1.push(C1.substring(b1, Y1).replace(H1, L1)), C1[b1 = Y1 + 1 + me + K1] !== L1 && (Y1 = C1.indexOf(L1, b1)), ie = C1.indexOf(J, b1), ae = C1.indexOf(e1, b1);
              break;
            }
            if (me = Qe(ae), C1.substring(Y1 + 1 + me, Y1 + 1 + me + B1) === e1) {
              if (X1.push(C1.substring(b1, Y1).replace(H1, L1)), Bt(Y1 + 1 + me + B1), ie = C1.indexOf(J, b1), Y1 = C1.indexOf(L1, b1), R1 && (bt(), t1)) return ke();
              if (a1 && x1.length >= a1) return ke(!0);
              break;
            }
            J1.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: x1.length, index: b1 }), Y1++;
          }
        }
        else if (f1 && X1.length === 0 && C1.substring(b1, b1 + te) === f1) {
          if (ae === -1) return ke();
          b1 = ae + B1, ae = C1.indexOf(e1, b1), ie = C1.indexOf(J, b1);
        } else if (ie !== -1 && (ie < ae || ae === -1)) X1.push(C1.substring(b1, ie)), b1 = ie + K1, ie = C1.indexOf(J, b1);
        else {
          if (ae === -1) break;
          if (X1.push(C1.substring(b1, ae)), Bt(ae + B1), R1 && (bt(), t1)) return ke();
          if (a1 && x1.length >= a1) return ke(!0);
        }
        return Ae();
        function ut(pt) {
          x1.push(pt), D1 = b1;
        }
        function Qe(pt) {
          var rt = 0;
          return rt = pt !== -1 && (pt = C1.substring(Y1 + 1, pt)) && pt.trim() === "" ? pt.length : rt;
        }
        function Ae(pt) {
          return E1 || (pt === void 0 && (pt = C1.substring(b1)), X1.push(pt), b1 = V1, ut(X1), R1 && bt()), ke();
        }
        function Bt(pt) {
          b1 = pt, ut(X1), X1 = [], ae = C1.indexOf(e1, b1);
        }
        function ke(pt) {
          if (V.header && !w1 && x1.length && !h1) {
            var rt = x1[0], Jt = /* @__PURE__ */ Object.create(null), Pe = new Set(rt);
            let yn = !1;
            for (let ee = 0; ee < rt.length; ee++) {
              let ge = m(rt[ee]);
              if (Jt[ge = Y(V.transformHeader) ? V.transformHeader(ge, ee) : ge]) {
                let _e, wt = Jt[ge];
                for (; _e = ge + "_" + wt, wt++, Pe.has(_e); ) ;
                Pe.add(_e), rt[ee] = _e, Jt[ge]++, yn = !0, (S1 = S1 === null ? {} : S1)[_e] = ge;
              } else Jt[ge] = 1, rt[ee] = ge;
              Pe.add(ge);
            }
            yn && console.warn("Duplicate headers found and renamed."), h1 = !0;
          }
          return { data: x1, errors: J1, meta: { delimiter: J, linebreak: e1, aborted: t1, truncated: !!pt, cursor: D1 + (w1 || 0), renamedHeaders: S1 } };
        }
        function bt() {
          v1(ke()), x1 = [], J1 = [];
        }
      }, this.abort = function() {
        t1 = !0;
      }, this.getCharIndex = function() {
        return b1;
      };
    }
    function Q(V) {
      var J = V.data, e1 = c[J.workerId], f1 = !1;
      if (J.error) e1.userError(J.error, J.file);
      else if (J.results && J.results.data) {
        var v1 = { abort: function() {
          f1 = !0, _(J.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: X, resume: X };
        if (Y(e1.userStep)) {
          for (var a1 = 0; a1 < J.results.data.length && (e1.userStep({ data: J.results.data[a1], errors: J.results.errors, meta: J.results.meta }, v1), !f1); a1++) ;
          delete J.results;
        } else Y(e1.userChunk) && (e1.userChunk(J.results, v1, J.file), delete J.results);
      }
      J.finished && !f1 && _(J.workerId, J.results);
    }
    function _(V, J) {
      var e1 = c[V];
      Y(e1.userComplete) && e1.userComplete(J), e1.terminate(), delete c[V];
    }
    function X() {
      throw new Error("Not implemented.");
    }
    function B(V) {
      if (typeof V != "object" || V === null) return V;
      var J, e1 = Array.isArray(V) ? [] : {};
      for (J in V) e1[J] = B(V[J]);
      return e1;
    }
    function Z(V, J) {
      return function() {
        V.apply(J, arguments);
      };
    }
    function Y(V) {
      return typeof V == "function";
    }
    return h.parse = function(V, J) {
      var e1 = (J = J || {}).dynamicTyping || !1;
      if (Y(e1) && (J.dynamicTypingFunction = e1, e1 = {}), J.dynamicTyping = e1, J.transform = !!Y(J.transform) && J.transform, J.downloadTimeout !== void 0) {
        var e1 = parseInt(J.downloadTimeout);
        if (isNaN(e1)) throw new Error("Config downloadTimeout value (" + J.downloadTimeout + ") not parsable by parseInt(val).");
        J.downloadTimeout = e1;
      }
      if (!J.worker || !h.WORKERS_SUPPORTED) return e1 = null, h.NODE_STREAM_INPUT, typeof V == "string" ? (V = m(V), e1 = new (J.download ? x : O)(J)) : V.readable === !0 && Y(V.read) && Y(V.on) ? e1 = new k(J) : (a.File && V instanceof File || V instanceof Object) && (e1 = new M(J)), e1.stream(V);
      (e1 = (() => {
        var f1;
        return !!h.WORKERS_SUPPORTED && (f1 = (() => {
          var v1 = a.URL || a.webkitURL || null, a1 = i.toString();
          return h.BLOB_URL || (h.BLOB_URL = v1.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", a1, ")();"], { type: "text/javascript" })));
        })(), (f1 = new a.Worker(f1)).onmessage = Q, f1.id = I++, c[f1.id] = f1);
      })()).userStep = J.step, e1.userChunk = J.chunk, e1.userComplete = J.complete, e1.userError = J.error, J.step = Y(J.step), J.chunk = Y(J.chunk), J.complete = Y(J.complete), J.error = Y(J.error), delete J.worker, e1.postMessage({ input: V, config: J, workerId: e1.id });
    }, h.unparse = function(V, J) {
      var e1 = !1, f1 = !0, v1 = ",", a1 = `\r
`, d1 = '"', S1 = d1 + d1, h1 = !1, L1 = null, c1 = !1, b1 = ((() => {
        if (typeof J == "object") {
          if (typeof J.delimiter != "string" || h.BAD_DELIMITERS.filter(function(w1) {
            return J.delimiter.indexOf(w1) !== -1;
          }).length || (v1 = J.delimiter), typeof J.quotes != "boolean" && typeof J.quotes != "function" && !Array.isArray(J.quotes) || (e1 = J.quotes), typeof J.skipEmptyLines != "boolean" && typeof J.skipEmptyLines != "string" || (h1 = J.skipEmptyLines), typeof J.newline == "string" && (a1 = J.newline), typeof J.quoteChar == "string" && (d1 = J.quoteChar, S1 = d1 + d1), typeof J.header == "boolean" && (f1 = J.header), Array.isArray(J.columns)) {
            if (J.columns.length === 0) throw new Error("Option columns is empty");
            L1 = J.columns;
          }
          J.escapeChar !== void 0 && (S1 = J.escapeChar + d1), J.escapeFormulae instanceof RegExp ? c1 = J.escapeFormulae : typeof J.escapeFormulae == "boolean" && J.escapeFormulae && (c1 = /^[=+\-@\t\r].*$/);
        }
      })(), new RegExp(N(d1), "g"));
      if (typeof V == "string" && (V = JSON.parse(V)), Array.isArray(V)) {
        if (!V.length || Array.isArray(V[0])) return t1(null, V, h1);
        if (typeof V[0] == "object") return t1(L1 || Object.keys(V[0]), V, h1);
      } else if (typeof V == "object") return typeof V.data == "string" && (V.data = JSON.parse(V.data)), Array.isArray(V.data) && (V.fields || (V.fields = V.meta && V.meta.fields || L1), V.fields || (V.fields = Array.isArray(V.data[0]) ? V.fields : typeof V.data[0] == "object" ? Object.keys(V.data[0]) : []), Array.isArray(V.data[0]) || typeof V.data[0] == "object" || (V.data = [V.data])), t1(V.fields || [], V.data || [], h1);
      throw new Error("Unable to serialize unrecognized input");
      function t1(w1, E1, V1) {
        var K1 = "", B1 = (typeof w1 == "string" && (w1 = JSON.parse(w1)), typeof E1 == "string" && (E1 = JSON.parse(E1)), Array.isArray(w1) && 0 < w1.length), te = !Array.isArray(E1[0]);
        if (B1 && f1) {
          for (var R1 = 0; R1 < w1.length; R1++) 0 < R1 && (K1 += v1), K1 += C1(w1[R1], R1);
          0 < E1.length && (K1 += a1);
        }
        for (var x1 = 0; x1 < E1.length; x1++) {
          var J1 = (B1 ? w1 : E1[x1]).length, X1 = !1, D1 = B1 ? Object.keys(E1[x1]).length === 0 : E1[x1].length === 0;
          if (V1 && !B1 && (X1 = V1 === "greedy" ? E1[x1].join("").trim() === "" : E1[x1].length === 1 && E1[x1][0].length === 0), V1 === "greedy" && B1) {
            for (var $1 = [], y1 = 0; y1 < J1; y1++) {
              var ie = te ? w1[y1] : y1;
              $1.push(E1[x1][ie]);
            }
            X1 = $1.join("").trim() === "";
          }
          if (!X1) {
            for (var ae = 0; ae < J1; ae++) {
              0 < ae && !D1 && (K1 += v1);
              var H1 = B1 && te ? w1[ae] : ae;
              K1 += C1(E1[x1][H1], ae);
            }
            x1 < E1.length - 1 && (!V1 || 0 < J1 && !D1) && (K1 += a1);
          }
        }
        return K1;
      }
      function C1(w1, E1) {
        var V1, K1, B1;
        return w1 == null ? "" : w1.constructor === Date ? isNaN(w1.getTime()) ? "" : w1.toISOString() : (B1 = !1, c1 && typeof w1 == "string" && c1.test(w1) && (w1 = "'" + w1, B1 = !0), K1 = (V1 = w1.toString()).replace(b1, S1), (B1 = B1 || e1 === !0 || typeof e1 == "function" && e1(w1, E1) || Array.isArray(e1) && e1[E1] || ((te, R1) => {
          for (var x1 = 0; x1 < R1.length; x1++) if (-1 < te.indexOf(R1[x1])) return !0;
          return !1;
        })(K1, h.BAD_DELIMITERS) || -1 < K1.indexOf(v1) || -1 < V1.indexOf(d1) || K1.charAt(0) === " " || K1.charAt(K1.length - 1) === " ") ? d1 + K1 + d1 : K1);
      }
    }, h.RECORD_SEP = "", h.UNIT_SEP = "", h.BYTE_ORDER_MARK = "\uFEFF", h.BAD_DELIMITERS = ["\r", `
`, '"', h.BYTE_ORDER_MARK], h.WORKERS_SUPPORTED = !s && !!a.Worker, h.NODE_STREAM_INPUT = 1, h.LocalChunkSize = 10485760, h.RemoteChunkSize = 5242880, h.DefaultDelimiter = ",", h.Parser = U, h.ParserHandle = z, h.NetworkStreamer = x, h.FileStreamer = M, h.StringStreamer = O, h.ReadableStreamStreamer = k, g && (a.onmessage = function(V) {
      V = V.data, h.WORKER_ID === void 0 && V && (h.WORKER_ID = V.workerId), typeof V.input == "string" ? a.postMessage({ workerId: h.WORKER_ID, results: h.parse(V.input, V.config), finished: !0 }) : (a.File && V.input instanceof File || V.input instanceof Object) && (V = h.parse(V.input, V.config)) && a.postMessage({ workerId: h.WORKER_ID, results: V, finished: !0 });
    }), (x.prototype = Object.create(w.prototype)).constructor = x, (M.prototype = Object.create(w.prototype)).constructor = M, (O.prototype = Object.create(O.prototype)).constructor = O, (k.prototype = Object.create(w.prototype)).constructor = k, h;
  });
})(VT);
var ne1 = VT.exports;
const re1 = /* @__PURE__ */ _A(ne1), ie1 = 2 * 1024 * 1024, B7 = 200, H7 = 50;
class _m extends Error {
}
function ae1(e) {
  const n = re1.parse(e, {
    delimiter: ",",
    preview: B7 + 1,
    skipEmptyLines: !0,
    dynamicTyping: !1
  });
  if (n.errors.length)
    throw new _m(
      "Could not parse this CSV. Check its quotation marks or download the original file."
    );
  const i = n.data.slice(0, B7), a = Math.max(0, ...i.map((s) => s.length));
  return {
    rows: i.map((s) => s.slice(0, H7)),
    columns: Math.min(a, H7),
    limited: n.data.length > B7 || a > H7
  };
}
async function oe1(e, n) {
  var h;
  const i = await fetch(e, { signal: n });
  if (!i.ok)
    throw new Error("Could not load this CSV. Please try again.");
  const a = (h = i.body) == null ? void 0 : h.getReader();
  if (!a)
    throw new Error(
      "Could not read this CSV. Please download the original file."
    );
  const s = [];
  let g = 0;
  try {
    for (; ; ) {
      const { done: m, value: w } = await a.read();
      if (m) break;
      if (g += w.byteLength, g > ie1)
        throw await a.cancel(), new _m(
          "CSV previews support files up to 2 MB. Download the original file to view it."
        );
      s.push(w);
    }
  } finally {
    a.releaseLock();
  }
  const c = new Uint8Array(g);
  let I = 0;
  for (const m of s)
    c.set(m, I), I += m.byteLength;
  return ae1(new TextDecoder("utf-8").decode(c));
}
function Cn1(e) {
  return /* @__PURE__ */ v.jsx(se1, { ...e }, e.url);
}
function se1({
  url: e,
  title: n,
  sx: i = [],
  onLoadError: a,
  onRetry: s,
  onDownload: g,
  onError: c
}) {
  const [I, h] = gt(), [m, w] = gt(""), [x, M] = gt(0), [O, k] = gt(!1), z = Cn(c);
  z.current = c;
  const N = Cn(a);
  return N.current = a, vn(() => {
    const U = new AbortController();
    let Q = !0;
    const _ = setTimeout(() => U.abort(), 3e4);
    return h(void 0), w(""), oe1(e, U.signal).then((X) => {
      Q && h(X);
    }).catch((X) => {
      var B, Z;
      Q && (w(
        X instanceof Error && X.name !== "AbortError" ? X.message : "Could not load this CSV. Please try again."
      ), X instanceof _m || ((B = z.current) == null || B.call(z, "load", X), (Z = N.current) == null || Z.call(N, e)));
    }).finally(() => clearTimeout(_)), () => {
      Q = !1, clearTimeout(_), U.abort();
    };
  }, [e, x]), /* @__PURE__ */ v.jsxs(
    _1,
    {
      sx: [
        {
          height: "100%",
          minHeight: 0,
          minWidth: 0,
          display: "flex",
          flexDirection: "column"
        },
        ...Array.isArray(i) ? i : [i]
      ],
      children: [
        /* @__PURE__ */ v.jsx(
          Yr,
          {
            severity: "info",
            sx: { alignItems: "center" },
            action: /* @__PURE__ */ v.jsx(
              Wm,
              {
                url: e,
                title: n,
                onError: k,
                onDownloadError: (U) => c == null ? void 0 : c("download", U),
                onDownload: g
              }
            ),
            children: "Preview limited to the first 200 rows and 50 columns. Download the original file for all data."
          }
        ),
        O && /* @__PURE__ */ v.jsx(Yr, { severity: "error", children: "Could not download this CSV. Please try again." }),
        m ? /* @__PURE__ */ v.jsx(
          Yr,
          {
            severity: "error",
            action: /* @__PURE__ */ v.jsx(
              v2,
              {
                onClick: () => {
                  M(x + 1), s == null || s();
                },
                children: "Retry"
              }
            ),
            children: m
          }
        ) : I ? I.rows.length === 0 ? /* @__PURE__ */ v.jsx(le, { sx: { p: 2 }, children: "This CSV file is empty." }) : /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsx(
          xS,
          {
            tabIndex: 0,
            "aria-label": "Scrollable CSV preview",
            sx: { flex: 1, minHeight: 0, overflow: "auto" },
            children: /* @__PURE__ */ v.jsxs(
              Iz,
              {
                stickyHeader: !0,
                size: "small",
                "aria-label": `CSV preview: ${n}`,
                children: [
                  /* @__PURE__ */ v.jsx(
                    pz,
                    {
                      sx: {
                        "& .MuiTableCell-head": {
                          textTransform: "none",
                          letterSpacing: "normal"
                        }
                      },
                      children: /* @__PURE__ */ v.jsxs(W7, { children: [
                        /* @__PURE__ */ v.jsx(sf, { scope: "col", children: "Row" }),
                        Array.from({ length: I.columns }, (U, Q) => /* @__PURE__ */ v.jsx(sf, { scope: "col", children: I.rows[0][Q] || "" }, Q))
                      ] })
                    }
                  ),
                  /* @__PURE__ */ v.jsx(hz, { children: I.rows.slice(1).map((U, Q) => /* @__PURE__ */ v.jsxs(W7, { children: [
                    /* @__PURE__ */ v.jsx(
                      sf,
                      {
                        component: "th",
                        scope: "row",
                        sx: { fontWeight: "fontWeightRegular" },
                        children: Q + 2
                      }
                    ),
                    Array.from({ length: I.columns }, (_, X) => /* @__PURE__ */ v.jsx(
                      sf,
                      {
                        sx: {
                          fontWeight: "fontWeightRegular",
                          whiteSpace: "pre-wrap",
                          overflowWrap: "anywhere",
                          minWidth: 120,
                          maxWidth: 480,
                          verticalAlign: "top"
                        },
                        children: U[X] || ""
                      },
                      X
                    ))
                  ] }, Q)) })
                ]
              }
            )
          }
        ) }) : /* @__PURE__ */ v.jsx(_1, { sx: { flex: 1, display: "grid", placeItems: "center" }, children: /* @__PURE__ */ v.jsx(D3, { "aria-label": "Loading CSV" }) })
      ]
    }
  );
}
const An1 = ({
  children: e,
  innerProps: n = {},
  ...i
}) => /* @__PURE__ */ v.jsx(mz, { ...i, style: { height: "100vh", overflow: "auto" }, children: /* @__PURE__ */ v.jsx(
  _1,
  {
    overflow: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ...n,
    children: e
  }
) }), le1 = q1(_1)({
  flex: 1,
  overflow: "auto",
  width: "100%",
  display: "flex",
  flexDirection: "column"
}), In1 = ({
  header: e = null,
  children: n,
  footer: i = null
}) => /* @__PURE__ */ v.jsxs(qe, { direction: "column", flex: 1, height: "100%", width: "100%", children: [
  e,
  /* @__PURE__ */ v.jsx(le1, { children: n }),
  i
] }), ue1 = {
  baseline: "baseline",
  center: "center",
  end: "flex-end",
  start: "flex-start"
}, ce1 = {
  between: "space-between",
  center: "center",
  end: "flex-end",
  start: "flex-start"
}, ge1 = q1("div", {
  shouldForwardProp: (e) => !["align", "justify", "spacing", "wrap"].includes(String(e))
})(
  ({ align: e = "center", justify: n = "start", spacing: i = 0, theme: a, wrap: s }) => ({
    alignItems: ue1[e],
    display: "flex",
    flexWrap: s ? "wrap" : "nowrap",
    gap: a.spacing(i),
    justifyContent: ce1[n]
  })
), pn1 = (e) => /* @__PURE__ */ v.jsx(ge1, { ...e }), fe1 = q1("div")(({ theme: e }) => ({
  position: "absolute",
  inset: 0,
  display: "grid",
  placeItems: "center",
  background: e.palette.grey[100]
}));
function de1() {
  return /* @__PURE__ */ v.jsx(fe1, { children: /* @__PURE__ */ v.jsx(D3, { "aria-label": "Loading PDF" }) });
}
function Ce1() {
  var e;
  return typeof Worker < "u" && typeof Promise.withResolvers == "function" && typeof Array.prototype.at == "function" && typeof ((e = globalThis.crypto) == null ? void 0 : e.randomUUID) == "function";
}
class Ae1 extends xz {
  constructor() {
    super(...arguments);
    Sb(this, "state", { failed: !1 });
  }
  static getDerivedStateFromError() {
    return { failed: !0 };
  }
  componentDidCatch(i) {
    this.props.onError(i);
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
const KT = () => Sz(() => import("./ViewerSession-BHjB-aS0.js").then((e) => e.V)), Ie1 = KT();
function AS({
  viewer: e,
  children: n
}) {
  const [i, a] = gt(!1);
  return /* @__PURE__ */ v.jsxs(qe, { sx: { p: 2, gap: 2 }, children: [
    n,
    !e.downloadDisabled && /* @__PURE__ */ v.jsx(
      Wm,
      {
        url: e.downloadUrl || e.url,
        title: e.title,
        onError: a,
        onDownloadError: (s) => {
          var g;
          return (g = e.onError) == null ? void 0 : g.call(e, "download", s);
        }
      }
    ),
    i && /* @__PURE__ */ v.jsx(Yr, { severity: "error", children: "Could not download PDF." })
  ] });
}
function hn1(e) {
  const [n, i] = gt(0), [a, s] = gt(() => Ie1);
  return Ce1() ? /* @__PURE__ */ v.jsx(
    Ae1,
    {
      onError: (g) => {
        var c;
        return (c = e.onError) == null ? void 0 : c.call(e, "render", g);
      },
      fallback: /* @__PURE__ */ v.jsx(AS, { viewer: e, children: /* @__PURE__ */ v.jsx(
        Yr,
        {
          severity: "error",
          action: /* @__PURE__ */ v.jsx(
            v2,
            {
              color: "inherit",
              onClick: () => {
                s(KT), i((g) => g + 1);
              },
              children: "Try again"
            }
          ),
          children: "Could not open the PDF viewer."
        }
      ) }),
      children: /* @__PURE__ */ v.jsx(Ez, { fallback: /* @__PURE__ */ v.jsx(de1, {}), children: /* @__PURE__ */ v.jsx(a, { ...e }, e.documentId) })
    },
    `${e.documentId}:${n}`
  ) : /* @__PURE__ */ v.jsx(AS, { viewer: e, children: /* @__PURE__ */ v.jsx(Yr, { severity: "info", children: "PDF preview requires an up-to-date browser. On iPhone or iPad, use iOS 17.4 or later." }) });
}
const mn1 = "https://pspdfkit.com/instant-json/v1", vn1 = {
  fill: "#ffcc00",
  border: "#a88c28",
  ink: "#594913"
}, yn1 = (e) => {
  if (!e || typeof e != "object") return null;
  const { annotations: n, ...i } = e;
  delete i.pdfId;
  const a = Array.isArray(n) ? n.map((s) => {
    if (!s || typeof s != "object") return s;
    const g = { ...s };
    return delete g.pdfObjectId, g;
  }) : n;
  return { ...i, annotations: a };
};
function bn1(e) {
  const n = e == null ? void 0 : e.name;
  return n === "PasswordException" || n === "AbortException" || n === "AbortError" || n === "RenderingCancelledException";
}
function wn1(e) {
  return typeof e.text == "string" ? e.text : e.text.value;
}
function xn1(e) {
  var n;
  return !!((n = e.flags) != null && n.some(
    (i) => ["readOnly", "locked", "lockedContents"].includes(i)
  ));
}
function Sn1(e) {
  var n;
  return !((n = e.flags) != null && n.some((i) => i === "hidden" || i === "noView"));
}
function En1(e) {
  if (e !== null && (typeof e != "object" || Array.isArray(e)))
    return { notes: [], unsupported: !0 };
  const n = (e == null ? void 0 : e.annotations) ?? [];
  if (!Array.isArray(n)) return { notes: [], unsupported: !0 };
  const i = (g) => {
    var I;
    if (!g || typeof g != "object") return !1;
    const c = g;
    return c.type === "pspdfkit/note" && typeof c.id == "string" && Number.isInteger(c.pageIndex) && c.pageIndex >= 0 && Array.isArray(c.bbox) && c.bbox.length === 4 && c.bbox.every(Number.isFinite) && c.bbox[2] > 0 && c.bbox[3] > 0 && (c.flags === void 0 || Array.isArray(c.flags) && c.flags.every((h) => typeof h == "string")) && (typeof c.text == "string" || ((I = c.text) == null ? void 0 : I.format) === "plain" && typeof c.text.value == "string") && !c.pdfObjectId;
  }, a = n.filter(i), s = e == null ? void 0 : e.skippedPdfObjectIds;
  return {
    notes: a,
    unsupported: a.length !== n.length || Array.isArray(s) && s.length > 0 || new Set(a.map((g) => g.id)).size !== a.length
  };
}
export {
  ze1 as $,
  De1 as A,
  xm as B,
  Fz as C,
  Lb as D,
  ke1 as E,
  Em as F,
  OX as G,
  qe1 as H,
  De as I,
  dG as J,
  et1 as K,
  Rh as L,
  tt1 as M,
  nt1 as N,
  u11 as O,
  E as P,
  tn1 as Q,
  Ze1 as R,
  $e1 as S,
  Wf as T,
  it1 as U,
  Ge1 as V,
  ln1 as W,
  un1 as X,
  cn1 as Y,
  je1 as Z,
  k1 as _,
  y2 as a,
  qo as a$,
  Fe1 as a0,
  j2 as a1,
  Sm as a2,
  He1 as a3,
  Ue1 as a4,
  MK as a5,
  TK as a6,
  Je1 as a7,
  Om as a8,
  km as a9,
  Bq as aA,
  ot1 as aB,
  Bm as aC,
  Hq as aD,
  lt1 as aE,
  lZ as aF,
  ut1 as aG,
  st1 as aH,
  ct1 as aI,
  uZ as aJ,
  gt1 as aK,
  cZ as aL,
  ft1 as aM,
  Yx as aN,
  dt1 as aO,
  Ct1 as aP,
  At1 as aQ,
  yT as aR,
  T$ as aS,
  L$ as aT,
  It1 as aU,
  pt1 as aV,
  ht1 as aW,
  O$ as aX,
  mt1 as aY,
  D$ as aZ,
  vt1 as a_,
  _M as aa,
  WM as ab,
  bK as ac,
  wK as ad,
  xK as ae,
  SK as af,
  Ne1 as ag,
  EK as ah,
  We1 as ai,
  _e1 as aj,
  Ve1 as ak,
  Ke1 as al,
  yx as am,
  VM as an,
  Ye1 as ao,
  iG as ap,
  oG as aq,
  Qe1 as ar,
  Xe1 as as,
  IG as at,
  Dm as au,
  IX as av,
  rt1 as aw,
  Pq as ax,
  at1 as ay,
  Fq as az,
  lr as b,
  fn1 as b$,
  Um as b0,
  zT as b1,
  z7 as b2,
  _f as b3,
  P$ as b4,
  NT as b5,
  yt1 as b6,
  bt1 as b7,
  PT as b8,
  F$ as b9,
  Uh as bA,
  Pt1 as bB,
  l11 as bC,
  Ht1 as bD,
  Ut1 as bE,
  Wt1 as bF,
  _t1 as bG,
  Vt1 as bH,
  Kt1 as bI,
  Jt1 as bJ,
  Yt1 as bK,
  Qt1 as bL,
  Xt1 as bM,
  Gt1 as bN,
  qt1 as bO,
  Zt1 as bP,
  $t1 as bQ,
  en1 as bR,
  P11 as bS,
  nn1 as bT,
  rn1 as bU,
  in1 as bV,
  an1 as bW,
  on1 as bX,
  H11 as bY,
  sn1 as bZ,
  gn1 as b_,
  wt1 as ba,
  xt1 as bb,
  St1 as bc,
  B$ as bd,
  Et1 as be,
  Mt1 as bf,
  Tt1 as bg,
  Lt1 as bh,
  sS as bi,
  t11 as bj,
  n11 as bk,
  r11 as bl,
  Rt1 as bm,
  Ot1 as bn,
  Dt1 as bo,
  jt1 as bp,
  zt1 as bq,
  Nt1 as br,
  HT as bs,
  o11 as bt,
  i11 as bu,
  a11 as bv,
  BT as bw,
  s11 as bx,
  Ft1 as by,
  Bt1 as bz,
  tn as c,
  dn1 as c0,
  Cn1 as c1,
  An1 as c2,
  In1 as c3,
  pn1 as c4,
  Be1 as c5,
  rJ as c6,
  aJ as c7,
  a6 as c8,
  hn1 as c9,
  sr as d,
  oi as e,
  yA as f,
  _A as g,
  Dt as h,
  Qr as i,
  v as j,
  vn1 as k,
  bn1 as l,
  Pe1 as m,
  En1 as n,
  Sn1 as o,
  xn1 as p,
  wn1 as q,
  om as r,
  kn as s,
  de1 as t,
  jr as u,
  kt1 as v,
  mn1 as w,
  Ce1 as x,
  yn1 as y,
  Oe1 as z
};
